webpackJsonp([57],{

/***/ "+1eV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"logged-out-controls":"logged-out-controls___J4olr","link-default":"link-default___3j3sO","button-default":"button-default___25diZ"};

/***/ }),

/***/ "+Feu":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _stringify = __webpack_require__("mvHQ");

var _stringify2 = _interopRequireDefault(_stringify);

var _jsx2 = __webpack_require__("dcb+");

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _ControlLabel = __webpack_require__("TpLs");

var _ControlLabel2 = _interopRequireDefault(_ControlLabel);

var _Form = __webpack_require__("OoIh");

var _Form2 = _interopRequireDefault(_Form);

var _FormControl = __webpack_require__("qAYn");

var _FormControl2 = _interopRequireDefault(_FormControl);

var _FormGroup = __webpack_require__("lyyJ");

var _FormGroup2 = _interopRequireDefault(_FormGroup);

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propsComparer = __webpack_require__("wsGv");

var _propsComparer2 = _interopRequireDefault(_propsComparer);

var _canonical = __webpack_require__("5QdQ");

var _reactFontawesome = __webpack_require__("f7W8");

var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);

var _reactIntl = __webpack_require__("Pq8k");

var _reactHelmet = __webpack_require__("PIAa");

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactPaginate = __webpack_require__("sElP");

var _reactPaginate2 = _interopRequireDefault(_reactPaginate);

var _PaginationWrapper = __webpack_require__("BXmT");

var _PaginationWrapper2 = _interopRequireDefault(_PaginationWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PaginationWrapper = (_temp2 = _class = function (_Component) {
    (0, _inherits3.default)(PaginationWrapper, _Component);

    function PaginationWrapper() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, PaginationWrapper);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = PaginationWrapper.__proto__ || (0, _getPrototypeOf2.default)(PaginationWrapper)).call.apply(_ref, [this].concat(args))), _this), _this.mapAvailableViews = function (option, index) {
            return (0, _jsx3.default)('option', {
                value: option
            }, index, option === 'all' ? _this.context.intl.formatMessage({ id: option }) : option);
        }, _this.hrefBuilder = function (pathname, pageNumber) {
            var url = (0, _canonical.buildCanonicalUrlWithPageNum)(pathname, pageNumber);
            return pathname.includes('/c/') && pageNumber !== 1 ? url + '&parameters=' + encodeURIComponent((0, _stringify2.default)({ page: pageNumber })) : url;
        }, _this.handlePageChange = function (event) {
            return _this.props.onPageChange(event.selected);
        }, _this.handlePageSizeChange = function (event) {
            return _this.props.onPageSizeChange(event.target.value);
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(PaginationWrapper, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps) {
            return (0, _propsComparer2.default)(this.props, nextProps, ['availableViews', 'filteredItemCount', 'page', 'pageSize', 'paginatorContainerOverrideClass', 'paginatorOverrideClass', 'paginatorViewCountOverrideClass', 'pathname', 'totalItemsCount']);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                availableViews = _props.availableViews,
                baseUrl = _props.baseUrl,
                canonicalURL = _props.canonicalURL,
                onSubmit = _props.onSubmit,
                page = _props.page,
                pageSize = _props.pageSize,
                paginatorOverrideClass = _props.paginatorOverrideClass,
                paginatorContainerOverrideClass = _props.paginatorContainerOverrideClass,
                paginatorViewCountOverrideClass = _props.paginatorViewCountOverrideClass,
                pathname = _props.pathname,
                totalItemsCount = _props.totalItemsCount;
            var filteredItemCount = this.props.filteredItemCount;


            if (typeof filteredItemCount === 'undefined' || global.__SERVER__) {
                filteredItemCount = totalItemsCount;
            }

            var itemsToDisplay = isNaN(pageSize) ? totalItemsCount : pageSize;
            var numPages = Math.ceil(filteredItemCount / itemsToDisplay);
            var nextButtonClassName = numPages === page ? _PaginationWrapper2.default.grayed : '';
            var prevButtonClassName = page === 1 ? _PaginationWrapper2.default.grayed : '';
            var canonical = canonicalURL ? '' + baseUrl + canonicalURL : '' + baseUrl + pathname;

            var nextLink = '';
            var nextUrl = this.hrefBuilder(canonical, page + 1);
            if (numPages !== page) {
                nextLink = (0, _jsx3.default)('link', {
                    rel: 'next',
                    href: nextUrl
                });
            }
            var currentLink = (0, _jsx3.default)('link', {
                rel: 'canonical',
                href: this.hrefBuilder(canonical, page)
            });
            var prevLink = '';
            var prevUrl = this.hrefBuilder(canonical, page - 1);
            if (page > 1) {
                prevLink = (0, _jsx3.default)('link', {
                    rel: 'prev',
                    href: prevUrl
                });
            }

            return (0, _jsx3.default)('div', {
                className: _PaginationWrapper2.default['pagination-container'] + ' ' + paginatorContainerOverrideClass
            }, void 0, (0, _jsx3.default)(_reactHelmet2.default, {}, void 0, nextLink, currentLink, prevLink), (0, _jsx3.default)('div', {}), (0, _jsx3.default)(_reactPaginate2.default, {
                activeClassName: 'active',
                breakLabel: (0, _jsx3.default)('span', {
                    className: _PaginationWrapper2.default.break + ' ' + _PaginationWrapper2.default.disabled
                }, void 0, '\u2026'),
                containerClassName: _PaginationWrapper2.default.paginator + ' paginator' + this.guid + ' ' + paginatorOverrideClass,
                hrefBuilder: function hrefBuilder(num) {
                    return _this2.hrefBuilder(_this2.props.pathname, num);
                },
                forcePage: page - 1,
                marginPagesDisplayed: 1,
                nextLabel: (0, _jsx3.default)('span', {
                    className: nextButtonClassName
                }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                    id: 'next'
                }), ' ', (0, _jsx3.default)(_reactFontawesome2.default, {
                    className: _PaginationWrapper2.default.chevron,
                    icon: ['fas', 'chevron-right']
                })),
                onPageChange: this.handlePageChange,
                pageCount: numPages,
                pageRangeDisplayed: 2,
                previousLabel: (0, _jsx3.default)('span', {
                    className: prevButtonClassName
                }, void 0, (0, _jsx3.default)(_reactFontawesome2.default, {
                    className: _PaginationWrapper2.default.chevron,
                    icon: ['fas', 'chevron-left']
                }), ' ', (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                    id: 'previous'
                })),
                subContainerClassName: 'pages pagination'
            }), (0, _jsx3.default)(_Form2.default, {
                className: _PaginationWrapper2.default['pagination-view-count'] + ' ' + paginatorViewCountOverrideClass,
                inline: true,
                onSubmit: onSubmit
            }, void 0, (0, _jsx3.default)(_FormGroup2.default, {
                className: _PaginationWrapper2.default['page-size'],
                controlId: 'view'
            }, void 0, (0, _jsx3.default)(_ControlLabel2.default, {}, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'view'
            }), ':\xA0'), (0, _jsx3.default)(_FormControl2.default, {
                value: pageSize,
                componentClass: 'select',
                placeholder: 'select',
                onChange: this.handlePageSizeChange
            }, void 0, availableViews.map(this.mapAvailableViews)))));
        }
    }]);
    return PaginationWrapper;
}(_react.Component), _class.contextTypes = {
    intl: _propTypes2.default.object.isRequired
}, _class.defaultProps = {
    baseUrl: '',
    filteredItemCount: 0,
    page: 0,
    paginatorContainerOverrideClass: '',
    paginatorOverrideClass: '',
    paginatorViewCountOverrideClass: '',
    totalItemsCount: 0
}, _temp2);
exports.default = PaginationWrapper;
module.exports = exports['default'];
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("DuR2")))

/***/ }),

/***/ "+NGn":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.changeSellerSearchTermsPast = exports.changeSellerSearchTermsUpcoming = exports.changeSellerPagePast = exports.changeSellerPageUpcoming = exports.changeSavedItemsSearchTerms = exports.changeSavedItemsPage = exports.changeProfileTab = exports.changeMySavedSearchSearchRecentTerms = exports.changeMySavedSearchRecentPage = exports.changeMySavedSearchSearchManageTerms = exports.changeMySavedSearchManagePage = exports.changeMyBidsTab = exports.changeMyBidsSearchTerms = exports.changeMyBidsPage = exports.changeMyAuctionsTab = exports.changeMyAuctionsSearchTerms = exports.changeMyAuctionsPage = exports.changeFollowedSellersSearchTerms = exports.changeFollowedSellersPage = exports.changeCatalogSearchTerms = exports.changeCatalogPage = exports.getSellerViewData = exports.getSavedItemsViewData = exports.getProfileViewData = exports.getMySavedSearchRecentViewData = exports.getMySavedSearchManageViewData = exports.getMyBidsViewData = exports.getMyAuctionsViewData = exports.getFollowedSellersViewData = exports.getCatalogViewData = exports.MY_SAVED_SEARCH_RECENT_VIEW_DATA_KEY = exports.MY_SAVED_SEARCH_MANAGE_VIEW_DATA_KEY = exports.CHANGE_VIEW_DATA_TAB = exports.CHANGE_VIEW_DATA_SEARCH_TERMS = exports.CHANGE_VIEW_DATA_PAGE = undefined;

var _defineProperty2 = __webpack_require__("bOdI");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends5 = __webpack_require__("Dd8w");

var _extends6 = _interopRequireDefault(_extends5);

exports.default = reducer;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Action Types */
var CHANGE_VIEW_DATA_PAGE = exports.CHANGE_VIEW_DATA_PAGE = 'la/ui/viewData/page';
var CHANGE_VIEW_DATA_SEARCH_TERMS = exports.CHANGE_VIEW_DATA_SEARCH_TERMS = 'la/ui/viewData/searchTerms';
var CHANGE_VIEW_DATA_TAB = exports.CHANGE_VIEW_DATA_TAB = 'la/ui/viewData/tab';

var MY_SAVED_SEARCH_MANAGE_VIEW_DATA_KEY = exports.MY_SAVED_SEARCH_MANAGE_VIEW_DATA_KEY = 'my-saved-search-manage';
var MY_SAVED_SEARCH_RECENT_VIEW_DATA_KEY = exports.MY_SAVED_SEARCH_RECENT_VIEW_DATA_KEY = 'my-saved-search-recent';

// reducer
var DEFAULT_STATE = {};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        case CHANGE_VIEW_DATA_PAGE:
            return (0, _extends6.default)({}, state, (0, _defineProperty3.default)({}, action.payload.id, (0, _extends6.default)({}, state[action.payload.id], { page: action.payload.page })));
        case CHANGE_VIEW_DATA_SEARCH_TERMS:
            return (0, _extends6.default)({}, state, (0, _defineProperty3.default)({}, action.payload.id, (0, _extends6.default)({}, state[action.payload.id], {
                searchTerms: action.payload.searchTerms
            })));
        case CHANGE_VIEW_DATA_TAB:
            return (0, _extends6.default)({}, state, (0, _defineProperty3.default)({}, action.payload.id, (0, _extends6.default)({}, state[action.payload.id], { tab: action.payload.tab })));
        default:
            return state;
    }
}

/* SELECTORS */
var getCatalogViewData = exports.getCatalogViewData = function getCatalogViewData(state, catalogId) {
    var viewData = state.ui.viewData['catalog-' + catalogId] || {};
    return {
        page: viewData.page || 1,
        searchTerms: viewData.searchTerms || ''
    };
};

var getFollowedSellersViewData = exports.getFollowedSellersViewData = function getFollowedSellersViewData(state) {
    var viewData = state.ui.viewData['followed-sellers'] || {};
    return {
        page: viewData.page || 1,
        searchTerms: viewData.searchTerms || ''
    };
};

var getMyAuctionsViewData = exports.getMyAuctionsViewData = function getMyAuctionsViewData(state) {
    var viewData = state.ui.viewData['my-auctions'] || {};
    return {
        page: viewData.page || 1,
        searchTerms: viewData.searchTerms || '',
        tab: viewData.tab || 'approved'
    };
};

var getMyBidsViewData = exports.getMyBidsViewData = function getMyBidsViewData(state) {
    var viewData = state.ui.viewData['my-bids'] || {};
    return {
        page: viewData.page || 1,
        searchTerms: viewData.searchTerms || '',
        tab: viewData.tab || 'upcoming'
    };
};

var getMySavedSearchManageViewData = exports.getMySavedSearchManageViewData = function getMySavedSearchManageViewData(state) {
    var viewData = state.ui.viewData[MY_SAVED_SEARCH_MANAGE_VIEW_DATA_KEY] || {};
    return {
        page: viewData.page || 1,
        searchTerms: viewData.searchTerms || ''
    };
};

var getMySavedSearchRecentViewData = exports.getMySavedSearchRecentViewData = function getMySavedSearchRecentViewData(state) {
    var viewData = state.ui.viewData[MY_SAVED_SEARCH_RECENT_VIEW_DATA_KEY] || {};
    return {
        page: viewData.page || 1,
        searchTerms: viewData.searchTerms || ''
    };
};

var getProfileViewData = exports.getProfileViewData = function getProfileViewData(state) {
    var viewData = state.ui.viewData.profile || {};
    return {
        tab: viewData.tab || 'my-profile'
    };
};

var getSavedItemsViewData = exports.getSavedItemsViewData = function getSavedItemsViewData(state) {
    var viewData = state.ui.viewData['saved-items'] || {};
    return {
        page: viewData.page || 1,
        searchTerms: viewData.searchTerms || ''
    };
};

var getSellerViewData = exports.getSellerViewData = function getSellerViewData(state) {
    var which = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'upcoming';
    var sellerId = arguments[2];

    var viewData = state.ui.viewData['seller-' + sellerId + '-' + which] || {};
    return {
        page: viewData.page || 1,
        searchTerms: viewData.searchTerms || ''
    };
};

/* ACTION CREATORS */
var changeViewDataPage = function changeViewDataPage(id, page) {
    return {
        payload: { id: id, page: Number(page) },
        type: CHANGE_VIEW_DATA_PAGE
    };
};

var changeViewDataSearchTerms = function changeViewDataSearchTerms(id, searchTerms) {
    return {
        payload: { id: id, searchTerms: searchTerms },
        type: CHANGE_VIEW_DATA_SEARCH_TERMS
    };
};

var changeViewDataTab = function changeViewDataTab(id, tab) {
    return {
        payload: { id: id, tab: tab },
        type: CHANGE_VIEW_DATA_TAB
    };
};

var changeCatalogPage = exports.changeCatalogPage = function changeCatalogPage(catalogId, page) {
    return changeViewDataPage('catalog-' + catalogId, page);
};

var changeCatalogSearchTerms = exports.changeCatalogSearchTerms = function changeCatalogSearchTerms(catalogId, searchTerms) {
    return changeViewDataSearchTerms('catalog-' + catalogId, searchTerms);
};

var changeFollowedSellersPage = exports.changeFollowedSellersPage = function changeFollowedSellersPage(page) {
    return changeViewDataPage('followed-sellers', page);
};

var changeFollowedSellersSearchTerms = exports.changeFollowedSellersSearchTerms = function changeFollowedSellersSearchTerms(searchTerms) {
    return changeViewDataSearchTerms('followed-sellers', searchTerms);
};

var changeMyAuctionsPage = exports.changeMyAuctionsPage = function changeMyAuctionsPage(page) {
    return changeViewDataPage('my-auctions', page);
};

var changeMyAuctionsSearchTerms = exports.changeMyAuctionsSearchTerms = function changeMyAuctionsSearchTerms(searchTerms) {
    return changeViewDataSearchTerms('my-auctions', searchTerms);
};

var changeMyAuctionsTab = exports.changeMyAuctionsTab = function changeMyAuctionsTab(tab) {
    return changeViewDataTab('my-auctions', tab);
};

var changeMyBidsPage = exports.changeMyBidsPage = function changeMyBidsPage(page) {
    return changeViewDataPage('my-bids', page);
};

var changeMyBidsSearchTerms = exports.changeMyBidsSearchTerms = function changeMyBidsSearchTerms(searchTerms) {
    return changeViewDataSearchTerms('my-bids', searchTerms);
};

var changeMyBidsTab = exports.changeMyBidsTab = function changeMyBidsTab(tab) {
    return changeViewDataTab('my-bids', tab);
};

var changeMySavedSearchManagePage = exports.changeMySavedSearchManagePage = function changeMySavedSearchManagePage(page) {
    return changeViewDataPage(MY_SAVED_SEARCH_MANAGE_VIEW_DATA_KEY, page);
};

var changeMySavedSearchSearchManageTerms = exports.changeMySavedSearchSearchManageTerms = function changeMySavedSearchSearchManageTerms(searchTerms) {
    return changeViewDataSearchTerms(MY_SAVED_SEARCH_MANAGE_VIEW_DATA_KEY, searchTerms);
};

var changeMySavedSearchRecentPage = exports.changeMySavedSearchRecentPage = function changeMySavedSearchRecentPage(page) {
    return changeViewDataPage(MY_SAVED_SEARCH_RECENT_VIEW_DATA_KEY, page);
};

var changeMySavedSearchSearchRecentTerms = exports.changeMySavedSearchSearchRecentTerms = function changeMySavedSearchSearchRecentTerms(searchTerms) {
    return changeViewDataSearchTerms(MY_SAVED_SEARCH_RECENT_VIEW_DATA_KEY, searchTerms);
};

var changeProfileTab = exports.changeProfileTab = function changeProfileTab(tab) {
    return changeViewDataTab('profile', tab);
};

var changeSavedItemsPage = exports.changeSavedItemsPage = function changeSavedItemsPage(page) {
    return changeViewDataPage('saved-items', page);
};

var changeSavedItemsSearchTerms = exports.changeSavedItemsSearchTerms = function changeSavedItemsSearchTerms(searchTerms) {
    return changeViewDataSearchTerms('saved-items', searchTerms);
};

var changeSellerPageUpcoming = exports.changeSellerPageUpcoming = function changeSellerPageUpcoming(sellerId, page) {
    return changeViewDataPage('seller-' + sellerId + '-upcoming', page);
};

var changeSellerPagePast = exports.changeSellerPagePast = function changeSellerPagePast(sellerId, page) {
    return changeViewDataPage('seller-' + sellerId + '-past', page);
};

var changeSellerSearchTermsUpcoming = exports.changeSellerSearchTermsUpcoming = function changeSellerSearchTermsUpcoming(sellerId, searchTerms) {
    return changeViewDataSearchTerms('seller-' + sellerId + '-upcoming', searchTerms);
};

var changeSellerSearchTermsPast = exports.changeSellerSearchTermsPast = function changeSellerSearchTermsPast(sellerId, searchTerms) {
    return changeViewDataSearchTerms('seller-' + sellerId + '-past', searchTerms);
};

/***/ }),

/***/ "+RB6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _healthcheck = __webpack_require__("aIJS");

exports.default = {
    fetchHealthCheckData: _healthcheck.HealthCheck.fetchHealthCheckData
};
module.exports = exports['default'];

/***/ }),

/***/ "+WQL":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = __webpack_require__("dcb+");

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propsComparer = __webpack_require__("wsGv");

var _propsComparer2 = _interopRequireDefault(_propsComparer);

var _Button = __webpack_require__("KluA");

var _Button2 = _interopRequireDefault(_Button);

var _reactFontawesome = __webpack_require__("f7W8");

var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);

var _reactIntl = __webpack_require__("Pq8k");

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ItemSaveButton = __webpack_require__("ohur");

var _ItemSaveButton2 = _interopRequireDefault(_ItemSaveButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ItemSaveButton = (_temp = _class = function (_Component) {
    (0, _inherits3.default)(ItemSaveButton, _Component);

    function ItemSaveButton() {
        (0, _classCallCheck3.default)(this, ItemSaveButton);
        return (0, _possibleConstructorReturn3.default)(this, (ItemSaveButton.__proto__ || (0, _getPrototypeOf2.default)(ItemSaveButton)).apply(this, arguments));
    }

    (0, _createClass3.default)(ItemSaveButton, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps) {
            return (0, _propsComparer2.default)(this.props, nextProps, ['saved']);
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                save = _props.save,
                saved = _props.saved;

            var icon = saved ? ['fas', 'heart'] : ['far', 'heart'];
            var buttonClass = saved ? _ItemSaveButton2.default.button + ' ' + _ItemSaveButton2.default.saved : '' + _ItemSaveButton2.default.button;
            return (0, _jsx3.default)('div', {
                className: _ItemSaveButton2.default['live-item-save']
            }, void 0, (0, _jsx3.default)(_Button2.default, {
                className: buttonClass,
                onClick: save,
                secondary: true
            }, void 0, (0, _jsx3.default)(_reactFontawesome2.default, {
                className: _ItemSaveButton2.default.icon,
                icon: icon
            }), !saved ? (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'save_item'
            }) : (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'item_saved'
            })), (0, _jsx3.default)('div', {
                className: _ItemSaveButton2.default['message-wrapper']
            }, void 0, (0, _jsx3.default)('span', {
                className: _ItemSaveButton2.default.title
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'interested_in_this_item'
            })), (0, _jsx3.default)('span', {
                className: _ItemSaveButton2.default.message
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'save_to_saved_items'
            }))));
        }
    }]);
    return ItemSaveButton;
}(_react.Component), _class.defaultProps = {
    saved: false
}, _temp);
exports.default = ItemSaveButton;
module.exports = exports['default'];

/***/ }),

/***/ "/7aV":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = __webpack_require__("dcb+");

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _urls = __webpack_require__("CakR");

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propsComparer = __webpack_require__("wsGv");

var _propsComparer2 = _interopRequireDefault(_propsComparer);

var _reactIntl = __webpack_require__("Pq8k");

var _components = __webpack_require__("bGai");

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _LACrown = __webpack_require__("Oq/P");

var _LACrown2 = _interopRequireDefault(_LACrown);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LACrown = function (_Component) {
    (0, _inherits3.default)(LACrown, _Component);

    function LACrown() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, LACrown);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = LACrown.__proto__ || (0, _getPrototypeOf2.default)(LACrown)).call.apply(_ref, [this].concat(args))), _this), _this.classicLink = function (classicBaseUrl, pathName) {
            if (pathName.includes('/auctioneer/') && pathName.endsWith('past/')) {
                return '' + classicBaseUrl + pathName.replace('past/', '');
            }
            return '' + classicBaseUrl + pathName;
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(LACrown, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps) {
            return (0, _propsComparer2.default)(this.props.location, nextProps.location, ['pathname']);
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                baseUrl = _props.baseUrl,
                classicBaseUrl = _props.classicBaseUrl,
                location = _props.location;


            return (0, _jsx3.default)('div', {
                className: _LACrown2.default.crown
            }, void 0, (0, _jsx3.default)('div', {
                className: _LACrown2.default['crown-inner']
            }, void 0, (0, _jsx3.default)(_components.Link, {
                route: true,
                to: (0, _urls.getAuctioneerDirectoryUrl)(),
                secondary: true
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'directory'
            })), (0, _jsx3.default)(_components.Link, {
                route: true,
                to: (0, _urls.getAuctionResultsUrl)(),
                secondary: true
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'price_results'
            })), (0, _jsx3.default)(_components.Link, {
                target: '_blank',
                to: baseUrl + '/news/',
                secondary: true
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'news'
            })), (0, _jsx3.default)(_components.Link, {
                target: '_blank',
                to: 'http://liveauctioneers.desk.com/',
                secondary: true,
                rel: 'noopener'
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'help'
            })), (0, _jsx3.default)(_components.Link, {
                route: true,
                to: '/consignments',
                secondary: true
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'consign'
            })), (0, _jsx3.default)('span', {}, void 0, '|'), (0, _jsx3.default)(_components.Link, {
                to: this.classicLink(classicBaseUrl, location.pathname),
                secondary: true,
                rel: 'nofollow'
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'classic_site'
            }))));
        }
    }]);
    return LACrown;
}(_react.Component);

exports.default = LACrown;
module.exports = exports['default'];

/***/ }),

/***/ "/9SA":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.submitUnfollowSeller = exports.submitFollowSeller = exports.isSellerFollowed = exports.getFollowedSellerIds = exports.UNFOLLOW_SELLER_SUCCESS = exports.UNFOLLOW_SELLER_REQUEST = exports.UNFOLLOW_SELLER_FAIL = exports.FOLLOW_SELLER_SUCCESS = exports.FOLLOW_SELLER_REQUEST = exports.FOLLOW_SELLER_FAIL = undefined;

var _regenerator = __webpack_require__("Xxa5");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__("exGp");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _toConsumableArray2 = __webpack_require__("Gu7T");

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

exports.default = reducer;

var _user = __webpack_require__("CFLi");

var _analytics = __webpack_require__("yxCd");

var _api = __webpack_require__("zFQO");

var _reselect = __webpack_require__("bndy");

var _difference = __webpack_require__("WlNK");

var _difference2 = _interopRequireDefault(_difference);

var _config = __webpack_require__("iS9E");

var _login = __webpack_require__("SpFG");

var _passwordReset = __webpack_require__("fWpZ");

var _union = __webpack_require__("gszD");

var _union2 = _interopRequireDefault(_union);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Action Types */
var FOLLOW_SELLER_FAIL = exports.FOLLOW_SELLER_FAIL = 'la/user/followSeller/FAIL';
var FOLLOW_SELLER_REQUEST = exports.FOLLOW_SELLER_REQUEST = 'la/user/followSeller/REQUEST';
var FOLLOW_SELLER_SUCCESS = exports.FOLLOW_SELLER_SUCCESS = 'la/user/followSeller/SUCCESS';

var UNFOLLOW_SELLER_FAIL = exports.UNFOLLOW_SELLER_FAIL = 'la/user/unfollowSeller/FAIL';
var UNFOLLOW_SELLER_REQUEST = exports.UNFOLLOW_SELLER_REQUEST = 'la/user/unfollowSeller/REQUEST';
var UNFOLLOW_SELLER_SUCCESS = exports.UNFOLLOW_SELLER_SUCCESS = 'la/user/unfollowSeller/SUCCESS';

// reducer
var DEFAULT_STATE = [];

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        case FOLLOW_SELLER_SUCCESS:
            return (0, _union2.default)(state, [action.payload]);

        case _user.LOAD_BIDDER_DATA_SUCCESS:
            return [].concat((0, _toConsumableArray3.default)(action.payload.followedSellers));

        case _user.LOG_OUT_BIDDER:
            return [];

        case _login.LOGIN_SUCCESS:
        case _passwordReset.PASSWORD_RESET_SUCCESS:
            return [].concat((0, _toConsumableArray3.default)(action.payload.followedSellers));

        case UNFOLLOW_SELLER_SUCCESS:
            return (0, _difference2.default)(state, [action.payload]);

        default:
            return state;
    }
}

/* SELECTORS */
var stateSelector = function stateSelector(state) {
    return state.user.followSeller;
};
var idSelector = function idSelector(state, id) {
    return id;
};

var getFollowedSellerIds = exports.getFollowedSellerIds = (0, _reselect.createSelector)(stateSelector, function (state) {
    return [].concat((0, _toConsumableArray3.default)(state));
});

var isSellerFollowed = exports.isSellerFollowed = (0, _reselect.createSelector)([stateSelector, idSelector], function (state, id) {
    return state.indexOf(id) >= 0;
});

/* ACTION CREATORS */
var submitFollowSeller = exports.submitFollowSeller = function submitFollowSeller(sellerId) {
    return function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch, getState) {
            var state, authToken, deployment;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.prev = 0;
                            state = getState();
                            authToken = (0, _user.getAuthToken)(state);
                            deployment = (0, _config.getDeployment)(state);

                            dispatch({
                                type: FOLLOW_SELLER_REQUEST
                            });
                            _context.next = 7;
                            return _api.Seller.postFollow({ authToken: authToken, deployment: deployment, sellerId: sellerId });

                        case 7:
                            dispatch({
                                meta: (0, _analytics.getFollowSellerAnalytics)(sellerId),
                                payload: sellerId,
                                type: FOLLOW_SELLER_SUCCESS
                            });
                            _context.next = 13;
                            break;

                        case 10:
                            _context.prev = 10;
                            _context.t0 = _context['catch'](0);

                            dispatch({
                                error: true,
                                payload: _context.t0,
                                type: FOLLOW_SELLER_FAIL
                            });

                        case 13:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, undefined, [[0, 10]]);
        }));

        return function (_x3, _x4) {
            return _ref.apply(this, arguments);
        };
    }();
};

var submitUnfollowSeller = exports.submitUnfollowSeller = function submitUnfollowSeller(sellerId) {
    return function () {
        var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(dispatch, getState) {
            var state, authToken, deployment;
            return _regenerator2.default.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            _context2.prev = 0;
                            state = getState();
                            authToken = (0, _user.getAuthToken)(state);
                            deployment = (0, _config.getDeployment)(state);

                            dispatch({
                                type: UNFOLLOW_SELLER_REQUEST
                            });
                            _context2.next = 7;
                            return _api.Seller.postUnfollow({ authToken: authToken, deployment: deployment, sellerId: sellerId });

                        case 7:
                            dispatch({
                                meta: (0, _analytics.getUnfollowSellerAnalytics)(sellerId),
                                payload: sellerId,
                                type: UNFOLLOW_SELLER_SUCCESS
                            });
                            _context2.next = 13;
                            break;

                        case 10:
                            _context2.prev = 10;
                            _context2.t0 = _context2['catch'](0);

                            dispatch({
                                error: true,
                                payload: _context2.t0,
                                type: UNFOLLOW_SELLER_FAIL
                            });

                        case 13:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, undefined, [[0, 10]]);
        }));

        return function (_x5, _x6) {
            return _ref2.apply(this, arguments);
        };
    }();
};

/***/ }),

/***/ "/L+n":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _itemDetail = __webpack_require__("dekO");

var _itemDetail2 = __webpack_require__("rjim");

var ItemDetail = {
    fetchItemDetailsByIds: function fetchItemDetailsByIds(params) {
        return  false ? _itemDetail.ItemDetailMock.fetchItemDetailsByIds(params) : _itemDetail2.ItemDetailRemote.fetchItemDetailsByIds(params);
    }
};

exports.default = ItemDetail;
module.exports = exports['default'];

/***/ }),

/***/ "/MQq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"support":"support___1y5Ow","container":"container___3iGW3","column":"column___2hT4O","wrapper":"wrapper___m9Vj7","column-title":"column-title___3OeaQ","container-using":"container-using___8aErp","social-icons":"social-icons___2T5en","email":"email___3IyG4","twitter":"twitter___TWBLH","facebook":"facebook___1u-0v","pinterest":"pinterest___3OMTQ","container-copyright":"container-copyright___2W9Wd","copyright":"copyright___Xct_z","health":"health___3LF-z","sitemap":"sitemap___1cAJ6","bold-title":"bold-title___k8bLv","new-site":"new-site___1y71T","classic-link":"classic-link___2DbCN"};

/***/ }),

/***/ "/Mrt":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fetchBidIncrementsIfNeeded = exports.getBidIncrementsByItemId = exports.getBidIncrements = exports.LOAD_BID_INCREMENTS_SUCCESS = exports.LOAD_BID_INCREMENTS_REQUEST = exports.LOAD_BID_INCREMENTS_FAIL = undefined;

var _regenerator = __webpack_require__("Xxa5");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _asyncToGenerator2 = __webpack_require__("exGp");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _toConsumableArray2 = __webpack_require__("Gu7T");

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;

var _item = __webpack_require__("Gk4U");

var _api = __webpack_require__("zFQO");

var _cloneDeep = __webpack_require__("kvU2");

var _cloneDeep2 = _interopRequireDefault(_cloneDeep);

var _reselect = __webpack_require__("bndy");

var _difference = __webpack_require__("WlNK");

var _difference2 = _interopRequireDefault(_difference);

var _config = __webpack_require__("iS9E");

var _isEmpty = __webpack_require__("lHK6");

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _catalog = __webpack_require__("yv/Z");

var _home = __webpack_require__("TSUT");

var _sellerEndedCatalogs = __webpack_require__("wFxa");

var _sellerUpcomingCatalogs = __webpack_require__("iMUO");

var _ms = __webpack_require__("EarI");

var _ms2 = _interopRequireDefault(_ms);

var _union = __webpack_require__("gszD");

var _union2 = _interopRequireDefault(_union);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Action Types */
var LOAD_BID_INCREMENTS_FAIL = exports.LOAD_BID_INCREMENTS_FAIL = 'la/domain/bidIncrements/LOAD_FAIL';
var LOAD_BID_INCREMENTS_REQUEST = exports.LOAD_BID_INCREMENTS_REQUEST = 'la/domain/bidIncrements/LOAD_REQUEST';
var LOAD_BID_INCREMENTS_SUCCESS = exports.LOAD_BID_INCREMENTS_SUCCESS = 'la/domain/bidIncrements/LOAD_SUCCESS';

var REDUX_STORE_TIME = (0, _ms2.default)('30m');

/* reducer */
var DEFAULT_STATE = {
    byId: {},
    loaded: {},
    loading: []
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var existing = void 0;
    var loaded = void 0;
    var loading = void 0;
    var time = void 0;

    switch (action.type) {
        case LOAD_BID_INCREMENTS_FAIL:
            return (0, _extends3.default)({}, state, {
                loading: (0, _difference2.default)(state.loading, [action.meta.catalogId])
            });
        case LOAD_BID_INCREMENTS_REQUEST:
            return (0, _extends3.default)({}, state, {
                loading: (0, _union2.default)(state.loading, [action.payload])
            });
        case LOAD_BID_INCREMENTS_SUCCESS:
            existing = (0, _cloneDeep2.default)(state.byId);
            loaded = (0, _extends3.default)({}, state.loaded);
            loading = (0, _cloneDeep2.default)(state.loading);
            time = action.meta.actionTime;

            action.payload.forEach(function (item) {
                existing[item.catalogId] = item.bidIncrements;
                loaded[item.catalogId] = time;
                loading = (0, _difference2.default)(loading, [item.catalogId]);
            });
            return (0, _extends3.default)({}, state, {
                byId: existing,
                loaded: loaded,
                loading: loading
            });
        case _catalog.LOAD_CATALOGS_SUCCESS:
        case _home.LOAD_HOME_DATA_SUCCESS:
        case _item.LOAD_ITEMS_SUCCESS:
        case _sellerUpcomingCatalogs.LOAD_SELLER_UPCOMING_CATALOGS_SUCCESS:
        case _sellerEndedCatalogs.LOAD_SELLER_ENDED_CATALOGS_SUCCESS:
            existing = (0, _cloneDeep2.default)(state.byId);
            loaded = (0, _extends3.default)({}, state.loaded);
            loading = (0, _cloneDeep2.default)(state.loading);
            time = action.meta.actionTime;

            if (action.payload.bidIncrements) {
                action.payload.bidIncrements.forEach(function (item) {
                    existing[item.catalogId] = [].concat((0, _toConsumableArray3.default)(item.bidIncrements));
                    loaded[item.catalogId] = time;
                    loading = (0, _difference2.default)(loading, [item.catalogId]);
                });
            }
            return (0, _extends3.default)({}, state, {
                byId: existing,
                loaded: loaded,
                loading: loading
            });
        default:
            return state;
    }
}

/* SELECTORS */
var stateSelector = function stateSelector(state) {
    return state.domain.bidIncrements;
};
var idSelector = function idSelector(state, id) {
    return id;
};

var byIdSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.byId;
});

var loadedSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.loaded;
});

var loadingSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.loading;
});

var getBidIncrements = exports.getBidIncrements = (0, _reselect.createSelector)([byIdSelector, idSelector], function (byId, id) {
    return byId[id] || [];
});

var getBidIncrementsByItemId = exports.getBidIncrementsByItemId = (0, _reselect.createSelector)([byIdSelector, _item.getItem], function (byId, item) {
    return byId[item.catalogId] || [];
});

var getLoadTimeForBidIncrements = (0, _reselect.createSelector)([loadedSelector, idSelector], function (loaded, id) {
    return loaded[id] || 0;
});

var isBidIncrementsLoading = (0, _reselect.createSelector)([loadingSelector, idSelector], function (loading, id) {
    return loading.includes(id);
});

var shouldFetchBidIncrements = (0, _reselect.createSelector)([idSelector, getBidIncrements, getLoadTimeForBidIncrements, isBidIncrementsLoading], function (catalogId, item, loaded, loading) {
    if (!catalogId) return false;
    if (!(0, _isEmpty2.default)(item)) {
        var time = Date.now();
        var diff = time - loaded;
        if (diff < REDUX_STORE_TIME) return false;
    }
    return !loading;
});

/* ACTION CREATORS */
var fetchBidIncrementsIfNeeded = exports.fetchBidIncrementsIfNeeded = function fetchBidIncrementsIfNeeded(catalogId) {
    return function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch, getState) {
            var state, deployment, response;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            state = getState();

                            if (!shouldFetchBidIncrements(state, catalogId)) {
                                _context.next = 16;
                                break;
                            }

                            deployment = (0, _config.getDeployment)(state);
                            _context.prev = 3;

                            dispatch({
                                meta: { actionTime: Date.now() },
                                payload: catalogId,
                                type: LOAD_BID_INCREMENTS_REQUEST
                            });
                            _context.next = 7;
                            return _api.BidIncrements.fetchBidIncrements({ catalogId: catalogId, deployment: deployment });

                        case 7:
                            response = _context.sent;

                            dispatch({
                                meta: { actionTime: Date.now(), catalogId: catalogId },
                                payload: response.data,
                                type: LOAD_BID_INCREMENTS_SUCCESS
                            });
                            _context.next = 14;
                            break;

                        case 11:
                            _context.prev = 11;
                            _context.t0 = _context['catch'](3);

                            dispatch({
                                error: true,
                                meta: { catalogId: catalogId },
                                payload: _context.t0,
                                type: LOAD_BID_INCREMENTS_FAIL
                            });

                        case 14:
                            _context.next = 17;
                            break;

                        case 16:
                            return _context.abrupt('return', _promise2.default.resolve());

                        case 17:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, undefined, [[3, 11]]);
        }));

        return function (_x3, _x4) {
            return _ref.apply(this, arguments);
        };
    }();
};

/***/ }),

/***/ "/P8x":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper___UR0r_","navigation":"navigation___XnLRJ","scroll-container":"scroll-container___1nOkH","item":"item___25vCK","pipe":"pipe___3205S","fade":"fade___3K1k9","navBar":"navBar___2x98N"};

/***/ }),

/***/ "/j9A":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = __webpack_require__("dcb+");

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;

var _saveItem = __webpack_require__("6oKK");

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propsComparer = __webpack_require__("wsGv");

var _propsComparer2 = _interopRequireDefault(_propsComparer);

var _redux = __webpack_require__("2KeS");

var _reactRedux = __webpack_require__("RH2O");

var _user = __webpack_require__("CFLi");

var _ItemSaveButton = __webpack_require__("+WQL");

var _ItemSaveButton2 = _interopRequireDefault(_ItemSaveButton);

var _ItemSaveIcon = __webpack_require__("MKYO");

var _ItemSaveIcon2 = _interopRequireDefault(_ItemSaveIcon);

var _noop = __webpack_require__("9vKl");

var _noop2 = _interopRequireDefault(_noop);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _components = __webpack_require__("bGai");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ItemSaveContainer = (_dec = (0, _reactRedux.connect)(function (state, _ref) {
    var itemId = _ref.itemId;

    var saved = (0, _saveItem.isItemSaved)(state, itemId);
    return {
        saved: saved,
        userLoggedIn: (0, _user.isUserLoggedIn)(state)
    };
}, function (dispatch) {
    return (0, _redux.bindActionCreators)({ toggleItemSave: _saveItem.toggleItemSave }, dispatch);
}), _dec(_class = (_temp2 = _class2 = function (_Component) {
    (0, _inherits3.default)(ItemSaveContainer, _Component);

    function ItemSaveContainer() {
        var _ref2;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, ItemSaveContainer);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref2 = ItemSaveContainer.__proto__ || (0, _getPrototypeOf2.default)(ItemSaveContainer)).call.apply(_ref2, [this].concat(args))), _this), _this.onToggleSave = function () {
            _this.props.toggleItemSave(_this.props.itemId);
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(ItemSaveContainer, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps) {
            return (0, _propsComparer2.default)(this.props, nextProps, ['saved', 'userLoggedIn']);
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                button = _props.button,
                className = _props.className,
                iconClassName = _props.iconClassName,
                saved = _props.saved,
                userLoggedIn = _props.userLoggedIn;


            return (0, _jsx3.default)(_components.ShouldLogInContainer, {
                requireLogin: true,
                runFunction: this.onToggleSave,
                className: className
            }, void 0, button ? (0, _jsx3.default)(_ItemSaveButton2.default, {
                save: _noop2.default,
                saved: userLoggedIn && saved
            }) : (0, _jsx3.default)(_ItemSaveIcon2.default, {
                className: iconClassName,
                save: _noop2.default,
                saved: userLoggedIn && saved
            }));
        }
    }]);
    return ItemSaveContainer;
}(_react.Component), _class2.defaultProps = {
    button: false,
    className: '',
    iconClassName: '',
    itemId: 0,
    saved: false,
    userLoggedIn: false
}, _temp2)) || _class);
exports.default = ItemSaveContainer;
module.exports = exports['default'];

/***/ }),

/***/ "/lBP":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (event) {
    event.preventDefault();
};

module.exports = exports["default"];

/***/ }),

/***/ "/rMq":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _consignment = __webpack_require__("5jkQ");

var Consignment = {
    postConsignment: _consignment.ConsignmentRemote.postConsignment
};

exports.default = Consignment;
module.exports = exports['default'];

/***/ }),

/***/ "/wT0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = __webpack_require__("fZjL");

var _keys2 = _interopRequireDefault(_keys);

var _isInteger = __webpack_require__("RRo+");

var _isInteger2 = _interopRequireDefault(_isInteger);

exports.email = email;
exports.phone = phone;
exports.internationalPhone = internationalPhone;
exports.required = required;
exports.minLength = minLength;
exports.maxLength = maxLength;
exports.integer = integer;
exports.match = match;
exports.createValidator = createValidator;
exports.wholeNumbersStartingWithOne = wholeNumbersStartingWithOne;
exports.validatePassword = validatePassword;
exports.validateInternationalZipCode = validateInternationalZipCode;

var _isEmpty = __webpack_require__("lHK6");

var _isEmpty2 = _interopRequireDefault(_isEmpty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var join = function join(rules) {
    return function (value, data) {
        return rules.map(function (rule) {
            return rule(value, data);
        }).filter(function (error) {
            return !!error;
        })[0];
    };
};

function email(value) {
    var emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return emailRegex.test(value);
}

function phone(value) {
    var phoneRegex = /(?:(?:(\s*\(?([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9])\s*)|([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9]))\)?\s*(?:[.-]\s*)?)([2-9]1[02-9]|[2-9][02-9]1|[2-9][02-9]{2})\s*(?:[.-]\s*)?([0-9]{4})/;
    return phoneRegex.test(value);
}

function internationalPhone(value) {
    return !!value;
}

function required(value) {
    if (typeof value === 'number') return true;
    return !(0, _isEmpty2.default)(value);
}

function minLength(min) {
    return function (value) {
        if (!(0, _isEmpty2.default)(value) && value.length < min) {
            return 'Must be at least ' + min + ' characters';
        }
    };
}

function maxLength(value, max) {
    return !(0, _isEmpty2.default)(value) && value.length <= max;
}

function integer(value) {
    if (!(0, _isInteger2.default)(Number(value))) {
        return 'Must be an integer';
    }
    return !(0, _isInteger2.default)(Number(value));
}

function match(field) {
    return function (value, data) {
        if (data) {
            if (value !== data[field]) {
                return 'Do not match';
            }
        }
    };
}

function createValidator(rules) {
    return function () {
        var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        var errors = {};
        (0, _keys2.default)(rules).forEach(function (key) {
            var rule = join([].concat(rules[key])); // concat enables both functions and arrays of functions
            var error = rule(data[key], data);
            if (error) {
                errors[key] = error;
            }
        });
        return errors;
    };
}

function wholeNumbersStartingWithOne(value) {
    var regExp = /^[1-9][0-9]*$/;
    return regExp.test(value);
}

function validatePassword(value) {
    return required(value) && value.length >= 6;
}

function validateInternationalZipCode(zipCode) {
    var zipCodeValidationRegex = /^[a-zA-Z0-9-_]+$/;
    return zipCodeValidationRegex.test(zipCode);
}

/***/ }),

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("wPPq");
module.exports = __webpack_require__("2Eh+");


/***/ }),

/***/ "018r":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"curator-info":"curator-info___HUcKu","label":"label___3v92j","curator":"curator___Qv2HW","image":"image___3wBWN","details":"details___2H4_K","name":"name___1PKMs","title":"title___HruQg"};

/***/ }),

/***/ "0QM2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fetchCatalogAdIfNeeded = exports.isCatalogAdLoading = exports.getLoadTimeForCatalogAd = exports.getAd = exports.getAdByKeyword = exports.getAdById = exports.LOAD_CATALOG_AD_SUCCESS = exports.LOAD_CATALOG_AD_REQUEST = exports.LOAD_CATALOG_AD_FAIL = undefined;

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _regenerator = __webpack_require__("Xxa5");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__("exGp");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;

var _api = __webpack_require__("zFQO");

var _cloneDeep = __webpack_require__("kvU2");

var _cloneDeep2 = _interopRequireDefault(_cloneDeep);

var _reselect = __webpack_require__("bndy");

var _difference = __webpack_require__("WlNK");

var _difference2 = _interopRequireDefault(_difference);

var _config = __webpack_require__("iS9E");

var _ms = __webpack_require__("EarI");

var _ms2 = _interopRequireDefault(_ms);

var _union = __webpack_require__("gszD");

var _union2 = _interopRequireDefault(_union);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var REDUX_STORE_TIME = (0, _ms2.default)('3m');

/* Action Types */
var LOAD_CATALOG_AD_FAIL = exports.LOAD_CATALOG_AD_FAIL = 'la/domain/catalogAds/LOAD_FAIL';
var LOAD_CATALOG_AD_REQUEST = exports.LOAD_CATALOG_AD_REQUEST = 'la/domain/catalogAds/LOAD_REQUEST';
var LOAD_CATALOG_AD_SUCCESS = exports.LOAD_CATALOG_AD_SUCCESS = 'la/domain/catalogAds/LOAD_SUCCESS';

/* reducer */
var DEFAULT_STATE = {
    byId: {},
    byKeyword: {},
    loaded: {},
    loading: []
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var existing = void 0;
    var existingByKeywords = void 0;
    var loaded = void 0;
    var loading = void 0;

    switch (action.type) {
        case LOAD_CATALOG_AD_FAIL:
            return (0, _extends3.default)({}, state, {
                loading: (0, _difference2.default)(state.loading, [action.meta.keywords || action.meta.categoryIds])
            });
        case LOAD_CATALOG_AD_REQUEST:
            return (0, _extends3.default)({}, state, {
                loading: (0, _union2.default)(state.loading, [action.payload])
            });
        case LOAD_CATALOG_AD_SUCCESS:
            var _action$meta = action.meta,
                categoryIds = _action$meta.categoryIds,
                keywords = _action$meta.keywords;

            existing = (0, _cloneDeep2.default)(state.byId);
            existingByKeywords = (0, _cloneDeep2.default)(state.byKeyword);
            loaded = (0, _cloneDeep2.default)(state.loaded);
            loading = (0, _cloneDeep2.default)(state.loading);
            loaded[keywords || categoryIds] = action.meta.actionTime;
            loading = (0, _difference2.default)(loading, [keywords || categoryIds]);
            if (keywords) {
                existingByKeywords[keywords] = action.payload.ads[0];
            } else {
                existing[categoryIds] = action.payload.ads[0];
            }

            return (0, _extends3.default)({}, state, {
                byId: existing,
                byKeyword: existingByKeywords,
                loaded: loaded,
                loading: loading
            });
        default:
            return state;
    }
}

/* SELECTORS */
var stateSelector = function stateSelector(state) {
    return state.domain.catalogAd;
};
var idSelector = function idSelector(state, id) {
    return id;
};

var byIdSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.byId;
});
var byKeywordSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.byKeyword;
});
var loadedSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.loaded;
});
var loadingSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.loading;
});

var getAdById = exports.getAdById = (0, _reselect.createSelector)([byIdSelector, idSelector], function (byId, id) {
    return byId[id] || {};
});
var getAdByKeyword = exports.getAdByKeyword = (0, _reselect.createSelector)([byKeywordSelector, idSelector], function (byKeyword, keywords) {
    return byKeyword[keywords] || {};
});

var getAd = exports.getAd = function getAd(state, categoryIds, keywords) {
    if (keywords) return getAdByKeyword(state, keywords);else if (categoryIds) return getAdById(state, categoryIds);else return {};
};

var getLoadTimeForCatalogAd = exports.getLoadTimeForCatalogAd = function getLoadTimeForCatalogAd(state, categoryIds, keywords) {
    var selector = keywords || categoryIds;
    return (0, _reselect.createSelector)([loadedSelector, idSelector], function (loaded, id) {
        return loaded[id] || 0;
    })(state, selector);
};

var isCatalogAdLoading = exports.isCatalogAdLoading = (0, _reselect.createSelector)([loadingSelector, idSelector], function (loading, id) {
    return loading.includes(id);
});

var loadCatalogAd = function loadCatalogAd(categoryIds, keywords, pageName) {
    return function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch, getState) {
            var state, deployment, response;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.prev = 0;
                            state = getState();
                            deployment = (0, _config.getDeployment)(state);

                            dispatch({
                                payload: keywords || categoryIds,
                                type: LOAD_CATALOG_AD_REQUEST
                            });
                            _context.next = 6;
                            return _api.CatalogAd.fetchCatalogAd({ categoryIds: categoryIds, deployment: deployment, keywords: keywords, pageName: pageName });

                        case 6:
                            response = _context.sent;

                            dispatch({
                                meta: { actionTime: Date.now(), categoryIds: categoryIds, keywords: keywords },
                                payload: response.data,
                                type: LOAD_CATALOG_AD_SUCCESS
                            });
                            _context.next = 13;
                            break;

                        case 10:
                            _context.prev = 10;
                            _context.t0 = _context['catch'](0);

                            dispatch({
                                error: true,
                                meta: { categoryIds: categoryIds, keywords: keywords },
                                payload: _context.t0,
                                type: LOAD_CATALOG_AD_FAIL
                            });

                        case 13:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, undefined, [[0, 10]]);
        }));

        return function (_x3, _x4) {
            return _ref.apply(this, arguments);
        };
    }();
};

var shouldFetchCatalogAd = function shouldFetchCatalogAd(state, categoryIds, keywords) {
    if (!categoryIds && !keywords) return false;
    var item = getAd(state, categoryIds, keywords);
    if (item) {
        var loaded = getLoadTimeForCatalogAd(state, categoryIds, keywords);
        var time = Date.now();
        var diff = time - loaded;
        if (diff < REDUX_STORE_TIME) return false;
    }
    var loading = isCatalogAdLoading(state, categoryIds);
    return !loading;
};

var fetchCatalogAdIfNeeded = exports.fetchCatalogAdIfNeeded = function fetchCatalogAdIfNeeded(_ref2) {
    var categoryIds = _ref2.categoryIds,
        keywords = _ref2.keywords,
        pageName = _ref2.pageName;
    return function (dispatch, getState) {
        if (shouldFetchCatalogAd(getState(), categoryIds, keywords)) {
            return dispatch(loadCatalogAd(categoryIds, keywords, pageName));
        }
        return _promise2.default.resolve();
    };
};

/***/ }),

/***/ "0cas":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"logged-in":"logged-in___1wUVf","me-button":"me-button___2YCsf","me":"me___3BtI7","link":"link___1vuTj","auction-pipe":"auction-pipe___B7jzU","me-modal":"me-modal___3cn0H","header":"header___3J3lX","body":"body___3ra_Q","list":"list___1avTj","list-item":"list-item___3EUAY","footer":"footer___2PVzQ","popover":"popover___p9-8v","log-out":"log-out___5QsYj"};

/***/ }),

/***/ "0jBl":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _catalogAd = __webpack_require__("6QU5");

var CatalogAd = {
    fetchCatalogAd: _catalogAd.CatalogAdRemote.fetchCatalogAd
};

exports.default = CatalogAd;
module.exports = exports['default'];

/***/ }),

/***/ "0lB/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = createStore;

var _redux = __webpack_require__("2KeS");

var _reactIntl = __webpack_require__("Pq8k");

var _analyticsActionMapper = __webpack_require__("4hkW");

var _analyticsActionMapper2 = _interopRequireDefault(_analyticsActionMapper);

var _reduxDevtoolsExtension = __webpack_require__("gFN5");

var _logger = __webpack_require__("JcK0");

var _logger2 = _interopRequireDefault(_logger);

var _reduxSegment = __webpack_require__("m95F");

var _en = __webpack_require__("TCl6");

var _en2 = _interopRequireDefault(_en);

var _riskified = __webpack_require__("cOev");

var _riskified2 = _interopRequireDefault(_riskified);

var _reactRouterRedux = __webpack_require__("jZgO");

var _reduxThunk = __webpack_require__("4ufr");

var _reduxThunk2 = _interopRequireDefault(_reduxThunk);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _reactIntl.addLocaleData)(_en2.default);

function createStore(history, data) {
    // middlewares
    var middleware = [(0, _reactRouterRedux.routerMiddleware)(history), _reduxThunk2.default, _riskified2.default];

    if (false) {
        middleware.push((0, _logger2.default)({ client: true, server: true }));
        middleware.push(require('redux-immutable-state-invariant').default());
    } else {
        middleware.push((0, _reduxSegment.createTracker)(_analyticsActionMapper2.default));
    }

    // enhancers
    var enhancers = [_redux.applyMiddleware.apply(undefined, middleware)];

    var compose = (0, _reduxDevtoolsExtension.composeWithDevTools)({});
    var finalCreateStore = compose.apply(undefined, enhancers)(_redux.createStore);

    var reducer = __webpack_require__("PTSw");
    var store = finalCreateStore(reducer, data);
    return store;
}
module.exports = exports['default'];

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "11Md":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

var _ = __webpack_require__("cjn6");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var myBidsSortOrders = (0, _extends3.default)({}, _.itemSortOrders, {
    BID_RECENT_FIRST: 'BID_RECENT_FIRST',
    BID_OLDEST_FIRST: 'BID_OLDEST_FIRST'
    /*eslint-enable */
});

exports.default = myBidsSortOrders;
module.exports = exports['default'];

/***/ }),

/***/ "1G/f":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = __webpack_require__("dcb+");

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;

var _followSeller = __webpack_require__("/9SA");

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propsComparer = __webpack_require__("wsGv");

var _propsComparer2 = _interopRequireDefault(_propsComparer);

var _redux = __webpack_require__("2KeS");

var _reactRedux = __webpack_require__("RH2O");

var _FollowSellerButton = __webpack_require__("iwOt");

var _FollowSellerButton2 = _interopRequireDefault(_FollowSellerButton);

var _FollowSellerLink = __webpack_require__("53Ov");

var _FollowSellerLink2 = _interopRequireDefault(_FollowSellerLink);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _components = __webpack_require__("bGai");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FollowSellerContainer = (_dec = (0, _reactRedux.connect)(function (state, _ref) {
    var sellerId = _ref.sellerId;

    var followed = (0, _followSeller.isSellerFollowed)(state, sellerId);
    return {
        followed: followed
    };
}, function (dispatch) {
    return (0, _redux.bindActionCreators)({
        submitFollowSeller: _followSeller.submitFollowSeller,
        submitUnfollowSeller: _followSeller.submitUnfollowSeller
    }, dispatch);
}), _dec(_class = (_temp2 = _class2 = function (_Component) {
    (0, _inherits3.default)(FollowSellerContainer, _Component);

    function FollowSellerContainer() {
        var _ref2;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, FollowSellerContainer);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref2 = FollowSellerContainer.__proto__ || (0, _getPrototypeOf2.default)(FollowSellerContainer)).call.apply(_ref2, [this].concat(args))), _this), _this.toggleFollowSeller = function () {
            if (!_this.props.followed) {
                _this.props.submitFollowSeller(_this.props.sellerId);
            } else {
                _this.props.submitUnfollowSeller(_this.props.sellerId);
            }
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(FollowSellerContainer, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps) {
            return (0, _propsComparer2.default)(this.props, nextProps, ['button', 'children', 'followed', 'sellerId']);
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                button = _props.button,
                children = _props.children,
                followed = _props.followed;


            return (0, _jsx3.default)(_components.ShouldLogInContainer, {
                requireLogin: true,
                runFunction: this.toggleFollowSeller
            }, void 0, button ? (0, _jsx3.default)(_FollowSellerButton2.default, {
                followed: followed
            }, void 0, children) : (0, _jsx3.default)(_FollowSellerLink2.default, {
                followed: followed
            }, void 0, children));
        }
    }]);
    return FollowSellerContainer;
}(_react.Component), _class2.defaultProps = {
    button: false
}, _temp2)) || _class);
exports.default = FollowSellerContainer;
module.exports = exports['default'];

/***/ }),

/***/ "1Hq4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getCategoryLandingPageSearchQuery = exports.getDeletedItemTitleIfNeeded = exports.searchCategory = exports.getLandingPageMetaData = exports.getAuctionResultsLandingPageUrl = exports.getCategoryLandingPageUrl = exports.getPageLabel = exports.LOAD_CATEGORY_RESULTS_SUCCESS = exports.LOAD_CATEGORY_RESULTS_REQUEST = exports.LOAD_CATEGORY_RESULTS_FAIL = undefined;

var _defineProperty2 = __webpack_require__("bOdI");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _keys = __webpack_require__("fZjL");

var _keys2 = _interopRequireDefault(_keys);

var _isNan = __webpack_require__("MICi");

var _isNan2 = _interopRequireDefault(_isNan);

var _extends3 = __webpack_require__("Dd8w");

var _extends4 = _interopRequireDefault(_extends3);

exports.default = reducer;

var _api = __webpack_require__("zFQO");

var _cloneDeep = __webpack_require__("kvU2");

var _cloneDeep2 = _interopRequireDefault(_cloneDeep);

var _reselect = __webpack_require__("bndy");

var _config = __webpack_require__("iS9E");

var _item = __webpack_require__("Gk4U");

var _user = __webpack_require__("CFLi");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Action Types */
var LOAD_CATEGORY_RESULTS_FAIL = exports.LOAD_CATEGORY_RESULTS_FAIL = 'LOAD_CATEGORY_RESULTS_FAIL';
var LOAD_CATEGORY_RESULTS_REQUEST = exports.LOAD_CATEGORY_RESULTS_REQUEST = 'LOAD_CATEGORY_RESULTS_REQUEST';
var LOAD_CATEGORY_RESULTS_SUCCESS = exports.LOAD_CATEGORY_RESULTS_SUCCESS = 'LOAD_CATEGORY_RESULTS_SUCCESS';

// reducer
var DEFAULT_STATE = {
    // error: false,
    // isLoading: true,
    metaData: {
        pageLabel: '',
        pageMetaDescription: '',
        pageMetaKeywords: '',
        pageTitle: ''
    }
    // submitted: false,
    // success: false,
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        case LOAD_CATEGORY_RESULTS_SUCCESS:
            var metaData = state.metaData;
            if (action.payload.landingPageMetaData) {
                metaData = {
                    canonicalURL: action.payload.landingPageMetaData.canonicalURL,
                    pageLabel: action.payload.landingPageMetaData.label,
                    pageMetaDescription: action.payload.landingPageMetaData.metaDescription,
                    pageMetaKeywords: action.payload.landingPageMetaData.metaKeywords,
                    pageTitle: action.payload.landingPageMetaData.pageTitle
                };
            }
            return (0, _extends4.default)({}, state, {
                // isLoading: false,
                metaData: metaData
                // submitted: false,
                // success: true,
            });
        default:
            return state;
    }
}

/* SELECTORS */
var stateSelector = function stateSelector(state) {
    return state.ui.landingPage;
};
// const idSelector = (state, id) => id;

// const errorSelector = createSelector(
//     stateSelector,
//     state => state.error,
// );

// const isLoadingSelector = createSelector(
//     stateSelector,
//     state => state.isLoading,
// );

var metaDataSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.metaData;
});

// const submittedSelector = createSelector(
//     stateSelector,
//     state => state.submitted,
// );

// const successSelector = createSelector(
//     stateSelector,
//     state => state.success,
// );

var getPageMetaDescription = (0, _reselect.createSelector)(metaDataSelector, function (metaData) {
    return metaData.pageMetaDescription;
});

var getPageMetaKeywords = (0, _reselect.createSelector)(metaDataSelector, function (metaData) {
    return metaData.pageMetaKeywords;
});

var getPageTitle = (0, _reselect.createSelector)(metaDataSelector, function (metaData) {
    return metaData.pageTitle;
});
var getCanonicalURL = (0, _reselect.createSelector)(metaDataSelector, function (metaData) {
    return metaData.canonicalURL;
});

var getPageLabel = exports.getPageLabel = (0, _reselect.createSelector)(metaDataSelector, function (metaData) {
    return metaData.pageLabel;
});

var getCategoryLandingPageUrl = exports.getCategoryLandingPageUrl = function getCategoryLandingPageUrl(params) {
    return getLandingPageUrl(params, 'c');
};

var getAuctionResultsLandingPageUrl = exports.getAuctionResultsLandingPageUrl = function getAuctionResultsLandingPageUrl(params) {
    return getLandingPageUrl(params, 'price-guide');
};

var getLandingPageUrl = function getLandingPageUrl(params, route) {
    if (!params.categoryId || (0, _isNan2.default)(Number(params.categoryId))) {
        return '/' + route + '/';
    } else if (params.categoryId2 && params.categoryName2) {
        return '/' + route + '/' + params.categoryName + '/' + params.categoryName2 + '/' + params.categoryId + '/' + params.categoryId2 + '/';
    }
    return '/' + route + '/' + params.categoryName + '/' + params.categoryId + '/';
};

var getLandingPageMetaData = exports.getLandingPageMetaData = function getLandingPageMetaData(state, params) {
    var landingPageMetaData = {
        canonicalURL: getCanonicalURL(state),
        pageMetaDescription: getPageMetaDescription(state),
        pageMetaKeywords: getPageMetaKeywords(state),
        pageTitle: getPageTitle(state),
        pageUrl: getCategoryLandingPageUrl(params)
    };

    return (0, _cloneDeep2.default)(landingPageMetaData);
};

/* ACTION CREATORS */
var categoryResultsFail = function categoryResultsFail(searchQuery, error) {
    return {
        error: true,
        meta: { searchQuery: searchQuery },
        payload: error,
        type: LOAD_CATEGORY_RESULTS_FAIL
    };
};

var categoryResultsRequest = function categoryResultsRequest(searchQuery) {
    return {
        payload: searchQuery,
        type: LOAD_CATEGORY_RESULTS_REQUEST
    };
};

var categoryResultsSuccess = function categoryResultsSuccess(results) {
    return {
        payload: results,
        type: LOAD_CATEGORY_RESULTS_SUCCESS
    };
};

var searchCategory = exports.searchCategory = function searchCategory(searchQuery, ids) {
    return function (dispatch, getState) {
        var state = getState();
        var deployment = (0, _config.getDeployment)(state);
        dispatch(categoryResultsRequest(searchQuery));

        // Annotate facets which have user-defined search exclusions
        var searchExclusions = (0, _user.getUserExcludedFacets)(state);
        var augmentedOptions = !searchExclusions ? searchQuery.options : (0, _keys2.default)(searchExclusions).reduce(function (options, facetWithExclusions) {
            return (0, _extends4.default)({}, options, (0, _defineProperty3.default)({}, facetWithExclusions, [{
                exclude: searchExclusions[facetWithExclusions] || [],
                include: searchQuery.options && searchQuery.options[facetWithExclusions] || []
            }]));
        }, (0, _extends4.default)({}, searchQuery.options));
        var augmentedSearchQuery = (0, _extends4.default)({}, searchQuery, {
            options: augmentedOptions
        });

        return _api.Search.fetchCategoryResults({ deployment: deployment, ids: ids, searchQuery: augmentedSearchQuery }).then(function (results) {
            if (results.errorMessage) {
                dispatch(categoryResultsFail(searchQuery, results));
            } else {
                dispatch(categoryResultsSuccess(results));
            }
        }).catch(function (error) {
            dispatch(categoryResultsFail(searchQuery, error));
        });
    };
};

var getDeletedItemTitleIfNeeded = exports.getDeletedItemTitleIfNeeded = function getDeletedItemTitleIfNeeded(state, query) {
    var item = void 0;
    var returnTitle = '';
    if (query.deleted && !isNaN(query.deleted)) {
        item = (0, _item.getItem)(state, query.deleted) || {
            isDeleted: true,
            title: 'The item you were seeking'
        };
    }
    if (item && item.isDeleted && item.title) {
        returnTitle = item.title;
    }
    return returnTitle;
};

var getCategoryLandingPageSearchQuery = exports.getCategoryLandingPageSearchQuery = function getCategoryLandingPageSearchQuery(pathname, savedSearchQuery) {
    var result = (0, _cloneDeep2.default)(savedSearchQuery);

    if (pathname.includes('/c/') && !result.campaignId) {
        var pathCategoryIds = pathname.match(/\d+/g);
        pathCategoryIds = pathCategoryIds ? pathCategoryIds.join() : '';
        var category_id = savedSearchQuery.category_id;


        if (!category_id) {
            result.category_id = pathCategoryIds;
        } else {
            result.category_id = pathCategoryIds + ',' + savedSearchQuery.category_id;
        }
    }

    return result;
};

//TODO: rename all the categories to landing where appropriate

/***/ }),

/***/ "1Wc7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.WonItems = undefined;

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _helpers = __webpack_require__("SY39");

var _wonLostCatalogsTransform = __webpack_require__("wTTR");

var _wonLostCatalogsTransform2 = _interopRequireDefault(_wonLostCatalogsTransform);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WonItems = exports.WonItems = {
    fetchWonItems: function fetchWonItems(_ref) {
        var authToken = _ref.authToken,
            bidderId = _ref.bidderId,
            catalogId = _ref.catalogId,
            deployment = _ref.deployment,
            _ref$page = _ref.page,
            page = _ref$page === undefined ? 1 : _ref$page,
            _ref$pageSize = _ref.pageSize,
            pageSize = _ref$pageSize === undefined ? 1250 : _ref$pageSize;

        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makeGet)('<MAINHOST-API>api/bidders/' + bidderId + '/wonitems', deployment);
            request.query({ client_version: '5.0', page: page, pagesize: pageSize });
            (0, _helpers.addAuthToken)(request, authToken);
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response, transform: _wonLostCatalogsTransform2.default });
            });
        });
    }
};

/***/ }),

/***/ "1dxa":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _biddingInfo = __webpack_require__("Z/Sy");

var _biddingInfo2 = __webpack_require__("bigW");

var BiddingInfo = {
    fetchCatalogBidding: function fetchCatalogBidding(params) {
        return  false ? _biddingInfo.BiddingInfoMock.fetchCatalogBidding(params) : _biddingInfo2.BiddingInfoRemote.fetchCatalogBidding(params);
    },
    fetchItemBidding: _biddingInfo2.BiddingInfoRemote.fetchItemBidding
};

exports.default = BiddingInfo;
module.exports = exports['default'];

/***/ }),

/***/ "1mgj":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fetchCatalogDetailsIfNeeded = exports.isCatalogDetailLoading = exports.getLoadTimeForCatalogDetail = exports.getCatalogDetail = exports.LOAD_CATALOG_DETAILS_SUCCESS = exports.LOAD_CATALOG_DETAILS_REQUEST = exports.LOAD_CATALOG_DETAILS_FAIL = undefined;

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _regenerator = __webpack_require__("Xxa5");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__("exGp");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;

var _api = __webpack_require__("zFQO");

var _cloneDeep = __webpack_require__("kvU2");

var _cloneDeep2 = _interopRequireDefault(_cloneDeep);

var _reselect = __webpack_require__("bndy");

var _difference = __webpack_require__("WlNK");

var _difference2 = _interopRequireDefault(_difference);

var _config = __webpack_require__("iS9E");

var _ms = __webpack_require__("EarI");

var _ms2 = _interopRequireDefault(_ms);

var _union = __webpack_require__("gszD");

var _union2 = _interopRequireDefault(_union);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Action Types */
var LOAD_CATALOG_DETAILS_FAIL = exports.LOAD_CATALOG_DETAILS_FAIL = 'la/domain/catalogDetail/LOAD_FAIL';
var LOAD_CATALOG_DETAILS_REQUEST = exports.LOAD_CATALOG_DETAILS_REQUEST = 'la/domain/catalogDetail/LOAD_REQUEST';
var LOAD_CATALOG_DETAILS_SUCCESS = exports.LOAD_CATALOG_DETAILS_SUCCESS = 'la/domain/catalogDetail/LOAD_SUCCESS';

var REDUX_STORE_TIME = (0, _ms2.default)('30m');

var splitCustomTerms = function splitCustomTerms(terms) {
    var paymentDetails = terms.find(function (term) {
        return term.id === 'pay';
    }) || {};
    var shippingDetails = terms.find(function (term) {
        return term.id === 'ship';
    }) || {};
    var customTerms = terms.filter(function (term) {
        return term.id !== 'pay' && term.id !== 'ship';
    });

    return {
        customTerms: customTerms,
        paymentDetails: paymentDetails.data || '',
        shippingDetails: shippingDetails.data || ''
    };
};

/* reducer */
var DEFAULT_STATE = {
    byId: {},
    loaded: {},
    loading: []
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var existing = void 0;
    var loaded = void 0;
    var loading = void 0;
    var time = void 0;

    switch (action.type) {
        case LOAD_CATALOG_DETAILS_FAIL:
            return (0, _extends3.default)({}, state, {
                loading: (0, _difference2.default)(state.loading, action.meta.catalogIds)
            });
        case LOAD_CATALOG_DETAILS_REQUEST:
            return (0, _extends3.default)({}, state, {
                loading: (0, _union2.default)(state.loading, action.payload)
            });
        case LOAD_CATALOG_DETAILS_SUCCESS:
            existing = (0, _cloneDeep2.default)(state.byId);
            loaded = (0, _cloneDeep2.default)(state.loaded);
            loading = (0, _cloneDeep2.default)(state.loading);
            time = action.meta.actionTime;

            if (action.payload.catalogDetails) {
                action.payload.catalogDetails.forEach(function (item) {
                    existing[item.catalogId] = (0, _extends3.default)({
                        catalogId: item.catalogId
                    }, splitCustomTerms(item.customTerms), {
                        terms: item.terms
                    });
                    loaded[item.catalogId] = time;
                    loading = (0, _difference2.default)(loading, [item.catalogId]);
                });
            }
            return (0, _extends3.default)({}, state, {
                byId: existing,
                loaded: loaded,
                loading: loading
            });
        default:
            return state;
    }
}

/* SELECTORS */
var stateSelector = function stateSelector(state) {
    return state.domain.catalogDetail;
};
var idSelector = function idSelector(state, id) {
    return id;
};

var byIdSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.byId;
});

var loadedSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.loaded;
});

var loadingSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.loading;
});

var getCatalogDetail = exports.getCatalogDetail = (0, _reselect.createSelector)([byIdSelector, idSelector], function (byId, id) {
    return byId[id] || {};
});

var getLoadTimeForCatalogDetail = exports.getLoadTimeForCatalogDetail = (0, _reselect.createSelector)([loadedSelector, idSelector], function (loaded, id) {
    return loaded[id] || 0;
});

var isCatalogDetailLoading = exports.isCatalogDetailLoading = (0, _reselect.createSelector)([loadingSelector, idSelector], function (loading, id) {
    return loading.includes(id);
});

var shouldFetchCatalogDetail = function shouldFetchCatalogDetail(state, catalogId) {
    if (!catalogId) return false;
    var item = getCatalogDetail(state, catalogId);
    if (item) {
        var loaded = getLoadTimeForCatalogDetail(state, catalogId);
        var time = Date.now();
        var diff = time - loaded;
        if (diff < REDUX_STORE_TIME) return false;
    }
    var loading = isCatalogDetailLoading(state, catalogId);
    return !loading;
};

var whichCatalogDetailsNeeded = function whichCatalogDetailsNeeded(state, catalogIds) {
    return catalogIds.filter(function (catalogId) {
        return shouldFetchCatalogDetail(state, catalogId);
    });
};

/* ACTION CREATORS */
var loadCatalogDetails = function loadCatalogDetails(catalogIds) {
    return function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch, getState) {
            var state, deployment, response;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.prev = 0;
                            state = getState();
                            deployment = (0, _config.getDeployment)(state);

                            dispatch({
                                payload: catalogIds,
                                type: LOAD_CATALOG_DETAILS_REQUEST
                            });
                            _context.next = 6;
                            return _api.CatalogDetail.fetchCatalogDetailsByIds({ catalogIds: catalogIds, deployment: deployment });

                        case 6:
                            response = _context.sent;

                            dispatch({
                                meta: { actionTime: Date.now(), catalogIds: catalogIds },
                                payload: response.data,
                                type: LOAD_CATALOG_DETAILS_SUCCESS
                            });
                            _context.next = 13;
                            break;

                        case 10:
                            _context.prev = 10;
                            _context.t0 = _context['catch'](0);

                            dispatch({
                                error: true,
                                meta: { catalogIds: catalogIds },
                                payload: _context.t0,
                                type: LOAD_CATALOG_DETAILS_FAIL
                            });

                        case 13:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, undefined, [[0, 10]]);
        }));

        return function (_x3, _x4) {
            return _ref.apply(this, arguments);
        };
    }();
};

var fetchCatalogDetailsIfNeeded = exports.fetchCatalogDetailsIfNeeded = function fetchCatalogDetailsIfNeeded(catalogIds) {
    return function (dispatch, getState) {
        var needed = whichCatalogDetailsNeeded(getState(), catalogIds);
        if (needed.length) {
            return dispatch(loadCatalogDetails(needed));
        }
        return _promise2.default.resolve();
    };
};

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "2+GA":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.BidRemote = undefined;

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _helpers = __webpack_require__("SY39");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var transform = function transform(body) {
    return {
        currentBid: body.current_bid,
        isCurrentHighBid: body.is_current_high_bid,
        isReserveMet: body.is_reserve_met,
        leadingBid: body.leading_bid,
        success: body.success
    };
};

var BidRemote = exports.BidRemote = {
    postPlaceAbsenteeBid: function postPlaceAbsenteeBid(_ref) {
        var authToken = _ref.authToken,
            deployment = _ref.deployment,
            details = _ref.details;

        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makePost)('<MAINHOST-API>api/abs_bid', deployment);
            (0, _helpers.addAuthToken)(request, authToken);
            request.type('form');
            request.send({
                accept_terms: true,
                bid: details.bidAmount,
                cat_id: details.catalogId,
                lot_id: details.itemId
            });
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response, transform: transform });
            });
        });
    },
    postRetractBid: function postRetractBid(_ref2) {
        var authToken = _ref2.authToken,
            bidderId = _ref2.bidderId,
            deployment = _ref2.deployment,
            itemId = _ref2.itemId,
            retractionExplanation = _ref2.retractionExplanation,
            retractionReason = _ref2.retractionReason;

        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makePost)('<MAINHOST-API>api/bidders/' + bidderId + '/biditems/' + itemId + '/retract', deployment);
            (0, _helpers.addAuthToken)(request, authToken);
            request.send({
                retractionExplanation: retractionExplanation,
                retractionReason: retractionReason
            });
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response });
            });
        });
    }
};

/***/ }),

/***/ "2Eh+":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _jsx2 = __webpack_require__("dcb+");

var _jsx3 = _interopRequireDefault(_jsx2);

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

var _slicedToArray2 = __webpack_require__("d7EF");

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

__webpack_require__("j1ja");

__webpack_require__("V/K8");

var _reactRouter = __webpack_require__("CIox");

var _create = __webpack_require__("0lB/");

var _create2 = _interopRequireDefault(_create);

var _caterwaulComponents = __webpack_require__("7T5E");

var _initialData = __webpack_require__("t5WM");

var _initialData2 = _interopRequireDefault(_initialData);

var _routes = __webpack_require__("eqvY");

var _routes2 = _interopRequireDefault(_routes);

var _isOnline = __webpack_require__("8AIN");

var _isOnline2 = _interopRequireDefault(_isOnline);

var _reduxPersist = __webpack_require__("AyKp");

var _reactIntlRedux = __webpack_require__("Q58t");

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__("O27J");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reduxAsyncConnect = __webpack_require__("5t3y");

var _reactRouterRedux = __webpack_require__("jZgO");

var _reactRouterScroll = __webpack_require__("Pt99");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

__webpack_require__("iYVZ"); /* eslint-disable sort-imports */
/* eslint-disable import/newline-after-import */

__webpack_require__("Lsne");
__webpack_require__("c0QG");
__webpack_require__("mabt");
__webpack_require__("Dlsl");
__webpack_require__("Yyf6");
__webpack_require__("ZsVc");
__webpack_require__("EeU7");


// /* Soasta Boomerang config */
var hadRouteChange = false;

function hookHistoryBoomerang() {
    if (window.BOOMR && BOOMR.version) {
        if (BOOMR.plugins && BOOMR.plugins.History) {
            BOOMR.plugins.History.hook(_reactRouter.browserHistory, hadRouteChange);
        }
        return true;
    }
}

if (!hookHistoryBoomerang()) {
    if (document.addEventListener) {
        document.addEventListener('onBoomerangLoaded', hookHistoryBoomerang);
    } else if (document.attachEvent) {
        document.attachEvent('onpropertychange', function (e) {
            e = e || window.event;
            if (e && e.propertyName === 'onBoomerangLoaded') {
                hookHistoryBoomerang();
            }
        });
    }
}

function onEnter() {
    hadRouteChange = true;
}
/* end Soasta config code 2 */

function renderTheApp() {
    var dest = document.getElementById('content');
    var localStoragePersistConfig = {
        debounce: 33,
        keyPrefix: 'la:',
        whitelist: ['persist']
    };

    /* eslint-disable no-unused-vars */
    _promise2.default.all([window.__data ? true : (0, _isOnline2.default)()]).then(function (_ref) {
        var _ref2 = (0, _slicedToArray3.default)(_ref, 1),
            online = _ref2[0];

        var data = window.__data ? (0, _extends3.default)({}, window.__data) : (0, _initialData2.default)();
        var store = (0, _create2.default)(_reactRouter.browserHistory, data);

        // save to local storage
        (0, _reduxPersist.persistStore)(store, localStoragePersistConfig);
        var history = (0, _reactRouterRedux.syncHistoryWithStore)(_reactRouter.browserHistory, store, { adjustUrlOnReplay: false });
        var routes = (0, _routes2.default)(store.getState().whiteLabel.isWhiteLabel);

        (0, _reactRouter.match)({ history: history, routes: routes }, function (error, redirectLocation, renderProps) {
            _reactDom2.default.hydrate((0, _jsx3.default)(_caterwaulComponents.ErrorBoundary, {}, void 0, (0, _jsx3.default)(_reactIntlRedux.Provider, {
                store: store
            }, 'provider', _react2.default.createElement(_reactRouter.Router, (0, _extends3.default)({}, renderProps, {
                history: history,
                onEnter: onEnter,
                render: function render(props) {
                    return _react2.default.createElement(_reduxAsyncConnect.ReduxAsyncConnect, (0, _extends3.default)({}, props, {
                        filter: function filter(item) {
                            return !item.deferred;
                        },
                        render: (0, _reactRouter.applyRouterMiddleware)((0, _reactRouterScroll.useScroll)())
                    }));
                }
            })))), dest);
        });

        if (false) {
            window.React = _react2.default; // enable debugger
        }
    });
}

if (!global.Intl) {
    __webpack_require__.e/* require.ensure */(33).then((function (require) {
        __webpack_require__("3a5k");
        __webpack_require__("OYzX");
        renderTheApp();
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
} else {
    renderTheApp();
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("DuR2")))

/***/ }),

/***/ "2JX2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.submitPayment = exports.getUiSubmitPayment = exports.SUBMIT_PAYMENT_SUCCESS = exports.SUBMIT_PAYMENT_REQUEST = exports.SUBMIT_PAYMENT_FAIL = undefined;

var _regenerator = __webpack_require__("Xxa5");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__("exGp");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;

var _user = __webpack_require__("CFLi");

var _api = __webpack_require__("zFQO");

var _reselect = __webpack_require__("bndy");

var _modal = __webpack_require__("u90i");

var _config = __webpack_require__("iS9E");

var _getStripeErrorMessageFromResponse = __webpack_require__("VFQi");

var _getStripeErrorMessageFromResponse2 = _interopRequireDefault(_getStripeErrorMessageFromResponse);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Action Types */
var SUBMIT_PAYMENT_FAIL = exports.SUBMIT_PAYMENT_FAIL = 'la/ui/payment/FAIL';
var SUBMIT_PAYMENT_REQUEST = exports.SUBMIT_PAYMENT_REQUEST = 'la/ui/payment/REQUEST';
var SUBMIT_PAYMENT_SUCCESS = exports.SUBMIT_PAYMENT_SUCCESS = 'la/ui/payment/SUCCESS';

// reducer
var DEFAULT_STATE = {
    error: false,
    errorMessage: null,
    submitted: false,
    success: false
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        case SUBMIT_PAYMENT_REQUEST:
            return (0, _extends3.default)({}, state, {
                error: false,
                errorMessage: null,
                submitted: true,
                success: false
            });
        case SUBMIT_PAYMENT_SUCCESS:
            return (0, _extends3.default)({}, state, {
                submitted: false,
                success: true
            });
        case SUBMIT_PAYMENT_FAIL:
            return (0, _extends3.default)({}, state, {
                error: true,
                errorMessage: (0, _getStripeErrorMessageFromResponse2.default)(action.payload),
                submitted: false,
                success: false
            });
        case _modal.DISMISS_MODAL:
            return DEFAULT_STATE;
        default:
            return state;
    }
}

/* SELECTORS */
var stateSelector = function stateSelector(state) {
    return state.ui.payment;
};

var getUiSubmitPayment = exports.getUiSubmitPayment = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state;
});

/* ACTION CREATORS */
var submitPayment = exports.submitPayment = function submitPayment(_ref) {
    var address = _ref.address,
        amount = _ref.amount,
        cardToken = _ref.cardToken,
        catalogId = _ref.catalogId,
        currency = _ref.currency;
    return function () {
        var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch, getState) {
            var state, authToken, bidderId, deployment, response;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.prev = 0;
                            state = getState();
                            authToken = (0, _user.getAuthToken)(state);
                            bidderId = (0, _user.getBidderId)(state);
                            deployment = (0, _config.getDeployment)(state);

                            dispatch({
                                payload: bidderId,
                                type: SUBMIT_PAYMENT_REQUEST
                            });
                            _context.next = 8;
                            return _api.Auth.postPayment({
                                address: address,
                                amount: amount,
                                authToken: authToken,
                                bidderId: bidderId,
                                cardToken: cardToken,
                                catalogId: catalogId,
                                currency: currency,
                                deployment: deployment
                            });

                        case 8:
                            response = _context.sent;


                            dispatch({
                                meta: { actionTime: Date.now() },
                                payload: response.data,
                                type: SUBMIT_PAYMENT_SUCCESS
                            });
                            _context.next = 16;
                            break;

                        case 12:
                            _context.prev = 12;
                            _context.t0 = _context['catch'](0);

                            dispatch({
                                error: true,
                                payload: _context.t0,
                                type: SUBMIT_PAYMENT_FAIL
                            });
                            throw _context.t0;

                        case 16:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, undefined, [[0, 12]]);
        }));

        return function (_x3, _x4) {
            return _ref2.apply(this, arguments);
        };
    }();
};

/***/ }),

/***/ "2eK9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CatalogSearchRemote = undefined;

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _helpers = __webpack_require__("SY39");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CatalogSearchRemote = exports.CatalogSearchRemote = {
    fetchCatalogsTodayCount: function fetchCatalogsTodayCount(deployment) {
        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makeGet)('<ITEM-API>spa/small/catalogtodaycount', deployment);
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response });
            });
        });
    },
    fetchSearchResults: function fetchSearchResults(_ref) {
        var deployment = _ref.deployment,
            searchParams = _ref.searchParams;

        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makeGet)('<MAINHOST-API>api/catalogs/search', deployment);
            request.query(searchParams);
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response });
            });
        });
    }
};

/***/ }),

/***/ "2xKK":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = __webpack_require__("dcb+");

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propsComparer = __webpack_require__("wsGv");

var _propsComparer2 = _interopRequireDefault(_propsComparer);

var _reactIntl = __webpack_require__("Pq8k");

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _SearchStatus = __webpack_require__("WH74");

var _SearchStatus2 = _interopRequireDefault(_SearchStatus);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SearchStatus = (_temp = _class = function (_Component) {
    (0, _inherits3.default)(SearchStatus, _Component);

    function SearchStatus() {
        (0, _classCallCheck3.default)(this, SearchStatus);
        return (0, _possibleConstructorReturn3.default)(this, (SearchStatus.__proto__ || (0, _getPrototypeOf2.default)(SearchStatus)).apply(this, arguments));
    }

    (0, _createClass3.default)(SearchStatus, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps) {
            return (0, _propsComparer2.default)(this.props, nextProps, ['itemCount', 'search']);
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                clear = _props.clear,
                _props$itemCount = _props.itemCount,
                itemCount = _props$itemCount === undefined ? 0 : _props$itemCount,
                _props$search = _props.search,
                search = _props$search === undefined ? '' : _props$search;


            if (!search) return null;

            return (0, _jsx3.default)('div', {
                className: _SearchStatus2.default['search-status']
            }, void 0, (0, _jsx3.default)('div', {
                className: _SearchStatus2.default.match
            }, void 0, (0, _jsx3.default)('span', {
                className: _SearchStatus2.default['results-for']
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'results_for',
                values: { count: '' + itemCount }
            }), (0, _jsx3.default)('span', {
                className: _SearchStatus2.default.search
            }, void 0, ' ', search), (0, _jsx3.default)('span', {
                className: _SearchStatus2.default.clear,
                onClick: clear
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'clear'
            })))), !itemCount && (0, _jsx3.default)('div', {
                className: _SearchStatus2.default['no-match']
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'try_another_search'
            })));
        }
    }]);
    return SearchStatus;
}(_react.Component), _class.defaultProps = {
    itemCount: 0,
    search: ''
}, _temp);
exports.default = SearchStatus;
module.exports = exports['default'];

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "39qi":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fetchUpcomingCatalogsIfNeeded = exports.getLiveCatalogsIds = exports.getUpcomingCatalogIds = exports.LOAD_UPCOMING_CATALOGS_SUCCESS = exports.LOAD_UPCOMING_CATALOGS_REQUEST = exports.LOAD_UPCOMING_CATALOGS_FAIL = undefined;

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _regenerator = __webpack_require__("Xxa5");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__("exGp");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;

var _api = __webpack_require__("zFQO");

var _reselect = __webpack_require__("bndy");

var _user = __webpack_require__("CFLi");

var _catalog = __webpack_require__("yv/Z");

var _config = __webpack_require__("iS9E");

var _ms = __webpack_require__("EarI");

var _ms2 = _interopRequireDefault(_ms);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOAD_UPCOMING_CATALOGS_FAIL = exports.LOAD_UPCOMING_CATALOGS_FAIL = 'la/domain/upcomingCatalogs/LOAD_FAIL';
var LOAD_UPCOMING_CATALOGS_REQUEST = exports.LOAD_UPCOMING_CATALOGS_REQUEST = 'la/domain/upcomingCatalogs/LOAD_REQUEST';
var LOAD_UPCOMING_CATALOGS_SUCCESS = exports.LOAD_UPCOMING_CATALOGS_SUCCESS = 'la/domain/upcomingCatalogs/LOAD_SUCCESS';

var REDUX_STORE_TIME = (0, _ms2.default)('30m');

var DEFAULT_STATE = {
    ids: [],
    loaded: 0,
    loading: false
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        case LOAD_UPCOMING_CATALOGS_FAIL:
            return (0, _extends3.default)({}, state, {
                loading: false
            });
        case LOAD_UPCOMING_CATALOGS_REQUEST:
            return (0, _extends3.default)({}, state, {
                loading: true
            });
        case LOAD_UPCOMING_CATALOGS_SUCCESS:
            return (0, _extends3.default)({}, state, {
                ids: action.payload.catalogs.map(function (catalog) {
                    return catalog.catalogId;
                }).sort(),
                loaded: action.meta.actionTime,
                loading: false
            });
        default:
            return state;
    }
}

/* SELECTORS */
var stateSelector = function stateSelector(state) {
    return state.domain.upcomingCatalogs;
};

var loadedSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.loaded;
});

var loadingSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.loading;
});

var getUpcomingCatalogIds = exports.getUpcomingCatalogIds = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.ids;
});

var getLiveCatalogsIds = exports.getLiveCatalogsIds = function getLiveCatalogsIds(state) {
    var allUpcomingCatalogIds = getUpcomingCatalogIds(state);
    return allUpcomingCatalogIds.filter(function (id) {
        var catalog = (0, _catalog.getCatalog)(state, id);
        return catalog.catalogStatus === 'live';
    });
};

var shouldFetchUpcomingCatalogs = function shouldFetchUpcomingCatalogs(state) {
    var items = getUpcomingCatalogIds(state);
    if (items.length) {
        var loaded = loadedSelector(state);
        var time = Date.now();
        var diff = time - loaded;
        if (diff < REDUX_STORE_TIME) return false;
    }
    var loading = loadingSelector(state);
    return !loading;
};

/* ACTION CREATORS */
var loadUpcomingCatalogs = function loadUpcomingCatalogs(sellerId) {
    return function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch, getState) {
            var state, authToken, deployment, response;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.prev = 0;
                            state = getState();
                            authToken = (0, _user.getAuthToken)(state);
                            deployment = (0, _config.getDeployment)(state);

                            dispatch({
                                type: LOAD_UPCOMING_CATALOGS_REQUEST
                            });
                            _context.next = 7;
                            return _api.Catalog.fetchUpcomingCatalogs({
                                authToken: authToken,
                                deployment: deployment
                            });

                        case 7:
                            response = _context.sent;

                            dispatch({
                                meta: { actionTime: Date.now() },
                                payload: response.data,
                                type: LOAD_UPCOMING_CATALOGS_SUCCESS
                            });
                            _context.next = 14;
                            break;

                        case 11:
                            _context.prev = 11;
                            _context.t0 = _context['catch'](0);

                            dispatch({
                                error: true,
                                payload: _context.t0,
                                type: LOAD_UPCOMING_CATALOGS_FAIL
                            });

                        case 14:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, undefined, [[0, 11]]);
        }));

        return function (_x3, _x4) {
            return _ref.apply(this, arguments);
        };
    }();
};

var fetchUpcomingCatalogsIfNeeded = exports.fetchUpcomingCatalogsIfNeeded = function fetchUpcomingCatalogsIfNeeded(sellerId) {
    return function (dispatch, getState) {
        if (shouldFetchUpcomingCatalogs(getState(), sellerId)) {
            return dispatch(loadUpcomingCatalogs(sellerId));
        }
        return _promise2.default.resolve();
    };
};

/***/ }),

/***/ "3aW2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ItemFacetsRemote = undefined;

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _helpers = __webpack_require__("SY39");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ItemFacetsRemote = exports.ItemFacetsRemote = {
    fetchItemFacets: function fetchItemFacets(_ref) {
        var authToken = _ref.authToken,
            deployment = _ref.deployment,
            ids = _ref.ids;
        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makePost)('<ITEM-API>spa/small/item-facets', deployment);
            (0, _helpers.addAuthToken)(request, authToken);
            request.send({ ids: ids });
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response });
            });
        });
    }
};

/***/ }),

/***/ "3q2/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var art = exports.art = [{
    columnCategories: [{
        headerLink: '/c/art/1/',
        headerText: 'Art',
        links: [{
            route: '/c/drawings/8/',
            text: 'Drawings'
        }, {
            route: '/c/mixed-media-collages/9/',
            text: 'Mixed Media & Collages'
        }, {
            route: '/c/paintings/10/',
            text: 'Paintings'
        }, {
            route: '/c/photography/11/',
            text: 'Photography'
        }, {
            route: '/c/prints-multiples/12/',
            text: 'Prints & Multiples'
        }, {
            route: '/c/scrolls-screens-fan-paintings/13/',
            text: 'Scrolls, Screens & Fan Paintings'
        }, {
            route: '/c/sculptures/14/',
            text: 'Sculptures'
        }, {
            route: '/c/statues-statuettes/26420/',
            text: 'Statues & Statuettes'
        }]
    }]
}, {
    columnCategories: [{
        headerText: 'Artists',
        links: [{
            route: '/c/art/pablo-picasso/1/18755/',
            text: 'Pablo Picasso'
        }, {
            route: '/c/art/banksy/1/2655',
            text: 'Banksy'
        }, {
            route: '/c/art/andy-warhol/1/1705/',
            text: 'Andy Warhol'
        }, {
            route: '/c/art/jean-michel-basquiat/1/11965/',
            text: 'Jean-Michel Basquiat'
        }, {
            route: '/c/art/roy-lichtenstein/1/21418/',
            text: 'Roy Lichtenstein'
        }, {
            route: '/c/art/keith-haring/1/14133/',
            text: 'Keith Haring'
        }, {
            route: '/c/art/francis-bacon/1/7794/',
            text: 'Francis Bacon'
        }, {
            route: '/c/art/frank-stella/1/7962/',
            text: 'Frank Stella'
        }]
    }]
}, {
    columnCategories: [{
        headerText: 'Popular Searches',
        links: [{
            route: '/c/paintings/oil/10/25830/',
            text: 'Oil Paintings'
        }, {
            route: '/c/statues-statuettes/bronze/26420/25739/',
            text: 'Bronze Statues'
        }, {
            route: '/search?parameters=%7B"pageSize"%3A24%2C"page"%3A1%2C"sort"%3A"-relevance"%2C"keyword"%3A"folk"%2C"status"%3A"online"%2C"category_id"%3A"1"%7D',
            text: 'Folk Art'
        }, {
            route: '/search?parameters=%7B"pageSize"%3A24%2C"page"%3A1%2C"sort"%3A"-relevance"%2C"keyword"%3A"portrait"%2C"status"%3A"online"%2C"category_id"%3A"1"%7D',
            text: 'Portraits'
        }, {
            route: '/c/paintings/watercolor/10/25898/',
            text: 'Watercolor Paintings'
        }]
    }]
}];
var jewelry = exports.jewelry = [{
    columnCategories: [{
        headerText: 'Jewelry',
        links: [{
            route: '/c/bracelets/89/',
            text: 'Bracelets'
        }, {
            route: '/c/brooches-pins/90/',
            text: 'Brooches & Pins'
        }, {
            route: '/c/cufflinks-tie-pins-tie-clips/91/',
            text: 'Cufflinks, Tie Pins & Tie Clips'
        }, {
            route: '/c/costume-jewelry/26441/',
            text: 'Costume Jewelry'
        }, {
            route: '/c/earrings/92/',
            text: 'Earrings'
        }, {
            route: '/c/loose-stones-beads/94/',
            text: 'Loose Stones & Beads'
        }, {
            route: '/c/necklaces-pendants/95/',
            text: 'Necklaces & Pendants'
        }, {
            route: '/c/rings/96/',
            text: 'Rings'
        }, {
            route: '/c/watches/97/',
            text: 'Watches'
        }]
    }]
}, {
    columnCategories: [{
        headerText: 'Featured',
        links: [{
            route: '/c/jewelry/cartier/6/3899/',
            text: 'Cartier'
        }, {
            route: '/c/jewelry/chanel/6/4017/',
            text: 'Chanel'
        }, {
            route: '/c/jewelry/rolex/6/21252/',
            text: 'Rolex'
        }, {
            route: '/c/jewelry/bulova/6/3513/',
            text: 'Bulova'
        }, {
            route: '/c/jewelry/chopard/6/4393/',
            text: 'Chopard'
        }, {
            route: '/c/jewelry/swarovski/6/23012/',
            text: 'Swarovski'
        }, {
            route: '/c/jewelry/bulgari/6/3512/',
            text: 'Bulgari'
        }, {
            route: '/c/jewelry/patek-philippe/6/18874/',
            text: 'Patek Philippe'
        }]
    }]
}];
var asian = exports.asian = [{
    columnCategories: [{
        headerLink: '/c/asian/158/',
        headerText: 'Asian Antiques',
        links: [{
            route: '/c/art/asian/1/158/',
            text: 'Art'
        }, {
            route: '/c/collectibles/asian/2/158/',
            text: 'Collectibles'
        }, {
            route: '/c/fashion/asian/3/158/',
            text: 'Fashion'
        }, {
            route: '/c/furniture/asian/4/158/',
            text: 'Furniture'
        }, {
            route: '/c/jewelry/asian/6/158/',
            text: 'Jewelry'
        }, {
            route: '/c/serveware-flatware-services/asian/86/158/',
            text: 'Serveware, Flatware & Services'
        }, {
            route: '/c/vases-garnitures/asian/87/158/',
            text: 'Vases & Garnitures'
        }]
    }]
}, {
    columnCategories: [{
        headerText: 'Browse By Origin',
        links: [{
            route: '/c/chinese/162/',
            text: 'Chinese Antiques'
        }, {
            route: '/c/indian/176/',
            text: 'Indian Antiques'
        }, {
            route: '/c/japanese/163/',
            text: 'Japanese Antiques'
        }, {
            route: '/c/korean/164/',
            text: 'Korean Antiques'
        }, {
            route: '/c/persian/185/',
            text: 'Persian Antiques'
        }, {
            route: '/c/southeast-asian/169/',
            text: 'Southeast Asian Antiques'
        }, {
            route: '/c/tibetan/168/',
            text: 'Tibetan Antiques'
        }]
    }]
}, {
    columnCategories: [{
        headerText: 'Featured',
        links: [{
            route: '/c/asian/bronze/158/25739/',
            text: 'Bronze'
        }, {
            route: '/c/asian/cloisonne/158/25757/',
            text: 'Cloisonne'
        }, {
            route: '/c/han-dynasty/245/',
            text: 'Han Dynasty'
        }, {
            route: '/c/jewelry/jade/6/25797/',
            text: 'Jade Jewelry'
        }, {
            route: '/c/asian/porcelain/158/25849/',
            text: 'Porcelain'
        }, {
            route: '/c/ming-dynasty/246/',
            text: 'Ming Dynasty'
        }, {
            route: '/c/qing-dynasty/251/',
            text: 'Qing Dynasty'
        }, {
            route: '/c/prints/woodblock/12/25903/',
            text: 'Woodblock Prints'
        }]
    }]
}];
var furniture = exports.furniture = [{
    columnCategories: [{
        headerLink: '/c/furniture/4/',
        headerText: 'Furniture',
        links: [{
            route: '/c/bedframes-headboards/56/',
            text: 'Bedframes & Headboards'
        }, {
            route: '/c/cabinets-case-pieces/59/',
            text: 'Cabinets & Case Pieces'
        }, {
            route: '/c/seating/26443/',
            text: 'Seating'
        }, {
            route: '/c/tables/69/',
            text: 'Tables'
        }]
    }, {
        headerLink: '/c/cabinets-case-pieces/59/',
        headerText: 'Cabinets & Case Pieces',
        links: [{
            route: '/c/armoires-wardrobes/55/',
            text: 'Armoires & Wardrobes'
        }, {
            route: '/c/bookcases-etageres-display-cases/58/',
            text: 'Bookcases, Etageres & Display Cases'
        }, {
            route: '/c/chests-of-drawers-commodes/65/',
            text: 'Chests of Drawers & Commodes'
        }, {
            route: '/c/sideboards-buffets/67/',
            text: 'Sideboards & Buffets'
        }]
    }]
}, {
    columnCategories: [{
        headerLink: '/c/seating/26443/',
        headerText: 'Seating',
        links: [{
            route: '/c/benches-stools/57/',
            text: 'Benches & Stools'
        }, {
            route: '/c/chairs/61/',
            text: 'Chairs'
        }, {
            route: '/c/sofas-chaises/68/',
            text: 'Sofas & Canapes'
        }]
    }, {
        headerLink: '/c/tables/69/',
        headerText: 'Tables',
        links: [{
            route: '/c/coffee-tables-cocktail-tables/26614/',
            text: 'Coffee & Cocktail Tables'
        }, {
            route: '/c/desks-writing-tables/63/',
            text: 'Desks & Writing Tables'
        }, {
            route: '/c/dining-tables/64/',
            text: 'Dining Tables'
        }]
    }]
}, {
    columnCategories: [{
        headerText: 'Browse By Style',
        links: [{
            route: '/c/furniture/art-deco/4/253/',
            text: 'Art Deco'
        }, {
            route: '/c/chippendale/277/',
            text: 'Chippendale'
        }, {
            route: '/search?parameters=%7B"pageSize"%3A24%2C"page"%3A1%2C"sort"%3A"-relevance"%2C"keyword"%3A"federal%20style"%2C"status"%3A"online"%2C"category_id"%3A"4"%7D',
            text: 'Federal Style'
        }, {
            route: '/search?parameters=%7B"pageSize"%3A24%2C"page"%3A1%2C"sort"%3A"-relevance"%2C"keyword"%3A"hollywood%20regency"%2C"status"%3A"online"%2C"category_id"%3A"4"%7D',
            text: 'Hollywood Regency'
        }, {
            route: '/c/furniture/mid-century-modern/4/265/',
            text: 'Mid-Century Modern'
        }, {
            route: '/search?parameters=%7B"pageSize"%3A24%2C"page"%3A1%2C"sort"%3A"-relevance"%2C"keyword"%3A"mission%20style"%2C"status"%3A"online"%2C"category_id"%3A"4"%7D',
            text: 'Mission Style'
        }, {
            route: '/c/furniture/rococo/4/260/',
            text: 'Rococo'
        }, {
            route: '/search?parameters=%7B"pageSize"%3A24%2C"page"%3A1%2C"sort"%3A"-relevance"%2C"keyword"%3A"queen%20anne"%2C"status"%3A"online"%2C"category_id"%3A"4"%7D',
            text: 'Queen Anne'
        }, {
            route: '/c/furniture/victorian/4/275/',
            text: 'Victorian'
        }]
    }]
}, {
    columnCategories: [{
        headerText: 'Featured',
        links: [{
            route: '/search?parameters=%7B"pageSize"%3A24%2C"page"%3A1%2C"sort"%3A"-relevance"%2C"keyword"%3A"Eames"%2C"status"%3A"online"%2C"category_id"%3A"4"%7D',
            text: 'Eames Chairs'
        }, {
            route: '/c/furniture/herman-miller/4/10385/',
            text: 'Herman Miller'
        }, {
            route: '/search?parameters=%7B"pageSize"%3A24%2C"page"%3A1%2C"sort"%3A"-relevance"%2C"keyword"%3A"hans%20wegner"%2C"status"%3A"online"%2C"category_id"%3A"4"%7D',
            text: 'Hans Wegner'
        }, {
            route: '/c/furniture/paul-evans/4/19010/',
            text: 'Paul Evans'
        }, {
            route: '/c/furniture/george-nelson/4/8661/',
            text: 'George Nelson'
        }, {
            route: '/c/furniture/stickley/4/9563/',
            text: 'Stickley'
        }, {
            route: '/c/furniture/milo-baughman/4/17579/',
            text: 'Milo Baughman'
        }]
    }]
}];
var collectibles = exports.collectibles = [{
    columnCategories: [{
        headerText: 'Collectibles',
        links: [{
            route: '/c/advertisements-signs/38/',
            text: 'Advertisements & Signs'
        }, {
            route: '/c/automobilia-petroliana/7/',
            text: 'Automobilia & Petroliana'
        }, {
            route: '/c/banks-registers-adding-machines/18/',
            text: 'Banks, Registers & Adding Machines'
        }, {
            route: '/c/books-magazines-papers/20/',
            text: 'Books, Magazines & Papers'
        }, {
            route: '/c/breweriana-beer-signs/26426/',
            text: 'Breweriana & Beer Signs'
        }, {
            route: '/c/cameras-photographica/21/',
            text: 'Cameras & Photographica'
        }, {
            route: '/c/coins-currency-stamps/24/',
            text: 'Coins, Currency & Stamps'
        }]
    }]
}, {
    columnCategories: [{
        headerText: ' ',
        links: [{
            route: '/c/figurines-miniatures/28/',
            text: 'Figurines & Miniatures'
        }, {
            route: '/c/home-hardware-tools-locks/45/',
            text: 'Home Hardware, Tools & Locks'
        }, {
            route: '/c/hunting-fishing/26905/',
            text: 'Hunting & Fishing'
        }, {
            route: '/c/maps-globes-atlases/33/',
            text: 'Maps, Globes & Atlases'
        }, {
            route: '/c/musical-instruments-music-stands/37/',
            text: 'Musical Instruments & Music Stands'
        }, {
            route: '/c/pens-writing-instruments/32/',
            text: 'Pens & Writing Instruments'
        }, {
            route: '/c/railroadiana/26431/',
            text: 'Railroadiana'
        }]
    }]
}, {
    columnCategories: [{
        headerText: ' ',
        links: [{
            route: '/c/radios-audio-equipment/26430/',
            text: 'Radios & Audio Equipment'
        }, {
            route: '/c/religious-spiritual-objects/39/',
            text: 'Religious & Spiritual Objects'
        }, {
            route: '/c/rocks-shells-minerals/40/',
            text: 'Rocks, Shells & Minerals'
        }, {
            route: '/c/scientific-medical-objects/26432/',
            text: 'Scientific & Medical Objects'
        }, {
            route: '/c/tobacciana/44/',
            text: 'Tobacciana'
        }, {
            route: '/c/toys-trains-games/46/',
            text: 'Toys, Dolls & Games'
        }, {
            route: '/c/vanity-items/52/',
            text: 'Vanity Items'
        }, {
            route: '/c/wine-spirits/88/',
            text: 'Wine & Spirits'
        }, {
            route: '/c/weapons-armor/35/',
            text: 'Weapons & Armor'
        }]
    }]
}];
var memorabilia = exports.memorabilia = [{
    columnCategories: [{
        headerText: 'Memorabilia',
        links: [{
            route: '/c/carnival-circus-collectibles/23/',
            text: 'Carnival & Circus Collectibles'
        }, {
            route: '/c/militaria-war-memorabilia/26903/',
            text: 'Militaria & War Memorabilia'
        }, {
            route: '/c/movie-tv-memorabilia/36/',
            text: 'Movie & TV Memorabilia'
        }, {
            route: '/c/political-memorabilia/31/',
            text: 'Political Memorabilia'
        }, {
            route: '/c/scrapbooks-photo-albums/26901/',
            text: 'Scrapbooks & Photo Albums'
        }, {
            route: '/c/sports-memorabilia/42/',
            text: 'Sports Memorabilia'
        }, {
            route: '/c/travel-memorabilia-souvenirs/49/',
            text: 'Travel Memorabilia & Souvenirs'
        }, {
            route: '/c/theater-memorabilia/26899/',
            text: 'Theater Memorabilia'
        }]
    }]
}, {
    columnCategories: [{
        headerText: '',
        links: []
    }]
}, {
    columnCategories: [{
        headerText: 'Featured',
        links: [{
            route: '/search?parameters=%7B"page":1,"sort":"-relevance","keyword":"%5C"baseball%20Memorabilia%5C"%20OR%20%5C"baseball%20bats%5C"%20OR%20%5C"baseball%20bobbleheads%5C"%20OR%20%5C"baseball%20cards%5C"%20OR%20%5C"baseball%20gloves%5C"%20OR%20%5C"baseball%20pennants%5C"%20OR%20%5C"baseball%20photos%5C"%20OR%20%5C"baseball%20programs%5C"%20OR%20%5C"game%20used%20items%5C"%20OR%20%5C"rookie%20cards%5C"%20OR%20%5C"signed%20baseballs%5C"%20OR%20%5C"tobacco%20cards%5C"%20OR%20%5C"Topps%20cards%5C"%20OR%20%5C"World%20Series%5C"%20OR%20%5C"babe%20ruth%5C"%20OR%20%5C"hank%20aaron%5C"%20OR%20%5C"joe%20dimaggio%5C"%20OR%20%5C"lou%20gehrig%5C"%20OR%20%5C"jackie%20robinson%5C"%20OR%20%5C"ty%20cobb%5C"%20OR%20%5C"mickey%20mantle%5C"%20OR%20%5C"red%20sox%5C"%20OR%20%5C"chicago%20cubs%5C"%20OR%20%5C"texas%20rangers%5C"%20OR%20%5C"sf%20giants%5C"%20OR%20%5C"houston%20astros%5C"%20OR%20%5C"brooklyn%20dodgers%5C"%20OR%20%5C"new%20york%20yankees%5C"%20OR%20%5C"new%20york%20mets%5C"","status":"online"%7D',
            text: 'Baseball Memorabilia'
        }, {
            route: '/search?parameters=%7B"page":1,"sort":"-relevance","keyword":"%5C"elvis%20presley%5C"","status":"online"%7D',
            text: 'Elvis Presley Memorabilia'
        }, {
            route: '/search?parameters=%7B"page":1,"sort":"-relevance","keyword":"autograph","status":"online"%7D',
            text: 'Autographs'
        }, {
            route: '/search?parameters=%7B"page":1,"sort":"-relevance","keyword":"%5C"civil%20war%5C"","status":"online"%7D',
            text: 'Civil War Memorabilia'
        }, {
            route: '/search?parameters=%7B"page":1,"sort":"-relevance","keyword":"wwi%20OR%20ww1%20OR%20%5C"world%20war%201%5C"","status":"online"%7D',
            text: 'World War I Memorabilia'
        }, {
            route: '/search?parameters=%7B"page":1,"sort":"-relevance","keyword":"wwii%20OR%20ww2%20OR%20%5C"world%20war%202%5C"","status":"online"%7D',
            text: 'World War II Memorabilia'
        }]
    }]
}];
var home = exports.home = [{
    columnCategories: [{
        headerLink: '/c/home-garden/5/',
        headerText: 'Home & Garden',
        links: [{
            route: '/c/baskets-containers/72/',
            text: 'Baskets & Containers'
        }, {
            route: '/c/candle-holders/60/',
            text: 'Candle Holders'
        }, {
            route: '/c/clocks/74/',
            text: 'Clocks'
        }, {
            route: '/c/fireplaces-mantels/77/',
            text: 'Fireplaces & Mantels'
        }, {
            route: '/c/fireplace-accessories/76/',
            text: 'Fireplace Accessories'
        }, {
            route: '/c/garden-furniture/66/',
            text: 'Garden Furniture'
        }]
    }]
}, {
    columnCategories: [{
        headerText: ' ',
        links: [{
            route: '/c/garden-ornaments/79/',
            text: 'Garden Ornaments'
        }, {
            route: '/c/frames-shelves-wall-decor/78/',
            text: 'Frames, Shelves & Wall Decor'
        }, {
            route: '/c/kitchenware/26446/',
            text: 'Kitchenware'
        }, {
            route: '/c/lighting/81/',
            text: 'Lighting'
        }, {
            route: '/c/magazine-racks/82/',
            text: 'Magazine Racks'
        }, {
            route: '/c/mirrors/83/',
            text: 'Mirrors'
        }]
    }]
}, {
    columnCategories: [{
        headerText: ' ',
        links: [{
            route: '/c/planters/84/',
            text: 'Planters'
        }, {
            route: '/c/rugs-carpets/85/',
            text: 'Rugs & Carpets'
        }, {
            route: '/c/serveware-flatware-barware/86/',
            text: 'Serveware, Flatware & Barware'
        }, {
            route: '/c/textiles/75/',
            text: 'Textiles'
        }, {
            route: '/c/umbrella-stands-coat-stands/26878/',
            text: 'Umbrella Stands & Coat Stands'
        }, {
            route: '/c/vases-garnitures/87/',
            text: 'Vases & Garnitures'
        }]
    }]
}, {
    columnCategories: [{
        headerText: 'Featured',
        links: [{
            route: '/search?parameters=%7B"page":1,"sort":"-relevance","keyword":"tiffany%20OR%20swarovski%20OR%20steuben%20OR%20moser%20OR%20loetz%20OR%20lalique%20OR%20imperial%20OR%20fenton%20OR%20daum%20OR%20blenko%20OR%20baccarat%20OR%20murano%20OR%20%5C"stained%20glass%5C"%20OR%20%5C"art%20glass%5C"","status":"online"%7D',
            text: 'Art Glass'
        }, {
            route: '/c/baccarat/2618/',
            text: 'Baccarat'
        }, {
            route: '/c/kpm/26128/',
            text: 'KPM'
        }, {
            route: '/c/murano/25937/',
            text: 'Murano'
        }, {
            route: '/search?parameters=%7B"page":1,"sort":"-relevance","keyword":"%5C"limoges%5C"","status":"online"%7D',
            text: 'Limoges'
        }, {
            route: '/c/rookwood-pottery/21341/',
            text: 'Rookwood'
        }, {
            route: '/c/sevres-porcelain/23056/',
            text: 'Sèvres'
        }, {
            route: '/c/lalique/14553/',
            text: 'Lalique'
        }, {
            route: '/c/tiffany-studios/23547/',
            text: 'Tiffany Studios'
        }, {
            route: '/c/meissen/26157/',
            text: 'Meissen'
        }]
    }]
}];
var fashion = exports.fashion = [{
    columnCategories: [{
        headerText: 'Clothing',
        links: [{
            route: '/c/dresses-gowns/26840/',
            text: 'Dresses & Gowns'
        }, {
            route: '/c/jackets-coats/26841/',
            text: 'Jackets & Coats'
        }, {
            route: '/c/shirts-blouses/26845/',
            text: 'Shirts & Blouses'
        }, {
            route: '/c/pants-trousers/26843/',
            text: 'Pants & Trousers'
        }, {
            route: '/c/robes-kimonos/26844/',
            text: 'Robes & Kimonos'
        }, {
            route: '/c/skirts/26847/',
            text: 'Skirts'
        }, {
            route: '/c/suits-ensembles/26848/',
            text: 'Suits & Ensembles'
        }, {
            route: '/c/sweaters/26849/',
            text: 'Sweaters'
        }, {
            route: '/c/vets/26851/',
            text: 'Vests'
        }]
    }]
}, {
    columnCategories: [{
        headerText: 'Accessories',
        links: [{
            route: '/c/belts-chatelaines/26829/',
            text: 'Belts & Chatelaines'
        }, {
            route: '/c/canes-walking-sticks/22/',
            text: 'Canes & Walking Sticks'
        }, {
            route: '/c/eyeglasses-spectacles/26831/',
            text: 'Eyeglasses & Spectacles'
        }, {
            route: '/c/handbags-purses/26833/',
            text: 'Handbags & Purses'
        }, {
            route: '/c/handkerchiefs-pocket-squares/26834/',
            text: 'Handkerchiefs & Pocket Squares'
        }, {
            route: '/c/neckties-bowties-bolo-ties/26836/',
            text: 'Neckties & Bow Ties'
        }, {
            route: '/c/scarves-wraps-shawls/26837/',
            text: 'Scarves, Wraps & Shawls'
        }, {
            route: '/c/shoes/26442/',
            text: 'Shoes'
        }, {
            route: '/c/wallets/26839/',
            text: 'Wallets'
        }]
    }]
}, {
    columnCategories: [{
        headerText: 'Featured Designers',
        links: [{
            route: '/c/fashion/chanel/3/4017/',
            text: 'Chanel'
        }, {
            route: '/c/fashion/christian-dior/3/4461/',
            text: 'Christian Dior'
        }, {
            route: '/c/fashion/chloe/3/4385/',
            text: 'Chloe'
        }, {
            route: '/c/fashion/gucci/3/9450/',
            text: 'Gucci'
        }, {
            route: '/c/fashion/hermes/3/10420/',
            text: 'Hermes'
        }, {
            route: '/c/fashion/louis-vuitton/3/15385/',
            text: 'Louis Vuitton'
        }, {
            route: '/c/fashion/michael-kors/3/17295/',
            text: 'Michael Kors'
        }, {
            route: '/c/fashion/yves-saint-laurent/3/25497/',
            text: 'Yves Saint Laurent'
        }]
    }]
}];

/***/ }),

/***/ "4C+L":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = __webpack_require__("dcb+");

var _jsx3 = _interopRequireDefault(_jsx2);

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Polyfill for webpack, just in case
if (false) require.ensure = function (d, c) {
    c(require);
};

var ForgotPasswordModalLoader = function (_Component) {
    (0, _inherits3.default)(ForgotPasswordModalLoader, _Component);

    function ForgotPasswordModalLoader(props, context) {
        (0, _classCallCheck3.default)(this, ForgotPasswordModalLoader);

        var _this = (0, _possibleConstructorReturn3.default)(this, (ForgotPasswordModalLoader.__proto__ || (0, _getPrototypeOf2.default)(ForgotPasswordModalLoader)).call(this, props, context));

        _this.state = {
            Component: null,
            mounted: false
        };
        return _this;
    }

    (0, _createClass3.default)(ForgotPasswordModalLoader, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            var _this2 = this;

            return new _promise2.default(function (resolve) {
                __webpack_require__.e/* require.ensure */(26).then((function () {
                    resolve(__webpack_require__("C0Vv"));
                }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            }).then(function (container) {
                _this2.setState({ Component: container });
            });
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.setState({ mounted: true });
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.setState({ mounted: false });
        }
    }, {
        key: 'render',
        value: function render() {
            var _state = this.state,
                Component = _state.Component,
                mounted = _state.mounted;

            return mounted && Component !== null ? (0, _jsx3.default)(Component, {}) : null;
        }
    }]);
    return ForgotPasswordModalLoader;
}(_react.Component);

exports.default = ForgotPasswordModalLoader;
module.exports = exports['default'];

/***/ }),

/***/ "4aul":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"discover-items":"discover-items___6YX-_","header":"header___14o8k","links":"links___YvrVu"};

/***/ }),

/***/ "4hkW":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
// needs to be here in order to overwrite redux-segment location change actions for page view posts.

exports.default = {
    mapper: {
        '@@router/LOCATION_CHANGE': function routerLOCATION_CHANGE() {
            return {};
        }
    }
};
module.exports = exports['default'];

/***/ }),

/***/ "4q18":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fetchSellersIfNeeded = exports.fetchAllSellersIfNeeded = exports.shouldFetchSeller = exports.getSeller = exports.shouldFetchSellers = exports.getMatchingSellersFunction = exports.getAllSellersForDirectoryPage = exports.areAllSellersLoading = exports.LOAD_SELLERS_SUCCESS = exports.LOAD_SELLERS_REQUEST = exports.LOAD_SELLERS_FAIL = exports.LOAD_ALL_SELLERS_SUCCESS = exports.LOAD_ALL_SELLERS_REQUEST = exports.LOAD_ALL_SELLERS_FAIL = undefined;

var _regenerator = __webpack_require__("Xxa5");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__("exGp");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _keys = __webpack_require__("fZjL");

var _keys2 = _interopRequireDefault(_keys);

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;

var _fetchBatch = __webpack_require__("6OCT");

var _api = __webpack_require__("zFQO");

var _cloneDeep = __webpack_require__("kvU2");

var _cloneDeep2 = _interopRequireDefault(_cloneDeep);

var _reselect = __webpack_require__("bndy");

var _difference = __webpack_require__("WlNK");

var _difference2 = _interopRequireDefault(_difference);

var _user = __webpack_require__("CFLi");

var _config = __webpack_require__("iS9E");

var _groupBy = __webpack_require__("swUc");

var _groupBy2 = _interopRequireDefault(_groupBy);

var _catalogAd = __webpack_require__("0QM2");

var _catalog = __webpack_require__("yv/Z");

var _home = __webpack_require__("TSUT");

var _item = __webpack_require__("Gk4U");

var _upcomingCatalogs = __webpack_require__("39qi");

var _ms = __webpack_require__("EarI");

var _ms2 = _interopRequireDefault(_ms);

var _union = __webpack_require__("gszD");

var _union2 = _interopRequireDefault(_union);

var _sellerCatalogCounts = __webpack_require__("9vxb");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Action Types */
var LOAD_ALL_SELLERS_FAIL = exports.LOAD_ALL_SELLERS_FAIL = 'la/domain/allSellers/LOAD_FAIL';
var LOAD_ALL_SELLERS_REQUEST = exports.LOAD_ALL_SELLERS_REQUEST = 'la/domain/allSellers/LOAD_REQUEST';
var LOAD_ALL_SELLERS_SUCCESS = exports.LOAD_ALL_SELLERS_SUCCESS = 'la/domain/allSellers/LOAD_SUCCESS';

var LOAD_SELLERS_FAIL = exports.LOAD_SELLERS_FAIL = 'la/domain/sellers/LOAD_FAIL';
var LOAD_SELLERS_REQUEST = exports.LOAD_SELLERS_REQUEST = 'la/domain/sellers/LOAD_REQUEST';
var LOAD_SELLERS_SUCCESS = exports.LOAD_SELLERS_SUCCESS = 'la/domain/sellers/LOAD_SUCCESS';

var REDUX_STORE_TIME = (0, _ms2.default)('30m');
var FETCH_SET_SIZE = 120;

/* reducer */
var DEFAULT_STATE = {
    byId: {},
    loaded: {},
    loadedSellers: false,
    loading: [],
    loadingSellers: false
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var existing = void 0;
    var loaded = void 0;
    var loadedSellers = void 0;
    var loading = void 0;
    var loadingSellers = void 0;
    var time = void 0;

    switch (action.type) {
        case LOAD_ALL_SELLERS_FAIL:
            return (0, _extends3.default)({}, state, {
                loadingSellers: false
            });
        case LOAD_ALL_SELLERS_REQUEST:
            return (0, _extends3.default)({}, state, {
                loadingSellers: true
            });
        case LOAD_SELLERS_FAIL:
            return (0, _extends3.default)({}, state, {
                loading: (0, _difference2.default)(state.loading, action.meta.sellerIds)
            });
        case LOAD_SELLERS_REQUEST:
            return (0, _extends3.default)({}, state, {
                loading: (0, _union2.default)(state.loading, action.payload)
            });
        case LOAD_ALL_SELLERS_SUCCESS:
            existing = (0, _cloneDeep2.default)(state.byId);
            loaded = (0, _extends3.default)({}, state.loaded);
            loading = (0, _cloneDeep2.default)(state.loading);
            time = action.meta.actionTime;

            action.payload.forEach(function (item) {
                existing[item.sellerId] = (0, _extends3.default)({}, item);
                loaded[item.sellerId] = time;
                loading = (0, _difference2.default)(loading, [item.sellerId]);
            });
            loadingSellers = false;
            loadedSellers = true;
            return (0, _extends3.default)({}, state, {
                byId: existing,
                loaded: loaded,
                loadedSellers: loadedSellers,
                loading: loading,
                loadingSellers: loadingSellers
            });
        case _catalogAd.LOAD_CATALOG_AD_SUCCESS:
        case _catalog.LOAD_CATALOGS_SUCCESS:
        case _home.LOAD_HOME_DATA_SUCCESS:
        case _item.LOAD_ITEMS_SUCCESS:
        case LOAD_SELLERS_SUCCESS:
        case _upcomingCatalogs.LOAD_UPCOMING_CATALOGS_SUCCESS:
            existing = (0, _cloneDeep2.default)(state.byId);
            loaded = (0, _extends3.default)({}, state.loaded);
            loading = (0, _cloneDeep2.default)(state.loading);
            time = action.meta.actionTime;

            if (action.payload.sellers) {
                action.payload.sellers.forEach(function (item) {
                    existing[item.sellerId] = (0, _extends3.default)({}, item);
                    loaded[item.sellerId] = time;
                    loading = (0, _difference2.default)(loading, [item.sellerId]);
                });
            }
            return (0, _extends3.default)({}, state, {
                byId: existing,
                loaded: loaded,
                loading: loading
            });
        default:
            return state;
    }
}

/* SELECTORS */
var sellerSelector = function sellerSelector(state) {
    return state.domain.seller;
};
var idSelector = function idSelector(state, id) {
    return id;
};

// get the "byId" part of the state
var byIdSelector = (0, _reselect.createSelector)(sellerSelector, function (sellers) {
    return sellers.byId;
});

var areAllSellersLoaded = function areAllSellersLoaded(state) {
    return state.domain.seller.loadedSellers || false;
};

var areAllSellersLoading = exports.areAllSellersLoading = function areAllSellersLoading(state) {
    return state.domain.seller.loadingSellers || false;
};

var getAllSellers = (0, _reselect.createSelector)(byIdSelector, function (byId) {
    return (0, _keys2.default)(byId).map(function (key) {
        return byId[key];
    });
});

// This is pretty gross.  Hopefully we can just get the correct form of data
var generateStateLists = function generateStateLists() {
    var sellers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var europeSellers = sellers.europe || [];
    var usSellers = sellers.us || [];
    var worldSellers = sellers.world || [];

    var europeSellerByState = (0, _groupBy2.default)(europeSellers.sort(function (a, b) {
        if (a.country.toLowerCase() > b.country.toLowerCase()) {
            return 1;
        }
        return -1;
    }), function (seller) {
        return seller.countryCode;
    });
    var usSellersByState = (0, _groupBy2.default)(usSellers.sort(function (a, b) {
        if (a.stateName.toLowerCase() > b.stateName.toLowerCase()) {
            return 1;
        }
        return -1;
    }), function (seller) {
        return seller.stateCode;
    });
    var worldSellersByState = (0, _groupBy2.default)(worldSellers.sort(function (a, b) {
        if (a.country.toLowerCase() > b.country.toLowerCase()) {
            return 1;
        }
        return -1;
    }), function (seller) {
        return seller.countryCode;
    });

    var europe = [];
    (0, _keys2.default)(europeSellerByState).forEach(function (key) {
        if (!europeSellerByState[key][0].country) {
            return;
        }
        var country = {
            name: europeSellerByState[key][0].country,
            sellers: europeSellerByState[key].map(function (seller) {
                return { name: seller.name, sellerId: seller.sellerId };
            }).sort(function (a, b) {
                if (a.name.toLowerCase() > b.name.toLowerCase()) {
                    return 1;
                }
                return -1;
            })
        };
        europe.push(country);
    });

    var us = [];
    (0, _keys2.default)(usSellersByState).forEach(function (key) {
        if (!usSellersByState[key][0].stateName) {
            return;
        }
        var state = {
            name: usSellersByState[key][0].stateName,
            sellers: usSellersByState[key].map(function (seller) {
                return { name: seller.name, sellerId: seller.sellerId };
            }).sort(function (a, b) {
                if (a.name.toLowerCase() > b.name.toLowerCase()) {
                    return 1;
                }
                return -1;
            })
        };
        us.push(state);
    });

    var world = [];
    (0, _keys2.default)(worldSellersByState).forEach(function (key) {
        if (!worldSellersByState[key][0].country) {
            return;
        }
        var country = {
            name: worldSellersByState[key][0].country,
            sellers: worldSellersByState[key].map(function (seller) {
                return { name: seller.name, sellerId: seller.sellerId };
            }).sort(function (a, b) {
                if (a.name.toLowerCase() > b.name.toLowerCase()) {
                    return 1;
                }
                return -1;
            })
        };
        world.push(country);
    });

    return {
        europe: europe,
        us: us,
        world: world
    };
};

var getFilteredAllSellers = (0, _reselect.createSelector)(getAllSellers, function (allSellers) {
    return allSellers.filter(function (x) {
        // Premiere Props has 3 seller ids now, filter out the first two from the directory page
        return x.sellerId !== 675 && x.sellerId !== 759;
    });
});

var getAllSellersForDirectoryPage = exports.getAllSellersForDirectoryPage = (0, _reselect.createSelector)(getFilteredAllSellers, function (allSellers) {
    var sellers = (0, _groupBy2.default)(allSellers, function (seller) {
        return seller.regionCode;
    });
    return generateStateLists(sellers);
});

var getMatchingSellersFunction = exports.getMatchingSellersFunction = function getMatchingSellersFunction(state) {
    return function (query) {
        var sellers = getFilteredAllSellers(state);
        return sellers.filter(function (seller) {
            var searchTokens = query.split(/\s/);
            var matchingTokens = searchTokens.filter(function (token) {
                var _seller$name = seller.name,
                    name = _seller$name === undefined ? '' : _seller$name;

                return ('' + name).toLowerCase().indexOf(token) !== -1;
            });
            var doesMatch = matchingTokens.length === searchTokens.length;
            return doesMatch;
        });
    };
};

var shouldFetchSellers = exports.shouldFetchSellers = function shouldFetchSellers(state) {
    return !areAllSellersLoaded(state) && !areAllSellersLoading(state);
};

var getLoadTimeForSeller = function getLoadTimeForSeller(state, sellerId) {
    return state.domain.seller.loaded[sellerId] || 0;
};

var isSellerLoading = function isSellerLoading(state, sellerId) {
    return state.domain.seller.loading.indexOf(sellerId) !== -1;
};

var getSeller = exports.getSeller = (0, _reselect.createSelector)([byIdSelector, idSelector], function (byId, id) {
    return byId[id] || {};
});

var shouldFetchSeller = exports.shouldFetchSeller = function shouldFetchSeller(state, sellerId) {
    if (!sellerId) return false;
    var item = getSeller(state, sellerId);
    if (item) {
        var loaded = getLoadTimeForSeller(state, sellerId);
        var time = Date.now();
        var diff = time - loaded;
        if (diff < REDUX_STORE_TIME) return false;
    }
    var loading = isSellerLoading(state, sellerId);
    return !loading;
};

var whichSellersNeeded = function whichSellersNeeded(state, sellerIds) {
    return sellerIds.filter(function (sellerId) {
        return shouldFetchSeller(state, sellerId);
    });
};

/* ACTION CREATORS */
// all sellers
var loadAllSellersFail = function loadAllSellersFail(error) {
    return {
        error: true,
        payload: error,
        type: LOAD_ALL_SELLERS_FAIL
    };
};

var loadAllSellersRequest = function loadAllSellersRequest() {
    return {
        type: LOAD_ALL_SELLERS_REQUEST
    };
};

var loadAllSellersSuccess = function loadAllSellersSuccess(results) {
    return {
        meta: { actionTime: Date.now() },
        payload: results,
        type: LOAD_ALL_SELLERS_SUCCESS
    };
};

var loadAllSellers = function loadAllSellers() {
    return function (dispatch, getState) {
        var state = getState();
        var deployment = (0, _config.getDeployment)(state);
        dispatch(loadAllSellersRequest());
        return _api.Seller.fetchSellers({ deployment: deployment }).then(function (response) {
            dispatch(loadAllSellersSuccess(response.data));
        }).catch(function (error) {
            dispatch(loadAllSellersFail(error));
        });
    };
};

var fetchAllSellersIfNeeded = exports.fetchAllSellersIfNeeded = function fetchAllSellersIfNeeded() {
    return function (dispatch, getState) {
        if (shouldFetchSellers(getState())) {
            return dispatch(loadAllSellers());
        }
        return _promise2.default.resolve();
    };
};

// seller
var loadSellers = function loadSellers(sellerIds, loadingId, isFinalFetch) {
    return function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch, getState) {
            var state, authToken, deployment, response;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.prev = 0;
                            state = getState();
                            authToken = (0, _user.getAuthToken)(state);
                            deployment = (0, _config.getDeployment)(state);

                            dispatch({
                                payload: sellerIds,
                                type: LOAD_SELLERS_REQUEST
                            });
                            _context.next = 7;
                            return _api.Seller.fetchSellersByIds({ authToken: authToken, deployment: deployment, sellerIds: sellerIds });

                        case 7:
                            response = _context.sent;

                            dispatch({
                                meta: { actionTime: Date.now(), sellerIds: sellerIds },
                                payload: response.data,
                                type: LOAD_SELLERS_SUCCESS
                            });
                            if (isFinalFetch) {
                                dispatch((0, _fetchBatch.loadBatchEnd)(loadingId));
                            }
                            _context.next = 16;
                            break;

                        case 12:
                            _context.prev = 12;
                            _context.t0 = _context['catch'](0);

                            dispatch({
                                error: true,
                                meta: { sellerIds: sellerIds },
                                payload: _context.t0,
                                type: LOAD_SELLERS_FAIL
                            });
                            dispatch((0, _fetchBatch.loadBatchEnd)(loadingId));

                        case 16:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, undefined, [[0, 12]]);
        }));

        return function (_x4, _x5) {
            return _ref.apply(this, arguments);
        };
    }();
};

var loadSellersInSets = function loadSellersInSets(ids, setSize, loadingId) {
    return function (dispatch) {
        if (ids.length > setSize) {
            return dispatch(loadSellers(ids.slice(0, setSize), loadingId, false)).then(function () {
                dispatch(loadSellersInSets(ids.slice(setSize), setSize, loadingId));
            });
        }
        return dispatch(loadSellers(ids, loadingId, true));
    };
};

var fetchSellersIfNeeded = exports.fetchSellersIfNeeded = function fetchSellersIfNeeded(sellerIds) {
    var loadingId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'none';

    return function (dispatch, getState) {
        var neededSellers = whichSellersNeeded(getState(), sellerIds);
        var neededCatalogCounts = (0, _sellerCatalogCounts.whichSellerCatalogCountsNeeded)(getState(), sellerIds);
        var needed = (0, _union2.default)(neededSellers, neededCatalogCounts);
        if (needed.length) {
            dispatch((0, _fetchBatch.loadBatchStart)(loadingId));
            return dispatch(loadSellersInSets(needed, FETCH_SET_SIZE, loadingId));
        }
        return _promise2.default.resolve();
    };
};

/***/ }),

/***/ "53Ov":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = __webpack_require__("dcb+");

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propsComparer = __webpack_require__("wsGv");

var _propsComparer2 = _interopRequireDefault(_propsComparer);

var _reactIntl = __webpack_require__("Pq8k");

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _FollowSellerLink = __webpack_require__("xSux");

var _FollowSellerLink2 = _interopRequireDefault(_FollowSellerLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FollowSellerLink = (_temp = _class = function (_Component) {
    (0, _inherits3.default)(FollowSellerLink, _Component);

    function FollowSellerLink() {
        (0, _classCallCheck3.default)(this, FollowSellerLink);
        return (0, _possibleConstructorReturn3.default)(this, (FollowSellerLink.__proto__ || (0, _getPrototypeOf2.default)(FollowSellerLink)).apply(this, arguments));
    }

    (0, _createClass3.default)(FollowSellerLink, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps) {
            return (0, _propsComparer2.default)(this.props, nextProps, ['followed']);
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                children = _props.children,
                followed = _props.followed;


            if (children) {
                return (0, _jsx3.default)('span', {
                    className: _FollowSellerLink2.default['follow-seller']
                }, 0, children);
            }

            return (0, _jsx3.default)('span', {
                className: _FollowSellerLink2.default['follow-seller']
            }, 0, followed ? (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'following_auctioneer'
            }) : (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'follow_auctioneer'
            }));
        }
    }]);
    return FollowSellerLink;
}(_react.Component), _class.defaultProps = {
    followed: false
}, _temp);
exports.default = FollowSellerLink;
module.exports = exports['default'];

/***/ }),

/***/ "57qU":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.stopTracker = exports.openSetPasswordModalFromChecker = exports.openConfirmPasswordModalFromChecker = exports.openCompleteAccountModalFromChecker = exports.openLoginModalFromChecker = exports.getTriggerId = exports.isCompleteAccountModalOpen = exports.isLoginModalOpen = exports.isTracking = exports.STOP_TRACKER = exports.OPEN_SET_PASSWORD_MODAL_FROM_CHECKER = exports.OPEN_LOGIN_MODAL_FROM_CHECKER = exports.OPEN_CONFIRM_PASSWORD_MODAL_FROM_CHECKER = exports.OPEN_COMPLETE_ACCOUNT_MODAL_FROM_CHECKER = undefined;

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;

var _modal = __webpack_require__("u90i");

var _completeAccount = __webpack_require__("Qs/t");

var _reselect = __webpack_require__("bndy");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Action Types */
var OPEN_COMPLETE_ACCOUNT_MODAL_FROM_CHECKER = exports.OPEN_COMPLETE_ACCOUNT_MODAL_FROM_CHECKER = 'la/ui/shouldLogin/OPEN_COMPLETE_ACCOUNT_MODAL_FROM_CHECKER';
var OPEN_CONFIRM_PASSWORD_MODAL_FROM_CHECKER = exports.OPEN_CONFIRM_PASSWORD_MODAL_FROM_CHECKER = 'la/ui/shouldLogin/OPEN_CONFIRM_PASSWORD_MODAL_FROM_CHECKER';
var OPEN_LOGIN_MODAL_FROM_CHECKER = exports.OPEN_LOGIN_MODAL_FROM_CHECKER = 'la/ui/shouldLogin/OPEN_LOGIN_MODAL_FROM_CHECKER';
var OPEN_SET_PASSWORD_MODAL_FROM_CHECKER = exports.OPEN_SET_PASSWORD_MODAL_FROM_CHECKER = 'la/ui/shouldLogin/OPEN_SET_PASSWORD_MODAL_FROM_CHECKER';
var STOP_TRACKER = exports.STOP_TRACKER = 'la/ui/shouldLogin/STOP_TRACKER';

/* reducer */
var DEFAULT_STATE = {
    completeAccountModalOpen: false,
    confirmPasswordModalOpen: false,
    loginModalOpen: false,
    setPasswordModalOpen: false,
    startTracking: false,
    trigger: ''
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        case OPEN_COMPLETE_ACCOUNT_MODAL_FROM_CHECKER:
            return (0, _extends3.default)({}, state, {
                completeAccountModalOpen: true,
                confirmPasswordModalOpen: false,
                loginModalOpen: false,
                setPasswordModalOpen: false,
                startTracking: true,
                trigger: action.trigger
            });
        case OPEN_CONFIRM_PASSWORD_MODAL_FROM_CHECKER:
            // do we need this?
            return (0, _extends3.default)({}, state, {
                completeAccountModalOpen: false,
                confirmPasswordModalOpen: true,
                loginModalOpen: false,
                setPasswordModalOpen: false,
                startTracking: true,
                trigger: action.trigger
            });
        case OPEN_LOGIN_MODAL_FROM_CHECKER:
            return (0, _extends3.default)({}, state, {
                completeAccountModalOpen: false,
                confirmPasswordModalOpen: false,
                loginModalOpen: true,
                setPasswordModalOpen: false,
                startTracking: true,
                trigger: action.trigger
            });
        case OPEN_SET_PASSWORD_MODAL_FROM_CHECKER:
            return (0, _extends3.default)({}, state, {
                completeAccountModalOpen: false,
                confirmPasswordModalOpen: false,
                loginModalOpen: false,
                setPasswordModalOpen: true,
                startTracking: true,
                trigger: action.trigger
            });
        case _modal.COMPLETE_COMPLETE_ACCOUNT_MODAL:
            return (0, _extends3.default)({}, state, {
                completeAccountModalOpen: false
            });
        case _modal.COMPLETE_LOGIN_MODAL:
            return (0, _extends3.default)({}, state, {
                loginModalOpen: false
            });
        case _completeAccount.COMPLETE_ACCOUNT_SUCCESS:
            return (0, _extends3.default)({}, state, {
                completeAccountModalOpen: false
            });
        case _modal.COMPLETE_CONFIRM_PASSWORD_MODAL:
            // TODO there is not action for this
            return (0, _extends3.default)({}, state, {
                confirmPasswordModalOpen: false
            });
        case STOP_TRACKER:
        case _modal.DISMISS_MODAL:
            return (0, _extends3.default)({}, state, {
                completeAccountModalOpen: false,
                confirmPasswordModalOpen: false,
                loginModalOpen: false,
                setPasswordModalOpen: false,
                startTracking: false,
                trigger: ''
            });
        default:
            return state;
    }
}

/* SELECTORS */
var stateSelector = function stateSelector(state) {
    return state.shouldLogin;
};

var isTracking = exports.isTracking = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.startTracking;
});

var isLoginModalOpen = exports.isLoginModalOpen = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.loginModalOpen;
});

var isCompleteAccountModalOpen = exports.isCompleteAccountModalOpen = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.completeAccountModalOpen;
});

var getTriggerId = exports.getTriggerId = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.trigger ? state.trigger : null;
});

/* ACTION CREATORS */
var openLoginModalFromChecker = exports.openLoginModalFromChecker = function openLoginModalFromChecker(trigger) {
    return {
        trigger: trigger,
        type: OPEN_LOGIN_MODAL_FROM_CHECKER
    };
};

var openCompleteAccountModalFromChecker = exports.openCompleteAccountModalFromChecker = function openCompleteAccountModalFromChecker(trigger) {
    return {
        trigger: trigger,
        type: OPEN_COMPLETE_ACCOUNT_MODAL_FROM_CHECKER
    };
};

var openConfirmPasswordModalFromChecker = exports.openConfirmPasswordModalFromChecker = function openConfirmPasswordModalFromChecker(trigger) {
    return {
        trigger: trigger,
        type: OPEN_CONFIRM_PASSWORD_MODAL_FROM_CHECKER
    };
};

var openSetPasswordModalFromChecker = exports.openSetPasswordModalFromChecker = function openSetPasswordModalFromChecker(trigger) {
    return {
        trigger: trigger,
        type: OPEN_SET_PASSWORD_MODAL_FROM_CHECKER
    };
};

var stopTracker = exports.stopTracker = function stopTracker() {
    return {
        type: STOP_TRACKER
    };
};

/***/ }),

/***/ "5A1c":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.BidIncrementsRemote = undefined;

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _helpers = __webpack_require__("SY39");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BidIncrementsRemote = exports.BidIncrementsRemote = {
    fetchBidIncrements: function fetchBidIncrements(_ref) {
        var authToken = _ref.authToken,
            catalogId = _ref.catalogId,
            deployment = _ref.deployment;
        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makePost)('<ITEM-API>spa/small/bid-increments', deployment);
            (0, _helpers.addAuthToken)(request, authToken);
            request.send({ catalogIds: [catalogId] });
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response });
            });
        });
    }
};

/***/ }),

/***/ "5Fhj":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.submitAbsenteeBid = exports.getAbsenteeBidItemId = exports.getAbsenteeBidAmount = exports.getUiAbsenteeBid = exports.ABSENTEE_BID_SUCCESS = exports.ABSENTEE_BID_REQUEST = exports.ABSENTEE_BID_FAIL = undefined;

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;

var _modal = __webpack_require__("u90i");

var _api = __webpack_require__("zFQO");

var _reselect = __webpack_require__("bndy");

var _user = __webpack_require__("CFLi");

var _config = __webpack_require__("iS9E");

var _analytics = __webpack_require__("yxCd");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Action Types */
var ABSENTEE_BID_FAIL = exports.ABSENTEE_BID_FAIL = 'la/ui/absenteeBid/FAIL';
var ABSENTEE_BID_REQUEST = exports.ABSENTEE_BID_REQUEST = 'la/ui/absenteeBid/REQUEST';
var ABSENTEE_BID_SUCCESS = exports.ABSENTEE_BID_SUCCESS = 'la/ui/absenteeBid/SUCCESS';

// reducer
var DEFAULT_STATE = {
    bidAmount: null,
    bidPlaced: false,
    isCurrentHighBid: false,
    itemId: null,
    submitted: false,
    success: false
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        case _modal.DISMISS_MODAL:
            return (0, _extends3.default)({}, state, {
                bidPlaced: false
            });
        case _modal.OPEN_ABSENTEE_BID_MODAL:
            return (0, _extends3.default)({}, state, {
                bidAmount: action.payload.bidAmount,
                itemId: action.payload.itemId
            });
        case ABSENTEE_BID_REQUEST:
            return (0, _extends3.default)({}, state, {
                bidPlaced: true,
                submitted: true,
                success: false
            });
        case ABSENTEE_BID_SUCCESS:
            return (0, _extends3.default)({}, state, {
                bidAmount: null,
                isCurrentHighBid: action.payload.isCurrentHighBid,
                submitted: false,
                success: true
            });
        case ABSENTEE_BID_FAIL:
            return (0, _extends3.default)({}, state, {
                error: true,
                submitted: false,
                success: false
            });
        default:
            return state;
    }
}

/* SELECTORS */
var stateSelector = function stateSelector(state) {
    return state.ui.absenteeBid;
};

var getUiAbsenteeBid = exports.getUiAbsenteeBid = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state;
});

var getAbsenteeBidAmount = exports.getAbsenteeBidAmount = (0, _reselect.createSelector)(getUiAbsenteeBid, function (uiState) {
    return !isNaN(uiState.bidAmount) ? uiState.bidAmount : null;
});

var getAbsenteeBidItemId = exports.getAbsenteeBidItemId = (0, _reselect.createSelector)(getUiAbsenteeBid, function (uiState) {
    return uiState.itemId ? uiState.itemId : null;
});

/* ACTION CREATORS */
var submitAbsenteeBid = exports.submitAbsenteeBid = function submitAbsenteeBid(details) {
    return function (dispatch, getState) {
        var state = getState();
        var authToken = (0, _user.getAuthToken)(state);
        var deployment = (0, _config.getDeployment)(state);
        dispatch({
            type: ABSENTEE_BID_REQUEST
        });
        return _api.Bid.postPlaceAbsenteeBid({ authToken: authToken, deployment: deployment, details: details }).then(function (response) {
            var analytics = (0, _analytics.getPlacedAbsenteeBidAnalytics)(state, details.itemId, details.bidAmount);
            dispatch({
                meta: {
                    actionTime: Date.now(),
                    analytics: analytics.analytics,
                    itemId: details.itemId
                },
                payload: response,
                type: ABSENTEE_BID_SUCCESS
            });
        }).catch(function (error) {
            dispatch({
                error: true,
                payload: error,
                type: ABSENTEE_BID_FAIL
            });
        });
    };
};

/***/ }),

/***/ "5QdQ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.buildCanonicalUrlWithPageNum = undefined;

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

var _url = __webpack_require__("ArKR");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var buildCanonicalUrl = function buildCanonicalUrl(canonicalPageUrl, pageNum) {
    var base = (0, _url.getBase)(canonicalPageUrl);
    var originalQuery = (0, _url.getQueryString)(canonicalPageUrl);
    var params = (0, _url.getParams)(originalQuery);

    var withPage = (0, _extends3.default)({}, params);

    // remove parameters for search page
    delete withPage.parameters;

    // remove page (we will add it later)
    delete withPage.page;
    if (pageNum && pageNum !== 1) {
        withPage.page = pageNum;
    }

    var query = (0, _url.toQueryString)(withPage);

    return query === '' ? base : base + '?' + query;
};

var buildCanonicalUrlWithPageNum = exports.buildCanonicalUrlWithPageNum = function buildCanonicalUrlWithPageNum(canonicalPageUrl, pageNum) {
    return buildCanonicalUrl(canonicalPageUrl, pageNum);
};

/***/ }),

/***/ "5Sl0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = __webpack_require__("dcb+");

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _ = __webpack_require__("bGai");

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__("Pq8k");

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _LoggedOut = __webpack_require__("+1eV");

var _LoggedOut2 = _interopRequireDefault(_LoggedOut);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LoggedOut = function (_Component) {
    (0, _inherits3.default)(LoggedOut, _Component);

    function LoggedOut() {
        (0, _classCallCheck3.default)(this, LoggedOut);
        return (0, _possibleConstructorReturn3.default)(this, (LoggedOut.__proto__ || (0, _getPrototypeOf2.default)(LoggedOut)).apply(this, arguments));
    }

    (0, _createClass3.default)(LoggedOut, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate() {
            return false;
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                openCreateAccountModal = _props.openCreateAccountModal,
                openLoginModal = _props.openLoginModal;


            return (0, _jsx3.default)('div', {
                className: _LoggedOut2.default['logged-out-controls']
            }, void 0, (0, _jsx3.default)(_.Link, {
                className: _LoggedOut2.default['link-default'],
                onClick: openLoginModal,
                primaryWeak: true
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'log_in'
            })), (0, _jsx3.default)(_.Button, {
                primary: true,
                className: _LoggedOut2.default['button-default'],
                onClick: openCreateAccountModal
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'sign_up'
            })));
        }
    }]);
    return LoggedOut;
}(_react.Component);

exports.default = LoggedOut;
module.exports = exports['default'];

/***/ }),

/***/ "5jkQ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ConsignmentRemote = undefined;

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _helpers = __webpack_require__("SY39");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ConsignmentRemote = exports.ConsignmentRemote = {
    postConsignment: function postConsignment(_ref) {
        var authToken = _ref.authToken,
            deployment = _ref.deployment,
            file = _ref.file,
            form = _ref.form,
            userData = _ref.userData;
        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makePost)('<ITEM-API>spa/consignment/upload', deployment);
            var address = '' + userData.address + (userData.address2 ? '' + (' ' + userData.address2) : '');
            (0, _helpers.addAuthToken)(request, authToken);
            request.field('address', address).field('city', userData.city).field('country', userData.country).field('description', form.description).field('email', form.email).field('multi2', form.multi2).field('name', userData.firstName + ' ' + userData.lastName).field('other', form.other).field('state', userData.state).field('telephone', userData.mobileNumber).attach('photo', file).end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response });
            });
        });
    }
};

/***/ }),

/***/ "5qJt":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _bidHistory = __webpack_require__("BK5P");

var _bidHistory2 = __webpack_require__("uC6t");

var BidHistory = {
    fetchBidHistory: function fetchBidHistory(params) {
        return  false ? _bidHistory.BidHistoryMock.fetchBidHistory(params) : _bidHistory2.BidHistoryRemote.fetchBidHistory(params);
    }
};

exports.default = BidHistory;
module.exports = exports['default'];

/***/ }),

/***/ "5tCn":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _faAngleLeft = __webpack_require__("WHuM");

var _faAngleLeft2 = _interopRequireDefault(_faAngleLeft);

var _faCalendarAlt = __webpack_require__("W+WY");

var _faCalendarAlt2 = _interopRequireDefault(_faCalendarAlt);

var _faCameraAlt = __webpack_require__("nQk0");

var _faCameraAlt2 = _interopRequireDefault(_faCameraAlt);

var _faCaretDown = __webpack_require__("4fO9");

var _faCaretDown2 = _interopRequireDefault(_faCaretDown);

var _faCaretLeft = __webpack_require__("+cSO");

var _faCaretLeft2 = _interopRequireDefault(_faCaretLeft);

var _faCaretRight = __webpack_require__("crK8");

var _faCaretRight2 = _interopRequireDefault(_faCaretRight);

var _faCaretUp = __webpack_require__("5uW9");

var _faCaretUp2 = _interopRequireDefault(_faCaretUp);

var _faCheckCircle = __webpack_require__("Jalj");

var _faCheckCircle2 = _interopRequireDefault(_faCheckCircle);

var _faChevronLeft = __webpack_require__("eKYM");

var _faChevronLeft2 = _interopRequireDefault(_faChevronLeft);

var _faChevronRight = __webpack_require__("3MR1");

var _faChevronRight2 = _interopRequireDefault(_faChevronRight);

var _faClock = __webpack_require__("mWfM");

var _faClock2 = _interopRequireDefault(_faClock);

var _faEnvelope = __webpack_require__("/hM8");

var _faEnvelope2 = _interopRequireDefault(_faEnvelope);

var _faExclamationCircle = __webpack_require__("ZEVB");

var _faExclamationCircle2 = _interopRequireDefault(_faExclamationCircle);

var _faExclamationTriangle = __webpack_require__("j5xF");

var _faExclamationTriangle2 = _interopRequireDefault(_faExclamationTriangle);

var _faEye = __webpack_require__("9A+h");

var _faEye2 = _interopRequireDefault(_faEye);

var _faEyeSlash = __webpack_require__("dQhn");

var _faEyeSlash2 = _interopRequireDefault(_faEyeSlash);

var _faHeart = __webpack_require__("9/v2");

var _faHeart2 = _interopRequireDefault(_faHeart);

var _faHeart3 = __webpack_require__("5zpx");

var _faHeart4 = _interopRequireDefault(_faHeart3);

var _faHourglassStart = __webpack_require__("kts1");

var _faHourglassStart2 = _interopRequireDefault(_faHourglassStart);

var _faLightbulb = __webpack_require__("D6A3");

var _faLightbulb2 = _interopRequireDefault(_faLightbulb);

var _faLock = __webpack_require__("0SrU");

var _faLock2 = _interopRequireDefault(_faLock);

var _faMobileAlt = __webpack_require__("uVnY");

var _faMobileAlt2 = _interopRequireDefault(_faMobileAlt);

var _faPlay = __webpack_require__("Os3c");

var _faPlay2 = _interopRequireDefault(_faPlay);

var _faQuestionCircle = __webpack_require__("oW+v");

var _faQuestionCircle2 = _interopRequireDefault(_faQuestionCircle);

var _faSearch = __webpack_require__("5BL6");

var _faSearch2 = _interopRequireDefault(_faSearch);

var _faSpinner = __webpack_require__("3d2B");

var _faSpinner2 = _interopRequireDefault(_faSpinner);

var _faUsdCircle = __webpack_require__("fWDC");

var _faUsdCircle2 = _interopRequireDefault(_faUsdCircle);

var _faTachometerAlt = __webpack_require__("rwdf");

var _faTachometerAlt2 = _interopRequireDefault(_faTachometerAlt);

var _faTimes = __webpack_require__("Stea");

var _faTimes2 = _interopRequireDefault(_faTimes);

var _faUsdCircle3 = __webpack_require__("cIdi");

var _faUsdCircle4 = _interopRequireDefault(_faUsdCircle3);

var _fontawesome = __webpack_require__("QxPg");

var _fontawesome2 = _interopRequireDefault(_fontawesome);

var _react = __webpack_require__("GiK3");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_fontawesome2.default.library.add(_faAngleLeft2.default, _faCalendarAlt2.default, _faCameraAlt2.default, _faCaretDown2.default, _faCaretLeft2.default, _faCaretRight2.default, _faCaretUp2.default, _faCheckCircle2.default, _faChevronLeft2.default, _faChevronRight2.default, _faClock2.default, _faEnvelope2.default, _faExclamationCircle2.default, _faExclamationTriangle2.default, _faEye2.default, _faEyeSlash2.default, _faHeart2.default, _faHeart4.default, _faHourglassStart2.default, _faLightbulb2.default, _faLock2.default, _faMobileAlt2.default, _faPlay2.default, _faQuestionCircle2.default, _faSearch2.default, _faSpinner2.default, _faUsdCircle2.default, _faTachometerAlt2.default, _faTimes2.default, _faUsdCircle4.default);

var FontAwesome = function (_PureComponent) {
    (0, _inherits3.default)(FontAwesome, _PureComponent);

    function FontAwesome() {
        (0, _classCallCheck3.default)(this, FontAwesome);
        return (0, _possibleConstructorReturn3.default)(this, (FontAwesome.__proto__ || (0, _getPrototypeOf2.default)(FontAwesome)).apply(this, arguments));
    }

    (0, _createClass3.default)(FontAwesome, [{
        key: 'render',
        value: function render() {
            return null;
        }
    }]);
    return FontAwesome;
}(_react.PureComponent);

exports.default = FontAwesome;
module.exports = exports['default'];

/***/ }),

/***/ "6Gwy":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = __webpack_require__("dcb+");

var _jsx3 = _interopRequireDefault(_jsx2);

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Polyfill for webpack, just in case
if (false) require.ensure = function (d, c) {
    c(require);
};

var DownloadMobileModalLoader = function (_Component) {
    (0, _inherits3.default)(DownloadMobileModalLoader, _Component);

    function DownloadMobileModalLoader(props, context) {
        (0, _classCallCheck3.default)(this, DownloadMobileModalLoader);

        var _this = (0, _possibleConstructorReturn3.default)(this, (DownloadMobileModalLoader.__proto__ || (0, _getPrototypeOf2.default)(DownloadMobileModalLoader)).call(this, props, context));

        _this.state = {
            Component: null,
            mounted: false
        };
        return _this;
    }

    (0, _createClass3.default)(DownloadMobileModalLoader, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            var _this2 = this;

            return new _promise2.default(function (resolve) {
                __webpack_require__.e/* require.ensure */(52).then((function () {
                    resolve(__webpack_require__("1lTZ"));
                }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            }).then(function (container) {
                _this2.setState({ Component: container });
            });
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.setState({ mounted: true });
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.setState({ mounted: false });
        }
    }, {
        key: 'render',
        value: function render() {
            var _state = this.state,
                Component = _state.Component,
                mounted = _state.mounted;

            return mounted && Component !== null ? (0, _jsx3.default)(Component, {}) : null;
        }
    }]);
    return DownloadMobileModalLoader;
}(_react.Component);

exports.default = DownloadMobileModalLoader;
module.exports = exports['default'];

/***/ }),

/***/ "6OCT":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.loadBatchStart = exports.loadBatchEnd = exports.isDataLoading = exports.LOAD_BATCH_START = exports.LOAD_BATCH_END = undefined;

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;

var _reselect = __webpack_require__("bndy");

var _difference = __webpack_require__("WlNK");

var _difference2 = _interopRequireDefault(_difference);

var _union = __webpack_require__("gszD");

var _union2 = _interopRequireDefault(_union);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Action Types */
var LOAD_BATCH_END = exports.LOAD_BATCH_END = 'LOAD_BATCH_END';
var LOAD_BATCH_START = exports.LOAD_BATCH_START = 'LOAD_BATCH_START';

/* reducer */
var DEFAULT_STATE = {
    loading: []
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        case LOAD_BATCH_END:
            return (0, _extends3.default)({}, state, {
                loading: (0, _difference2.default)(state.loading, [action.payload])
            });
        case LOAD_BATCH_START:
            return (0, _extends3.default)({}, state, {
                loading: (0, _union2.default)(state.loading, [action.payload])
            });
        default:
            return state;
    }
}

/* SELECTORS */
var stateSelector = function stateSelector(state) {
    return state.ui.fetchBatch;
};
var idSelector = function idSelector(state, id) {
    return id;
};

var loadingSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.loading;
});

var isDataLoading = exports.isDataLoading = (0, _reselect.createSelector)([loadingSelector, idSelector], function (loading, id) {
    return loading.includes(id);
});

/* ACTION CREATORS */
var loadBatchEnd = exports.loadBatchEnd = function loadBatchEnd(loadingId) {
    return {
        payload: loadingId,
        type: LOAD_BATCH_END
    };
};

var loadBatchStart = exports.loadBatchStart = function loadBatchStart(loadingId) {
    return {
        payload: loadingId,
        type: LOAD_BATCH_START
    };
};

/***/ }),

/***/ "6OFE":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getSellerCardDatas = exports.getSellerCardData = exports.getLiveItemCardData = exports.getLiveItemCardDatas = exports.getItemCardDatas = exports.getItemCardData = exports.getLiveCatalogCardDatas = exports.getLiveCatalogCardData = exports.getCatalogCardDatas = exports.getCatalogCardData = undefined;

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

var _reselect = __webpack_require__("bndy");

var _biddingInfo = __webpack_require__("m9FA");

var _catalog = __webpack_require__("yv/Z");

var _console = __webpack_require__("FSAu");

var _catalogRegistration = __webpack_require__("uhYE");

var _coverLots = __webpack_require__("fr8l");

var _item = __webpack_require__("Gk4U");

var _saveItem = __webpack_require__("6oKK");

var _savedItemCount = __webpack_require__("oIDo");

var _savedSearchItem = __webpack_require__("c5lA");

var _seller = __webpack_require__("4q18");

var _sellerCatalogCounts = __webpack_require__("9vxb");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var globalStateSelector = function globalStateSelector(state) {
    return state;
};
var idSelector = function idSelector(state, id) {
    return id;
};

var getCatalogCardData = exports.getCatalogCardData = (0, _reselect.createSelector)([globalStateSelector, idSelector], function (state, catalogId) {
    var catalog = (0, _catalog.getCatalog)(state, catalogId);
    var coverLots = (0, _coverLots.getCoverLots)(state, catalogId);
    var seller = (0, _seller.getSeller)(state, catalog.sellerId);
    return { catalog: catalog, coverLots: coverLots, seller: seller };
});

var getCatalogCardDatas = exports.getCatalogCardDatas = (0, _reselect.createSelector)([globalStateSelector, idSelector], function (state, catalogIds) {
    return catalogIds.map(function (id) {
        return getCatalogCardData(state, id);
    });
});

var getLiveCatalogCardData = exports.getLiveCatalogCardData = (0, _reselect.createSelector)([globalStateSelector, idSelector], function (state, catalogId) {
    return (0, _extends3.default)({}, getCatalogCardData(state, catalogId), {
        bidders: (0, _console.getCatalogBidders)(state, catalogId)
    });
});

var getLiveCatalogCardDatas = exports.getLiveCatalogCardDatas = (0, _reselect.createSelector)([globalStateSelector, idSelector], function (state, catalogIds) {
    return catalogIds.map(function (id) {
        return getLiveCatalogCardData(state, id);
    });
});

var getItemCardData = exports.getItemCardData = (0, _reselect.createSelector)([globalStateSelector, idSelector], function (state, itemId) {
    var item = (0, _item.getItem)(state, itemId);
    var biddingInfo = (0, _biddingInfo.getBiddingInfo)(state, item.itemId);
    var catalogId = item.catalogId,
        sellerId = item.sellerId;
    // bidding info should usually be more up to date

    if (item.itemId) {
        // ensure that the item obj stays empty if we dont get it from the getItem call
        // TODO: fix this, we should not mutate the item's state
        item.isSold = biddingInfo.isSold !== undefined ? biddingInfo.isSold : item.isSold;
        item.isAvailable = biddingInfo.isAvailable !== undefined ? biddingInfo.isAvailable : item.isAvailable;
        item.isPassed = biddingInfo.isPassed !== undefined ? biddingInfo.isPassed : item.isPassed;
        item.isLocked = biddingInfo.isLocked !== undefined ? biddingInfo.isLocked : item.isLocked;
    }
    var catalog = (0, _catalog.getCatalog)(state, item.catalogId);
    var catalogRegistration = (0, _catalogRegistration.getCatalogRegistration)(state, catalogId);
    var savedItem = (0, _saveItem.getSavedItem)(state, itemId);
    var savedSearch = (0, _savedSearchItem.getSavedSearchItem)(state, itemId);
    var seller = (0, _seller.getSeller)(state, sellerId);
    var saves = (0, _savedItemCount.getSavedItemCount)(state, itemId);

    return {
        biddingInfo: biddingInfo,
        catalog: catalog,
        catalogRegistration: catalogRegistration,
        item: item,
        savedItem: savedItem,
        savedSearch: savedSearch,
        saves: saves,
        seller: seller
    };
});

var getItemCardDatas = exports.getItemCardDatas = (0, _reselect.createSelector)([globalStateSelector, idSelector], function (state, itemIds) {
    return itemIds.map(function (id) {
        return getItemCardData(state, id);
    });
});

var getLiveItemCardDatas = exports.getLiveItemCardDatas = (0, _reselect.createSelector)([globalStateSelector, idSelector], function (state, itemIds) {
    return itemIds.map(function (id) {
        return getLiveItemCardData(state, id);
    });
});

var getLiveItemCardData = exports.getLiveItemCardData = (0, _reselect.createSelector)([globalStateSelector, idSelector], function (state, itemId) {
    return (0, _extends3.default)({}, getItemCardData(state, itemId), {
        saves: (0, _savedItemCount.getSavedItemCount)(state, itemId)
    });
});

var getSellerCardData = exports.getSellerCardData = (0, _reselect.createSelector)([globalStateSelector, idSelector], function (state, sellerId) {
    var seller = (0, _seller.getSeller)(state, sellerId);
    var catalogCounts = (0, _sellerCatalogCounts.getSellerCatalogCounts)(state, sellerId);
    return { catalogCounts: catalogCounts, seller: seller };
});

var getSellerCardDatas = exports.getSellerCardDatas = (0, _reselect.createSelector)([globalStateSelector, idSelector], function (state, sellerIds) {
    return sellerIds.map(function (id) {
        return getSellerCardData(state, id);
    });
});

/***/ }),

/***/ "6QU5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CatalogAdRemote = undefined;

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _helpers = __webpack_require__("SY39");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CatalogAdRemote = exports.CatalogAdRemote = {
    fetchCatalogAd: function fetchCatalogAd(_ref) {
        var authToken = _ref.authToken,
            categoryIds = _ref.categoryIds,
            deployment = _ref.deployment,
            keywords = _ref.keywords,
            pageName = _ref.pageName;
        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makePost)('<ITEM-API>spa/ads/page', deployment);
            request.send({ categoryIds: categoryIds, keywords: keywords, pageName: pageName });
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response });
            });
        });
    }
};

/***/ }),

/***/ "6Sk3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SaveSearchRemote = undefined;

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

var _stringify = __webpack_require__("mvHQ");

var _stringify2 = _interopRequireDefault(_stringify);

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _helpers = __webpack_require__("SY39");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SaveSearchRemote = exports.SaveSearchRemote = {
    deleteSavedSearch: function deleteSavedSearch(_ref) {
        var authToken = _ref.authToken,
            deployment = _ref.deployment,
            savedSearchId = _ref.savedSearchId;
        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makeDelete)('<SAVED-SEARCH-API>searches/' + savedSearchId, deployment);
            (0, _helpers.addAuthToken)(request, authToken);
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response });
            });
        });
    },
    fetchSavedSearches: function fetchSavedSearches(_ref2) {
        var authToken = _ref2.authToken,
            deployment = _ref2.deployment;
        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makeGet)('<ITEM-API>savedsearch/searches', deployment);
            (0, _helpers.addAuthToken)(request, authToken);
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response });
            });
        });
    },
    fetchSavedSearchItems: function fetchSavedSearchItems(_ref3) {
        var authToken = _ref3.authToken,
            deployment = _ref3.deployment;
        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makeGet)('<ITEM-API>savedsearch/items', deployment);
            (0, _helpers.addAuthToken)(request, authToken);
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response });
            });
        });
    },
    postDeleteSavedSearches: function postDeleteSavedSearches(_ref4) {
        var authToken = _ref4.authToken,
            deployment = _ref4.deployment,
            savedSearchIds = _ref4.savedSearchIds;
        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makePost)('<ITEM-API>savedsearch/delete', deployment);
            (0, _helpers.addAuthToken)(request, authToken);
            request.send({ ids: savedSearchIds });
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response });
            });
        });
    },
    postIsSavedSearch: function postIsSavedSearch(_ref5) {
        var authToken = _ref5.authToken,
            deployment = _ref5.deployment,
            searchParams = _ref5.searchParams;
        return new _promise2.default(function (resolve, reject) {
            var encodedSearch = encodeURIComponent((0, _stringify2.default)(searchParams));
            var request = (0, _helpers.makePost)('<SAVED-SEARCH-API>searches/' + encodedSearch, deployment);
            (0, _helpers.addAuthToken)(request, authToken);
            request.send(encodedSearch);
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response, success404: true });
            });
        });
    },
    postSaveSearch: function postSaveSearch(_ref6) {
        var authToken = _ref6.authToken,
            deployment = _ref6.deployment,
            searchParams = _ref6.searchParams,
            sendalert = _ref6.sendalert;
        return new _promise2.default(function (resolve, reject) {
            var facets = (0, _extends3.default)({}, searchParams);
            var request = (0, _helpers.makePost)('<SAVED-SEARCH-API>searches', deployment);
            (0, _helpers.addAuthToken)(request, authToken);
            request.send({ facets: facets, sendalert: sendalert });
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response });
            });
        });
    },
    postSubscribeToSavedSearches: function postSubscribeToSavedSearches(_ref7) {
        var authToken = _ref7.authToken,
            deployment = _ref7.deployment,
            savedSearchIds = _ref7.savedSearchIds;
        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makePost)('<ITEM-API>savedsearch/subscribe', deployment);
            (0, _helpers.addAuthToken)(request, authToken);
            request.send({ ids: savedSearchIds });
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response });
            });
        });
    },
    postUnsubscribeFromSavedSearches: function postUnsubscribeFromSavedSearches(_ref8) {
        var authToken = _ref8.authToken,
            deployment = _ref8.deployment,
            savedSearchIds = _ref8.savedSearchIds;
        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makePost)('<ITEM-API>savedsearch/unsubscribe', deployment);
            (0, _helpers.addAuthToken)(request, authToken);
            request.send({ ids: savedSearchIds });
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response });
            });
        });
    }
};

/***/ }),

/***/ "6Sy9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = __webpack_require__("dcb+");

var _jsx3 = _interopRequireDefault(_jsx2);

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Polyfill for webpack, just in case
if (false) require.ensure = function (d, c) {
    c(require);
};

var AddCreditCardModalLoader = function (_Component) {
    (0, _inherits3.default)(AddCreditCardModalLoader, _Component);

    function AddCreditCardModalLoader(props, context) {
        (0, _classCallCheck3.default)(this, AddCreditCardModalLoader);

        var _this = (0, _possibleConstructorReturn3.default)(this, (AddCreditCardModalLoader.__proto__ || (0, _getPrototypeOf2.default)(AddCreditCardModalLoader)).call(this, props, context));

        _this.state = {
            Component: null,
            mounted: false
        };
        return _this;
    }

    (0, _createClass3.default)(AddCreditCardModalLoader, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            var _this2 = this;

            return new _promise2.default(function (resolve) {
                __webpack_require__.e/* require.ensure */(20).then((function () {
                    resolve(__webpack_require__("JDBM"));
                }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            }).then(function (container) {
                _this2.setState({ Component: container });
            });
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.setState({ mounted: true });
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.setState({ mounted: false });
        }
    }, {
        key: 'render',
        value: function render() {
            var _state = this.state,
                Component = _state.Component,
                mounted = _state.mounted;

            return mounted && Component !== null ? (0, _jsx3.default)(Component, {}) : null;
        }
    }]);
    return AddCreditCardModalLoader;
}(_react.Component);

exports.default = AddCreditCardModalLoader;
module.exports = exports['default'];

/***/ }),

/***/ "6VmH":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getTestItemsForCatalog = exports.addTestItemsToCatalog = exports.getTestItem = exports.getTestCatalog = exports.getTestSeller = exports.getTestBidIncrementForCatalog = exports.getTestBiddingInfoForItem = exports.getTestItemFacets = exports.getTestCatalogDetails = exports.getTestItemDetails = exports.getTestBidHistory = exports.mockSimilarItems = exports.mockItems = exports.mockBiddingInfos = undefined;

var _find = __webpack_require__("kbi+");

var _find2 = _interopRequireDefault(_find);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mockBiddingInfos = exports.mockBiddingInfos = [];
var mockBidHistories = [];
var mockBidIncrements = [];
var mockCatalogs = [];
var mockCatalogDetails = [];
var mockItemDetails = [];
var mockItemFacets = [];
var mockItems = exports.mockItems = [];
var mockSellers = [];
var mockSimilarItems = exports.mockSimilarItems = [{
    itemId: 32543804,
    similarItems: [32544155, 32544156, 32544355, 32544356, 32544357, 32544358]
}];

var lastId = 1000;
/* eslint-disable-next-line no-plusplus */
var getRandomId = function getRandomId() {
    return ++lastId;
};

var generateTestBidHistory = function generateTestBidHistory() {
    var itemId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

    if (itemId === 0) {
        itemId = getRandomId();
    }
    var data = {
        history: [{
            amount: 200,
            bidderId: 0,
            currency: 'USD',
            source: 'Competing Bid'
        }, {
            amount: 100,
            bidderId: 0,
            currency: 'USD',
            source: 'Competing Bid'
        }],
        itemId: itemId
    };
    mockBidHistories.push(data);
    return data;
};

var getTestBidHistory = exports.getTestBidHistory = function getTestBidHistory(itemId) {
    var data = (0, _find2.default)(mockBidHistories, function (x) {
        return x.itemId === itemId;
    });
    if (data) {
        return data;
    }
    return generateTestBidHistory(itemId);
};

var generateTestItemDetail = function generateTestItemDetail() {
    var itemId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

    if (itemId === 0) {
        itemId = getRandomId();
    }
    var data = {
        description: 'Test item description.',
        itemId: itemId
    };
    mockItemDetails.push(data);
    return data;
};

var getTestItemDetails = exports.getTestItemDetails = function getTestItemDetails(itemId) {
    var data = (0, _find2.default)(mockItemDetails, function (x) {
        return x.itemId === itemId;
    });
    if (data) {
        return data;
    }
    return generateTestItemDetail(itemId);
};

var generateTestCatalogDetail = function generateTestCatalogDetail() {
    var catalogId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

    if (catalogId === 0) {
        catalogId = getRandomId();
    }
    var data = {
        catalogId: catalogId,
        customTerms: [],
        terms: 'Test terms.'
    };
    mockCatalogDetails.push(data);
    return data;
};

var getTestCatalogDetails = exports.getTestCatalogDetails = function getTestCatalogDetails(catalogId) {
    var data = (0, _find2.default)(mockCatalogDetails, function (x) {
        return x.catalogId === catalogId;
    });
    if (data) {
        return data;
    }
    return generateTestCatalogDetail(catalogId);
};

var generateTestItemFacets = function generateTestItemFacets() {
    var itemId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

    if (itemId === 0) {
        itemId = getRandomId();
    }
    var data = {
        categories: ['Paintings'],
        creators: [],
        itemId: itemId,
        materialsTechniques: ['Canvas', 'Oil'],
        origins: [],
        stylePeriods: []
    };
    mockItemFacets.push(data);
    return data;
};

var getTestItemFacets = exports.getTestItemFacets = function getTestItemFacets(itemId) {
    var data = (0, _find2.default)(mockItemFacets, function (x) {
        return x.itemId === itemId;
    });
    if (data) {
        return data;
    }
    return generateTestItemFacets(itemId);
};

var generateTestBiddingInfoForItem = function generateTestBiddingInfoForItem() {
    var itemId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

    if (itemId === 0) {
        itemId = getRandomId();
    }
    var data = {
        bidActivityCount: 0,
        bidCount: 0,
        bidderBidTimestamp: 0,
        bidderHasBid: false,
        bidderHasHighBid: false,
        bidderMaxBid: 0,
        isReserveMet: true,
        itemId: itemId,
        leadingBid: 0
    };
    mockBiddingInfos.push(data);
    return data;
};

var getTestBiddingInfoForItem = exports.getTestBiddingInfoForItem = function getTestBiddingInfoForItem(itemId) {
    var data = (0, _find2.default)(mockBiddingInfos, function (x) {
        return x.itemId === itemId;
    });
    if (data) {
        return data;
    }
    return generateTestBiddingInfoForItem(itemId);
};

var generateTestBidIncrementForCatalog = function generateTestBidIncrementForCatalog() {
    var catalogId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

    if (catalogId === 0) {
        catalogId = getRandomId();
    }
    var data = {
        bidIncrements: [{ fromAmount: 0, incAmount: 1 }, { fromAmount: 30, incAmount: 2 }, { fromAmount: 100, incAmount: 5 }, { fromAmount: 500, incAmount: 10 }],
        catalogId: catalogId
    };
    mockBidIncrements.push(data);
    return data;
};

var getTestBidIncrementForCatalog = exports.getTestBidIncrementForCatalog = function getTestBidIncrementForCatalog(catalogId) {
    var data = (0, _find2.default)(mockBidIncrements, function (x) {
        return x.catalogId === catalogId;
    });
    if (data) {
        return data;
    }
    return generateTestBidIncrementForCatalog(catalogId);
};

var generateTestSeller = function generateTestSeller() {
    var sellerId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

    if (sellerId === 0) {
        sellerId = getRandomId();
    }
    var data = {
        address: 'Proshyan',
        address2: '',
        alias: 'arman-antiques-and-co',
        city: 'Yerervan',
        country: 'Armenia',
        countryCode: 'am',
        description: 'We are a multi-dealer shop dealing in antiques and collectibles.\r\n\r\nRussian, Asian, European Art and Decorative Art represented.',
        email: '2334_contact@liveauctioneers.com',
        logoId: 'armanantiques',
        name: 'Arman Antiques & Co',
        phoneNumber: '37491325310',
        regionCode: 'europe',
        sellerId: sellerId,
        stateCode: '',
        stateName: 'other',
        website: 'http://www.armandantiques.jimdo.com/',
        zip: '12'
    };
    mockSellers.push(data);
    return data;
};

var getTestSeller = exports.getTestSeller = function getTestSeller(sellerId) {
    var data = (0, _find2.default)(mockSellers, function (x) {
        return x.sellerId === sellerId;
    });
    if (data) {
        return data;
    }
    return generateTestSeller(sellerId);
};

var generateTestCatalog = function generateTestCatalog() {
    var catalogId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var sellerId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

    if (catalogId === 0) {
        catalogId = getRandomId();
    }
    if (sellerId === 0) {
        sellerId = getRandomId();
    }
    getTestSeller(sellerId);

    var catalog = {
        buyersPremium: {
            high: null,
            low: 0,
            lowCutoff: null,
            middle: null,
            middleCutoff: null
        },
        catalogId: catalogId,
        catalogStatus: 'live',
        currency: 'USD',
        description: 'Testing Follow Search Stuff',
        lotsListed: 50,
        paymentOptions: {
            'po-moneyorderaccepted': 'on',
            'po-wireaccepted': 'on',
            'so-shipwhere': 'worldwide',
            'sp-buyerpaysshippingactual': 'on'
        },
        preview: '',
        saleStartTs: 1460163600,
        sellerId: sellerId,
        title: 'Testing Follow Search'
    };
    mockCatalogs.push(catalog);
    return catalog;
};

var getTestCatalog = exports.getTestCatalog = function getTestCatalog(catalogId, sellerId) {
    var data = (0, _find2.default)(mockCatalogs, function (x) {
        return x.catalogId === catalogId;
    });
    if (data) {
        return data;
    }
    return generateTestCatalog(catalogId, sellerId);
};

var generateTestItem = function generateTestItem() {
    var itemId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var catalogId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var sellerId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

    if (itemId === 0) {
        itemId = getRandomId();
    }
    if (catalogId === 0) {
        catalogId = getRandomId();
    }
    if (sellerId === 0) {
        sellerId = getRandomId();
    }
    getTestBiddingInfoForItem(itemId);
    getTestCatalog(catalogId);
    getTestSeller(sellerId);
    var item = {
        catalogId: catalogId,
        conditionReport: 'Good',
        highBidEstimate: 1200,
        imageVersion: 1451943886,
        isAvailable: true,
        isLocked: false,
        isPassed: false,
        isSold: false,
        itemId: itemId,
        lotNumber: '0016',
        lowBidEstimate: 100,
        photos: [1],
        salePrice: 0,
        sellerId: sellerId,
        soldType: 0,
        startPrice: 100,
        title: '20th + japanese + wedding + kimono'
    };
    mockItems.push(item);
    return item;
};

var getTestItem = exports.getTestItem = function getTestItem(itemId, catalogId, sellerId) {
    var data = (0, _find2.default)(mockItems, function (x) {
        return x.itemId === itemId;
    });
    if (data) {
        return data;
    }
    return generateTestItem(itemId, catalogId, sellerId);
};

var addTestItemsToCatalog = exports.addTestItemsToCatalog = function addTestItemsToCatalog(catalogId, count) {
    // eslint-disable-next-line no-plusplus
    for (var i = 0; i < count; i++) {
        getTestItem(0, catalogId);
    }
};

var getTestItemsForCatalog = exports.getTestItemsForCatalog = function getTestItemsForCatalog(catalogId) {
    var items = mockItems.filter(function (x) {
        return x.catalogId === catalogId;
    });
    if (items.length < 100) {
        addTestItemsToCatalog(catalogId, 100);
    }
    items = mockItems.filter(function (x) {
        return x.catalogId === catalogId;
    });
    return items;
};

/***/ }),

/***/ "6f2F":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _analytics = __webpack_require__("yxCd");

var _propsComparer = __webpack_require__("wsGv");

var _propsComparer2 = _interopRequireDefault(_propsComparer);

var _redux = __webpack_require__("2KeS");

var _react = __webpack_require__("GiK3");

var _reactRedux = __webpack_require__("RH2O");

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SegmentTracker = (_dec = (0, _reactRedux.connect)(function (state) {
    return {
        attributionData: (0, _analytics.getAttributionData)(state)
    };
}, function (dispatch) {
    return (0, _redux.bindActionCreators)({
        recordAttributionAnalytics: _analytics.recordAttributionAnalytics
    }, dispatch);
}), _dec(_class = function (_Component) {
    (0, _inherits3.default)(SegmentTracker, _Component);

    function SegmentTracker() {
        (0, _classCallCheck3.default)(this, SegmentTracker);
        return (0, _possibleConstructorReturn3.default)(this, (SegmentTracker.__proto__ || (0, _getPrototypeOf2.default)(SegmentTracker)).apply(this, arguments));
    }

    (0, _createClass3.default)(SegmentTracker, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.props.recordAttributionAnalytics(this.props.attributionData);
        }
    }, {
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps) {
            return (0, _propsComparer2.default)(this.props, nextProps, ['attributionData']);
        }
    }, {
        key: 'render',
        value: function render() {
            return null;
        }
    }]);
    return SegmentTracker;
}(_react.Component)) || _class);
exports.default = SegmentTracker;
module.exports = exports['default'];

/***/ }),

/***/ "6oKK":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toggleItemSave = exports.isItemSaved = exports.getSortedSavedItemIdsFromState = exports.getSavedItem = exports.UNSAVE_ITEM_SUCCESS = exports.UNSAVE_ITEM_REQUEST = exports.UNSAVE_ITEM_FAIL = exports.SAVE_ITEM_SUCCESS = exports.SAVE_ITEM_REQUEST = exports.SAVE_ITEM_FAIL = undefined;

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _keys = __webpack_require__("fZjL");

var _keys2 = _interopRequireDefault(_keys);

exports.default = reducer;

var _item = __webpack_require__("Gk4U");

var _user = __webpack_require__("CFLi");

var _analytics = __webpack_require__("yxCd");

var _api = __webpack_require__("zFQO");

var _cloneDeep = __webpack_require__("kvU2");

var _cloneDeep2 = _interopRequireDefault(_cloneDeep);

var _reselect = __webpack_require__("bndy");

var _config = __webpack_require__("iS9E");

var _isEmpty = __webpack_require__("lHK6");

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _login = __webpack_require__("SpFG");

var _passwordReset = __webpack_require__("fWpZ");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Action Types */
var SAVE_ITEM_FAIL = exports.SAVE_ITEM_FAIL = 'la/user/saveItem/FAIL';
var SAVE_ITEM_REQUEST = exports.SAVE_ITEM_REQUEST = 'la/user/saveItem/REQUEST';
var SAVE_ITEM_SUCCESS = exports.SAVE_ITEM_SUCCESS = 'la/user/saveItem/SUCCESS';

var UNSAVE_ITEM_FAIL = exports.UNSAVE_ITEM_FAIL = 'la/user/unsaveItem/FAIL';
var UNSAVE_ITEM_REQUEST = exports.UNSAVE_ITEM_REQUEST = 'la/user/unsaveItem/REQUEST';
var UNSAVE_ITEM_SUCCESS = exports.UNSAVE_ITEM_SUCCESS = 'la/user/unsaveItem/SUCCESS';

// reducer
var DEFAULT_STATE = {};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var existing = void 0;

    switch (action.type) {
        case _user.LOAD_BIDDER_DATA_SUCCESS:
        case _login.LOGIN_SUCCESS:
        case _passwordReset.PASSWORD_RESET_SUCCESS:
            existing = {};
            if (action.payload.savedItemsTime) {
                action.payload.savedItemsTime.forEach(function (item) {
                    existing[item.itemId] = { itemId: Number(item.itemId), saveTs: item.saveTs };
                    existing[item.itemId].status = 'SAVED';
                });
            }
            return existing;

        case _user.LOG_OUT_BIDDER:
            // reset saved Items to defaults
            return DEFAULT_STATE;

        case SAVE_ITEM_FAIL:
            existing = (0, _cloneDeep2.default)(state);
            delete existing[action.meta.itemId];
            return existing;

        case UNSAVE_ITEM_REQUEST:
            existing = (0, _cloneDeep2.default)(state);
            existing[action.payload].status = 'REMOVED';
            return existing;

        case UNSAVE_ITEM_SUCCESS:
            return state;

        case SAVE_ITEM_REQUEST:
            existing = (0, _cloneDeep2.default)(state);
            existing[action.payload.itemId] = {
                itemId: action.payload.itemId,
                saveTs: action.payload.saveTs,
                status: 'SAVED'
            };
            return existing;

        case SAVE_ITEM_SUCCESS:
            return state;

        case UNSAVE_ITEM_FAIL:
            existing = (0, _cloneDeep2.default)(state);
            existing[action.meta.itemId].status = 'SAVED';
            return existing;

        default:
            return state;
    }
}

/* SELECTORS */
var saveItemSelector = function saveItemSelector(state) {
    return state.user.saveItem;
};
var idSelector = function idSelector(state, id) {
    return id;
};

var savedItemsSelector = (0, _reselect.createSelector)(saveItemSelector, function (saveItems) {
    return saveItems;
});

var getSavedItem = exports.getSavedItem = (0, _reselect.createSelector)([savedItemsSelector, idSelector], function (savedItems, id) {
    return savedItems[id] || {};
});

var getSortedSavedItemIdsFromState = exports.getSortedSavedItemIdsFromState = (0, _reselect.createSelector)(savedItemsSelector, function (savedItems) {
    var toBeSorted = (0, _keys2.default)(savedItems).map(function (item) {
        return savedItems[item];
    });
    var sorted = toBeSorted.sort(function (a, b) {
        return b.saveTs - a.saveTs;
    });
    return sorted.map(function (item) {
        return item.itemId;
    });
});

var isItemSaved = exports.isItemSaved = (0, _reselect.createSelector)(getSavedItem, function (savedItem) {
    return savedItem.status === 'SAVED';
});

/* ACTION CREATORS */
var saveItemFail = function saveItemFail(itemId, error) {
    return {
        error: true,
        meta: { itemId: itemId },
        payload: error,
        type: SAVE_ITEM_FAIL
    };
};

var saveItemRequest = function saveItemRequest(itemId) {
    return {
        payload: { itemId: itemId, saveTs: Date.now() },
        type: SAVE_ITEM_REQUEST
    };
};

var saveItemSuccess = function saveItemSuccess(itemId, savedItemAnalytics) {
    return {
        meta: savedItemAnalytics,
        payload: itemId,
        type: SAVE_ITEM_SUCCESS
    };
};

var submitSaveItem = function submitSaveItem(itemId) {
    return function (dispatch, getState) {
        var state = getState();
        var authToken = (0, _user.getAuthToken)(state);
        var deployment = (0, _config.getDeployment)(state);
        dispatch(saveItemRequest(itemId));
        return _api.SaveItem.postSaveItem({ authToken: authToken, deployment: deployment, itemId: itemId }).then(function () {
            var promises = [];
            if ((0, _isEmpty2.default)((0, _item.getItem)(state, itemId))) {
                promises.push(dispatch((0, _item.fetchItemsIfNeeded)([itemId])));
            }
            return _promise2.default.all(promises).then(function () {
                var newState = getState();
                var savedItemAnalytics = (0, _analytics.getSaveItemAnalytics)(newState, itemId);
                dispatch(saveItemSuccess(itemId, savedItemAnalytics));
            });
        }).catch(function (error) {
            dispatch(saveItemFail(itemId, error));
        });
    };
};

var unsaveItemFail = function unsaveItemFail(itemId, error) {
    return {
        error: true,
        meta: { itemId: itemId },
        payload: error,
        type: UNSAVE_ITEM_FAIL
    };
};

var unsaveItemRequest = function unsaveItemRequest(itemId) {
    return {
        payload: itemId,
        type: UNSAVE_ITEM_REQUEST
    };
};

var unsaveItemSuccess = function unsaveItemSuccess(itemId, unsavedItemAnalytics) {
    return {
        meta: unsavedItemAnalytics,
        payload: itemId,
        type: UNSAVE_ITEM_SUCCESS
    };
};

var submitUnsaveItem = function submitUnsaveItem(itemId) {
    return function (dispatch, getState) {
        var state = getState();
        var authToken = (0, _user.getAuthToken)(state);
        var deployment = (0, _config.getDeployment)(state);
        dispatch(unsaveItemRequest(itemId));
        return _api.SaveItem.postUnsaveItem({ authToken: authToken, deployment: deployment, itemId: itemId }).then(function () {
            var promises = [];
            if ((0, _isEmpty2.default)((0, _item.getItem)(state, itemId))) {
                promises.push(dispatch((0, _item.fetchItemsIfNeeded)([itemId])));
            }
            return _promise2.default.all(promises).then(function () {
                var unsavedItemAnalytics = (0, _analytics.getUnsaveItemAnalytics)(getState(), itemId);
                dispatch(unsaveItemSuccess(itemId, unsavedItemAnalytics));
            });
        }).catch(function (error) {
            dispatch(unsaveItemFail(itemId, error));
        });
    };
};

var toggleItemSave = exports.toggleItemSave = function toggleItemSave(itemId) {
    return function (dispatch, getState) {
        if (isItemSaved(getState(), itemId)) {
            return dispatch(submitUnsaveItem(itemId));
        } else {
            return dispatch(submitSaveItem(itemId));
        }
    };
};

/***/ }),

/***/ "6t9d":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SearchRemote = undefined;

var _stringify = __webpack_require__("mvHQ");

var _stringify2 = _interopRequireDefault(_stringify);

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _helpers = __webpack_require__("SY39");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SearchRemote = exports.SearchRemote = {
    // this is search ... need to adjust to use the category landing page endpoint
    fetchCategoryResults: function fetchCategoryResults(_ref) {
        var deployment = _ref.deployment,
            ids = _ref.ids,
            searchQuery = _ref.searchQuery;
        return new _promise2.default(function (resolve, reject) {
            var encodedParams = encodeURIComponent((0, _stringify2.default)(searchQuery));
            var encodedIds = encodeURIComponent((0, _stringify2.default)(ids));
            var request = (0, _helpers.makeGet)('<SEARCH-API>?ids=' + encodedIds + '&parameters=' + encodedParams, deployment, 'categoryweb');
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response });
            });
        });
    },
    fetchSearchFacetsResults: function fetchSearchFacetsResults(_ref2) {
        var deployment = _ref2.deployment,
            searchQuery = _ref2.searchQuery;
        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makeGet)('<SEARCH-API>?parameters=' + encodeURIComponent((0, _stringify2.default)(searchQuery)), deployment, 'faceted');
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response });
            });
        });
    },
    fetchSearchResults: function fetchSearchResults(_ref3) {
        var deployment = _ref3.deployment,
            searchQuery = _ref3.searchQuery;
        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makeGet)('<SEARCH-API>?parameters=' + encodeURIComponent((0, _stringify2.default)(searchQuery)), deployment, 'web');
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response });
            });
        });
    }
};

/***/ }),

/***/ "795h":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _bidIncrements = __webpack_require__("5A1c");

var BidIncrements = {
    fetchBidIncrements: _bidIncrements.BidIncrementsRemote.fetchBidIncrements
};

exports.default = BidIncrements;
module.exports = exports['default'];

/***/ }),

/***/ "7IsP":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.submitSendSellerMessage = exports.getUiSendSellerMessage = exports.SEND_SELLER_MESSAGE_SUCCESS = exports.SEND_SELLER_MESSAGE_REQUEST = exports.SEND_SELLER_MESSAGE_FAIL = undefined;

var _regenerator = __webpack_require__("Xxa5");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__("exGp");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;

var _modal = __webpack_require__("u90i");

var _api = __webpack_require__("zFQO");

var _reselect = __webpack_require__("bndy");

var _user = __webpack_require__("CFLi");

var _config = __webpack_require__("iS9E");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Action Types */
var SEND_SELLER_MESSAGE_FAIL = exports.SEND_SELLER_MESSAGE_FAIL = 'la/ui/sendSellerMessage/FAIL';
var SEND_SELLER_MESSAGE_REQUEST = exports.SEND_SELLER_MESSAGE_REQUEST = 'la/ui/sendSellerMessage/REQUEST';
var SEND_SELLER_MESSAGE_SUCCESS = exports.SEND_SELLER_MESSAGE_SUCCESS = 'la/ui/sendSellerMessage/SUCCESS';

// reducer
var DEFAULT_STATE = {
    error: false,
    submitted: false,
    success: false
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        case _modal.OPEN_SEND_SELLER_CONSIGNMENT_MESSAGE_MODAL:
        case _modal.OPEN_SEND_SELLER_MESSAGE_MODAL:
            return (0, _extends3.default)({}, state, {
                messageDetails: action.payload.messageDetails,
                sellerId: action.payload.sellerId,
                sellerName: action.payload.sellerName,
                subject: action.payload.subject,
                title: action.payload.title
            });
        case SEND_SELLER_MESSAGE_REQUEST:
            return (0, _extends3.default)({}, state, {
                error: false,
                submitted: true,
                success: false
            });
        case _modal.DISMISS_MODAL:
            return (0, _extends3.default)({}, state, {
                success: false
            });
        case SEND_SELLER_MESSAGE_SUCCESS:
            return (0, _extends3.default)({}, state, {
                submitted: false,
                success: true
            });
        case SEND_SELLER_MESSAGE_FAIL:
            return (0, _extends3.default)({}, state, {
                error: true,
                submitted: false,
                success: false
            });
        default:
            return state;
    }
}

/* SELECTORS */
var stateSelector = function stateSelector(state) {
    return state.ui.sendSellerMessage;
};

var getUiSendSellerMessage = exports.getUiSendSellerMessage = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state;
});

/* ACTION CREATORS */
var submitSendSellerMessage = exports.submitSendSellerMessage = function submitSendSellerMessage(messageDetails) {
    return function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch, getState) {
            var state, authToken, deployment, response;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.prev = 0;
                            state = getState();
                            authToken = (0, _user.getAuthToken)(state);
                            deployment = (0, _config.getDeployment)(state);

                            dispatch({
                                type: SEND_SELLER_MESSAGE_REQUEST
                            });
                            _context.next = 7;
                            return _api.Seller.postMessage({ authToken: authToken, deployment: deployment, messageDetails: messageDetails });

                        case 7:
                            response = _context.sent;

                            dispatch({
                                payload: response,
                                type: SEND_SELLER_MESSAGE_SUCCESS
                            });
                            _context.next = 14;
                            break;

                        case 11:
                            _context.prev = 11;
                            _context.t0 = _context['catch'](0);

                            dispatch({
                                error: true,
                                payload: _context.t0,
                                type: SEND_SELLER_MESSAGE_FAIL
                            });

                        case 14:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, undefined, [[0, 11]]);
        }));

        return function (_x3, _x4) {
            return _ref.apply(this, arguments);
        };
    }();
};

/***/ }),

/***/ "7bCi":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.formatDate = exports.useMinutes = exports.useHours = exports.useDays = exports.displayYearInDate = exports.showCountDownBasedOnMinimumDate = undefined;
exports.getCountDown = getCountDown;

var _momentTimezone = __webpack_require__("xNPZ");

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

__webpack_require__("SdwT");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var COUNTDOWN_CUTOFF_DAYS_HIGH = 7;
var COUNTDOWN_CUTOFF_DAYS_LOW = 2;
var COUNTDOWN_CUTOFF_HOURS_HIGH = 48;
var COUNTDOWN_CUTOFF_HOURS_LOW = 1;
var COUNTDOWN_CUTOFF_MINUTES = 59;

var showCountDownBasedOnMinimumDate = exports.showCountDownBasedOnMinimumDate = function showCountDownBasedOnMinimumDate(auctionDate) {
    var now = (0, _momentTimezone2.default)();
    var upcoming = _momentTimezone2.default.unix(auctionDate).tz(_momentTimezone2.default.tz.guess());
    var totalDays = upcoming.diff(now, 'days', true);

    if (totalDays <= COUNTDOWN_CUTOFF_DAYS_HIGH) {
        return true;
    }
    return false;
};

var displayYearInDate = exports.displayYearInDate = function displayYearInDate(now, upcoming) {
    if (now.year() !== upcoming.year() || now > upcoming) {
        return true;
    }
    return false;
};

var useDays = exports.useDays = function useDays(now, upcoming) {
    var totalDaysUntil = upcoming.diff(now, 'days', true);

    if (totalDaysUntil > COUNTDOWN_CUTOFF_DAYS_LOW && totalDaysUntil <= COUNTDOWN_CUTOFF_DAYS_HIGH) {
        return true;
    }
    return false;
};

var useHours = exports.useHours = function useHours(now, upcoming) {
    var totalHours = upcoming.diff(now, 'hours', true);

    if (totalHours <= COUNTDOWN_CUTOFF_HOURS_HIGH && totalHours >= COUNTDOWN_CUTOFF_HOURS_LOW) {
        return true;
    }
    return false;
};

var useMinutes = exports.useMinutes = function useMinutes(now, upcoming) {
    var totalMins = upcoming.diff(now, 'minutes', true);

    if (totalMins > 0 && totalMins <= COUNTDOWN_CUTOFF_MINUTES) {
        return true;
    }
    return false;
};

var formatDate = exports.formatDate = function formatDate(date) {
    return date.replace(/(\b\w)/gi, function (m) {
        return m.toUpperCase();
    });
};

function getCountDown(auctionDate) {
    var now = (0, _momentTimezone2.default)();
    var upcoming = _momentTimezone2.default.unix(auctionDate).tz(_momentTimezone2.default.tz.guess());
    var countDown = false;

    var dateFormat = displayYearInDate(now, upcoming) ? upcoming.format('MMM D, YYYY') : upcoming.format('MMM D');
    if (useDays(now, upcoming)) {
        var duration = _momentTimezone2.default.duration(upcoming.diff(now), 'ms');
        dateFormat = duration.format('d [days]');
        dateFormat = formatDate(dateFormat);
        countDown = true;
    } else if (useHours(now, upcoming)) {
        var _duration = _momentTimezone2.default.duration(upcoming.diff(now), 'ms');
        dateFormat = _duration.format('h [hours]');
        dateFormat = formatDate(dateFormat);
        countDown = true;
    } else if (useMinutes(now, upcoming)) {
        var _duration2 = _momentTimezone2.default.duration(upcoming.diff(now), 'ms');
        dateFormat = _duration2.format('m [mins]');
        dateFormat = formatDate(dateFormat);
        countDown = true;
    }

    return {
        countDown: countDown,
        dateFormat: dateFormat
    };
}

/***/ }),

/***/ "7oIq":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = __webpack_require__("dcb+");

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propsComparer = __webpack_require__("wsGv");

var _propsComparer2 = _interopRequireDefault(_propsComparer);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _NoResults = __webpack_require__("E6Dt");

var _NoResults2 = _interopRequireDefault(_NoResults);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NoResults = function (_Component) {
    (0, _inherits3.default)(NoResults, _Component);

    function NoResults() {
        (0, _classCallCheck3.default)(this, NoResults);
        return (0, _possibleConstructorReturn3.default)(this, (NoResults.__proto__ || (0, _getPrototypeOf2.default)(NoResults)).apply(this, arguments));
    }

    (0, _createClass3.default)(NoResults, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps) {
            return (0, _propsComparer2.default)(this.props, nextProps, ['children']);
        }
    }, {
        key: 'render',
        value: function render() {
            var children = this.props.children;

            return (0, _jsx3.default)('div', {
                className: _NoResults2.default['no-results-container']
            }, void 0, children);
        }
    }]);
    return NoResults;
}(_react.Component);

exports.default = NoResults;
module.exports = exports['default'];

/***/ }),

/***/ "7oYi":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var pageSlicer = exports.pageSlicer = function pageSlicer(catalog, count) {
    var page = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;

    if (count === 'all' || typeof count === 'undefined') {
        return catalog;
    }
    var pages = Math.ceil(catalog.length / count);
    var currentPage = page;
    if (page > pages) {
        currentPage = pages;
    }
    var start = (currentPage - 1) * count;
    return catalog.slice(start, start + count);
};

/***/ }),

/***/ "8AIN":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

exports.default = isOnline;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isOnline() {
    var path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '/favicon.ico';

    // Handle IE and more capable browsers
    var xhr = new (window.ActiveXObject || XMLHttpRequest)('Microsoft.XMLHTTP');

    // Open new request as a HEAD to the root hostname with a random param to bust the cache
    xhr.open('HEAD', '//' + window.location.host + path + '?rand=' + Math.floor((1 + Math.random()) * 0x10000), true);

    // Issue request and handle response
    return new _promise2.default(function (resolve) {
        xhr.onreadystatechange = function () {
            if (xhr.readyState === 4) {
                if (xhr.status >= 200 && (xhr.status < 300 || xhr.status === 304)) {
                    return resolve(true);
                }
                resolve(false);
            }
        };
        xhr.send(null);
    });
}
module.exports = exports['default'];

/***/ }),

/***/ "8g7e":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"dropdown-menu":"dropdown-menu___3AXnA","title":"title___3NhcW","triangle":"triangle___2cjQJ","popover":"popover___2POSX","calendar":"calendar___zn6KH","dropdown-pop-up":"dropdown-pop-up___3FgF7"};

/***/ }),

/***/ "8kzA":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _coverLots = __webpack_require__("rF6g");

var CoverLots = {
    fetchCoverLots: _coverLots.CoverLotsRemote.fetchCoverLots
};

exports.default = CoverLots;
module.exports = exports['default'];

/***/ }),

/***/ "8lrs":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.sortSellers = exports.sortItems = exports.sortCatalogs = exports.getPriceFromCard = exports.filterSellerSearch = exports.filterItemSearch = exports.filterCatalogSearch = exports.filterEmptySellers = exports.filterEmptyItems = exports.filterEmptyCatalogs = exports.sellerSearchFilter = exports.itemSearchFilter = exports.catalogSearchFilter = exports.filterSellers = exports.filterItems = exports.filterCatalogs = exports.filterCatalogsByReg = exports.catalogApprovedFilter = exports.catalogDoneFilter = undefined;

var _toConsumableArray2 = __webpack_require__("Gu7T");

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _flow = __webpack_require__("rgi1");

var _flow2 = _interopRequireDefault(_flow);

var _catalogRegistration = __webpack_require__("uhYE");

var _isEmpty = __webpack_require__("lHK6");

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _orderBy = __webpack_require__("Ba3q");

var _orderBy2 = _interopRequireDefault(_orderBy);

var _pagination = __webpack_require__("7oYi");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Tab Filters
var catalogDoneFilter = exports.catalogDoneFilter = function catalogDoneFilter(wrapper, tab) {
    if (tab === 'ended') {
        return wrapper.catalog.catalogStatus === 'done';
    }
    return wrapper.catalog.catalogStatus !== 'done';
};

var catalogApprovedFilter = exports.catalogApprovedFilter = function catalogApprovedFilter(state, wrapper, tab) {
    var _getCatalogRegistrati = (0, _catalogRegistration.getCatalogRegistration)(state, wrapper.catalog.catalogId),
        approved = _getCatalogRegistrati.approved,
        pending = _getCatalogRegistrati.pending;

    if (tab === 'approved') {
        return approved;
    } else if (tab === 'pending') {
        return pending;
    }
    return false;
};

// Filter Functions
var filterCatalogsByReg = exports.filterCatalogsByReg = function filterCatalogsByReg(state, all) {
    var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
        count = _ref.count,
        page = _ref.page,
        sort = _ref.sort,
        tab = _ref.tab,
        terms = _ref.terms;

    var loaded = filterEmptyCatalogs(all);
    var tabbed = tab ? loaded.filter(function (x) {
        return catalogApprovedFilter(state, x, tab);
    }) : loaded;
    var sorted = sortCatalogs(tabbed, sort);
    var filtered = filterCatalogSearch(sorted, terms);

    return {
        filteredCount: filtered.length || 0,
        items: (0, _pagination.pageSlicer)(filtered, count, page) || [],
        loadedItemsCount: loaded.length,
        tabbedCount: tabbed.length || 0,
        totalCount: all.length || 0
    };
};

var filterCatalogs = exports.filterCatalogs = function filterCatalogs(all) {
    var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        count = _ref2.count,
        page = _ref2.page,
        sort = _ref2.sort,
        tab = _ref2.tab,
        terms = _ref2.terms;

    var loaded = filterEmptyCatalogs(all);
    var tabbed = tab ? loaded.filter(function (x) {
        return catalogDoneFilter(x, tab);
    }) : loaded;
    var sorted = sortCatalogs(tabbed, sort);
    var filtered = filterCatalogSearch(sorted, terms);

    return {
        filteredCount: filtered.length || 0,
        items: (0, _pagination.pageSlicer)(filtered, count, page) || [],
        loadedItemsCount: loaded.length,
        tabbedCount: tabbed.length || 0,
        totalCount: all.length || 0
    };
};

var filterItems = exports.filterItems = function filterItems(all) {
    var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        count = _ref3.count,
        page = _ref3.page,
        sort = _ref3.sort,
        tab = _ref3.tab,
        terms = _ref3.terms;

    var loaded = filterEmptyItems(all);
    var tabbed = tab ? loaded.filter(function (itemWrapper) {
        return catalogDoneFilter(itemWrapper, tab);
    }) : loaded;
    var sorted = sortItems(tabbed, sort);
    var filtered = filterItemSearch(sorted, terms);

    return {
        filteredCount: filtered.length || 0,
        items: (0, _pagination.pageSlicer)(filtered, count, page) || [],
        loadedItemsCount: loaded.length,
        tabbedCount: tabbed.length || 0,
        totalCount: all.length || 0
    };
};

var filterSellers = exports.filterSellers = function filterSellers(all) {
    var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        count = _ref4.count,
        page = _ref4.page,
        sort = _ref4.sort,
        terms = _ref4.terms;

    var loaded = filterEmptySellers(all);
    var sorted = sortSellers(loaded, sort);
    var filtered = filterSellerSearch(sorted, terms);

    return {
        filteredCount: filtered.length || 0,
        items: (0, _pagination.pageSlicer)(filtered, count, page) || [],
        loadedItemsCount: loaded.length,
        totalCount: all.length || 0
    };
};

// Search Filters
var catalogSearchFilter = exports.catalogSearchFilter = function catalogSearchFilter(wrapper, searchString) {
    var searchTokens = searchString.toLowerCase().trim().split(/\s/);
    var matchingTokens = searchTokens.filter(function (token) {
        if (!wrapper || !wrapper.catalog) return false;
        var _wrapper$catalog$titl = wrapper.catalog.title,
            title = _wrapper$catalog$titl === undefined ? '' : _wrapper$catalog$titl;

        return ('' + title).toLowerCase().includes(token);
    });
    var doesMatch = matchingTokens.length === searchTokens.length;
    return doesMatch;
};

var itemSearchFilter = exports.itemSearchFilter = function itemSearchFilter(wrapper, searchString) {
    var searchTokens = searchString.toLowerCase().trim().split(/\s/);
    var matchingTokens = searchTokens.filter(function (token) {
        if (!wrapper || !wrapper.item) return false;
        var _wrapper$item = wrapper.item,
            _wrapper$item$descrip = _wrapper$item.description,
            description = _wrapper$item$descrip === undefined ? '' : _wrapper$item$descrip,
            _wrapper$item$lotNumb = _wrapper$item.lotNumber,
            lotNumber = _wrapper$item$lotNumb === undefined ? '' : _wrapper$item$lotNumb,
            _wrapper$item$title = _wrapper$item.title,
            title = _wrapper$item$title === undefined ? '' : _wrapper$item$title;

        return (description + ' ' + lotNumber + ' ' + title).toLowerCase().includes(token);
    });
    var doesMatch = matchingTokens.length === searchTokens.length;
    return doesMatch;
};

var sellerSearchFilter = exports.sellerSearchFilter = function sellerSearchFilter(wrapper, searchString) {
    var searchTokens = searchString.toLowerCase().trim().split(/\s/);
    var matchingTokens = searchTokens.filter(function (token) {
        if (!wrapper || !wrapper.seller) return false;
        var _wrapper$seller$name = wrapper.seller.name,
            name = _wrapper$seller$name === undefined ? '' : _wrapper$seller$name;

        return ('' + name).toLowerCase().includes(token);
    });
    var doesMatch = matchingTokens.length === searchTokens.length;
    return doesMatch;
};

var filterEmptyCatalogs = exports.filterEmptyCatalogs = function filterEmptyCatalogs(list) {
    return list ? list.filter(function (x) {
        return !(0, _isEmpty2.default)(x.catalog) && x.catalog.catalogId;
    }) : [];
};

var filterEmptyItems = exports.filterEmptyItems = function filterEmptyItems(list) {
    return list ? list.filter(function (x) {
        return !(0, _isEmpty2.default)(x.item) && x.item.itemId;
    }) : [];
};

var filterEmptySellers = exports.filterEmptySellers = function filterEmptySellers(list) {
    return list ? list.filter(function (x) {
        return !(0, _isEmpty2.default)(x.seller) && x.seller.sellerId;
    }) : [];
};

var filterCatalogSearch = exports.filterCatalogSearch = function filterCatalogSearch(list, terms) {
    if (!list) {
        return [];
    }
    return terms ? list.filter(function (x) {
        return catalogSearchFilter(x, terms);
    }) : list;
};

var filterItemSearch = exports.filterItemSearch = function filterItemSearch(list, terms) {
    if (!list) {
        return [];
    }
    return terms ? list.filter(function (x) {
        return itemSearchFilter(x, terms);
    }) : list;
};

var filterSellerSearch = exports.filterSellerSearch = function filterSellerSearch(list, terms) {
    if (!list) {
        return [];
    }
    return terms ? list.filter(function (x) {
        return sellerSearchFilter(x, terms);
    }) : list;
};

// Sorting Functions
var orderByBidderBidTimeAscending = function orderByBidderBidTimeAscending(list) {
    return (0, _orderBy2.default)(list, ['biddingInfo.bidderBidTimestamp']);
};

var orderByBidderBidTimeDescending = function orderByBidderBidTimeDescending(list) {
    return (0, _orderBy2.default)(list, ['biddingInfo.bidderBidTimestamp'], ['desc']);
};

var orderByCatalogSaleStartAscending = function orderByCatalogSaleStartAscending(list) {
    return (0, _orderBy2.default)(list, ['catalog.saleStartTs']);
};

var orderByCatalogSaleStartDescending = function orderByCatalogSaleStartDescending(list) {
    return (0, _orderBy2.default)(list, ['catalog.saleStartTs'], ['desc']);
};

var orderByCatalogTitleAscending = function orderByCatalogTitleAscending(list) {
    return (0, _orderBy2.default)(list, [function (x) {
        return x.catalog.title.toLowerCase();
    }]);
};

// const orderByCatalogTitleDescending = list => {
//     return orderBy(list, [x => x.catalog.title.toLowerCase()], ['desc']);
// };

var orderByItemBidCountAscending = function orderByItemBidCountAscending(list) {
    return (0, _orderBy2.default)(list, ['biddingInfo.bidActivityCount']);
};

var orderByItemBidCountDescending = function orderByItemBidCountDescending(list) {
    return (0, _orderBy2.default)(list, ['biddingInfo.bidActivityCount'], ['desc']);
};

// const orderByItemHighBidEstimateAscending = list => {
//     return orderBy(list, ['item.highBidEstimate']);
// };

var orderByItemHighBidEstimateDescending = function orderByItemHighBidEstimateDescending(list) {
    return (0, _orderBy2.default)(list, ['item.highBidEstimate'], ['desc']);
};

var orderByItemLowBidEstimateAscending = function orderByItemLowBidEstimateAscending(list) {
    return (0, _orderBy2.default)(list, ['item.lowBidEstimate']);
};

// const orderByItemLowBidEstimateDescending = list => {
//     return orderBy(list, ['item.lowBidEstimate'], ['desc']);
// };

var orderByItemLotNumberAscending = function orderByItemLotNumberAscending(list) {
    return (0, _orderBy2.default)(list, [function (x) {
        return x.item.lotNumber.toLowerCase();
    }]);
};

var orderByItemLotNumberDescending = function orderByItemLotNumberDescending(list) {
    return (0, _orderBy2.default)(list, [function (x) {
        return x.item.lotNumber.toLowerCase();
    }], ['desc']);
};

var orderByItemTitleAscending = function orderByItemTitleAscending(list) {
    return (0, _orderBy2.default)(list, [function (x) {
        return x.item.title.toLowerCase();
    }]);
};

// const orderByItemTitleDescending = list => {
//     return orderBy(list, [x => x.item.title.toLowerCase()], ['desc']);
// };

var orderBySellerNameAscending = function orderBySellerNameAscending(list) {
    return (0, _orderBy2.default)(list, [function (x) {
        return x.seller.name.toLowerCase();
    }]);
};

var orderBySellerNameDescending = function orderBySellerNameDescending(list) {
    return (0, _orderBy2.default)(list, [function (x) {
        return x.seller.name.toLowerCase();
    }], ['desc']);
};

var getPriceFromCard = exports.getPriceFromCard = function getPriceFromCard(card) {
    if (card.item.isPassed) {
        return 0;
    }
    if (card.item.isSold) {
        return card.item.salePrice;
    }
    return card.biddingInfo.leadingBid || card.item.startPrice || 0;
};

var orderByItemPriceAscending = function orderByItemPriceAscending(list) {
    return (0, _orderBy2.default)(list, [getPriceFromCard]);
};

var orderByItemPriceDescending = function orderByItemPriceDescending(list) {
    return (0, _orderBy2.default)(list, [getPriceFromCard], ['desc']);
};

var orderBySaveSearchItemPublishTimeAscending = function orderBySaveSearchItemPublishTimeAscending(list) {
    return (0, _orderBy2.default)(list, ['savedSearch.publishTs']);
};

var orderBySaveSearchItemPublishTimeDescending = function orderBySaveSearchItemPublishTimeDescending(list) {
    return (0, _orderBy2.default)(list, ['savedSearch.publishTs'], ['desc']);
};

var orderByItemSaveTimeAscending = function orderByItemSaveTimeAscending(list) {
    return (0, _orderBy2.default)(list, ['savedItem.saveTs']);
};

var orderByItemSaveTimeDescending = function orderByItemSaveTimeDescending(list) {
    return (0, _orderBy2.default)(list, ['savedItem.saveTs'], ['desc']);
};

var orderByUpcomingCatalogCountAscending = function orderByUpcomingCatalogCountAscending(list) {
    return (0, _orderBy2.default)(list, ['catalogCounts.upcomingCount']);
};

var orderByUpcomingCatalogCountDescending = function orderByUpcomingCatalogCountDescending(list) {
    return (0, _orderBy2.default)(list, ['catalogCounts.upcomingCount'], ['desc']);
};

var sortCatalogs = exports.sortCatalogs = function sortCatalogs(all, sort) {
    var sorted = void 0;
    if (sort === 'DATE_ASCENDING') {
        sorted = (0, _flow2.default)(orderByCatalogTitleAscending, orderByCatalogSaleStartAscending)(all);
    } else if (sort === 'DATE_DESCENDING') {
        sorted = (0, _flow2.default)(orderByCatalogTitleAscending, orderByCatalogSaleStartDescending)(all);
    } else {
        sorted = all;
    }
    return sorted;
};

var sortItems = exports.sortItems = function sortItems(all, sort) {
    var sorted = void 0;
    if (sort === 'DATE_ASCENDING') {
        sorted = (0, _flow2.default)(orderByItemTitleAscending, orderByCatalogSaleStartAscending)(all);
    } else if (sort === 'BID_OLDEST_FIRST') {
        sorted = (0, _flow2.default)(orderByItemTitleAscending, orderByBidderBidTimeAscending)(all);
    } else if (sort === 'BID_RECENT_FIRST') {
        sorted = (0, _flow2.default)(orderByItemTitleAscending, orderByBidderBidTimeDescending)(all);
    } else if (sort === 'DATE_DESCENDING') {
        sorted = (0, _flow2.default)(orderByItemTitleAscending, orderByCatalogSaleStartDescending)(all);
    } else if (sort === 'ESTIMATE_HIGHEST_FIRST') {
        sorted = (0, _flow2.default)(orderByItemTitleAscending, orderByItemHighBidEstimateDescending)(all);
    } else if (sort === 'ESTIMATE_LOWEST_FIRST') {
        sorted = (0, _flow2.default)(orderByItemTitleAscending, orderByItemLowBidEstimateAscending)(all);
    } else if (sort === 'LEAST_BIDS') {
        sorted = (0, _flow2.default)(orderByItemTitleAscending, orderByItemBidCountAscending)(all);
    } else if (sort === 'LOT_NUMBER_LOWEST_FIRST') {
        sorted = (0, _flow2.default)(orderByItemTitleAscending, orderByItemLotNumberAscending)(all);
    } else if (sort === 'LOT_NUMBER_HIGHEST_FIRST') {
        sorted = (0, _flow2.default)(orderByItemTitleAscending, orderByItemLotNumberDescending)(all);
    } else if (sort === 'MOST_BIDS') {
        sorted = (0, _flow2.default)(orderByItemTitleAscending, orderByItemBidCountDescending)(all);
    } else if (sort === 'PRICE_HIGHEST_FIRST') {
        sorted = (0, _flow2.default)(orderByItemTitleAscending, orderByItemPriceDescending)(all);
    } else if (sort === 'PRICE_LOWEST_FIRST') {
        sorted = (0, _flow2.default)(orderByItemTitleAscending, orderByItemPriceAscending)(all);
    } else if (sort === 'RESULT_OLDEST_FIRST') {
        sorted = (0, _flow2.default)(orderByItemTitleAscending, orderBySaveSearchItemPublishTimeAscending)(all);
    } else if (sort === 'RESULT_RECENT_FIRST') {
        sorted = (0, _flow2.default)(orderByItemTitleAscending, orderBySaveSearchItemPublishTimeDescending)(all);
    } else if (sort === 'SAVED_OLDEST_FIRST') {
        sorted = (0, _flow2.default)(orderByItemTitleAscending, orderByItemSaveTimeAscending)(all);
    } else if (sort === 'SAVED_RECENT_FIRST') {
        sorted = (0, _flow2.default)(orderByItemTitleAscending, orderByItemSaveTimeDescending)(all);
    } else if (sort === 'TIME_ENDING_FURTHEST') {
        sorted = (0, _flow2.default)(orderByItemLotNumberDescending, orderByCatalogSaleStartDescending)(all);
    } else if (sort === 'TIME_SOONEST_FIRST') {
        sorted = (0, _flow2.default)(orderByItemLotNumberAscending, orderByCatalogSaleStartAscending)(all);

        var time = Date.now() / 1000;
        var index = -1;
        // eslint-disable-next-line no-plusplus
        for (var i = 0; i < sorted.length && index < 0; i++) {
            var current = sorted[i];
            if (current.catalog.saleStartTs > time) {
                index = i;
            }
        }
        sorted = [].concat((0, _toConsumableArray3.default)(sorted.slice(index)), (0, _toConsumableArray3.default)(sorted.slice(0, index)));
    } else {
        sorted = all;
    }
    return sorted;
};

var sortSellers = exports.sortSellers = function sortSellers(all, sort) {
    var sorted = void 0;
    if (sort === 'UPCOMING_HIGHEST_FIRST') {
        sorted = (0, _flow2.default)(orderBySellerNameAscending, orderByUpcomingCatalogCountDescending)(all);
    } else if (sort === 'UPCOMING_LOWEST_FIRST') {
        sorted = (0, _flow2.default)(orderBySellerNameAscending, orderByUpcomingCatalogCountAscending)(all);
    } else if (sort === 'NAME_HIGHEST_FIRST') {
        sorted = (0, _flow2.default)(orderBySellerNameDescending)(all);
    } else if (sort === 'NAME_LOWEST_FIRST') {
        sorted = (0, _flow2.default)(orderBySellerNameAscending)(all);
    } else {
        sorted = all;
    }
    return sorted;
};

/***/ }),

/***/ "8s5y":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = __webpack_require__("dcb+");

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _components = __webpack_require__("bGai");

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propsComparer = __webpack_require__("wsGv");

var _propsComparer2 = _interopRequireDefault(_propsComparer);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _LinkContainer = __webpack_require__("Y7dY");

var _LinkContainer2 = _interopRequireDefault(_LinkContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var columnKey = 0;

var LinkContainer = function (_Component) {
    (0, _inherits3.default)(LinkContainer, _Component);

    function LinkContainer() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, LinkContainer);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = LinkContainer.__proto__ || (0, _getPrototypeOf2.default)(LinkContainer)).call.apply(_ref, [this].concat(args))), _this), _this.mapLinks = function (link) {
            return (0, _jsx3.default)('li', {}, link.text, (0, _jsx3.default)(_components.Link, {
                onClick: _this.props.closeNav,
                route: true,
                to: link.route
            }, void 0, link.text));
        }, _this.mapColumn = function (columnObject) {
            // inline styling is a workaround for ie 10/11 and edge
            var ulStyle = {
                listStyle: 'none'
            };
            var title = columnObject.headerLink ? (0, _jsx3.default)(_components.Link, {
                className: _LinkContainer2.default['column-title'],
                route: true,
                to: columnObject.headerLink
            }, void 0, columnObject.headerText) : (0, _jsx3.default)('div', {
                className: _LinkContainer2.default['column-title']
            }, void 0, columnObject.headerText);
            return (0, _jsx3.default)('div', {}, columnObject.headerText, title, (0, _jsx3.default)('ul', {
                style: ulStyle
            }, void 0, columnObject.links.map(_this.mapLinks)));
        }, _this.mapLinkObjects = function (linkObject) {
            columnKey += 1;
            return (0, _jsx3.default)('div', {
                className: _LinkContainer2.default.column
            }, columnKey, (0, _jsx3.default)('div', {
                className: _LinkContainer2.default.wrapper
            }, void 0, linkObject.columnCategories.map(_this.mapColumn)));
        }, _this.generateColumns = function (linkObjects) {
            return (0, _jsx3.default)('div', {
                className: _LinkContainer2.default.container
            }, void 0, linkObjects.map(_this.mapLinkObjects));
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(LinkContainer, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps) {
            return (0, _propsComparer2.default)(this.props, nextProps, ['active', 'linkArray', 'mobile', 'picLinkL', 'picLinkS']);
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                active = _props.active,
                linkArray = _props.linkArray,
                mobile = _props.mobile,
                picLinkL = _props.picLinkL,
                picLinkS = _props.picLinkS;

            var columns = this.generateColumns(linkArray);
            var isTablet = mobile === 'tablet';
            var pictureLink = isTablet ? picLinkS : picLinkL;

            return (0, _jsx3.default)('div', {
                className: _LinkContainer2.default.megaNav + ' ' + (active ? '' : 'hidden')
            }, void 0, (0, _jsx3.default)('div', {
                className: _LinkContainer2.default.seo
            }, void 0, columns, (picLinkL || picLinkS) && (0, _jsx3.default)(_components.ImageWithFallback, {
                src: pictureLink,
                className: _LinkContainer2.default.image
            })));
        }
    }]);
    return LinkContainer;
}(_react.Component);

exports.default = LinkContainer;
module.exports = exports['default'];

/***/ }),

/***/ "8tqB":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = __webpack_require__("dcb+");

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propsComparer = __webpack_require__("wsGv");

var _propsComparer2 = _interopRequireDefault(_propsComparer);

var _LACrownContainer = __webpack_require__("YBb+");

var _LACrownContainer2 = _interopRequireDefault(_LACrownContainer);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _WhiteLabelCrownContainer = __webpack_require__("pf/a");

var _WhiteLabelCrownContainer2 = _interopRequireDefault(_WhiteLabelCrownContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Crown = function (_Component) {
    (0, _inherits3.default)(Crown, _Component);

    function Crown() {
        (0, _classCallCheck3.default)(this, Crown);
        return (0, _possibleConstructorReturn3.default)(this, (Crown.__proto__ || (0, _getPrototypeOf2.default)(Crown)).apply(this, arguments));
    }

    (0, _createClass3.default)(Crown, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps, nextState) {
            return (0, _propsComparer2.default)(this.props, nextProps, ['location', 'whiteLabel']);
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                location = _props.location,
                whiteLabel = _props.whiteLabel;


            return whiteLabel ? (0, _jsx3.default)(_WhiteLabelCrownContainer2.default, {}) : (0, _jsx3.default)(_LACrownContainer2.default, {
                location: location
            });
        }
    }]);
    return Crown;
}(_react.Component);

exports.default = Crown;
module.exports = exports['default'];

/***/ }),

/***/ "8ugv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"search-input":"search-input___2bZry","search-bar-input":"search-bar-input___LQePm","search-bar-input-with-dropdown":"search-bar-input-with-dropdown___NSVVs","suggestions-result":"suggestions-result___1r0yz","query-match":"query-match___7fNg-","auction-house-wrapper":"auction-house-wrapper___2Aeo1","auction-house-divider":"auction-house-divider___bIhoM","auction-house-line":"auction-house-line___3q33X","search-field-icon":"search-field-icon___lPIO0","search-field-dropdown":"search-field-dropdown___1k164","search-dropdown":"search-dropdown___xUwOt","remove-bottom-border":"remove-bottom-border___uKuil","caret":"caret___3JJ7F"};

/***/ }),

/***/ "8wAc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"breadcrumb":"breadcrumb___PQxo-","ellipsis":"ellipsis___3V9Vf","wrapper":"wrapper___3LJyC","chevron":"chevron___1UZEJ"};

/***/ }),

/***/ "9NGF":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getCurrentUrlFromState = exports.isServerSideRendered = exports.getPastUrl = exports.getCurrentUrl = undefined;

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;

var _reselect = __webpack_require__("bndy");

var _reactRouterRedux = __webpack_require__("jZgO");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* reducer */
var DEFAULT_STATE = {
    currentUrl: {
        pathname: ''
    },
    pastUrl: {
        pathname: ''
    }
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        case _reactRouterRedux.LOCATION_CHANGE:
            return (0, _extends3.default)({}, state, {
                currentUrl: (0, _extends3.default)({}, action.payload),
                pastUrl: (0, _extends3.default)({}, state.currentUrl)
            });
        default:
            return state;
    }
}

/* SELECTORS */
var stateSelector = function stateSelector(state) {
    return state.route;
};

var getCurrentUrl = exports.getCurrentUrl = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.currentUrl || {};
});

var getPastUrl = exports.getPastUrl = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.pastUrl || {};
});

var isServerSideRendered = exports.isServerSideRendered = (0, _reselect.createSelector)([getCurrentUrl, getPastUrl], function (currentUrl, pastUrl) {
    return pastUrl.pathname === currentUrl.pathname;
});

// This is state.routing because it uses the routing reducer from react-router-redux
var getCurrentUrlFromState = exports.getCurrentUrlFromState = function getCurrentUrlFromState(state, baseUrl) {
    return '' + baseUrl + state.routing.locationBeforeTransitions.pathname + state.routing.locationBeforeTransitions.search;
};

/***/ }),

/***/ "9T3g":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"mobile":"mobile___TXFju","mobileInner":"mobileInner___25A-F","header":"header___1zWCZ","headerMobile":"headerMobile___1a1pk","headerDesktop":"headerDesktop___2he0R","links":"links___ILqiS","app-store-link":"app-store-link___2pUdz","ios":"ios___YkhZH","android":"android___giMRq"};

/***/ }),

/***/ "9ad9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.submitSearch = exports.getCategoryWithGreatestResults = exports.getUpcomingAuctions = exports.getSelectedCategory = exports.getSelectedOrigin = exports.getSelectedStyle = exports.getSelectedMaterials = exports.getSelectedCreator = exports.isArchivedSearchFromLocation = exports.searchQueryFromParams = exports.getRawFacetsFromStateOrParams = exports.translateSortForOlderUrls = exports.concatenatePath = exports.findCategoryContainingSomeCategoryId = exports.isArchivedSearch = exports.isArchivedSearchByParams = exports.getSearchFacets = exports.getIsLoading = exports.getSort = exports.getSearchPageSize = exports.getSearchPage = exports.getSearchTotalItems = exports.getSearchFailed = exports.getSearchSubmitted = exports.getSearchedItems = exports.getSearchResults = exports.getSearchedParameters = exports.DEFAULT_SORT_ORDER = exports.DEFAULT_ARCHIVE_STATUSES = exports.DEFAULT_LIVE_STATUSES = exports.LOAD_SEARCH_RESULTS_SUCCESS = exports.LOAD_SEARCH_RESULTS_REQUEST = exports.LOAD_SEARCH_RESULTS_FAIL = undefined;

var _defineProperty2 = __webpack_require__("bOdI");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _toConsumableArray2 = __webpack_require__("Gu7T");

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _keys = __webpack_require__("fZjL");

var _keys2 = _interopRequireDefault(_keys);

var _extends3 = __webpack_require__("Dd8w");

var _extends4 = _interopRequireDefault(_extends3);

exports.default = reducer;

var _user = __webpack_require__("CFLi");

var _searchParams = __webpack_require__("MJ4I");

var _searchFacets = __webpack_require__("XTPq");

var _landingPage = __webpack_require__("1Hq4");

var _api = __webpack_require__("zFQO");

var _cloneDeep = __webpack_require__("kvU2");

var _cloneDeep2 = _interopRequireDefault(_cloneDeep);

var _reselect = __webpack_require__("bndy");

var _facetTypes = __webpack_require__("Ycpv");

var _facetTypes2 = _interopRequireDefault(_facetTypes);

var _find = __webpack_require__("kbi+");

var _find2 = _interopRequireDefault(_find);

var _config = __webpack_require__("iS9E");

var _cardData = __webpack_require__("6OFE");

var _pagination = __webpack_require__("DNXl");

var _urls = __webpack_require__("CakR");

var _paramTypes = __webpack_require__("jQDs");

var _paramTypes2 = _interopRequireDefault(_paramTypes);

var _reject = __webpack_require__("YqDm");

var _reject2 = _interopRequireDefault(_reject);

var _some = __webpack_require__("mGzp");

var _some2 = _interopRequireDefault(_some);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Action Types */
var LOAD_SEARCH_RESULTS_FAIL = exports.LOAD_SEARCH_RESULTS_FAIL = 'la/domain/searchResults/LOAD_FAIL';
var LOAD_SEARCH_RESULTS_REQUEST = exports.LOAD_SEARCH_RESULTS_REQUEST = 'la/domain/searchResults/LOAD_REQUEST';
var LOAD_SEARCH_RESULTS_SUCCESS = exports.LOAD_SEARCH_RESULTS_SUCCESS = 'la/domain/searchResults/LOAD_SUCCESS';

var MAX_VIEW_COUNT_FOR_SEARCH = 120;
var UNSUPPORT_SEARCH_VIEW_COUNT = 'all';
var DEFAULT_LIVE_STATUSES = exports.DEFAULT_LIVE_STATUSES = ['upcoming', 'live', 'online'];
var DEFAULT_ARCHIVE_STATUSES = exports.DEFAULT_ARCHIVE_STATUSES = ['sold', 'passed', 'done'];
var DEFAULT_SORT_ORDER = exports.DEFAULT_SORT_ORDER = '-relevance';

/* reducer */
var DEFAULT_STATE = {
    error: false,
    facets: [],
    isLoading: true,
    itemIDs: [],
    searchQuery: {
        options: {},
        page: 1
    },
    sort: [],
    submitted: false,
    success: false,
    totalFound: 0
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        case LOAD_SEARCH_RESULTS_REQUEST:
        case _landingPage.LOAD_CATEGORY_RESULTS_REQUEST:
            return (0, _extends4.default)({}, state, {
                error: false,
                searchQuery: action.payload,
                submitted: true,
                success: false
            });
        case LOAD_SEARCH_RESULTS_SUCCESS:
        case _landingPage.LOAD_CATEGORY_RESULTS_SUCCESS:
            return (0, _extends4.default)({}, state, {
                facets: action.payload.facets,
                isLoading: false,
                itemIDs: action.payload.itemIDs,
                sort: action.payload.sort.filter(function (sortOption) {
                    return sortOption !== 'publishDate';
                }),
                submitted: false,
                success: true,
                totalFound: action.payload.totalFound
            });
        case LOAD_SEARCH_RESULTS_FAIL:
        case _landingPage.LOAD_CATEGORY_RESULTS_FAIL:
            return (0, _extends4.default)({}, state, {
                error: true,
                submitted: false,
                success: false
            });
        default:
            return state;
    }
}

/* SELECTORS */
var searchSelector = function searchSelector(state) {
    return state.ui.search;
};

var getSearchedParameters = exports.getSearchedParameters = function getSearchedParameters(state) {
    return state.ui.search.searchQuery;
};

var getSearchResults = exports.getSearchResults = function getSearchResults(state) {
    return state.ui.search.itemIDs || [];
};

var getSearchedItems = exports.getSearchedItems = function getSearchedItems(state) {
    var itemIDs = getSearchResults(state);
    return (0, _cardData.getItemCardDatas)(state, itemIDs);
};

var getSearchSubmitted = exports.getSearchSubmitted = function getSearchSubmitted(state) {
    return state.ui.search.submitted;
};

var getSearchFailed = exports.getSearchFailed = function getSearchFailed(state) {
    return state.ui.search.error;
};

var getSearchTotalItems = exports.getSearchTotalItems = function getSearchTotalItems(state) {
    return state.ui.search.totalFound;
};

var getSearchPage = exports.getSearchPage = function getSearchPage(state) {
    return state.ui.search.searchQuery.page;
};

var getSearchPageSize = exports.getSearchPageSize = function getSearchPageSize(state) {
    var pageSize = (0, _pagination.getPaginationPageSize)(state);
    return pageSize === UNSUPPORT_SEARCH_VIEW_COUNT ? Number(MAX_VIEW_COUNT_FOR_SEARCH) : Number(pageSize);
};

var getSort = exports.getSort = function getSort(state) {
    return state.ui.search.sort;
};

var getIsLoading = exports.getIsLoading = function getIsLoading(state) {
    return state.ui.search.isLoading;
};

// For each key in the exclusions object, find the raw facet with that key, and add
// it to the search facets array
var getSearchFacets = exports.getSearchFacets = (0, _reselect.createSelector)(searchSelector, _user.getUserExcludedFacets, _searchFacets.getRawSearchFacets, function (search, facetExclusions) {
    var rawFacets = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

    var facets = (0, _cloneDeep2.default)(search.facets) || [];

    // for each exclusion, find the corresponding raw facet option, and add it
    (0, _keys2.default)(facetExclusions).forEach(function (complexFacetId) {
        var index = facets.findIndex(function (f) {
            return f.id === complexFacetId;
        });
        var complexFacet = rawFacets.find(function (f) {
            return f.id === complexFacetId;
        });
        if (index === -1 || !complexFacet || !complexFacet.options) return;

        // add excluded options to the options present in the search results
        facets[index].options = facetExclusions[complexFacetId].reduce(function (options, exclusion) {
            var includedOptionsIndex = options.findIndex(function (o) {
                return o.id === exclusion;
            });
            var rawFacetOption = complexFacet.options.find(function (o) {
                return o.id === exclusion;
            });
            if (!rawFacetOption) return options;
            if (includedOptionsIndex === -1) return [rawFacetOption].concat((0, _toConsumableArray3.default)(options));
            options.splice(includedOptionsIndex, 1, rawFacetOption);
            return options;
        }, facets[index].options || []);
    });

    return (0, _user.annotateFacetExclusions)(facets, facetExclusions);
});

var isArchivedSearchByParams = exports.isArchivedSearchByParams = function isArchivedSearchByParams(searchQuery) {
    var archiveSearch = true;

    DEFAULT_ARCHIVE_STATUSES.forEach(function (status) {
        archiveSearch = archiveSearch && searchQuery.options && searchQuery.options.status && searchQuery.options.status.some(function (optionStatus) {
            return optionStatus === status;
        });
    });

    return archiveSearch;
};

var isArchivedSearch = exports.isArchivedSearch = function isArchivedSearch(state) {
    var searchQuery = getSearchedParameters(state);
    return isArchivedSearchByParams(searchQuery);
};

var findCategoryContainingSomeCategoryId = exports.findCategoryContainingSomeCategoryId = function findCategoryContainingSomeCategoryId(categoryId, categories) {
    if (!categories) return false;
    var trees = categories;
    if ((0, _some2.default)(trees, function (c) {
        return c.id === categoryId;
    })) {
        return (0, _find2.default)(trees, function (c) {
            return c.id === categoryId;
        });
    }
    return (0, _find2.default)(trees, function (c) {
        return findCategoryContainingSomeCategoryId(categoryId, c.categories);
    });
};

var getParentPathForQuery = function getParentPathForQuery(category) {
    var categoryToQuery = '';
    if (category.selected && category.parents && category.parents.length > 0) {
        var parentsToQuery = '';
        category.parents.forEach(function (parent) {
            parentsToQuery += parent.id + '/';
        });
        categoryToQuery = '' + parentsToQuery + categoryToQuery;
    }
    return categoryToQuery;
};

var concatenatePath = exports.concatenatePath = function concatenatePath(category, catId) {
    if (!category) return catId;
    if (category.id === catId) {
        var categoryToQuery = category.id;
        categoryToQuery = '' + getParentPathForQuery(category) + categoryToQuery;

        return categoryToQuery;
    }
    var nextCategory = findCategoryContainingSomeCategoryId(catId, category.categories);

    return category.id + '/' + concatenatePath(nextCategory, catId);
};

var translateSortForOlderUrls = exports.translateSortForOlderUrls = function translateSortForOlderUrls(sortOption, defaultSortOrder) {
    var translatedSort = sortOption || defaultSortOrder;

    if (translatedSort.indexOf('_') > 0) {
        var oldUrl = sortOption.split('_');
        var newOption = oldUrl[0] + oldUrl[1].charAt(0).toUpperCase() + oldUrl[1].slice(1);
        translatedSort = newOption;
    }

    return translatedSort;
};

var translateStatus = function translateStatus(searchParams, location) {
    var status = DEFAULT_LIVE_STATUSES;

    if (searchParams.status === 'archive' || location.pathname && location.pathname.includes((0, _urls.getPriceGuideBaseUrl)())) {
        status = DEFAULT_ARCHIVE_STATUSES;
    }

    return status;
};

var getRawFacetsFromStateOrParams = exports.getRawFacetsFromStateOrParams = function getRawFacetsFromStateOrParams(state, searchQuery) {
    var facets = (0, _searchFacets.getRawSearchFacets)(state);

    if (!!facets) {
        facets = (0, _searchFacets.getRawSearchFacetsByParams)(state, searchQuery);
    }

    return facets;
};

/* this should only be called server side */
var searchQueryFromParams = exports.searchQueryFromParams = function searchQueryFromParams(state, location) {
    var defaultSortOrder = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : DEFAULT_SORT_ORDER;

    var searchParams = (0, _searchParams.getSearchParams)(location);
    var searchPageSize = getSearchPageSize(state);
    var translateSort = translateSortForOlderUrls(searchParams.sort, defaultSortOrder);
    var status = translateStatus(searchParams, location);
    var searchQuery = {
        campaignId: searchParams.campaignId,
        categories: [],
        distance: {},
        options: {
            status: status
        },
        page: searchParams.page || 1,
        pageSize: searchPageSize,
        ranges: {},
        searchTerm: searchParams.keyword ? searchParams.keyword : '',
        sort: translateSort
    };

    var categoryIds = searchParams.category_id;

    var facets = getRawFacetsFromStateOrParams(state, searchQuery);
    if (categoryIds) {
        var treeFacets = facets.filter(function (f) {
            return f.id === _facetTypes2.default.CATEGORY_ID || f.id === _facetTypes2.default.ORIGIN_ID;
        });
        var flatCategoryFacets = (0, _reject2.default)(facets, function (f) {
            return f.id === _facetTypes2.default.CATEGORY_ID || f.id === _facetTypes2.default.ORIGIN_ID || !f.options || f.id === _facetTypes2.default.AUCTION_HOUSE_ID;
        });

        categoryIds.split(',').forEach(function (categoryId) {
            var facetOption = (0, _find2.default)(flatCategoryFacets, function (f) {
                return (0, _some2.default)(f.options, function (o) {
                    return o.id === categoryId;
                });
            });
            if (facetOption) {
                if (!searchQuery.options[facetOption.id]) {
                    searchQuery.options[facetOption.id] = [];
                }
                searchQuery.options[facetOption.id].push(categoryId);
            } else {
                var rootCategory = findCategoryContainingSomeCategoryId(categoryId, treeFacets);
                searchQuery.categories.push(concatenatePath(rootCategory, categoryId));
            }
        });
    }

    (0, _keys2.default)(searchParams).forEach(function (key) {
        if (key === _paramTypes2.default.PAGE || key === _paramTypes2.default.PAGE_SIZE_LEGACY_SUPPORT || key === _paramTypes2.default.PAGE_SIZE || key === _paramTypes2.default.CATEGORY_ID || key === _paramTypes2.default.KEYWORD || key === _paramTypes2.default.SORT || key === _paramTypes2.default.STATUS || key === _paramTypes2.default.CAMPAIGN_ID) return;

        var convertedKey = (0, _searchParams.getFacetFromSearchQueryParameter)(key);
        var isRangeFacet = convertedKey === _facetTypes2.default.ESTIMATED_PRICE_ID || convertedKey === _facetTypes2.default.CURRENT_BID_ID || convertedKey === _facetTypes2.default.HAMMER_PRICE_ID;
        var isDistanceFacet = convertedKey === _facetTypes2.default.DISTANCE_ID;
        if (isRangeFacet) {
            var minMaxMatches = searchParams[key].match(/-?\d+/g);
            if (!searchQuery.ranges[convertedKey]) {
                searchQuery.ranges[convertedKey] = {};
            }
            var minValue = Number(minMaxMatches[0]);
            var maxValue = Number(minMaxMatches[1]);
            searchQuery.ranges[convertedKey].min = minValue === -1 ? null : minValue;
            searchQuery.ranges[convertedKey].max = maxValue === -1 ? null : maxValue;
        } else if (isDistanceFacet) {
            var distanceOptions = searchParams[key].split(':');
            searchQuery.distance.country = distanceOptions[0];
            searchQuery.distance.zipCode = distanceOptions[1];
            searchQuery.distance.space = Number(distanceOptions[2]);
            searchQuery.distance.measurement = distanceOptions[3];
        } else {
            var arrayParams = searchParams[key].split(',');
            searchQuery.options[convertedKey] = arrayParams;
        }
    });

    return searchQuery;
};

var isArchivedSearchFromLocation = exports.isArchivedSearchFromLocation = function isArchivedSearchFromLocation(state, location) {
    var currentSearchParams = searchQueryFromParams(state, location);
    return isArchivedSearchByParams(currentSearchParams) || location.pathname.includes((0, _urls.getPriceGuideBaseUrl)());
};

var getSelectedOptionFacetValues = function getSelectedOptionFacetValues(state, facetId) {
    var facets = getSearchFacets(state);
    var facetValues = facets.find(function (f) {
        return f.id === facetId;
    });
    var selectedFacetsValues = facetValues && facetValues.options ? facetValues.options.find(function (f) {
        return f.selected;
    }) : {};
    return selectedFacetsValues || {};
};

var getSelectedTreeFacetValues = function getSelectedTreeFacetValues(state, facetId) {
    var facets = getSearchFacets(state);
    var categoryFacets = facets.find(function (f) {
        return f.id === facetId;
    });
    var category = categoryFacets && categoryFacets.categories.facets.length > 0 ? categoryFacets.categories.facets.find(function (f) {
        return f.selected;
    }) : {};
    return category || {};
};

var getSelectedCreator = exports.getSelectedCreator = function getSelectedCreator(state) {
    return getSelectedOptionFacetValues(state, _facetTypes2.default.CREATOR_ID);
};

var getSelectedMaterials = exports.getSelectedMaterials = function getSelectedMaterials(state) {
    return getSelectedOptionFacetValues(state, _facetTypes2.default.MATERIALS_AND_TECHNIQUES_ID);
};

var getSelectedStyle = exports.getSelectedStyle = function getSelectedStyle(state) {
    return getSelectedOptionFacetValues(state, _facetTypes2.default.STYLE_PERIOD_ID);
};

var getSelectedOrigin = exports.getSelectedOrigin = function getSelectedOrigin(state) {
    return getSelectedTreeFacetValues(state, _facetTypes2.default.ORIGIN_ID);
};

var getSelectedCategory = exports.getSelectedCategory = function getSelectedCategory(state) {
    return getSelectedTreeFacetValues(state, _facetTypes2.default.CATEGORY_ID);
};

var getUpcomingAuctions = exports.getUpcomingAuctions = function getUpcomingAuctions(state) {
    var facets = getSearchFacets(state);
    var facetValues = facets.find(function (f) {
        return f.id === _facetTypes2.default.AUCTION_HOUSE_ID;
    });
    return facetValues ? facetValues.options.length : 0;
};

var getCategoryWithGreatestResults = exports.getCategoryWithGreatestResults = function getCategoryWithGreatestResults(state) {
    var facets = getSearchFacets(state);
    var categoryFacets = facets.find(function (f) {
        return f.id === _facetTypes2.default.CATEGORY_ID;
    });
    var category = categoryFacets && categoryFacets.categories && categoryFacets.categories.facets.length > 0 ? categoryFacets.categories.facets[0] : {};
    return category;
};

/* ACTION CREATORS */
var searchResultsFail = function searchResultsFail(searchQuery, error) {
    return {
        error: true,
        meta: { searchQuery: searchQuery },
        payload: error,
        type: LOAD_SEARCH_RESULTS_FAIL
    };
};

var searchResultsRequest = function searchResultsRequest(searchQuery) {
    return {
        payload: searchQuery,
        type: LOAD_SEARCH_RESULTS_REQUEST
    };
};

var searchResultsSuccess = function searchResultsSuccess(results) {
    return {
        payload: results,
        type: LOAD_SEARCH_RESULTS_SUCCESS
    };
};

var submitSearch = exports.submitSearch = function submitSearch(searchQuery) {
    return function (dispatch, getState) {
        var state = getState();
        var deployment = (0, _config.getDeployment)(state);
        dispatch(searchResultsRequest(searchQuery));

        // Annotate facets which have user-defined search exclusions
        var searchExclusions = (0, _user.getUserExcludedFacets)(state);
        var augmentedOptions = !searchExclusions ? searchQuery.options : (0, _keys2.default)(searchExclusions).reduce(function (options, facetWithExclusions) {
            return (0, _extends4.default)({}, options, (0, _defineProperty3.default)({}, facetWithExclusions, [{
                exclude: searchExclusions[facetWithExclusions] || [],
                include: searchQuery.options[facetWithExclusions] || []
            }]));
        }, (0, _extends4.default)({}, searchQuery.options));
        var augmentedSearchQuery = (0, _extends4.default)({}, searchQuery, {
            options: augmentedOptions
        });

        return _api.Search.fetchSearchResults({ deployment: deployment, searchQuery: augmentedSearchQuery }).then(function (results) {
            if (results.errorMessage) {
                dispatch(searchResultsFail(searchQuery, results));
            } else {
                dispatch(searchResultsSuccess(results));
            }
        }).catch(function (error) {
            dispatch(searchResultsFail(searchQuery, error));
        });
    };
};

/***/ }),

/***/ "9iAi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"address":"address___fI92y"};

/***/ }),

/***/ "9vKl":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {};

module.exports = exports["default"];

/***/ }),

/***/ "9vxb":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.whichSellerCatalogCountsNeeded = exports.shouldFetchSellerCatalogCounts = exports.getSellerCatalogCounts = undefined;

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;

var _seller = __webpack_require__("4q18");

var _cloneDeep = __webpack_require__("kvU2");

var _cloneDeep2 = _interopRequireDefault(_cloneDeep);

var _reselect = __webpack_require__("bndy");

var _difference = __webpack_require__("WlNK");

var _difference2 = _interopRequireDefault(_difference);

var _ms = __webpack_require__("EarI");

var _ms2 = _interopRequireDefault(_ms);

var _union = __webpack_require__("gszD");

var _union2 = _interopRequireDefault(_union);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Action Types */

var REDUX_STORE_TIME = (0, _ms2.default)('30m');

/* reducer */
var DEFAULT_STATE = {
    byId: {},
    loaded: {},
    loading: []
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var existing = void 0;
    var loaded = void 0;
    var loading = void 0;
    var time = void 0;

    switch (action.type) {
        case _seller.LOAD_SELLERS_FAIL:
            return (0, _extends3.default)({}, state, {
                loading: (0, _difference2.default)(state.loading, action.meta.sellerIds)
            });
        case _seller.LOAD_SELLERS_REQUEST:
            return (0, _extends3.default)({}, state, {
                loading: (0, _union2.default)(state.loading, action.payload)
            });
        case _seller.LOAD_SELLERS_SUCCESS:
            existing = (0, _cloneDeep2.default)(state.byId);
            loaded = (0, _extends3.default)({}, state.loaded);
            loading = (0, _cloneDeep2.default)(state.loading);
            time = action.meta.actionTime;

            if (action.payload.sellerCatalogCounts) {
                action.payload.sellerCatalogCounts.forEach(function (item) {
                    existing[item.sellerId] = (0, _extends3.default)({}, item, {
                        upcomingCount: item.liveCount + item.onlineCount
                    });
                    loaded[item.sellerId] = time;
                    loading = (0, _difference2.default)(loading, [item.sellerId]);
                });
            }
            return (0, _extends3.default)({}, state, {
                byId: existing,
                loaded: loaded,
                loading: loading
            });
        default:
            return state;
    }
}

/* SELECTORS */
var stateSelector = function stateSelector(state) {
    return state.domain.sellerCatalogCounts;
};
var idSelector = function idSelector(state, id) {
    return id;
};

var byIdSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.byId;
});

var loadedSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.loaded;
});

var loadingSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.loading;
});

// takes in a (state, id) and returns data
var getSellerCatalogCounts = exports.getSellerCatalogCounts = (0, _reselect.createSelector)([byIdSelector, idSelector], function (byId, id) {
    return byId[id] || { doneCount: 0, liveCount: 0, onlineCount: 0, upcomingCount: 0 };
});

// takes in a (state, id) and returns load time
var getLoadTimeForSellerCatalogCounts = (0, _reselect.createSelector)([loadedSelector, idSelector], function (loaded, id) {
    return loaded[id] || 0;
});

// takes in a (state, id) and returns if data is loading
var isSellerCatalogCountsLoading = (0, _reselect.createSelector)([loadingSelector, idSelector], function (loading, id) {
    return loading.indexOf(id) !== -1;
});

var shouldFetchSellerCatalogCounts = exports.shouldFetchSellerCatalogCounts = function shouldFetchSellerCatalogCounts(state, sellerId) {
    if (!sellerId) return false;
    var item = getSellerCatalogCounts(state, sellerId);
    if (item) {
        var loaded = getLoadTimeForSellerCatalogCounts(state, sellerId);
        var time = Date.now();
        var diff = time - loaded;
        if (diff < REDUX_STORE_TIME) return false;
    }
    var loading = isSellerCatalogCountsLoading(state, sellerId);
    return !loading;
};

var whichSellerCatalogCountsNeeded = exports.whichSellerCatalogCountsNeeded = function whichSellerCatalogCountsNeeded(state, sellerIds) {
    return sellerIds.filter(function (sellerId) {
        return shouldFetchSellerCatalogCounts(state, sellerId);
    });
};

/***/ }),

/***/ "9yZm":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _lostItems = __webpack_require__("nUI6");

exports.default = {
    fetchLostItems: _lostItems.LostItems.fetchLostItems
};
module.exports = exports['default'];

/***/ }),

/***/ "A6XQ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.updateAccountDetails = exports.getUiUpdateAccount = exports.UPDATE_ACCOUNT_SUCCESS = exports.UPDATE_ACCOUNT_REQUEST = exports.UPDATE_ACCOUNT_FAIL = undefined;

var _regenerator = __webpack_require__("Xxa5");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__("exGp");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;

var _user = __webpack_require__("CFLi");

var _api = __webpack_require__("zFQO");

var _reselect = __webpack_require__("bndy");

var _config = __webpack_require__("iS9E");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import {
//     getAttributionData,
//     getEditProfileAnalytics,
// } from '../selectors';

/* Action Types */
var UPDATE_ACCOUNT_FAIL = exports.UPDATE_ACCOUNT_FAIL = 'la/ui/updateAccount/FAIL';
var UPDATE_ACCOUNT_REQUEST = exports.UPDATE_ACCOUNT_REQUEST = 'la/ui/updateAccount/REQUEST';
var UPDATE_ACCOUNT_SUCCESS = exports.UPDATE_ACCOUNT_SUCCESS = 'la/ui/updateAccount/SUCCESS';

/* reducer */
var DEFAULT_STATE = {
    error: false,
    submitted: false,
    success: false
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        case UPDATE_ACCOUNT_FAIL:
            return (0, _extends3.default)({}, state, {
                error: true,
                submitted: false,
                success: false
            });
        case UPDATE_ACCOUNT_REQUEST:
            return (0, _extends3.default)({}, state, {
                submitted: true,
                success: false
            });
        case UPDATE_ACCOUNT_SUCCESS:
            return (0, _extends3.default)({}, state, {
                error: false,
                submitted: false,
                success: true
            });
        default:
            return state;
    }
}

/* SELECTORS */
var stateSelector = function stateSelector(state) {
    return state.ui.updateAccount;
};

var getUiUpdateAccount = exports.getUiUpdateAccount = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state;
});

/* ACTION CREATORS */
var updateAccountDetails = exports.updateAccountDetails = function updateAccountDetails(userDetails) {
    return function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch, getState) {
            var state, authToken, deployment, userData, response;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.prev = 0;
                            state = getState();
                            authToken = (0, _user.getAuthToken)(state);
                            deployment = (0, _config.getDeployment)(state);
                            userData = (0, _user.getUserData)(state);

                            userDetails.username = userData.username;
                            dispatch({
                                type: UPDATE_ACCOUNT_REQUEST
                            });
                            _context.next = 9;
                            return _api.Bidder.postCompleteAccount({
                                authToken: authToken,
                                bidderDetails: userDetails,
                                deployment: deployment
                            });

                        case 9:
                            response = _context.sent;

                            dispatch({
                                // meta: { ...getEditProfileAnalytics(attributionData), actionTime: Date.now() },
                                meta: { actionTime: Date.now() },
                                payload: response,
                                type: UPDATE_ACCOUNT_SUCCESS
                            });
                            _context.next = 16;
                            break;

                        case 13:
                            _context.prev = 13;
                            _context.t0 = _context['catch'](0);

                            dispatch({
                                error: true,
                                payload: _context.t0,
                                type: UPDATE_ACCOUNT_FAIL
                            });

                        case 16:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, undefined, [[0, 13]]);
        }));

        return function (_x3, _x4) {
            return _ref.apply(this, arguments);
        };
    }();
};

/***/ }),

/***/ "AGZl":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _auth = __webpack_require__("i2pf");

var Auth = {
    postAddCreditCard: _auth.AuthRemote.postAddCreditCard,
    postConfirmPassword: _auth.AuthRemote.postConfirmPassword,
    postForgotPassword: _auth.AuthRemote.postForgotPassword,
    postPayment: _auth.AuthRemote.postPayment,
    postResetPassword: _auth.AuthRemote.postResetPassword,
    postUpdatePassword: _auth.AuthRemote.postUpdatePassword,
    putAddCreditCard: _auth.AuthRemote.putAddCreditCard
};

exports.default = Auth;
module.exports = exports['default'];

/***/ }),

/***/ "AMoU":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _catalogLocation = __webpack_require__("EuUL");

var CatalogLocation = {
    fetchCatalogLocations: _catalogLocation.CatalogLocationRemote.fetchCatalogLocations
};

exports.default = CatalogLocation;
module.exports = exports['default'];

/***/ }),

/***/ "AN9j":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"card-date":"card-date___3dU5s","countdown":"countdown___1-YQq","clock":"clock___33YPc"};

/***/ }),

/***/ "Agmk":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ItemMock = undefined;

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _mockData = __webpack_require__("6VmH");

var _delay = __webpack_require__("kRHc");

var _delay2 = _interopRequireDefault(_delay);

var _union = __webpack_require__("gszD");

var _union2 = _interopRequireDefault(_union);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ItemMock = exports.ItemMock = {
    fetchItemsByIds: function fetchItemsByIds(itemIds) {
        return new _promise2.default(function (resolve) {
            setTimeout(function () {
                var items = itemIds.map(function (x) {
                    return (0, _mockData.getTestItem)(x);
                });
                var biddingInfos = [];
                var bidIncrements = [];
                var catalogs = [];
                var sellers = [];

                items.forEach(function (item) {
                    biddingInfos = (0, _union2.default)(biddingInfos, [(0, _mockData.getTestBiddingInfoForItem)(item.itemId)]);
                    bidIncrements = (0, _union2.default)(bidIncrements, [(0, _mockData.getTestBidIncrementForCatalog)(item.catalogId)]);
                    catalogs = (0, _union2.default)(catalogs, [(0, _mockData.getTestCatalog)(item.catalogId)]);
                    sellers = (0, _union2.default)(sellers, [(0, _mockData.getTestSeller)(item.sellerId)]);
                });
                resolve({
                    data: {
                        biddingInfos: biddingInfos,
                        bidIncrements: bidIncrements,
                        catalogs: catalogs,
                        items: items,
                        sellers: sellers
                    }
                });
            }, _delay2.default);
        });
    }
};

/***/ }),

/***/ "Ah1N":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"ScrollUpButton__Container":"ScrollUpButton__Container___32SwK","ScrollUpButton__Toggled":"ScrollUpButton__Toggled___E4oTw","arrowWrapper":"arrowWrapper___2negf","arrowUp":"arrowUp___3tFoN","backToTopText":"backToTopText___2-vz6"};

/***/ }),

/***/ "Alk2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__("bOdI");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _jsx2 = __webpack_require__("dcb+");

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _ControlLabel = __webpack_require__("TpLs");

var _ControlLabel2 = _interopRequireDefault(_ControlLabel);

var _FormControl = __webpack_require__("qAYn");

var _FormControl2 = _interopRequireDefault(_FormControl);

var _FormGroup = __webpack_require__("lyyJ");

var _FormGroup2 = _interopRequireDefault(_FormGroup);

var _HelpBlock = __webpack_require__("hxCs");

var _HelpBlock2 = _interopRequireDefault(_HelpBlock);

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propsComparer = __webpack_require__("wsGv");

var _propsComparer2 = _interopRequireDefault(_propsComparer);

var _classnames = __webpack_require__("HW6M");

var _classnames2 = _interopRequireDefault(_classnames);

var _noop = __webpack_require__("9vKl");

var _noop2 = _interopRequireDefault(_noop);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Input = __webpack_require__("xf6/");

var _Input2 = _interopRequireDefault(_Input);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Input = (_temp = _class = function (_Component) {
    (0, _inherits3.default)(Input, _Component);

    function Input() {
        (0, _classCallCheck3.default)(this, Input);
        return (0, _possibleConstructorReturn3.default)(this, (Input.__proto__ || (0, _getPrototypeOf2.default)(Input)).apply(this, arguments));
    }

    (0, _createClass3.default)(Input, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps) {
            return (0, _propsComparer2.default)(this.props, nextProps, ['accept', 'autoFocus', 'autoCapitalize', 'autoComplete', 'autoCorrect', 'children', 'className', 'disabled', 'errorMessage', 'help', 'iconClassName', 'id', 'inputClassName', 'label', 'placeholder', 'small', 'type', 'valid', 'value', 'wide']);
        }
    }, {
        key: 'render',
        value: function render() {
            var _classNames;

            var _props = this.props,
                accept = _props.accept,
                autoComplete = _props.autoComplete,
                autoCapitalize = _props.autoCapitalize,
                autoCorrect = _props.autoCorrect,
                autoFocus = _props.autoFocus,
                dontRecordForFullstory = _props.dontRecordForFullstory,
                children = _props.children,
                className = _props.className,
                disabled = _props.disabled,
                errorMessage = _props.errorMessage,
                help = _props.help,
                iconClassName = _props.iconClassName,
                id = _props.id,
                inputClassName = _props.inputClassName,
                inputRef = _props.inputRef,
                label = _props.label,
                onBlur = _props.onBlur,
                onChange = _props.onChange,
                onKeyPress = _props.onKeyPress,
                placeholder = _props.placeholder,
                small = _props.small,
                type = _props.type,
                valid = _props.valid,
                value = _props.value,
                wide = _props.wide;


            var validationState = valid ? {} : { validationState: 'error' };
            var componentClass = type === 'select' ? { componentClass: 'select' } : {};
            componentClass = type === 'textarea' ? { componentClass: 'textarea' } : componentClass;

            var errorComponents = [(0, _jsx3.default)(_FormControl2.default.Feedback, {
                className: _Input2.default['custom-error-icon'] + ' ' + iconClassName,
                bsClass: 'form-control-feedback custom-error-icon'
            }, 0), (0, _jsx3.default)('div', {
                className: _Input2.default.error
            }, 1, errorMessage)];

            var classes = (0, _classnames2.default)(_Input2.default['form-group'], className, (_classNames = {}, (0, _defineProperty3.default)(_classNames, _Input2.default.small, small), (0, _defineProperty3.default)(_classNames, _Input2.default.wide, wide), _classNames), className);

            var inputClasses = (0, _classnames2.default)(_Input2.default['form-control'], inputClassName, (0, _defineProperty3.default)({}, _Input2.default.recordingExclude, dontRecordForFullstory));
            var pattern = type === 'number' ? '\\d*' : '';

            return _react2.default.createElement(
                _FormGroup2.default,
                (0, _extends3.default)({ className: classes, controlId: id }, validationState),
                !!label && (0, _jsx3.default)(_ControlLabel2.default, {}, void 0, label),
                !!help && (0, _jsx3.default)(_HelpBlock2.default, {}, void 0, help),
                _react2.default.createElement(
                    _FormControl2.default,
                    (0, _extends3.default)({
                        accept: accept,
                        autoComplete: autoComplete ? 'on' : 'off',
                        autoCapitalize: autoCapitalize ? 'on' : 'off',
                        autoCorrect: autoCorrect ? 'on' : 'off',
                        autoFocus: autoFocus,
                        className: inputClasses,
                        disabled: disabled,
                        inputRef: inputRef,
                        onChange: onChange,
                        onBlur: onBlur,
                        onKeyPress: onKeyPress,
                        placeholder: placeholder,
                        type: type,
                        pattern: pattern,
                        value: value
                    }, componentClass),
                    children
                ),
                !valid && errorComponents
            );
        }
    }]);
    return Input;
}(_react.Component), _class.defaultProps = {
    accept: '*',
    autoCapitalize: true,
    autoComplete: true,
    autoCorrect: true,
    className: '',
    disabled: false,
    iconClassName: '',
    inputClassName: '',
    inputRef: _noop2.default,
    onBlur: _noop2.default,
    onChange: _noop2.default,
    onKeyPress: _noop2.default,
    placeholder: '',
    small: false,
    type: 'text',
    valid: true
}, _temp);
exports.default = Input;
module.exports = exports['default'];

/***/ }),

/***/ "ApaR":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _similarItems = __webpack_require__("RB4q");

var _similarItems2 = __webpack_require__("QMRE");

var SimilarItems = {
    fetchSimilarItems: function fetchSimilarItems(params) {
        return  false ? _similarItems.SimilarItemsMock.fetchSimilarItems(params) : _similarItems2.SimilarItemsRemote.fetchSimilarItems(params);
    }
};

exports.default = SimilarItems;
module.exports = exports['default'];

/***/ }),

/***/ "ArKR":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toQueryString = exports.getQueryString = exports.getParams = exports.getBase = undefined;

var _slicedToArray2 = __webpack_require__("d7EF");

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getBase = exports.getBase = function getBase(url) {
    if (!url) {
        return '';
    }
    if (url.includes('#')) {
        return url.substring(0, url.indexOf('#'));
    }
    if (url.includes('?')) {
        return url.substring(0, url.indexOf('?'));
    }
    return url;
};

// From https://stackoverflow.com/a/3855394/148256
var getParams = exports.getParams = function getParams(query) {
    if (!query) {
        return {};
    }

    return (/^[?#]/.test(query) ? query.slice(1) : query).split('&').reduce(function (params, param) {
        var _param$split = param.split('='),
            _param$split2 = (0, _slicedToArray3.default)(_param$split, 2),
            key = _param$split2[0],
            value = _param$split2[1];

        if (key) params[key] = value ? decodeURIComponent(value.replace(/\+/g, ' ')) : '';
        return params;
    }, {});
};

var getQueryString = exports.getQueryString = function getQueryString(url) {
    var base = getBase(url);
    var query = url.substring(base.length);
    if (query !== '' && query !== '/') {
        return query;
    }
    return '';
};

// https://stackoverflow.com/a/1714899/148256
var toQueryString = exports.toQueryString = function toQueryString(obj) {
    var arr = [];
    for (var p in obj) {
        // eslint-disable-next-line no-prototype-builtins
        if (obj.hasOwnProperty(p)) {
            arr.push(encodeURIComponent(p) + '=' + encodeURIComponent(obj[p]));
        }
    }
    arr.sort();
    return arr.join('&');
};

/***/ }),

/***/ "AwUZ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.submitSaveSearch = exports.getSaveSearchParams = exports.getSaveSearchState = exports.DELETE_SAVED_SEARCH_SUCCESS = exports.DELETE_SAVED_SEARCH_REQUEST = exports.DELETE_SAVED_SEARCH_FAIL = exports.SAVE_SEARCH_SUCCESS = exports.SAVE_SEARCH_REQUEST = exports.SAVE_SEARCH_FAIL = undefined;

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.deleteSavedSearch = deleteSavedSearch;

var _searchParams = __webpack_require__("MJ4I");

var _user = __webpack_require__("CFLi");

var _analytics = __webpack_require__("yxCd");

var _saveSearchCheck = __webpack_require__("nQXN");

var _api = __webpack_require__("zFQO");

var _savedSearch = __webpack_require__("qWId");

var _config = __webpack_require__("iS9E");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Action Types */
var SAVE_SEARCH_FAIL = exports.SAVE_SEARCH_FAIL = 'la/ui/saveSearch/FAIL';
var SAVE_SEARCH_REQUEST = exports.SAVE_SEARCH_REQUEST = 'la/ui/saveSearch/REQUEST';
var SAVE_SEARCH_SUCCESS = exports.SAVE_SEARCH_SUCCESS = 'la/ui/saveSearch/SUCCESS';

var DELETE_SAVED_SEARCH_FAIL = exports.DELETE_SAVED_SEARCH_FAIL = 'la/ui/deleteSavedSearch/FAIL';
var DELETE_SAVED_SEARCH_REQUEST = exports.DELETE_SAVED_SEARCH_REQUEST = 'la/ui/deleteSavedSearch/REQUEST';
var DELETE_SAVED_SEARCH_SUCCESS = exports.DELETE_SAVED_SEARCH_SUCCESS = 'la/ui/deleteSavedSearch/SUCCESS';

// reducer
var DEFAULT_STATE = {
    error: false,
    submitted: false,
    success: false
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        case SAVE_SEARCH_REQUEST:
        case DELETE_SAVED_SEARCH_REQUEST:
            return (0, _extends3.default)({}, state, {
                submitted: true,
                success: false
            });
        case SAVE_SEARCH_SUCCESS:
            return (0, _extends3.default)({}, state, {
                submitted: false,
                success: true
            });
        case _user.LOG_OUT_BIDDER:
        case DELETE_SAVED_SEARCH_SUCCESS:
            return (0, _extends3.default)({}, state, {
                submitted: false,
                success: true
            });
        case SAVE_SEARCH_FAIL:
            return (0, _extends3.default)({}, state, {
                error: true,
                submitted: false,
                success: false
            });
        default:
            return state;
    }
}

/* SELECTORS */
var getSaveSearchState = exports.getSaveSearchState = function getSaveSearchState(state) {
    return state.ui.saveSearch;
};

var getSaveSearchParams = exports.getSaveSearchParams = function getSaveSearchParams(location) {
    var searchParams = (0, _searchParams.getSearchParams)(location);

    if (searchParams.status === _searchParams.DEFAULT_STATUS_FOR_ARCHIVED_SEARCH) {
        searchParams.status = _searchParams.DEFAULT_STATUS_FOR_ONLINE_SEARCH;
    }

    delete searchParams.pageSize;
    delete searchParams.pagesize;
    delete searchParams.page;
    delete searchParams.sort;

    searchParams.keyword = searchParams.keyword ? searchParams.keyword : '';

    return searchParams;
};

/* ACTION CREATORS */
var submitSaveSearch = exports.submitSaveSearch = function submitSaveSearch(searchParams, sendAlert) {
    return function (dispatch, getState) {
        var state = getState();
        var authToken = (0, _user.getAuthToken)(state);
        var deployment = (0, _config.getDeployment)(state);
        var analytics = (0, _analytics.getFollowSearchAnalytics)();
        dispatch({
            type: SAVE_SEARCH_REQUEST
        });
        return _api.SaveSearch.postSaveSearch({ authToken: authToken, deployment: deployment, searchParams: searchParams, sendalert: sendAlert }).then(function (response) {
            dispatch({
                meta: analytics,
                payload: response,
                type: SAVE_SEARCH_SUCCESS
            });
            dispatch((0, _savedSearch.fetchSavedSearchesIfNeeded)(true));
            dispatch((0, _saveSearchCheck.submitIsSavedSearchCheck)(searchParams));
        }).catch(function (error) {
            dispatch({
                error: true,
                payload: error,
                type: SAVE_SEARCH_FAIL
            });
            dispatch((0, _savedSearch.fetchSavedSearchesIfNeeded)(true));
            dispatch((0, _saveSearchCheck.submitIsSavedSearchCheck)(searchParams));
        });
    };
};

function deleteSavedSearch(searchParams) {
    return function (dispatch, getState) {
        var state = getState();
        var authToken = (0, _user.getAuthToken)(state);
        var deployment = (0, _config.getDeployment)(state);
        var savedSearchId = (0, _saveSearchCheck.getSavedSearchId)(state);
        var analytics = (0, _analytics.getUnfollowSearchAnalytics)();
        dispatch({
            type: DELETE_SAVED_SEARCH_REQUEST
        });
        return _api.SaveSearch.deleteSavedSearch({ authToken: authToken, deployment: deployment, savedSearchId: savedSearchId }).then(function (response) {
            dispatch({
                meta: analytics,
                payload: response,
                type: DELETE_SAVED_SEARCH_SUCCESS
            });
            dispatch((0, _savedSearch.fetchSavedSearchesIfNeeded)(true));
            dispatch((0, _saveSearchCheck.submitIsSavedSearchCheck)(searchParams));
        }).catch(function (error) {
            dispatch({
                error: true,
                payload: error,
                type: DELETE_SAVED_SEARCH_FAIL
            });
            dispatch((0, _savedSearch.fetchSavedSearchesIfNeeded)(true));
            dispatch((0, _saveSearchCheck.submitIsSavedSearchCheck)(searchParams));
        });
    };
}

/***/ }),

/***/ "B1jV":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ItemRemote = undefined;

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _helpers = __webpack_require__("SY39");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ItemRemote = exports.ItemRemote = {
    fetchItemsByIds: function fetchItemsByIds(_ref) {
        var authToken = _ref.authToken,
            deployment = _ref.deployment,
            itemIds = _ref.itemIds;
        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makePost)('<ITEM-API>spa/small/items', deployment);
            (0, _helpers.addAuthToken)(request, authToken);
            request.send({ ids: itemIds });
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response });
            });
        });
    },
    fetchItemShippingsByIds: function fetchItemShippingsByIds(_ref2) {
        var authToken = _ref2.authToken,
            deployment = _ref2.deployment,
            itemIds = _ref2.itemIds;
        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makePost)('<ITEM-API>item-shippings', deployment);
            (0, _helpers.addAuthToken)(request, authToken);
            request.send({ itemIds: itemIds });
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response });
            });
        });
    },
    fetchListingAgentsByIds: function fetchListingAgentsByIds(_ref3) {
        var agentIds = _ref3.agentIds,
            authToken = _ref3.authToken,
            deployment = _ref3.deployment;
        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makePost)('<ITEM-API>listing-agents', deployment);
            (0, _helpers.addAuthToken)(request, authToken);
            request.send({ agentIds: agentIds });
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response });
            });
        });
    }
};

/***/ }),

/***/ "BBIF":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = __webpack_require__("dcb+");

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__("Pq8k");

var _reactScrollUpButton = __webpack_require__("+3AT");

var _reactScrollUpButton2 = _interopRequireDefault(_reactScrollUpButton);

var _BackToTop = __webpack_require__("Ah1N");

var _BackToTop2 = _interopRequireDefault(_BackToTop);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BackToTop = function (_PureComponent) {
    (0, _inherits3.default)(BackToTop, _PureComponent);

    function BackToTop() {
        (0, _classCallCheck3.default)(this, BackToTop);
        return (0, _possibleConstructorReturn3.default)(this, (BackToTop.__proto__ || (0, _getPrototypeOf2.default)(BackToTop)).apply(this, arguments));
    }

    (0, _createClass3.default)(BackToTop, [{
        key: 'render',
        value: function render() {
            return (0, _jsx3.default)(_reactScrollUpButton2.default, {
                ShowAtPostion: 1250,
                ContainerClassName: _BackToTop2.default['ScrollUpButton__Container'],
                TransitionClassName: _BackToTop2.default['ScrollUpButton__Toggled']
            }, void 0, (0, _jsx3.default)(_react.Fragment, {}, void 0, (0, _jsx3.default)('div', {
                className: _BackToTop2.default.arrowWrapper
            }, void 0, (0, _jsx3.default)('div', {
                className: _BackToTop2.default.arrowUp
            })), (0, _jsx3.default)('div', {
                className: _BackToTop2.default.backToTopText
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'back_to_top_button'
            }))));
        }
    }]);
    return BackToTop;
}(_react.PureComponent);

exports.default = BackToTop;
module.exports = exports['default'];

/***/ }),

/***/ "BK5P":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.BidHistoryMock = undefined;

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _delay = __webpack_require__("kRHc");

var _delay2 = _interopRequireDefault(_delay);

var _mockData = __webpack_require__("6VmH");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BidHistoryMock = exports.BidHistoryMock = {
    fetchBidHistory: function fetchBidHistory(catalogId) {
        return new _promise2.default(function (resolve) {
            setTimeout(function () {
                var bidHistory = (0, _mockData.getTestBidHistory)(catalogId);
                resolve({
                    data: bidHistory.history
                });
            }, _delay2.default);
        });
    }
};

/***/ }),

/***/ "BXmT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"pagination-container":"pagination-container___3VWUM","paginator":"paginator___3Z9Gr","chevron":"chevron___3qHta","break":"break___3EiEL","disabled":"disabled___1ckQv","grayed":"grayed___2b6y5","pagination-view-count":"pagination-view-count___2eR0Y","page-size":"page-size___8XSeH"};

/***/ }),

/***/ "ByEe":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fetchLiveCatalogStatusIfNeeded = exports.isLiveCatalogStatusLoading = exports.getLoadTimeForLiveCatalogStatus = exports.LOAD_LIVE_CATALOG_STATUS_SUCCESS = exports.LOAD_LIVE_CATALOG_STATUS_REQUEST = exports.LOAD_LIVE_CATALOG_STATUS_FAIL = undefined;

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _regenerator = __webpack_require__("Xxa5");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__("exGp");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;

var _user = __webpack_require__("CFLi");

var _api = __webpack_require__("zFQO");

var _cloneDeep = __webpack_require__("kvU2");

var _cloneDeep2 = _interopRequireDefault(_cloneDeep);

var _reselect = __webpack_require__("bndy");

var _difference = __webpack_require__("WlNK");

var _difference2 = _interopRequireDefault(_difference);

var _config = __webpack_require__("iS9E");

var _ms = __webpack_require__("EarI");

var _ms2 = _interopRequireDefault(_ms);

var _union = __webpack_require__("gszD");

var _union2 = _interopRequireDefault(_union);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Action Types */
var LOAD_LIVE_CATALOG_STATUS_FAIL = exports.LOAD_LIVE_CATALOG_STATUS_FAIL = 'la/domain/liveCatalogStatus/LOAD_FAIL';
var LOAD_LIVE_CATALOG_STATUS_REQUEST = exports.LOAD_LIVE_CATALOG_STATUS_REQUEST = 'la/domain/liveCatalogStatus/LOAD_REQUEST';
var LOAD_LIVE_CATALOG_STATUS_SUCCESS = exports.LOAD_LIVE_CATALOG_STATUS_SUCCESS = 'la/domain/liveCatalogStatus/LOAD_SUCCESS';

var REDUX_STORE_TIME = (0, _ms2.default)('30m');

/* reducer */
var DEFAULT_STATE = {
    loaded: {},
    loading: []
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var loaded = void 0;
    var loading = void 0;
    var time = void 0;

    switch (action.type) {
        case LOAD_LIVE_CATALOG_STATUS_FAIL:
            return (0, _extends3.default)({}, state, {
                loading: (0, _difference2.default)(state.loading, action.meta.catalogId)
            });
        case LOAD_LIVE_CATALOG_STATUS_REQUEST:
            return (0, _extends3.default)({}, state, {
                loading: (0, _union2.default)(state.loading, action.payload)
            });
        case LOAD_LIVE_CATALOG_STATUS_SUCCESS:
            loaded = (0, _cloneDeep2.default)(state.loaded);
            loading = (0, _cloneDeep2.default)(state.loading);
            time = action.meta.actionTime;
            loaded[action.meta.catalogId] = time;

            return (0, _extends3.default)({}, state, {
                loaded: loaded,
                loading: (0, _difference2.default)(loading, [action.payload.catalogId])
            });
        default:
            return state;
    }
}

/* SELECTORS */
var stateSelector = function stateSelector(state) {
    return state.domain.liveCatalogStatus;
};
var idSelector = function idSelector(state, id) {
    return id;
};

var loadedSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.loaded;
});

var loadingSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.loading;
});

var getLoadTimeForLiveCatalogStatus = exports.getLoadTimeForLiveCatalogStatus = (0, _reselect.createSelector)([loadedSelector, idSelector], function (loaded, id) {
    return loaded[id] || 0;
});

var isLiveCatalogStatusLoading = exports.isLiveCatalogStatusLoading = (0, _reselect.createSelector)([loadingSelector, idSelector], function (loading, id) {
    return loading.includes(id);
});

var shouldFetchLiveCatalogStatus = function shouldFetchLiveCatalogStatus(state, catalogId) {
    if (!catalogId) return false;
    var loaded = getLoadTimeForLiveCatalogStatus(state, catalogId);
    if (loaded) {
        var time = Date.now();
        var diff = time - loaded;
        if (diff < REDUX_STORE_TIME) return false;
    }
    var loading = isLiveCatalogStatusLoading(state, catalogId);
    return !loading;
};

/* ACTION CREATORS */
var loadLiveCatalogStatus = function loadLiveCatalogStatus(catalogId) {
    return function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch, getState) {
            var state, bidderId, authToken, Email, deployment, response;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.prev = 0;
                            state = getState();
                            bidderId = (0, _user.getBidderId)(state);
                            authToken = (0, _user.getAuthToken)(state);
                            Email = (0, _user.getBidderEmail)(state);
                            deployment = (0, _config.getDeployment)(state);

                            bidderId = bidderId === -1 ? false : bidderId;

                            dispatch({
                                payload: [catalogId],
                                type: LOAD_LIVE_CATALOG_STATUS_REQUEST
                            });

                            _context.next = 10;
                            return _api.LiveCatalogStatus.fetchLiveCatalogStatus({ authToken: authToken, bidderId: bidderId, catalogId: catalogId, deployment: deployment, Email: Email });

                        case 10:
                            response = _context.sent;

                            dispatch({
                                meta: { actionTime: Date.now(), bidderId: bidderId, catalogId: catalogId },
                                payload: response.data,
                                type: LOAD_LIVE_CATALOG_STATUS_SUCCESS
                            });
                            _context.next = 17;
                            break;

                        case 14:
                            _context.prev = 14;
                            _context.t0 = _context['catch'](0);

                            dispatch({
                                error: true, // TODO: this isn't used
                                meta: { catalogId: catalogId },
                                payload: _context.t0,
                                type: LOAD_LIVE_CATALOG_STATUS_FAIL
                            });

                        case 17:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, undefined, [[0, 14]]);
        }));

        return function (_x3, _x4) {
            return _ref.apply(this, arguments);
        };
    }();
};

var fetchLiveCatalogStatusIfNeeded = exports.fetchLiveCatalogStatusIfNeeded = function fetchLiveCatalogStatusIfNeeded(catalogId) {
    return function (dispatch, getState) {
        if (shouldFetchLiveCatalogStatus(getState(), catalogId)) {
            return dispatch(loadLiveCatalogStatus(catalogId));
        }
        return _promise2.default.resolve();
    };
};

/***/ }),

/***/ "C5B+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"breadcrumb-list":"breadcrumb-list___3OiDQ","breadcrumb-container":"breadcrumb-container___2dzq_","breadcrumbs":"breadcrumbs___2t3tN","clear-all":"clear-all___3eTEh","selected-filter":"selected-filter___1fm2k","filter-text":"filter-text___2ljHR","keyword-crumb":"keyword-crumb___39GoB","full-text":"full-text___2cH8P"};

/***/ }),

/***/ "CCNV":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toggleEmailSubscription = exports.fetchEmailListsIfNeeded = exports.getEmailList = exports.getEmailLists = exports.UNSUBSCRIBE_SUCCESS = exports.UNSUBSCRIBE_REQUEST = exports.UNSUBSCRIBE_FAIL = exports.SUBSCRIBE_SUCCESS = exports.SUBSCRIBE_REQUEST = exports.SUBSCRIBE_FAIL = exports.LOAD_EMAIL_LIST_SUCCESS = exports.LOAD_EMAIL_LIST_REQUEST = exports.LOAD_EMAIL_LIST_FAIL = undefined;

var _regenerator = __webpack_require__("Xxa5");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _asyncToGenerator2 = __webpack_require__("exGp");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _toConsumableArray2 = __webpack_require__("Gu7T");

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;

var _api = __webpack_require__("zFQO");

var _reselect = __webpack_require__("bndy");

var _user = __webpack_require__("CFLi");

var _config = __webpack_require__("iS9E");

var _ms = __webpack_require__("EarI");

var _ms2 = _interopRequireDefault(_ms);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Action Types */
var LOAD_EMAIL_LIST_FAIL = exports.LOAD_EMAIL_LIST_FAIL = 'la/user/emailList/LOAD_FAIL';
var LOAD_EMAIL_LIST_REQUEST = exports.LOAD_EMAIL_LIST_REQUEST = 'la/user/emailList/LOAD_REQUEST';
var LOAD_EMAIL_LIST_SUCCESS = exports.LOAD_EMAIL_LIST_SUCCESS = 'la/user/emailList/LOAD_SUCCESS';

var SUBSCRIBE_FAIL = exports.SUBSCRIBE_FAIL = 'la/user/emailList/SUBSCRIBE_FAIL';
var SUBSCRIBE_REQUEST = exports.SUBSCRIBE_REQUEST = 'la/user/emailList/SUBSCRIBE_REQUEST';
var SUBSCRIBE_SUCCESS = exports.SUBSCRIBE_SUCCESS = 'la/user/emailList/SUBSCRIBE_SUCCESS';

var UNSUBSCRIBE_FAIL = exports.UNSUBSCRIBE_FAIL = 'la/user/emailList/UNSUBSCRIBE_FAIL';
var UNSUBSCRIBE_REQUEST = exports.UNSUBSCRIBE_REQUEST = 'la/user/emailList/UNSUBSCRIBE_REQUEST';
var UNSUBSCRIBE_SUCCESS = exports.UNSUBSCRIBE_SUCCESS = 'la/user/emailList/UNSUBSCRIBE_SUCCESS';

var REDUX_STORE_TIME = (0, _ms2.default)('5m');

// reducer
var DEFAULT_STATE = {
    lists: [],
    loaded: 0,
    loading: false
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var lists = void 0;

    switch (action.type) {
        case LOAD_EMAIL_LIST_FAIL:
            return (0, _extends3.default)({}, state, {
                loading: false
            });
        case LOAD_EMAIL_LIST_REQUEST:
            return (0, _extends3.default)({}, state, {
                loading: true
            });
        case LOAD_EMAIL_LIST_SUCCESS:
            return (0, _extends3.default)({}, state, {
                lists: action.payload,
                loaded: action.meta.actionTime,
                loading: false
            });
        case SUBSCRIBE_REQUEST:
            lists = [].concat((0, _toConsumableArray3.default)(state.lists));
            if (action.payload === 'Unsubscribed All') {
                lists.forEach(function (x) {
                    if (x.type === 'newsletter') {
                        x.subscribed = true;
                    }
                });
            } else {
                lists.forEach(function (x) {
                    if (x.code === action.payload) {
                        x.subscribed = true;
                    }
                });
            }
            return (0, _extends3.default)({}, state, {
                lists: lists
            });
        case UNSUBSCRIBE_REQUEST:
            lists = [].concat((0, _toConsumableArray3.default)(state.lists));
            if (action.payload === 'Unsubscribed All') {
                lists.forEach(function (x) {
                    if (x.type === 'newsletter') {
                        x.subscribed = false;
                    }
                });
            } else {
                lists.forEach(function (x) {
                    if (x.code === action.payload) {
                        x.subscribed = false;
                    }
                });
            }
            return (0, _extends3.default)({}, state, {
                lists: lists
            });
        default:
            return state;
    }
}

/* SELECTORS */
var stateSelector = function stateSelector(state) {
    return state.user.emailList;
};
var codeSelector = function codeSelector(state, code) {
    return code;
};

var getEmailLists = exports.getEmailLists = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.lists && state.lists.sort(function (a, b) {
        return a.type - b.type;
    }).sort(function (a, b) {
        return a.sequence - b.sequence;
    }) || [];
});

var getEmailList = exports.getEmailList = (0, _reselect.createSelector)([stateSelector, codeSelector], function (state, code) {
    return state.lists.find(function (x) {
        return x.code === code;
    }) || {};
});

var getLoadTime = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.loaded || 0;
});

var isLoading = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.loading || false;
});

var shouldFetchEmailLists = function shouldFetchEmailLists(state) {
    var loaded = getLoadTime(state);
    var time = Date.now();
    var diff = time - loaded;
    if (diff < REDUX_STORE_TIME) return false;
    return !isLoading(state);
};

/* ACTION CREATORS */
var fetchEmailListsIfNeeded = exports.fetchEmailListsIfNeeded = function fetchEmailListsIfNeeded() {
    return function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch, getState) {
            var state, deployment, authToken, response;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            state = getState();

                            if (!shouldFetchEmailLists(state)) {
                                _context.next = 17;
                                break;
                            }

                            deployment = (0, _config.getDeployment)(state);
                            _context.prev = 3;

                            dispatch({
                                meta: { actionTime: Date.now() },
                                type: LOAD_EMAIL_LIST_REQUEST
                            });
                            authToken = (0, _user.getAuthToken)(state);
                            _context.next = 8;
                            return _api.EmailList.fetchEmailLists({ authToken: authToken, deployment: deployment });

                        case 8:
                            response = _context.sent;

                            dispatch({
                                meta: { actionTime: Date.now() },
                                payload: response.data,
                                type: LOAD_EMAIL_LIST_SUCCESS
                            });
                            _context.next = 15;
                            break;

                        case 12:
                            _context.prev = 12;
                            _context.t0 = _context['catch'](3);

                            dispatch({
                                error: true,
                                payload: _context.t0,
                                type: LOAD_EMAIL_LIST_FAIL
                            });

                        case 15:
                            _context.next = 18;
                            break;

                        case 17:
                            return _context.abrupt('return', _promise2.default.resolve());

                        case 18:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, undefined, [[3, 12]]);
        }));

        return function (_x3, _x4) {
            return _ref.apply(this, arguments);
        };
    }();
};

var toggleEmailSubscription = exports.toggleEmailSubscription = function toggleEmailSubscription(code) {
    return function () {
        var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(dispatch, getState) {
            var state, authToken, deployment, list, response, _response;

            return _regenerator2.default.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            state = getState();
                            authToken = (0, _user.getAuthToken)(state);
                            deployment = (0, _config.getDeployment)(state);
                            list = getEmailList(state, code);

                            if (!(list.subscribed || code === 'Unsubscribed All')) {
                                _context2.next = 18;
                                break;
                            }

                            dispatch({
                                payload: code,
                                type: UNSUBSCRIBE_REQUEST
                            });
                            _context2.prev = 6;
                            _context2.next = 9;
                            return _api.EmailList.postUnsubscribeFromEmailList({
                                authToken: authToken,
                                code: code,
                                deployment: deployment
                            });

                        case 9:
                            response = _context2.sent;

                            dispatch({
                                meta: { code: code },
                                payload: response.data,
                                type: UNSUBSCRIBE_SUCCESS
                            });
                            _context2.next = 16;
                            break;

                        case 13:
                            _context2.prev = 13;
                            _context2.t0 = _context2['catch'](6);

                            dispatch({
                                error: true,
                                meta: { code: code },
                                payload: _context2.t0,
                                type: UNSUBSCRIBE_FAIL
                            });

                        case 16:
                            _context2.next = 29;
                            break;

                        case 18:
                            dispatch({
                                payload: code,
                                type: SUBSCRIBE_REQUEST
                            });
                            _context2.prev = 19;
                            _context2.next = 22;
                            return _api.EmailList.postSubscribeToEmailList({ authToken: authToken, code: code, deployment: deployment });

                        case 22:
                            _response = _context2.sent;

                            dispatch({
                                meta: { code: code },
                                payload: _response.data,
                                type: SUBSCRIBE_SUCCESS
                            });
                            _context2.next = 29;
                            break;

                        case 26:
                            _context2.prev = 26;
                            _context2.t1 = _context2['catch'](19);

                            dispatch({
                                error: true,
                                meta: { code: code },
                                payload: _context2.t1,
                                type: SUBSCRIBE_FAIL
                            });

                        case 29:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, undefined, [[6, 13], [19, 26]]);
        }));

        return function (_x5, _x6) {
            return _ref2.apply(this, arguments);
        };
    }();
};

/***/ }),

/***/ "CFLi":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fetchBidderDataIfNeeded = exports.setSearchExclusion = exports.logOutBidder = exports.getMainhostLogin = exports.isProfileComplete = exports.isBidderLoaded = exports.getBidderId = exports.getUserData = exports.isUserAtLeastPartiallyRegistered = exports.isUserLoggedIn = exports.isUserPartiallyRegistered = exports.isConfirmPasswordTriggered = exports.getStripeShippingAddress = exports.getProfileAddress = exports.getCreditCard = exports.getIsStripeCustomer = exports.getBidderType = exports.getBidderEmail = exports.getAuthToken = exports.getUserExcludedFacets = exports.upgradeFacetToComplexFacet = exports.annotateFacetExclusions = exports.SET_FACET_EXCLUSION_SUCCESS = exports.SET_FACET_EXCLUSION_REQUEST = exports.SET_FACET_EXCLUSION_FAIL = exports.LOG_OUT_BIDDER = exports.LOAD_BIDDER_DATA_SUCCESS = exports.LOAD_BIDDER_DATA_REQUEST = exports.LOAD_BIDDER_DATA_FAIL = undefined;

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _regenerator = __webpack_require__("Xxa5");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__("exGp");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _defineProperty2 = __webpack_require__("bOdI");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _keys = __webpack_require__("fZjL");

var _keys2 = _interopRequireDefault(_keys);

var _extends3 = __webpack_require__("Dd8w");

var _extends4 = _interopRequireDefault(_extends3);

exports.default = reducer;

var _completeAccount = __webpack_require__("Qs/t");

var _createAccount = __webpack_require__("FneX");

var _login = __webpack_require__("SpFG");

var _passwordReset = __webpack_require__("fWpZ");

var _updateAccount = __webpack_require__("A6XQ");

var _api = __webpack_require__("zFQO");

var _cloneDeep = __webpack_require__("kvU2");

var _cloneDeep2 = _interopRequireDefault(_cloneDeep);

var _confirmPassword = __webpack_require__("pOp2");

var _reselect = __webpack_require__("bndy");

var _config = __webpack_require__("iS9E");

var _jwtDecode = __webpack_require__("ytdl");

var _jwtDecode2 = _interopRequireDefault(_jwtDecode);

var _ms = __webpack_require__("EarI");

var _ms2 = _interopRequireDefault(_ms);

var _shouldLogin = __webpack_require__("57qU");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Action Types */
var LOAD_BIDDER_DATA_FAIL = exports.LOAD_BIDDER_DATA_FAIL = 'la/domain/bidderData/LOAD_FAIL';
var LOAD_BIDDER_DATA_REQUEST = exports.LOAD_BIDDER_DATA_REQUEST = 'la/domain/bidderData/LOAD_REQUEST';
var LOAD_BIDDER_DATA_SUCCESS = exports.LOAD_BIDDER_DATA_SUCCESS = 'la/domain/bidderData/LOAD_SUCCESS';
var LOG_OUT_BIDDER = exports.LOG_OUT_BIDDER = 'LOG_OUT_BIDDER';
var SET_FACET_EXCLUSION_FAIL = exports.SET_FACET_EXCLUSION_FAIL = 'la/domain/bidderData/SET_FACET_EXCLUSION_FAIL';
var SET_FACET_EXCLUSION_REQUEST = exports.SET_FACET_EXCLUSION_REQUEST = 'la/domain/bidderData/SET_FACET_EXCLUSION_REQUEST';
var SET_FACET_EXCLUSION_SUCCESS = exports.SET_FACET_EXCLUSION_SUCCESS = 'la/domain/bidderData/SET_FACET_EXCLUSION_SUCCESS';

var REDUX_STORE_TIME = (0, _ms2.default)('30m');
var UNREGISTERED = 'unregistered';
var PARTIALLYREGISTEREDBIDDER = 'PartiallyRegisteredBidder';
var REGISTEREDBIDDER = 'bidder';

/* reducer */
var DEFAULT_STATE = {
    authName: '',
    authNuid: '',
    authVerify: '',
    confirmPasswordRequiredTriggered: false,
    excludedFacets: {
        auctionHouse: []
    },
    loaded: 0,
    loading: false,
    mobile: '',
    stripeCustomer: {},
    token: '',
    userData: {}
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var time = void 0;

    switch (action.type) {
        case _createAccount.CREATE_ACCOUNT_SUCCESS:
            time = action.meta.actionTime;
            return (0, _extends4.default)({}, state, {
                loaded: time,
                loading: false,
                token: action.payload
            });
        case _login.LOGIN_SUCCESS:
        case _confirmPassword.CONFIRM_PASSWORD_SUCCESS:
        case _completeAccount.COMPLETE_ACCOUNT_SUCCESS:
        case _passwordReset.PASSWORD_RESET_SUCCESS:
            time = action.meta.actionTime;
            if (typeof action.payload.annualNMS !== 'undefined') {
                action.payload.bidder.ANMS = action.payload.annualNMS;
            }
            return (0, _extends4.default)({}, state, {
                authName: action.payload.mainhostLogin['5Xq_name'],
                authNuid: action.payload.mainhostLogin['5Xq_nuid'],
                authVerify: action.payload.mainhostLogin['5Xq_nverify'],
                confirmPasswordRequiredTriggered: false,
                excludedFacets: renameSearchExclusionsToFacetIds(action.payload.searchExclusions),
                loaded: time,
                loading: false,
                stripeCustomer: action.payload.stripeCustomer,
                token: action.payload.token,
                userData: (0, _extends4.default)({}, action.payload.bidder, {
                    bidderId: Number(action.payload.bidder.bidderId)
                })
            });
        case LOAD_BIDDER_DATA_REQUEST:
        case _login.LOGIN_REQUEST:
        case _createAccount.CREATE_ACCOUNT_REQUEST:
        case _completeAccount.COMPLETE_ACCOUNT_REQUEST:
        case _passwordReset.PASSWORD_RESET_REQUEST:
        case _updateAccount.UPDATE_ACCOUNT_REQUEST:
        case SET_FACET_EXCLUSION_REQUEST:
            return (0, _extends4.default)({}, state, {
                loading: true
            });
        case LOAD_BIDDER_DATA_SUCCESS:
        case _updateAccount.UPDATE_ACCOUNT_SUCCESS:
            time = action.meta.actionTime;
            if (typeof action.payload.annualNMS !== 'undefined') {
                action.payload.bidder.ANMS = action.payload.annualNMS;
            }
            return (0, _extends4.default)({}, state, {
                excludedFacets: renameSearchExclusionsToFacetIds(action.payload.searchExclusions),
                loaded: time,
                loading: false,
                stripeCustomer: action.payload.stripeCustomer,
                userData: (0, _extends4.default)({}, action.payload.bidder, {
                    bidderId: Number(action.payload.bidder.bidderId)
                })
            });
        case _shouldLogin.OPEN_CONFIRM_PASSWORD_MODAL_FROM_CHECKER:
            return (0, _extends4.default)({}, state, {
                confirmPasswordRequiredTriggered: true
            });
        case LOG_OUT_BIDDER:
            return DEFAULT_STATE;
        case SET_FACET_EXCLUSION_SUCCESS:
            time = action.meta.actionTime;
            return (0, _extends4.default)({}, state, {
                excludedFacets: renameSearchExclusionsToFacetIds(action.payload),
                loaded: time,
                loading: false
            });
        case SET_FACET_EXCLUSION_FAIL:
            return (0, _extends4.default)({}, state, {
                loading: false
            });
        default:
            return state;
    }
}

// TODO: remove this, and instead update the item api to return correct names

/* HELPERS */
var FACET_ID_LEGEND = {
    houseIds: 'auctionHouse'
};

// Maps facet names returned by the api to facet names used within the application
var renameSearchExclusionsToFacetIds = function renameSearchExclusionsToFacetIds() {
    var searchExclusions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return (0, _keys2.default)(searchExclusions).reduce(function (excludedFacets, key) {
        return (0, _extends4.default)({}, excludedFacets, (0, _defineProperty3.default)({}, FACET_ID_LEGEND[key], searchExclusions[key].map(function (option) {
            return option.toString();
        })));
    }, {});
};

// END TODO

var annotateFacetExclusions = exports.annotateFacetExclusions = function annotateFacetExclusions() {
    var facets = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var exclusions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return facets.map(function (facet) {
        return !exclusions[facet.id] ? facet : (0, _extends4.default)({}, facet, {
            excludable: true,
            options: facet.options.map(function (option) {
                return (0, _extends4.default)({}, option, {
                    excluded: exclusions[facet.id].includes(option.id)
                });
            })
        });
    });
};

var upgradeFacetToComplexFacet = exports.upgradeFacetToComplexFacet = function upgradeFacetToComplexFacet(facetOptions, exclusions) {
    return {
        exclusions: exclusions,
        inclusions: facetOptions
    };
};

/* SELECTORS */
var stateSelector = function stateSelector(state) {
    return state.user.user;
};

var userDataSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.userData;
});
var stripeCustomerSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.stripeCustomer;
});

var getUserExcludedFacets = exports.getUserExcludedFacets = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.excludedFacets || (0, _cloneDeep2.default)(DEFAULT_STATE.excludedFacets);
});

var getAuthToken = exports.getAuthToken = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.token ? state.token : null;
});

var getBidderEmail = exports.getBidderEmail = (0, _reselect.createSelector)(userDataSelector, function (userData) {
    return userData.email ? userData.email : '';
});

var getBidderType = exports.getBidderType = (0, _reselect.createSelector)(getAuthToken, function (token) {
    if (token) {
        try {
            // TODO: see if this try catch is enough.  We shouldn't throw if something is wrong
            return (0, _jwtDecode2.default)(token).type;
        } catch (error) {
            return UNREGISTERED;
        }
    }
    return UNREGISTERED;
});

var getIsStripeCustomer = exports.getIsStripeCustomer = (0, _reselect.createSelector)(stripeCustomerSelector, function (stripeCustomer) {
    return !!stripeCustomer.id;
});

var getSmallCardDetails = function getSmallCardDetails(card) {
    return {
        brand: card.brand,
        last4: card.last4,
        month: card.exp_month,
        name: card.name,
        token: card.id,
        year: card.exp_year
    };
};

var getCreditCard = exports.getCreditCard = (0, _reselect.createSelector)([stripeCustomerSelector, getIsStripeCustomer], function (stripeCustomer, isStripeCustomer) {
    if (!isStripeCustomer) {
        return {};
    }
    var default_source = stripeCustomer.default_source,
        sources = stripeCustomer.sources;
    var data = sources.data;


    if (sources.total_count === 1) {
        return getSmallCardDetails(data[0]);
    }

    var card = data.find(function (x) {
        return x.id === default_source;
    }) || {};
    return getSmallCardDetails(card);
});

var defaultAddress = {
    address: '',
    address2: '',
    city: '',
    country: '',
    firstName: '',
    lastName: '',
    mobileNumber: '',
    state: '',
    zip: ''
};

var getProfileAddress = exports.getProfileAddress = (0, _reselect.createSelector)([userDataSelector], function (userData) {
    return {
        address: userData.address || '',
        address2: userData.address2 || '',
        city: userData.city || '',
        country: userData.country || '',
        firstName: userData.firstName || '',
        lastName: userData.lastName || '',
        mobileNumber: userData.mobileNumber || userData.phoneNumber || '',
        state: userData.state || '',
        zip: userData.zip || ''
    };
});

var getStripeShippingAddress = exports.getStripeShippingAddress = (0, _reselect.createSelector)([stripeCustomerSelector, getIsStripeCustomer, userDataSelector], function (stripeCustomer, isStripeCustomer, userData) {
    if (!isStripeCustomer) {
        return defaultAddress;
    }
    var shipping = stripeCustomer.shipping || {};
    var address = shipping.address || {};

    return {
        address: address.line1 || '',
        address2: address.line2 || '',
        city: address.city || '',
        country: address.country || '',
        firstName: userData.firstName || '',
        lastName: userData.lastName || '',
        mobileNumber: shipping.phone || '',
        state: address.state || '',
        zip: address.postal_code || ''
    };
});

var isConfirmPasswordTriggered = exports.isConfirmPasswordTriggered = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.confirmPasswordRequiredTriggered;
});

var isUserPartiallyRegistered = exports.isUserPartiallyRegistered = (0, _reselect.createSelector)(getBidderType, function (bidderType) {
    return bidderType === PARTIALLYREGISTEREDBIDDER;
});

var isUserRegistered = (0, _reselect.createSelector)(getBidderType, function (bidderType) {
    return bidderType === REGISTEREDBIDDER;
});

var isUserLoggedIn = exports.isUserLoggedIn = (0, _reselect.createSelector)(getAuthToken, isUserRegistered, function (token, registered) {
    return !!token && registered;
});

var isUserAtLeastPartiallyRegistered = exports.isUserAtLeastPartiallyRegistered = (0, _reselect.createSelector)(isUserPartiallyRegistered, isUserLoggedIn, function (registered, loggedIn) {
    return registered || loggedIn;
});

var getUserData = exports.getUserData = (0, _reselect.createSelector)(isUserAtLeastPartiallyRegistered, userDataSelector, function (userAtLeastPartiallyRegistered, userData) {
    return userAtLeastPartiallyRegistered ? userData : {};
});

var getBidderId = exports.getBidderId = (0, _reselect.createSelector)(userDataSelector, function (userData) {
    return userData.bidderId ? userData.bidderId : -1;
});

var isBidderLoaded = exports.isBidderLoaded = (0, _reselect.createSelector)(getBidderId, function (bidderId) {
    return bidderId > 0;
});

var isProfileComplete = exports.isProfileComplete = (0, _reselect.createSelector)(userDataSelector, function (userData) {
    return userData ? !!userData.profileComplete : false;
});

var getLoadTimeForUserData = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.loaded || 0;
});

var isUserDataLoading = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.loading || false;
});

var shouldFetchUserData = function shouldFetchUserData(state) {
    var userAtLeastPartiallyRegistered = isUserAtLeastPartiallyRegistered(state);
    if (!userAtLeastPartiallyRegistered) return false;

    var userData = getUserData(state);
    if (userData) {
        var loaded = getLoadTimeForUserData(state);
        var time = Date.now();
        var diff = time - loaded;
        if (diff < REDUX_STORE_TIME) return false;
    }
    var loading = isUserDataLoading(state);
    return !loading;
};

var getMainhostLogin = exports.getMainhostLogin = (0, _reselect.createSelector)(stateSelector, function (state) {
    return {
        authName: state.authName,
        authNuid: state.authNuid,
        authVerify: state.authVerify
    };
});

/* ACTION CREATORS */
var logOutBidder = exports.logOutBidder = function logOutBidder() {
    return {
        type: LOG_OUT_BIDDER
    };
};

var loadBidderData = function loadBidderData(_ref) {
    var authToken = _ref.authToken,
        deployment = _ref.deployment;
    return function () {
        var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch) {
            var response;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.prev = 0;

                            dispatch({
                                payload: authToken,
                                type: LOAD_BIDDER_DATA_REQUEST
                            });
                            _context.next = 4;
                            return _api.Bidder.fetchBidderData({ authToken: authToken, deployment: deployment });

                        case 4:
                            response = _context.sent;
                            return _context.abrupt('return', dispatch({
                                meta: { actionTime: Date.now() },
                                payload: response.data,
                                type: LOAD_BIDDER_DATA_SUCCESS
                            }));

                        case 8:
                            _context.prev = 8;
                            _context.t0 = _context['catch'](0);

                            dispatch({
                                error: true,
                                meta: { token: authToken },
                                payload: _context.t0,
                                type: LOAD_BIDDER_DATA_FAIL
                            });
                            dispatch(logOutBidder());

                        case 12:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, undefined, [[0, 8]]);
        }));

        return function (_x6) {
            return _ref2.apply(this, arguments);
        };
    }();
};

var setSearchExclusion = exports.setSearchExclusion = function setSearchExclusion(facetId, optionId, exclude) {
    return function () {
        var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(dispatch, getState) {
            var state, authToken, deployment, requestParams, response;
            return _regenerator2.default.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            state = getState();
                            authToken = getAuthToken(state);
                            deployment = (0, _config.getDeployment)(state);
                            requestParams = { authToken: authToken, deployment: deployment, exclude: exclude, facetId: facetId, optionId: optionId };
                            _context2.prev = 4;

                            dispatch({
                                type: SET_FACET_EXCLUSION_REQUEST
                            });
                            _context2.next = 8;
                            return _api.Bidder.postSetSearchFacetOptionExclusion(requestParams);

                        case 8:
                            response = _context2.sent;

                            dispatch({
                                meta: { actionTime: Date.now() },
                                payload: response.data,
                                type: SET_FACET_EXCLUSION_SUCCESS
                            });
                            _context2.next = 15;
                            break;

                        case 12:
                            _context2.prev = 12;
                            _context2.t0 = _context2['catch'](4);

                            dispatch({
                                error: true,
                                payload: _context2.t0.error_message,
                                type: SET_FACET_EXCLUSION_FAIL
                            });

                        case 15:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, undefined, [[4, 12]]);
        }));

        return function (_x7, _x8) {
            return _ref3.apply(this, arguments);
        };
    }();
};

var fetchBidderDataIfNeeded = exports.fetchBidderDataIfNeeded = function fetchBidderDataIfNeeded(token, force) {
    return function (dispatch, getState) {
        var state = getState();
        var authToken = token || getAuthToken(state);
        var deployment = (0, _config.getDeployment)(state);
        if (force || shouldFetchUserData(state)) {
            return dispatch(loadBidderData({ authToken: authToken, deployment: deployment }));
        }
        return _promise2.default.resolve();
    };
};

/***/ }),

/***/ "CIJv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"seo":"seo___2Ktk2","container":"container___2zAT8","column":"column___1Nb1N","wrapper":"wrapper___syBEF","column-title":"column-title___1L7rd"};

/***/ }),

/***/ "COnH":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getBrowserDataFromUA = undefined;

var _uaParserJs = __webpack_require__("GCDA");

var _uaParserJs2 = _interopRequireDefault(_uaParserJs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getMinimumBrowserVersions = function getMinimumBrowserVersions() {
    return {
        chrome: 45,
        edge: 13,
        firefox: 41,
        ie: 11,
        safari: 9
    };
};

var getBrowserDataFromUA = exports.getBrowserDataFromUA = function getBrowserDataFromUA(userAgentString) {
    var parser = new _uaParserJs2.default();

    parser.setUA(userAgentString);
    var result = parser.getResult();

    var name = '';
    var os = '';
    var majorVersion = 0;
    var mobile = '';
    var deviceType = '';

    if (result && result.browser) {
        if (typeof result.browser.name === 'string') {
            // Googlebot don't have a name
            name = result.browser.name.toLowerCase();
        }
        if (result.browser.major) {
            majorVersion = parseInt(result.browser.major, 10);
        }
    }
    if (result && result.os) {
        if (typeof result.os.name === 'string') {
            os = result.os.name.toLowerCase();
        }
    }
    if (result && result.device) {
        deviceType = result.device.type || ''; // [console, mobile, tablet, smarttv, wearable, embedded]

        if (result.device.type === 'mobile') {
            mobile = 'phone';
        } else if (result.device.type === 'tablet') {
            mobile = result.device.type;
        }
    }

    var minimumBrowserVersions = getMinimumBrowserVersions();

    var isOutdated = false;
    if (Object.prototype.hasOwnProperty.call(minimumBrowserVersions, name)) {
        isOutdated = minimumBrowserVersions[name] > majorVersion;
    }

    var isGoogle = userAgentString.toLowerCase().includes('google');
    if (isGoogle) {
        isOutdated = false;
    }

    return {
        deviceType: deviceType,
        isOutdated: isOutdated,
        majorVersion: majorVersion,
        microsoftBrowser: name === 'ie' || name === 'edge',
        mobile: mobile,
        name: name,
        os: os
    };
};

/***/ }),

/***/ "CRk2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _jsx2 = __webpack_require__("dcb+");

var _jsx3 = _interopRequireDefault(_jsx2);

var _dec, _class;

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propsComparer = __webpack_require__("wsGv");

var _propsComparer2 = _interopRequireDefault(_propsComparer);

var _reactRedux = __webpack_require__("RH2O");

var _reactIntl = __webpack_require__("Pq8k");

var _item = __webpack_require__("Gk4U");

var _filteredItems = __webpack_require__("IeGF");

var _similarItems = __webpack_require__("sjfW");

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _SimilarItems = __webpack_require__("yi49");

var _SimilarItems2 = _interopRequireDefault(_SimilarItems);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SimilarItemsContainer = (_dec = (0, _reactRedux.connect)(function (state, _ref) {
    var facets = _ref.facets,
        itemId = _ref.itemId,
        windowWidth = _ref.windowWidth;

    var headerMessage = (0, _jsx3.default)(_reactIntl.FormattedMessage, {
        id: 'discover_related_items'
    });
    var item = (0, _item.getItem)(state, itemId);
    var itemTitle = item.title;


    var limit = windowWidth < 991 ? 12 : 15;
    var similarItems = (0, _similarItems.getSimilarItems)(state, itemId, limit);

    if (similarItems.length === 0) {
        similarItems = (0, _filteredItems.getMostPopularItemsByBids)(state, item.sellerId);
        headerMessage = (0, _jsx3.default)(_reactIntl.FormattedMessage, {
            id: 'bid_most_popular_items'
        });
    }

    return {
        headerMessage: headerMessage,
        itemTitle: itemTitle,
        similarItems: similarItems
    };
}), _dec(_class = function (_Component) {
    (0, _inherits3.default)(SimilarItemsContainer, _Component);

    function SimilarItemsContainer() {
        (0, _classCallCheck3.default)(this, SimilarItemsContainer);
        return (0, _possibleConstructorReturn3.default)(this, (SimilarItemsContainer.__proto__ || (0, _getPrototypeOf2.default)(SimilarItemsContainer)).apply(this, arguments));
    }

    (0, _createClass3.default)(SimilarItemsContainer, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps) {
            return (0, _propsComparer2.default)(this.props, nextProps, ['centerHeader', 'className', 'facets', 'itemId', 'itemTitle', 'slider', 'headerMessage', 'similarItems', 'windowWidth']);
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                centerHeader = _props.centerHeader,
                className = _props.className,
                facets = _props.facets,
                headerMessage = _props.headerMessage,
                itemTitle = _props.itemTitle,
                similarItems = _props.similarItems,
                slider = _props.slider;


            return (0, _jsx3.default)(_SimilarItems2.default, {
                centerHeader: centerHeader,
                className: className,
                facets: facets,
                headerMessage: headerMessage,
                itemTitle: itemTitle,
                similarItems: similarItems,
                slider: slider
            });
        }
    }]);
    return SimilarItemsContainer;
}(_react.Component)) || _class);
exports.default = SimilarItemsContainer;
module.exports = exports['default'];

/***/ }),

/***/ "CakR":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getWonItemsPageUrl = exports.signupLadySmallUrl = exports.logoUrl = undefined;

var _typeof2 = __webpack_require__("pFYg");

var _typeof3 = _interopRequireDefault(_typeof2);

var _stringify = __webpack_require__("mvHQ");

var _stringify2 = _interopRequireDefault(_stringify);

exports.safeTitle = safeTitle;
exports.setQueryParams = setQueryParams;
exports.addImageQueryParams = addImageQueryParams;
exports.getAuctioneerLogoUrl = getAuctioneerLogoUrl;
exports.getAllUpcomingAuctionsUrl = getAllUpcomingAuctionsUrl;
exports.getAllEndedAuctionsUrl = getAllEndedAuctionsUrl;
exports.getAuctioneerDirectoryUrl = getAuctioneerDirectoryUrl;
exports.getAuctionResultsUrl = getAuctionResultsUrl;
exports.getPriceGuideBaseUrl = getPriceGuideBaseUrl;
exports.getPriceGuideUrl = getPriceGuideUrl;
exports.getIntellectualPropertyUrl = getIntellectualPropertyUrl;
exports.getPrivacyUrl = getPrivacyUrl;
exports.getTerminologyUrl = getTerminologyUrl;
exports.getTermsAndConditionsUrl = getTermsAndConditionsUrl;
exports.getItemUrl = getItemUrl;
exports.getCatalogUrl = getCatalogUrl;
exports.getCatalogConsoleUrl = getCatalogConsoleUrl;
exports.getNewCatalogConsoleUrl = getNewCatalogConsoleUrl;
exports.getNotFoundUrl = getNotFoundUrl;
exports.getSellerUrl = getSellerUrl;
exports.getThumbnailItemImageUrl = getThumbnailItemImageUrl;
exports.getMediumItemImageUrl = getMediumItemImageUrl;
exports.getLargeItemImageUrl = getLargeItemImageUrl;
exports.getXLargeItemImageUrl = getXLargeItemImageUrl;
exports.getItemImageUrl = getItemImageUrl;
exports.getCoverLotSecondaryImageUrl = getCoverLotSecondaryImageUrl;
exports.getCoverLotSecondaryImageUrlLarge = getCoverLotSecondaryImageUrlLarge;
exports.getCoverLotSecondaryImageUrlSmall = getCoverLotSecondaryImageUrlSmall;
exports.getItemCardImageUrl = getItemCardImageUrl;
exports.getCoverLotPrimaryImageUrl = getCoverLotPrimaryImageUrl;
exports.getCoverLotPrimaryImageUrlLarge = getCoverLotPrimaryImageUrlLarge;
exports.getCoverLotPrimaryImageUrlSmall = getCoverLotPrimaryImageUrlSmall;
exports.getMegaNavImageUrlLarge = getMegaNavImageUrlLarge;
exports.getMegaNavImageUrlSmall = getMegaNavImageUrlSmall;
exports.getFollowedSellersUrl = getFollowedSellersUrl;
exports.getMyBidsUrl = getMyBidsUrl;
exports.getMyAuctionsUrl = getMyAuctionsUrl;
exports.getProfileUrl = getProfileUrl;
exports.getSavedItemsUrl = getSavedItemsUrl;
exports.getSavedSearchesUrl = getSavedSearchesUrl;
exports.getDeskSupportEmail = getDeskSupportEmail;
exports.getAdQuestionLink = getAdQuestionLink;
exports.getCategoryLandingPageBaseUrl = getCategoryLandingPageBaseUrl;
exports.getSearchLandingPageBaseUrl = getSearchLandingPageBaseUrl;
exports.getSearchLandingPageMostPopular = getSearchLandingPageMostPopular;
exports.getSearchLandingPageMostBids = getSearchLandingPageMostBids;
exports.getCategoryLandingPageUrl = getCategoryLandingPageUrl;
exports.getCategoryPageUrlFromObject = getCategoryPageUrlFromObject;
exports.separateURL = separateURL;
exports.getCuratorImageUrl = getCuratorImageUrl;
exports.getCheckoutConfirmationUrl = getCheckoutConfirmationUrl;
exports.getSearchAuctioneerUrl = getSearchAuctioneerUrl;
exports.getSearchAuctioneerSoldUrl = getSearchAuctioneerSoldUrl;
exports.getSimilarItemsUrl = getSimilarItemsUrl;
exports.getLiveBiddingUrl = getLiveBiddingUrl;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var logoUrl = exports.logoUrl = 'https://p1.liveauctioneers.com/dist/images/logo_og.jpg?format=pjpg&auto=webp&quality=50';
var signupLadySmallUrl = exports.signupLadySmallUrl = 'https://p1.liveauctioneers.com/dist/images/SignupLadySmall.png?auto=webp&quality=50';

function safeTitle() {
    var title = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    var safe = title.trim()
    // & to and
    .replace(/&/g, 'and')
    // comma to hyphen
    .replace(/,+/g, '-')
    // * to hyphen
    .replace(/\*+/g, '-')
    // ; to hyphen
    .replace(/;+/g, '-')
    // : to hyphen
    .replace(/:+/g, '-')
    // ' to hyphen
    .replace(/'+/g, '-')
    // " to hyphen
    .replace(/"+/g, '-').replace(/-*\s+-*/g, '-')
    // non letter/digit/& to nothing
    .replace(/[^a-zA-Z0-9-_&]/g, '')
    // many hyphen to one
    .replace(/--+/g, '-').toLowerCase();
    return safe;
}

function setQueryParams(url) {
    var queryParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var cleanedUrl = url.replace(/\?.*/, '');
    var paramString = [];

    for (var key in queryParams) {
        var value = queryParams[key];
        paramString.push(key + '=' + value);
    }

    if (paramString.length > 0) {
        return cleanedUrl + '?' + paramString.join('&');
    }

    return cleanedUrl;
}

function addImageQueryParams(url, width) {
    var correctImageUrl = url.replace('http://', 'https://');
    return correctImageUrl + '?width=' + width + '&auto=webp&format=pjpg';
}

function getAuctioneerLogoUrl(auctioneer) {
    var width = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 110;

    return 'https://images.liveauctioneers.com/houses/logos/lg/' + auctioneer + '_large.jpg?width=' + width + '&format=pjpg&auto=webp&quality=100';
}

function getAllUpcomingAuctionsUrl() {
    var params = {
        catalog_status: 'live,online',
        page: 1,
        pageSize: 24
    };
    return '/catalog/search?parameters=' + encodeURIComponent((0, _stringify2.default)(params));
}

function getAllEndedAuctionsUrl(baseUrl, sellerId) {
    var params = {
        catalog_status: 'done',
        house_id: sellerId
    };
    return '/catalog/search?parameters=' + encodeURIComponent((0, _stringify2.default)(params));
}

function getAuctioneerDirectoryUrl() {
    return '/auctioneer/directory/';
}

function getAuctionResultsUrl() {
    return '/auction-results';
}

function getPriceGuideBaseUrl() {
    return '/price-guide/';
}

function getPriceGuideUrl(name, id) {
    return '' + getPriceGuideBaseUrl() + name + '/' + id + '/';
}

function getIntellectualPropertyUrl() {
    return '/intellectualproperty';
}

function getPrivacyUrl() {
    return '/privacy';
}

function getTerminologyUrl() {
    return '/terminology';
}

function getTermsAndConditionsUrl() {
    return '/termsandconditions';
}

function getItemUrl(id, title) {
    return '/item/' + id + '_' + safeTitle(title).replace(/-+$/, '');
}

function getCatalogUrl(id, title) {
    return '/catalog/' + id + '_' + safeTitle(title).replace(/-+$/, '') + '/';
}

function getCatalogConsoleUrl(classicBaseUrl, id) {
    return classicBaseUrl + '/bidapplet' + id;
}

function getNewCatalogConsoleUrl(id, title) {
    return '/console/' + id + '_' + safeTitle(title).replace(/-+$/, '') + '/';
}

function getNotFoundUrl() {
    return '/not-found';
}

function getSellerUrl(id, title) {
    var url = '/auctioneer/' + id + '/' + safeTitle(title).replace(/-+$/, '') + '/';
    return url;
}

function generateImageUrl(sellerId, catalogId, itemId, imgNumber, imageVersion, size) {
    var limitQuality = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : true;
    var cropImage = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : false;

    if (!sellerId || !catalogId || !itemId || !imgNumber) {
        return '';
    }

    var quality = limitQuality ? '&quality=50' : '';
    var crop = cropImage ? '&crop=' + cropImage : '';

    return 'https://p1.liveauctioneers.com/' + sellerId + '/' + catalogId + '/' + itemId + '_' + imgNumber + '_x.jpg?version=' + imageVersion + '&width=' + size + '&format=pjpg&auto=webp' + quality + crop;
}

function getThumbnailItemImageUrl(sellerId, catalogId, itemId, imgNumber) {
    var imageVersion = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 1;
    var gallery = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;

    return generateImageUrl(sellerId, catalogId, itemId, imgNumber, imageVersion, gallery ? 64 : 128);
}

function getMediumItemImageUrl(sellerId, catalogId, itemId, imgNumber) {
    var imageVersion = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 1;

    return generateImageUrl(sellerId, catalogId, itemId, imgNumber, imageVersion, 512);
}

function getLargeItemImageUrl(sellerId, catalogId, itemId, imgNumber) {
    var imageVersion = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 1;

    return generateImageUrl(sellerId, catalogId, itemId, imgNumber, imageVersion, 768);
}

function getXLargeItemImageUrl(sellerId, catalogId, itemId, imgNumber) {
    var imageVersion = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 1;

    return generateImageUrl(sellerId, catalogId, itemId, imgNumber, imageVersion, 1600, false);
}

function getItemImageUrl(sellerId, catalogId, itemId, imgNumber) {
    var imageVersion = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 1;
    var width = arguments[5];
    var limitQuality = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : true;
    var crop = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : false;

    return generateImageUrl(sellerId, catalogId, itemId, imgNumber, imageVersion, width, limitQuality, crop);
}

function getCoverLotSecondaryImageUrl(sellerId, catalogId, itemId, imgNumber) {
    var imageVersion = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 1;
    var featured = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;

    return generateImageUrl(sellerId, catalogId, itemId, imgNumber, imageVersion, featured ? 170 : 130);
}

function getCoverLotSecondaryImageUrlLarge(sellerId, catalogId, itemId, imgNumber) {
    var imageVersion = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 1;

    return generateImageUrl(sellerId, catalogId, itemId, imgNumber, imageVersion, 202);
}

function getCoverLotSecondaryImageUrlSmall(sellerId, catalogId, itemId, imgNumber) {
    var imageVersion = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 1;

    return generateImageUrl(sellerId, catalogId, itemId, imgNumber, imageVersion, 105);
}

function getItemCardImageUrl(sellerId, catalogId, itemId, imgNumber) {
    var imageVersion = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 1;

    return generateImageUrl(sellerId, catalogId, itemId, imgNumber, imageVersion, 280);
}

function getCoverLotPrimaryImageUrl(sellerId, catalogId, itemId, imgNumber) {
    var imageVersion = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 1;
    var featured = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;

    return generateImageUrl(sellerId, catalogId, itemId, imgNumber, imageVersion, featured ? 340 : 250);
}

function getCoverLotPrimaryImageUrlLarge(sellerId, catalogId, itemId, imgNumber) {
    var imageVersion = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 1;

    return generateImageUrl(sellerId, catalogId, itemId, imgNumber, imageVersion, 410);
}

function getCoverLotPrimaryImageUrlSmall(sellerId, catalogId, itemId, imgNumber) {
    var imageVersion = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 1;

    return generateImageUrl(sellerId, catalogId, itemId, imgNumber, imageVersion, 210);
}

function getMegaNavImageUrlLarge(category) {
    return 'https://p1.liveauctioneers.com/dist/images/desktop-' + category + '.jpg?height=382&format=pjpg&auto=webp&quality=50';
}

function getMegaNavImageUrlSmall(category) {
    return 'https://p1.liveauctioneers.com/dist/images/tablet-' + category + '.jpg?height=288&format=pjpg&auto=webp&quality=50';
}

function getFollowedSellersUrl() {
    return '/dashboard/followed-auctioneers';
}

function getMyBidsUrl() {
    return '/dashboard/my-bids';
}

function getMyAuctionsUrl() {
    return '/dashboard/my-auctions';
}

function getProfileUrl() {
    return '/dashboard/profile';
}

function getSavedItemsUrl() {
    return '/dashboard/saved-items';
}

function getSavedSearchesUrl(append) {
    return '/dashboard/search-and-alerts/' + (append ? append + '/' : '');
}

function getDeskSupportEmail(name, email) {
    var fields = [];
    name && fields.push('interaction[name]=' + encodeURIComponent(name));
    email && fields.push('interaction[email]=' + email);

    return 'https://liveauctioneers.desk.com/customer/portal/emails/new' + (fields.length ? '?' + fields.join('&') : '');
}

function getAdQuestionLink() {
    return 'https://www.surveymonkey.com/r/KFCCVSX';
}

var categoryLandingIds = {
    art: 1,
    asian: 158,
    collectibles: 2,
    fashion: 3,
    furniture: 4,
    'home-garden': 5,
    jewelry: 6
};

function getCategoryLandingPageBaseUrl() {
    return '/c/';
}

function getSearchLandingPageBaseUrl() {
    return '/search/';
}

function getSearchLandingPageMostPopular() {
    var params = {
        page: 1,
        sort: '-popularity'
    };
    return getSearchLandingPageBaseUrl() + '?parameters=' + encodeURIComponent((0, _stringify2.default)(params));
}

function getSearchLandingPageMostBids() {
    var params = {
        page: 1,
        sort: '-bidCount'
    };
    return getSearchLandingPageBaseUrl() + '?parameters=' + encodeURIComponent((0, _stringify2.default)(params));
}

function getCategoryLandingPageUrl(category) {
    var categoryId = categoryLandingIds[category];
    if (categoryId) {
        return '' + getCategoryLandingPageBaseUrl() + category + '/' + categoryId + '/';
    }

    return getCategoryLandingPageBaseUrl();
}

function getCategoryPageUrlFromObject(category) {
    var url = getCategoryLandingPageBaseUrl();
    if (!category || !category.l1CategoryId) {
        return url;
    }
    url += category.l1CategoryUrl + '/';
    if ((0, _typeof3.default)(category.l2CategoryId) !== undefined && category.l2CategoryId) {
        url += category.l2CategoryUrl + '/' + category.l1CategoryId + '/' + category.l2CategoryId + '/';
    } else {
        url += category.l1CategoryId + '/';
    }
    return url;
}

function separateURL(url) {
    var match = url.match(/^(https?:)\/\/(([^:/?#]*)(?::([0-9]+))?)([/]{0,1}[^?#]*)(\?[^#]*|)(#.*|)$/);
    if (match === null) {
        return {
            host: '',
            path: ''
        };
    }
    return {
        host: match[2],
        path: match[5]
    };
}

function getCuratorImageUrl(baseUrl, curatorId, curatorImageFileName) {
    return baseUrl + '/' + curatorId + '/' + curatorImageFileName;
}

function getCheckoutConfirmationUrl(sellerId, itemId) {
    return '/confirmation/' + sellerId + '/' + itemId;
}

function getSearchAuctioneerUrl(sellerId) {
    var params = {
        house_id: '' + sellerId,
        page: 1,
        sort: '-popularity'
    };
    return '/search?parameters=' + encodeURIComponent((0, _stringify2.default)(params));
}

function getSearchAuctioneerSoldUrl(sellerId) {
    var params = { house_id: '' + sellerId, page: 1, status: 'archive' };
    return '/search?parameters=' + encodeURIComponent((0, _stringify2.default)(params));
}

function getSimilarItemsUrl() {
    var title = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    var keyword = title.split(/\s+/g).map(function (word) {
        return '"' + word + '"';
    }).join(' OR ').replace(/"/g, '\\"');
    var params = '' + ('{"keyword":"' + keyword + '","status":["online", "live", "upcoming"]}');

    return '/search?parameters=' + encodeURIComponent(params);
}

function getLiveBiddingUrl(catalogId) {
    return '/console/' + catalogId;
}

var getWonItemsPageUrl = exports.getWonItemsPageUrl = function getWonItemsPageUrl() {
    return '/dashboard/won-items';
};

/***/ }),

/***/ "CiCz":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = __webpack_require__("dcb+");

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propsComparer = __webpack_require__("wsGv");

var _propsComparer2 = _interopRequireDefault(_propsComparer);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _BreadcrumbList = __webpack_require__("C5B+");

var _BreadcrumbList2 = _interopRequireDefault(_BreadcrumbList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BreadcrumbList = function (_Component) {
    (0, _inherits3.default)(BreadcrumbList, _Component);

    function BreadcrumbList() {
        (0, _classCallCheck3.default)(this, BreadcrumbList);
        return (0, _possibleConstructorReturn3.default)(this, (BreadcrumbList.__proto__ || (0, _getPrototypeOf2.default)(BreadcrumbList)).apply(this, arguments));
    }

    (0, _createClass3.default)(BreadcrumbList, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps) {
            return (0, _propsComparer2.default)(this.props, nextProps, ['breadcrumbs', 'secondaryNavigation']);
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                breadcrumbs = _props.breadcrumbs,
                secondaryNavigation = _props.secondaryNavigation;


            return (0, _jsx3.default)('div', {
                className: _BreadcrumbList2.default['breadcrumb-list']
            }, void 0, (0, _jsx3.default)('div', {
                className: _BreadcrumbList2.default['breadcrumb-container']
            }, void 0, (0, _jsx3.default)('ul', {
                className: _BreadcrumbList2.default.breadcrumbs
            }, void 0, breadcrumbs), secondaryNavigation));
        }
    }]);
    return BreadcrumbList;
}(_react.Component);

exports.default = BreadcrumbList;
module.exports = exports['default'];

/***/ }),

/***/ "CwSH":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _liveCatalogStatus = __webpack_require__("grTh");

var LiveCatalogStatus = {
    fetchLiveCatalogStatus: _liveCatalogStatus.LiveCatalogStatusRemote.fetchLiveCatalogStatus
};

exports.default = LiveCatalogStatus;
module.exports = exports['default'];

/***/ }),

/***/ "CyO3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = __webpack_require__("dcb+");

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propsComparer = __webpack_require__("wsGv");

var _propsComparer2 = _interopRequireDefault(_propsComparer);

var _classnames = __webpack_require__("HW6M");

var _classnames2 = _interopRequireDefault(_classnames);

var _reactIntl = __webpack_require__("Pq8k");

var _urls = __webpack_require__("CakR");

var _components = __webpack_require__("bGai");

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _CuratorInfo = __webpack_require__("018r");

var _CuratorInfo2 = _interopRequireDefault(_CuratorInfo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CuratorInfo = function (_Component) {
    (0, _inherits3.default)(CuratorInfo, _Component);

    function CuratorInfo() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, CuratorInfo);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = CuratorInfo.__proto__ || (0, _getPrototypeOf2.default)(CuratorInfo)).call.apply(_ref, [this].concat(args))), _this), _this.mapCurators = function (curator) {
            var curatorImgUrl = _this.props.curatorImgUrl;

            return (0, _jsx3.default)('div', {
                className: _CuratorInfo2.default.curator
            }, curator.id, (0, _jsx3.default)(_components.ImageWithFallback, {
                className: 'img-circle ' + _CuratorInfo2.default.image,
                src: (0, _urls.getCuratorImageUrl)(curatorImgUrl, curator.id, curator.imageFileName)
            }), (0, _jsx3.default)('div', {
                className: _CuratorInfo2.default.details
            }, void 0, (0, _jsx3.default)('div', {
                className: _CuratorInfo2.default.name
            }, void 0, curator.name), (0, _jsx3.default)('div', {
                className: _CuratorInfo2.default.title
            }, void 0, curator.expertise)), (0, _jsx3.default)('div', {
                style: { clear: 'both' }
            }));
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(CuratorInfo, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps) {
            return (0, _propsComparer2.default)(this.props, nextProps, ['className', 'curatorImgUrl', 'curators']);
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                curators = _props.curators,
                className = _props.className;


            var classes = (0, _classnames2.default)(_CuratorInfo2.default['curator-info'], className);

            return curators.length ? (0, _jsx3.default)('div', {
                className: classes
            }, void 0, (0, _jsx3.default)('span', {
                className: _CuratorInfo2.default.label
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'auction_curated_by'
            }), ':'), curators.map(this.mapCurators)) : (0, _jsx3.default)('div', {});
        }
    }]);
    return CuratorInfo;
}(_react.Component);

exports.default = CuratorInfo;
module.exports = exports['default'];

/***/ }),

/***/ "D6G4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fetchDataForCatalogSearchPage = exports.updateFacetsSelected = exports.updateSearchParams = exports.fetchCatalogsTodayCountIfNeeded = exports.fetchCatalogSearchResults = exports.getCatalogSearchDate = exports.getCatalogSearchPageSize = exports.getCatalogSearchPage = exports.getCatalogSearchParams = exports.getCatalogSearchAuctionStatusFacetValues = exports.getCatalogSearchFacets = exports.getCatalogSearchSubmitted = exports.getCatalogSearchTotalCount = exports.getCatalogSearchIds = exports.getCatalogsTodayCount = exports.getUiCatalogSearch = exports.LOAD_CATALOGS_TODAY_COUNT_FAIL = exports.LOAD_CATALOGS_TODAY_COUNT_SUCCESS = exports.LOAD_CATALOGS_TODAY_COUNT_REQUEST = exports.UPDATE_FACETS_SELECTED = exports.UPDATE_CATALOG_SEARCH_PARAMS = exports.LOAD_CATALOG_SEARCH_SUCCESS = exports.LOAD_CATALOG_SEARCH_REQUEST = exports.LOAD_CATALOG_SEARCH_FAIL = undefined;

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _regenerator = __webpack_require__("Xxa5");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__("exGp");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;

var _api = __webpack_require__("zFQO");

var _cloneDeep = __webpack_require__("kvU2");

var _cloneDeep2 = _interopRequireDefault(_cloneDeep);

var _reselect = __webpack_require__("bndy");

var _catalogAd = __webpack_require__("0QM2");

var _catalog = __webpack_require__("yv/Z");

var _coverLots = __webpack_require__("fr8l");

var _searchFacets = __webpack_require__("XTPq");

var _config = __webpack_require__("iS9E");

var _sortBy = __webpack_require__("KBYM");

var _sortBy2 = _interopRequireDefault(_sortBy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Action Types */
var prefix = 'la/ui/catalogSearch';
var LOAD_CATALOG_SEARCH_FAIL = exports.LOAD_CATALOG_SEARCH_FAIL = prefix + '/LOAD_FAIL';
var LOAD_CATALOG_SEARCH_REQUEST = exports.LOAD_CATALOG_SEARCH_REQUEST = prefix + '/LOAD_REQUEST';
var LOAD_CATALOG_SEARCH_SUCCESS = exports.LOAD_CATALOG_SEARCH_SUCCESS = prefix + '/LOAD_SUCCESS';
var UPDATE_CATALOG_SEARCH_PARAMS = exports.UPDATE_CATALOG_SEARCH_PARAMS = prefix + '/UPDATE_SEARCH_PARAMS';
var UPDATE_FACETS_SELECTED = exports.UPDATE_FACETS_SELECTED = prefix + '/UPDATE_FACETS_SELECTED';
var LOAD_CATALOGS_TODAY_COUNT_REQUEST = exports.LOAD_CATALOGS_TODAY_COUNT_REQUEST = prefix + '/LOAD_TODAY_REQUEST';
var LOAD_CATALOGS_TODAY_COUNT_SUCCESS = exports.LOAD_CATALOGS_TODAY_COUNT_SUCCESS = prefix + '/LOAD_TODAY_SUCCESS';
var LOAD_CATALOGS_TODAY_COUNT_FAIL = exports.LOAD_CATALOGS_TODAY_COUNT_FAIL = prefix + '/LOAD_TODAY_FAIL';

// reducer
var DEFAULT_STATE = {
    catalogIds: [],
    error: false,
    facets: [],
    searchParams: {
        catalog_status: 'live,online',
        page: 1,
        pageSize: 24
    },
    submitted: false,
    success: false,
    totalFound: 0
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        case LOAD_CATALOG_SEARCH_FAIL:
            return (0, _extends3.default)({}, state, {
                error: true,
                submitted: false,
                success: false
            });
        case LOAD_CATALOG_SEARCH_REQUEST:
            return (0, _extends3.default)({}, state, {
                submitted: true,
                success: false
            });
        case LOAD_CATALOG_SEARCH_SUCCESS:
            var renameEndedToPast = function renameEndedToPast(facet) {
                if (facet.id === 'catalog_status') {
                    facet.values = facet.values.map(function (value) {
                        if (value.value === 'done') value.name = 'Past';
                        return value;
                    });
                }

                return facet;
            };

            // TODO: sometimes solr has outdated results so it returns catalogs that don't
            // fit the catalog_status criteria this is a temporay fix till that gets sorted.


            var filterResults = function filterResults(results, catalogStatus) {
                if (!results) return results;

                var statusList = catalogStatus.split(',').map(function (status) {
                    return status.trim();
                });

                var filteredList = results.filter(function (catalog) {
                    return statusList.includes(catalog.ncatalog_status);
                });

                return filteredList;
            };

            var _action$payload = action.payload,
                response = _action$payload.response,
                catalogStatus = _action$payload.catalogStatus;

            var catIds = filterResults(response.results, catalogStatus).map(function (c) {
                return c.catid;
            });

            return (0, _extends3.default)({}, state, {
                catalogIds: catIds,
                facets: response.facets.map(renameEndedToPast),
                submitted: false,
                success: true,
                totalFound: response.count
            });
        case UPDATE_CATALOG_SEARCH_PARAMS:
            return (0, _extends3.default)({}, state, {
                searchParams: (0, _extends3.default)({}, action.payload)
            });
        case UPDATE_FACETS_SELECTED:
            var _action$payload2 = action.payload,
                facets = _action$payload2.facets,
                searchParams = _action$payload2.searchParams;
            // this adjusts the saved facets which we get from the initial call. The api doesn't return all facets after you run a search
            // this matches what you searched for against all of the facets and sets their selected value.

            var newFacetModel = (0, _cloneDeep2.default)(facets);
            newFacetModel.forEach(function (facet) {
                var facetAndParamProp = facet.qs;
                if (facetAndParamProp !== 'date') {
                    if (searchParams[facetAndParamProp]) {
                        var paramsSearched = searchParams[facetAndParamProp].split(',');
                        facet.values.forEach(function (facetObj) {
                            var selected = paramsSearched.find(function (param) {
                                return param === facetObj.value;
                            });
                            if (selected) {
                                facetObj.selected = true;
                            } else {
                                facetObj.selected = false;
                            }
                        });
                    } else {
                        facet.values.forEach(function (facetObj) {
                            facetObj.selected = false;
                        });
                    }

                    facet.values = (0, _sortBy2.default)(facet.values, function (value) {
                        return !value.selected;
                    });
                }
            });

            return (0, _extends3.default)({}, state, {
                facets: newFacetModel
            });
        case LOAD_CATALOGS_TODAY_COUNT_REQUEST:
            return (0, _extends3.default)({}, state, {
                submitted: true,
                success: false
            });
        case LOAD_CATALOGS_TODAY_COUNT_SUCCESS:
            return (0, _extends3.default)({}, state, {
                catalogsTodayCount: action.payload.count,
                submitted: false,
                success: true
            });
        case LOAD_CATALOGS_TODAY_COUNT_FAIL:
            return (0, _extends3.default)({}, state, {
                error: true,
                submitted: false,
                success: false
            });
        default:
            return state;
    }
}
/* SELECTORS */
var stateSelector = function stateSelector(state) {
    return state.ui.catalogSearch;
};

var getUiCatalogSearch = exports.getUiCatalogSearch = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state;
});

var getCatalogsTodayCount = exports.getCatalogsTodayCount = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.catalogsTodayCount;
});

var getCatalogSearchIds = exports.getCatalogSearchIds = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.catalogIds;
});

var getCatalogSearchTotalCount = exports.getCatalogSearchTotalCount = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.totalFound;
});

var getCatalogSearchSubmitted = exports.getCatalogSearchSubmitted = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.submitted;
});

var getCatalogSearchFacets = exports.getCatalogSearchFacets = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.facets.length > 0 ? (0, _cloneDeep2.default)(state.facets) : [];
});

var getCatalogSearchAuctionStatusFacetValues = exports.getCatalogSearchAuctionStatusFacetValues = (0, _reselect.createSelector)(getCatalogSearchFacets, function (facets) {
    var facet = facets.find(function (x) {
        return x.name === 'Auction Status';
    });
    if (facet) {
        return facet.values;
    }
    return [];
});

var getCatalogSearchParams = exports.getCatalogSearchParams = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.searchParams;
});

var getCatalogSearchPage = exports.getCatalogSearchPage = (0, _reselect.createSelector)(getCatalogSearchParams, function (searchParams) {
    return searchParams.page;
});

var getCatalogSearchPageSize = exports.getCatalogSearchPageSize = (0, _reselect.createSelector)(getCatalogSearchParams, function (searchParams) {
    return searchParams.pageSize;
});

var getCatalogSearchDate = exports.getCatalogSearchDate = (0, _reselect.createSelector)(getCatalogSearchParams, function (searchParams) {
    return searchParams.date || '';
});

/* ACTIONS CREATORS */
var fetchCatalogSearchResults = exports.fetchCatalogSearchResults = function fetchCatalogSearchResults(params) {
    return function (dispatch, getState) {
        var state = getState();
        var deployment = (0, _config.getDeployment)(state);
        var searchParams = getCatalogSearchParams(state);
        var parameters = (0, _extends3.default)({
            client: 'web',
            client_version: '5.0.0',
            max_facet_values: 3,
            pagesize: searchParams.pageSize || searchParams.pagesize
        }, searchParams, params);

        dispatch({
            type: LOAD_CATALOG_SEARCH_REQUEST
        });

        return _api.CatalogSearch.fetchResults({ deployment: deployment, searchParams: parameters }).then(function (response) {
            dispatch({
                payload: { catalogStatus: searchParams.catalog_status, response: response },
                type: LOAD_CATALOG_SEARCH_SUCCESS
            });
        }, function (error) {
            dispatch({
                error: true,
                payload: error,
                type: LOAD_CATALOG_SEARCH_FAIL
            });
        });
    };
};

var fetchCatalogsTodayCountIfNeeded = exports.fetchCatalogsTodayCountIfNeeded = function fetchCatalogsTodayCountIfNeeded() {
    return function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch, getState) {
            var state, todayCount, deployment, response;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.prev = 0;
                            state = getState();
                            todayCount = getCatalogsTodayCount(state);

                            if (todayCount) {
                                _context.next = 10;
                                break;
                            }

                            deployment = (0, _config.getDeployment)(state);


                            dispatch({
                                type: LOAD_CATALOGS_TODAY_COUNT_REQUEST
                            });
                            _context.next = 8;
                            return _api.CatalogSearch.fetchCatalogsTodayCount(deployment);

                        case 8:
                            response = _context.sent;

                            dispatch({
                                payload: response.data[0],
                                type: LOAD_CATALOGS_TODAY_COUNT_SUCCESS
                            });

                        case 10:
                            _context.next = 15;
                            break;

                        case 12:
                            _context.prev = 12;
                            _context.t0 = _context['catch'](0);

                            dispatch({
                                error: true,
                                type: LOAD_CATALOGS_TODAY_COUNT_FAIL
                            });

                        case 15:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, undefined, [[0, 12]]);
        }));

        return function (_x3, _x4) {
            return _ref.apply(this, arguments);
        };
    }();
};

var updateSearchParams = exports.updateSearchParams = function updateSearchParams(searchParams) {
    return function () {
        var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(dispatch, getState) {
            return _regenerator2.default.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            dispatch({
                                payload: searchParams,
                                type: UPDATE_CATALOG_SEARCH_PARAMS
                            });

                        case 1:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, undefined);
        }));

        return function (_x5, _x6) {
            return _ref2.apply(this, arguments);
        };
    }();
};

var updateFacetsSelected = exports.updateFacetsSelected = function updateFacetsSelected(searchParams) {
    return function () {
        var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(dispatch, getState) {
            var state, facets, searchParams;
            return _regenerator2.default.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            state = getState();
                            facets = getCatalogSearchFacets(state);
                            searchParams = getCatalogSearchParams(state);


                            dispatch({
                                payload: { facets: facets, searchParams: searchParams },
                                type: UPDATE_FACETS_SELECTED
                            });

                        case 4:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, undefined);
        }));

        return function (_x7, _x8) {
            return _ref3.apply(this, arguments);
        };
    }();
};

var fetchDataForCatalogSearchPage = exports.fetchDataForCatalogSearchPage = function fetchDataForCatalogSearchPage(searchQuery) {
    return function (dispatch, getState) {
        return _promise2.default.all([dispatch((0, _searchFacets.fetchSearchFacetsIfNeeded)()), dispatch((0, _searchFacets.fetchSearchFacetsIfNeeded)(true)), dispatch(fetchCatalogsTodayCountIfNeeded()), dispatch((0, _catalogAd.fetchCatalogAdIfNeeded)({ categoryIds: '0', pageName: 'calendar' }))] // pass 0 to indicate that its the calendar/catalog search page
        ).then(function () {
            return _promise2.default.all([dispatch(updateSearchParams(searchQuery)), dispatch(fetchCatalogSearchResults(searchQuery))]);
        })
        // in order to re-arrange the facets set in state we need to adjust them after the search call
        .then(function () {
            return _promise2.default.all([dispatch(updateFacetsSelected())]);
        }).then(function () {
            var state = getState();
            var catalogIds = getCatalogSearchIds(state);
            return _promise2.default.all([dispatch((0, _catalog.fetchCatalogsIfNeeded)(catalogIds)), dispatch((0, _coverLots.fetchCoverLotsIfNeeded)(catalogIds))]);
        });
    };
};

/***/ }),

/***/ "DAZk":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fetchItemDetailsIfNeeded = exports.isItemDetailLoading = exports.getLoadTimeForItemDetail = exports.getItemDetail = exports.LOAD_ITEM_DETAILS_SUCCESS = exports.LOAD_ITEM_DETAILS_REQUEST = exports.LOAD_ITEM_DETAILS_FAIL = undefined;

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;

var _api = __webpack_require__("zFQO");

var _cloneDeep = __webpack_require__("kvU2");

var _cloneDeep2 = _interopRequireDefault(_cloneDeep);

var _reselect = __webpack_require__("bndy");

var _difference = __webpack_require__("WlNK");

var _difference2 = _interopRequireDefault(_difference);

var _config = __webpack_require__("iS9E");

var _ms = __webpack_require__("EarI");

var _ms2 = _interopRequireDefault(_ms);

var _union = __webpack_require__("gszD");

var _union2 = _interopRequireDefault(_union);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Action Types */
var LOAD_ITEM_DETAILS_FAIL = exports.LOAD_ITEM_DETAILS_FAIL = 'la/domain/itemDetail/LOAD_FAIL';
var LOAD_ITEM_DETAILS_REQUEST = exports.LOAD_ITEM_DETAILS_REQUEST = 'la/domain/itemDetail/LOAD_REQUEST';
var LOAD_ITEM_DETAILS_SUCCESS = exports.LOAD_ITEM_DETAILS_SUCCESS = 'la/domain/itemDetail/LOAD_SUCCESS';

var REDUX_STORE_TIME = (0, _ms2.default)('30m');

/* reducer */
var DEFAULT_STATE = {
    byId: {},
    loaded: {},
    loading: []
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var existing = void 0;
    var loaded = void 0;
    var loading = void 0;
    var time = void 0;

    switch (action.type) {
        case LOAD_ITEM_DETAILS_FAIL:
            return (0, _extends3.default)({}, state, {
                loading: (0, _difference2.default)(state.loading, action.meta.itemIds)
            });
        case LOAD_ITEM_DETAILS_REQUEST:
            return (0, _extends3.default)({}, state, {
                loading: (0, _union2.default)(state.loading, action.payload)
            });
        case LOAD_ITEM_DETAILS_SUCCESS:
            existing = (0, _cloneDeep2.default)(state.byId);
            loaded = (0, _extends3.default)({}, state.loaded);
            loading = (0, _cloneDeep2.default)(state.loading);
            time = action.meta.actionTime;

            if (action.payload.itemDetails) {
                action.payload.itemDetails.forEach(function (x) {
                    existing[x.itemId] = (0, _extends3.default)({}, x);
                    loaded[x.itemId] = time;
                    loading = (0, _difference2.default)(loading, [x.itemId]);
                });
            }
            return (0, _extends3.default)({}, state, {
                byId: existing,
                loaded: loaded,
                loading: loading
            });
        default:
            return state;
    }
}

/* SELECTORS */
var stateSelector = function stateSelector(state) {
    return state.domain.itemDetail;
};
var idSelector = function idSelector(state, id) {
    return id;
};

var byIdSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.byId;
});

var loadedSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.loaded;
});

var loadingSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.loading;
});

// takes in a (state, id) and passes both params to every function on
// the way down.
var getItemDetail = exports.getItemDetail = (0, _reselect.createSelector)([byIdSelector, idSelector], function (byId, id) {
    return byId[id] || {};
});

var getLoadTimeForItemDetail = exports.getLoadTimeForItemDetail = (0, _reselect.createSelector)([loadedSelector, idSelector], function (loaded, id) {
    return loaded[id] || 0;
});

var isItemDetailLoading = exports.isItemDetailLoading = (0, _reselect.createSelector)([loadingSelector, idSelector], function (loading, id) {
    return loading.includes(id);
});

var shouldFetchItemDetail = function shouldFetchItemDetail(state, itemId) {
    if (!itemId) return false;
    var item = getItemDetail(state, itemId);
    if (item) {
        var loaded = getLoadTimeForItemDetail(state, itemId);
        var time = Date.now();
        var diff = time - loaded;
        if (diff < REDUX_STORE_TIME) return false;
    }
    var loading = isItemDetailLoading(state, itemId);
    return !loading;
};

var whichItemDetailsNeeded = function whichItemDetailsNeeded(state, itemIds) {
    return itemIds.filter(function (itemId) {
        return shouldFetchItemDetail(state, itemId);
    });
};

/* ACTION CREATORS */
var loadItemDetailsFail = function loadItemDetailsFail(itemIds, error) {
    return {
        error: true,
        meta: { itemIds: itemIds },
        payload: error,
        type: LOAD_ITEM_DETAILS_FAIL
    };
};

var loadItemDetailsRequest = function loadItemDetailsRequest(itemIds) {
    return {
        payload: itemIds,
        type: LOAD_ITEM_DETAILS_REQUEST
    };
};

var loadItemDetailsSuccess = function loadItemDetailsSuccess(itemIds, results) {
    return {
        meta: { actionTime: Date.now(), itemIds: itemIds },
        payload: results,
        type: LOAD_ITEM_DETAILS_SUCCESS
    };
};

var loadItemDetails = function loadItemDetails(itemIds) {
    return function (dispatch, getState) {
        var state = getState();
        var deployment = (0, _config.getDeployment)(state);
        dispatch(loadItemDetailsRequest(itemIds));
        return _api.ItemDetail.fetchItemDetailsByIds({ deployment: deployment, itemIds: itemIds }).then(function (response) {
            dispatch(loadItemDetailsSuccess(itemIds, response.data));
        }).catch(function (error) {
            dispatch(loadItemDetailsFail(itemIds, error));
        });
    };
};

var fetchItemDetailsIfNeeded = exports.fetchItemDetailsIfNeeded = function fetchItemDetailsIfNeeded(itemIds) {
    return function (dispatch, getState) {
        var needed = whichItemDetailsNeeded(getState(), itemIds);
        if (needed.length) {
            return dispatch(loadItemDetails(needed));
        }
        return _promise2.default.resolve();
    };
};

/***/ }),

/***/ "DNXl":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.changePaginationPageSize = exports.changePaginationSortOrder = exports.CHANGE_PAGINATION_PAGE_SIZE = exports.CHANGE_PAGINATION_SORT_ORDER = undefined;

var _defineProperty2 = __webpack_require__("bOdI");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends3 = __webpack_require__("Dd8w");

var _extends4 = _interopRequireDefault(_extends3);

exports.paginationLocalStorageReducer = paginationLocalStorageReducer;
exports.paginationCookiesReducer = paginationCookiesReducer;
exports.getPaginationSortOrder = getPaginationSortOrder;
exports.getPaginationPageSize = getPaginationPageSize;

var _reactCookie = __webpack_require__("Zld1");

var _reactCookie2 = _interopRequireDefault(_reactCookie);

var _constants = __webpack_require__("5fUn");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Action Types */
var CHANGE_PAGINATION_SORT_ORDER = exports.CHANGE_PAGINATION_SORT_ORDER = 'la/ui/pagination/sortOrder';
var CHANGE_PAGINATION_PAGE_SIZE = exports.CHANGE_PAGINATION_PAGE_SIZE = 'la/ui/pagination/pageSize';

// reducer
var DEFAULT_LOCAL_STORAGE_STATE = {
    sort: {}
};
var DEFAULT_COOKIE_STATE = {
    pageSize: 24
};

function paginationLocalStorageReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_LOCAL_STORAGE_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        case _constants.REHYDRATE:
            if (Object.prototype.hasOwnProperty.call(action.payload, 'persist') && Object.prototype.hasOwnProperty.call(action.payload.persist, 'pagination')) {
                var incoming = action.payload.persist.pagination;
                return (0, _extends4.default)({}, state, incoming);
            }
            return state;
        case CHANGE_PAGINATION_SORT_ORDER:
            return (0, _extends4.default)({}, state, {
                sort: (0, _extends4.default)({}, state.sort, (0, _defineProperty3.default)({}, action.payload.type, action.payload.sortOrder))
            });
        default:
            return state;
    }
}

function paginationCookiesReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_COOKIE_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        case CHANGE_PAGINATION_PAGE_SIZE:
            return (0, _extends4.default)({}, state, {
                pageSize: action.payload
            });
        default:
            return state;
    }
}

/* SELECTORS */
// Because this is global it will not be able to return a default.
function getPaginationSortOrder(state, type) {
    return state.persist.pagination.sort[type] || '';
}

function getPaginationPageSize(state) {
    return state.ui.pagination.pageSize || 24;
}

/* ACTION CREATORS */
var changePaginationSortOrder = exports.changePaginationSortOrder = function changePaginationSortOrder(type, sortOrder) {
    return {
        payload: { sortOrder: sortOrder, type: type },
        type: CHANGE_PAGINATION_SORT_ORDER
    };
};

var changePaginationPageSize = exports.changePaginationPageSize = function changePaginationPageSize(pageSize) {
    var expires = new Date();
    expires.setDate(expires.getDate() + 60);
    _reactCookie2.default.save('pagination-page-size', pageSize, {
        domain: '.liveauctioneers.com',
        expires: expires,
        path: '/'
    });
    return {
        payload: pageSize !== 'all' ? Number(pageSize) : pageSize,
        type: CHANGE_PAGINATION_PAGE_SIZE
    };
};

/***/ }),

/***/ "Dc2Q":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = __webpack_require__("dcb+");

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _components = __webpack_require__("bGai");

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propsComparer = __webpack_require__("wsGv");

var _propsComparer2 = _interopRequireDefault(_propsComparer);

var _reactIntl = __webpack_require__("Pq8k");

var _validation = __webpack_require__("/wT0");

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _SignUpEmail = __webpack_require__("Pb0h");

var _SignUpEmail2 = _interopRequireDefault(_SignUpEmail);

var _caterwaulComponents = __webpack_require__("7T5E");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SignUpEmail = function (_Component) {
    (0, _inherits3.default)(SignUpEmail, _Component);

    function SignUpEmail(props, context) {
        (0, _classCallCheck3.default)(this, SignUpEmail);

        var _this = (0, _possibleConstructorReturn3.default)(this, (SignUpEmail.__proto__ || (0, _getPrototypeOf2.default)(SignUpEmail)).call(this, props, context));

        _this.onValueChange = function (event) {
            var newState = {};
            newState[event.target.id] = event.target.value;
            _this.setState(newState);
        };

        _this.onSignUp = function () {
            var email = _this.state.email.trim();
            var emailValid = (0, _validation.email)(email);
            _this.setState({ emailValid: emailValid });
            if (emailValid) {
                _this.props.setEmail(email);
                _this.props.submitCreateAccount(email);
            }
        };

        _this.handleEnterKeyPress = function (event) {
            if (event.key === 'Enter') {
                _this.onSignUp();
            }
            event.stopPropagation();
        };

        _this.state = {
            email: '',
            emailValid: true
        };
        return _this;
    }

    (0, _createClass3.default)(SignUpEmail, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps, nextState) {
            return (0, _propsComparer2.default)(this.props, nextProps, ['error', 'submitted']) || (0, _propsComparer2.default)(this.state, nextState, ['email', 'emailValid']);
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                error = _props.error,
                submitted = _props.submitted;
            var _state = this.state,
                email = _state.email,
                emailValid = _state.emailValid;


            var errorMessage = '';
            var errorOnPage = !emailValid || error;

            var tosLink = (0, _jsx3.default)(_components.Link, {
                to: '/termsandconditions',
                target: '_blank',
                rel: 'noopener'
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'terms_and_conditions'
            }));
            var privacyLink = (0, _jsx3.default)(_components.Link, {
                to: '/privacy',
                target: '_blank',
                rel: 'noopener'
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'privacy_policy'
            }));

            if (!emailValid) {
                errorMessage = (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                    id: 'enter_a_valid_email_address'
                });
            } else if (error) {
                errorMessage = (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                    id: 'we_experienced_a_server_error'
                }); // we could show the error
            }
            return (0, _jsx3.default)('div', {
                className: _SignUpEmail2.default.body
            }, void 0, (0, _jsx3.default)(_components.Input, {
                autoCapitalize: false,
                autoComplete: false,
                autoCorrect: false,
                autoFocus: true,
                errorMessage: errorMessage,
                id: 'email',
                label: (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                    id: 'email_address'
                }),
                onChange: this.onValueChange,
                onKeyPress: this.handleEnterKeyPress,
                type: 'email',
                valid: !errorOnPage
            }), (0, _jsx3.default)('div', {
                className: _SignUpEmail2.default.links
            }, void 0, (0, _jsx3.default)(_components.Button, {
                className: _SignUpEmail2.default.submit,
                tertiary: true,
                disabled: submitted || !email,
                onClick: this.onSignUp
            }, void 0, !submitted ? (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'start_now'
            }) : (0, _jsx3.default)(_caterwaulComponents.Throbber, {}))), (0, _jsx3.default)('div', {
                className: _SignUpEmail2.default.modalTerms
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'terms_and_privacy',
                values: { privacyLink: privacyLink, tosLink: tosLink }
            })));
        }
    }]);
    return SignUpEmail;
}(_react.Component);

exports.default = SignUpEmail;
module.exports = exports['default'];

/***/ }),

/***/ "Dgym":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.changeLostItemsPage = exports.fetchLostItemsIfNeeded = exports.areLostItemsLoaded = exports.getLostItemsPageSize = exports.getLostItemsPage = exports.getLostItems = exports.getTotalLostItemsCount = exports.CHANGE_LOST_ITEMS_PAGE_SIZE = exports.CHANGE_LOST_ITEMS_PAGE = exports.LOAD_LOST_ITEMS_SUCCESS = exports.LOAD_LOST_ITEMS_REQUEST = exports.LOAD_LOST_ITEMS_FAIL = undefined;

var _regenerator = __webpack_require__("Xxa5");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _asyncToGenerator2 = __webpack_require__("exGp");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;

var _user = __webpack_require__("CFLi");

var _api = __webpack_require__("zFQO");

var _cloneDeep = __webpack_require__("kvU2");

var _cloneDeep2 = _interopRequireDefault(_cloneDeep);

var _reselect = __webpack_require__("bndy");

var _config = __webpack_require__("iS9E");

var _ms = __webpack_require__("EarI");

var _ms2 = _interopRequireDefault(_ms);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Action Types */
var LOAD_LOST_ITEMS_FAIL = exports.LOAD_LOST_ITEMS_FAIL = 'la/ui/lostItems/LOAD_FAIL';
var LOAD_LOST_ITEMS_REQUEST = exports.LOAD_LOST_ITEMS_REQUEST = 'la/ui/lostItems/LOAD_REQUEST';
var LOAD_LOST_ITEMS_SUCCESS = exports.LOAD_LOST_ITEMS_SUCCESS = 'la/ui/lostItems/LOAD_SUCCESS';
var CHANGE_LOST_ITEMS_PAGE = exports.CHANGE_LOST_ITEMS_PAGE = 'la/ui/lostItems/CHANGE_LOST_ITEMS_PAGE';
var CHANGE_LOST_ITEMS_PAGE_SIZE = exports.CHANGE_LOST_ITEMS_PAGE_SIZE = 'la/ui/lostItems/CHANGE_LOST_ITEMS_PAGE_SIZE';

var REDUX_STORE_TIME = (0, _ms2.default)('30m');

/* reducer */
var DEFAULT_STATE = {
    catalogs: [],
    loaded: null,
    loading: false,
    page: 1,
    pageSize: 10,
    totalItems: 0
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        case LOAD_LOST_ITEMS_FAIL:
            return (0, _extends3.default)({}, state, {
                loading: false
            });
        case LOAD_LOST_ITEMS_REQUEST:
            return (0, _extends3.default)({}, state, {
                loading: true
            });
        case LOAD_LOST_ITEMS_SUCCESS:
            return (0, _extends3.default)({}, state, {
                catalogs: (0, _cloneDeep2.default)(action.payload.catalogs),
                loaded: action.meta.actionTime,
                loading: false,
                totalItems: Number(action.payload.count)
            });
        case CHANGE_LOST_ITEMS_PAGE_SIZE:
            return (0, _extends3.default)({}, state, {
                pageSize: action.payload
            });
        case CHANGE_LOST_ITEMS_PAGE:
            return (0, _extends3.default)({}, state, {
                page: action.payload
            });
        default:
            return state;
    }
}

/* SELECTORS */
var stateSelector = function stateSelector(state) {
    return state.ui.lostItems;
};

var loadedSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.loaded;
});
var loadingSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.loading;
});

var getTotalLostItemsCount = exports.getTotalLostItemsCount = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.totalItems;
}) || 0;
var getLostItems = exports.getLostItems = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.catalogs;
}) || [];
var getLostItemsPage = exports.getLostItemsPage = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.page;
}) || 1;
var getLostItemsPageSize = exports.getLostItemsPageSize = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.pageSize;
}) || 10;
var areLostItemsLoaded = exports.areLostItemsLoaded = loadedSelector;

var shouldFetchLostItems = (0, _reselect.createSelector)([loadedSelector, loadingSelector], function (loaded, loading) {
    if (loaded) {
        var time = Date.now();
        var diff = time - loaded;
        if (diff < REDUX_STORE_TIME) return false;
    }
    return !loading;
});

/* ACTION CREATORS */
var fetchLostItemsIfNeeded = exports.fetchLostItemsIfNeeded = function fetchLostItemsIfNeeded(_ref) {
    var page = _ref.page,
        pageSize = _ref.pageSize;
    return function () {
        var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch, getState) {
            var state;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            state = getState();

                            if (!shouldFetchLostItems(state)) {
                                _context.next = 8;
                                break;
                            }

                            page = page || getLostItemsPage(state);
                            pageSize = pageSize || getLostItemsPageSize(state);
                            _context.next = 6;
                            return changeLostItemsPage({ force: true, page: page, pageSize: pageSize })(dispatch, getState);

                        case 6:
                            _context.next = 9;
                            break;

                        case 8:
                            return _context.abrupt('return', _promise2.default.resolve());

                        case 9:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, undefined);
        }));

        return function (_x3, _x4) {
            return _ref2.apply(this, arguments);
        };
    }();
};

var changeLostItemsPage = exports.changeLostItemsPage = function changeLostItemsPage(_ref3) {
    var page = _ref3.page,
        pageSize = _ref3.pageSize,
        force = _ref3.force;
    return function () {
        var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(dispatch, getState) {
            var state, oldPage, oldPageSize, dirty, authToken, deployment, bidderId, response;
            return _regenerator2.default.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            state = getState();
                            oldPage = getLostItemsPage(state);
                            oldPageSize = getLostItemsPageSize(state);
                            dirty = false;


                            if (oldPage !== page) {
                                dirty = true;
                                dispatch({
                                    payload: Number(page),
                                    type: CHANGE_LOST_ITEMS_PAGE
                                });
                            }

                            if (oldPageSize !== pageSize) {
                                dirty = true;
                                dispatch({
                                    payload: Number(pageSize),
                                    type: CHANGE_LOST_ITEMS_PAGE_SIZE
                                });
                            }

                            if (!(dirty || force)) {
                                _context2.next = 21;
                                break;
                            }

                            _context2.prev = 7;
                            authToken = (0, _user.getAuthToken)(state);
                            deployment = (0, _config.getDeployment)(state);
                            bidderId = (0, _user.getBidderId)(state);


                            dispatch({
                                meta: { actionTime: Date.now() },
                                type: LOAD_LOST_ITEMS_REQUEST
                            });
                            _context2.next = 14;
                            return _api.LostItems.fetchLostItems({ authToken: authToken, bidderId: bidderId, deployment: deployment, page: page, pageSize: pageSize });

                        case 14:
                            response = _context2.sent;

                            dispatch({
                                meta: { actionTime: Date.now() },
                                payload: response.data,
                                type: LOAD_LOST_ITEMS_SUCCESS
                            });
                            _context2.next = 21;
                            break;

                        case 18:
                            _context2.prev = 18;
                            _context2.t0 = _context2['catch'](7);

                            dispatch({
                                error: true,
                                payload: _context2.t0,
                                type: LOAD_LOST_ITEMS_FAIL
                            });

                        case 21:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, undefined, [[7, 18]]);
        }));

        return function (_x5, _x6) {
            return _ref4.apply(this, arguments);
        };
    }();
};

/***/ }),

/***/ "E6Dt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"no-results-container":"no-results-container___1hQRQ"};

/***/ }),

/***/ "EDkj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"next":"next___2Aco7","prev":"prev___19rGl","arrow":"arrow___ZBm6_"};

/***/ }),

/***/ "EeU7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "EuUL":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CatalogLocationRemote = undefined;

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _helpers = __webpack_require__("SY39");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CatalogLocationRemote = exports.CatalogLocationRemote = {
    fetchCatalogLocations: function fetchCatalogLocations(_ref) {
        var deployment = _ref.deployment;
        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makeGet)('<ITEM-API>catalog-locations', deployment);
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response });
            });
        });
    }
};

/***/ }),

/***/ "F213":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.changeUserPassword = exports.getUiUpdatePassword = exports.CHANGE_PASSWORD_SUCCESS = exports.CHANGE_PASSWORD_REQUEST = exports.CHANGE_PASSWORD_FAIL = undefined;

var _regenerator = __webpack_require__("Xxa5");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__("exGp");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;

var _api = __webpack_require__("zFQO");

var _reselect = __webpack_require__("bndy");

var _user = __webpack_require__("CFLi");

var _config = __webpack_require__("iS9E");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Action Types */
var CHANGE_PASSWORD_FAIL = exports.CHANGE_PASSWORD_FAIL = 'la/ui/updatePassword/FAIL';
var CHANGE_PASSWORD_REQUEST = exports.CHANGE_PASSWORD_REQUEST = 'la/ui/updatePassword/REQUEST';
var CHANGE_PASSWORD_SUCCESS = exports.CHANGE_PASSWORD_SUCCESS = 'la/ui/updatePassword/SUCCESS';

// reducer
var DEFAULT_STATE = {
    error: false,
    errorMessage: '',
    submitted: false,
    success: false
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        case CHANGE_PASSWORD_FAIL:
            return (0, _extends3.default)({}, state, {
                error: true,
                errorMessage: action.payload.message,
                submitted: false,
                success: false
            });
        case CHANGE_PASSWORD_REQUEST:
            return (0, _extends3.default)({}, state, {
                error: false,
                errorMessage: '',
                submitted: true,
                success: false
            });
        case CHANGE_PASSWORD_SUCCESS:
            return (0, _extends3.default)({}, state, {
                error: false, // TODO: remove
                errorMessage: '', // TODO: remove
                submitted: false,
                success: true
            });
        default:
            return state;
    }
}

/* SELECTORS */
var stateSelector = function stateSelector(state) {
    return state.ui.updatePassword;
};

var getUiUpdatePassword = exports.getUiUpdatePassword = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state;
});

/* ACTION CREATORS */
var changeUserPassword = exports.changeUserPassword = function changeUserPassword(newPassword, oldPassword) {
    return function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch, getState) {
            var state, authToken, deployment;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.prev = 0;
                            state = getState();
                            authToken = (0, _user.getAuthToken)(state);
                            deployment = (0, _config.getDeployment)(state);

                            dispatch({
                                type: CHANGE_PASSWORD_REQUEST
                            });
                            _context.next = 7;
                            return _api.Auth.postUpdatePassword({ authToken: authToken, deployment: deployment, newPassword: newPassword, oldPassword: oldPassword });

                        case 7:
                            dispatch({
                                type: CHANGE_PASSWORD_SUCCESS
                            });
                            _context.next = 13;
                            break;

                        case 10:
                            _context.prev = 10;
                            _context.t0 = _context['catch'](0);

                            dispatch({
                                error: true,
                                payload: _context.t0,
                                type: CHANGE_PASSWORD_FAIL
                            });

                        case 13:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, undefined, [[0, 10]]);
        }));

        return function (_x3, _x4) {
            return _ref.apply(this, arguments);
        };
    }();
};

/***/ }),

/***/ "FGjK":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SearchSuggestionsRemote = undefined;

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _config = __webpack_require__("QmSG");

var _helpers = __webpack_require__("SY39");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SearchSuggestionsRemote = exports.SearchSuggestionsRemote = {
    fetchSuggestions: function fetchSuggestions(_ref) {
        var deployment = _ref.deployment,
            term = _ref.term;

        if (!term) {
            return _promise2.default.all([]);
        }
        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makeGet)('<MAINHOST-API>api/search/' + encodeURIComponent(term.trim()) + '/suggestions', deployment);
            request.query({
                auctionHouseSize: _config.auctionHouseSize,
                client_version: '5.0',
                giveRawResults: _config.giveRawResults,
                querySize: _config.querySize
            });
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response });
            });
        });
    }
};

/***/ }),

/***/ "FHLC":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _autoPopModal = __webpack_require__("GvHb");

var _redux = __webpack_require__("2KeS");

var _react = __webpack_require__("GiK3");

var _reactRedux = __webpack_require__("RH2O");

var _reactCookie = __webpack_require__("Zld1");

var _reactCookie2 = _interopRequireDefault(_reactCookie);

var _modal = __webpack_require__("u90i");

var _browser = __webpack_require__("aN2S");

var _user = __webpack_require__("CFLi");

var _enums = __webpack_require__("cjn6");

var _momentTimezone = __webpack_require__("xNPZ");

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AutoPopModalContainer = (_dec = (0, _reactRedux.connect)(function (state) {
    var isMobile = !!(0, _browser.isUiMobile)(state);
    var openModal = (0, _modal.getOpenModal)(state);
    var userLoggedIn = (0, _user.isUserLoggedIn)(state);
    var modalShown = (0, _autoPopModal.getUiModalShown)(state);
    var lastDateShown = (0, _autoPopModal.getUiDateLastShown)(state);
    var preventAutoPopup = (0, _autoPopModal.shouldStopAutoPopup)(state);
    return {
        isMobile: isMobile,
        lastDateShown: lastDateShown,
        modalShown: modalShown,
        openModal: openModal,
        preventAutoPopup: preventAutoPopup,
        userLoggedIn: userLoggedIn
    };
}, function (dispatch) {
    return (0, _redux.bindActionCreators)({
        autoOpenCreateAccountModal: _autoPopModal.autoOpenCreateAccountModal
    }, dispatch);
}), _dec(_class = function (_Component) {
    (0, _inherits3.default)(AutoPopModalContainer, _Component);

    function AutoPopModalContainer() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, AutoPopModalContainer);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = AutoPopModalContainer.__proto__ || (0, _getPrototypeOf2.default)(AutoPopModalContainer)).call.apply(_ref, [this].concat(args))), _this), _this.onScroll = function (e) {
            e.preventDefault();
            _this.props.autoOpenCreateAccountModal();
            window.removeEventListener('scroll', _this.onScroll);
        }, _this.onTouchMove = function (e) {
            e.preventDefault();
            _this.props.autoOpenCreateAccountModal();
            window.removeEventListener('touchmove', _this.onTouchMove);
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(AutoPopModalContainer, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _props = this.props,
                isMobile = _props.isMobile,
                modalShown = _props.modalShown,
                openModal = _props.openModal,
                preventAutoPopup = _props.preventAutoPopup,
                userLoggedIn = _props.userLoggedIn;


            var shouldShowModal = !preventAutoPopup && !modalShown && openModal === _enums.modalTypes.NONE && !userLoggedIn;

            if (shouldShowModal) {
                if (isMobile) {
                    window.addEventListener('touchmove', this.onTouchMove);
                } else {
                    window.addEventListener('scroll', this.onScroll);
                }
            }
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            var _props2 = this.props,
                lastDateShown = _props2.lastDateShown,
                userLoggedIn = _props2.userLoggedIn,
                modalShown = _props2.modalShown;


            if (!userLoggedIn && nextProps.userLoggedIn) {
                var expires = new Date();
                expires.setDate(expires.getDate() + 60);
                _reactCookie2.default.save('bidder-has-logged-in', true, {
                    domain: '.liveauctioneers.com',
                    expires: expires,
                    path: '/'
                });
            }

            if (!modalShown && nextProps.modalShown || lastDateShown !== nextProps.lastDateShown) {
                var _expires = new Date();
                _expires.setDate(_expires.getDate() + _autoPopModal.DAYS_TO_WAIT_TO_SHOW_MODAL_AGAIN);
                _reactCookie2.default.save('join-modal-last-seen', (0, _momentTimezone2.default)().format('YYYY-MM-DD'), {
                    domain: '.liveauctioneers.com',
                    expires: _expires,
                    path: '/'
                });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            return null;
        }
    }]);
    return AutoPopModalContainer;
}(_react.Component)) || _class);
exports.default = AutoPopModalContainer;
module.exports = exports['default'];

/***/ }),

/***/ "FSAu":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.updateActiveBiddersSfs = exports.updateActiveBiddersPubnub = exports.nextLotLoaded = exports.nextLotOpened = exports.networkReconnected = exports.networkDisconnected = exports.missive = exports.lotUnsold = exports.lotSold = exports.lotSkipped = exports.lotReopened = exports.lotPassed = exports.lotClosed = exports.bidRetracted = exports.bidAccepted = exports.auctionStarted = exports.auctionClosed = exports.askChanged = exports.getLiveItemData = exports.getLiveCatalogData = exports.getPubNubPublishKey = exports.getCatalogBidders = exports.getCatalogMessages = exports.UPDATE_ACTIVE_BIDDERS_SFS = exports.UPDATE_ACTIVE_BIDDERS_PUBNUB = exports.NEXT_LOT_OPENED = exports.NEXT_LOT_LOADED = exports.NETWORK_RECONNECTED = exports.NETWORK_DISCONNECTED = exports.MISSIVE = exports.LOT_UNSOLD = exports.LOT_SOLD = exports.LOT_SKIPPED = exports.LOT_REOPENED = exports.LOT_PASSED = exports.LOT_CLOSED = exports.BID_RETRACTED = exports.BID_ACCEPTED = exports.AUCTION_STARTED = exports.AUCTION_ENDED = exports.ASK_CHANGED = undefined;

var _regenerator = __webpack_require__("Xxa5");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__("exGp");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;

var _cloneDeep = __webpack_require__("kvU2");

var _cloneDeep2 = _interopRequireDefault(_cloneDeep);

var _reselect = __webpack_require__("bndy");

var _user = __webpack_require__("CFLi");

var _liveBid = __webpack_require__("xmqD");

var _catalogRegistration = __webpack_require__("uhYE");

var _catalog = __webpack_require__("yv/Z");

var _liveCatalogStatus = __webpack_require__("ByEe");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Action Types */
var ASK_CHANGED = exports.ASK_CHANGED = 'ASK_CHANGED';
var AUCTION_ENDED = exports.AUCTION_ENDED = 'AUCTION_ENDED';
var AUCTION_STARTED = exports.AUCTION_STARTED = 'AUCTION_STARTED';
var BID_ACCEPTED = exports.BID_ACCEPTED = 'BID_ACCEPTED';
var BID_RETRACTED = exports.BID_RETRACTED = 'BID_RETRACTED';
var LOT_CLOSED = exports.LOT_CLOSED = 'LOT_CLOSED';
var LOT_PASSED = exports.LOT_PASSED = 'LOT_PASSED';
var LOT_REOPENED = exports.LOT_REOPENED = 'LOT_REOPENED';
var LOT_SKIPPED = exports.LOT_SKIPPED = 'LOT_SKIPPED';
var LOT_SOLD = exports.LOT_SOLD = 'LOT_SOLD';
var LOT_UNSOLD = exports.LOT_UNSOLD = 'LOT_UNSOLD';
var MISSIVE = exports.MISSIVE = 'MISSIVE';
var NETWORK_DISCONNECTED = exports.NETWORK_DISCONNECTED = 'NETWORK_DISCONNECTED';
var NETWORK_RECONNECTED = exports.NETWORK_RECONNECTED = 'NETWORK_RECONNECTED';
var NEXT_LOT_LOADED = exports.NEXT_LOT_LOADED = 'NEXT_LOT_LOADED';
var NEXT_LOT_OPENED = exports.NEXT_LOT_OPENED = 'NEXT_LOT_OPENED';
var UPDATE_ACTIVE_BIDDERS_PUBNUB = exports.UPDATE_ACTIVE_BIDDERS_PUBNUB = 'UPDATE_ACTIVE_BIDDERS_PUBNUB';
var UPDATE_ACTIVE_BIDDERS_SFS = exports.UPDATE_ACTIVE_BIDDERS_SFS = 'UPDATE_ACTIVE_BIDDERS_SFS';

/* helpers */
var addMessage = function addMessage(messages, catalogId, message) {
    var newMessages = (0, _cloneDeep2.default)(messages);
    newMessages[catalogId] = newMessages[catalogId] || [];
    newMessages[catalogId].push(message);
    newMessages[catalogId] = newMessages[catalogId].sort(function (a, b) {
        return a.created - b.created;
    });
    if (newMessages[catalogId].length > 500) {
        // reduce to 5 if we exceed 500 messages
        newMessages[catalogId] = newMessages[catalogId].slice(0, 5);
    }
    return newMessages;
};

var getCurrentTimestamp = function getCurrentTimestamp() {
    return new Date().getTime();
};

/* reducer */
var DEFAULT_STATE = {
    catalogs: {},
    items: {},
    messages: {}
};

var DEFAULT_CATALOG = {
    activeBidder: false,
    approved: false,
    bidderOutbid: false,
    bidders: 1,
    closed: true,
    currentItem: 0,
    networkStatus: 'connected',
    pubNubPublishKey: '',
    status: '',
    won: false
};

var setCatalogLive = function setCatalogLive(state, catalogId) {
    var catalogs = (0, _cloneDeep2.default)(state.catalogs);
    catalogs[catalogId] = catalogs[catalogId] || (0, _cloneDeep2.default)(DEFAULT_CATALOG);
    catalogs[catalogId].status = 'live';
    return catalogs;
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var catalogs = void 0;
    var itemId = void 0;
    var items = void 0;
    var messages = void 0;

    switch (action.type) {
        case ASK_CHANGED:
            catalogs = setCatalogLive(state, action.payload.catalogId);
            catalogs[action.payload.catalogId].currentItem = action.payload.itemId;
            items = (0, _cloneDeep2.default)(state.items);
            items[action.payload.itemId] = items[action.payload.itemId] || {};
            items[action.payload.itemId].currentAskPrice = action.payload.ask;

            return (0, _extends3.default)({}, state, {
                catalogs: catalogs,
                items: items
            });
        case AUCTION_ENDED:
            catalogs = (0, _cloneDeep2.default)(state.catalogs);
            catalogs[action.payload.catalogId] = catalogs[action.payload.catalogId] || {};
            catalogs[action.payload.catalogId].status = 'done';

            return (0, _extends3.default)({}, state, {
                catalogs: catalogs
            });
        case AUCTION_STARTED:
            catalogs = setCatalogLive(state, action.payload.catalogId);

            return (0, _extends3.default)({}, state, {
                catalogs: catalogs
            });
        case BID_ACCEPTED:
            catalogs = setCatalogLive(state, action.payload.catalogId);
            catalogs[action.payload.catalogId].currentItem = action.payload.itemId;
            catalogs[action.payload.catalogId].closed = false;
            catalogs[action.payload.catalogId].activeBidder = !!catalogs[action.payload.catalogId].activeBidder || !!action.payload.myBid;
            catalogs[action.payload.catalogId].bidderOutbid = !!action.payload.bidderOutbid;

            items = (0, _cloneDeep2.default)(state.items);
            items[action.payload.itemId] = items[action.payload.itemId] || { created: getCurrentTimestamp() };
            var current = items[action.payload.itemId];
            var currentCreatedTimeStamp = current.created;
            if (currentCreatedTimeStamp < action.payload.created) {
                current.created = action.payload.created;
                current.leadingBid = action.payload.amount;
                current.leadingBidder = action.payload.bidderId;
                current.currentAskPrice = action.payload.ask;
                current.source = action.payload.source;
            }

            messages = (0, _cloneDeep2.default)(state.messages);
            var type = action.payload.myBid ? 'mybid' : action.payload.bidderOutbid ? 'outbid' : action.payload.source !== 'Reserve' ? 'accepted' : '';

            var reserve = action.payload.source === 'Reserve';

            var data = {
                amount: action.payload.amount,
                bidderId: action.payload.bidderId,
                currency: action.payload.currency,
                paddleNumber: action.payload.paddleNumber,
                source: action.payload.source
            };

            switch (type) {
                case 'accepted':
                    messages = addMessage(messages, action.payload.catalogId, {
                        created: action.payload.created,
                        data: data,
                        type: type
                    });
                    break;
                case 'mybid':
                    messages = addMessage(messages, action.payload.catalogId, {
                        created: action.payload.created,
                        data: data,
                        type: type
                    });
                    break;
                case 'outbid':
                    messages = addMessage(messages, action.payload.catalogId, {
                        created: action.payload.created,
                        data: data,
                        type: type
                    });

                    messages = addMessage(messages, action.payload.catalogId, {
                        created: action.payload.created + 1,
                        data: data,
                        type: 'accepted'
                    });
                    break;
                default:
                    break;
            }

            if (reserve) {
                messages = addMessage(messages, action.payload.catalogId, {
                    created: action.payload.created + 1,
                    data: data,
                    type: 'reserve'
                });
            }

            return (0, _extends3.default)({}, state, {
                catalogs: catalogs,
                items: items,
                messages: messages
            });
        case BID_RETRACTED:
            catalogs = setCatalogLive(state, action.payload.catalogId);
            catalogs[action.payload.catalogId].currentItem = action.payload.itemId;
            catalogs[action.payload.catalogId].bidderOutbid = false;
            catalogs[action.payload.catalogId].closed = false;

            items = (0, _cloneDeep2.default)(state.items);
            items[action.payload.itemId] = items[action.payload.itemId] || {};
            items[action.payload.itemId].leadingBid = action.payload.amount;
            var myBid = items[action.payload.itemId].leadingBidder === action.payload.currentBidderId;
            items[action.payload.itemId].leadingBidder = action.payload.bidderId;
            items[action.payload.itemId].currentAskPrice = action.payload.ask;
            items[action.payload.itemId].source = action.payload.source;
            items[action.payload.itemId].created = action.payload.created;

            messages = addMessage(state.messages, action.payload.catalogId, {
                created: action.payload.created,
                data: {
                    amount: action.payload.ask,
                    currency: action.payload.currency,
                    myBid: myBid
                },
                type: 'retracted'
            });

            return (0, _extends3.default)({}, state, {
                catalogs: catalogs,
                items: items,
                messages: messages
            });
        case LOT_CLOSED:
            catalogs = setCatalogLive(state, action.payload.catalogId);
            catalogs[action.payload.catalogId].bidderOutbid = false;
            if (catalogs[action.payload.catalogId].currentItem === action.payload.itemId) {
                catalogs[action.payload.catalogId].closed = true;
            }

            return (0, _extends3.default)({}, state, {
                catalogs: catalogs
            });
        case LOT_PASSED:
            catalogs = setCatalogLive(state, action.payload.catalogId);
            catalogs[action.payload.catalogId].closed = true;
            catalogs[action.payload.catalogId].bidderOutbid = false;

            messages = addMessage(state.messages, action.payload.catalogId, {
                created: action.payload.created,
                data: { lotNumber: action.payload.lotNumber },
                type: 'passed'
            });

            return (0, _extends3.default)({}, state, {
                catalogs: catalogs,
                messages: messages
            });
        case LOT_REOPENED:
            catalogs = setCatalogLive(state, action.payload.catalogId);
            catalogs[action.payload.catalogId].closed = false;

            messages = addMessage(state.messages, action.payload.catalogId, {
                created: action.payload.created,
                data: { lotNumber: action.payload.lotNumber },
                type: 'reopened'
            });

            return (0, _extends3.default)({}, state, {
                catalogs: catalogs,
                messages: messages
            });
        case LOT_SKIPPED:
            catalogs = setCatalogLive(state, action.payload.catalogId);
            catalogs[action.payload.catalogId].closed = true;
            catalogs[action.payload.catalogId].bidderOutbid = false;

            messages = addMessage(state.messages, action.payload.catalogId, {
                created: action.payload.created,
                data: { lotNumber: action.payload.lotNumber },
                type: 'skipped'
            });

            return (0, _extends3.default)({}, state, {
                catalogs: catalogs,
                messages: messages
            });
        case LOT_SOLD:
            catalogs = setCatalogLive(state, action.payload.catalogId);
            catalogs[action.payload.catalogId].closed = true;
            catalogs[action.payload.catalogId].bidderOutbid = false;
            catalogs[action.payload.catalogId].won = action.payload.myBid;
            messages = addMessage(state.messages, action.payload.catalogId, {
                created: action.payload.created,
                data: {
                    amount: action.payload.amount,
                    bidderId: action.payload.bidderId,
                    currency: action.payload.currency,
                    lotNumber: action.payload.lotNumber,
                    myBid: action.payload.myBid,
                    paddleNumber: action.payload.paddleNumber
                },
                type: 'sold'
            });

            return (0, _extends3.default)({}, state, {
                catalogs: catalogs,
                messages: messages
            });
        case LOT_UNSOLD:
            catalogs = setCatalogLive(state, action.payload.catalogId);
            catalogs[action.payload.catalogId].bidderOutbid = false;
            messages = addMessage(state.messages, action.payload.catalogId, {
                created: action.payload.created,
                data: { lotNumber: action.payload.lotNumber },
                type: 'unsold'
            });

            return (0, _extends3.default)({}, state, {
                catalogs: catalogs,
                messages: messages
            });
        case MISSIVE:
            catalogs = setCatalogLive(state, action.payload.catalogId);
            messages = addMessage(state.messages, action.payload.catalogId, {
                created: action.payload.created,
                text: action.payload.missiveText,
                type: 'missive'
            });

            return (0, _extends3.default)({}, state, {
                catalogs: catalogs,
                messages: messages
            });
        case NEXT_LOT_OPENED:
            // This does not do what one might think
            break;
        case NETWORK_DISCONNECTED:
            catalogs = (0, _cloneDeep2.default)(state.catalogs);
            catalogs[action.payload.catalogId] = catalogs[action.payload.catalogId] || {};
            catalogs[action.payload.catalogId].networkStatus = 'disconnected';
            return (0, _extends3.default)({}, state, {
                catalogs: catalogs
            });
        case NETWORK_RECONNECTED:
            catalogs = (0, _cloneDeep2.default)(state.catalogs);
            catalogs[action.payload.catalogId] = catalogs[action.payload.catalogId] || {};
            catalogs[action.payload.catalogId].networkStatus = 'connected';
            return (0, _extends3.default)({}, state, {
                catalogs: catalogs
            });
        case _catalogRegistration.LOAD_CATALOG_REGISTRATION_SUCCESS:
            catalogs = (0, _cloneDeep2.default)(state.catalogs);
            catalogs[action.meta.catalogId].pubNubPublishKey = action.payload.publishKey;
            var wasApproved = catalogs[action.meta.catalogId].approved;
            catalogs[action.meta.catalogId].approved = action.payload.approved;

            var newState = (0, _extends3.default)({}, state, {
                catalogs: catalogs
            });

            if (!wasApproved && action.payload.approved) {
                messages = addMessage(state.messages, action.meta.catalogId, {
                    created: action.payload.created,
                    type: 'approved'
                });
                newState.messages = messages;
            }

            return newState;
        case _liveCatalogStatus.LOAD_LIVE_CATALOG_STATUS_SUCCESS:
            catalogs = (0, _cloneDeep2.default)(state.catalogs);
            catalogs[action.payload.catalogId] = catalogs[action.payload.catalogId] || {};
            catalogs[action.payload.catalogId].currency = action.payload.currency;
            catalogs[action.payload.catalogId].status = action.payload.status;
            catalogs[action.payload.catalogId].itemCount = action.payload.itemCount;

            items = (0, _cloneDeep2.default)(state.items);

            if (action.payload.currentItem.itemId) {
                var _action$payload$curre = action.payload.currentItem,
                    askPrice = _action$payload$curre.askPrice,
                    created = _action$payload$curre.created,
                    highEstimate = _action$payload$curre.highEstimate,
                    _itemId = _action$payload$curre.itemId,
                    leadingBid = _action$payload$curre.leadingBid,
                    leadingBidder = _action$payload$curre.leadingBidder,
                    lotDescription = _action$payload$curre.lotDescription,
                    lotNumber = _action$payload$curre.lotNumber,
                    lotTitle = _action$payload$curre.lotTitle,
                    lowEstimate = _action$payload$curre.lowEstimate;


                catalogs[action.payload.catalogId].closed = false;
                catalogs[action.payload.catalogId].won = false;
                catalogs[action.payload.catalogId].currentItem = _itemId;
                items[_itemId] = items[_itemId] || {};
                items[_itemId].created = created || getCurrentTimestamp();
                items[_itemId].currentAskPrice = askPrice;
                items[_itemId].description = lotDescription;
                items[_itemId].highEstimate = highEstimate;
                items[_itemId].leadingBid = leadingBid || 0;
                items[_itemId].leadingBidder = leadingBidder || 0;
                items[_itemId].lotNumber = lotNumber;
                items[_itemId].lowEstimate = lowEstimate;
                items[_itemId].title = lotTitle;
            }

            return (0, _extends3.default)({}, state, {
                catalogs: catalogs,
                items: items
            });
        case NEXT_LOT_LOADED:
            itemId = action.payload.itemId;

            catalogs = setCatalogLive(state, action.payload.catalogId);
            catalogs[action.payload.catalogId].currentItem = itemId;
            catalogs[action.payload.catalogId].currency = action.payload.currency;
            catalogs[action.payload.catalogId].closed = false;
            catalogs[action.payload.catalogId].won = false;
            catalogs[action.payload.catalogId].activeBidder = false;
            catalogs[action.payload.catalogId].bidderOutbid = false;

            items = (0, _cloneDeep2.default)(state.items);
            items[itemId] = items[itemId] || {};
            items[itemId].leadingBid = 0;
            items[itemId].leadingBidder = 0;
            items[itemId].currentAskPrice = action.payload.askPrice;
            items[itemId].lotNumber = action.payload.lotNumber;
            items[itemId].title = action.payload.lotTitle;
            items[itemId].description = action.payload.description;
            items[itemId].highEstimate = action.payload.highEstimate;
            items[itemId].lowEstimate = action.payload.lowEstimate;
            items[itemId].index = action.payload.index;
            items[itemId].status = action.payload.status;
            items[itemId].created = action.payload.created;

            messages = addMessage(state.messages, action.payload.catalogId, {
                created: action.payload.created,
                data: {
                    amount: action.payload.askPrice,
                    currency: action.payload.currency,
                    lotNumber: action.payload.lotNumber
                },
                type: 'opened'
            });

            return (0, _extends3.default)({}, state, {
                catalogs: catalogs,
                items: items,
                messages: messages
            });
        case UPDATE_ACTIVE_BIDDERS_PUBNUB:
            catalogs = (0, _cloneDeep2.default)(state.catalogs);
            catalogs[action.payload.catalogId] = catalogs[action.payload.catalogId] || {};
            catalogs[action.payload.catalogId].pubnubBidderCount = action.payload.bidderCount;

            return (0, _extends3.default)({}, state, {
                catalogs: catalogs
            });
        case UPDATE_ACTIVE_BIDDERS_SFS:
            catalogs = (0, _cloneDeep2.default)(state.catalogs);
            catalogs[action.payload.catalogId].currentItem = action.payload.itemId;

            catalogs[action.payload.catalogId] = catalogs[action.payload.catalogId] || {};
            catalogs[action.payload.catalogId].sfsBidderCount = action.payload.bidderCount;

            return (0, _extends3.default)({}, state, {
                catalogs: catalogs
            });
        case _catalog.LOAD_CATALOGS_SUCCESS:
            catalogs = (0, _cloneDeep2.default)(state.catalogs);
            action.payload.catalogs.forEach(function (catalog) {
                if (catalog.catalogStatus === 'done') {
                    // set the catalog to done if it is
                    catalogs[catalog.catalogId] = catalogs[catalog.catalogId] || {};
                    catalogs[catalog.catalogId].status = catalog.catalogStatus;
                }
            });

            return (0, _extends3.default)({}, state, {
                catalogs: catalogs
            });
        default:
            return state;
    }
}

/* SELECTORS */
var stateSelector = function stateSelector(state) {
    return state.console;
};
var idSelector = function idSelector(state, id) {
    return id;
};

var catalogsSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.catalogs;
});
var itemsSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.items;
});
var messagesSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.messages;
});

var getCatalogMessages = exports.getCatalogMessages = (0, _reselect.createSelector)([messagesSelector, idSelector], function (messages, id) {
    return (0, _cloneDeep2.default)(messages[id]) || [];
});

var getCatalogBidders = exports.getCatalogBidders = (0, _reselect.createSelector)([catalogsSelector, idSelector], function (catalogs, id) {
    var catalog = catalogs[id] || {};
    var sfs = catalog.sfsBidderCount || 0;
    var pubnub = catalog.pubnubBidderCount || 0;
    return sfs + pubnub || 1;
});

var getPubNubPublishKey = exports.getPubNubPublishKey = (0, _reselect.createSelector)([catalogsSelector, idSelector], function (catalogs, id) {
    var catalog = catalogs[id] || {};
    return catalog.pubNubPublishKey || '';
});

var getLiveCatalogData = exports.getLiveCatalogData = (0, _reselect.createSelector)([catalogsSelector, getCatalogBidders, idSelector], function (catalogs, bidders, id) {
    return (0, _cloneDeep2.default)((0, _extends3.default)({}, DEFAULT_CATALOG, catalogs[id] || {}, { bidders: bidders }));
});

var getLiveItemData = exports.getLiveItemData = (0, _reselect.createSelector)([itemsSelector, idSelector], function (items, id) {
    return (0, _cloneDeep2.default)(items[id]) || { leadingBid: 0, leadingBidder: 0 };
});

/* ACTION CREATORS */
var askChanged = exports.askChanged = function askChanged(_ref) {
    var ask = _ref.ask,
        catalogId = _ref.catalogId,
        created = _ref.created,
        currency = _ref.currency,
        itemId = _ref.itemId,
        lotNumber = _ref.lotNumber;
    return {
        payload: { ask: ask, catalogId: catalogId, created: created, currency: currency, itemId: itemId, lotNumber: lotNumber },
        type: ASK_CHANGED
    };
};

var auctionClosed = exports.auctionClosed = function auctionClosed(_ref2) {
    var catalogId = _ref2.catalogId,
        created = _ref2.created;
    return {
        payload: { catalogId: catalogId, created: created },
        type: AUCTION_ENDED
    };
};

var auctionStarted = exports.auctionStarted = function auctionStarted(_ref3) {
    var catalogId = _ref3.catalogId,
        created = _ref3.created;
    return {
        payload: { catalogId: catalogId, created: created },
        type: AUCTION_STARTED
    };
};

var bidAccepted = exports.bidAccepted = function bidAccepted(_ref4) {
    var amount = _ref4.amount,
        ask = _ref4.ask,
        bidderId = _ref4.bidderId,
        catalogId = _ref4.catalogId,
        created = _ref4.created,
        currency = _ref4.currency,
        itemId = _ref4.itemId,
        lotNumber = _ref4.lotNumber,
        myBid = _ref4.myBid,
        paddleNumber = _ref4.paddleNumber,
        source = _ref4.source;
    return function () {
        var _ref5 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch, getState) {
            var state, currentBidderId, _getUiLiveBid, bidderHasHighBid, submitted, bidderOutbid;

            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            state = getState();
                            currentBidderId = (0, _user.getBidderId)(state);
                            _getUiLiveBid = (0, _liveBid.getUiLiveBid)(state), bidderHasHighBid = _getUiLiveBid.bidderHasHighBid, submitted = _getUiLiveBid.submitted;
                            bidderOutbid = currentBidderId !== bidderId && bidderHasHighBid && bidderId !== -1 || submitted && !myBid;
                            return _context.abrupt('return', dispatch({
                                payload: {
                                    amount: amount,
                                    ask: ask,
                                    bidderId: bidderId,
                                    bidderOutbid: bidderOutbid,
                                    catalogId: catalogId,
                                    created: created,
                                    currency: currency,
                                    itemId: itemId,
                                    lotNumber: lotNumber,
                                    myBid: myBid,
                                    paddleNumber: paddleNumber,
                                    source: source
                                },
                                type: BID_ACCEPTED
                            }));

                        case 5:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, undefined);
        }));

        return function (_x3, _x4) {
            return _ref5.apply(this, arguments);
        };
    }();
};

var bidRetracted = exports.bidRetracted = function bidRetracted(_ref6) {
    var amount = _ref6.amount,
        ask = _ref6.ask,
        bidderId = _ref6.bidderId,
        catalogId = _ref6.catalogId,
        created = _ref6.created,
        currency = _ref6.currency,
        itemId = _ref6.itemId,
        lotNumber = _ref6.lotNumber,
        source = _ref6.source;
    return function () {
        var _ref7 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(dispatch, getState) {
            var state, currentBidderId;
            return _regenerator2.default.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            state = getState();
                            currentBidderId = (0, _user.getBidderId)(state);
                            return _context2.abrupt('return', dispatch({
                                payload: { amount: amount, ask: ask, bidderId: bidderId, catalogId: catalogId, created: created, currency: currency, currentBidderId: currentBidderId, itemId: itemId, lotNumber: lotNumber, source: source },
                                type: BID_RETRACTED
                            }));

                        case 3:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, undefined);
        }));

        return function (_x5, _x6) {
            return _ref7.apply(this, arguments);
        };
    }();
};

var lotClosed = exports.lotClosed = function lotClosed(_ref8) {
    var catalogId = _ref8.catalogId,
        created = _ref8.created,
        itemId = _ref8.itemId,
        lotNumber = _ref8.lotNumber;
    return {
        payload: { catalogId: catalogId, created: created, itemId: itemId, lotNumber: lotNumber },
        type: LOT_CLOSED
    };
};

var lotPassed = exports.lotPassed = function lotPassed(_ref9) {
    var catalogId = _ref9.catalogId,
        created = _ref9.created,
        lotNumber = _ref9.lotNumber;
    return {
        payload: { catalogId: catalogId, created: created, lotNumber: lotNumber },
        type: LOT_PASSED
    };
};

var lotReopened = exports.lotReopened = function lotReopened(_ref10) {
    var catalogId = _ref10.catalogId,
        created = _ref10.created,
        lotNumber = _ref10.lotNumber;
    return {
        payload: { catalogId: catalogId, created: created, lotNumber: lotNumber },
        type: LOT_REOPENED
    };
};

var lotSkipped = exports.lotSkipped = function lotSkipped(_ref11) {
    var catalogId = _ref11.catalogId,
        created = _ref11.created,
        lotNumber = _ref11.lotNumber;
    return {
        payload: { catalogId: catalogId, created: created, lotNumber: lotNumber },
        type: LOT_SKIPPED
    };
};

var lotSold = exports.lotSold = function lotSold(_ref12) {
    var amount = _ref12.amount,
        bidderId = _ref12.bidderId,
        catalogId = _ref12.catalogId,
        created = _ref12.created,
        currency = _ref12.currency,
        lotNumber = _ref12.lotNumber,
        myBid = _ref12.myBid,
        paddleNumber = _ref12.paddleNumber;
    return {
        payload: { amount: amount, bidderId: bidderId, catalogId: catalogId, created: created, currency: currency, lotNumber: lotNumber, myBid: myBid, paddleNumber: paddleNumber },
        type: LOT_SOLD
    };
};

var lotUnsold = exports.lotUnsold = function lotUnsold(_ref13) {
    var catalogId = _ref13.catalogId,
        created = _ref13.created,
        lotNumber = _ref13.lotNumber;
    return {
        payload: { catalogId: catalogId, created: created, lotNumber: lotNumber },
        type: LOT_UNSOLD
    };
};

var missive = exports.missive = function missive(_ref14) {
    var catalogId = _ref14.catalogId,
        created = _ref14.created,
        missiveText = _ref14.missiveText;
    return {
        payload: { catalogId: catalogId, created: created, missiveText: missiveText },
        type: MISSIVE
    };
};

var networkDisconnected = exports.networkDisconnected = function networkDisconnected(_ref15) {
    var catalogId = _ref15.catalogId;
    return { payload: { catalogId: catalogId }, type: NETWORK_DISCONNECTED };
};
var networkReconnected = exports.networkReconnected = function networkReconnected(_ref16) {
    var catalogId = _ref16.catalogId;
    return { payload: { catalogId: catalogId }, type: NETWORK_RECONNECTED };
};

var nextLotOpened = exports.nextLotOpened = function nextLotOpened(_ref17) {
    var amount = _ref17.amount,
        catalogId = _ref17.catalogId,
        created = _ref17.created,
        currency = _ref17.currency,
        itemId = _ref17.itemId;
    return {
        payload: { amount: amount, catalogId: catalogId, created: created, currency: currency, itemId: itemId },
        type: NEXT_LOT_OPENED
    };
};

var nextLotLoaded = exports.nextLotLoaded = function nextLotLoaded(_ref18) {
    var catalogId = _ref18.catalogId,
        created = _ref18.created,
        currency = _ref18.currency,
        itemId = _ref18.itemId,
        askPrice = _ref18.askPrice,
        highEstimate = _ref18.highEstimate,
        index = _ref18.index,
        description = _ref18.description,
        lotNumber = _ref18.lotNumber,
        lotTitle = _ref18.lotTitle,
        lowEstimate = _ref18.lowEstimate,
        status = _ref18.status;
    return {
        payload: {
            askPrice: askPrice,
            catalogId: catalogId,
            created: created,
            currency: currency,
            description: description,
            highEstimate: highEstimate,
            index: index,
            itemId: itemId,
            lotNumber: lotNumber,
            lotTitle: lotTitle,
            lowEstimate: lowEstimate,
            status: status
        },
        type: NEXT_LOT_LOADED
    };
};

var updateActiveBiddersPubnub = exports.updateActiveBiddersPubnub = function updateActiveBiddersPubnub(_ref19) {
    var bidderCount = _ref19.bidderCount,
        catalogId = _ref19.catalogId;
    return {
        payload: { bidderCount: bidderCount, catalogId: catalogId },
        type: UPDATE_ACTIVE_BIDDERS_PUBNUB
    };
};

var updateActiveBiddersSfs = exports.updateActiveBiddersSfs = function updateActiveBiddersSfs(_ref20) {
    var bidderCount = _ref20.bidderCount,
        catalogId = _ref20.catalogId,
        created = _ref20.created,
        itemId = _ref20.itemId;
    return {
        payload: { bidderCount: bidderCount, catalogId: catalogId, created: created, itemId: itemId },
        type: UPDATE_ACTIVE_BIDDERS_SFS
    };
};

/***/ }),

/***/ "FVZ4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SellerDetailRemote = undefined;

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _helpers = __webpack_require__("SY39");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SellerDetailRemote = exports.SellerDetailRemote = {
    fetchSellerDetailsByIds: function fetchSellerDetailsByIds(_ref) {
        var authToken = _ref.authToken,
            deployment = _ref.deployment,
            sellerIds = _ref.sellerIds;
        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makePost)('<ITEM-API>small/seller-detail', deployment);
            (0, _helpers.addAuthToken)(request, authToken);
            request.send({ ids: sellerIds });
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response });
            });
        });
    }
};

/***/ }),

/***/ "FftY":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = __webpack_require__("dcb+");

var _jsx3 = _interopRequireDefault(_jsx2);

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Polyfill for webpack, just in case
if (false) require.ensure = function (d, c) {
    c(require);
};

var SignUpPasswordModalLoader = function (_Component) {
    (0, _inherits3.default)(SignUpPasswordModalLoader, _Component);

    function SignUpPasswordModalLoader(props, context) {
        (0, _classCallCheck3.default)(this, SignUpPasswordModalLoader);

        var _this = (0, _possibleConstructorReturn3.default)(this, (SignUpPasswordModalLoader.__proto__ || (0, _getPrototypeOf2.default)(SignUpPasswordModalLoader)).call(this, props, context));

        _this.state = {
            Component: null,
            mounted: false
        };
        return _this;
    }

    (0, _createClass3.default)(SignUpPasswordModalLoader, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            var _this2 = this;

            return new _promise2.default(function (resolve) {
                __webpack_require__.e/* require.ensure */(29).then((function () {
                    resolve(__webpack_require__("7gVH"));
                }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            }).then(function (container) {
                _this2.setState({ Component: container });
            });
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.setState({ mounted: true });
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.setState({ mounted: false });
        }
    }, {
        key: 'render',
        value: function render() {
            var _state = this.state,
                Component = _state.Component,
                mounted = _state.mounted;

            return mounted && Component !== null ? (0, _jsx3.default)(Component, {}) : null;
        }
    }]);
    return SignUpPasswordModalLoader;
}(_react.Component);

exports.default = SignUpPasswordModalLoader;
module.exports = exports['default'];

/***/ }),

/***/ "FlQW":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("GiK3");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SailthruInit = function (_PureComponent) {
    (0, _inherits3.default)(SailthruInit, _PureComponent);

    function SailthruInit() {
        (0, _classCallCheck3.default)(this, SailthruInit);
        return (0, _possibleConstructorReturn3.default)(this, (SailthruInit.__proto__ || (0, _getPrototypeOf2.default)(SailthruInit)).apply(this, arguments));
    }

    (0, _createClass3.default)(SailthruInit, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            if (window.Sailthru && window.Sailthru.init && !window.Sailthru.initRan) {
                window.Sailthru.init({
                    autoTrackPageview: false,
                    customerId: this.props.customerId,
                    isCustom: true,
                    useStoredTags: true
                });
                window.Sailthru.initRan = true;
            }
        }
    }, {
        key: 'render',
        value: function render() {
            return null;
        }
    }]);
    return SailthruInit;
}(_react.PureComponent);

exports.default = SailthruInit;
module.exports = exports['default'];

/***/ }),

/***/ "FneX":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getCreateAccountState = exports.CREATE_ACCOUNT_SUCCESS_LOG_ANALYTICS = exports.CREATE_ACCOUNT_SUCCESS = exports.CREATE_ACCOUNT_REQUEST = exports.CREATE_ACCOUNT_FAIL = undefined;

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.submitCreateAccount = submitCreateAccount;

var _user = __webpack_require__("CFLi");

var _api = __webpack_require__("zFQO");

var _bidderExists = __webpack_require__("uien");

var _reselect = __webpack_require__("bndy");

var _config = __webpack_require__("iS9E");

var _analytics = __webpack_require__("yxCd");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Action Types */
var CREATE_ACCOUNT_FAIL = exports.CREATE_ACCOUNT_FAIL = 'la/ui/createAccount/FAIL';
var CREATE_ACCOUNT_REQUEST = exports.CREATE_ACCOUNT_REQUEST = 'la/ui/createAccount/REQUEST';
var CREATE_ACCOUNT_SUCCESS = exports.CREATE_ACCOUNT_SUCCESS = 'la/ui/createAccount/SUCCESS';
var CREATE_ACCOUNT_SUCCESS_LOG_ANALYTICS = exports.CREATE_ACCOUNT_SUCCESS_LOG_ANALYTICS = 'la/ui/createAccount/LOG_ANALYTICS';

// reducer
var DEFAULT_STATE = {
    error: null,
    submitted: false,
    success: false
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        case CREATE_ACCOUNT_FAIL:
            return (0, _extends3.default)({}, state, {
                error: action.payload,
                submitted: false,
                success: false
            });
        case CREATE_ACCOUNT_REQUEST:
            return (0, _extends3.default)({}, state, {
                error: null,
                submitted: true,
                success: false
            });
        case CREATE_ACCOUNT_SUCCESS:
            return (0, _extends3.default)({}, state, {
                error: null,
                submitted: false,
                success: true
            });
        default:
            return state;
    }
}

/* SELECTORS */
var stateSelector = function stateSelector(state) {
    return state.ui.createAccount;
};

var getCreateAccountState = exports.getCreateAccountState = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state;
});

/* ACTION CREATORS */
function submitCreateAccount(emailAddress, attributionData) {
    return function (dispatch, getState) {
        var state = getState();
        var deployment = (0, _config.getDeployment)(state);
        var forceFetchBidderData = true;
        dispatch({
            payload: emailAddress,
            type: CREATE_ACCOUNT_REQUEST
        });
        return _api.Bidder.postCreateAccount({ deployment: deployment, emailAddress: emailAddress }).then(function (response) {
            var token = response.payload.createToken;
            dispatch({
                meta: { actionTime: Date.now() },
                payload: token,
                type: CREATE_ACCOUNT_SUCCESS
            });
            dispatch((0, _user.fetchBidderDataIfNeeded)(token, forceFetchBidderData)).then(function () {
                var userData = (0, _user.getUserData)(getState());
                dispatch({
                    meta: (0, _extends3.default)({}, (0, _analytics.getRegisterAccountAnalytics)(getState(), userData.bidderId, attributionData), {
                        actionTime: Date.now()
                    }),
                    payload: userData,
                    type: CREATE_ACCOUNT_SUCCESS_LOG_ANALYTICS
                });
            });
        }).catch(function (error) {
            // Response from Flynn has this format { Payload: { bidderExists?, error?, token?}}
            if (error.payload && error.payload.bidderExists) {
                dispatch((0, _bidderExists.bidderExistsSuccess)(emailAddress));
            }
            if (error.payload && error.payload.error) {
                dispatch({
                    error: true,
                    meta: { emailAddress: emailAddress },
                    payload: error.payload.error,
                    type: CREATE_ACCOUNT_FAIL
                });
            } else {
                // I think this is the proper way to catch a 500 error from the server
                dispatch({
                    error: true,
                    meta: { emailAddress: emailAddress },
                    payload: error.message,
                    type: CREATE_ACCOUNT_FAIL
                });
            }
        });
    };
}

/***/ }),

/***/ "FoiQ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = __webpack_require__("dcb+");

var _jsx3 = _interopRequireDefault(_jsx2);

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Polyfill for webpack, just in case
if (false) require.ensure = function (d, c) {
    c(require);
};

var ConfirmPasswordModalLoader = function (_Component) {
    (0, _inherits3.default)(ConfirmPasswordModalLoader, _Component);

    function ConfirmPasswordModalLoader(props, context) {
        (0, _classCallCheck3.default)(this, ConfirmPasswordModalLoader);

        var _this = (0, _possibleConstructorReturn3.default)(this, (ConfirmPasswordModalLoader.__proto__ || (0, _getPrototypeOf2.default)(ConfirmPasswordModalLoader)).call(this, props, context));

        _this.state = {
            Component: null,
            mounted: false
        };
        return _this;
    }

    (0, _createClass3.default)(ConfirmPasswordModalLoader, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            var _this2 = this;

            return new _promise2.default(function (resolve) {
                __webpack_require__.e/* require.ensure */(31).then((function () {
                    resolve(__webpack_require__("Ec8g"));
                }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            }).then(function (container) {
                _this2.setState({ Component: container });
            });
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.setState({ mounted: true });
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.setState({ mounted: false });
        }
    }, {
        key: 'render',
        value: function render() {
            var _state = this.state,
                Component = _state.Component,
                mounted = _state.mounted;

            return mounted && Component !== null ? (0, _jsx3.default)(Component, {}) : null;
        }
    }]);
    return ConfirmPasswordModalLoader;
}(_react.Component);

exports.default = ConfirmPasswordModalLoader;
module.exports = exports['default'];

/***/ }),

/***/ "G3Tb":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = createLogger;

var _util = __webpack_require__("OMJi");

// Server side redux action logger
function createLogger(shouldLog) {
    return function (store) {
        return function (next) {
            return function (action) {
                if (!shouldLog) return next(action);

                var formattedPayload = (0, _util.inspect)(action.payload, { colors: true });
                // eslint-disable-next-line no-console
                console.log(' * ' + action.type + ': ' + formattedPayload);
                return next(action);
            };
        };
    };
}
module.exports = exports['default'];

/***/ }),

/***/ "Gd4V":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getCategoryLevel = getCategoryLevel;
exports.getCategoryLevels = getCategoryLevels;
function getCategoryLevel(item) {
    if (!item) {
        return {};
    }
    var categoryId = void 0;
    if (item.categoryId) {
        categoryId = item.categoryId;
    } else {
        categoryId = item.l1CategoryId;
    }

    if (categoryId === item.l1CategoryId) {
        return {
            categoryId: categoryId,
            categoryLabel: item.l1CategoryLabel,
            categoryName: item.l1CategoryName,
            categoryUrl: item.l1CategoryUrl
        };
    } else if (categoryId === item.l2CategoryId) {
        return {
            categoryId: categoryId,
            categoryLabel: item.l2CategoryLabel,
            categoryName: item.l2CategoryName,
            categoryUrl: item.l2CategoryUrl
        };
    } else if (categoryId === item.l3CategoryId) {
        return {
            categoryId: categoryId,
            categoryLabel: item.l3CategoryLabel,
            categoryName: item.l3CategoryName,
            categoryUrl: item.l3CategoryUrl
        };
    } else if (categoryId === item.l4CategoryId) {
        return {
            categoryId: categoryId,
            categoryLabel: item.l4CategoryLabel,
            categoryName: item.l4CategoryName,
            categoryUrl: item.l4CategoryUrl
        };
    }
}

function getCategoryLevels(item) {
    var collection = [];

    if (!item) {
        return collection;
    }

    collection.push({
        categoryId: item.l1CategoryId,
        categoryLabel: item.l1CategoryLabel,
        categoryName: item.l1CategoryName,
        categoryUrl: item.l1CategoryUrl
    });

    if (item.l2CategoryId) {
        collection.push({
            categoryId: item.l2CategoryId,
            categoryLabel: item.l2CategoryLabel,
            categoryName: item.l2CategoryName,
            categoryUrl: item.l2CategoryUrl
        });
    }

    if (item.l3CategoryId) {
        collection.push({
            categoryId: item.l3CategoryId,
            categoryLabel: item.l3CategoryLabel,
            categoryName: item.l3CategoryName,
            categoryUrl: item.l3CategoryUrl
        });
    }

    if (item.l4CategoryId) {
        collection.push({
            categoryId: item.l4CategoryId,
            categoryLabel: item.l4CategoryLabel,
            categoryName: item.l4CategoryName,
            categoryUrl: item.l4CategoryUrl
        });
    }

    return collection;
}

/***/ }),

/***/ "Gk4U":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fetchItemsIfNeeded = exports.getNextAndPreviousItems = exports.whichCatalogItemsNeeded = exports.getItemIdsForSeller = exports.getItemIdsForCatalog = exports.isItemLoading = exports.getLoadTimeForItem = exports.getItem = exports.LOAD_ITEMS_SUCCESS = exports.LOAD_ITEMS_REQUEST = exports.LOAD_ITEMS_FAIL = undefined;

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _regenerator = __webpack_require__("Xxa5");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__("exGp");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _keys = __webpack_require__("fZjL");

var _keys2 = _interopRequireDefault(_keys);

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;

var _loaded = __webpack_require__("N5um");

var _fetchBatch = __webpack_require__("6OCT");

var _api = __webpack_require__("zFQO");

var _cloneDeep = __webpack_require__("kvU2");

var _cloneDeep2 = _interopRequireDefault(_cloneDeep);

var _reselect = __webpack_require__("bndy");

var _difference = __webpack_require__("WlNK");

var _difference2 = _interopRequireDefault(_difference);

var _user = __webpack_require__("CFLi");

var _filteredItems = __webpack_require__("IeGF");

var _config = __webpack_require__("iS9E");

var _catalogAd = __webpack_require__("0QM2");

var _catalogItems = __webpack_require__("ozIy");

var _home = __webpack_require__("TSUT");

var _sellerRecordResults = __webpack_require__("TaFV");

var _ms = __webpack_require__("EarI");

var _ms2 = _interopRequireDefault(_ms);

var _union = __webpack_require__("gszD");

var _union2 = _interopRequireDefault(_union);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Action Types */
var LOAD_ITEMS_FAIL = exports.LOAD_ITEMS_FAIL = 'la/domain/items/LOAD_FAIL';
var LOAD_ITEMS_REQUEST = exports.LOAD_ITEMS_REQUEST = 'la/domain/items/LOAD_REQUEST';
var LOAD_ITEMS_SUCCESS = exports.LOAD_ITEMS_SUCCESS = 'la/domain/items/LOAD_SUCCESS';

var REDUX_STORE_TIME = (0, _ms2.default)('30m');
var FETCH_SET_SIZE = 128;

/* reducer */
var DEFAULT_STATE = {
    byId: {},
    loaded: {},
    loading: []
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var existing = void 0;
    var loaded = void 0;
    var loading = void 0;
    var time = void 0;

    switch (action.type) {
        case LOAD_ITEMS_FAIL:
            return (0, _extends3.default)({}, state, {
                loading: (0, _difference2.default)(state.loading, action.meta.itemIds)
            });
        case LOAD_ITEMS_REQUEST:
            return (0, _extends3.default)({}, state, {
                loading: (0, _union2.default)(state.loading, action.payload)
            });
        case _catalogItems.LOAD_CATALOG_ITEMS_SUCCESS:
            existing = (0, _cloneDeep2.default)(state.byId);
            loaded = (0, _extends3.default)({}, state.loaded);
            loading = (0, _cloneDeep2.default)(state.loading);
            time = action.meta.actionTime;
            action.payload.forEach(function (item) {
                existing[item.itemId] = (0, _extends3.default)({}, item);
                loaded[item.itemId] = time;
                loading = (0, _difference2.default)(loading, [item.itemId]);
            });
            return (0, _extends3.default)({}, state, {
                byId: existing,
                loaded: loaded,
                loading: loading
            });
        case _catalogAd.LOAD_CATALOG_AD_SUCCESS:
        case _home.LOAD_HOME_DATA_SUCCESS:
        case LOAD_ITEMS_SUCCESS:
        case _sellerRecordResults.LOAD_SELLER_RECORD_RESULTS_SUCCESS:
            existing = (0, _cloneDeep2.default)(state.byId);
            loaded = (0, _extends3.default)({}, state.loaded);
            loading = (0, _cloneDeep2.default)(state.loading);
            time = action.meta.actionTime;

            if (action.payload.items) {
                action.payload.items.forEach(function (item) {
                    existing[item.itemId] = (0, _extends3.default)({}, item);
                    loaded[item.itemId] = time;
                    loading = (0, _difference2.default)(loading, [item.itemId]);
                });
            }
            return (0, _extends3.default)({}, state, {
                byId: existing,
                loaded: loaded,
                loading: loading
            });
        default:
            return state;
    }
}

/* SELECTORS */
var stateSelector = function stateSelector(state) {
    return state.domain.item;
};
var idSelector = function idSelector(state, id) {
    return id;
};

var byIdSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.byId;
});

var loadedSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.loaded;
});

var loadingSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.loading;
});

// TODO: remove the cloneDeep after the mutation in cardData is fixed
var getItem = exports.getItem = (0, _reselect.createSelector)([byIdSelector, idSelector], function (byId, id) {
    return (0, _cloneDeep2.default)(byId[id]) || {};
});

var getLoadTimeForItem = exports.getLoadTimeForItem = (0, _reselect.createSelector)([loadedSelector, idSelector], function (loaded, id) {
    return loaded[id] || 0;
});

var isItemLoading = exports.isItemLoading = (0, _reselect.createSelector)([loadingSelector, idSelector], function (loading, id) {
    return loading.includes(id);
});

var getItemIdsForCatalog = exports.getItemIdsForCatalog = (0, _reselect.createSelector)([byIdSelector, idSelector], function (byId, id) {
    return (0, _keys2.default)(byId).map(function (key) {
        return byId[key];
    }).filter(function (item) {
        return item.catalogId === id;
    }).map(function (item) {
        return item.itemId;
    });
});

var getItemIdsForSeller = exports.getItemIdsForSeller = (0, _reselect.createSelector)([byIdSelector, idSelector], function (byId, id) {
    return (0, _keys2.default)(byId).map(function (key) {
        return byId[key];
    }).filter(function (item) {
        return item.sellerId === id;
    }).map(function (item) {
        return item.itemId;
    });
});

var shouldFetchItem = function shouldFetchItem(state, itemId) {
    if (!itemId) return false;
    var item = getItem(state, itemId);
    if (item) {
        var loaded = getLoadTimeForItem(state, itemId);
        var time = Date.now();
        var diff = time - loaded;
        if (diff < REDUX_STORE_TIME) return false;
    }
    var loading = isItemLoading(state, itemId);
    return !loading;
};

var whichItemsNeeded = function whichItemsNeeded(state, itemIds) {
    return itemIds.filter(function (itemId) {
        return shouldFetchItem(state, itemId);
    });
};

var shouldFetchItemsForCatalog = function shouldFetchItemsForCatalog(state, catalogId) {
    if (!catalogId) return false;
    var loaded = (0, _loaded.getLoadTimeForCatalogItems)(state, catalogId);
    var time = Date.now();
    var diff = time - loaded;
    if (diff < REDUX_STORE_TIME) return false;
    var loading = (0, _loaded.isCatalogItemsLoading)(state, catalogId);
    return !loading;
};

var whichCatalogItemsNeeded = exports.whichCatalogItemsNeeded = function whichCatalogItemsNeeded(state, catalogIds) {
    return catalogIds.filter(function (catalogId) {
        return shouldFetchItemsForCatalog(state, catalogId);
    });
};

var getNextAndPreviousItems = exports.getNextAndPreviousItems = function getNextAndPreviousItems(state, itemId) {
    var item = getItem(state, itemId);
    var lotNumber = item.lotNumber;

    var _getCatalogItems = (0, _filteredItems.getCatalogItems)(state, item.catalogId, {
        sort: 'LOT_NUMBER_LOWEST_FIRST'
    }),
        items = _getCatalogItems.items;

    var previous = {};
    var next = {};
    // eslint-disable-next-line no-plusplus
    for (var i = 0; i < items.length; i++) {
        var current = items[i];
        if (current.item.lotNumber === lotNumber) {
            previous = i - 1 >= 0 ? items[i - 1].item : {};
            next = i + 1 < items.length ? items[i + 1].item : {};
            break;
        }
    }
    return { next: next, previous: previous };
};

/* ACTION CREATORS */
var loadItems = function loadItems(itemIds, loadingId, lastRound) {
    return function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch, getState) {
            var state, authToken, deployment, response;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.prev = 0;
                            state = getState();
                            authToken = (0, _user.getAuthToken)(state);
                            deployment = (0, _config.getDeployment)(state);

                            dispatch({
                                payload: itemIds,
                                type: LOAD_ITEMS_REQUEST
                            });
                            _context.next = 7;
                            return _api.Item.fetchItemsByIds({ authToken: authToken, deployment: deployment, itemIds: itemIds });

                        case 7:
                            response = _context.sent;

                            dispatch({
                                meta: { actionTime: Date.now(), itemIds: itemIds },
                                payload: response.data,
                                type: LOAD_ITEMS_SUCCESS
                            });
                            if (lastRound) {
                                dispatch((0, _fetchBatch.loadBatchEnd)(loadingId));
                            }
                            _context.next = 16;
                            break;

                        case 12:
                            _context.prev = 12;
                            _context.t0 = _context['catch'](0);

                            dispatch({
                                error: true,
                                meta: { itemIds: itemIds },
                                payload: _context.t0,
                                type: LOAD_ITEMS_FAIL
                            });
                            dispatch((0, _fetchBatch.loadBatchEnd)(loadingId));

                        case 16:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, undefined, [[0, 12]]);
        }));

        return function (_x3, _x4) {
            return _ref.apply(this, arguments);
        };
    }();
};

var loadItemsInSets = function loadItemsInSets(ids, setSize, loadingId) {
    return function (dispatch) {
        if (ids.length > setSize) {
            var newSize = Math.min(8192, setSize * 2);
            return dispatch(loadItems(ids.slice(0, setSize), loadingId, false)).then(function () {
                dispatch(loadItemsInSets(ids.slice(setSize), newSize, loadingId));
            });
        }
        return dispatch(loadItems(ids, loadingId, true));
    };
};

var fetchItemsIfNeeded = exports.fetchItemsIfNeeded = function fetchItemsIfNeeded(itemIds) {
    var loadingId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'none';

    return function (dispatch, getState) {
        var needed = whichItemsNeeded(getState(), itemIds);
        if (needed.length) {
            dispatch((0, _fetchBatch.loadBatchStart)(loadingId));
            return dispatch(loadItemsInSets(needed, FETCH_SET_SIZE, loadingId));
        }
        return _promise2.default.resolve();
    };
};

/***/ }),

/***/ "GlFK":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var modalTypes = {
    ABSENTEE_BID: 'ABSENTEE_BID',
    ADD_CREDIT_CARD: 'ADD_CREDIT_CARD',
    ADD_SEARCH_ALERT: 'ADD_SEARCH_ALERT',
    CHANGE_PASSWORD: 'CHANGE_PASSWORD',
    COMPLETE_ACCOUNT: 'COMPLETE_ACCOUNT',
    CONFIRM_CONSIGNMENT: 'CONFIRM_CONSIGNMENT',
    CONFIRM_PASSWORD: 'CONFIRM_PASSWORD',
    DOWNLOAD_MOBILE: 'DOWNLOAD_MOBILE',
    FORGOT_PASSWORD: 'FORGOT_PASSWORD',
    HEALTHCHECK: 'HEALTHCHECK',
    INSTALL_FLASH: 'INSTALL_FLASH',
    ITEM_DESCRIPTION: 'ITEM_DESCRIPTION',
    LIVE_BID: 'LIVE_BID',
    LOGIN: 'LOGIN',
    NONE: 'NONE',
    REGISTER_FOR_AUCTION: 'REGISTER_FOR_AUCTION',
    RETRACT_BID: 'RETRACT_BID',
    SEND_SELLER_CONSIGNMENT_MESSAGE: 'SEND_SELLER_CONSIGNMENT_MESSAGE',
    SEND_SELLER_MESSAGE: 'SEND_SELLER_MESSAGE',
    SET_PASSWORD: 'SET_PASSWORD',
    SIGN_UP: 'SIGN_UP',
    TERMS: 'TERMS'
};

exports.default = modalTypes;
module.exports = exports['default'];

/***/ }),

/***/ "GomR":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _jsx2 = __webpack_require__("dcb+");

var _jsx3 = _interopRequireDefault(_jsx2);

var _class, _temp;

var _components = __webpack_require__("bGai");

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propsComparer = __webpack_require__("wsGv");

var _propsComparer2 = _interopRequireDefault(_propsComparer);

var _reactIntl = __webpack_require__("Pq8k");

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _SignUpEmail = __webpack_require__("Dc2Q");

var _SignUpEmail2 = _interopRequireDefault(_SignUpEmail);

var _urls = __webpack_require__("CakR");

var _SignUpModal = __webpack_require__("IRS6");

var _SignUpModal2 = _interopRequireDefault(_SignUpModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var headerText = (0, _jsx3.default)(_reactIntl.FormattedMessage, {
    id: 'sign_up_for_a_free_membership'
});

var SignUpModal = (_temp = _class = function (_Component) {
    (0, _inherits3.default)(SignUpModal, _Component);

    function SignUpModal() {
        (0, _classCallCheck3.default)(this, SignUpModal);
        return (0, _possibleConstructorReturn3.default)(this, (SignUpModal.__proto__ || (0, _getPrototypeOf2.default)(SignUpModal)).apply(this, arguments));
    }

    (0, _createClass3.default)(SignUpModal, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps) {
            return (0, _propsComparer2.default)(this.props, nextProps, ['error', 'isMobile', 'isTablet', 'show', 'submitted', 'success', 'whiteLabel']);
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                cancelSignUp = _props.cancelSignUp,
                error = _props.error,
                isMobile = _props.isMobile,
                isTablet = _props.isTablet,
                openLoginModal = _props.openLoginModal,
                setEmail = _props.setEmail,
                show = _props.show,
                submitCreateAccount = _props.submitCreateAccount,
                submitted = _props.submitted,
                whiteLabel = _props.whiteLabel;


            var link = (0, _jsx3.default)(_components.Link, {
                onClick: openLoginModal
            }, 'link', (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'log_in'
            }));
            var footerContent = (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'already_have_an_account_sign_in_here',
                values: { link: link }
            });

            var modalHeader = (0, _jsx3.default)(_components.ModalHeader, {
                onHide: cancelSignUp,
                content: headerText,
                hideLogo: whiteLabel
            });
            var modalLeftImage = isMobile && !isTablet ? null : (0, _jsx3.default)(_components.ImageWithFallback, {
                src: _urls.signupLadySmallUrl
            });
            var modalBody = (0, _jsx3.default)('div', {}, void 0, (0, _jsx3.default)(_SignUpEmail2.default, {
                error: error,
                setEmail: setEmail,
                submitCreateAccount: submitCreateAccount,
                submitted: submitted
            }));
            var modalFooter = (0, _jsx3.default)('div', {}, void 0, footerContent);

            return (0, _jsx3.default)(_components.Modal, {
                body: modalBody,
                contentLabel: 'SignUpModal',
                footer: modalFooter,
                footerClassName: _SignUpModal2.default.footer,
                header: modalHeader,
                leftImage: modalLeftImage,
                show: show
            });
        }
    }]);
    return SignUpModal;
}(_react.Component), _class.defaultProps = {
    error: '',
    show: false,
    submitted: false
}, _temp);
exports.default = SignUpModal;
module.exports = exports['default'];

/***/ }),

/***/ "GvHb":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.autoOpenCreateAccountModal = exports.shouldPopModal = exports.shouldStopAutoPopup = exports.getUiModalShown = exports.getUiDateLastShown = exports.DAYS_TO_WAIT_TO_SHOW_MODAL_AGAIN = exports.AUTO_POP_MODAL_SUCCESS = undefined;

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;

var _modal = __webpack_require__("u90i");

var _reselect = __webpack_require__("bndy");

var _login = __webpack_require__("SpFG");

var _enums = __webpack_require__("cjn6");

var _momentTimezone = __webpack_require__("xNPZ");

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _passwordReset = __webpack_require__("fWpZ");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Action Types */
var AUTO_POP_MODAL_SUCCESS = exports.AUTO_POP_MODAL_SUCCESS = 'la/ui/autoPopModal/SUCCESS';
var DAYS_TO_WAIT_TO_SHOW_MODAL_AGAIN = exports.DAYS_TO_WAIT_TO_SHOW_MODAL_AGAIN = 7;

// reducer
var DEFAULT_STATE = {
    dateLastShown: '',
    disableModalForTesting: false,
    hasLoggedInBefore: false
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        case AUTO_POP_MODAL_SUCCESS:
            return (0, _extends3.default)({}, state, {
                dateLastShown: action.payload
            });
        case _login.LOGIN_SUCCESS:
        case _passwordReset.PASSWORD_RESET_SUCCESS:
            return (0, _extends3.default)({}, state, {
                hasLoggedInBefore: true
            });
        default:
            return state;
    }
}

/* SELECTORS */
var stateSelector = function stateSelector(state) {
    return state.ui.autoPopModal;
};

var getUiDateLastShown = exports.getUiDateLastShown = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.dateLastShown;
});

var getUiHasLoggedInBefore = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.hasLoggedInBefore;
});

var getUiModalShown = exports.getUiModalShown = (0, _reselect.createSelector)(getUiDateLastShown, function (date) {
    return !!date;
});

var shouldStopAutoPopup = exports.shouldStopAutoPopup = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.disableModalForTesting;
});

var shouldPopModal = exports.shouldPopModal = (0, _reselect.createSelector)([shouldStopAutoPopup, _modal.getOpenModal, getUiDateLastShown, getUiModalShown, getUiHasLoggedInBefore], function (abort, openModal, dateLastShown, hasSeenModal, hasLoggedInBefore) {
    if (abort) return false;

    var seenMoreThanCertainNumber = false;
    if (!!dateLastShown) {
        var now = (0, _momentTimezone2.default)();
        var difference = (0, _momentTimezone2.default)(dateLastShown).diff(now, 'days') * -1;
        seenMoreThanCertainNumber = difference >= DAYS_TO_WAIT_TO_SHOW_MODAL_AGAIN;
    }
    var popModal = (!hasSeenModal || seenMoreThanCertainNumber) && !hasLoggedInBefore && openModal === _enums.modalTypes.NONE;
    return popModal;
});

/* ACTION CREATORS */
var autoOpenCreateAccountModal = exports.autoOpenCreateAccountModal = function autoOpenCreateAccountModal() {
    return function (dispatch, getState) {
        var state = getState();
        if (shouldPopModal(state)) {
            return _promise2.default.all([dispatch({
                payload: (0, _momentTimezone2.default)(new Date()).format('YYYY-MM-DD'),
                type: AUTO_POP_MODAL_SUCCESS
            }), dispatch((0, _modal.openCreateAccountModal)())]);
        } else {
            return _promise2.default.resolve({});
        }
    };
};

/***/ }),

/***/ "H1j4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

var _ = __webpack_require__("cjn6");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var savedItemSortOrders = (0, _extends3.default)({}, _.itemSortOrders, {
    SAVED_RECENT_FIRST: 'SAVED_RECENT_FIRST',
    SAVED_OLDEST_FIRST: 'SAVED_OLDEST_FIRST'
}); /*eslint-disable sort-keys */
exports.default = savedItemSortOrders;
module.exports = exports['default'];

/***/ }),

/***/ "HJpS":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var itemSortOrders = {
    /*eslint-disable */
    PRICE_HIGHEST_FIRST: 'PRICE_HIGHEST_FIRST',
    PRICE_LOWEST_FIRST: 'PRICE_LOWEST_FIRST',
    ESTIMATE_HIGHEST_FIRST: 'ESTIMATE_HIGHEST_FIRST',
    ESTIMATE_LOWEST_FIRST: 'ESTIMATE_LOWEST_FIRST',
    MOST_BIDS: 'MOST_BIDS',
    LEAST_BIDS: 'LEAST_BIDS',
    LOT_NUMBER_HIGHEST_FIRST: 'LOT_NUMBER_HIGHEST_FIRST',
    LOT_NUMBER_LOWEST_FIRST: 'LOT_NUMBER_LOWEST_FIRST',
    DATE_ASCENDING: 'DATE_ASCENDING',
    DATE_DESCENDING: 'DATE_DESCENDING',
    TIME_ENDING_FURTHEST: 'TIME_ENDING_FURTHEST',
    TIME_SOONEST_FIRST: 'TIME_SOONEST_FIRST'
    /*eslint-enable */
};

exports.default = itemSortOrders;
module.exports = exports['default'];

/***/ }),

/***/ "HW2X":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _sellerDetail = __webpack_require__("FVZ4");

var SellerDetail = {
    fetchSellerDetailsByIds: _sellerDetail.SellerDetailRemote.fetchSellerDetailsByIds
};

exports.default = SellerDetail;
module.exports = exports['default'];

/***/ }),

/***/ "HgIS":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = __webpack_require__("dcb+");

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _reactHelmet = __webpack_require__("PIAa");

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _urls = __webpack_require__("CakR");

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AppHeaderMeta = (_temp = _class = function (_Component) {
    (0, _inherits3.default)(AppHeaderMeta, _Component);

    function AppHeaderMeta() {
        (0, _classCallCheck3.default)(this, AppHeaderMeta);
        return (0, _possibleConstructorReturn3.default)(this, (AppHeaderMeta.__proto__ || (0, _getPrototypeOf2.default)(AppHeaderMeta)).apply(this, arguments));
    }

    (0, _createClass3.default)(AppHeaderMeta, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate() {
            return false;
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                baseUrl = _props.baseUrl,
                pathname = _props.pathname,
                whiteLabel = _props.whiteLabel;
            var formatMessage = this.context.intl.formatMessage;


            var indexOfQuestion = pathname.indexOf('?');
            var path = !pathname.includes('?') ? pathname : pathname.substring(0, indexOfQuestion);
            var canonical = '' + baseUrl + path;
            var iOSAppUrl = 'https://itunes.apple.com/us/app/live-auctions/id321243082';

            var description = formatMessage({ id: 'get_in_on_the_auction' });
            var title = formatMessage({ id: 'bid_in_online_auctions' });

            return (0, _jsx3.default)(_reactHelmet2.default, {
                titleTemplate: '%s'
            }, void 0, (0, _jsx3.default)('link', {
                rel: 'canonical',
                href: canonical
            }), (0, _jsx3.default)('meta', {
                name: 'description',
                content: description
            }), (0, _jsx3.default)('title', {}, void 0, title), (0, _jsx3.default)('meta', {
                property: 'og:description',
                content: description
            }), (0, _jsx3.default)('meta', {
                property: 'og:image',
                content: _urls.logoUrl
            }), (0, _jsx3.default)('meta', {
                property: 'og:image:height',
                content: '600'
            }), (0, _jsx3.default)('meta', {
                property: 'og:image:width',
                content: '600'
            }), (0, _jsx3.default)('meta', {
                property: 'og:locale',
                content: 'en_US'
            }), (0, _jsx3.default)('meta', {
                property: 'og:site_name',
                content: 'LiveAuctioneers'
            }), (0, _jsx3.default)('meta', {
                property: 'og:title',
                content: title
            }), (0, _jsx3.default)('meta', {
                property: 'og:url',
                content: canonical
            }), (0, _jsx3.default)('meta', {
                property: 'og:type',
                content: 'website'
            }), (0, _jsx3.default)('meta', {
                name: 'twitter:app:country',
                content: 'US'
            }), (0, _jsx3.default)('meta', {
                name: 'twitter:app:id:googleplay',
                content: 'com.liveauctioneers.and'
            }), (0, _jsx3.default)('meta', {
                name: 'twitter:app:id:ipad',
                content: '321243082'
            }), (0, _jsx3.default)('meta', {
                name: 'twitter:app:id:iphone',
                content: '321243082'
            }), (0, _jsx3.default)('meta', {
                name: 'twitter:app:name:googleplay',
                content: 'LiveAuctioneers'
            }), (0, _jsx3.default)('meta', {
                name: 'twitter:app:name:ipad',
                content: 'LiveAuctioneers'
            }), (0, _jsx3.default)('meta', {
                name: 'twitter:app:name:iphone',
                content: 'LiveAuctioneers'
            }), (0, _jsx3.default)('meta', {
                name: 'twitter:app:url:googleplay',
                content: 'https://play.google.com/store/apps/details?id=com.liveauctioneers.and'
            }), (0, _jsx3.default)('meta', {
                name: 'twitter:app:url:ipad',
                content: iOSAppUrl
            }), (0, _jsx3.default)('meta', {
                name: 'twitter:app:url:iphone',
                content: iOSAppUrl
            }), (0, _jsx3.default)('meta', {
                name: 'twitter:card',
                content: 'summary_large_image'
            }), (0, _jsx3.default)('meta', {
                name: 'twitter:description',
                content: description
            }), (0, _jsx3.default)('meta', {
                name: 'twitter:domain',
                content: 'liveauctioneers.com'
            }), (0, _jsx3.default)('meta', {
                name: 'twitter:image',
                content: _urls.logoUrl
            }), (0, _jsx3.default)('meta', {
                name: 'twitter:site',
                content: '@liveauctioneers'
            }), (0, _jsx3.default)('meta', {
                name: 'twitter:title',
                content: title
            }), whiteLabel && (0, _jsx3.default)('meta', {
                name: 'robots',
                content: 'noindex,nofollow'
            }));
        }
    }]);
    return AppHeaderMeta;
}(_react.Component), _class.contextTypes = {
    intl: _propTypes2.default.object.isRequired
}, _temp);
exports.default = AppHeaderMeta;
module.exports = exports['default'];

/***/ }),

/***/ "HlCz":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = __webpack_require__("dcb+");

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propsComparer = __webpack_require__("wsGv");

var _propsComparer2 = _interopRequireDefault(_propsComparer);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _GoogleMapSmall = __webpack_require__("qyrl");

var _GoogleMapSmall2 = _interopRequireDefault(_GoogleMapSmall);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var googleBaseUrl = 'https://maps.googleapis.com/maps/api/staticmap';

var GoogleMapSmall = function (_Component) {
    (0, _inherits3.default)(GoogleMapSmall, _Component);

    function GoogleMapSmall() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, GoogleMapSmall);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = GoogleMapSmall.__proto__ || (0, _getPrototypeOf2.default)(GoogleMapSmall)).call.apply(_ref, [this].concat(args))), _this), _this.getEncodedLocation = function (seller) {
            var location = ['' + seller.address, '' + seller.city, '' + seller.stateCode, '' + seller.zip, '' + seller.country];
            return encodeURIComponent(location.join(' '));
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(GoogleMapSmall, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps) {
            return (0, _propsComparer2.default)(this.props, nextProps, ['googleApiKey']) || (0, _propsComparer2.default)(this.props.seller, nextProps.seller, ['address', 'city', 'stateCode', 'zip', 'country']);
        }
    }, {
        key: 'render',
        value: function render() {
            var encodedLocation = this.getEncodedLocation(this.props.seller);
            var mapParams = ['key=' + this.props.googleApiKey, 'size=238x170', 'center=' + encodedLocation, 'zoom=13', 'scale=2', 'maptype=roadmap', 'format=png', 'visual_refresh=true', 'markers=size:mid%7Ccolor:0xff0000%7Clabel:%7C' + encodedLocation, 'style=feature:poi%7Cvisibility:off'];

            var mapTileSrc = googleBaseUrl + '?' + mapParams.join('&');

            return (0, _jsx3.default)('a', {
                href: 'https://www.google.com/maps/place/' + encodedLocation,
                target: '_blank'
            }, void 0, (0, _jsx3.default)('img', {
                className: _GoogleMapSmall2.default.map,
                src: mapTileSrc,
                alt: 'map'
            }));
        }
    }]);
    return GoogleMapSmall;
}(_react.Component);

exports.default = GoogleMapSmall;
module.exports = exports['default'];

/***/ }),

/***/ "Hwmz":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _bidder = __webpack_require__("bSWU");

var Bidder = {
    fetchBidderData: _bidder.BidderRemote.fetchBidderData,
    postCompleteAccount: _bidder.BidderRemote.postCompleteAccount,
    postCreateAccount: _bidder.BidderRemote.postCreateAccount,
    postLogin: _bidder.BidderRemote.postLogin,
    postSetPassword: _bidder.BidderRemote.postSetPassword,
    postSetSearchFacetOptionExclusion: _bidder.BidderRemote.postSetSearchFacetOptionExclusion
};

exports.default = Bidder;
module.exports = exports['default'];

/***/ }),

/***/ "HxLY":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.setHeaderDropdownVisible = exports.isHeaderDropdownVisible = exports.SET_HEADER_DROPDOWN_VISIBLE = undefined;

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;

var _reselect = __webpack_require__("bndy");

var _constants = __webpack_require__("5fUn");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Action Types */
var SET_HEADER_DROPDOWN_VISIBLE = exports.SET_HEADER_DROPDOWN_VISIBLE = 'SET_HEADER_DROPDOWN_VISIBLE';

/* reducer */
var DEFAULT_STATE = {
    headerDropdownVisible: false
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        case _constants.REHYDRATE:
            if (Object.prototype.hasOwnProperty.call(action.payload, 'persist') && Object.prototype.hasOwnProperty.call(action.payload.persist, 'headerSearchDropdown')) {
                var incoming = action.payload.persist.headerSearchDropdown;
                return (0, _extends3.default)({}, state, incoming);
            }
            return state;
        case SET_HEADER_DROPDOWN_VISIBLE:
            return (0, _extends3.default)({}, state, {
                headerDropdownVisible: action.payload
            });
        default:
            return state;
    }
}

/* SELECTORS */
var stateSelector = function stateSelector(state) {
    return state.persist.headerSearchDropdown;
};

var isHeaderDropdownVisible = exports.isHeaderDropdownVisible = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.headerDropdownVisible;
});

/* ACTION CREATORS */
var setHeaderDropdownVisible = exports.setHeaderDropdownVisible = function setHeaderDropdownVisible() {
    var show = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    return {
        payload: show,
        type: SET_HEADER_DROPDOWN_VISIBLE
    };
};

/***/ }),

/***/ "I0kU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"auction-title":"auction-title___21VXL","calendar":"calendar___87MiO","aDropDown":"aDropDown___1KbY1"};

/***/ }),

/***/ "I7EN":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fetchSearchSuggestions = exports.getSearchSuggestions = exports.SEARCH_SUGGESTIONS_SUCCESS = exports.SEARCH_SUGGESTIONS_REQUEST = exports.SEARCH_SUGGESTIONS_FAIL = undefined;

var _toConsumableArray2 = __webpack_require__("Gu7T");

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;

var _api = __webpack_require__("zFQO");

var _cloneDeep = __webpack_require__("kvU2");

var _cloneDeep2 = _interopRequireDefault(_cloneDeep);

var _reselect = __webpack_require__("bndy");

var _config = __webpack_require__("iS9E");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Action Types */
var SEARCH_SUGGESTIONS_FAIL = exports.SEARCH_SUGGESTIONS_FAIL = 'la/ui/searchSuggestions/FAIL';
var SEARCH_SUGGESTIONS_REQUEST = exports.SEARCH_SUGGESTIONS_REQUEST = 'la/ui/searchSuggestions/REQUEST';
var SEARCH_SUGGESTIONS_SUCCESS = exports.SEARCH_SUGGESTIONS_SUCCESS = 'la/ui/searchSuggestions/SUCCESS';

// reducer
var DEFAULT_STATE = {
    error: false,
    submitted: false,
    success: false,
    suggestions: []
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        case SEARCH_SUGGESTIONS_REQUEST:
            return (0, _extends3.default)({}, state, {
                submitted: true,
                success: false
            });
        case SEARCH_SUGGESTIONS_SUCCESS:
            return (0, _extends3.default)({}, state, {
                submitted: false,
                success: true,
                suggestions: (0, _cloneDeep2.default)(action.payload)
            });
        case SEARCH_SUGGESTIONS_FAIL:
            return (0, _extends3.default)({}, state, {
                error: true,
                submitted: false,
                success: false
            });
        default:
            return state;
    }
}

/* SELECTORS */
var stateSelector = function stateSelector(state) {
    return state.ui.searchSuggestions;
};

var getUiSearchSuggestions = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state;
});

var getSearchSuggestions = exports.getSearchSuggestions = (0, _reselect.createSelector)(getUiSearchSuggestions, function (uiSearchSuggestions) {
    return [].concat((0, _toConsumableArray3.default)(uiSearchSuggestions.suggestions));
});

/* ACTION CREATORS */
var searchSuggestionsFail = function searchSuggestionsFail(term, error) {
    return {
        error: true,
        meta: { term: term },
        payload: error,
        type: SEARCH_SUGGESTIONS_FAIL
    };
};

var searchSuggestionsRequest = function searchSuggestionsRequest(term) {
    return {
        payload: term,
        type: SEARCH_SUGGESTIONS_REQUEST
    };
};

var searchSuggestionsSuccess = function searchSuggestionsSuccess(suggestions) {
    return {
        payload: suggestions,
        type: SEARCH_SUGGESTIONS_SUCCESS
    };
};

var fetchSearchSuggestions = exports.fetchSearchSuggestions = function fetchSearchSuggestions(term) {
    return function (dispatch, getState) {
        var state = getState();
        var deployment = (0, _config.getDeployment)(state);
        dispatch(searchSuggestionsRequest(term));
        return _api.SearchSuggestions.fetchSuggestions({ deployment: deployment, term: term }).then(function (response) {
            dispatch(searchSuggestionsSuccess(response.suggestions));
        }).catch(function (error) {
            dispatch(searchSuggestionsFail(term, error));
        });
    };
};

/***/ }),

/***/ "I7qg":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SellerRecordResultsRemote = undefined;

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _helpers = __webpack_require__("SY39");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SellerRecordResultsRemote = exports.SellerRecordResultsRemote = {
    fetchSellerRecordResultsById: function fetchSellerRecordResultsById(_ref) {
        var authToken = _ref.authToken,
            deployment = _ref.deployment,
            sellerId = _ref.sellerId;
        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makeGet)('<ITEM-API>spa/small/seller/' + sellerId + '/recordResults', deployment);
            (0, _helpers.addAuthToken)(request, authToken);
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response });
            });
        });
    }
};

/***/ }),

/***/ "IE5j":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = __webpack_require__("dcb+");

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _components = __webpack_require__("bGai");

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propsComparer = __webpack_require__("wsGv");

var _propsComparer2 = _interopRequireDefault(_propsComparer);

var _Crown = __webpack_require__("8tqB");

var _Crown2 = _interopRequireDefault(_Crown);

var _reactFontawesome = __webpack_require__("f7W8");

var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);

var _Login = __webpack_require__("vC/J");

var _Login2 = _interopRequireDefault(_Login);

var _Navigation = __webpack_require__("M7t3");

var _Navigation2 = _interopRequireDefault(_Navigation);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Header = __webpack_require__("ykdQ");

var _Header2 = _interopRequireDefault(_Header);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Header = function (_Component) {
    (0, _inherits3.default)(Header, _Component);

    function Header(props, context) {
        (0, _classCallCheck3.default)(this, Header);

        var _this = (0, _possibleConstructorReturn3.default)(this, (Header.__proto__ || (0, _getPrototypeOf2.default)(Header)).call(this, props, context));

        _this.toggleShowSearch = function () {
            _this.setState({ showSearch: !_this.state.showSearch });
        };

        _this.state = {
            showSearch: false
        };
        return _this;
    }

    (0, _createClass3.default)(Header, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps, nextState) {
            return (0, _propsComparer2.default)(this.props, nextProps, ['location', 'logo', 'mobile', 'userLoggedIn', 'whiteLabel', 'windowWidth']) || (0, _propsComparer2.default)(this.state, nextState, ['showSearch']);
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                baseUrl = _props.baseUrl,
                location = _props.location,
                logo = _props.logo,
                logOutBidder = _props.logOutBidder,
                mobile = _props.mobile,
                openCreateAccountModal = _props.openCreateAccountModal,
                openLoginModal = _props.openLoginModal,
                userLoggedIn = _props.userLoggedIn,
                whiteLabel = _props.whiteLabel,
                windowWidth = _props.windowWidth;
            var showSearch = this.state.showSearch;


            var headerLogo = logo;

            var searchBarDesktop = 'search-bar-desktop';
            var searchBarMobile = 'search-bar-mobile';

            return (0, _jsx3.default)('div', {
                className: _Header2.default.header
            }, void 0, (0, _jsx3.default)(_Crown2.default, {
                location: location,
                whiteLabel: whiteLabel
            }), (0, _jsx3.default)('div', {
                className: '' + _Header2.default.wrapper + (whiteLabel ? ' ' + _Header2.default['white-label'] : '')
            }, void 0, (0, _jsx3.default)('div', {
                className: _Header2.default['search-bar']
            }, void 0, (0, _jsx3.default)('div', {
                className: _Header2.default['image-container']
            }, void 0, (0, _jsx3.default)(_components.Link, {
                className: _Header2.default['header-logo-link'],
                route: true,
                to: '/'
            }, void 0, headerLogo && (0, _jsx3.default)('img', {
                className: _Header2.default['header-logo'],
                src: headerLogo
            }))), (0, _jsx3.default)('div', {
                className: _Header2.default['search-field-container']
            }, void 0, (0, _jsx3.default)(_components.SearchInput, {
                name: searchBarDesktop
            })), (0, _jsx3.default)('div', {
                className: _Header2.default['search-button-container']
            }, void 0, (0, _jsx3.default)(_reactFontawesome2.default, {
                className: _Header2.default['search-field-icon'],
                icon: ['fas', 'search'],
                onClick: this.toggleShowSearch
            })), (0, _jsx3.default)('div', {
                className: _Header2.default['controls-container']
            }, void 0, (0, _jsx3.default)(_Login2.default, {
                baseUrl: baseUrl,
                logOutBidder: logOutBidder,
                mobile: mobile,
                openCreateAccountModal: openCreateAccountModal,
                openLoginModal: openLoginModal,
                parent: this,
                userLoggedIn: userLoggedIn,
                whiteLabel: whiteLabel,
                windowWidth: windowWidth
            }))), (0, _jsx3.default)('div', {
                className: _Header2.default['mobile-search'] + ' ' + (showSearch ? _Header2.default.show : '')
            }, void 0, (0, _jsx3.default)(_components.SearchInput, {
                name: searchBarMobile
            }))), !whiteLabel && (0, _jsx3.default)(_Navigation2.default, {
                mobile: mobile,
                parent: this
            }));
        }
    }]);
    return Header;
}(_react.Component);

exports.default = Header;
module.exports = exports['default'];

/***/ }),

/***/ "IRS6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"footer":"footer___2sOKM"};

/***/ }),

/***/ "IVRy":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getItemDescriptionId = undefined;

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;

var _reselect = __webpack_require__("bndy");

var _modal = __webpack_require__("u90i");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* reducer */
var DEFAULT_STATE = {
    itemId: 0
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        case _modal.OPEN_ITEM_DESCRIPTION_MODAL:
            return (0, _extends3.default)({}, state, {
                itemId: action.payload
            });
        default:
            return state;
    }
}

/* SELECTORS */
var stateSelector = function stateSelector(state) {
    return state.ui.itemDescription;
};

var getItemDescriptionId = exports.getItemDescriptionId = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.itemId;
});

/***/ }),

/***/ "IWsF":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _home = __webpack_require__("IjDc");

exports.default = {
    fetchHomeData: _home.HomeRemote.fetchHomeData
};
module.exports = exports['default'];

/***/ }),

/***/ "IeGF":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getTrendingItemsByBids = exports.getMostPopularItemsByBids = exports.getMyAuctions = exports.getSellerCatalogs = exports.getMySavedSearchItems = exports.getMySavedItems = exports.getMyBids = exports.getFollowedSellers = exports.getLiveCatalogItems = exports.getCatalogItems = undefined;

var _sorting = __webpack_require__("8lrs");

var _cardData = __webpack_require__("6OFE");

var _item = __webpack_require__("Gk4U");

var _catalogRegistration = __webpack_require__("uhYE");

var _catalog = __webpack_require__("yv/Z");

var _followSeller = __webpack_require__("/9SA");

var _biddingInfo = __webpack_require__("m9FA");

var _savedSearchItem = __webpack_require__("c5lA");

var _saveItem = __webpack_require__("6oKK");

var getCatalogItems = exports.getCatalogItems = function getCatalogItems(state, catalogId) {
    var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
        count = _ref.count,
        page = _ref.page,
        sort = _ref.sort,
        terms = _ref.terms;

    var ids = (0, _item.getItemIdsForCatalog)(state, catalogId);
    var all = (0, _cardData.getItemCardDatas)(state, ids);
    return (0, _sorting.filterItems)(all, { count: count, page: page, sort: sort, terms: terms });
};

var getLiveCatalogItems = exports.getLiveCatalogItems = function getLiveCatalogItems(state, catalogId) {
    var _ref2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
        count = _ref2.count,
        page = _ref2.page,
        sort = _ref2.sort,
        terms = _ref2.terms;

    var ids = (0, _item.getItemIdsForCatalog)(state, catalogId);
    var all = (0, _cardData.getLiveItemCardDatas)(state, ids);
    return (0, _sorting.filterItems)(all, { count: count, page: page, sort: sort, terms: terms });
};

var getFollowedSellers = exports.getFollowedSellers = function getFollowedSellers(state) {
    var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        count = _ref3.count,
        page = _ref3.page,
        sort = _ref3.sort,
        terms = _ref3.terms;

    var ids = (0, _followSeller.getFollowedSellerIds)(state);
    var all = (0, _cardData.getSellerCardDatas)(state, ids);
    return (0, _sorting.filterSellers)(all, { count: count, page: page, sort: sort, terms: terms });
};

var getMyBids = exports.getMyBids = function getMyBids(state) {
    var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        count = _ref4.count,
        page = _ref4.page,
        sort = _ref4.sort,
        terms = _ref4.terms,
        tab = _ref4.tab;

    var ids = (0, _biddingInfo.getMyBidItemIds)(state);
    var all = (0, _cardData.getItemCardDatas)(state, ids);
    return (0, _sorting.filterItems)(all, { count: count, page: page, sort: sort, tab: tab, terms: terms });
};

var getMySavedItems = exports.getMySavedItems = function getMySavedItems(state) {
    var _ref5 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        count = _ref5.count,
        page = _ref5.page,
        sort = _ref5.sort,
        terms = _ref5.terms;

    var ids = (0, _saveItem.getSortedSavedItemIdsFromState)(state);
    var all = (0, _cardData.getItemCardDatas)(state, ids);
    return (0, _sorting.filterItems)(all, { count: count, page: page, sort: sort, terms: terms });
};

var getMySavedSearchItems = exports.getMySavedSearchItems = function getMySavedSearchItems(state) {
    var _ref6 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        count = _ref6.count,
        page = _ref6.page,
        sort = _ref6.sort,
        terms = _ref6.terms;

    var ids = (0, _savedSearchItem.getSavedSearchItemIds)(state);
    var all = (0, _cardData.getItemCardDatas)(state, ids);
    return (0, _sorting.filterItems)(all, { count: count, page: page, sort: sort, terms: terms });
};

var getSellerCatalogs = exports.getSellerCatalogs = function getSellerCatalogs(state, sellerId) {
    var _ref7 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
        count = _ref7.count,
        page = _ref7.page,
        sort = _ref7.sort,
        tab = _ref7.tab,
        terms = _ref7.terms;

    var ids = (0, _catalog.getCatalogIdsForSeller)(state, sellerId);
    var all = (0, _cardData.getCatalogCardDatas)(state, ids);
    return (0, _sorting.filterCatalogs)(all, { count: count, page: page, sort: sort, tab: tab, terms: terms });
};

var getMyAuctions = exports.getMyAuctions = function getMyAuctions(state) {
    var _ref8 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        count = _ref8.count,
        page = _ref8.page,
        sort = _ref8.sort,
        terms = _ref8.terms,
        tab = _ref8.tab;

    var catalogIds = (0, _catalogRegistration.getAllUserCatalogRegistrationIds)(state);
    var all = (0, _cardData.getCatalogCardDatas)(state, catalogIds);
    return (0, _sorting.filterCatalogsByReg)(state, all, { count: count, page: page, sort: sort, tab: tab, terms: terms });
};

var getMostPopularItemsByBids = exports.getMostPopularItemsByBids = function getMostPopularItemsByBids(state, sellerId) {
    var ids = (0, _item.getItemIdsForSeller)(state, sellerId);
    var all = (0, _cardData.getItemCardDatas)(state, ids);

    var _filterItems = (0, _sorting.filterItems)(all, { count: 20, page: 1, sort: 'MOST_BIDS', tab: 'upcoming' }),
        items = _filterItems.items;

    return items || [];
};

var getTrendingItemsByBids = exports.getTrendingItemsByBids = function getTrendingItemsByBids(state, trendingItemIds, count) {
    var trendingItems = (0, _cardData.getItemCardDatas)(state, trendingItemIds);

    var _filterItems2 = (0, _sorting.filterItems)(trendingItems, {
        count: count,
        page: 1,
        sort: 'MOST_BIDS',
        tab: 'upcoming'
    }),
        items = _filterItems2.items;

    return items || [];
};

/***/ }),

/***/ "IjDc":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.HomeRemote = undefined;

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _helpers = __webpack_require__("SY39");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HomeRemote = exports.HomeRemote = {
    fetchHomeData: function fetchHomeData(_ref) {
        var deployment = _ref.deployment;
        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makeGet)('<ITEM-API>spapage/home', deployment);
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response });
            });
        });
    }
};

/***/ }),

/***/ "IkOe":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = __webpack_require__("dcb+");

var _jsx3 = _interopRequireDefault(_jsx2);

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Polyfill for webpack, just in case
if (false) require.ensure = function (d, c) {
    c(require);
};

var ConsignmentConfirmModalLoader = function (_Component) {
    (0, _inherits3.default)(ConsignmentConfirmModalLoader, _Component);

    function ConsignmentConfirmModalLoader(props, context) {
        (0, _classCallCheck3.default)(this, ConsignmentConfirmModalLoader);

        var _this = (0, _possibleConstructorReturn3.default)(this, (ConsignmentConfirmModalLoader.__proto__ || (0, _getPrototypeOf2.default)(ConsignmentConfirmModalLoader)).call(this, props, context));

        _this.state = {
            Component: null,
            mounted: false
        };
        return _this;
    }

    (0, _createClass3.default)(ConsignmentConfirmModalLoader, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            var _this2 = this;

            return new _promise2.default(function (resolve) {
                __webpack_require__.e/* require.ensure */(53).then((function () {
                    resolve(__webpack_require__("eAbe"));
                }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            }).then(function (container) {
                _this2.setState({ Component: container });
            });
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.setState({ mounted: true });
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.setState({ mounted: false });
        }
    }, {
        key: 'render',
        value: function render() {
            var _state = this.state,
                Component = _state.Component,
                mounted = _state.mounted;

            return mounted && Component !== null ? (0, _jsx3.default)(Component, {}) : null;
        }
    }]);
    return ConsignmentConfirmModalLoader;
}(_react.Component);

exports.default = ConsignmentConfirmModalLoader;
module.exports = exports['default'];

/***/ }),

/***/ "JcK0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _clientLogger = __webpack_require__("Sr01");

var _clientLogger2 = _interopRequireDefault(_clientLogger);

var _serverLogger = __webpack_require__("G3Tb");

var _serverLogger2 = _interopRequireDefault(_serverLogger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createLogger = function createLogger(_ref) {
    var server = _ref.server,
        client = _ref.client;

    return global.__SERVER__ ? (0, _serverLogger2.default)(server) : (0, _clientLogger2.default)(client);
};

exports.default = createLogger;
module.exports = exports['default'];
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("DuR2")))

/***/ }),

/***/ "JhzB":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fetchHealthCheckData = exports.getHealthCheckData = exports.dataSelector = exports.LOAD_HEALTH_CHECK_DATA_SUCCESS = exports.LOAD_HEALTH_CHECK_DATA_REQUEST = exports.LOAD_HEALTH_CHECK_DATA_FAIL = undefined;

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;

var _api = __webpack_require__("zFQO");

var _reselect = __webpack_require__("bndy");

var _isEmpty = __webpack_require__("lHK6");

var _isEmpty2 = _interopRequireDefault(_isEmpty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Action Types */
var LOAD_HEALTH_CHECK_DATA_FAIL = exports.LOAD_HEALTH_CHECK_DATA_FAIL = 'la/domain/healthcheck/LOAD_FAIL';
var LOAD_HEALTH_CHECK_DATA_REQUEST = exports.LOAD_HEALTH_CHECK_DATA_REQUEST = 'la/domain/healthcheck/LOAD_REQUEST';
var LOAD_HEALTH_CHECK_DATA_SUCCESS = exports.LOAD_HEALTH_CHECK_DATA_SUCCESS = 'la/domain/healthcheck/LOAD_SUCCESS';

// reducer
var DEFAULT_STATE = {
    data: {},
    loading: false
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        case LOAD_HEALTH_CHECK_DATA_FAIL:
            return (0, _extends3.default)({}, state, {
                loading: false
            });
        case LOAD_HEALTH_CHECK_DATA_REQUEST:
            return (0, _extends3.default)({}, state, {
                loading: true
            });
        case LOAD_HEALTH_CHECK_DATA_SUCCESS:
            return (0, _extends3.default)({}, state, {
                data: action.payload,
                loading: false
            });
        default:
            return state;
    }
}

/* SELECTORS */
var stateSelector = function stateSelector(state) {
    return state.healthcheck;
};

var dataSelector = exports.dataSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.data;
});

var getHealthCheckData = exports.getHealthCheckData = (0, _reselect.createSelector)(dataSelector, function (data) {
    return !(0, _isEmpty2.default)(data) ? data : false;
});

/* ACTION CREATORS */
var loadHealthCheckDataFail = function loadHealthCheckDataFail(error) {
    return {
        error: true,
        payload: error,
        type: LOAD_HEALTH_CHECK_DATA_FAIL
    };
};

var loadHealthCheckDataRequest = function loadHealthCheckDataRequest() {
    return {
        type: LOAD_HEALTH_CHECK_DATA_REQUEST
    };
};

var loadHealthCheckDataSuccess = function loadHealthCheckDataSuccess(HealthCheckData) {
    return {
        payload: HealthCheckData,
        type: LOAD_HEALTH_CHECK_DATA_SUCCESS
    };
};

var fetchHealthCheckData = exports.fetchHealthCheckData = function fetchHealthCheckData() {
    return function (dispatch) {
        dispatch(loadHealthCheckDataRequest());
        return _api.HealthCheck.fetchHealthCheckData().then(function (response) {
            dispatch(loadHealthCheckDataSuccess(response));
        }).catch(function (error) {
            dispatch(loadHealthCheckDataFail(error));
        });
    };
};

/***/ }),

/***/ "JstK":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _toConsumableArray2 = __webpack_require__("Gu7T");

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _jsx2 = __webpack_require__("dcb+");

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propsComparer = __webpack_require__("wsGv");

var _propsComparer2 = _interopRequireDefault(_propsComparer);

var _classnames = __webpack_require__("HW6M");

var _classnames2 = _interopRequireDefault(_classnames);

var _discoverItems = __webpack_require__("nmQq");

var _categoryGrabber = __webpack_require__("Gd4V");

var _Link = __webpack_require__("rkxl");

var _Link2 = _interopRequireDefault(_Link);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _DiscoveryTags = __webpack_require__("RIJi");

var _DiscoveryTags2 = _interopRequireDefault(_DiscoveryTags);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DiscoverTags = (_temp2 = _class = function (_Component) {
    (0, _inherits3.default)(DiscoverTags, _Component);

    function DiscoverTags() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, DiscoverTags);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = DiscoverTags.__proto__ || (0, _getPrototypeOf2.default)(DiscoverTags)).call.apply(_ref, [this].concat(args))), _this), _this.createCategoryLandingLink = function (mainItem, secondItem) {
            mainItem = (0, _categoryGrabber.getCategoryLevel)(mainItem);
            secondItem = (0, _categoryGrabber.getCategoryLevel)(secondItem);
            var isTwoItems = secondItem.categoryUrl;

            var key = isTwoItems ? mainItem.categoryLabel + '-' + secondItem.categoryLabel : '' + mainItem.categoryLabel;

            var link = isTwoItems ? '/c/' + mainItem.categoryUrl + '/' + secondItem.categoryUrl + '/' + mainItem.categoryId + '/' + secondItem.categoryId + '/' : '/c/' + mainItem.categoryUrl + '/' + mainItem.categoryId + '/';

            var name = isTwoItems ? secondItem.categoryLabel + ' ' + mainItem.categoryLabel : '' + mainItem.categoryLabel;

            return (0, _jsx3.default)('div', {}, key, (0, _jsx3.default)(_Link2.default, {
                route: true,
                className: _DiscoveryTags2.default['tag-link'],
                to: link
            }, void 0, name));
        }, _this.getColorIndex = function (index) {
            return index % DiscoverTags.colorArr.length;
        }, _this.getColorClasses = function (index) {
            return (0, _classnames2.default)(_DiscoveryTags2.default.tag, _DiscoveryTags2.default[DiscoverTags.colorArr[_this.getColorIndex(index)] + '-tag']);
        }, _this.mapToTags = function (link, index) {
            return (0, _jsx3.default)('div', {
                className: _this.getColorClasses(index)
            }, index, link);
        }, _this.mapToDefaultTags = function (tag, index) {
            return (0, _jsx3.default)('div', {
                className: _this.getColorClasses(index)
            }, index + '-' + tag.name, (0, _jsx3.default)(_Link2.default, {
                route: true,
                className: _DiscoveryTags2.default['tag-link'],
                to: tag.link
            }, void 0, tag.name));
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(DiscoverTags, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps) {
            return (0, _propsComparer2.default)(this.props, nextProps, ['facets']);
        }

        // copied and refactored from DiscoverItems.js

    }, {
        key: 'render',
        value: function render() {
            var facets = this.props.facets;

            var links = (0, _discoverItems.generateDiscoverLinks)(facets, this.createCategoryLandingLink);
            var defaultTags = DiscoverTags.defaultTags.map(this.mapToDefaultTags); // radomize the default tags

            return (0, _jsx3.default)('div', {
                className: _DiscoveryTags2.default['tags']
            }, void 0, !links.length ? defaultTags : [].concat((0, _toConsumableArray3.default)(links.map(this.mapToTags)), (0, _toConsumableArray3.default)(defaultTags)));
        }
    }]);
    return DiscoverTags;
}(_react.Component), _class.colorArr = ['red', 'blue', 'orange', 'green', 'purple'], _class.defaultTags = [{ link: '/c/coins-currency-stamps/24/', name: 'Coins' }, { link: '/c/paintings/10/', name: 'Paintings' }, { link: '/c/toys-trains-games/46/', name: 'Toys, Dolls & Games' }, { link: '/c/fashion/3/', name: 'Vintage Fashion' }, { link: '/c/watches/97/ ', name: 'Watches' }, { link: '/c/rings/96/', name: 'Rings' }, { link: '/c/weapons-armor/35/', name: 'Weapons & Armor' }, { link: '/c/photography/11/', name: 'Photography' }, { link: '/c/sculptures/14/', name: 'Sculptures' }, { link: '/c/rugs-carpets/85/', name: 'Rugs & Carpets' }, { link: '/c/clocks/74/', name: 'Clocks' }, { link: '/c/books-folios-manuscripts/25910/', name: 'Books' }, { link: '/c/art-deco/253/', name: 'Art Deco' }], _temp2);
exports.default = DiscoverTags;
module.exports = exports['default'];

/***/ }),

/***/ "JuF/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SaveItemRemote = undefined;

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _helpers = __webpack_require__("SY39");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SaveItemRemote = exports.SaveItemRemote = {
    fetchSavedItemCounts: function fetchSavedItemCounts(_ref) {
        var deployment = _ref.deployment,
            itemIds = _ref.itemIds;
        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makePost)('<ITEM-API>saved-items/count', deployment);
            request.send({ ids: itemIds });
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response });
            });
        });
    },
    postSaveItem: function postSaveItem(_ref2) {
        var authToken = _ref2.authToken,
            deployment = _ref2.deployment,
            itemId = _ref2.itemId;
        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makePost)('<ITEM-API>saved-items/save/' + itemId, deployment);
            (0, _helpers.addAuthToken)(request, authToken);
            request.send({ itemId: itemId });
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response });
            });
        });
    },
    postUnsaveItem: function postUnsaveItem(_ref3) {
        var authToken = _ref3.authToken,
            deployment = _ref3.deployment,
            itemId = _ref3.itemId;
        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makePost)('<ITEM-API>saved-items/unsave/' + itemId, deployment);
            (0, _helpers.addAuthToken)(request, authToken);
            request.send({ itemId: itemId });
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response });
            });
        });
    }
};

/***/ }),

/***/ "Jxk+":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray2 = __webpack_require__("d7EF");

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _urls = __webpack_require__("CakR");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (catalogId, coverLots, sellerId, featured, catalogUrl) {
    var _ref = coverLots || {},
        results = _ref.results;

    var _results = (0, _slicedToArray3.default)(results, 3),
        _results$ = _results[0],
        item1 = _results$ === undefined ? {} : _results$,
        _results$2 = _results[1],
        item2 = _results$2 === undefined ? {} : _results$2,
        _results$3 = _results[2],
        item3 = _results$3 === undefined ? {} : _results$3;

    var coverLotImgAlt1 = item1.title;
    var coverLotImgAlt2 = item2.title;
    var coverLotImgAlt3 = item3.title;

    var coverLotImgSrc1 = (0, _urls.getCoverLotPrimaryImageUrl)(sellerId, catalogId, item1.itemId, 1, item1.imageVersion, featured);
    var coverLotImgSrc2 = (0, _urls.getCoverLotSecondaryImageUrl)(sellerId, catalogId, item2.itemId, 1, item2.imageVersion, featured);
    var coverLotImgSrc3 = (0, _urls.getCoverLotSecondaryImageUrl)(sellerId, catalogId, item3.itemId, 1, item3.imageVersion, featured);

    var coverLotImgHref1 = void 0,
        coverLotImgHref2 = void 0,
        coverLotImgHref3 = void 0;
    if (catalogUrl) {
        coverLotImgHref1 = catalogUrl;
        coverLotImgHref2 = catalogUrl;
        coverLotImgHref3 = catalogUrl;
    } else {
        coverLotImgHref1 = (0, _urls.getItemUrl)(item1.itemId, item1.title);
        coverLotImgHref2 = (0, _urls.getItemUrl)(item2.itemId, item2.title);
        coverLotImgHref3 = (0, _urls.getItemUrl)(item3.itemId, item3.title);
    }

    return {
        primary: {
            imageAlt: coverLotImgAlt1,
            imageHref: coverLotImgHref1,
            imageSrc: coverLotImgSrc1
        },
        secondary1: {
            imageAlt: coverLotImgAlt2,
            imageHref: coverLotImgHref2,
            imageSrc: coverLotImgSrc2
        },
        secondary2: {
            imageAlt: coverLotImgAlt3,
            imageHref: coverLotImgHref3,
            imageSrc: coverLotImgSrc3
        }
    };
};

module.exports = exports['default'];

/***/ }),

/***/ "KCpM":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxOTkxLjI3IDE5MjEuMzMiPjxkZWZzPjxzdHlsZT4uY2xzLTF7ZmlsbDojZmZmfS5jbHMtMntmaWxsOnNpbHZlcn08L3N0eWxlPjwvZGVmcz48dGl0bGU+cGxhY2Vob2xkZXIgaWNvbjwvdGl0bGU+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNMCAwaDE5OTEuMjd2MTkyMS4zM0gweiIvPjxwYXRoIGNsYXNzPSJjbHMtMiIgZD0iTTEyODguNTIgNzg3LjUxbC0zNC4yLTE5OS45LTcwMC4xNSAxMjIuOTMgMTAyLjYxIDU4NC43MSA2OS40OS0xMS43NnY1MC4yNGg3MTAuODNWNzg3LjUxem0tNTYyLjI1IDQzNy4xOGwtMjIuNDUgNC4zMS04My4zOC00NzEuNCA1ODYuODQtMTAzLjY5IDIzLjUyIDEzMy42Mkg3MjYuMjd6bTY1My4xMSA1MS4zMUg3ODRWODQ1LjIyaDU5NS40eiIvPjxwYXRoIGNsYXNzPSJjbHMtMiIgZD0iTTgyMi40NiAxMjMwLjA4aDUxOC40NHYtMTcwLjIybC0xMDktMTIzLjZhMjggMjggMCAwIDAtNDQuNzQgMy41OGwtOTMuOSAxNDguODJhMTguMjcgMTguMjcgMCAwIDEtMjcuNzMgMy43OGwtNjEuMDItNTUuNDRhMjUuMjggMjUuMjggMCAwIDAtMzcuMDcgMy4zN3oiLz48Y2lyY2xlIGNsYXNzPSJjbHMtMiIgY3g9Ijg5Mi4xNiIgY3k9Ijk0OC4yIiByPSI0MC44MSIvPjwvc3ZnPg=="

/***/ }),

/***/ "KaKp":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = __webpack_require__("dcb+");

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _components = __webpack_require__("bGai");

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propsComparer = __webpack_require__("wsGv");

var _propsComparer2 = _interopRequireDefault(_propsComparer);

var _reactIntl = __webpack_require__("Pq8k");

var _isEmpty = __webpack_require__("lHK6");

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _RegisterLink = __webpack_require__("UUHK");

var _RegisterLink2 = _interopRequireDefault(_RegisterLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RegisterLink = (_temp = _class = function (_Component) {
    (0, _inherits3.default)(RegisterLink, _Component);

    function RegisterLink() {
        (0, _classCallCheck3.default)(this, RegisterLink);
        return (0, _possibleConstructorReturn3.default)(this, (RegisterLink.__proto__ || (0, _getPrototypeOf2.default)(RegisterLink)).apply(this, arguments));
    }

    (0, _createClass3.default)(RegisterLink, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps) {
            return (0, _propsComparer2.default)(this.props, nextProps, ['className', 'catalogId', 'isCatalogOnly', 'registrationStatus']);
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                catalogId = _props.catalogId,
                className = _props.className,
                isCatalogOnly = _props.isCatalogOnly,
                openRegisterForCatalogModal = _props.openRegisterForCatalogModal,
                registrationStatus = _props.registrationStatus,
                requestOnlineBidding = _props.requestOnlineBidding;
            var declined = registrationStatus.declined,
                pending = registrationStatus.pending;


            var registeredMessage = void 0;
            if (declined) {
                registeredMessage = 'registration_declined';
            } else if (isCatalogOnly) {
                registeredMessage = 'request_submitted';
            } else {
                registeredMessage = pending ? 'registration_pending' : 'registration_approved';
            }

            if (!(0, _isEmpty2.default)(registrationStatus)) {
                return (0, _jsx3.default)('span', {
                    className: _RegisterLink2.default.registered + ' ' + className
                }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                    id: registeredMessage
                }));
            }

            if (isCatalogOnly) {
                return (0, _jsx3.default)(_components.ShouldLogInContainer, {
                    requireLogin: true,
                    requireCompleteProfile: true,
                    runFunction: requestOnlineBidding,
                    runFunctionArgument: catalogId
                }, void 0, (0, _jsx3.default)(_components.Link, {
                    className: _RegisterLink2.default['register-for-auction'] + ' ' + className
                }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                    id: 'request_online_bidding'
                })));
            }

            return (0, _jsx3.default)(_components.ShouldLogInContainer, {
                requireLogin: true,
                requireCompleteProfile: true,
                runFunction: openRegisterForCatalogModal,
                runFunctionArgument: { catalogId: catalogId }
            }, void 0, (0, _jsx3.default)(_components.Link, {
                className: _RegisterLink2.default['register-for-auction'] + ' ' + className
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'register_to_bid'
            })));
        }
    }]);
    return RegisterLink;
}(_react.Component), _class.defaultProps = {
    className: ''
}, _temp);
exports.default = RegisterLink;
module.exports = exports['default'];

/***/ }),

/***/ "Kk/C":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = __webpack_require__("dcb+");

var _jsx3 = _interopRequireDefault(_jsx2);

var _toConsumableArray2 = __webpack_require__("Gu7T");

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _components = __webpack_require__("bGai");

var _urls = __webpack_require__("CakR");

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propsComparer = __webpack_require__("wsGv");

var _propsComparer2 = _interopRequireDefault(_propsComparer);

var _dates = __webpack_require__("TbAp");

var _caterwaulComponents = __webpack_require__("7T5E");

var _reactIntl = __webpack_require__("Pq8k");

var _noop = __webpack_require__("9vKl");

var _noop2 = _interopRequireDefault(_noop);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _live = __webpack_require__("o2ZH");

var _countDown = __webpack_require__("7bCi");

var _CatalogCard = __webpack_require__("OMSM");

var _CatalogCard2 = _interopRequireDefault(_CatalogCard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CatalogCard = (_temp = _class = function (_Component) {
    (0, _inherits3.default)(CatalogCard, _Component);

    function CatalogCard() {
        (0, _classCallCheck3.default)(this, CatalogCard);
        return (0, _possibleConstructorReturn3.default)(this, (CatalogCard.__proto__ || (0, _getPrototypeOf2.default)(CatalogCard)).apply(this, arguments));
    }

    (0, _createClass3.default)(CatalogCard, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps) {
            return (0, _propsComparer2.default)(this.props, nextProps, ['className', 'featured', 'cardViewModel']);
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                cardViewModel = _props.cardViewModel,
                className = _props.className,
                featured = _props.featured,
                trackClick = _props.trackClick;
            var catalog = cardViewModel.catalog,
                coverLots = cardViewModel.coverLots,
                seller = cardViewModel.seller;

            var _ref = catalog || {},
                catalogId = _ref.catalogId,
                catalogStatus = _ref.catalogStatus,
                isCatalogOnly = _ref.isCatalogOnly,
                saleStartTs = _ref.saleStartTs,
                sellerId = _ref.sellerId,
                title = _ref.title;

            var _ref2 = seller || {},
                _ref2$countryCode = _ref2.countryCode,
                countryCode = _ref2$countryCode === undefined ? 'us' : _ref2$countryCode,
                sellerName = _ref2.name;

            var classes = [].concat((0, _toConsumableArray3.default)(className.split(' ')), [_CatalogCard2.default['catalog-card']]).join(' ').trim();

            var coverLotsClasses = featured ? _CatalogCard2.default.featured + ' ' + _CatalogCard2.default['cover-lots'] : _CatalogCard2.default['cover-lots'];
            var startDate = (0, _dates.catalogCardDate)(saleStartTs);
            var catalogUrl = (0, _urls.getCatalogUrl)(catalogId, title);
            var showDate = !isCatalogOnly && (0, _countDown.showCountDownBasedOnMinimumDate)(saleStartTs);

            var leftStyles = featured ? _CatalogCard2.default.left + ' ' + _CatalogCard2.default['featured-left'] : _CatalogCard2.default.left;

            var showLiveButton = (0, _live.shouldShowLive)(catalogStatus, isCatalogOnly, saleStartTs);

            return (0, _jsx3.default)('div', {
                className: classes,
                onClick: trackClick
            }, void 0, (0, _jsx3.default)(_components.CoverLots, {
                catalogId: catalogId,
                catalogUrl: catalogUrl,
                className: coverLotsClasses,
                coverLots: coverLots,
                featured: featured,
                sellerId: sellerId
            }), (0, _jsx3.default)('div', {
                className: _CatalogCard2.default['card-body']
            }, void 0, (0, _jsx3.default)('div', {
                className: leftStyles
            }, void 0, (0, _jsx3.default)('div', {
                className: _CatalogCard2.default.title
            }, void 0, (0, _jsx3.default)(_components.Link, {
                route: true,
                to: catalogUrl,
                primary: true
            }, void 0, title)), (0, _jsx3.default)('div', {
                className: _CatalogCard2.default.seller
            }, void 0, (0, _jsx3.default)(_components.Link, {
                route: true,
                to: (0, _urls.getSellerUrl)(sellerId, sellerName),
                primary: true
            }, void 0, sellerName)), (0, _jsx3.default)('div', {
                className: _CatalogCard2.default.date
            }, void 0, startDate)), (0, _jsx3.default)('div', {
                className: _CatalogCard2.default.right
            }, void 0, featured ? (0, _jsx3.default)(_components.ButtonLink, {
                url: catalogUrl,
                className: _CatalogCard2.default.explore
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'explore'
            })) : (0, _jsx3.default)(_caterwaulComponents.Flag, {
                className: _CatalogCard2.default.flag,
                countryCode: countryCode
            }), showLiveButton ? (0, _jsx3.default)(_components.BidConsoleOpener, {
                catalogId: catalogId,
                sellerId: sellerId
            }, void 0, (0, _jsx3.default)('span', {
                className: _CatalogCard2.default.live
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'live_auction'
            }))) : (0, _jsx3.default)('span', {}, void 0, catalogStatus !== 'done' ? (0, _jsx3.default)(_components.CatalogDate, {
                className: _CatalogCard2.default.countdown,
                date: saleStartTs,
                showDate: showDate
            }) : (0, _jsx3.default)('span', {
                className: _CatalogCard2.default.ended
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'auction_ended'
            }))))));
        }
    }]);
    return CatalogCard;
}(_react.Component), _class.defaultProps = {
    cardViewModel: {},
    className: '',
    featured: false,
    trackClick: _noop2.default
}, _temp);
exports.default = CatalogCard;
module.exports = exports['default'];

/***/ }),

/***/ "KlEt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"login-to-see-price":"login-to-see-price___TWjeS","icon-link":"icon-link___3edRS","link":"link___osGH7","icon":"icon___9mquq"};

/***/ }),

/***/ "KluA":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _defineProperty2 = __webpack_require__("bOdI");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propsComparer = __webpack_require__("wsGv");

var _propsComparer2 = _interopRequireDefault(_propsComparer);

var _Button = __webpack_require__("DoE4");

var _Button2 = _interopRequireDefault(_Button);

var _classnames = __webpack_require__("HW6M");

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Button3 = __webpack_require__("wyFM");

var _Button4 = _interopRequireDefault(_Button3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Button = (_temp = _class = function (_Component) {
    (0, _inherits3.default)(Button, _Component);

    function Button() {
        (0, _classCallCheck3.default)(this, Button);
        return (0, _possibleConstructorReturn3.default)(this, (Button.__proto__ || (0, _getPrototypeOf2.default)(Button)).apply(this, arguments));
    }

    (0, _createClass3.default)(Button, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps) {
            return (0, _propsComparer2.default)(this.props, nextProps, ['children', 'className', 'disabled', 'primary', 'secondary', 'small', 'tertiary']);
        }
    }, {
        key: 'render',
        value: function render() {
            var _classNames;

            var _props = this.props,
                className = _props.className,
                disabled = _props.disabled,
                primary = _props.primary,
                onClick = _props.onClick,
                onMouseOut = _props.onMouseOut,
                onMouseOver = _props.onMouseOver,
                secondary = _props.secondary,
                tertiary = _props.tertiary,
                small = _props.small;


            var classes = (0, _classnames2.default)(_Button4.default.button, (_classNames = {}, (0, _defineProperty3.default)(_classNames, _Button4.default.secondary, secondary), (0, _defineProperty3.default)(_classNames, _Button4.default.primary, primary), (0, _defineProperty3.default)(_classNames, _Button4.default.small, small), (0, _defineProperty3.default)(_classNames, _Button4.default.tertiary, tertiary), _classNames), className);

            var buttonProps = {
                className: classes
            };
            if (disabled) {
                buttonProps.disabled = disabled;
            }
            if (onClick) {
                buttonProps.onClick = onClick;
            }
            if (onMouseOut) {
                buttonProps.onMouseOut = onMouseOut;
            }
            if (onMouseOver) {
                buttonProps.onMouseOver = onMouseOver;
            }

            return _react2.default.createElement(
                _Button2.default,
                buttonProps,
                this.props.children
            );
        }
    }]);
    return Button;
}(_react.Component), _class.defaultProps = {
    children: '',
    className: '',
    disabled: false,
    onClick: null,
    onMouseOut: null,
    onMouseOver: null,
    primary: false,
    secondary: false,
    small: false,
    tertiary: false
}, _temp);
exports.default = Button;
module.exports = exports['default'];

/***/ }),

/***/ "KmPa":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = __webpack_require__("dcb+");

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _modal = __webpack_require__("u90i");

var _createAccount = __webpack_require__("FneX");

var _browser = __webpack_require__("aN2S");

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propsComparer = __webpack_require__("wsGv");

var _propsComparer2 = _interopRequireDefault(_propsComparer);

var _redux = __webpack_require__("2KeS");

var _reactRedux = __webpack_require__("RH2O");

var _analytics = __webpack_require__("yxCd");

var _bidderExists = __webpack_require__("uien");

var _whiteLabel = __webpack_require__("cYj3");

var _enums = __webpack_require__("cjn6");

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _SignUpModal = __webpack_require__("GomR");

var _SignUpModal2 = _interopRequireDefault(_SignUpModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SignUpContainer = (_dec = (0, _reactRedux.connect)(function (state) {
    var attributionData = (0, _analytics.getAttributionData)(state);
    var bidderExists = (0, _bidderExists.getBidderExists)(state);

    var _getCreateAccountStat = (0, _createAccount.getCreateAccountState)(state),
        error = _getCreateAccountStat.error,
        submitted = _getCreateAccountStat.submitted,
        success = _getCreateAccountStat.success;

    var isMobile = !!(0, _browser.isUiMobile)(state);
    var isTablet = (0, _browser.isUiTablet)(state);
    var openModal = (0, _modal.getOpenModal)(state);
    var whiteLabel = (0, _whiteLabel.isWhiteLabel)(state);

    return {
        attributionData: attributionData,
        bidderExists: bidderExists,
        error: error,
        isMobile: isMobile,
        isTablet: isTablet,
        openModal: openModal,
        submitted: submitted,
        success: success,
        whiteLabel: whiteLabel
    };
}, function (dispatch) {
    return (0, _redux.bindActionCreators)({
        dismissModal: _modal.dismissModal,
        openLoginModal: _modal.openLoginModal,
        openSetPasswordModal: _modal.openSetPasswordModal,
        submitCreateAccount: _createAccount.submitCreateAccount
    }, dispatch);
}), _dec(_class = function (_Component) {
    (0, _inherits3.default)(SignUpContainer, _Component);

    function SignUpContainer(props, context) {
        (0, _classCallCheck3.default)(this, SignUpContainer);

        var _this = (0, _possibleConstructorReturn3.default)(this, (SignUpContainer.__proto__ || (0, _getPrototypeOf2.default)(SignUpContainer)).call(this, props, context));

        _this.setEmail = function (email) {
            _this.setState({ email: email });
        };

        _this.submitCreateAccount = function (email) {
            _this.props.submitCreateAccount(email, _this.props.attributionData);
        };

        _this.cancelSignUp = function () {
            _this.props.dismissModal();
        };

        _this.state = {
            email: ''
        };
        return _this;
    }

    (0, _createClass3.default)(SignUpContainer, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps, nextState) {
            return (0, _propsComparer2.default)(this.props, nextProps, ['attributionData', 'bidderExists', 'error', 'openModal', 'submitted', 'success', 'whiteLabel']) || (0, _propsComparer2.default)(this.state, nextState, ['email']);
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps) {
            var _props = this.props,
                bidderExists = _props.bidderExists,
                success = _props.success;


            if (success && !prevProps.success) {
                this.props.openSetPasswordModal();
            } else if (bidderExists && !prevProps.bidderExists) {
                this.props.openLoginModal();
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var show = this.props.openModal === _enums.modalTypes.SIGN_UP;
            var _props2 = this.props,
                bidderExists = _props2.bidderExists,
                error = _props2.error,
                isMobile = _props2.isMobile,
                isTablet = _props2.isTablet,
                submitted = _props2.submitted,
                whiteLabel = _props2.whiteLabel;


            return (0, _jsx3.default)(_SignUpModal2.default, {
                bidderExists: bidderExists,
                cancelSignUp: this.cancelSignUp,
                error: error,
                isMobile: isMobile,
                isTablet: isTablet,
                openLoginModal: this.props.openLoginModal,
                setEmail: this.setEmail,
                show: show,
                submitCreateAccount: this.submitCreateAccount,
                submitted: submitted,
                whiteLabel: whiteLabel
            });
        }
    }]);
    return SignUpContainer;
}(_react.Component)) || _class);
exports.default = SignUpContainer;
module.exports = exports['default'];

/***/ }),

/***/ "Kn4k":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

var _jsx2 = __webpack_require__("dcb+");

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _reactFontawesome = __webpack_require__("f7W8");

var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _SliderArrow = __webpack_require__("EDkj");

var _SliderArrow2 = _interopRequireDefault(_SliderArrow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SliderArrow = function (_PureComponent) {
    (0, _inherits3.default)(SliderArrow, _PureComponent);

    function SliderArrow() {
        (0, _classCallCheck3.default)(this, SliderArrow);
        return (0, _possibleConstructorReturn3.default)(this, (SliderArrow.__proto__ || (0, _getPrototypeOf2.default)(SliderArrow)).apply(this, arguments));
    }

    (0, _createClass3.default)(SliderArrow, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                className = _props.className,
                next = _props.next,
                onClick = _props.onClick,
                prev = _props.prev,
                style = _props.style;

            var icon = prev ? ['fas', 'caret-left'] : ['fas', 'caret-right'];
            var classes = '' + (next ? _SliderArrow2.default.next : _SliderArrow2.default.prev) + (className ? ' ' + className : '');
            return (0, _jsx3.default)('div', {
                className: classes,
                style: (0, _extends3.default)({}, style),
                onClick: onClick
            }, void 0, (0, _jsx3.default)(_reactFontawesome2.default, {
                icon: icon,
                className: _SliderArrow2.default.arrow
            }));
        }
    }]);
    return SliderArrow;
}(_react.PureComponent);

exports.default = SliderArrow;
module.exports = exports['default'];

/***/ }),

/***/ "Kt20":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _catalogDetail = __webpack_require__("hmCE");

var _catalogDetail2 = __webpack_require__("dJZv");

var CatalogDetail = {
    fetchCatalogDetailsByIds: function fetchCatalogDetailsByIds(params) {
        return  false ? _catalogDetail.CatalogDetailMock.fetchCatalogDetailsByIds(params) : _catalogDetail2.CatalogDetailRemote.fetchCatalogDetailsByIds(params);
    }
};

exports.default = CatalogDetail;
module.exports = exports['default'];

/***/ }),

/***/ "L9QP":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = __webpack_require__("dcb+");

var _jsx3 = _interopRequireDefault(_jsx2);

var _toConsumableArray2 = __webpack_require__("Gu7T");

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _components = __webpack_require__("bGai");

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _getCoverLotUrls2 = __webpack_require__("Jxk+");

var _getCoverLotUrls3 = _interopRequireDefault(_getCoverLotUrls2);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _CoverLots = __webpack_require__("i7yC");

var _CoverLots2 = _interopRequireDefault(_CoverLots);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CoverLots = (_temp = _class = function (_PureComponent) {
    (0, _inherits3.default)(CoverLots, _PureComponent);

    function CoverLots() {
        (0, _classCallCheck3.default)(this, CoverLots);
        return (0, _possibleConstructorReturn3.default)(this, (CoverLots.__proto__ || (0, _getPrototypeOf2.default)(CoverLots)).apply(this, arguments));
    }

    (0, _createClass3.default)(CoverLots, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                catalogId = _props.catalogId,
                catalogUrl = _props.catalogUrl,
                className = _props.className,
                coverLots = _props.coverLots,
                featured = _props.featured,
                sellerId = _props.sellerId;

            var _getCoverLotUrls = (0, _getCoverLotUrls3.default)(catalogId, coverLots, sellerId, featured, catalogUrl),
                primary = _getCoverLotUrls.primary,
                secondary1 = _getCoverLotUrls.secondary1,
                secondary2 = _getCoverLotUrls.secondary2;

            var classes = [].concat((0, _toConsumableArray3.default)(className.split(' ')), [_CoverLots2.default['cover-lots']]).join(' ').trim();

            return (0, _jsx3.default)('div', {
                className: classes
            }, void 0, (0, _jsx3.default)(_components.Link, {
                route: true,
                to: primary.imageHref,
                className: _CoverLots2.default['primary-img-container']
            }, void 0, (0, _jsx3.default)(_components.ImageWithFallback, {
                className: _CoverLots2.default.primary,
                src: primary.imageSrc,
                alt: primary.imageAlt
            })), (0, _jsx3.default)('div', {
                className: _CoverLots2.default['secondary-img-container']
            }, void 0, (0, _jsx3.default)(_components.Link, {
                route: true,
                to: secondary1.imageHref,
                className: _CoverLots2.default['img-container']
            }, void 0, (0, _jsx3.default)(_components.ImageWithFallback, {
                className: _CoverLots2.default.secondary,
                src: secondary1.imageSrc,
                alt: secondary1.imageAlt
            })), (0, _jsx3.default)(_components.Link, {
                route: true,
                to: secondary2.imageHref,
                className: _CoverLots2.default['img-container']
            }, void 0, (0, _jsx3.default)(_components.ImageWithFallback, {
                className: _CoverLots2.default.secondary,
                src: secondary2.imageSrc,
                alt: secondary2.imageAlt
            }))));
        }
    }]);
    return CoverLots;
}(_react.PureComponent), _class.defaultProps = {
    className: ''
}, _temp);
exports.default = CoverLots;
module.exports = exports['default'];

/***/ }),

/***/ "LHJ5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getUiTermsCatalogId = undefined;

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;

var _reselect = __webpack_require__("bndy");

var _modal = __webpack_require__("u90i");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// reducer
var DEFAULT_STATE = {
    catalogId: 0
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        case _modal.OPEN_TERMS_MODAL:
            return (0, _extends3.default)({}, state, {
                catalogId: action.payload.catalogId
            });
        default:
            return state;
    }
}

/* SELECTORS */
var stateSelector = function stateSelector(state) {
    return state.ui.terms;
};

var getUiTermsCatalogId = exports.getUiTermsCatalogId = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.catalogId;
});

/***/ }),

/***/ "LXPM":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _stringify = __webpack_require__("mvHQ");

var _stringify2 = _interopRequireDefault(_stringify);

var _jsx2 = __webpack_require__("dcb+");

var _jsx3 = _interopRequireDefault(_jsx2);

var _toConsumableArray2 = __webpack_require__("Gu7T");

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _class, _class2, _temp, _initialiseProps;

var _AsyncTypeahead = __webpack_require__("X0TU");

var _AsyncTypeahead2 = _interopRequireDefault(_AsyncTypeahead);

var _Menu = __webpack_require__("1rZl");

var _Menu2 = _interopRequireDefault(_Menu);

var _MenuItem = __webpack_require__("tDLE");

var _MenuItem2 = _interopRequireDefault(_MenuItem);

var _search = __webpack_require__("9ad9");

var _searchParams = __webpack_require__("MJ4I");

var _DropdownButton = __webpack_require__("m4Ll");

var _DropdownButton2 = _interopRequireDefault(_DropdownButton);

var _MenuItem3 = __webpack_require__("nVt1");

var _MenuItem4 = _interopRequireDefault(_MenuItem3);

var _searchSuggestions = __webpack_require__("I7EN");

var _whiteLabel = __webpack_require__("cYj3");

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propsComparer = __webpack_require__("wsGv");

var _propsComparer2 = _interopRequireDefault(_propsComparer);

var _redux = __webpack_require__("2KeS");

var _reactRedux = __webpack_require__("RH2O");

var _reactFontawesome = __webpack_require__("f7W8");

var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);

var _config = __webpack_require__("iS9E");

var _route = __webpack_require__("9NGF");

var _urls = __webpack_require__("CakR");

var _headerSearchDropdown = __webpack_require__("HxLY");

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouterRedux = __webpack_require__("jZgO");

var _SearchInput = __webpack_require__("8ugv");

var _SearchInput2 = _interopRequireDefault(_SearchInput);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MenuHeader = function MenuHeader(props) {
    return _react2.default.createElement('span', (0, _extends3.default)({}, props, { className: _SearchInput2.default['auction-house-divider'] }));
};

var SearchInput = (_dec = (0, _reactRedux.connect)(function (state) {
    var pageSize = (0, _search.getSearchPageSize)(state);
    var archivedSearchGlobalState = (0, _search.isArchivedSearch)(state);
    var baseUrl = (0, _config.getBaseUrl)(state);
    var currentUrl = (0, _route.getCurrentUrlFromState)(state, baseUrl);
    var isOnSearchPage = currentUrl.includes('/search');
    var dropdownVisible = isOnSearchPage && archivedSearchGlobalState && (0, _headerSearchDropdown.isHeaderDropdownVisible)(state);
    var suggestions = (0, _searchSuggestions.getSearchSuggestions)(state);
    var whiteLabel = (0, _whiteLabel.isWhiteLabel)(state);
    var sellerId = (0, _whiteLabel.getWhiteLabelSellerId)(state);

    return {
        archivedSearchGlobalState: archivedSearchGlobalState,
        dropdownVisible: dropdownVisible,
        pageSize: pageSize,
        sellerId: sellerId,
        suggestions: suggestions,
        whiteLabel: whiteLabel
    };
}, function (dispatch) {
    return (0, _redux.bindActionCreators)({
        fetchSearchSuggestions: _searchSuggestions.fetchSearchSuggestions,
        push: _reactRouterRedux.push
    }, dispatch);
}), _dec(_class = (_temp = _class2 = function (_Component) {
    (0, _inherits3.default)(SearchInput, _Component);

    function SearchInput(props, context) {
        (0, _classCallCheck3.default)(this, SearchInput);

        var _this = (0, _possibleConstructorReturn3.default)(this, (SearchInput.__proto__ || (0, _getPrototypeOf2.default)(SearchInput)).call(this, props, context));

        _initialiseProps.call(_this);

        _this.state = {
            archiveSearchStatus: props.archivedSearchGlobalState,
            dropdownVisible: props.dropdownVisible,
            isMenuOpen: false,
            selected: [],
            text: ''
        };
        return _this;
    }

    (0, _createClass3.default)(SearchInput, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            // hack to add enterkey listening to the typeahead
            var mainInput = document.querySelector('input[name="' + this.props.name + '"]');
            mainInput.addEventListener('keyup', this.onKeyUp);
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            // checking prop changes to ensure the right option on the dropdown is shown
            if (nextProps.dropdownVisible && !this.props.archivedSearchGlobalState || !nextProps.dropdownVisible && this.props.archivedSearchGlobalState) {
                this.setState({ archiveSearchStatus: nextProps.archivedSearchGlobalState });
            }

            // checking prop changes to ensure that the dropdown is still visible when you select upcoming
            if (this.state.archiveSearchStatus && !nextProps.dropdownVisible || nextProps.dropdownVisible) {
                this.setState({ dropdownVisible: true });
            }
        }
    }, {
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps, nextState) {
            return (0, _propsComparer2.default)(this.props, nextProps, ['archivedSearchGlobalState', 'dropdownVisible', 'className', 'forceArchiveOnly', 'name', 'pageSize', 'sellerId', 'suggestions', 'whiteLabel']) || (0, _propsComparer2.default)(this.state, nextState, ['archiveSearchStatus', 'dropdownVisible', 'isMenuOpen', 'text', 'selected']);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                _props$className = _props.className,
                className = _props$className === undefined ? '' : _props$className,
                _props$suggestions = _props.suggestions,
                suggestions = _props$suggestions === undefined ? [] : _props$suggestions,
                whiteLabel = _props.whiteLabel;
            var _state = this.state,
                archiveSearchStatus = _state.archiveSearchStatus,
                dropdownVisible = _state.dropdownVisible;
            var formatMessage = this.context.intl.formatMessage;


            var title = formatMessage({
                id: archiveSearchStatus ? 'search_input_sold' : 'search_input_upcoming'
            });
            var item = formatMessage({
                id: archiveSearchStatus ? 'search_input_upcoming' : 'search_input_sold'
            });

            var classes = [].concat((0, _toConsumableArray3.default)(className.split(' ')), [_SearchInput2.default['search-input']]).join(' ').trim();
            var searchBarClass = dropdownVisible ? _SearchInput2.default['search-bar-input'] : _SearchInput2.default['search-bar-input-with-dropdown'];
            var extraClass = this.state.isMenuOpen ? _SearchInput2.default['remove-bottom-border'] : '';

            return (0, _jsx3.default)('div', {
                className: classes
            }, void 0, dropdownVisible && (0, _jsx3.default)('div', {
                className: _SearchInput2.default['search-dropdown'] + ' ' + extraClass
            }, void 0, (0, _jsx3.default)(_DropdownButton2.default, {
                className: _SearchInput2.default['search-field-dropdown'],
                title: title,
                onSelect: this.changeSearchStatus,
                onToggle: this.onToggle,
                id: 'search-input-dropdown'
            }, '1', (0, _jsx3.default)(_MenuItem4.default, {
                eventKey: '1'
            }, void 0, item))), _react2.default.createElement(_AsyncTypeahead2.default, {
                className: searchBarClass,
                delay: 300,
                emptyLabel: '',
                filterBy: function filterBy() {
                    return true;
                },
                labelKey: 'value',
                minLength: 1,
                name: this.props.name,
                onChange: this.handleChange,
                onInputChange: this.handleInputChange,
                onSearch: this.handleSearch,
                options: whiteLabel ? [] : this.addHousesHeader(suggestions),
                placeholder: formatMessage({
                    id: archiveSearchStatus ? 'search_input_search_past_auction_price_results' : 'search_input_search_for_items_and_auction_houses'
                }),
                promptText: '',
                ref: function ref(_ref) {
                    _this2._typeahead = _ref;
                },
                renderMenu: this.renderSuggestions,
                selected: this.state.selected,
                useCache: false
            }), (0, _jsx3.default)(_reactFontawesome2.default, {
                className: _SearchInput2.default['search-field-icon'],
                icon: ['fas', 'search'],
                onClick: this.search
            }));
        }
    }]);
    return SearchInput;
}(_react.Component), _class2.contextTypes = {
    intl: _propTypes2.default.object.isRequired
}, _class2.defaultProps = {
    className: '',
    suggestions: []
}, _initialiseProps = function _initialiseProps() {
    var _this3 = this;

    this.onKeyUp = function (event) {
        if (event.keyCode === 13) {
            _this3.search();
        }
    };

    this.onToggle = function () {
        _this3.setState({
            isMenuOpen: !_this3.state.isMenuOpen
        });
    };

    this.searchPhrase = function (keyword) {
        keyword = keyword.replace(/"/g, '\\"');
        var searchStatus = _this3.state.archiveSearchStatus || _this3.props.forceArchiveOnly ? _searchParams.DEFAULT_STATUS_FOR_ARCHIVED_SEARCH : _searchParams.DEFAULT_STATUS_FOR_ONLINE_SEARCH;

        var params = {
            keyword: keyword,
            page: 1,
            sort: _search.DEFAULT_SORT_ORDER,
            status: searchStatus
        };

        if (_this3.props.whiteLabel) {
            params.house_id = '' + _this3.props.sellerId;
        }

        var search = '?parameters=' + encodeURIComponent((0, _stringify2.default)(params));

        _this3.props.push({
            pathname: '/search',
            search: search
        });
        var instance = _this3._typeahead.getInstance();
        instance.blur();
    };

    this.searchHouse = function (houseId, houseName) {
        _this3.props.push({
            pathname: (0, _urls.getSellerUrl)(houseId, houseName)
        });
    };

    this.search = function () {
        var selected = _this3.state.selected.length > 0 ? _this3.state.selected[0] : null;
        if (selected) {
            if (selected.houseId) {
                _this3.searchHouse(selected.houseId, selected.value);
            } else {
                _this3.searchPhrase(selected.value);
            }
        } else {
            if (_this3.state.text.trim().length === 0) {
                return;
            }
            _this3.searchPhrase(_this3.state.text.trim());
        }
    };

    this.addHousesHeader = function (suggestions) {
        if (!suggestions || !suggestions.length) return undefined;
        if (suggestions.some(function (suggestion) {
            return suggestion.label === 'Auction Houses';
        })) return suggestions;
        var catalogIndex = suggestions.findIndex(function (result) {
            return result.houseId;
        });
        if (catalogIndex > -1) {
            suggestions.splice(catalogIndex, 0, {
                label: 'Auction Houses',
                value: 'Auction Houses'
            });
        }
        return suggestions;
    };

    this.handleChange = function (selected) {
        var selectedItem = selected && selected.length && selected[0].value ? selected[0] : null;

        if (selectedItem) {
            if (selectedItem.label === 'Auction Houses') return;
            if (selectedItem.houseId) {
                _this3.searchHouse(selectedItem.houseId, selectedItem.value);
            } else {
                _this3.searchPhrase(selectedItem.value);
            }
        }
    };

    this.handleInputChange = function (newValue) {
        _this3.setState({
            text: newValue
        });
    };

    this.handleSearch = function (query) {
        _this3.props.fetchSearchSuggestions(query);
    };

    this.buildMenuItems = function (items, term, index) {
        var menuItems = [];
        items.forEach(function (item) {
            var menuItem = (0, _jsx3.default)(_MenuItem2.default, {
                option: item,
                position: index
            }, index, (0, _jsx3.default)('span', {
                className: _SearchInput2.default['suggestions-result'],
                dangerouslySetInnerHTML: {
                    __html: item.label.replace(new RegExp('(' + term + ')', 'gi'), '<span class="' + _SearchInput2.default['query-match'] + '">$1</span>')
                }
            }));
            index += 1;
            menuItems.push(menuItem);
        });
        return menuItems;
    };

    this.changeSearchStatus = function () {
        _this3.setState({ archiveSearchStatus: !_this3.state.archiveSearchStatus });
    };

    this.renderSuggestions = function (results, props) {
        var term = _this3.state.text;
        var items = [];
        var auctionHouses = [];
        var grouped = results.reduce(function (refinedResult, result) {
            if (result.label === 'Auction Houses') return refinedResult;
            if (result.houseId) {
                refinedResult.auctionHouses.push(result);
            } else {
                refinedResult.auctionItems.push(result);
            }
            return refinedResult;
        }, { auctionHouses: [], auctionItems: [] });

        // reduce popular search suggestions for items to 5
        if (grouped.auctionItems.length > 5) {
            grouped.auctionItems = grouped.auctionItems.slice(0, 5);
        }

        items = _this3.buildMenuItems(grouped.auctionItems, term, 0);
        if (grouped.auctionHouses.length > 0) {
            var auctionHouseHeader = (0, _jsx3.default)('div', {
                className: _SearchInput2.default['auction-house-wrapper']
            }, 'auction-house-wrapper', (0, _jsx3.default)(MenuHeader, {}, 'auctionHouse' + '-header', 'Auction Houses'), (0, _jsx3.default)('span', {
                className: _SearchInput2.default['auction-house-line']
            }));

            if (!_this3.state.archiveSearchStatus) {
                var auctionHouse = _this3.buildMenuItems(grouped.auctionHouses, term, 5);
                auctionHouses = [auctionHouseHeader].concat((0, _toConsumableArray3.default)(auctionHouse));
            } else {
                auctionHouses = [];
            }
        }
        return _react2.default.createElement(
            _Menu2.default,
            props,
            [].concat((0, _toConsumableArray3.default)(items), (0, _toConsumableArray3.default)(auctionHouses))
        );
    };
}, _temp)) || _class);
exports.default = SearchInput;
module.exports = exports['default'];

/***/ }),

/***/ "Lsne":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LtPH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"status-banner":"status-banner___1vZz3","reserve":"reserve___Dle05","reserve-dispute-text":"reserve-dispute-text___3vPAq","cta":"cta___2GAr9","container":"container___3OX-l","link":"link___1S1kJ","cta-text":"cta-text___15npL","leading-bidder-bar":"leading-bidder-bar___1PEQo","button-container":"button-container___1eh-m","button":"button___3T6pr","bid-live-message":"bid-live-message___1_TwZ","light":"light___voswB","message":"message___2s-6F"};

/***/ }),

/***/ "Lvxz":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _jsx2 = __webpack_require__("dcb+");

var _jsx3 = _interopRequireDefault(_jsx2);

var _class, _temp;

var _components = __webpack_require__("bGai");

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propsComparer = __webpack_require__("wsGv");

var _propsComparer2 = _interopRequireDefault(_propsComparer);

var _reactFontawesome = __webpack_require__("f7W8");

var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);

var _reactIntl = __webpack_require__("Pq8k");

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ReservePopover = __webpack_require__("YaZr");

var _ReservePopover2 = _interopRequireDefault(_ReservePopover);

var _live = __webpack_require__("o2ZH");

var _StatusBannerMessage = __webpack_require__("m1mj");

var _StatusBannerMessage2 = _interopRequireDefault(_StatusBannerMessage);

var _StatusBanner = __webpack_require__("LtPH");

var _StatusBanner2 = _interopRequireDefault(_StatusBanner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RibbonPopover = (0, _jsx3.default)(_ReservePopover2.default, {
    id: 'ribbonReservePopover',
    styles: _StatusBanner2.default
});

var leadingMessage = (0, _jsx3.default)(_StatusBannerMessage2.default, {
    header: (0, _jsx3.default)(_reactIntl.FormattedMessage, {
        id: 'you_are_the_leading_bidder'
    }),
    message: (0, _jsx3.default)(_reactIntl.FormattedMessage, {
        id: 'increase_your_chances'
    }),
    iconName: ['fas', 'check-circle']
});
var outBidMessage = (0, _jsx3.default)(_StatusBannerMessage2.default, {
    alert: true,
    header: (0, _jsx3.default)(_reactIntl.FormattedMessage, {
        id: 'you_have_been_outbid'
    }),
    iconName: ['fas', 'exclamation-circle']
});
var registeredMessage = (0, _jsx3.default)(_StatusBannerMessage2.default, {
    alert: true,
    header: (0, _jsx3.default)(_reactIntl.FormattedMessage, {
        id: 'registration_pending'
    }),
    message: (0, _jsx3.default)(_reactIntl.FormattedMessage, {
        id: 'well_send_you_an_email'
    }),
    iconName: ['far', 'hourglass-start']
});
var registrationDeclinedMessage = (0, _jsx3.default)(_StatusBannerMessage2.default, {
    alert: true,
    header: (0, _jsx3.default)(_reactIntl.FormattedMessage, {
        id: 'registration_declined'
    }),
    message: (0, _jsx3.default)(_reactIntl.FormattedMessage, {
        id: 'auctioneer_has_declined_registration'
    }),
    iconName: ['fas', 'exclamation-circle']
});
var reserveMessage = (0, _jsx3.default)(_StatusBannerMessage2.default, {
    alert: true,
    header: (0, _jsx3.default)(_reactIntl.FormattedMessage, {
        id: 'reserve_not_met_bidder_message'
    }),
    message: (0, _jsx3.default)(_reactIntl.FormattedMessage, {
        id: 'reserve_bid_has_been_recorded',
        values: { reserve: RibbonPopover }
    }),
    iconName: ['fas', 'exclamation-circle']
});
var approvedMessage = (0, _jsx3.default)(_StatusBannerMessage2.default, {
    header: (0, _jsx3.default)(_reactIntl.FormattedMessage, {
        id: 'approved_to_bid'
    }),
    message: (0, _jsx3.default)(_reactIntl.FormattedMessage, {
        id: 'you_can_bid_on_any_of_the_items'
    }),
    iconName: ['fas', 'check-circle']
});
var requestMessage = (0, _jsx3.default)(_StatusBannerMessage2.default, {
    header: (0, _jsx3.default)(_reactIntl.FormattedMessage, {
        id: 'request_submitted'
    }),
    message: (0, _jsx3.default)(_reactIntl.FormattedMessage, {
        id: 'request_submitted_long'
    }),
    iconName: ['fas', 'check-circle']
});

var StatusBanner = (_temp = _class = function (_Component) {
    (0, _inherits3.default)(StatusBanner, _Component);

    function StatusBanner() {
        (0, _classCallCheck3.default)(this, StatusBanner);
        return (0, _possibleConstructorReturn3.default)(this, (StatusBanner.__proto__ || (0, _getPrototypeOf2.default)(StatusBanner)).apply(this, arguments));
    }

    (0, _createClass3.default)(StatusBanner, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps) {
            return (0, _propsComparer2.default)(this.props, nextProps, ['bidderHasHighBid', 'catalogId', 'itemId', 'registrationStatus', 'saleStartTs', 'sellerId']);
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                bidderHasBid = _props.bidderHasBid,
                bidderHasHighBid = _props.bidderHasHighBid,
                bidderHasMetReserve = _props.bidderHasMetReserve,
                catalogId = _props.catalogId,
                catalogStatus = _props.catalogStatus,
                className = _props.className,
                isCatalogOnly = _props.isCatalogOnly,
                isLocked = _props.isLocked,
                itemId = _props.itemId,
                openDownloadMobileModal = _props.openDownloadMobileModal,
                openAbstenteeBidModal = _props.openAbstenteeBidModal,
                registrationStatus = _props.registrationStatus,
                saleStartTs = _props.saleStartTs,
                sellerId = _props.sellerId;
            var approved = registrationStatus.approved,
                declined = registrationStatus.declined,
                pending = registrationStatus.pending;


            var banner = '';
            if (declined) {
                banner = registrationDeclinedMessage;
            } else if (isCatalogOnly && !bidderHasBid && pending) {
                banner = requestMessage;
            } else if (bidderHasHighBid && !bidderHasMetReserve) {
                banner = reserveMessage;
            } else if (bidderHasHighBid && bidderHasMetReserve) {
                banner = leadingMessage;
            } else if (!bidderHasBid && pending) {
                banner = registeredMessage;
            } else if (bidderHasBid && !bidderHasHighBid) {
                banner = outBidMessage;
            } else if (!itemId && approved) {
                banner = approvedMessage;
            }

            var showLiveButton = (0, _live.shouldShowLive)(catalogStatus, isCatalogOnly, saleStartTs);

            var watchButton = (0, _jsx3.default)(_components.BidConsoleOpener, {
                catalogId: catalogId,
                sellerId: sellerId
            }, void 0, (0, _jsx3.default)(_components.Button, {
                primary: true,
                className: _StatusBanner2.default.button
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'watch_live_auction'
            })));
            var bidButton = (0, _jsx3.default)(_components.Button, {
                primary: true,
                className: _StatusBanner2.default.button,
                onClick: function onClick() {
                    return openAbstenteeBidModal(itemId, 0);
                }
            }, void 0, '\xA0', (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'increase_bid'
            }));
            var isCatalog = !itemId;
            var button = void 0;

            if (isCatalog) {
                if (showLiveButton) {
                    button = watchButton;
                }
            } else if (!isCatalog) {
                if (bidderHasBid && !isLocked && !declined) {
                    button = bidButton;
                } else if (showLiveButton) {
                    button = watchButton;
                }
            }

            return (0, _jsx3.default)('div', {
                className: _StatusBanner2.default['status-banner'] + ' ' + className
            }, void 0, (0, _jsx3.default)('div', {
                className: _StatusBanner2.default.cta
            }, void 0, (0, _jsx3.default)('div', {
                className: _StatusBanner2.default.container
            }, void 0, (0, _jsx3.default)('span', {
                className: _StatusBanner2.default.link,
                onClick: openDownloadMobileModal
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'download_our_app'
            })), (0, _jsx3.default)('span', {
                className: _StatusBanner2.default['cta-text']
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'and_get_bid_notifications'
            })))), (0, _jsx3.default)('div', {
                className: _StatusBanner2.default['leading-bidder-bar']
            }, void 0, banner, (0, _jsx3.default)('div', {
                className: _StatusBanner2.default['button-container']
            }, void 0, button), (0, _jsx3.default)('div', {
                className: _StatusBanner2.default['bid-live-message']
            }, void 0, (0, _jsx3.default)(_reactFontawesome2.default, {
                className: _StatusBanner2.default.light,
                icon: ['fal', 'lightbulb']
            }), (0, _jsx3.default)('span', {
                className: _StatusBanner2.default.message
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'bid_in_the_live_auction'
            })))));
        }
    }]);
    return StatusBanner;
}(_react.Component), _class.defaultProps = {
    bidderHasBid: false,
    bidderHasHighBid: false,
    bidderHasMetReserve: false,
    catalogId: 0,
    catalogStatus: '',
    className: '',
    isCatalogOnly: false,
    isLocked: false,
    itemId: 0,
    registrationStatus: {}
}, _temp);
exports.default = StatusBanner;
module.exports = exports['default'];

/***/ }),

/***/ "M0zy":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.submitRetractBid = exports.getUiRetractBid = exports.RETRACT_BID_SUCCESS = exports.RETRACT_BID_REQUEST = exports.RETRACT_BID_FAIL = undefined;

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.getRetractBidItemId = getRetractBidItemId;

var _modal = __webpack_require__("u90i");

var _user = __webpack_require__("CFLi");

var _api = __webpack_require__("zFQO");

var _reselect = __webpack_require__("bndy");

var _config = __webpack_require__("iS9E");

var _analytics = __webpack_require__("yxCd");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Action Types */
var RETRACT_BID_FAIL = exports.RETRACT_BID_FAIL = 'la/ui/retractBid/FAIL';
var RETRACT_BID_REQUEST = exports.RETRACT_BID_REQUEST = 'la/ui/retractBid/REQUEST';
var RETRACT_BID_SUCCESS = exports.RETRACT_BID_SUCCESS = 'la/ui/retractBid/SUCCESS';

// reducer
var DEFAULT_STATE = {
    bidRetracted: false,
    error: false,
    itemId: null,
    submitted: false,
    success: false
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        case _modal.DISMISS_MODAL:
            return (0, _extends3.default)({}, state, {
                bidRetracted: false
            });
        case _modal.OPEN_RETRACT_BID_MODAL:
            return (0, _extends3.default)({}, state, {
                itemId: action.payload.itemId
            });
        case RETRACT_BID_REQUEST:
            return (0, _extends3.default)({}, state, {
                bidRetracted: true,
                submitted: true,
                success: false
            });
        case RETRACT_BID_SUCCESS:
            return (0, _extends3.default)({}, state, {
                submitted: false,
                success: true
            });
        case RETRACT_BID_FAIL:
            return (0, _extends3.default)({}, state, {
                error: true,
                submitted: false,
                success: false
            });
        default:
            return state;
    }
}

/* SELECTORS */
var retractBidSelector = function retractBidSelector(state) {
    return state.ui.retractBid;
};

var getUiRetractBid = exports.getUiRetractBid = (0, _reselect.createSelector)(retractBidSelector, function (retractBid) {
    return retractBid;
});

function getRetractBidItemId(state) {
    return state && state.ui && state.ui.retractBid && state.ui.retractBid.itemId ? state.ui.retractBid.itemId : null;
}

/* ACTION CREATORS */
var retractBidFail = function retractBidFail(error) {
    return {
        error: true,
        payload: error,
        type: RETRACT_BID_FAIL
    };
};

var retractBidRequest = function retractBidRequest(itemId, retractionReason, retractionExplanation) {
    return {
        payload: {
            itemId: itemId,
            retractionExplanation: retractionExplanation,
            retractionReason: retractionReason
        },
        type: RETRACT_BID_REQUEST
    };
};

var retractBidSuccess = function retractBidSuccess(itemId, analytics) {
    return {
        meta: {
            analytics: analytics.analytics,
            itemId: itemId
        },
        payload: itemId,
        type: RETRACT_BID_SUCCESS
    };
};

var submitRetractBid = exports.submitRetractBid = function submitRetractBid(itemId, retractionReason, retractionExplanation) {
    return function (dispatch, getState) {
        var state = getState();
        var authToken = (0, _user.getAuthToken)(state);
        var deployment = (0, _config.getDeployment)(state);
        var userData = (0, _user.getUserData)(state);
        var bidderId = userData.bidderId;
        dispatch(retractBidRequest(itemId, retractionReason, retractionExplanation));
        return _api.Bid.postRetractBid({
            authToken: authToken,
            bidderId: bidderId,
            deployment: deployment,
            itemId: itemId,
            retractionExplanation: retractionExplanation,
            retractionReason: retractionReason
        }).then(function () {
            var analytics = (0, _analytics.getRetractedAbsenteeBidAnalytics)(state, itemId, retractionReason, retractionExplanation);
            dispatch(retractBidSuccess(itemId, analytics));
        }).catch(function (error) {
            dispatch(retractBidFail(error));
        });
    };
};

/***/ }),

/***/ "M7t3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = __webpack_require__("dcb+");

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _megaNavLinks = __webpack_require__("3q2/");

var _urls = __webpack_require__("CakR");

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _AllAuctions = __webpack_require__("fR6t");

var _AllAuctions2 = _interopRequireDefault(_AllAuctions);

var _propsComparer = __webpack_require__("wsGv");

var _propsComparer2 = _interopRequireDefault(_propsComparer);

var _reactIntl = __webpack_require__("Pq8k");

var _components = __webpack_require__("bGai");

var _LinkContainer = __webpack_require__("8s5y");

var _LinkContainer2 = _interopRequireDefault(_LinkContainer);

var _MegaNavLink = __webpack_require__("qG7W");

var _MegaNavLink2 = _interopRequireDefault(_MegaNavLink);

var _noop = __webpack_require__("9vKl");

var _noop2 = _interopRequireDefault(_noop);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Navigation = __webpack_require__("/P8x");

var _Navigation2 = _interopRequireDefault(_Navigation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Navigation = function (_Component) {
    (0, _inherits3.default)(Navigation, _Component);

    function Navigation(props, context) {
        (0, _classCallCheck3.default)(this, Navigation);

        var _this = (0, _possibleConstructorReturn3.default)(this, (Navigation.__proto__ || (0, _getPrototypeOf2.default)(Navigation)).call(this, props, context));

        _this.setWrapper = function (node) {
            _this.wrapper = node;
        };

        _this.handleClickOutside = function (event) {
            if (_this.wrapper && !_this.wrapper.contains(event.target)) {
                _this.closeNav();
            }
        };

        _this.openNav = function (Key) {
            return function () {
                if (_this.props.hideDropdown) {
                    return;
                }
                _this.setState({ active: Key });
            };
        };

        _this.closeNav = function () {
            if (_this.state.active) {
                _this.setState({ active: 0 });
            }
        };

        _this.tabletNavigation = function (link, key) {
            return function () {
                if (_this.state.active !== key) {
                    _this.setState({ active: key });
                } else {
                    window.location.assign(link);
                    _this.setState({ active: 0 });
                }
            };
        };

        _this.state = {
            active: 0
        };
        return _this;
    }

    (0, _createClass3.default)(Navigation, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            if (this.props.mobile === 'tablet') {
                document.addEventListener('touchstart', this.handleClickOutside);
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            if (this.props.mobile === 'tablet') {
                document.removeEventListener('touchstart', this.handleClickOutside);
            }
        }
    }, {
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps, nextState) {
            return (0, _propsComparer2.default)(this.props, nextProps, ['mobile', 'parent']) || (0, _propsComparer2.default)(this.state, nextState, ['active']);
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                mobile = _props.mobile,
                parent = _props.parent;

            var calendarUrl = (0, _urls.getAllUpcomingAuctionsUrl)();

            var active = this.state.active;

            var isPhone = mobile && mobile !== 'tablet';
            return _react2.default.createElement(
                'div',
                { className: _Navigation2.default.wrapper, ref: this.setWrapper },
                (0, _jsx3.default)('div', {
                    className: _Navigation2.default.navigation,
                    onMouseLeave: !mobile ? this.closeNav : _noop2.default
                }, void 0, (0, _jsx3.default)('div', {
                    className: _Navigation2.default['scroll-container']
                }, void 0, (0, _jsx3.default)(_components.Link, {
                    className: _Navigation2.default.item,
                    route: true,
                    to: calendarUrl
                }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                    id: 'today'
                })), (0, _jsx3.default)('div', {
                    className: _Navigation2.default.item + ' ' + _Navigation2.default.pipe
                }, void 0, '|'), (0, _jsx3.default)(_AllAuctions2.default, {
                    parent: parent
                }), (0, _jsx3.default)('div', {
                    className: _Navigation2.default.item + ' ' + _Navigation2.default.pipe
                }, void 0, '|'), (0, _jsx3.default)('div', {
                    className: _Navigation2.default.navBar
                }, void 0, (0, _jsx3.default)(_MegaNavLink2.default, {
                    active: active === 1,
                    closeNav: this.closeNav,
                    mobile: mobile,
                    openNav: this.openNav(1),
                    tabletNavigation: this.tabletNavigation('/c/art/1/', 1),
                    link: '/c/art/1/',
                    msgId: 'art'
                }), (0, _jsx3.default)(_MegaNavLink2.default, {
                    active: active === 2,
                    closeNav: this.closeNav,
                    mobile: mobile,
                    openNav: this.openNav(2),
                    tabletNavigation: this.tabletNavigation('/c/jewelry/6/', 2),
                    link: '/c/jewelry/6/',
                    msgId: 'jewelry'
                }), (0, _jsx3.default)(_MegaNavLink2.default, {
                    active: active === 3,
                    closeNav: this.closeNav,
                    mobile: mobile,
                    openNav: this.openNav(3),
                    tabletNavigation: this.tabletNavigation('/c/asian/158/', 3),
                    link: '/c/asian/158/',
                    msgId: 'asian_antiques'
                }), (0, _jsx3.default)(_MegaNavLink2.default, {
                    active: active === 4,
                    closeNav: this.closeNav,
                    mobile: mobile,
                    openNav: this.openNav(4),
                    tabletNavigation: this.tabletNavigation('/c/furniture/4/', 4),
                    link: '/c/furniture/4/',
                    msgId: 'furniture'
                }), (0, _jsx3.default)(_MegaNavLink2.default, {
                    active: active === 5,
                    closeNav: this.closeNav,
                    mobile: mobile,
                    openNav: this.openNav(5),
                    tabletNavigation: this.tabletNavigation('/c/collectibles/2/', 5),
                    link: '/c/collectibles/2/',
                    msgId: 'collectibles'
                }), (0, _jsx3.default)(_MegaNavLink2.default, {
                    active: active === -1,
                    openNav: this.openNav(0),
                    mobile: mobile,
                    closeNav: this.closeNav,
                    tabletNavigation: this.tabletNavigation('/c/coins-currency-stamps/24/', 0),
                    link: '/c/coins-currency-stamps/24/',
                    msgId: 'coins'
                }), (0, _jsx3.default)(_MegaNavLink2.default, {
                    active: active === 6,
                    closeNav: this.closeNav,
                    mobile: mobile,
                    openNav: this.openNav(6),
                    tabletNavigation: this.tabletNavigation('/c/memorabilia/26429/', 6),
                    link: '/c/memorabilia/26429/',
                    msgId: 'memorabilia'
                }), (0, _jsx3.default)(_MegaNavLink2.default, {
                    active: active === 7,
                    closeNav: this.closeNav,
                    mobile: mobile,
                    openNav: this.openNav(7),
                    tabletNavigation: this.tabletNavigation('/c/home-garden/5/', 7),
                    link: '/c/home-garden/5/',
                    msgId: 'home_and_garden'
                }), (0, _jsx3.default)(_MegaNavLink2.default, {
                    active: active === 8,
                    closeNav: this.closeNav,
                    mobile: mobile,
                    openNav: this.openNav(8),
                    tabletNavigation: this.tabletNavigation('/c/fashion/3/', 8),
                    link: '/c/fashion/3/',
                    msgId: 'fashion'
                }))), !isPhone && (0, _jsx3.default)('div', {}, void 0, (0, _jsx3.default)(_LinkContainer2.default, {
                    active: active === 1,
                    closeNav: this.closeNav,
                    mobile: mobile,
                    linkArray: _megaNavLinks.art,
                    picLinkS: (0, _urls.getMegaNavImageUrlSmall)('art'),
                    picLinkL: (0, _urls.getMegaNavImageUrlLarge)('art')
                }), (0, _jsx3.default)(_LinkContainer2.default, {
                    active: active === 2,
                    closeNav: this.closeNav,
                    mobile: mobile,
                    linkArray: _megaNavLinks.jewelry,
                    picLinkS: (0, _urls.getMegaNavImageUrlSmall)('jewelry'),
                    picLinkL: (0, _urls.getMegaNavImageUrlLarge)('jewelry')
                }), (0, _jsx3.default)(_LinkContainer2.default, {
                    active: active === 3,
                    closeNav: this.closeNav,
                    mobile: mobile,
                    linkArray: _megaNavLinks.asian,
                    picLinkS: (0, _urls.getMegaNavImageUrlSmall)('asian'),
                    picLinkL: (0, _urls.getMegaNavImageUrlLarge)('asian')
                }), (0, _jsx3.default)(_LinkContainer2.default, {
                    active: active === 4,
                    closeNav: this.closeNav,
                    mobile: mobile,
                    linkArray: _megaNavLinks.furniture
                }), (0, _jsx3.default)(_LinkContainer2.default, {
                    active: active === 5,
                    closeNav: this.closeNav,
                    mobile: mobile,
                    linkArray: _megaNavLinks.collectibles,
                    picLinkS: (0, _urls.getMegaNavImageUrlSmall)('collectibles'),
                    picLinkL: (0, _urls.getMegaNavImageUrlLarge)('collectibles')
                }), (0, _jsx3.default)(_LinkContainer2.default, {
                    active: active === 6,
                    closeNav: this.closeNav,
                    mobile: mobile,
                    linkArray: _megaNavLinks.memorabilia,
                    picLinkS: (0, _urls.getMegaNavImageUrlSmall)('memorabilia'),
                    picLinkL: (0, _urls.getMegaNavImageUrlLarge)('memorabilia')
                }), (0, _jsx3.default)(_LinkContainer2.default, {
                    active: active === 7,
                    closeNav: this.closeNav,
                    mobile: mobile,
                    linkArray: _megaNavLinks.home
                }), (0, _jsx3.default)(_LinkContainer2.default, {
                    active: active === 8,
                    closeNav: this.closeNav,
                    mobile: mobile,
                    linkArray: _megaNavLinks.fashion,
                    picLinkS: (0, _urls.getMegaNavImageUrlSmall)('fashion'),
                    picLinkL: (0, _urls.getMegaNavImageUrlLarge)('fashion')
                })), (0, _jsx3.default)('div', {
                    className: _Navigation2.default.fade
                }))
            );
        }
    }]);
    return Navigation;
}(_react.Component);

exports.default = Navigation;
module.exports = exports['default'];

/***/ }),

/***/ "M7vW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"item-grid":"item-grid___1ONpx"};

/***/ }),

/***/ "M8Jj":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
/*eslint-disable sort-keys */
var sellerSortOrders = {
    UPCOMING_LOWEST_FIRST: 'UPCOMING_LOWEST_FIRST',
    UPCOMING_HIGHEST_FIRST: 'UPCOMING_HIGHEST_FIRST',
    NAME_LOWEST_FIRST: 'NAME_LOWEST_FIRST',
    NAME_HIGHEST_FIRST: 'NAME_HIGHEST_FIRST'
};

exports.default = sellerSortOrders;
module.exports = exports['default'];

/***/ }),

/***/ "M8WM":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = __webpack_require__("dcb+");

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _components = __webpack_require__("bGai");

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Breadcrumb = __webpack_require__("8wAc");

var _Breadcrumb2 = _interopRequireDefault(_Breadcrumb);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Breadcrumb = (_temp2 = _class = function (_PureComponent) {
    (0, _inherits3.default)(Breadcrumb, _PureComponent);

    function Breadcrumb() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, Breadcrumb);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Breadcrumb.__proto__ || (0, _getPrototypeOf2.default)(Breadcrumb)).call.apply(_ref, [this].concat(args))), _this), _this.ensureTrailingSlash = function (target) {
            return target.endsWith('/') ? target : target + '/';
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(Breadcrumb, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                label = _props.label,
                last = _props.last,
                target = _props.target,
                type = _props.type;

            var classes = label.length > 32 ? _Breadcrumb2.default.breadcrumb + ' ' + _Breadcrumb2.default.ellipsis : '' + _Breadcrumb2.default.breadcrumb;
            return (0, _jsx3.default)('li', {
                className: classes
            }, void 0, (0, _jsx3.default)('div', {
                className: _Breadcrumb2.default.wrapper
            }, void 0, type === 'anchor' && (0, _jsx3.default)(_components.Link, {
                href: this.ensureTrailingSlash(target),
                primaryWeak: true
            }, void 0, label), type === 'label' && (0, _jsx3.default)('div', {
                className: 'pull-left'
            }, void 0, label), type === 'link' && (0, _jsx3.default)(_components.Link, {
                route: true,
                to: this.ensureTrailingSlash(target),
                primaryWeak: true
            }, void 0, label), !last && (0, _jsx3.default)('span', {
                className: _Breadcrumb2.default.chevron
            }, void 0, '\u203A')));
        }
    }]);
    return Breadcrumb;
}(_react.PureComponent), _class.defaultProps = {
    label: '',
    last: false,
    target: '',
    type: 'label'
}, _temp2);
exports.default = Breadcrumb;
module.exports = exports['default'];

/***/ }),

/***/ "MFq5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

var _jsx2 = __webpack_require__("dcb+");

var _jsx3 = _interopRequireDefault(_jsx2);

var _objectWithoutProperties2 = __webpack_require__("+6Bu");

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__("Pq8k");

var _Input = __webpack_require__("Alk2");

var _Input2 = _interopRequireDefault(_Input);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FormInput = function (_Component) {
    (0, _inherits3.default)(FormInput, _Component);

    function FormInput() {
        (0, _classCallCheck3.default)(this, FormInput);
        return (0, _possibleConstructorReturn3.default)(this, (FormInput.__proto__ || (0, _getPrototypeOf2.default)(FormInput)).apply(this, arguments));
    }

    (0, _createClass3.default)(FormInput, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                children = _props.children,
                form = _props.form,
                id = _props.id,
                rest = (0, _objectWithoutProperties3.default)(_props, ['children', 'form', 'id']);
            var fieldErrors = form.fieldErrors,
                fieldValid = form.fieldValid;


            return _react2.default.createElement(
                _Input2.default,
                (0, _extends3.default)({
                    errorMessage: (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                        id: fieldErrors[id]
                    }),
                    id: id,
                    label: (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                        id: 'formLabels.' + id
                    }),
                    valid: fieldValid[id]
                }, rest),
                children
            );
        }
    }]);
    return FormInput;
}(_react.Component);

exports.default = FormInput;
module.exports = exports['default'];

/***/ }),

/***/ "MJ4I":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.removePageFromEncodedSearchParams = exports.DEFAULT_STATUS_FOR_ARCHIVED_SEARCH = exports.DEFAULT_STATUS_FOR_ONLINE_SEARCH = undefined;

var _toConsumableArray2 = __webpack_require__("Gu7T");

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _keys = __webpack_require__("fZjL");

var _keys2 = _interopRequireDefault(_keys);

var _has = __webpack_require__("iD6E");

var _has2 = _interopRequireDefault(_has);

var _stringify = __webpack_require__("mvHQ");

var _stringify2 = _interopRequireDefault(_stringify);

exports.getSearchParams = getSearchParams;
exports.parameterNameFromFacetId = parameterNameFromFacetId;
exports.getFacetFromSearchQueryParameter = getFacetFromSearchQueryParameter;
exports.resetPageNumber = resetPageNumber;
exports.addValueToParamsList = addValueToParamsList;
exports.removeParamsFromList = removeParamsFromList;
exports.removeCampaignId = removeCampaignId;
exports.removeCountry = removeCountry;
exports.removeDistance = removeDistance;
exports.modifyUrlWhenChecked = modifyUrlWhenChecked;
exports.addRangeToParams = addRangeToParams;
exports.modifyUrlWithSearchStatus = modifyUrlWithSearchStatus;
exports.modifyUrlWithRange = modifyUrlWithRange;
exports.modifyUrlWithTaxonomy = modifyUrlWithTaxonomy;
exports.taxonomyParentSelected = taxonomyParentSelected;
exports.taxonomyAllSelected = taxonomyAllSelected;
exports.modifyUrlWhenPageChanges = modifyUrlWhenPageChanges;
exports.removeCountryAndDistance = removeCountryAndDistance;
exports.modifyUrlWithDistance = modifyUrlWithDistance;
exports.modifyUrlWithSort = modifyUrlWithSort;
exports.removeFacetById = removeFacetById;
exports.removeUpcomingFacetFromUrl = removeUpcomingFacetFromUrl;
exports.removeArchiveFacetFromUrl = removeArchiveFacetFromUrl;
exports.clearAllParamsExceptCategoriesForCategoryPage = clearAllParamsExceptCategoriesForCategoryPage;
exports.clearAllParamsExceptCategories = clearAllParamsExceptCategories;

var _search = __webpack_require__("9ad9");

var _urls = __webpack_require__("CakR");

var _facetTypes = __webpack_require__("Ycpv");

var _facetTypes2 = _interopRequireDefault(_facetTypes);

var _paramTypes = __webpack_require__("jQDs");

var _paramTypes2 = _interopRequireDefault(_paramTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DEFAULT_STATUS_FOR_ONLINE_SEARCH = exports.DEFAULT_STATUS_FOR_ONLINE_SEARCH = 'online';
var DEFAULT_STATUS_FOR_ARCHIVED_SEARCH = exports.DEFAULT_STATUS_FOR_ARCHIVED_SEARCH = 'archive';

function getSearchParams(location) {
    //  breaking when & (and probably other) symbol is in the search term
    var searchParams = void 0;
    try {
        searchParams = location.query.parameters ? JSON.parse(location.query.parameters) : {};
    } catch (e) {
        try {
            searchParams = location.query.parameters ? JSON.parse(decodeURIComponent(location.query.parameters)) : {};
        } catch (err) {
            // Do we need to log this?  it feel like it is just bloating the logs
            // console.error(
            //     'FAILED to get parameters from an existing query.parameters',
            //     err,
            //     location
            // );
            return {};
        }
    }

    try {
        if (searchParams.campaignId || location.query.campaign_id) {
            searchParams.campaignId = searchParams.campaignId || location.query.campaign_id;
        }

        if (searchParams.campaignId || location.query.campaign_id) {
            searchParams.campaignId = searchParams.campaignId || location.query.campaign_id;
        }
        if (searchParams.category_id) {
            searchParams.category_id = searchParams.category_id.toString();
        }

        return searchParams;
    } catch (error) {
        // eslint-disable-next-line
        console.error(error, location);

        return {};
    }
}

var removePageFromEncodedSearchParams = exports.removePageFromEncodedSearchParams = function removePageFromEncodedSearchParams(params) {
    if (!params || params === '%7B%7D') {
        return params;
    }
    var decoded = decodeURIComponent(params);
    var unstringified = JSON.parse(decoded);
    delete unstringified.page;
    var stringified = (0, _stringify2.default)(unstringified);
    var encoded = encodeURIComponent(stringified);

    return encoded;
};

function parameterNameFromFacetId(facetId) {
    var paramName = '';
    if (facetId === _facetTypes2.default.AUCTION_HOUSE_ID) {
        paramName = _paramTypes2.default.AUCTION_HOUSE_ID;
    } else if (facetId === _facetTypes2.default.MATERIALS_AND_TECHNIQUES_ID || facetId === _facetTypes2.default.CREATOR_ID || facetId === _facetTypes2.default.STYLE_PERIOD_ID || facetId === _facetTypes2.default.CATEGORY_ID || facetId === _facetTypes2.default.ORIGIN_ID) {
        paramName = _paramTypes2.default.CATEGORY_ID;
    } else if (facetId === _facetTypes2.default.COUNTRY_CODE_ID) {
        paramName = _paramTypes2.default.COUNTRY_CODE_ID;
    } else if (facetId === _facetTypes2.default.CURRENCY_ID) {
        paramName = _paramTypes2.default.CURRENCY_ID;
    } else if (facetId === _facetTypes2.default.CURRENT_BID_ID) {
        paramName = _paramTypes2.default.CURRENT_BID_ID;
    } else if (facetId === _facetTypes2.default.ESTIMATED_PRICE_ID) {
        paramName = _paramTypes2.default.ESTIMATED_PRICE_ID;
    } else if (facetId === _facetTypes2.default.HAMMER_PRICE_ID) {
        paramName = _paramTypes2.default.HAMMER_PRICE_ID;
    }

    return paramName;
}

function getFacetFromSearchQueryParameter(paramKey) {
    var facetId = void 0;
    if (paramKey === _paramTypes2.default.AUCTION_HOUSE_ID) {
        facetId = _facetTypes2.default.AUCTION_HOUSE_ID;
    } else if (paramKey === _paramTypes2.default.COUNTRY_CODE_ID) {
        facetId = _facetTypes2.default.COUNTRY_CODE_ID;
    } else if (paramKey === _paramTypes2.default.CURRENCY_ID) {
        facetId = _facetTypes2.default.CURRENCY_ID;
    } else if (paramKey === _paramTypes2.default.ESTIMATED_PRICE_ID) {
        facetId = _facetTypes2.default.ESTIMATED_PRICE_ID;
    } else if (paramKey === _paramTypes2.default.CURRENT_BID_ID) {
        facetId = _facetTypes2.default.CURRENT_BID_ID;
    } else if (paramKey === _paramTypes2.default.DISTANCE_ID) {
        facetId = _facetTypes2.default.DISTANCE_ID;
    } else if (paramKey === _paramTypes2.default.HAMMER_PRICE_ID) {
        facetId = _facetTypes2.default.HAMMER_PRICE_ID;
    }
    return facetId;
}

function resetPageNumber(params) {
    params.page = 1;
}

function addValueToParamsList(params, paramName, value) {
    if (params[paramName]) {
        var ids = params[paramName].split(',');
        if (!ids.some(function (id) {
            return id === value;
        })) {
            ids.push(value);
            params[paramName] = ids.join(',');
        }
    } else {
        params[paramName] = value;
    }
}

function removeParamsFromList(params, paramName, value) {
    if ((0, _has2.default)(params, paramName)) {
        var values = params[paramName].split(',');
        var index = values.indexOf(value);
        if (index > -1) {
            values.splice(index, 1);
        }

        if (values.length === 0) {
            delete params[paramName];
        } else {
            params[paramName] = values.join(',');
        }
    }
}

function removeCampaignId(params) {
    removeParamsFromList(params, _paramTypes2.default.CAMPAIGN_ID, params.campaignId);
    return params;
}

function removeCountry(params) {
    removeParamsFromList(params, _paramTypes2.default.COUNTRY_CODE_ID, params.country);
    return params;
}

function removeDistance(params) {
    removeParamsFromList(params, _paramTypes2.default.DISTANCE_ID, params.distance);
    return params;
}

function modifyUrlWhenChecked(facetId, value, location, checked) {
    var params = getSearchParams(location);
    var paramName = parameterNameFromFacetId(facetId);
    if (checked) {
        addValueToParamsList(params, paramName, value);
        if (facetId === _facetTypes2.default.COUNTRY_CODE_ID) {
            removeDistance(params);
        }
    } else {
        removeParamsFromList(params, paramName, value);
    }
    return params;
}

function addRangeToParams(params, paramName, min, max) {
    var minValue = min !== '' && min !== undefined ? min : -1;
    var maxValue = max !== '' && max !== undefined ? max : -1;

    params[paramName] = 'USD:' + minValue + ':' + maxValue;
}

function modifyUrlWithSearchStatus(location, archivedSearch, sellerId) {
    var params = getSearchParams(location);

    (0, _keys2.default)(params).forEach(function (key) {
        if (key === _paramTypes2.default.KEYWORD || key === _paramTypes2.default.PAGE_SIZE_LEGACY_SUPPORT || key === _paramTypes2.default.PAGE_SIZE) return;

        delete params[key];
    });

    params[_paramTypes2.default.SORT] = _search.DEFAULT_SORT_ORDER;

    var paramName = _paramTypes2.default.STATUS;
    if (!archivedSearch) {
        params[paramName] = DEFAULT_STATUS_FOR_ONLINE_SEARCH;
    } else {
        params[paramName] = DEFAULT_STATUS_FOR_ARCHIVED_SEARCH;
    }

    if (sellerId) {
        params['house_id'] = '' + sellerId;
    }

    return params;
}

function modifyUrlWithRange(facetId, location, min, max) {
    var params = getSearchParams(location);
    var paramName = parameterNameFromFacetId(facetId);

    addRangeToParams(params, paramName, min, max);

    return params;
}

var concatenatePath = function concatenatePath(category, catId) {
    if (!category) return '';
    if (category.id === catId) {
        return category.id;
    }
    var nextCategory = (0, _search.findCategoryContainingSomeCategoryId)(catId, category.categories);
    return [category.id].concat((0, _toConsumableArray3.default)(concatenatePath(nextCategory, catId)));
};

function modifyUrlWithTaxonomy(facetId, value, location, facets) {
    var params = getSearchParams(location);
    var paramName = parameterNameFromFacetId(facetId);
    var treeFacets = facets.filter(function (category) {
        return category.id === facetId;
    });

    var result = (0, _search.findCategoryContainingSomeCategoryId)(value, treeFacets);

    var numbersToRemove = concatenatePath(result, value);
    if (numbersToRemove && numbersToRemove.length > 0) {
        numbersToRemove.forEach(function (idToRemove) {
            if (idToRemove !== facetId || idToRemove !== value) {
                removeParamsFromList(params, paramName, idToRemove);
            }
        });
    }
    addValueToParamsList(params, paramName, value);
    return params;
}

function taxonomyParentSelected(parentId, categoryId, facetId, location) {
    var params = getSearchParams(location);
    var paramName = parameterNameFromFacetId(facetId);
    removeParamsFromList(params, paramName, categoryId);
    addValueToParamsList(params, paramName, parentId);
    return params;
}

function taxonomyAllSelected(facetId, categoryId, location) {
    var params = getSearchParams(location);
    var paramName = parameterNameFromFacetId(facetId);
    removeParamsFromList(params, paramName, categoryId);
    return params;
}

function modifyUrlWhenPageChanges(page, location) {
    var params = getSearchParams(location);
    var paramName = _paramTypes2.default.PAGE;
    params[paramName] = page;
    return params;
}

function removeCountryAndDistance(location) {
    var params = getSearchParams(location);
    removeCountry(params);
    removeDistance(params);
    return params;
}

function modifyUrlWithDistance(country, zipCode, range, measurement, location) {
    var params = getSearchParams(location);
    removeCountry(params);
    var paramName = _paramTypes2.default.DISTANCE_ID;
    params[paramName] = country + ':' + zipCode + ':' + range + ':' + measurement;
    return params;
}

function modifyUrlWithSort(sortOption, location) {
    var params = getSearchParams(location);
    var paramName = _paramTypes2.default.SORT;
    params[paramName] = sortOption;
    return params;
}

function removeFacetById(facetId, location) {
    var params = getSearchParams(location);
    var paramName = parameterNameFromFacetId(facetId);
    delete params[paramName];
    return params;
}

function removeFacetFromUrl(location, categoryId, params, baseUrl) {
    // expecting a url in the pattern of "/c/name/name/id/id", "/c/name/id" or "/c"
    var url = location.pathname;
    // split the current location into its separate parts
    var splitUrl = url.split('/');
    // remove the empty string and the c (created because of the format '/c/')from the array
    var categoryNames = splitUrl.splice(2, splitUrl.length - 2);
    // split the category names and Ids (there will always be an even number of Ids and names in the pattern name/id or name/name/id/id etc.)
    var categoryIds = categoryNames.splice(categoryNames.length / 2, categoryNames.length - categoryNames.length / 2);

    var id = '';
    var name = '';
    // begin reassembling the two parts by adding each of the ones we want but not the one we don't
    for (var i = 0; i < categoryIds.length; i += 1) {
        if (categoryIds[i] !== categoryId) {
            id += categoryIds[i] + '/';
            name += '/' + categoryNames[i];
        }
    }

    if (name === '') {
        var _url = baseUrl;
        if (params !== '') {
            _url += '?parameters=' + params;
        }
        return _url;
    }

    return '/' + splitUrl[1] + name + '/' + id.substring(0, id.length - 1) + '/?parameters=' + params;
}

function removeUpcomingFacetFromUrl(location, categoryId, params) {
    return removeFacetFromUrl(location, categoryId, params, (0, _urls.getCategoryLandingPageBaseUrl)());
}

function removeArchiveFacetFromUrl(location, categoryId, params) {
    return removeFacetFromUrl(location, categoryId, params, (0, _urls.getPriceGuideBaseUrl)());
}

function clearAllParamsExceptCategoriesForCategoryPage(location, facets) {
    var categoryFacets = facets.filter(function (fac) {
        return fac.id === _facetTypes2.default.CATEGORY_ID;
    });
    var selectedCategoryFacet = categoryFacets[0].categories.facets.filter(function (fac) {
        return fac.selected;
    });
    // expecting a url in the pattern of "/c/name/name/id/id", "/c/name/id" or "/c"
    var url = location.pathname;
    // split the current location into its separate parts
    var splitUrl = url.split('/');
    // just gets the Id for the first category in the url
    var id = splitUrl[(splitUrl.length + 1) / 2];
    // just gets the name for the first category in the url
    var name = splitUrl[2];
    // if the length is 3 (meaning there's no categories in the url) or id is greater than or equal to the firstNonCategoryId (meaning it's a facet not a category)
    if (splitUrl.length <= 3 || selectedCategoryFacet.length <= 0) {
        return (0, _urls.getCategoryLandingPageBaseUrl)();
    }

    return '/' + splitUrl[1] + '/' + name + '/' + id;
}
function clearAllParamsExceptCategories(location, facets) {
    var params = getSearchParams(location);

    (0, _keys2.default)(params).forEach(function (key) {
        if (key === _paramTypes2.default.KEYWORD || key === _paramTypes2.default.PAGE || key === _paramTypes2.default.PAGE_SIZE_LEGACY_SUPPORT || key === _paramTypes2.default.PAGE_SIZE || key === _paramTypes2.default.SORT || key === _paramTypes2.default.STATUS) return;

        if (key === _paramTypes2.default.CATEGORY_ID) {
            var categoryFacets = facets.filter(function (fac) {
                return fac.id === _facetTypes2.default.CATEGORY_ID;
            });
            var selectedCategoryFacet = categoryFacets[0].categories.facets.filter(function (fac) {
                return fac.selected;
            });
            if (selectedCategoryFacet.length > 0) {
                params[key] = selectedCategoryFacet[0].id;
            } else {
                delete params[key];
            }
        } else {
            delete params[key];
        }
    });
    return params;
}

/***/ }),

/***/ "MJII":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"scroll-track":"scroll-track___XJnoT","scroll-track-hidden":"scroll-track-hidden___s644C","scroll-thumb":"scroll-thumb___2jFBY","scroll-thumb-hidden":"scroll-thumb-hidden___17a9V"};

/***/ }),

/***/ "MKYO":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = __webpack_require__("dcb+");

var _jsx3 = _interopRequireDefault(_jsx2);

var _toConsumableArray2 = __webpack_require__("Gu7T");

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propsComparer = __webpack_require__("wsGv");

var _propsComparer2 = _interopRequireDefault(_propsComparer);

var _reactFontawesome = __webpack_require__("f7W8");

var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ItemSaveIcon = __webpack_require__("uHXy");

var _ItemSaveIcon2 = _interopRequireDefault(_ItemSaveIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ItemSaveIcon = (_temp = _class = function (_Component) {
    (0, _inherits3.default)(ItemSaveIcon, _Component);

    function ItemSaveIcon() {
        (0, _classCallCheck3.default)(this, ItemSaveIcon);
        return (0, _possibleConstructorReturn3.default)(this, (ItemSaveIcon.__proto__ || (0, _getPrototypeOf2.default)(ItemSaveIcon)).apply(this, arguments));
    }

    (0, _createClass3.default)(ItemSaveIcon, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps) {
            return (0, _propsComparer2.default)(this.props, nextProps, ['className', 'iconClassName', 'saved']);
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                className = _props.className,
                iconClassName = _props.iconClassName,
                save = _props.save,
                saved = _props.saved;

            var icon = saved ? ['fas', 'heart'] : ['far', 'heart'];
            var classes = [].concat((0, _toConsumableArray3.default)(className.split(' ')), [_ItemSaveIcon2.default['save-container']]).join(' ');
            var iconClasses = [].concat((0, _toConsumableArray3.default)(iconClassName.split(' ')), [_ItemSaveIcon2.default.save]).join(' ');
            return (0, _jsx3.default)('div', {
                className: classes
            }, void 0, (0, _jsx3.default)(_reactFontawesome2.default, {
                className: iconClasses,
                icon: icon,
                onClick: save
            }));
        }
    }]);
    return ItemSaveIcon;
}(_react.Component), _class.defaultProps = {
    className: '',
    iconClassName: '',
    saved: false
}, _temp);
exports.default = ItemSaveIcon;
module.exports = exports['default'];

/***/ }),

/***/ "ML/9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.submitAddCreditCard = exports.getUiAddCreditCard = exports.ADD_CREDIT_CARD_SUCCESS = exports.ADD_CREDIT_CARD_REQUEST = exports.ADD_CREDIT_CARD_FAIL = undefined;

var _regenerator = __webpack_require__("Xxa5");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__("exGp");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;

var _user = __webpack_require__("CFLi");

var _api = __webpack_require__("zFQO");

var _reselect = __webpack_require__("bndy");

var _modal = __webpack_require__("u90i");

var _config = __webpack_require__("iS9E");

var _getStripeErrorMessageFromResponse = __webpack_require__("VFQi");

var _getStripeErrorMessageFromResponse2 = _interopRequireDefault(_getStripeErrorMessageFromResponse);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Action Types */
var ADD_CREDIT_CARD_FAIL = exports.ADD_CREDIT_CARD_FAIL = 'la/ui/addCreditCard/FAIL';
var ADD_CREDIT_CARD_REQUEST = exports.ADD_CREDIT_CARD_REQUEST = 'la/ui/addCreditCard/REQUEST';
var ADD_CREDIT_CARD_SUCCESS = exports.ADD_CREDIT_CARD_SUCCESS = 'la/ui/addCreditCard/SUCCESS';

// reducer
var DEFAULT_STATE = {
    error: false,
    errorMessage: null,
    submitted: false,
    success: false
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        case ADD_CREDIT_CARD_REQUEST:
            return (0, _extends3.default)({}, state, {
                error: false,
                errorMessage: null,
                submitted: true,
                success: false
            });
        case ADD_CREDIT_CARD_SUCCESS:
            return (0, _extends3.default)({}, state, {
                submitted: false,
                success: true
            });
        case ADD_CREDIT_CARD_FAIL:
            return (0, _extends3.default)({}, state, {
                error: true,
                errorMessage: (0, _getStripeErrorMessageFromResponse2.default)(action.payload),
                submitted: false,
                success: false
            });
        case _modal.DISMISS_MODAL:
            return DEFAULT_STATE;
        default:
            return state;
    }
}

/* SELECTORS */
var stateSelector = function stateSelector(state) {
    return state.ui.addCreditCard;
};

var getUiAddCreditCard = exports.getUiAddCreditCard = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state;
});

/* ACTION CREATORS */
var submitAddCreditCard = exports.submitAddCreditCard = function submitAddCreditCard(_ref) {
    var cardToken = _ref.cardToken;
    return function () {
        var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch, getState) {
            var state, authToken, bidderId, deployment, isStripeCustomer, apiCall, response;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.prev = 0;
                            state = getState();
                            authToken = (0, _user.getAuthToken)(state);
                            bidderId = (0, _user.getBidderId)(state);
                            deployment = (0, _config.getDeployment)(state);
                            isStripeCustomer = (0, _user.getIsStripeCustomer)(state);


                            dispatch({
                                payload: bidderId,
                                type: ADD_CREDIT_CARD_REQUEST
                            });

                            apiCall = isStripeCustomer ? _api.Auth.putAddCreditCard : _api.Auth.postAddCreditCard;
                            _context.next = 10;
                            return apiCall({ authToken: authToken, bidderId: bidderId, cardToken: cardToken, deployment: deployment });

                        case 10:
                            response = _context.sent;
                            _context.next = 13;
                            return dispatch((0, _user.fetchBidderDataIfNeeded)(authToken, true));

                        case 13:

                            dispatch({
                                meta: { actionTime: Date.now() },
                                payload: response.data,
                                type: ADD_CREDIT_CARD_SUCCESS
                            });
                            _context.next = 20;
                            break;

                        case 16:
                            _context.prev = 16;
                            _context.t0 = _context['catch'](0);

                            dispatch({
                                error: true,
                                payload: _context.t0,
                                type: ADD_CREDIT_CARD_FAIL
                            });
                            throw _context.t0;

                        case 20:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, undefined, [[0, 16]]);
        }));

        return function (_x3, _x4) {
            return _ref2.apply(this, arguments);
        };
    }();
};

/***/ }),

/***/ "Mz5s":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"password-label":"password-label___28D0q","label":"label___tsG4d","icon":"icon___1Le0b","eye":"eye___1z1hl"};

/***/ }),

/***/ "N5um":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isCatalogItemsLoading = exports.getLoadTimeForCatalogItems = exports.shouldFetchBiddingInfoForCatalog = undefined;

var _toConsumableArray2 = __webpack_require__("Gu7T");

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;

var _biddingInfo = __webpack_require__("m9FA");

var _catalogItems = __webpack_require__("ozIy");

var _reselect = __webpack_require__("bndy");

var _difference = __webpack_require__("WlNK");

var _difference2 = _interopRequireDefault(_difference);

var _ms = __webpack_require__("EarI");

var _ms2 = _interopRequireDefault(_ms);

var _union = __webpack_require__("gszD");

var _union2 = _interopRequireDefault(_union);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var REDUX_STORE_TIME_CATALOG = (0, _ms2.default)('5m');

// reducer
var DEFAULT_STATE = {
    loaded: {},
    loading: []
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var loaded = (0, _extends3.default)({}, state.loaded);
    var loading = [].concat((0, _toConsumableArray3.default)(state.loading));
    var time = void 0;

    switch (action.type) {
        case _biddingInfo.LOAD_CATALOG_BIDDING_REQUEST:
        case _biddingInfo.LOAD_CATALOG_BIDDING_SUCCESS:
        case _catalogItems.LOAD_CATALOG_ITEMS_REQUEST:
        case _catalogItems.LOAD_CATALOG_ITEMS_SUCCESS:
            time = action.meta.actionTime;

            if (action.type === _biddingInfo.LOAD_CATALOG_BIDDING_REQUEST) {
                loading = (0, _union2.default)(loading, ['catalog-bidding-info-' + action.payload]);
            }

            if (action.type === _biddingInfo.LOAD_CATALOG_BIDDING_SUCCESS) {
                var id = action.meta.catalogId;
                loaded['catalog-bidding-info-' + id] = time;
                loading = (0, _difference2.default)(loading, ['catalog-bidding-info-' + id]);
            }

            // TODO: make this a pure function by moving the global
            if (action.type === _catalogItems.LOAD_CATALOG_ITEMS_REQUEST && !global.__SERVER__) {
                action.payload.forEach(function (id) {
                    loading = (0, _union2.default)(loading, ['catalog-items-' + id]);
                });
            }

            if (action.type === _catalogItems.LOAD_CATALOG_ITEMS_SUCCESS && !global.__SERVER__) {
                // TODO: why is catalogId not plural?
                action.meta.catalogId.forEach(function (id) {
                    loaded['catalog-items-' + id] = time;
                    loading = (0, _difference2.default)(loading, ['catalog-items-' + id]);
                });
            }

            return (0, _extends3.default)({}, state, {
                loaded: loaded,
                loading: loading
            });
        default:
            return state;
    }
}

/* SELECTORS */
var stateSelector = function stateSelector(state) {
    return state.domain.loaded;
};
var idSelector = function idSelector(state, id) {
    return id;
};

var loadedSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.loaded;
});

var loadingSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.loading;
});

var getLoadTimeForCatalogBidding = (0, _reselect.createSelector)([loadedSelector, idSelector], function (loaded, id) {
    return loaded['catalog-bidding-info-' + id] || 0;
});

var isCatalogBiddingLoading = (0, _reselect.createSelector)([loadingSelector, idSelector], function (loading, id) {
    return loading.includes('catalog-bidding-info-' + id);
});

var shouldFetchBiddingInfoForCatalog = exports.shouldFetchBiddingInfoForCatalog = (0, _reselect.createSelector)([idSelector, getLoadTimeForCatalogBidding, isCatalogBiddingLoading], function (catalogId, loaded, loading) {
    if (!catalogId) return false;
    var time = Date.now();
    var diff = time - loaded;
    if (diff < REDUX_STORE_TIME_CATALOG) return false;
    return !loading;
});

var getLoadTimeForCatalogItems = exports.getLoadTimeForCatalogItems = (0, _reselect.createSelector)([loadedSelector, idSelector], function (loaded, id) {
    return loaded['catalog-items-' + id] || 0;
});

var isCatalogItemsLoading = exports.isCatalogItemsLoading = (0, _reselect.createSelector)([loadingSelector, idSelector], function (loading, id) {
    return loading.includes('catalog-items-' + id);
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("DuR2")))

/***/ }),

/***/ "NCJW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"table":"table___i-ve_","row":"row___326PN"};

/***/ }),

/***/ "Ng+f":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fetchInvoiceIfNeeded = exports.isInvoiceLoading = exports.isInvoiceLoaded = exports.getLoadTimeForInvoice = exports.getInvoice = exports.LOAD_INVOICE_SUCCESS = exports.LOAD_INVOICE_REQUEST = exports.LOAD_INVOICE_FAIL = undefined;

var _regenerator = __webpack_require__("Xxa5");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _asyncToGenerator2 = __webpack_require__("exGp");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _defineProperty2 = __webpack_require__("bOdI");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends3 = __webpack_require__("Dd8w");

var _extends4 = _interopRequireDefault(_extends3);

exports.default = reducer;

var _user = __webpack_require__("CFLi");

var _api = __webpack_require__("zFQO");

var _cloneDeep = __webpack_require__("kvU2");

var _cloneDeep2 = _interopRequireDefault(_cloneDeep);

var _reselect = __webpack_require__("bndy");

var _difference = __webpack_require__("WlNK");

var _difference2 = _interopRequireDefault(_difference);

var _config = __webpack_require__("iS9E");

var _isEmpty = __webpack_require__("lHK6");

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _ms = __webpack_require__("EarI");

var _ms2 = _interopRequireDefault(_ms);

var _union = __webpack_require__("gszD");

var _union2 = _interopRequireDefault(_union);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Action Types */
var LOAD_INVOICE_FAIL = exports.LOAD_INVOICE_FAIL = 'la/ui/checkout/LOAD_FAIL';
var LOAD_INVOICE_REQUEST = exports.LOAD_INVOICE_REQUEST = 'la/ui/checkout/LOAD_REQUEST';
var LOAD_INVOICE_SUCCESS = exports.LOAD_INVOICE_SUCCESS = 'la/ui/checkout/LOAD_SUCCESS';

var REDUX_STORE_TIME = (0, _ms2.default)('30m');

/* reducer */
var DEFAULT_STATE = {
    byId: {},
    loaded: {},
    loading: []
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var existing = void 0;
    var loaded = void 0;
    var loading = void 0;
    var time = void 0;

    switch (action.type) {
        case LOAD_INVOICE_FAIL:
            return (0, _extends4.default)({}, state, {
                loading: (0, _difference2.default)(state.loading, [action.meta.catalogId])
            });
        case LOAD_INVOICE_REQUEST:
            return (0, _extends4.default)({}, state, {
                loading: (0, _union2.default)(state.loading, [action.payload])
            });
        case LOAD_INVOICE_SUCCESS:
            time = action.meta.actionTime;
            existing = (0, _cloneDeep2.default)(state.byId);
            loaded = (0, _extends4.default)({}, state.loaded, (0, _defineProperty3.default)({}, action.meta.catalogId, time));
            loading = (0, _cloneDeep2.default)(state.loading);

            existing[action.meta.catalogId] = action.payload;
            loading = (0, _difference2.default)(loading, [action.meta.catalogId]);
            return (0, _extends4.default)({}, state, {
                byId: existing,
                loaded: loaded,
                loading: loading
            });
        default:
            return state;
    }
}

/* SELECTORS */
var stateSelector = function stateSelector(state) {
    return state.ui.checkout;
};
var idSelector = function idSelector(state, id) {
    return id;
};

var byIdSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.byId;
});

var loadedSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.loaded;
});

var loadingSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.loading;
});

var getInvoice = exports.getInvoice = (0, _reselect.createSelector)([byIdSelector, idSelector], function (byId, id) {
    return byId[id] || { invoice: {}, items: [] };
});

var getLoadTimeForInvoice = exports.getLoadTimeForInvoice = (0, _reselect.createSelector)([loadedSelector, idSelector], function (loaded, id) {
    return loaded[id] || 0;
});
var isInvoiceLoaded = exports.isInvoiceLoaded = getLoadTimeForInvoice;
var isInvoiceLoading = exports.isInvoiceLoading = (0, _reselect.createSelector)([loadingSelector, idSelector], function (loading, id) {
    return loading.includes(id);
});

var shouldFetchInvoice = (0, _reselect.createSelector)([idSelector, getInvoice, getLoadTimeForInvoice, isInvoiceLoading], function (catalogId, invoice, loaded, loading) {
    if (!catalogId) return false;
    if (!(0, _isEmpty2.default)(invoice)) {
        var time = Date.now();
        var diff = time - loaded;
        if (diff < REDUX_STORE_TIME) return false;
    }
    return !loading;
});

/* ACTION CREATORS */
var fetchInvoiceIfNeeded = exports.fetchInvoiceIfNeeded = function fetchInvoiceIfNeeded(catalogId) {
    return function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch, getState) {
            var state, authToken, deployment, bidderId, response;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            state = getState();

                            if (!shouldFetchInvoice(state, catalogId)) {
                                _context.next = 18;
                                break;
                            }

                            _context.prev = 2;
                            authToken = (0, _user.getAuthToken)(state);
                            deployment = (0, _config.getDeployment)(state);
                            bidderId = (0, _user.getBidderId)(state);

                            dispatch({
                                meta: { actionTime: Date.now() },
                                payload: catalogId,
                                type: LOAD_INVOICE_REQUEST
                            });
                            _context.next = 9;
                            return _api.Checkout.fetchInvoice({ authToken: authToken, bidderId: bidderId, catalogId: catalogId, deployment: deployment });

                        case 9:
                            response = _context.sent;

                            dispatch({
                                meta: { actionTime: Date.now(), catalogId: catalogId },
                                payload: response.data,
                                type: LOAD_INVOICE_SUCCESS
                            });
                            _context.next = 16;
                            break;

                        case 13:
                            _context.prev = 13;
                            _context.t0 = _context['catch'](2);

                            dispatch({
                                error: true,
                                meta: { catalogId: catalogId },
                                payload: _context.t0,
                                type: LOAD_INVOICE_FAIL
                            });

                        case 16:
                            _context.next = 19;
                            break;

                        case 18:
                            return _context.abrupt('return', _promise2.default.resolve());

                        case 19:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, undefined, [[2, 13]]);
        }));

        return function (_x3, _x4) {
            return _ref.apply(this, arguments);
        };
    }();
};

/***/ }),

/***/ "NmEf":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
/*eslint-disable sort-keys */
var savedSearchSortOrders = {
    LAST_SENT_ASCENDING: 'LAST_SENT_ASCENDING',
    LAST_SENT_DESCENDING: 'LAST_SENT_DESCENDING',
    SEARCH_TERM_ASCENDING: 'SEARCH_TERM_ASCENDING',
    SEARCH_TERM_DESCENDING: 'SEARCH_TERM_DESCENDING'
};

exports.default = savedSearchSortOrders;
module.exports = exports['default'];

/***/ }),

/***/ "O+2Z":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"item-card-control":"item-card-control___1_FCI","button":"button___1OsF4","live":"live___u0R1_","help-button":"help-button___2NZND","retract":"retract___1ckjE","why-cant-i-retract-bid-popover-text":"why-cant-i-retract-bid-popover-text___1ffuS","why_cant_i_retract_bid_popover_text":"why_cant_i_retract_bid_popover_text___n73IJ"};

/***/ }),

/***/ "OMSM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"catalog-card":"catalog-card___2pksc","cover-lots":"cover-lots___3qUZ3","featured":"featured___2hbnC","card-body":"card-body___13BXC","left":"left___3IuZp","title":"title___2jz91","seller":"seller___23oJW","date":"date___3Y4jh","featured-left":"featured-left___3-aCI","right":"right___14GH1","explore":"explore___20aW9","flag":"flag___1GRva","live":"live___13H-I","countdown":"countdown___2ufl1","ended":"ended___38HnW"};

/***/ }),

/***/ "Oq/P":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"crown":"crown___2qJ5m","crown-inner":"crown-inner___RNy0Z"};

/***/ }),

/***/ "OylW":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _modal = __webpack_require__("u90i");

var _propsComparer = __webpack_require__("wsGv");

var _propsComparer2 = _interopRequireDefault(_propsComparer);

var _redux = __webpack_require__("2KeS");

var _react = __webpack_require__("GiK3");

var _reactRedux = __webpack_require__("RH2O");

var _user = __webpack_require__("CFLi");

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouterRedux = __webpack_require__("jZgO");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EnsureLoggedInContainer = (_dec = (0, _reactRedux.connect)(function (state) {
    var userLoggedIn = (0, _user.isUserLoggedIn)(state);
    var openModal = (0, _modal.getOpenModal)(state);
    var loginModalOpen = openModal === 'LOGIN';

    return {
        loginModalOpen: loginModalOpen,
        userLoggedIn: userLoggedIn
    };
}, function (dispatch) {
    return (0, _redux.bindActionCreators)({
        openLoginModal: _modal.openLoginModal,
        push: _reactRouterRedux.push
    }, dispatch);
}), _dec(_class = (_temp = _class2 = function (_Component) {
    (0, _inherits3.default)(EnsureLoggedInContainer, _Component);

    function EnsureLoggedInContainer() {
        (0, _classCallCheck3.default)(this, EnsureLoggedInContainer);
        return (0, _possibleConstructorReturn3.default)(this, (EnsureLoggedInContainer.__proto__ || (0, _getPrototypeOf2.default)(EnsureLoggedInContainer)).apply(this, arguments));
    }

    (0, _createClass3.default)(EnsureLoggedInContainer, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            if (!this.props.userLoggedIn) {
                this.props.openLoginModal();
            }
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (!nextProps.loginModalOpen && !nextProps.userLoggedIn) {
                // From a route that requires a login, logout should send back to the homepage
                this.props.push({
                    pathname: '/'
                });
            }
        }
    }, {
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps) {
            return (0, _propsComparer2.default)(this.props, nextProps, ['children', 'loginModalOpen', 'userLoggedIn']);
        }
    }, {
        key: 'render',
        value: function render() {
            return this.props.userLoggedIn ? this.props.children : null;
        }
    }]);
    return EnsureLoggedInContainer;
}(_react.Component), _class2.defaultProps = {
    loginModalOpen: false
}, _temp)) || _class);
exports.default = EnsureLoggedInContainer;
module.exports = exports['default'];

/***/ }),

/***/ "PTSw":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _pagination = __webpack_require__("DNXl");

var _absenteeBid = __webpack_require__("5Fhj");

var _absenteeBid2 = _interopRequireDefault(_absenteeBid);

var _addCreditCard = __webpack_require__("ML/9");

var _addCreditCard2 = _interopRequireDefault(_addCreditCard);

var _analytics = __webpack_require__("yxCd");

var _analytics2 = _interopRequireDefault(_analytics);

var _autoPopModal = __webpack_require__("GvHb");

var _autoPopModal2 = _interopRequireDefault(_autoPopModal);

var _biddable = __webpack_require__("g3g9");

var _biddable2 = _interopRequireDefault(_biddable);

var _bidderExists = __webpack_require__("uien");

var _bidderExists2 = _interopRequireDefault(_bidderExists);

var _biddingInfo = __webpack_require__("m9FA");

var _biddingInfo2 = _interopRequireDefault(_biddingInfo);

var _bidHistory = __webpack_require__("vx4l");

var _bidHistory2 = _interopRequireDefault(_bidHistory);

var _bidIncrements = __webpack_require__("/Mrt");

var _bidIncrements2 = _interopRequireDefault(_bidIncrements);

var _browser = __webpack_require__("aN2S");

var _browser2 = _interopRequireDefault(_browser);

var _catalog = __webpack_require__("yv/Z");

var _catalog2 = _interopRequireDefault(_catalog);

var _catalogAd = __webpack_require__("0QM2");

var _catalogAd2 = _interopRequireDefault(_catalogAd);

var _catalogCurators = __webpack_require__("UTtJ");

var _catalogCurators2 = _interopRequireDefault(_catalogCurators);

var _catalogDetail = __webpack_require__("1mgj");

var _catalogDetail2 = _interopRequireDefault(_catalogDetail);

var _catalogLocation = __webpack_require__("oUvu");

var _catalogLocation2 = _interopRequireDefault(_catalogLocation);

var _catalogRegistration = __webpack_require__("uhYE");

var _catalogRegistration2 = _interopRequireDefault(_catalogRegistration);

var _catalogSearch = __webpack_require__("D6G4");

var _catalogSearch2 = _interopRequireDefault(_catalogSearch);

var _checkout = __webpack_require__("Ng+f");

var _checkout2 = _interopRequireDefault(_checkout);

var _redux = __webpack_require__("2KeS");

var _completeAccount = __webpack_require__("Qs/t");

var _completeAccount2 = _interopRequireDefault(_completeAccount);

var _config = __webpack_require__("iS9E");

var _config2 = _interopRequireDefault(_config);

var _confirmPassword = __webpack_require__("pOp2");

var _confirmPassword2 = _interopRequireDefault(_confirmPassword);

var _consignment = __webpack_require__("kcnD");

var _consignment2 = _interopRequireDefault(_consignment);

var _console = __webpack_require__("FSAu");

var _console2 = _interopRequireDefault(_console);

var _coverLots = __webpack_require__("fr8l");

var _coverLots2 = _interopRequireDefault(_coverLots);

var _createAccount = __webpack_require__("FneX");

var _createAccount2 = _interopRequireDefault(_createAccount);

var _emailList = __webpack_require__("CCNV");

var _emailList2 = _interopRequireDefault(_emailList);

var _errors = __webpack_require__("frA2");

var _errors2 = _interopRequireDefault(_errors);

var _fetchBatch = __webpack_require__("6OCT");

var _fetchBatch2 = _interopRequireDefault(_fetchBatch);

var _followSeller = __webpack_require__("/9SA");

var _followSeller2 = _interopRequireDefault(_followSeller);

var _forgotPassword = __webpack_require__("vOFV");

var _forgotPassword2 = _interopRequireDefault(_forgotPassword);

var _headerSearchDropdown = __webpack_require__("HxLY");

var _headerSearchDropdown2 = _interopRequireDefault(_headerSearchDropdown);

var _healthcheck = __webpack_require__("JhzB");

var _healthcheck2 = _interopRequireDefault(_healthcheck);

var _home = __webpack_require__("TSUT");

var _home2 = _interopRequireDefault(_home);

var _imageGalleryActiveImage = __webpack_require__("lp2g");

var _imageGalleryActiveImage2 = _interopRequireDefault(_imageGalleryActiveImage);

var _reactIntlRedux = __webpack_require__("Q58t");

var _item = __webpack_require__("Gk4U");

var _item2 = _interopRequireDefault(_item);

var _itemDescription = __webpack_require__("IVRy");

var _itemDescription2 = _interopRequireDefault(_itemDescription);

var _itemDetail = __webpack_require__("DAZk");

var _itemDetail2 = _interopRequireDefault(_itemDetail);

var _itemFacets = __webpack_require__("WWzX");

var _itemFacets2 = _interopRequireDefault(_itemFacets);

var _itemShipping = __webpack_require__("YcIK");

var _itemShipping2 = _interopRequireDefault(_itemShipping);

var _landingPage = __webpack_require__("1Hq4");

var _landingPage2 = _interopRequireDefault(_landingPage);

var _listingAgent = __webpack_require__("fuBz");

var _listingAgent2 = _interopRequireDefault(_listingAgent);

var _liveBid = __webpack_require__("xmqD");

var _liveBid2 = _interopRequireDefault(_liveBid);

var _liveCatalogStatus = __webpack_require__("ByEe");

var _liveCatalogStatus2 = _interopRequireDefault(_liveCatalogStatus);

var _loaded = __webpack_require__("N5um");

var _loaded2 = _interopRequireDefault(_loaded);

var _login = __webpack_require__("SpFG");

var _login2 = _interopRequireDefault(_login);

var _lostItems = __webpack_require__("Dgym");

var _lostItems2 = _interopRequireDefault(_lostItems);

var _modal = __webpack_require__("u90i");

var _modal2 = _interopRequireDefault(_modal);

var _moreItemsFromCatalogIndex = __webpack_require__("i+lj");

var _moreItemsFromCatalogIndex2 = _interopRequireDefault(_moreItemsFromCatalogIndex);

var _passwordReset = __webpack_require__("fWpZ");

var _passwordReset2 = _interopRequireDefault(_passwordReset);

var _payment = __webpack_require__("2JX2");

var _payment2 = _interopRequireDefault(_payment);

var _reduxAsyncConnect = __webpack_require__("5t3y");

var _registerForCatalog = __webpack_require__("eUWk");

var _registerForCatalog2 = _interopRequireDefault(_registerForCatalog);

var _retractBid = __webpack_require__("M0zy");

var _retractBid2 = _interopRequireDefault(_retractBid);

var _route = __webpack_require__("9NGF");

var _route2 = _interopRequireDefault(_route);

var _reactRouterRedux = __webpack_require__("jZgO");

var _savedItemCount = __webpack_require__("oIDo");

var _savedItemCount2 = _interopRequireDefault(_savedItemCount);

var _savedSearch = __webpack_require__("qWId");

var _savedSearch2 = _interopRequireDefault(_savedSearch);

var _savedSearchItem = __webpack_require__("c5lA");

var _savedSearchItem2 = _interopRequireDefault(_savedSearchItem);

var _saveItem = __webpack_require__("6oKK");

var _saveItem2 = _interopRequireDefault(_saveItem);

var _saveSearch = __webpack_require__("AwUZ");

var _saveSearch2 = _interopRequireDefault(_saveSearch);

var _saveSearchCheck = __webpack_require__("nQXN");

var _saveSearchCheck2 = _interopRequireDefault(_saveSearchCheck);

var _search = __webpack_require__("9ad9");

var _search2 = _interopRequireDefault(_search);

var _searchFacets = __webpack_require__("XTPq");

var _searchFacets2 = _interopRequireDefault(_searchFacets);

var _searchSuggestions = __webpack_require__("I7EN");

var _searchSuggestions2 = _interopRequireDefault(_searchSuggestions);

var _seller = __webpack_require__("4q18");

var _seller2 = _interopRequireDefault(_seller);

var _sellerCatalogCounts = __webpack_require__("9vxb");

var _sellerCatalogCounts2 = _interopRequireDefault(_sellerCatalogCounts);

var _sellerDetail = __webpack_require__("vi1m");

var _sellerDetail2 = _interopRequireDefault(_sellerDetail);

var _sellerEndedCatalogs = __webpack_require__("wFxa");

var _sellerEndedCatalogs2 = _interopRequireDefault(_sellerEndedCatalogs);

var _sellerRecordResults = __webpack_require__("TaFV");

var _sellerRecordResults2 = _interopRequireDefault(_sellerRecordResults);

var _sellerUpcomingCatalogs = __webpack_require__("iMUO");

var _sellerUpcomingCatalogs2 = _interopRequireDefault(_sellerUpcomingCatalogs);

var _sendSellerMessage = __webpack_require__("7IsP");

var _sendSellerMessage2 = _interopRequireDefault(_sendSellerMessage);

var _setPassword = __webpack_require__("x7tz");

var _setPassword2 = _interopRequireDefault(_setPassword);

var _shouldLogin = __webpack_require__("57qU");

var _shouldLogin2 = _interopRequireDefault(_shouldLogin);

var _similarItems = __webpack_require__("sjfW");

var _similarItems2 = _interopRequireDefault(_similarItems);

var _terms = __webpack_require__("LHJ5");

var _terms2 = _interopRequireDefault(_terms);

var _upcomingCatalogs = __webpack_require__("39qi");

var _upcomingCatalogs2 = _interopRequireDefault(_upcomingCatalogs);

var _updateAccount = __webpack_require__("A6XQ");

var _updateAccount2 = _interopRequireDefault(_updateAccount);

var _updatePassword = __webpack_require__("F213");

var _updatePassword2 = _interopRequireDefault(_updatePassword);

var _user = __webpack_require__("CFLi");

var _user2 = _interopRequireDefault(_user);

var _viewData = __webpack_require__("+NGn");

var _viewData2 = _interopRequireDefault(_viewData);

var _whiteLabel = __webpack_require__("cYj3");

var _whiteLabel2 = _interopRequireDefault(_whiteLabel);

var _windowSize = __webpack_require__("rVZG");

var _windowSize2 = _interopRequireDefault(_windowSize);

var _wonItems = __webpack_require__("V13H");

var _wonItems2 = _interopRequireDefault(_wonItems);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _redux.combineReducers)({
    config: _config2.default,
    console: _console2.default,
    domain: (0, _redux.combineReducers)({
        biddingInfo: _biddingInfo2.default,
        bidHistory: _bidHistory2.default,
        bidIncrements: _bidIncrements2.default,
        catalog: _catalog2.default,
        catalogAd: _catalogAd2.default,
        catalogCurators: _catalogCurators2.default,
        catalogDetail: _catalogDetail2.default,
        catalogLocation: _catalogLocation2.default,
        coverLots: _coverLots2.default,
        home: _home2.default,
        item: _item2.default,
        itemDetail: _itemDetail2.default,
        itemFacets: _itemFacets2.default,
        itemShipping: _itemShipping2.default,
        listingAgent: _listingAgent2.default,
        liveCatalogStatus: _liveCatalogStatus2.default,
        loaded: _loaded2.default,
        savedItemCount: _savedItemCount2.default,
        seller: _seller2.default,
        sellerCatalogCounts: _sellerCatalogCounts2.default,
        sellerDetail: _sellerDetail2.default,
        sellerEndedCatalogs: _sellerEndedCatalogs2.default,
        sellerRecordResults: _sellerRecordResults2.default,
        sellerUpcomingCatalogs: _sellerUpcomingCatalogs2.default,
        similarItems: _similarItems2.default,
        terms: _terms2.default,
        upcomingCatalogs: _upcomingCatalogs2.default
    }),
    errors: _errors2.default,
    healthcheck: _healthcheck2.default,
    intl: _reactIntlRedux.intlReducer,
    persist: (0, _redux.combineReducers)({
        headerSearchDropdown: _headerSearchDropdown2.default,
        pagination: _pagination.paginationLocalStorageReducer
    }),
    reduxAsyncConnect: _reduxAsyncConnect.reducer,
    route: _route2.default,
    routing: _reactRouterRedux.routerReducer,
    shouldLogin: _shouldLogin2.default,
    ui: (0, _redux.combineReducers)({
        absenteeBid: _absenteeBid2.default,
        addCreditCard: _addCreditCard2.default,
        analytics: _analytics2.default,
        autoPopModal: _autoPopModal2.default,
        bidderExists: _bidderExists2.default,
        browser: _browser2.default,
        catalogSearch: _catalogSearch2.default,
        checkout: _checkout2.default,
        completeAccount: _completeAccount2.default,
        confirmPassword: _confirmPassword2.default,
        consignment: _consignment2.default,
        createAccount: _createAccount2.default,
        fetchBatch: _fetchBatch2.default,
        forgotPassword: _forgotPassword2.default,
        imageGalleryActiveImage: _imageGalleryActiveImage2.default,
        itemDescription: _itemDescription2.default,
        landingPage: _landingPage2.default,
        liveBid: _liveBid2.default,
        login: _login2.default,
        lostItems: _lostItems2.default,
        modal: _modal2.default,
        moreItemsFromCatalogIndex: _moreItemsFromCatalogIndex2.default,
        pagination: _pagination.paginationCookiesReducer,
        passwordReset: _passwordReset2.default,
        payment: _payment2.default,
        retractBid: _retractBid2.default,
        saveSearch: _saveSearch2.default,
        saveSearchCheck: _saveSearchCheck2.default,
        search: _search2.default,
        searchFacets: _searchFacets2.default,
        searchSuggestions: _searchSuggestions2.default,
        sendSellerMessage: _sendSellerMessage2.default,
        setPassword: _setPassword2.default,
        terms: _terms2.default,
        updateAccount: _updateAccount2.default,
        updatePassword: _updatePassword2.default,
        viewData: _viewData2.default,
        windowSize: _windowSize2.default,
        wonItems: _wonItems2.default
    }),
    user: (0, _redux.combineReducers)({
        biddable: _biddable2.default,
        catalogRegistration: _catalogRegistration2.default,
        emailList: _emailList2.default,
        followSeller: _followSeller2.default,
        registerForCatalog: _registerForCatalog2.default,
        savedSearch: _savedSearch2.default,
        savedSearchItem: _savedSearchItem2.default,
        saveItem: _saveItem2.default,
        user: _user2.default
    }),
    whiteLabel: _whiteLabel2.default
});
module.exports = exports['default'];

/***/ }),

/***/ "Pb0h":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"body":"body___1Rfbn","links":"links___31WXV","submit":"submit___3jzX8","modalTerms":"modalTerms___150oy"};

/***/ }),

/***/ "PbAz":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = __webpack_require__("dcb+");

var _jsx3 = _interopRequireDefault(_jsx2);

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Polyfill for webpack, just in case
if (false) require.ensure = function (d, c) {
    c(require);
};

var InstallFlashModalLoader = function (_Component) {
    (0, _inherits3.default)(InstallFlashModalLoader, _Component);

    function InstallFlashModalLoader(props, context) {
        (0, _classCallCheck3.default)(this, InstallFlashModalLoader);

        var _this = (0, _possibleConstructorReturn3.default)(this, (InstallFlashModalLoader.__proto__ || (0, _getPrototypeOf2.default)(InstallFlashModalLoader)).call(this, props, context));

        _this.state = {
            Component: null,
            mounted: false
        };
        return _this;
    }

    (0, _createClass3.default)(InstallFlashModalLoader, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            var _this2 = this;

            return new _promise2.default(function (resolve) {
                __webpack_require__.e/* require.ensure */(48).then((function () {
                    resolve(__webpack_require__("R6Q/"));
                }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            }).then(function (container) {
                _this2.setState({ Component: container });
            });
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.setState({ mounted: true });
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.setState({ mounted: false });
        }
    }, {
        key: 'render',
        value: function render() {
            var _state = this.state,
                Component = _state.Component,
                mounted = _state.mounted;

            return mounted && Component !== null ? (0, _jsx3.default)(Component, {}) : null;
        }
    }]);
    return InstallFlashModalLoader;
}(_react.Component);

exports.default = InstallFlashModalLoader;
module.exports = exports['default'];

/***/ }),

/***/ "PbmM":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = __webpack_require__("dcb+");

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propsComparer = __webpack_require__("wsGv");

var _propsComparer2 = _interopRequireDefault(_propsComparer);

var _classnames = __webpack_require__("HW6M");

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _AuctioneerAddress = __webpack_require__("9iAi");

var _AuctioneerAddress2 = _interopRequireDefault(_AuctioneerAddress);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AuctioneerAddress = (_temp = _class = function (_Component) {
    (0, _inherits3.default)(AuctioneerAddress, _Component);

    function AuctioneerAddress() {
        (0, _classCallCheck3.default)(this, AuctioneerAddress);
        return (0, _possibleConstructorReturn3.default)(this, (AuctioneerAddress.__proto__ || (0, _getPrototypeOf2.default)(AuctioneerAddress)).apply(this, arguments));
    }

    (0, _createClass3.default)(AuctioneerAddress, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps) {
            return (0, _propsComparer2.default)(this.props.seller, nextProps.seller, ['address', 'address2', 'city', 'stateCode', 'zip', 'country']) || (0, _propsComparer2.default)(this.props, nextProps, ['className']);
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                className = _props.className,
                seller = _props.seller;
            var address = seller.address,
                address2 = seller.address2,
                city = seller.city,
                country = seller.country,
                stateCode = seller.stateCode,
                zip = seller.zip;


            var cityWithCommaAndSpace = city + ', ';
            var stateCodeWithSpace = stateCode + ' ';

            var addressComponents = [(0, _jsx3.default)('div', {
                className: _AuctioneerAddress2.default.one
            }, 0, address)];
            if (address2) {
                addressComponents.push((0, _jsx3.default)('div', {
                    className: _AuctioneerAddress2.default.two
                }, 1, address2));
            }
            addressComponents.push((0, _jsx3.default)('div', {
                className: _AuctioneerAddress2.default.area
            }, 2, city ? cityWithCommaAndSpace : '', stateCode ? stateCodeWithSpace : '', zip));
            addressComponents.push((0, _jsx3.default)('div', {
                className: _AuctioneerAddress2.default.country
            }, 3, country));

            var classes = (0, _classnames2.default)(_AuctioneerAddress2.default.address, className);

            return (0, _jsx3.default)('div', {
                className: classes
            }, void 0, addressComponents);
        }
    }]);
    return AuctioneerAddress;
}(_react.Component), _class.defaultProps = {
    className: ''
}, _temp);
exports.default = AuctioneerAddress;
module.exports = exports['default'];

/***/ }),

/***/ "PosD":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = __webpack_require__("dcb+");

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _windowSize = __webpack_require__("rVZG");

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _redux = __webpack_require__("2KeS");

var _reactRedux = __webpack_require__("RH2O");

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactWindowSizeListener = __webpack_require__("6VPS");

var _reactWindowSizeListener2 = _interopRequireDefault(_reactWindowSizeListener);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WindowSizeContainer = (_dec = (0, _reactRedux.connect)(function (state) {
    var windowSize = (0, _windowSize.getWindowSize)(state);
    return {
        windowHeight: windowSize.height,
        windowWidth: windowSize.width
    };
}, function (dispatch) {
    return (0, _redux.bindActionCreators)({
        setWindowSize: _windowSize.setWindowSize
    }, dispatch);
}), _dec(_class = function (_Component) {
    (0, _inherits3.default)(WindowSizeContainer, _Component);

    function WindowSizeContainer() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, WindowSizeContainer);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = WindowSizeContainer.__proto__ || (0, _getPrototypeOf2.default)(WindowSizeContainer)).call.apply(_ref, [this].concat(args))), _this), _this.onResize = function (windowSize) {
            if (_this.props.windowHeight !== windowSize.windowHeight || _this.props.windowWidth !== windowSize.windowWidth) {
                _this.props.setWindowSize({
                    height: windowSize.windowHeight,
                    width: windowSize.windowWidth
                });
            }
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(WindowSizeContainer, [{
        key: 'render',
        value: function render() {
            return (0, _jsx3.default)(_reactWindowSizeListener2.default, {
                onResize: this.onResize
            });
        }
    }]);
    return WindowSizeContainer;
}(_react.Component)) || _class);
exports.default = WindowSizeContainer;
module.exports = exports['default'];

/***/ }),

/***/ "Pv7X":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = __webpack_require__("dcb+");

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propsComparer = __webpack_require__("wsGv");

var _propsComparer2 = _interopRequireDefault(_propsComparer);

var _Mobile = __webpack_require__("S9mu");

var _Mobile2 = _interopRequireDefault(_Mobile);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Seo = __webpack_require__("vDMj");

var _Seo2 = _interopRequireDefault(_Seo);

var _LAFooter = __webpack_require__("qPVN");

var _LAFooter2 = _interopRequireDefault(_LAFooter);

var _Support = __webpack_require__("s0Az");

var _Support2 = _interopRequireDefault(_Support);

var _Trust = __webpack_require__("yMle");

var _Trust2 = _interopRequireDefault(_Trust);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LAFooter = function (_Component) {
    (0, _inherits3.default)(LAFooter, _Component);

    function LAFooter() {
        (0, _classCallCheck3.default)(this, LAFooter);
        return (0, _possibleConstructorReturn3.default)(this, (LAFooter.__proto__ || (0, _getPrototypeOf2.default)(LAFooter)).apply(this, arguments));
    }

    (0, _createClass3.default)(LAFooter, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps) {
            return (0, _propsComparer2.default)(this.props, nextProps, ['userData']);
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                baseUrl = _props.baseUrl,
                classicBaseUrl = _props.classicBaseUrl,
                openDownloadMobileModal = _props.openDownloadMobileModal,
                openHealthcheckModal = _props.openHealthcheckModal,
                userData = _props.userData;


            return (0, _jsx3.default)('div', {
                className: _LAFooter2.default.footer
            }, void 0, (0, _jsx3.default)(_Mobile2.default, {}), (0, _jsx3.default)(_Trust2.default, {}), (0, _jsx3.default)(_Seo2.default, {}), (0, _jsx3.default)(_Support2.default, {
                baseUrl: baseUrl,
                classicBaseUrl: classicBaseUrl,
                openDownloadMobileModal: openDownloadMobileModal,
                openHealthcheckModal: openHealthcheckModal,
                userData: userData
            }));
        }
    }]);
    return LAFooter;
}(_react.Component);

exports.default = LAFooter;
module.exports = exports['default'];

/***/ }),

/***/ "Q5vn":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = __webpack_require__("dcb+");

var _jsx3 = _interopRequireDefault(_jsx2);

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Polyfill for webpack, just in case
if (false) require.ensure = function (d, c) {
    c(require);
};

var LoginModalLoader = function (_Component) {
    (0, _inherits3.default)(LoginModalLoader, _Component);

    function LoginModalLoader(props, context) {
        (0, _classCallCheck3.default)(this, LoginModalLoader);

        var _this = (0, _possibleConstructorReturn3.default)(this, (LoginModalLoader.__proto__ || (0, _getPrototypeOf2.default)(LoginModalLoader)).call(this, props, context));

        _this.state = {
            Component: null,
            mounted: false
        };
        return _this;
    }

    (0, _createClass3.default)(LoginModalLoader, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            var _this2 = this;

            return new _promise2.default(function (resolve) {
                __webpack_require__.e/* require.ensure */(30).then((function () {
                    resolve(__webpack_require__("BlAi"));
                }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            }).then(function (container) {
                _this2.setState({ Component: container });
            });
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.setState({ mounted: true });
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.setState({ mounted: false });
        }
    }, {
        key: 'render',
        value: function render() {
            var _state = this.state,
                Component = _state.Component,
                mounted = _state.mounted;

            return mounted && Component !== null ? (0, _jsx3.default)(Component, {}) : null;
        }
    }]);
    return LoginModalLoader;
}(_react.Component);

exports.default = LoginModalLoader;
module.exports = exports['default'];

/***/ }),

/***/ "Q90x":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = __webpack_require__("dcb+");

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propsComparer = __webpack_require__("wsGv");

var _propsComparer2 = _interopRequireDefault(_propsComparer);

var _classnames = __webpack_require__("HW6M");

var _classnames2 = _interopRequireDefault(_classnames);

var _noop = __webpack_require__("9vKl");

var _noop2 = _interopRequireDefault(_noop);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _slider = __webpack_require__("kAUe");

var _slider2 = _interopRequireDefault(_slider);

var _SliderArrow = __webpack_require__("Kn4k");

var _SliderArrow2 = _interopRequireDefault(_SliderArrow);

var _Carousel = __webpack_require__("ssAn");

var _Carousel2 = _interopRequireDefault(_Carousel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DEFAULT_NUMBER_OF_ITEMS_TO_SHOW = 4;

var Carousel = (_temp = _class = function (_Component) {
    (0, _inherits3.default)(Carousel, _Component);

    function Carousel() {
        (0, _classCallCheck3.default)(this, Carousel);
        return (0, _possibleConstructorReturn3.default)(this, (Carousel.__proto__ || (0, _getPrototypeOf2.default)(Carousel)).apply(this, arguments));
    }

    (0, _createClass3.default)(Carousel, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps) {
            return (0, _propsComparer2.default)(this.props, nextProps, ['children', 'className', 'index']);
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps) {
            if (prevProps.index !== this.props.index) {
                this.slider.slickGoTo(this.props.index);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                afterChange = _props.afterChange,
                children = _props.children,
                className = _props.className,
                index = _props.index;

            // don't draw the carousel if we've got nothing to draw

            if (!children) {
                return null;
            }

            var settings = {
                afterChange: afterChange,
                dots: false,
                infinite: true,
                initialSlide: index,
                lazyLoad: true, // DONT CHANGE THIS - SHOULD BE `TRUE`.
                nextArrow: (0, _jsx3.default)(_SliderArrow2.default, {
                    next: true,
                    className: _Carousel2.default.next
                }),
                prevArrow: (0, _jsx3.default)(_SliderArrow2.default, {
                    prev: true,
                    className: _Carousel2.default.prev
                }),
                ref: function ref(slider) {
                    _this2.slider = slider;
                },
                responsive: [{ breakpoint: 992, settings: { slidesToScroll: 3, slidesToShow: 3 } }, { breakpoint: 768, settings: { slidesToScroll: 2, slidesToShow: 2 } }, { breakpoint: 320, settings: { slidesToScroll: 1, slidesToShow: 1 } }],
                slidesToScroll: DEFAULT_NUMBER_OF_ITEMS_TO_SHOW,
                slidesToShow: DEFAULT_NUMBER_OF_ITEMS_TO_SHOW
            };

            var classes = (0, _classnames2.default)(_Carousel2.default.carousel, className);

            return (0, _jsx3.default)('div', {
                className: classes
            }, void 0, _react2.default.createElement(
                _slider2.default,
                settings,
                children
            ));
        }
    }]);
    return Carousel;
}(_react.Component), _class.defaultProps = {
    afterChange: _noop2.default
}, _temp);
exports.default = Carousel;
module.exports = exports['default'];

/***/ }),

/***/ "QJRV":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = __webpack_require__("dcb+");

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propsComparer = __webpack_require__("wsGv");

var _propsComparer2 = _interopRequireDefault(_propsComparer);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AddThis = (_temp2 = _class = function (_Component) {
    (0, _inherits3.default)(AddThis, _Component);

    function AddThis() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, AddThis);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = AddThis.__proto__ || (0, _getPrototypeOf2.default)(AddThis)).call.apply(_ref, [this].concat(args))), _this), _this.initializeAddThis = function () {
            /* eslint-disable no-undef */
            if (typeof addthis !== 'undefined' && addthis.init) {
                addthis.init();
                addthis.toolbox('.share_button_wrapper');
            } else {
                _this.shareWrapper.style.display = 'none';
            }
            /* eslint-enable no-undef */
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(AddThis, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.initializeAddThis();
        }
    }, {
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps) {
            return (0, _propsComparer2.default)(this.props, nextProps, ['className', 'itemTitle', 'itemUrl']);
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps) {
            if (this.props.itemTitle !== prevProps.itemTitle) {
                this.initializeAddThis();
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                className = _props.className,
                itemTitle = _props.itemTitle,
                itemUrl = _props.itemUrl;


            return _react2.default.createElement(
                'div',
                {
                    ref: function ref(share) {
                        _this2.shareWrapper = share;
                    },
                    className: 'share_button_wrapper ' + (className || ''),
                    'data-addthis-title': itemTitle,
                    'data-addthis-url': itemUrl
                },
                (0, _jsx3.default)('a', {
                    className: 'addthis_button_email share-button'
                }),
                (0, _jsx3.default)('a', {
                    className: 'addthis_button_pinterest_share share-button'
                }),
                (0, _jsx3.default)('a', {
                    className: 'addthis_button_facebook share-button'
                }),
                (0, _jsx3.default)('a', {
                    className: 'addthis_button_twitter share-button'
                })
            );
        }
    }]);
    return AddThis;
}(_react.Component), _class.defaultProps = {
    className: '',
    itemTitle: '',
    itemUrl: ''
}, _temp2);
exports.default = AddThis;
module.exports = exports['default'];

/***/ }),

/***/ "QJZ2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = __webpack_require__("dcb+");

var _jsx3 = _interopRequireDefault(_jsx2);

var _toConsumableArray2 = __webpack_require__("Gu7T");

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _components = __webpack_require__("bGai");

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propsComparer = __webpack_require__("wsGv");

var _propsComparer2 = _interopRequireDefault(_propsComparer);

var _dates = __webpack_require__("TbAp");

var _reactIntl = __webpack_require__("Pq8k");

var _urls = __webpack_require__("CakR");

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _safelyRender = __webpack_require__("YLee");

var _safelyRender2 = _interopRequireDefault(_safelyRender);

var _live = __webpack_require__("o2ZH");

var _HorizontalCatalogCard = __webpack_require__("z0Eu");

var _HorizontalCatalogCard2 = _interopRequireDefault(_HorizontalCatalogCard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HorizontalCatalogCard = (_temp2 = _class = function (_Component) {
    (0, _inherits3.default)(HorizontalCatalogCard, _Component);

    function HorizontalCatalogCard() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, HorizontalCatalogCard);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = HorizontalCatalogCard.__proto__ || (0, _getPrototypeOf2.default)(HorizontalCatalogCard)).call.apply(_ref, [this].concat(args))), _this), _this.limitDescription = function (description) {
            if (description && description.length > 139) {
                description = description.slice(0, 139).trim() + '\u2026';
            }
            return (0, _safelyRender2.default)(description);
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(HorizontalCatalogCard, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps) {
            return (0, _propsComparer2.default)(this.props, nextProps, ['className', 'featured', 'cardViewModel']);
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                cardViewModel = _props.cardViewModel,
                className = _props.className,
                featured = _props.featured;
            var catalog = cardViewModel.catalog,
                coverLots = cardViewModel.coverLots,
                seller = cardViewModel.seller;

            var _ref2 = catalog || {},
                catalogId = _ref2.catalogId,
                catalogStatus = _ref2.catalogStatus,
                description = _ref2.description,
                isCatalogOnly = _ref2.isCatalogOnly,
                saleStartTs = _ref2.saleStartTs,
                title = _ref2.title;

            var _ref3 = seller || {},
                sellerId = _ref3.sellerId;

            var classes = [].concat((0, _toConsumableArray3.default)(className.split(' ')), [_HorizontalCatalogCard2.default['catalog-card']]).join(' ').trim();

            var coverLotsClasses = featured ? _HorizontalCatalogCard2.default.featured + ' ' + _HorizontalCatalogCard2.default['cover-lots'] : _HorizontalCatalogCard2.default['cover-lots'];
            var startDate = (0, _dates.catalogLongCardDate)(saleStartTs);
            var catalogUrl = (0, _urls.getCatalogUrl)(catalogId, title);

            var showLiveButton = (0, _live.shouldShowLive)(catalogStatus, isCatalogOnly, saleStartTs);

            return (0, _jsx3.default)('div', {
                className: classes
            }, void 0, (0, _jsx3.default)('div', {
                className: _HorizontalCatalogCard2.default['card-body']
            }, void 0, (0, _jsx3.default)('div', {
                className: _HorizontalCatalogCard2.default.left
            }, void 0, (0, _jsx3.default)(_components.CoverLots, {
                catalogId: catalogId,
                catalogUrl: catalogUrl,
                className: coverLotsClasses,
                coverLots: coverLots,
                featured: featured,
                sellerId: sellerId
            })), (0, _jsx3.default)('div', {
                className: _HorizontalCatalogCard2.default.middle
            }, void 0, (0, _jsx3.default)('div', {
                className: _HorizontalCatalogCard2.default.title
            }, void 0, (0, _jsx3.default)(_components.Link, {
                route: true,
                to: catalogUrl,
                primary: true
            }, void 0, title)), (0, _jsx3.default)('div', {
                className: _HorizontalCatalogCard2.default.description
            }, void 0, (0, _jsx3.default)(_components.Link, {
                route: true,
                to: catalogUrl,
                primaryWeak: true
            }, void 0, this.limitDescription(description)))), (0, _jsx3.default)('div', {
                className: _HorizontalCatalogCard2.default.right
            }, void 0, (0, _jsx3.default)('div', {
                className: _HorizontalCatalogCard2.default['start-date']
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'starts',
                values: { startDate: startDate }
            })), showLiveButton ? (0, _jsx3.default)('div', {
                className: _HorizontalCatalogCard2.default['live-link-container']
            }, void 0, (0, _jsx3.default)(_components.BidConsoleOpener, {
                catalogId: catalogId,
                sellerId: sellerId
            }, void 0, (0, _jsx3.default)('span', {
                className: _HorizontalCatalogCard2.default.live
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'live_auction'
            })))) : !isCatalogOnly && (0, _jsx3.default)(_components.CatalogDate, {
                className: _HorizontalCatalogCard2.default.countdown,
                date: saleStartTs
            }), (0, _jsx3.default)(_components.ButtonLink, {
                url: catalogUrl,
                className: _HorizontalCatalogCard2.default.explore
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'explore'
            })), (0, _jsx3.default)(_components.RegisterLinkContainer, {
                className: _HorizontalCatalogCard2.default['register-link'],
                catalogId: catalogId,
                isCatalogOnly: isCatalogOnly
            }))));
        }
    }]);
    return HorizontalCatalogCard;
}(_react.Component), _class.defaultProps = {
    cardViewModel: {},
    className: '',
    featured: false
}, _temp2);
exports.default = HorizontalCatalogCard;
module.exports = exports['default'];

/***/ }),

/***/ "QMRE":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SimilarItemsRemote = undefined;

var _stringify = __webpack_require__("mvHQ");

var _stringify2 = _interopRequireDefault(_stringify);

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _helpers = __webpack_require__("SY39");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SimilarItemsRemote = exports.SimilarItemsRemote = {
    fetchSimilarItems: function fetchSimilarItems(_ref) {
        var authToken = _ref.authToken,
            deployment = _ref.deployment,
            similarItemInfo = _ref.similarItemInfo;
        return new _promise2.default(function (resolve, reject) {
            var params = {
                boostFields: ['houseid:' + similarItemInfo.sellerId + '^2.5'],
                options: {
                    status: ['upcoming', 'live', 'online']
                },
                pageSize: 16,
                searchTerm: similarItemInfo.title
            };
            var encodedParams = encodeURIComponent((0, _stringify2.default)(params));
            var encodedIds = encodeURIComponent((0, _stringify2.default)(similarItemInfo.categoryIds));

            var request = (0, _helpers.makeGet)('<SEARCH-API>?ids=' + encodedIds + '&parameters=' + encodedParams, deployment, 'similaritems');
            (0, _helpers.addAuthToken)(request, authToken);
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response });
            });
        });
    }
};

/***/ }),

/***/ "QmSG":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var deployment = Object({"NODE_ENV":"production"}).DEPLOYMENT || 'preprod';
var baseUrl = deployment === 'prod' || deployment === 'pc' ? 'https://www.liveauctioneers.com' : 'https://' + deployment + '-test.liveauctioneers.com';
var classicBaseUrl = deployment === 'prod' || deployment === 'pc' ? 'https://classic.liveauctioneers.com' : 'https://mainhost-' + deployment + '.liveauctioneers.com';
var segmentWriteKey = deployment === 'prod' || deployment === 'pc' ? 'HoHgffZL05YMRQr7OAzt1zyzp9ySNQnq' : '2VVBXTAj8OAmELKqpJhQBVy8wxquVSE5';
var buildNumber = Object({"NODE_ENV":"production"}).BUILD;
var cachekey = 20170802; // change to break cache.
var pubNubSubscribeKey = deployment === 'prod' || deployment === 'pc' || deployment === 'preprod' ? 'sub-c-afcdf614-eb2a-11e7-acf8-26f7716e5467' : 'sub-c-3bc9bd46-1c28-11e8-bb29-5a43d096f02f';
var stripePublishKey = deployment === 'prod' || deployment === 'pc' || deployment === 'preprod' ? 'pk_live_IQCt8ISLv0ih1YlxIWoMbiCs' : 'pk_test_h4oTIGGE4a5mKDPRz8H0gkFT';

var baseCuratorImgUrl = 'https://s3.amazonaws.com/images.liveauctioneers.com/curators';
var curatorImgUrl = deployment === 'prod' || deployment === 'pc' || deployment === 'preprod' ? baseCuratorImgUrl : baseCuratorImgUrl + '/stage';

var referralCandy = {
    houseIdForReferrals: 5584,
    id: 'gxctnclfwvd0gv4bazqhums4c',
    secret: '791390824dbf598938847ebaf55cf85c'
};

module.exports = {
    auctionHouseSize: 3,
    baseUrl: baseUrl,
    buildNumber: buildNumber,
    cachekey: cachekey,
    classicBaseUrl: classicBaseUrl,
    curatorImgUrl: curatorImgUrl,
    deployment: deployment,
    giveRawResults: true,
    googleApiKey: 'AIzaSyBuqhxwHg5xqsBxp2Wnv0TlptXduChjwOw',
    host: Object({"NODE_ENV":"production"}).HOST || 'localhost',
    port: Object({"NODE_ENV":"production"}).PORT || 3000,
    pubNubSubscribeKey: pubNubSubscribeKey,
    querySize: 6,
    referralCandy: referralCandy,
    sailthruCustomerId: '3ae424afe5d152e7a420ba8614f4ba16',
    segmentWriteKey: segmentWriteKey,
    soastaMPulseApiKey: 'P4TR8-DZB39-665FZ-Q5A4W-7K7EB',
    stripePublishKey: stripePublishKey
};

/***/ }),

/***/ "Qs/t":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.submitCompleteAccount = exports.getUiCompleteAccount = exports.COMPLETE_ACCOUNT_SUCCESS = exports.COMPLETE_ACCOUNT_REQUEST = exports.COMPLETE_ACCOUNT_FAIL = undefined;

var _regenerator = __webpack_require__("Xxa5");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__("exGp");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;

var _user = __webpack_require__("CFLi");

var _api = __webpack_require__("zFQO");

var _reselect = __webpack_require__("bndy");

var _modal = __webpack_require__("u90i");

var _analytics = __webpack_require__("yxCd");

var _config = __webpack_require__("iS9E");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Action Types */
var COMPLETE_ACCOUNT_FAIL = exports.COMPLETE_ACCOUNT_FAIL = 'la/ui/completeAccount/FAIL';
var COMPLETE_ACCOUNT_REQUEST = exports.COMPLETE_ACCOUNT_REQUEST = 'la/ui/completeAccount/REQUEST';
var COMPLETE_ACCOUNT_SUCCESS = exports.COMPLETE_ACCOUNT_SUCCESS = 'la/ui/completeAccount/SUCCESS';

// reducer
var DEFAULT_STATE = {
    error: false,
    submitted: false,
    success: false
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        case _modal.DISMISS_MODAL:
            return (0, _extends3.default)({}, state, {
                error: false,
                submitted: false,
                success: false
            });
        case COMPLETE_ACCOUNT_FAIL:
            return (0, _extends3.default)({}, state, {
                error: true,
                submitted: false,
                success: false
            });
        case COMPLETE_ACCOUNT_REQUEST:
            return (0, _extends3.default)({}, state, {
                submitted: true,
                success: false
            });
        case COMPLETE_ACCOUNT_SUCCESS:
            return (0, _extends3.default)({}, state, {
                submitted: false,
                success: true
            });
        default:
            return state;
    }
}

/* SELECTORS */
var stateSelector = function stateSelector(state) {
    return state.ui.completeAccount;
};

var getUiCompleteAccount = exports.getUiCompleteAccount = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state;
});

/* ACTION CREATORS */
var submitCompleteAccount = exports.submitCompleteAccount = function submitCompleteAccount(userDetails) {
    return function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch, getState) {
            var state, authToken, deployment, userData, response;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.prev = 0;
                            state = getState();
                            authToken = (0, _user.getAuthToken)(state);
                            deployment = (0, _config.getDeployment)(state);
                            userData = (0, _user.getUserData)(state);

                            userDetails.email = (0, _user.getBidderEmail)(state);
                            userDetails.username = userData.username;
                            dispatch({
                                type: COMPLETE_ACCOUNT_REQUEST
                            });
                            _context.next = 10;
                            return _api.Bidder.postCompleteAccount({
                                authToken: authToken,
                                bidderDetails: userDetails,
                                deployment: deployment
                            });

                        case 10:
                            response = _context.sent;

                            dispatch({
                                meta: (0, _extends3.default)({}, (0, _analytics.getCompleteAccountAnalytics)(), { actionTime: Date.now() }),
                                payload: response,
                                type: COMPLETE_ACCOUNT_SUCCESS
                            });
                            _context.next = 17;
                            break;

                        case 14:
                            _context.prev = 14;
                            _context.t0 = _context['catch'](0);

                            dispatch({
                                error: true,
                                payload: _context.t0,
                                type: COMPLETE_ACCOUNT_FAIL
                            });

                        case 17:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, undefined, [[0, 14]]);
        }));

        return function (_x3, _x4) {
            return _ref.apply(this, arguments);
        };
    }();
};

/***/ }),

/***/ "Qv2C":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"bid-status":"bid-status___35hUA","leading":"leading___1Fl87","warning":"warning___3BOCD","pending":"pending___Scm9Z"};

/***/ }),

/***/ "RB4q":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SimilarItemsMock = undefined;

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _mockData = __webpack_require__("6VmH");

var _delay = __webpack_require__("kRHc");

var _delay2 = _interopRequireDefault(_delay);

var _union = __webpack_require__("gszD");

var _union2 = _interopRequireDefault(_union);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SimilarItemsMock = exports.SimilarItemsMock = {
    fetchSimilarItems: function fetchSimilarItems(similarItemInfo) {
        return new _promise2.default(function (resolve) {
            setTimeout(function () {
                var similarItemIds = _mockData.mockSimilarItems.filter(function (x) {
                    return x.itemId === similarItemInfo.itemId;
                });
                var items = similarItemIds[0].similarItems.map(function (x) {
                    return (0, _mockData.getTestItem)(x);
                });
                var biddingInfos = [];
                var bidIncrements = [];
                var catalogs = [];
                var sellers = [];

                items.forEach(function (item) {
                    biddingInfos = (0, _union2.default)(biddingInfos, [(0, _mockData.getTestBiddingInfoForItem)(item.itemId)]);
                    bidIncrements = (0, _union2.default)(bidIncrements, [(0, _mockData.getTestBidIncrementForCatalog)(item.catalogId)]);
                    catalogs = (0, _union2.default)(catalogs, [(0, _mockData.getTestCatalog)(item.catalogId)]);
                    sellers = (0, _union2.default)(sellers, [(0, _mockData.getTestSeller)(item.sellerId)]);
                });
                resolve({
                    data: {
                        biddingInfos: biddingInfos,
                        bidIncrements: bidIncrements,
                        catalogs: catalogs,
                        items: items,
                        sellers: sellers
                    }
                });
            }, _delay2.default);
        });
    }
};

/***/ }),

/***/ "RIJi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"tags":"tags___3xfie","tag":"tag___3RKEn","tag-link":"tag-link___1vUAN","red-tag":"red-tag___3gmMs","blue-tag":"blue-tag___3WI-O","orange-tag":"orange-tag___3l23O","green-tag":"green-tag___ykZS7","purple-tag":"purple-tag___7i6o6"};

/***/ }),

/***/ "S9mu":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = __webpack_require__("dcb+");

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__("Pq8k");

var _Mobile = __webpack_require__("rWG9");

var _Mobile2 = _interopRequireDefault(_Mobile);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Mobile = function (_PureComponent) {
    (0, _inherits3.default)(Mobile, _PureComponent);

    function Mobile() {
        (0, _classCallCheck3.default)(this, Mobile);
        return (0, _possibleConstructorReturn3.default)(this, (Mobile.__proto__ || (0, _getPrototypeOf2.default)(Mobile)).apply(this, arguments));
    }

    (0, _createClass3.default)(Mobile, [{
        key: 'render',
        value: function render() {
            return (0, _jsx3.default)('div', {
                className: _Mobile2.default.mobile
            }, void 0, (0, _jsx3.default)('img', {
                src: 'https://p1.liveauctioneers.com/dist/images/IPhone_Small.png',
                alt: 'mobile'
            }), (0, _jsx3.default)('span', {
                className: _Mobile2.default.header
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'bid_anywhere_anytime'
            })), (0, _jsx3.default)('a', {
                className: _Mobile2.default['app-store-link'] + ' ' + _Mobile2.default.ios,
                href: 'https://itunes.apple.com/us/app/live-auctions/id321243082',
                target: 'blank',
                title: 'Available on the App Store'
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'available_on_the_app_store'
            })), (0, _jsx3.default)('a', {
                className: _Mobile2.default['app-store-link'] + ' ' + _Mobile2.default.android,
                href: 'https://play.google.com/store/apps/details?id=com.liveauctioneers.and',
                target: 'blank',
                title: 'Android App on Google Play'
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'android_app_on_google_play'
            })));
        }
    }]);
    return Mobile;
}(_react.PureComponent);

exports.default = Mobile;
module.exports = exports['default'];

/***/ }),

/***/ "SCYO":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = __webpack_require__("dcb+");

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propsComparer = __webpack_require__("wsGv");

var _propsComparer2 = _interopRequireDefault(_propsComparer);

var _reactIntl = __webpack_require__("Pq8k");

var _isEmpty = __webpack_require__("lHK6");

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _preventDefault = __webpack_require__("/lBP");

var _preventDefault2 = _interopRequireDefault(_preventDefault);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _CardStatusBanner = __webpack_require__("Qv2C");

var _CardStatusBanner2 = _interopRequireDefault(_CardStatusBanner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CardStatusBanner = (_temp2 = _class = function (_Component) {
    (0, _inherits3.default)(CardStatusBanner, _Component);

    function CardStatusBanner() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, CardStatusBanner);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = CardStatusBanner.__proto__ || (0, _getPrototypeOf2.default)(CardStatusBanner)).call.apply(_ref, [this].concat(args))), _this), _this.onClick = _preventDefault2.default, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(CardStatusBanner, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps) {
            return (0, _propsComparer2.default)(this.props.catalogRegistration, nextProps.catalogRegistration, ['declined', 'pending']) || (0, _propsComparer2.default)(this.props.item, nextProps.item, ['isAvailable', 'isPassed']) || (0, _propsComparer2.default)(this.props.biddingInfo, nextProps.biddingInfo, ['bidderHasHighBid', 'isReserveMet']);
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                biddingInfo = _props.biddingInfo,
                catalogRegistration = _props.catalogRegistration,
                item = _props.item;
            var bidderHasHighBid = biddingInfo.bidderHasHighBid,
                isReserveMet = biddingInfo.isReserveMet;


            if ((0, _isEmpty2.default)(biddingInfo)) {
                return null;
            }

            var blockedByAuctioneer = catalogRegistration.blockedByAuctioneer,
                declined = catalogRegistration.declined,
                pending = catalogRegistration.pending,
                suspended = catalogRegistration.suspended;
            var isAvailable = item.isAvailable,
                isPassed = item.isPassed;


            var statusMessageClass = '';
            var statusMessage = '';

            if (declined) {
                statusMessage = 'registration_declined';
                statusMessageClass = _CardStatusBanner2.default.pending;
            } else if (blockedByAuctioneer || suspended) {
                statusMessage = 'account_suspended';
                statusMessageClass = _CardStatusBanner2.default.pending;
            } else if (isAvailable) {
                if (pending) {
                    statusMessage = 'pending_approval';
                    statusMessageClass = _CardStatusBanner2.default.pending;
                } else if (bidderHasHighBid && isReserveMet) {
                    statusMessage = 'you_are_leading';
                    statusMessageClass = _CardStatusBanner2.default.leading;
                } else if (bidderHasHighBid && !isReserveMet) {
                    statusMessage = 'reserve_not_met';
                    statusMessageClass = _CardStatusBanner2.default.warning;
                } else {
                    statusMessage = 'outbid';
                    statusMessageClass = _CardStatusBanner2.default.warning;
                }
            } else if (isPassed) {
                if (pending) {
                    statusMessage = 'not_approved';
                    statusMessageClass = _CardStatusBanner2.default.pending;
                } else {
                    statusMessage = 'lot_passed';
                    statusMessageClass = _CardStatusBanner2.default.warning;
                }
            } else if (bidderHasHighBid) {
                statusMessage = 'you_won';
                statusMessageClass = _CardStatusBanner2.default.leading;
            } else {
                statusMessage = 'lost';
                statusMessageClass = _CardStatusBanner2.default.warning;
            }

            return (0, _jsx3.default)('div', {
                onClick: this.onClick,
                className: _CardStatusBanner2.default['bid-status'] + ' ' + statusMessageClass
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: statusMessage
            }));
        }
    }]);
    return CardStatusBanner;
}(_react.Component), _class.defaultProps = {
    biddingInfo: {},
    catalogRegistration: {},
    item: {}
}, _temp2);
exports.default = CardStatusBanner;
module.exports = exports['default'];

/***/ }),

/***/ "SWTO":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__("GiK3");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Sentry = function (_PureComponent) {
    (0, _inherits3.default)(Sentry, _PureComponent);

    function Sentry() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, Sentry);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Sentry.__proto__ || (0, _getPrototypeOf2.default)(Sentry)).call.apply(_ref, [this].concat(args))), _this), _this.initializeSentry = function () {
            /* eslint-disable no-undef */
            if (typeof Raven !== 'undefined') {
                Raven.config('https://fa7392f08ad44440a81d103b44e5b2aa@sentry.io/203557').install();
            }
            /* eslint-enable no-undef */
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(Sentry, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.initializeSentry();
        }
    }, {
        key: 'render',
        value: function render() {
            return null;
        }
    }]);
    return Sentry;
}(_react.PureComponent);

exports.default = Sentry;
module.exports = exports['default'];

/***/ }),

/***/ "SY39":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.makePut = exports.makePost = exports.makeGet = exports.makeDelete = exports.buildUrl = exports.handleResponseUseItemApiError = exports.handleResponse = exports.addAuthToken = undefined;

var _config = __webpack_require__("QmSG");

var _superagent = __webpack_require__("GG98");

var _superagent2 = _interopRequireDefault(_superagent);

var _uuid = __webpack_require__("DlMc");

var _uuid2 = _interopRequireDefault(_uuid);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var backupKey = _uuid2.default.v4();

var addAuthToken = exports.addAuthToken = function addAuthToken(request, authToken) {
    if (authToken) {
        request.set('Authorization', 'Bearer ' + authToken);
    }
};

var handleResponse = exports.handleResponse = function handleResponse(_ref) {
    var err = _ref.err,
        reject = _ref.reject,
        resolve = _ref.resolve,
        _ref$response = _ref.response,
        response = _ref$response === undefined ? {} : _ref$response,
        success404 = _ref.success404,
        transform = _ref.transform;

    // If there is a server level error, reject the promise
    if (err) {
        if (success404 && err.status === 404) {
            resolve(response.body || {});
        }
        return reject(err);
    }

    var body = response.body || {};
    if (transform) {
        body = transform(body);
    }

    // If the successa and message properties are set in body (item-api response)
    // but success is falsy, reject the promise
    if ('success' in body && 'message' in body && !body.success) {
        return reject(body.message);
    }

    // If the success property is set in body but is falsy, reject the promise
    // Might be some sort of lambda (Flynn)
    if ('success' in body && !body.success) {
        return reject(body);
    }

    // else
    return resolve(body);
};

var handleResponseUseItemApiError = exports.handleResponseUseItemApiError = function handleResponseUseItemApiError(_ref2) {
    var err = _ref2.err,
        reject = _ref2.reject,
        resolve = _ref2.resolve,
        _ref2$response = _ref2.response,
        response = _ref2$response === undefined ? {} : _ref2$response,
        success404 = _ref2.success404,
        transform = _ref2.transform;

    // If there is a server level error, reject the promise
    if (err) {
        if (success404 && err.status === 404) {
            resolve(response.body || {});
        }
        return reject(err);
    }

    var body = response.body || {};
    if (transform) {
        body = transform(body);
    }

    // If the successa and message properties are set in body (item-api response)
    // but success is falsy, reject the promise
    if ('success' in body && 'error' in body && !body.success) {
        return reject(body.error);
    }

    // If the success property is set in body but is falsy, reject the promise
    // Might be some sort of lambda (Flynn)
    if ('success' in body && !body.success) {
        return reject(body);
    }

    // else
    return resolve(body);
};

var addCacheKey = function addCacheKey(request) {
    var c = _config.cachekey;
    if (!_config.cachekey) {
        c = backupKey;
    }
    request.query({ c: c });
    return request;
};

var hosts = [{
    path: '<ITEM-API>',
    url: 'https://item-api-DEPLOYMENT.liveauctioneers.com/'
}, {
    path: '<CLERK-SERVICE>',
    url: 'https://dante-DEPLOYMENT.liveauctioneers.com/'
}, {
    path: '<MAINHOST-API>',
    url: 'https://mainhost-DEPLOYMENT.liveauctioneers.com/'
}, {
    path: '<SAVED-SEARCH-API>',
    url: 'https://savedsearch-DEPLOYMENT.liveauctioneers.com/api/savedsearch/'
}, {
    path: '<SEARCH-API>',
    url: 'https://api.liveauctioneers.com/search/APIPATH/DEPLOYMENT'
}, {
    path: '<ESCROW-API>',
    url: 'https://api.liveauctioneers.com/escrow/APIPATH/DEPLOYMENT'
}, {
    path: '<USER-API>',
    url: 'https://api.liveauctioneers.com/user/APIPATH/DEPLOYMENT'
}];

var buildUrl = exports.buildUrl = function buildUrl(path, deployment, apiPath) {
    var updatedPath = path;
    hosts.forEach(function (obj) {
        if (path.includes(obj.path)) {
            var url = obj.url.replace('DEPLOYMENT', deployment);
            updatedPath = path.replace(obj.path, url);
            updatedPath = updatedPath.replace('APIPATH', apiPath);
        }
    });
    return updatedPath;
};

var makeDelete = exports.makeDelete = function makeDelete(path, deployment, apiPath) {
    var request = _superagent2.default.delete(buildUrl(path, deployment, apiPath));
    addCacheKey(request);
    return request;
};

var makeGet = exports.makeGet = function makeGet(path, deployment, apiPath) {
    var request = _superagent2.default.get(buildUrl(path, deployment, apiPath));
    addCacheKey(request);
    return request;
};

var makePost = exports.makePost = function makePost(path, deployment, apiPath) {
    var request = _superagent2.default.post(buildUrl(path, deployment, apiPath));
    addCacheKey(request);
    return request;
};

var makePut = exports.makePut = function makePut(path, deployment, apiPath) {
    var request = _superagent2.default.put(buildUrl(path, deployment, apiPath));
    addCacheKey(request);
    return request;
};

/***/ }),

/***/ "SpFG":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.submitLogin = exports.getUiLogin = exports.LOGIN_SUCCESS = exports.LOGIN_REQUEST = exports.LOGIN_FAIL = undefined;

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;

var _modal = __webpack_require__("u90i");

var _api = __webpack_require__("zFQO");

var _reselect = __webpack_require__("bndy");

var _item = __webpack_require__("Gk4U");

var _config = __webpack_require__("iS9E");

var _analytics = __webpack_require__("yxCd");

var _saveItem = __webpack_require__("6oKK");

var _shouldLogin = __webpack_require__("57qU");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Action Types */
var LOGIN_FAIL = exports.LOGIN_FAIL = 'LOGIN_FAIL';
var LOGIN_REQUEST = exports.LOGIN_REQUEST = 'LOGIN_REQUEST';
var LOGIN_SUCCESS = exports.LOGIN_SUCCESS = 'LOGIN_SUCCESS';

/* reducer */
var DEFAULT_STATE = {
    error: false,
    errorMessage: '',
    submitted: false,
    success: false
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        case LOGIN_FAIL:
            return (0, _extends3.default)({}, state, {
                error: true,
                errorMessage: action.payload.message,
                submitted: false,
                success: false
            });
        case LOGIN_REQUEST:
            return (0, _extends3.default)({}, state, {
                error: false,
                errorMessage: '',
                submitted: true,
                success: false
            });
        case LOGIN_SUCCESS:
            return (0, _extends3.default)({}, state, {
                submitted: false,
                success: true
            });
        case _modal.OPEN_LOGIN_MODAL:
        case _shouldLogin.OPEN_LOGIN_MODAL_FROM_CHECKER:
            return (0, _extends3.default)({}, state, {
                error: false,
                errorMessage: '',
                submitted: false,
                success: false
            });
        default:
            return state;
    }
}

/* SELECTORS */
var stateSelector = function stateSelector(state) {
    return state.ui.login;
};

var getUiLogin = exports.getUiLogin = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state;
});

/* ACTION CREATORS */
var loginFail = function loginFail(emailAddress, error) {
    return {
        error: true,
        meta: { emailAddress: emailAddress },
        payload: error,
        type: LOGIN_FAIL
    };
};

var loginRequest = function loginRequest(emailAddress) {
    return {
        payload: emailAddress,
        type: LOGIN_REQUEST
    };
};

var loginSuccess = function loginSuccess(loginData) {
    return {
        meta: (0, _extends3.default)({}, (0, _analytics.getLoginAnalytics)(loginData), { actionTime: Date.now() }),
        payload: loginData,
        type: LOGIN_SUCCESS
    };
};

var submitLogin = exports.submitLogin = function submitLogin(emailAddress, password) {
    var mainhostLogin = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    return function (dispatch, getState) {
        var state = getState();
        var deployment = (0, _config.getDeployment)(state);
        var username = emailAddress || mainhostLogin.authNuid;
        dispatch(loginRequest(username));
        return _api.Bidder.postLogin({ deployment: deployment, mainhostLogin: mainhostLogin, password: password, username: username }).then(function (response) {
            dispatch((0, _modal.completeLoginModal)());
            return _promise2.default.all([dispatch(loginSuccess(response.data))]).then(function () {
                var state2 = getState();
                var savedItemIds = (0, _saveItem.getSortedSavedItemIdsFromState)(state2);
                return _promise2.default.all([dispatch((0, _item.fetchItemsIfNeeded)(savedItemIds))]);
            });
        }).catch(function (error) {
            dispatch(loginFail(emailAddress, error));
        });
    };
};

/***/ }),

/***/ "Sr01":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = createLogger;

var _reduxLogger = __webpack_require__("oSVy");

function createLogger(shouldLog) {
    return (0, _reduxLogger.createLogger)({
        collapsed: true,
        predicate: shouldLog ? null : false
    });
}
module.exports = exports['default'];

/***/ }),

/***/ "TFOM":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = __webpack_require__("dcb+");

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propsComparer = __webpack_require__("wsGv");

var _propsComparer2 = _interopRequireDefault(_propsComparer);

var _classnames = __webpack_require__("HW6M");

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ModalHeader = __webpack_require__("imzI");

var _ModalHeader2 = _interopRequireDefault(_ModalHeader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ModalHeader = (_temp = _class = function (_Component) {
    (0, _inherits3.default)(ModalHeader, _Component);

    function ModalHeader() {
        (0, _classCallCheck3.default)(this, ModalHeader);
        return (0, _possibleConstructorReturn3.default)(this, (ModalHeader.__proto__ || (0, _getPrototypeOf2.default)(ModalHeader)).apply(this, arguments));
    }

    (0, _createClass3.default)(ModalHeader, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps) {
            return (0, _propsComparer2.default)(this.props, nextProps, ['className', 'closeButton', 'content', 'contentClassName', 'hideLogo', 'logoClassName']);
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                className = _props.className,
                closeButton = _props.closeButton,
                content = _props.content,
                contentClassName = _props.contentClassName,
                hideLogo = _props.hideLogo,
                logoClassName = _props.logoClassName,
                onHide = _props.onHide;


            var headerClass = (0, _classnames2.default)(className, _ModalHeader2.default.header);
            var logoClass = (0, _classnames2.default)(logoClassName, _ModalHeader2.default.logo);
            var contentClass = (0, _classnames2.default)(contentClassName, _ModalHeader2.default.content);

            return (0, _jsx3.default)('div', {
                className: headerClass
            }, void 0, closeButton && (0, _jsx3.default)('button', {
                className: _ModalHeader2.default['close-button'],
                onClick: onHide
            }, void 0, (0, _jsx3.default)('span', {}, void 0, '\xD7')), !hideLogo && (0, _jsx3.default)('img', {
                className: logoClass,
                src: 'https://p1.liveauctioneers.com/dist/images/logo.svg',
                alt: 'logo'
            }), content && (0, _jsx3.default)('span', {
                className: contentClass
            }, void 0, content));
        }
    }]);
    return ModalHeader;
}(_react.Component), _class.defaultProps = {
    className: '',
    closeButton: true,
    content: '',
    contentClassName: '',
    hideLogo: false,
    logoClassName: ''
}, _temp);
exports.default = ModalHeader;
module.exports = exports['default'];

/***/ }),

/***/ "TJgB":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = __webpack_require__("dcb+");

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _class, _class2, _temp2;

var _user = __webpack_require__("CFLi");

var _config = __webpack_require__("iS9E");

var _browser = __webpack_require__("aN2S");

var _whiteLabel = __webpack_require__("cYj3");

var _modal = __webpack_require__("u90i");

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _AppHeaderMeta = __webpack_require__("HgIS");

var _AppHeaderMeta2 = _interopRequireDefault(_AppHeaderMeta);

var _reduxAsyncConnect = __webpack_require__("5t3y");

var _Auth = __webpack_require__("WGE/");

var _Auth2 = _interopRequireDefault(_Auth);

var _BackToTop = __webpack_require__("BBIF");

var _BackToTop2 = _interopRequireDefault(_BackToTop);

var _BannerOutdatedBrowser = __webpack_require__("kqxN");

var _BannerOutdatedBrowser2 = _interopRequireDefault(_BannerOutdatedBrowser);

var _redux = __webpack_require__("2KeS");

var _reactRedux = __webpack_require__("RH2O");

var _DeskPopup = __webpack_require__("lHUE");

var _DeskPopup2 = _interopRequireDefault(_DeskPopup);

var _FontAwesome = __webpack_require__("5tCn");

var _FontAwesome2 = _interopRequireDefault(_FontAwesome);

var _Footer = __webpack_require__("z8S5");

var _Footer2 = _interopRequireDefault(_Footer);

var _FullStory = __webpack_require__("W0mi");

var _FullStory2 = _interopRequireDefault(_FullStory);

var _windowSize = __webpack_require__("rVZG");

var _GoogleTagManager = __webpack_require__("z3uV");

var _GoogleTagManager2 = _interopRequireDefault(_GoogleTagManager);

var _Header = __webpack_require__("IE5j");

var _Header2 = _interopRequireDefault(_Header);

var _Modals = __webpack_require__("pxDK");

var _Modals2 = _interopRequireDefault(_Modals);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _analytics = __webpack_require__("yxCd");

var _SailthruInit = __webpack_require__("FlQW");

var _SailthruInit2 = _interopRequireDefault(_SailthruInit);

var _reactRouterScroll = __webpack_require__("Pt99");

var _SegmentTracker = __webpack_require__("6f2F");

var _SegmentTracker2 = _interopRequireDefault(_SegmentTracker);

var _Sentry = __webpack_require__("SWTO");

var _Sentry2 = _interopRequireDefault(_Sentry);

var _SoastaGlobalSetter = __webpack_require__("mZDp");

var _SoastaGlobalSetter2 = _interopRequireDefault(_SoastaGlobalSetter);

var _App = __webpack_require__("xgTf");

var _App2 = _interopRequireDefault(_App);

var _login = __webpack_require__("SpFG");

var _WindowSizeContainer = __webpack_require__("PosD");

var _WindowSizeContainer2 = _interopRequireDefault(_WindowSizeContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var App = (_dec = (0, _reduxAsyncConnect.asyncConnect)([{
    deferred: true,
    promise: function promise(options) {
        var store = options.store;
        var dispatch = store.dispatch,
            getState = store.getState;

        var authToken = (0, _user.getAuthToken)(getState());
        return dispatch((0, _user.fetchBidderDataIfNeeded)(authToken));
    }
}]), _dec2 = (0, _reactRedux.connect)(function (state, _ref) {
    var location = _ref.location;

    var authToken = (0, _user.getAuthToken)(state);
    var baseUrl = (0, _config.getBaseUrl)(state);
    var bidderIsLoaded = (0, _user.isBidderLoaded)(state);
    var browser = (0, _browser.getUiBrowser)(state);
    var classicBaseUrl = (0, _config.getClassicBaseUrl)(state);
    var mainhostLogin = (0, _user.getMainhostLogin)(state);
    var mobile = (0, _browser.isUiMobile)(state);
    var sailthruCustomerId = (0, _config.getSailthruCustomerId)(state);
    var userData = (0, _user.getUserData)(state);
    var userLoggedIn = (0, _user.isUserLoggedIn)(state);
    var whiteLabel = (0, _whiteLabel.isWhiteLabel)(state);
    var logo = (0, _whiteLabel.getWhiteLabelLogo)(state);
    var biddingConsole = location.pathname.includes('/console/');

    var _getWindowSize = (0, _windowSize.getWindowSize)(state),
        windowWidth = _getWindowSize.width;

    var stripePublishKey = (0, _config.getStripePublishKey)(state);

    return {
        authToken: authToken,
        baseUrl: baseUrl,
        bidderIsLoaded: bidderIsLoaded,
        biddingConsole: biddingConsole,
        browser: browser,
        classicBaseUrl: classicBaseUrl,
        logo: logo,
        mainhostLogin: mainhostLogin,
        mobile: mobile,
        sailthruCustomerId: sailthruCustomerId,
        stripePublishKey: stripePublishKey,
        userData: userData,
        userLoggedIn: userLoggedIn,
        whiteLabel: whiteLabel,
        windowWidth: windowWidth
    };
}, function (dispatch) {
    return (0, _redux.bindActionCreators)({
        fetchBidderDataIfNeeded: _user.fetchBidderDataIfNeeded,
        logOutBidder: _user.logOutBidder,
        openCreateAccountModal: _modal.openCreateAccountModal,
        openDownloadMobileModal: _modal.openDownloadMobileModal,
        openHealthcheckModal: _modal.openHealthcheckModal,
        openLoginModal: _modal.openLoginModal,
        recordAnalyticsForIdentify: _analytics.recordAnalyticsForIdentify,
        submitLogin: _login.submitLogin
    }, dispatch);
}), _dec(_class = _dec2(_class = (_temp2 = _class2 = function (_Component) {
    (0, _inherits3.default)(App, _Component);

    function App() {
        var _ref2;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, App);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref2 = App.__proto__ || (0, _getPrototypeOf2.default)(App)).call.apply(_ref2, [this].concat(args))), _this), _this.getRequiredData = function () {
            var _this$props = _this.props,
                authToken = _this$props.authToken,
                bidderIsLoaded = _this$props.bidderIsLoaded,
                mainhostLogin = _this$props.mainhostLogin;


            if (!bidderIsLoaded) {
                if (!authToken && mainhostLogin.authVerify) {
                    _this.props.submitLogin(null, null, mainhostLogin);
                } else if (authToken) {
                    _this.props.fetchBidderDataIfNeeded(authToken);
                }
            }
        }, _this.shouldUpdateScroll = function (prevRouterProps, routerProps) {
            // if coming back from an external page, the prevRouterProps will be null
            if (!prevRouterProps) return [0, 0];
            if (prevRouterProps.location.query.page !== routerProps.location.query.page) return true;
            if (prevRouterProps.location.query.parameters !== routerProps.location.query.parameters) return true;
            return prevRouterProps.location.pathname !== routerProps.location.pathname;
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(App, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            if (window.optimizelyHook) {
                window.optimizelyHook();
            }

            if (true) {
                var addThis = document.createElement('script');
                addThis.src = '//s7.addthis.com/js/300/addthis_widget.js#pubid=liveauctioneers';
                addThis.type = 'text/javascript';
                addThis.async = true;

                var intlPolyfill = document.createElement('script');
                intlPolyfill.src = 'https://cdn.polyfill.io/v2/polyfill.min.js?features=Intl.~locale.en';
                intlPolyfill.type = 'text/javascript';
                intlPolyfill.async = true;

                document.head.appendChild(intlPolyfill);
                document.head.appendChild(addThis);
            }

            this.getRequiredData();

            // Set Stripe code
            window.Stripe.setPublishableKey(this.props.stripePublishKey);
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            if (typeof window !== 'undefined' && window.optimizelyHook) {
                window.optimizelyHook();
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                authToken = _props.authToken,
                baseUrl = _props.baseUrl,
                biddingConsole = _props.biddingConsole,
                browser = _props.browser,
                children = _props.children,
                classicBaseUrl = _props.classicBaseUrl,
                location = _props.location,
                logo = _props.logo,
                mainhostLogin = _props.mainhostLogin,
                mobile = _props.mobile,
                sailthruCustomerId = _props.sailthruCustomerId,
                userData = _props.userData,
                userLoggedIn = _props.userLoggedIn,
                whiteLabel = _props.whiteLabel,
                windowWidth = _props.windowWidth;


            return (0, _jsx3.default)(_react.Fragment, {}, void 0, (0, _jsx3.default)(_DeskPopup2.default, {}), (0, _jsx3.default)(_reactRouterScroll.ScrollContainer, {
                scrollKey: 'app',
                shouldUpdateScroll: this.shouldUpdateScroll
            }, void 0, (0, _jsx3.default)('div', {
                className: _App2.default.app
            }, void 0, (0, _jsx3.default)(_GoogleTagManager2.default, {
                gtmId: 'GTM-MGNHR3N'
            }), (0, _jsx3.default)(_FullStory2.default, {}), (0, _jsx3.default)(_WindowSizeContainer2.default, {}), (0, _jsx3.default)(_FontAwesome2.default, {}), (0, _jsx3.default)(_Sentry2.default, {}), (0, _jsx3.default)(_AppHeaderMeta2.default, {
                baseUrl: baseUrl,
                pathname: location.pathname,
                whiteLabel: whiteLabel
            }), (0, _jsx3.default)(_SailthruInit2.default, {
                customerId: sailthruCustomerId
            }), (0, _jsx3.default)(_Auth2.default, {
                authToken: authToken,
                mainhostLogin: mainhostLogin,
                recordAnalyticsForIdentify: this.props.recordAnalyticsForIdentify,
                userData: userData,
                userLoggedIn: userLoggedIn
            }), !!browser.isOutdated && (0, _jsx3.default)(_BannerOutdatedBrowser2.default, {
                name: browser.name,
                majorVersion: browser.majorVersion
            }), !biddingConsole && (0, _jsx3.default)(_Header2.default, {
                baseUrl: baseUrl,
                biddingConsole: biddingConsole,
                location: location,
                logo: logo,
                logOutBidder: this.props.logOutBidder,
                mobile: mobile,
                openCreateAccountModal: this.props.openCreateAccountModal,
                openLoginModal: this.props.openLoginModal,
                userLoggedIn: userLoggedIn,
                whiteLabel: whiteLabel,
                windowWidth: windowWidth
            }), (0, _jsx3.default)('div', {
                className: _App2.default.appContent,
                id: 'main'
            }, void 0, children), !biddingConsole && (0, _jsx3.default)(_Footer2.default, {
                baseUrl: baseUrl,
                classicBaseUrl: classicBaseUrl,
                openDownloadMobileModal: this.props.openDownloadMobileModal,
                openHealthcheckModal: this.props.openHealthcheckModal,
                userData: userData || {},
                whiteLabel: whiteLabel
            }), (0, _jsx3.default)(_Modals2.default, {}), (0, _jsx3.default)(_SegmentTracker2.default, {}), (0, _jsx3.default)(_SoastaGlobalSetter2.default, {}), (0, _jsx3.default)(_BackToTop2.default, {}))));
        }
    }]);
    return App;
}(_react.Component), _class2.defaultProps = {
    authToken: _propTypes2.default.string,
    userLoggedIn: false
}, _temp2)) || _class) || _class);
exports.default = App;
module.exports = exports['default'];

/***/ }),

/***/ "TMJx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = __webpack_require__("dcb+");

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propsComparer = __webpack_require__("wsGv");

var _propsComparer2 = _interopRequireDefault(_propsComparer);

var _redux = __webpack_require__("2KeS");

var _reactRedux = __webpack_require__("RH2O");

var _catalogRegistration = __webpack_require__("uhYE");

var _modal = __webpack_require__("u90i");

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _RegisterLink = __webpack_require__("KaKp");

var _RegisterLink2 = _interopRequireDefault(_RegisterLink);

var _registerForCatalog = __webpack_require__("eUWk");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RegisterLinkContainer = (_dec = (0, _reactRedux.connect)(function (state, _ref) {
    var catalogId = _ref.catalogId;

    var registrationStatus = (0, _catalogRegistration.getCatalogRegistration)(state, catalogId);
    return {
        registrationStatus: registrationStatus
    };
}, function (dispatch) {
    return (0, _redux.bindActionCreators)({
        openRegisterForCatalogModal: _modal.openRegisterForCatalogModal,
        requestOnlineBidding: _registerForCatalog.submitRegisterForCatalog
    }, dispatch);
}), _dec(_class = function (_Component) {
    (0, _inherits3.default)(RegisterLinkContainer, _Component);

    function RegisterLinkContainer() {
        (0, _classCallCheck3.default)(this, RegisterLinkContainer);
        return (0, _possibleConstructorReturn3.default)(this, (RegisterLinkContainer.__proto__ || (0, _getPrototypeOf2.default)(RegisterLinkContainer)).apply(this, arguments));
    }

    (0, _createClass3.default)(RegisterLinkContainer, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps) {
            return (0, _propsComparer2.default)(this.props, nextProps, ['className', 'catalogId', 'isCatalogOnly', 'registrationStatus']);
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                catalogId = _props.catalogId,
                className = _props.className,
                isCatalogOnly = _props.isCatalogOnly,
                registrationStatus = _props.registrationStatus;


            return (0, _jsx3.default)(_RegisterLink2.default, {
                catalogId: catalogId,
                className: className,
                isCatalogOnly: isCatalogOnly,
                openRegisterForCatalogModal: this.props.openRegisterForCatalogModal,
                registrationStatus: registrationStatus,
                requestOnlineBidding: this.props.requestOnlineBidding
            });
        }
    }]);
    return RegisterLinkContainer;
}(_react.Component)) || _class);
exports.default = RegisterLinkContainer;
module.exports = exports['default'];

/***/ }),

/***/ "TSUT":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fetchHomeDataIfNeeded = exports.shouldFetchHomeData = exports.getHomeData = exports.LOAD_HOME_DATA_SUCCESS = exports.LOAD_HOME_DATA_REQUEST = exports.LOAD_HOME_DATA_FAIL = undefined;

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _regenerator = __webpack_require__("Xxa5");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__("exGp");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _toConsumableArray2 = __webpack_require__("Gu7T");

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _isInteger = __webpack_require__("RRo+");

var _isInteger2 = _interopRequireDefault(_isInteger);

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;

var _api = __webpack_require__("zFQO");

var _reselect = __webpack_require__("bndy");

var _cardData = __webpack_require__("6OFE");

var _config = __webpack_require__("iS9E");

var _filteredItems = __webpack_require__("IeGF");

var _isEmpty = __webpack_require__("lHK6");

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _shuffle = __webpack_require__("yG5q");

var _shuffle2 = _interopRequireDefault(_shuffle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Action Types */
var LOAD_HOME_DATA_FAIL = exports.LOAD_HOME_DATA_FAIL = 'la/domain/home/LOAD_FAIL';
var LOAD_HOME_DATA_REQUEST = exports.LOAD_HOME_DATA_REQUEST = 'la/domain/home/LOAD_REQUEST';
var LOAD_HOME_DATA_SUCCESS = exports.LOAD_HOME_DATA_SUCCESS = 'la/domain/home/LOAD_SUCCESS';

// reducer
var DEFAULT_STATE = {
    acn: {},
    categories: [],
    featuredCatalogs: [],
    loading: false,
    trendingItems: [],
    trustMetrics: {},
    upcomingCatalogs: []
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var categories = void 0;
    var featuredCatalogs = void 0;

    switch (action.type) {
        case LOAD_HOME_DATA_FAIL:
            return (0, _extends3.default)({}, state, {
                loading: false
            });
        case LOAD_HOME_DATA_REQUEST:
            return (0, _extends3.default)({}, state, {
                loading: true
            });
        case LOAD_HOME_DATA_SUCCESS:
            // categories
            if (action.payload.categories) {
                categories = action.payload.categories.map(function (x) {
                    // add in the label until the api returns it
                    return (0, _extends3.default)({
                        label: x.title
                    }, x);
                });
            } else {
                categories = [];
            }

            // featuredCatalogs
            if (Array.isArray(action.payload.featuredCatalogs)) {
                if ((0, _isInteger2.default)(action.payload.featuredCatalogs[0])) {
                    // old way, an array of ints
                    featuredCatalogs = [].concat((0, _toConsumableArray3.default)(action.payload.featuredCatalogs));
                } else {
                    // new way, an array of objects
                    featuredCatalogs = action.payload.featuredCatalogs.map(function (x) {
                        return x.catalogId;
                    });
                }
            } else {
                // bad, not an array
                featuredCatalogs = [];
            }
            // TODO: make this reducer pure by moving the shuffle to the selector
            featuredCatalogs = (0, _shuffle2.default)(featuredCatalogs);
            return (0, _extends3.default)({}, state, {
                acn: (0, _extends3.default)({}, action.payload.acn),
                categories: categories,
                featuredCatalogs: featuredCatalogs,
                loading: false,
                trendingItems: [].concat((0, _toConsumableArray3.default)(action.payload.trendingItems)),
                trustMetrics: (0, _extends3.default)({}, action.payload.siteStatistics),
                upcomingCatalogs: [].concat((0, _toConsumableArray3.default)(action.payload.upcomingCatalogs))
            });
        default:
            return state;
    }
}

/* SELECTORS */
var stateSelector = function stateSelector(state) {
    return state.domain.home;
};
var globalStateSelector = function globalStateSelector(state) {
    return state;
};

var getHomeData = exports.getHomeData = (0, _reselect.createSelector)([stateSelector, globalStateSelector], function (state, globalState) {
    return {
        acn: state.acn,
        categories: state.categories,
        featuredCatalogs: (0, _cardData.getCatalogCardDatas)(globalState, state.featuredCatalogs),
        homeTrustMetrics: state.trustMetrics,
        trendingItems: (0, _filteredItems.getTrendingItemsByBids)(globalState, state.trendingItems),
        upcomingCatalogs: (0, _cardData.getCatalogCardDatas)(globalState, state.upcomingCatalogs, true)
    };
});

var shouldFetchHomeData = exports.shouldFetchHomeData = (0, _reselect.createSelector)(stateSelector, function (state) {
    return (0, _isEmpty2.default)(state.featuredCatalogs);
});

/* ACTION CREATORS */
var loadHomeData = function loadHomeData() {
    return function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch, getState) {
            var state, deployment, response;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.prev = 0;
                            state = getState();
                            deployment = (0, _config.getDeployment)(state);

                            dispatch({
                                type: LOAD_HOME_DATA_REQUEST
                            });
                            _context.next = 6;
                            return _api.Home.fetchHomeData({ deployment: deployment });

                        case 6:
                            response = _context.sent;

                            dispatch({
                                meta: { actionTime: Date.now() },
                                payload: response.data,
                                type: LOAD_HOME_DATA_SUCCESS
                            });
                            _context.next = 13;
                            break;

                        case 10:
                            _context.prev = 10;
                            _context.t0 = _context['catch'](0);

                            dispatch({
                                error: true,
                                payload: _context.t0,
                                type: LOAD_HOME_DATA_FAIL
                            });

                        case 13:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, undefined, [[0, 10]]);
        }));

        return function (_x3, _x4) {
            return _ref.apply(this, arguments);
        };
    }();
};

var fetchHomeDataIfNeeded = exports.fetchHomeDataIfNeeded = function fetchHomeDataIfNeeded() {
    return function (dispatch, getState) {
        if (shouldFetchHomeData(getState())) {
            return dispatch(loadHomeData());
        }
        return _promise2.default.resolve();
    };
};

/***/ }),

/***/ "TaFV":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fetchSellerRecordResultsIfNeeded = exports.getSellerRecordResults = exports.isSellerRecordResultsLoading = exports.getLoadTimeForRecordResults = exports.getSellerRecordResultsIds = exports.LOAD_SELLER_RECORD_RESULTS_SUCCESS = exports.LOAD_SELLER_RECORD_RESULTS_REQUEST = exports.LOAD_SELLER_RECORD_RESULTS_FAIL = undefined;

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _regenerator = __webpack_require__("Xxa5");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__("exGp");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;

var _api = __webpack_require__("zFQO");

var _cloneDeep = __webpack_require__("kvU2");

var _cloneDeep2 = _interopRequireDefault(_cloneDeep);

var _reselect = __webpack_require__("bndy");

var _difference = __webpack_require__("WlNK");

var _difference2 = _interopRequireDefault(_difference);

var _user = __webpack_require__("CFLi");

var _config = __webpack_require__("iS9E");

var _cardData = __webpack_require__("6OFE");

var _ms = __webpack_require__("EarI");

var _ms2 = _interopRequireDefault(_ms);

var _union = __webpack_require__("gszD");

var _union2 = _interopRequireDefault(_union);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Action Types */
var LOAD_SELLER_RECORD_RESULTS_FAIL = exports.LOAD_SELLER_RECORD_RESULTS_FAIL = 'la/domain/sellerRecordResults/LOAD_FAIL';
var LOAD_SELLER_RECORD_RESULTS_REQUEST = exports.LOAD_SELLER_RECORD_RESULTS_REQUEST = 'la/domain/sellerRecordResults/LOAD_REQUEST';
var LOAD_SELLER_RECORD_RESULTS_SUCCESS = exports.LOAD_SELLER_RECORD_RESULTS_SUCCESS = 'la/domain/sellerRecordResults/LOAD_SUCCESS';

var REDUX_STORE_TIME = (0, _ms2.default)('30m');

/* reducer */
var DEFAULT_STATE = {
    byId: {},
    loaded: {},
    loading: []
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var existing = void 0;
    var loaded = void 0;
    var loading = void 0;
    var time = void 0;

    switch (action.type) {
        case LOAD_SELLER_RECORD_RESULTS_FAIL:
            return (0, _extends3.default)({}, state, {
                loading: (0, _difference2.default)(state.loading, [action.meta.sellerId])
            });
        case LOAD_SELLER_RECORD_RESULTS_REQUEST:
            return (0, _extends3.default)({}, state, {
                loading: (0, _union2.default)(state.loading, [action.payload])
            });
        case LOAD_SELLER_RECORD_RESULTS_SUCCESS:
            existing = (0, _cloneDeep2.default)(state.byId);
            loaded = (0, _extends3.default)({}, state.loaded);
            loading = (0, _cloneDeep2.default)(state.loading);
            time = action.meta.actionTime;

            if (action.payload.items) {
                var sellerRecordResults = action.payload.items;
                var sellerId = sellerRecordResults[0].sellerId; // TODO: maybe we should use the sellerId from the meta
                existing[sellerId] = action.payload.items.map(function (item) {
                    return item.itemId;
                });
                loaded[sellerId] = time;
                loading = (0, _difference2.default)(loading, [sellerId]);
            }
            return (0, _extends3.default)({}, state, {
                byId: existing,
                loaded: loaded,
                loading: loading
            });
        default:
            return state;
    }
}

/* SELECTORS */
var stateSelector = function stateSelector(state) {
    return state.domain.sellerRecordResults;
};
var idSelector = function idSelector(state, id) {
    return id;
};

var byIdSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.byId;
});

var loadedSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.loaded;
});

var loadingSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.loading;
});

// takes in a (state, id) and returns the data
var getSellerRecordResultsIds = exports.getSellerRecordResultsIds = (0, _reselect.createSelector)([byIdSelector, idSelector], function (byId, id) {
    return byId[id] || [];
});

// takes in a (state, id) and returns the load time
var getLoadTimeForRecordResults = exports.getLoadTimeForRecordResults = (0, _reselect.createSelector)([loadedSelector, idSelector], function (loaded, id) {
    return loaded[id] || 0;
});

// takes in a (state, id) and returns the is loading
var isSellerRecordResultsLoading = exports.isSellerRecordResultsLoading = (0, _reselect.createSelector)([loadingSelector, idSelector], function (loading, id) {
    return loading.indexOf(id) !== -1;
});

var getSellerRecordResults = exports.getSellerRecordResults = function getSellerRecordResults(state, sellerId) {
    var itemIds = getSellerRecordResultsIds(state, sellerId);
    return (0, _cardData.getItemCardDatas)(state, itemIds);
};

var shouldFetchSellerRecordResults = function shouldFetchSellerRecordResults(state, sellerId) {
    if (!sellerId) return false;
    var items = getSellerRecordResults(state, sellerId);
    if (items.length) {
        var loaded = getLoadTimeForRecordResults(state, sellerId);
        var time = Date.now();
        var diff = time - loaded;
        if (diff < REDUX_STORE_TIME) return false;
    }
    var loading = isSellerRecordResultsLoading(state, sellerId);
    return !loading;
};

/* ACTION CREATORS */
var loadSellerRecordResults = function loadSellerRecordResults(sellerId) {
    return function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch, getState) {
            var state, authToken, deployment, response;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.prev = 0;
                            state = getState();
                            authToken = (0, _user.getAuthToken)(state);
                            deployment = (0, _config.getDeployment)(state);

                            dispatch({
                                payload: sellerId,
                                type: LOAD_SELLER_RECORD_RESULTS_REQUEST
                            });
                            _context.next = 7;
                            return _api.SellerRecordResults.fetchSellerRecordResultsById({
                                authToken: authToken,
                                deployment: deployment,
                                sellerId: sellerId
                            });

                        case 7:
                            response = _context.sent;

                            dispatch({
                                meta: { actionTime: Date.now(), sellerId: sellerId },
                                payload: response.data,
                                type: LOAD_SELLER_RECORD_RESULTS_SUCCESS
                            });
                            _context.next = 14;
                            break;

                        case 11:
                            _context.prev = 11;
                            _context.t0 = _context['catch'](0);

                            dispatch({
                                error: true,
                                meta: { sellerId: sellerId },
                                payload: _context.t0,
                                type: LOAD_SELLER_RECORD_RESULTS_FAIL
                            });

                        case 14:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, undefined, [[0, 11]]);
        }));

        return function (_x3, _x4) {
            return _ref.apply(this, arguments);
        };
    }();
};

var fetchSellerRecordResultsIfNeeded = exports.fetchSellerRecordResultsIfNeeded = function fetchSellerRecordResultsIfNeeded(sellerId) {
    return function (dispatch, getState) {
        if (shouldFetchSellerRecordResults(getState(), sellerId)) {
            return dispatch(loadSellerRecordResults(sellerId));
        }

        return _promise2.default.resolve();
    };
};

/***/ }),

/***/ "TbAp":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatShortDate = exports.formatLongDate = exports.errorDate = exports.catalogCardDate = exports.catalogLongCardDate = undefined;

var _momentTimezone = __webpack_require__("xNPZ");

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var momentGuessTZ = function momentGuessTZ(timestamp) {
  return _momentTimezone2.default.unix(timestamp).tz(_momentTimezone2.default.tz.guess());
};

var catalogLongCardDate = exports.catalogLongCardDate = function catalogLongCardDate(timestamp) {
  return momentGuessTZ(timestamp).format('ddd, MMM D, GGGG h:mm A zz');
};

var catalogCardDate = exports.catalogCardDate = function catalogCardDate(timestamp) {
  return momentGuessTZ(timestamp).format('MMM D, GGGG h:mm A zz');
};

var errorDate = exports.errorDate = function errorDate(timestamp) {
  return momentGuessTZ(timestamp / 1000).format('MMMM Do YYYY, h:mm:ss a');
};

var formatLongDate = exports.formatLongDate = function formatLongDate(timestamp) {
  return momentGuessTZ(timestamp).format('MMMM Do, YYYY zz');
};

var formatShortDate = exports.formatShortDate = function formatShortDate(timestamp) {
  return momentGuessTZ(timestamp).format('MMMM Do, YYYY');
};

/***/ }),

/***/ "TdMF":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _search = __webpack_require__("6t9d");

var Search = {
    fetchCategoryResults: _search.SearchRemote.fetchCategoryResults,
    fetchSearchFacetsResults: _search.SearchRemote.fetchSearchFacetsResults,
    fetchSearchResults: _search.SearchRemote.fetchSearchResults
};

exports.default = Search;
module.exports = exports['default'];

/***/ }),

/***/ "Tlyl":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = __webpack_require__("dcb+");

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _reactIntl = __webpack_require__("Pq8k");

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _BuyersPremium = __webpack_require__("ij/i");

var _BuyersPremium2 = _interopRequireDefault(_BuyersPremium);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BuyersPremium = (_temp2 = _class = function (_PureComponent) {
    (0, _inherits3.default)(BuyersPremium, _PureComponent);

    function BuyersPremium() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, BuyersPremium);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = BuyersPremium.__proto__ || (0, _getPrototypeOf2.default)(BuyersPremium)).call.apply(_ref, [this].concat(args))), _this), _this.mapPremiums = function (premium, index) {
            return (0, _jsx3.default)('li', {}, index, premium.percentage, ' ', premium.cutoff);
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(BuyersPremium, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                currency = _props.currency,
                low = _props.low,
                lowCutoff = _props.lowCutoff,
                middle = _props.middle,
                middleCutoff = _props.middleCutoff,
                high = _props.high;

            var premiums = [{
                percentage: (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                    id: 'low_percentage',
                    values: { low: low }
                })
            }];

            if (low && lowCutoff) {
                premiums = [{
                    cutoff: (0, _jsx3.default)(_reactIntl.FormattedNumber, {
                        value: lowCutoff,
                        style: 'currency',
                        currency: currency
                    }),
                    percentage: (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                        id: 'low_cut_off',
                        values: { low: low }
                    })
                }];
            }

            if (middle && middleCutoff) {
                premiums.push({
                    cutoff: (0, _jsx3.default)(_reactIntl.FormattedNumber, {
                        value: middleCutoff,
                        style: 'currency',
                        currency: currency
                    }),
                    percentage: (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                        id: 'middle_cut_off',
                        values: { middle: middle }
                    })
                });
            }

            if (middle && !middleCutoff) {
                premiums.push({
                    cutoff: (0, _jsx3.default)(_reactIntl.FormattedNumber, {
                        value: lowCutoff,
                        style: 'currency',
                        currency: currency
                    }),
                    percentage: (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                        id: 'middle_low_cut_off',
                        values: { middle: middle }
                    })
                });
            }

            if (high) {
                premiums.push({
                    cutoff: (0, _jsx3.default)(_reactIntl.FormattedNumber, {
                        value: middleCutoff,
                        style: 'currency',
                        currency: currency
                    }),
                    percentage: (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                        id: 'high_cut_off',
                        values: { high: high }
                    })
                });
            }

            return (0, _jsx3.default)('ul', {
                className: _BuyersPremium2.default['buyers-premium']
            }, void 0, premiums.map(this.mapPremiums));
        }
    }]);
    return BuyersPremium;
}(_react.PureComponent), _class.defaultProps = {
    low: 0
}, _temp2);
exports.default = BuyersPremium;
module.exports = exports['default'];

/***/ }),

/***/ "U847":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = __webpack_require__("dcb+");

var _jsx3 = _interopRequireDefault(_jsx2);

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Polyfill for webpack, just in case
if (false) require.ensure = function (d, c) {
    c(require);
};

var UpdatePasswordModalLoader = function (_Component) {
    (0, _inherits3.default)(UpdatePasswordModalLoader, _Component);

    function UpdatePasswordModalLoader(props, context) {
        (0, _classCallCheck3.default)(this, UpdatePasswordModalLoader);

        var _this = (0, _possibleConstructorReturn3.default)(this, (UpdatePasswordModalLoader.__proto__ || (0, _getPrototypeOf2.default)(UpdatePasswordModalLoader)).call(this, props, context));

        _this.state = {
            Component: null,
            mounted: false
        };
        return _this;
    }

    (0, _createClass3.default)(UpdatePasswordModalLoader, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            var _this2 = this;

            return new _promise2.default(function (resolve) {
                __webpack_require__.e/* require.ensure */(28).then((function () {
                    resolve(__webpack_require__("o5xt"));
                }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            }).then(function (container) {
                _this2.setState({ Component: container });
            });
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.setState({ mounted: true });
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.setState({ mounted: false });
        }
    }, {
        key: 'render',
        value: function render() {
            var _state = this.state,
                Component = _state.Component,
                mounted = _state.mounted;

            return mounted && Component !== null ? (0, _jsx3.default)(Component, {}) : null;
        }
    }]);
    return UpdatePasswordModalLoader;
}(_react.Component);

exports.default = UpdatePasswordModalLoader;
module.exports = exports['default'];

/***/ }),

/***/ "UGHK":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = __webpack_require__("dcb+");

var _jsx3 = _interopRequireDefault(_jsx2);

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Polyfill for webpack, just in case
if (false) require.ensure = function (d, c) {
    c(require);
};

var RetractBidModalLoader = function (_Component) {
    (0, _inherits3.default)(RetractBidModalLoader, _Component);

    function RetractBidModalLoader(props, context) {
        (0, _classCallCheck3.default)(this, RetractBidModalLoader);

        var _this = (0, _possibleConstructorReturn3.default)(this, (RetractBidModalLoader.__proto__ || (0, _getPrototypeOf2.default)(RetractBidModalLoader)).call(this, props, context));

        _this.state = {
            Component: null,
            mounted: false
        };
        return _this;
    }

    (0, _createClass3.default)(RetractBidModalLoader, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            var _this2 = this;

            return new _promise2.default(function (resolve) {
                __webpack_require__.e/* require.ensure */(23).then((function () {
                    resolve(__webpack_require__("5a6q"));
                }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            }).then(function (container) {
                _this2.setState({ Component: container });
            });
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.setState({ mounted: true });
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.setState({ mounted: false });
        }
    }, {
        key: 'render',
        value: function render() {
            var _state = this.state,
                Component = _state.Component,
                mounted = _state.mounted;

            return mounted && Component !== null ? (0, _jsx3.default)(Component, {}) : null;
        }
    }]);
    return RetractBidModalLoader;
}(_react.Component);

exports.default = RetractBidModalLoader;
module.exports = exports['default'];

/***/ }),

/***/ "UTtJ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fetchCatalogCuratorsIfNeeded = exports.getLoadTimeForCatalogCurators = exports.getCatalogCurators = exports.isLoading = exports.FETCH_CATALOG_CURATORS_FAIL = exports.FETCH_CATALOG_CURATORS_SUCCESS = exports.FETCH_CATALOG_CURATORS_REQUEST = undefined;

var _regenerator = __webpack_require__("Xxa5");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _asyncToGenerator2 = __webpack_require__("exGp");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;

var _api = __webpack_require__("zFQO");

var _cloneDeep = __webpack_require__("kvU2");

var _cloneDeep2 = _interopRequireDefault(_cloneDeep);

var _reselect = __webpack_require__("bndy");

var _difference = __webpack_require__("WlNK");

var _difference2 = _interopRequireDefault(_difference);

var _user = __webpack_require__("CFLi");

var _config = __webpack_require__("iS9E");

var _isEmpty = __webpack_require__("lHK6");

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _ms = __webpack_require__("EarI");

var _ms2 = _interopRequireDefault(_ms);

var _union = __webpack_require__("gszD");

var _union2 = _interopRequireDefault(_union);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Action Types */
var FETCH_CATALOG_CURATORS_REQUEST = exports.FETCH_CATALOG_CURATORS_REQUEST = 'FETCH_CATALOG_CURATORS_REQUEST';
var FETCH_CATALOG_CURATORS_SUCCESS = exports.FETCH_CATALOG_CURATORS_SUCCESS = 'FETCH_CATALOG_CURATORS_SUCCESS';
var FETCH_CATALOG_CURATORS_FAIL = exports.FETCH_CATALOG_CURATORS_FAIL = 'FETCH_CATALOG_CURATORS_FAIL';

var REDUX_STORE_TIME = (0, _ms2.default)('30m');

/* reducer */
var DEFAULT_STATE = {
    byId: {},
    loaded: {},
    loading: []
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var existing = void 0;
    var loaded = void 0;
    var loading = void 0;
    var time = void 0;
    var catalogId = void 0;

    switch (action.type) {
        case FETCH_CATALOG_CURATORS_FAIL:
            return (0, _extends3.default)({}, state, {
                loading: (0, _difference2.default)(state.loading, [action.meta.catalogId])
            });
        case FETCH_CATALOG_CURATORS_REQUEST:
            return (0, _extends3.default)({}, state, {
                loading: (0, _union2.default)(state.loading, [action.payload])
            });
        case FETCH_CATALOG_CURATORS_SUCCESS:
            catalogId = action.meta.catalogId;
            existing = (0, _cloneDeep2.default)(state.byId);
            loaded = (0, _extends3.default)({}, state.loaded);
            loading = (0, _cloneDeep2.default)(state.loading);
            time = action.meta.actionTime;

            existing[catalogId] = action.payload;
            loaded[catalogId] = time;
            loading = (0, _difference2.default)(loading, [catalogId]);

            return (0, _extends3.default)({}, state, {
                byId: existing,
                loaded: loaded,
                loading: loading
            });
        default:
            return state;
    }
}

/* SELECTORS */
var stateSelector = function stateSelector(state) {
    return state.domain.catalogCurators;
};
var idSelector = function idSelector(state, id) {
    return id;
};

var byIdSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.byId;
});

var loadedSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.loaded;
});

var loadingSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.loading;
});

var isLoading = exports.isLoading = (0, _reselect.createSelector)([loadingSelector, idSelector], function (loading, id) {
    return loading.includes(id);
});

var getCatalogCurators = exports.getCatalogCurators = (0, _reselect.createSelector)([byIdSelector, idSelector], function (byId, id) {
    return byId[id] || [];
});

var getLoadTimeForCatalogCurators = exports.getLoadTimeForCatalogCurators = (0, _reselect.createSelector)([loadedSelector, idSelector], function (loaded, id) {
    return loaded[id] || 0;
});

var shouldFetchCurators = function shouldFetchCurators(state, catalogId) {
    if (!catalogId) return false;
    var curators = getCatalogCurators(state, catalogId);
    if (!(0, _isEmpty2.default)(curators)) {
        var loaded = getLoadTimeForCatalogCurators(state, catalogId);
        var time = Date.now();
        var diff = time - loaded;
        if (diff < REDUX_STORE_TIME) return false;
    } else if (getLoadTimeForCatalogCurators(state, catalogId)) {
        return false;
    }
    var loading = isLoading(state, catalogId);
    return !loading;
};

/* ACTION CREATORS */
var fetchCatalogCuratorsIfNeeded = exports.fetchCatalogCuratorsIfNeeded = function fetchCatalogCuratorsIfNeeded(catalogId) {
    return function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch, getState) {
            var state, authToken, deployment, response;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            state = getState();

                            if (!shouldFetchCurators(state, catalogId)) {
                                _context.next = 17;
                                break;
                            }

                            authToken = (0, _user.getAuthToken)(state);
                            deployment = (0, _config.getDeployment)(state);
                            _context.prev = 4;

                            dispatch({
                                meta: { actionTime: Date.now() },
                                payload: catalogId,
                                type: FETCH_CATALOG_CURATORS_REQUEST
                            });
                            _context.next = 8;
                            return _api.Catalog.fetchCuratorsForCatalog({
                                authToken: authToken,
                                catalogId: catalogId,
                                deployment: deployment
                            });

                        case 8:
                            response = _context.sent;

                            dispatch({
                                meta: { actionTime: Date.now(), catalogId: catalogId },
                                payload: response.data,
                                type: FETCH_CATALOG_CURATORS_SUCCESS
                            });
                            _context.next = 15;
                            break;

                        case 12:
                            _context.prev = 12;
                            _context.t0 = _context['catch'](4);

                            dispatch({
                                error: true,
                                meta: { catalogId: catalogId },
                                payload: _context.t0,
                                type: FETCH_CATALOG_CURATORS_FAIL
                            });

                        case 15:
                            _context.next = 18;
                            break;

                        case 17:
                            return _context.abrupt('return', _promise2.default.resolve());

                        case 18:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, undefined, [[4, 12]]);
        }));

        return function (_x3, _x4) {
            return _ref.apply(this, arguments);
        };
    }();
};

/***/ }),

/***/ "UUHK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"registered":"registered___2Dlab","register-for-auction":"register-for-auction___ds_Fj"};

/***/ }),

/***/ "Ukn/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.EmailListRemote = undefined;

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _helpers = __webpack_require__("SY39");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EmailListRemote = exports.EmailListRemote = {
    fetchEmailLists: function fetchEmailLists(_ref) {
        var authToken = _ref.authToken,
            deployment = _ref.deployment;
        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makeGet)('<ITEM-API>profile/lists', deployment);
            (0, _helpers.addAuthToken)(request, authToken);
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response });
            });
        });
    },
    postSubscribeToEmailList: function postSubscribeToEmailList(_ref2) {
        var authToken = _ref2.authToken,
            code = _ref2.code,
            deployment = _ref2.deployment;
        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makePost)('<ITEM-API>profile/subscribe', deployment);
            (0, _helpers.addAuthToken)(request, authToken);
            request.send({ code: code });
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response });
            });
        });
    },
    postUnsubscribeFromEmailList: function postUnsubscribeFromEmailList(_ref3) {
        var authToken = _ref3.authToken,
            code = _ref3.code,
            deployment = _ref3.deployment;
        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makePost)('<ITEM-API>profile/unsubscribe', deployment);
            (0, _helpers.addAuthToken)(request, authToken);
            request.send({ code: code });
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response });
            });
        });
    }
};

/***/ }),

/***/ "UnnL":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = __webpack_require__("dcb+");

var _jsx3 = _interopRequireDefault(_jsx2);

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Polyfill for webpack, just in case
if (false) require.ensure = function (d, c) {
    c(require);
};

var HealthcheckModalLoader = function (_Component) {
    (0, _inherits3.default)(HealthcheckModalLoader, _Component);

    function HealthcheckModalLoader(props, context) {
        (0, _classCallCheck3.default)(this, HealthcheckModalLoader);

        var _this = (0, _possibleConstructorReturn3.default)(this, (HealthcheckModalLoader.__proto__ || (0, _getPrototypeOf2.default)(HealthcheckModalLoader)).call(this, props, context));

        _this.state = {
            Component: null,
            mounted: false
        };
        return _this;
    }

    (0, _createClass3.default)(HealthcheckModalLoader, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            var _this2 = this;

            return new _promise2.default(function (resolve) {
                __webpack_require__.e/* require.ensure */(2).then((function () {
                    resolve(__webpack_require__("fpO3"));
                }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            }).then(function (container) {
                _this2.setState({ Component: container });
            });
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.setState({ mounted: true });
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.setState({ mounted: false });
        }
    }, {
        key: 'render',
        value: function render() {
            var _state = this.state,
                Component = _state.Component,
                mounted = _state.mounted;

            return mounted && Component !== null ? (0, _jsx3.default)(Component, {}) : null;
        }
    }]);
    return HealthcheckModalLoader;
}(_react.Component);

exports.default = HealthcheckModalLoader;
module.exports = exports['default'];

/***/ }),

/***/ "UuWU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"links":"links___3bPm3","linksInner":"linksInner___2DkpO","linksUpper":"linksUpper___3Jqf5","name":"name___3ApsX","blackLink":"blackLink___mBE7N","linksLower":"linksLower___2VMZx","copyright":"copyright___ZUmJp"};

/***/ }),

/***/ "V13H":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.changeWonItemsPage = exports.fetchWonItemsIfNeeded = exports.areWonItemsLoaded = exports.getWonItemsPageSize = exports.getWonItemsPage = exports.getWonItems = exports.getTotalWonItemsCount = exports.CHANGE_WON_ITEMS_PAGE_SIZE = exports.CHANGE_WON_ITEMS_PAGE = exports.LOAD_WON_ITEMS_SUCCESS = exports.LOAD_WON_ITEMS_REQUEST = exports.LOAD_WON_ITEMS_FAIL = undefined;

var _regenerator = __webpack_require__("Xxa5");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _asyncToGenerator2 = __webpack_require__("exGp");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;

var _user = __webpack_require__("CFLi");

var _api = __webpack_require__("zFQO");

var _cloneDeep = __webpack_require__("kvU2");

var _cloneDeep2 = _interopRequireDefault(_cloneDeep);

var _reselect = __webpack_require__("bndy");

var _config = __webpack_require__("iS9E");

var _ms = __webpack_require__("EarI");

var _ms2 = _interopRequireDefault(_ms);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Action Types */
var LOAD_WON_ITEMS_FAIL = exports.LOAD_WON_ITEMS_FAIL = 'la/ui/wonItems/LOAD_FAIL';
var LOAD_WON_ITEMS_REQUEST = exports.LOAD_WON_ITEMS_REQUEST = 'la/ui/wonItems/LOAD_REQUEST';
var LOAD_WON_ITEMS_SUCCESS = exports.LOAD_WON_ITEMS_SUCCESS = 'la/ui/wonItems/LOAD_SUCCESS';
var CHANGE_WON_ITEMS_PAGE = exports.CHANGE_WON_ITEMS_PAGE = 'la/ui/wonItems/CHANGE_WON_ITEMS_PAGE';
var CHANGE_WON_ITEMS_PAGE_SIZE = exports.CHANGE_WON_ITEMS_PAGE_SIZE = 'la/ui/wonItems/CHANGE_WON_ITEMS_PAGE_SIZE';

var REDUX_STORE_TIME = (0, _ms2.default)('30m');

/* reducer */
var DEFAULT_STATE = {
    items: [],
    loaded: null,
    loading: false,
    page: 1,
    pageSize: 10,
    totalItems: 0
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        case LOAD_WON_ITEMS_FAIL:
            return (0, _extends3.default)({}, state, {
                loading: false
            });
        case LOAD_WON_ITEMS_REQUEST:
            return (0, _extends3.default)({}, state, {
                loading: true
            });
        case LOAD_WON_ITEMS_SUCCESS:
            return (0, _extends3.default)({}, state, {
                items: (0, _cloneDeep2.default)(action.payload.catalogs),
                loaded: action.meta.actionTime,
                loading: false,
                totalItems: action.payload.count
            });
        case CHANGE_WON_ITEMS_PAGE_SIZE:
            return (0, _extends3.default)({}, state, {
                pageSize: action.payload
            });
        case CHANGE_WON_ITEMS_PAGE:
            return (0, _extends3.default)({}, state, {
                page: action.payload
            });
        default:
            return state;
    }
}

/* SELECTORS */
var stateSelector = function stateSelector(state) {
    return state.ui.wonItems;
};

var loadedSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.loaded;
});
var loadingSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.loading;
});

var getTotalWonItemsCount = exports.getTotalWonItemsCount = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.totalItems;
}) || 0;
var getWonItems = exports.getWonItems = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.items;
}) || [];
var getWonItemsPage = exports.getWonItemsPage = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.page;
}) || 1;
var getWonItemsPageSize = exports.getWonItemsPageSize = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.pageSize;
}) || 10;
var areWonItemsLoaded = exports.areWonItemsLoaded = loadedSelector;

var shouldFetchWonItems = (0, _reselect.createSelector)([loadedSelector, loadingSelector], function (loaded, loading) {
    if (loaded) {
        var time = Date.now();
        var diff = time - loaded;
        if (diff < REDUX_STORE_TIME) return false;
    }
    return !loading;
});

/* ACTION CREATORS */
var fetchWonItemsIfNeeded = exports.fetchWonItemsIfNeeded = function fetchWonItemsIfNeeded(_ref) {
    var page = _ref.page,
        pageSize = _ref.pageSize;
    return function () {
        var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch, getState) {
            var state;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            state = getState();

                            if (!shouldFetchWonItems(state)) {
                                _context.next = 8;
                                break;
                            }

                            page = page || getWonItemsPage(state);
                            pageSize = pageSize || getWonItemsPageSize(state);
                            _context.next = 6;
                            return changeWonItemsPage({ force: true, page: page, pageSize: pageSize })(dispatch, getState);

                        case 6:
                            _context.next = 9;
                            break;

                        case 8:
                            return _context.abrupt('return', _promise2.default.resolve());

                        case 9:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, undefined);
        }));

        return function (_x3, _x4) {
            return _ref2.apply(this, arguments);
        };
    }();
};

var changeWonItemsPage = exports.changeWonItemsPage = function changeWonItemsPage(_ref3) {
    var page = _ref3.page,
        pageSize = _ref3.pageSize,
        force = _ref3.force;
    return function () {
        var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(dispatch, getState) {
            var state, oldPage, oldPageSize, dirty, authToken, deployment, bidderId, response;
            return _regenerator2.default.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            state = getState();
                            oldPage = getWonItemsPage(state);
                            oldPageSize = getWonItemsPageSize(state);
                            dirty = false;


                            if (oldPage !== page) {
                                dirty = true;
                                dispatch({
                                    payload: Number(page),
                                    type: CHANGE_WON_ITEMS_PAGE
                                });
                            }

                            if (oldPageSize !== pageSize) {
                                dirty = true;
                                dispatch({
                                    payload: Number(pageSize),
                                    type: CHANGE_WON_ITEMS_PAGE_SIZE
                                });
                            }

                            if (!(dirty || force)) {
                                _context2.next = 21;
                                break;
                            }

                            _context2.prev = 7;
                            authToken = (0, _user.getAuthToken)(state);
                            deployment = (0, _config.getDeployment)(state);
                            bidderId = (0, _user.getBidderId)(state);


                            dispatch({
                                meta: { actionTime: Date.now() },
                                type: LOAD_WON_ITEMS_REQUEST
                            });
                            _context2.next = 14;
                            return _api.WonItems.fetchWonItems({ authToken: authToken, bidderId: bidderId, deployment: deployment, page: page, pageSize: pageSize });

                        case 14:
                            response = _context2.sent;

                            dispatch({
                                meta: { actionTime: Date.now() },
                                payload: response.data,
                                type: LOAD_WON_ITEMS_SUCCESS
                            });
                            _context2.next = 21;
                            break;

                        case 18:
                            _context2.prev = 18;
                            _context2.t0 = _context2['catch'](7);

                            dispatch({
                                error: true,
                                payload: _context2.t0,
                                type: LOAD_WON_ITEMS_FAIL
                            });

                        case 21:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, undefined, [[7, 18]]);
        }));

        return function (_x5, _x6) {
            return _ref4.apply(this, arguments);
        };
    }();
};

/***/ }),

/***/ "V37k":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ItemFacetsMock = undefined;

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _delay = __webpack_require__("kRHc");

var _delay2 = _interopRequireDefault(_delay);

var _mockData = __webpack_require__("6VmH");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ItemFacetsMock = exports.ItemFacetsMock = {
    fetchItemFacets: function fetchItemFacets(itemIds) {
        return new _promise2.default(function (resolve) {
            setTimeout(function () {
                var itemFacets = itemIds.map(function (x) {
                    return (0, _mockData.getTestItemFacets)(x);
                });
                resolve({
                    data: {
                        data: itemFacets
                    }
                });
            }, _delay2.default);
        });
    }
};

/***/ }),

/***/ "VFQi":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (payload) {
    if (payload && payload.response && payload.response.body && payload.response.body.result && payload.response.body.result.content) {
        return payload.response.body.result.content;
    } else if (payload.message) {
        return payload.message;
    } else {
        return 'Error Making the request';
    }
};

module.exports = exports['default'];

/***/ }),

/***/ "VWZ9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getFacetIds = exports.getItemSavedSearchType = exports.getItemSavedSearchQuery = undefined;

var _isEmpty = __webpack_require__("lHK6");

var _isEmpty2 = _interopRequireDefault(_isEmpty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getCategoryName(facet) {
    var categoryId = facet.categoryId;


    if (categoryId === facet.l1CategoryId) {
        return facet.l1CategoryName;
    } else if (categoryId === facet.l2CategoryId) {
        return facet.l2CategoryName;
    } else if (categoryId === facet.l3CategoryId) {
        return facet.l3CategoryName;
    } else if (categoryId === facet.l4CategoryId) {
        return facet.l4CategoryName;
    }
}

function processFacets(facets) {
    /*
    * Order of Precedence for Search Alert
    * [creator + category]
    * [material + category]
    * [style + category]
    * [origin + category]
    * [origin + material]
    * [category]
    */
    var searchQuery = { keyword: '' };
    var searchType = '';

    if ((0, _isEmpty2.default)(facets)) return { searchQuery: searchQuery, searchType: searchType };
    var categories = facets.categories,
        creators = facets.creators,
        materialsTechniques = facets.materialsTechniques,
        origins = facets.origins,
        stylePeriods = facets.stylePeriods;


    if (creators.length && categories.length) {
        var ids = creators[0].l1CategoryId + ',' + categories[0].categoryId;

        searchQuery.category_id = ids;
        searchType = creators[0].l1CategoryName + ' ' + getCategoryName(categories[0]);
    } else if (materialsTechniques.length && categories.length) {
        var _ids = materialsTechniques[0].l1CategoryId + ',' + categories[0].categoryId;

        searchQuery.category_id = _ids;
        searchType = materialsTechniques[0].l1CategoryName + ' ' + getCategoryName(categories[0]);
    } else if (stylePeriods.length && categories.length) {
        var _ids2 = stylePeriods[0].l1CategoryId + ',' + categories[0].categoryId;

        searchQuery.category_id = _ids2;
        searchType = stylePeriods[0].l1CategoryName + ' ' + getCategoryName(categories[0]);
    } else if (origins.length && categories.length) {
        var _ids3 = origins[0].categoryId + ',' + categories[0].categoryId;

        searchQuery.category_id = _ids3;
        searchType = getCategoryName(origins[0]) + ' ' + getCategoryName(categories[0]);
    } else if (origins.length && materialsTechniques.length) {
        var _ids4 = origins[0].categoryId + ',' + materialsTechniques[0].l1CategoryId;

        searchQuery.category_id = _ids4;
        searchType = getCategoryName(origins[0]) + ' ' + materialsTechniques[0].l1CategoryName;
    } else if (categories.length) {
        var _ids5 = '' + categories[0].categoryId;

        searchQuery.category_id = _ids5;
        searchType = '' + getCategoryName(categories[0]);
    }

    return { searchQuery: searchQuery, searchType: searchType };
}

var getItemSavedSearchQuery = exports.getItemSavedSearchQuery = function getItemSavedSearchQuery(facets) {
    var _processFacets = processFacets(facets),
        searchQuery = _processFacets.searchQuery;

    return searchQuery;
};

var getItemSavedSearchType = exports.getItemSavedSearchType = function getItemSavedSearchType(facets) {
    var _processFacets2 = processFacets(facets),
        searchType = _processFacets2.searchType;

    return searchType;
};

var getFacetIds = exports.getFacetIds = function getFacetIds(facets) {
    var ids = [];
    if ((0, _isEmpty2.default)(facets)) return ids;

    var categories = facets.categories,
        creators = facets.creators,
        materialsTechniques = facets.materialsTechniques,
        origins = facets.origins,
        stylePeriods = facets.stylePeriods;

    if (categories.length) {
        ids.push(categories[0].categoryId);
    }
    if (creators.length) {
        ids.push(creators[0].l1CategoryId);
    }
    if (materialsTechniques.length) {
        ids.push(materialsTechniques[0].l1CategoryId);
    }
    if (origins.length) {
        ids.push(origins[0].categoryId);
    }
    if (stylePeriods.length) {
        ids.push(stylePeriods[0].l1CategoryId);
    }
    return ids;
};

/***/ }),

/***/ "VqFm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"catalog-grid":"catalog-grid___IQeKs","card":"card___3dX00"};

/***/ }),

/***/ "VxOq":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _keys = __webpack_require__("fZjL");

var _keys2 = _interopRequireDefault(_keys);

var _jsx2 = __webpack_require__("dcb+");

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _ControlLabel = __webpack_require__("TpLs");

var _ControlLabel2 = _interopRequireDefault(_ControlLabel);

var _Form = __webpack_require__("OoIh");

var _Form2 = _interopRequireDefault(_Form);

var _FormControl = __webpack_require__("qAYn");

var _FormControl2 = _interopRequireDefault(_FormControl);

var _FormGroup = __webpack_require__("lyyJ");

var _FormGroup2 = _interopRequireDefault(_FormGroup);

var _components = __webpack_require__("bGai");

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propsComparer = __webpack_require__("wsGv");

var _propsComparer2 = _interopRequireDefault(_propsComparer);

var _debounce = __webpack_require__("O4Lo");

var _debounce2 = _interopRequireDefault(_debounce);

var _reactFontawesome = __webpack_require__("f7W8");

var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);

var _reactIntl = __webpack_require__("Pq8k");

var _NoResults = __webpack_require__("7oIq");

var _NoResults2 = _interopRequireDefault(_NoResults);

var _preventDefault = __webpack_require__("/lBP");

var _preventDefault2 = _interopRequireDefault(_preventDefault);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _SearchStatus = __webpack_require__("2xKK");

var _SearchStatus2 = _interopRequireDefault(_SearchStatus);

var _PaginateSortFilter = __webpack_require__("yriu");

var _PaginateSortFilter2 = _interopRequireDefault(_PaginateSortFilter);

var _caterwaulComponents = __webpack_require__("7T5E");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VIEWS_TO_SHOW = [24, 48, 72, 96, 120, 'all'];

var PaginateSortFilter = (_temp = _class = function (_Component) {
    (0, _inherits3.default)(PaginateSortFilter, _Component);

    function PaginateSortFilter(props, context) {
        (0, _classCallCheck3.default)(this, PaginateSortFilter);

        var _this = (0, _possibleConstructorReturn3.default)(this, (PaginateSortFilter.__proto__ || (0, _getPrototypeOf2.default)(PaginateSortFilter)).call(this, props, context));

        _this.handlePageSizeChange = function (event) {
            _this.changePageSize(event.target.value);
        };

        _this.handleSearchChange = function (event) {
            _this.setSearch(event.target.value);
        };

        _this.handleSortChange = function (event) {
            var value = event.target.value;

            _this.props.replaceQueryParam({ sort: value });
        };

        _this.changePage = function (selected) {
            var page = selected + 1; // selected is base 0, we need base 1;
            if (selected === 0) {
                _this.props.removeQueryParam('page');
            } else if (_this.props.page !== page) {
                _this.props.pushQueryParam({ page: page });
            }
        };

        _this.changePageSize = function (pageSize) {
            // it's necessary to manually set the page size before navigating
            // because we need to read it off the cookie, not the params.
            // at some point this might enjoy a refactor, consolidating this
            // with the pattern used in the search page.
            _this.props.changePaginationPageSize(pageSize);
            _this.props.pushQueryParam({});
        };

        _this.setSearch = function (value) {
            if (value) {
                var search = value.toLowerCase().trim();
                _this.props.replaceQueryParam({ terms: search });
            } else {
                _this.props.removeQueryParam('terms');
            }
        };

        _this.mapViewOptions = function (option, index) {
            var label = option === 'all' ? _this.context.intl.formatMessage({ id: option }) : option;
            return (0, _jsx3.default)('option', {
                value: option
            }, index, label);
        };

        _this.mapSortByOptions = function (option, index) {
            var label = _this.context.intl.formatMessage({ id: option.toLowerCase() });
            return (0, _jsx3.default)('option', {
                value: option
            }, index, label);
        };

        _this.clearSearch = function () {
            _this.setSearch('');
            _this.input.value = '';
        };

        _this.preventDefault = _preventDefault2.default;

        _this.setSearch = (0, _debounce2.default)(_this.setSearch, 300);
        return _this;
    }

    (0, _createClass3.default)(PaginateSortFilter, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            if (this.props.searchTerms) {
                this.input.value = this.props.searchTerms;
            }
        }
    }, {
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps) {
            return (0, _propsComparer2.default)(this.props, nextProps, ['children', 'className', 'empty', 'emptyMessage', 'filteredItemCount', 'isLoading', 'items', 'page', 'pageSize', 'pathname', 'searchTerms', 'sortOptions', 'sortOrder', 'throbberMessage', 'totalItemsCount', 'viewsToShow']);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                children = _props.children,
                className = _props.className,
                baseUrl = _props.baseUrl,
                empty = _props.empty,
                emptyMessage = _props.emptyMessage,
                filteredItemCount = _props.filteredItemCount,
                isLoading = _props.isLoading,
                items = _props.items,
                page = _props.page,
                pageSize = _props.pageSize,
                pathname = _props.pathname,
                searchTerms = _props.searchTerms,
                sortOptions = _props.sortOptions,
                sortOrder = _props.sortOrder,
                throbberMessage = _props.throbberMessage,
                totalItemsCount = _props.totalItemsCount,
                type = _props.type,
                viewsToShow = _props.viewsToShow;
            var formatMessage = this.context.intl.formatMessage;


            var viewOptions = viewsToShow.map(this.mapViewOptions);
            var sortByOptions = (0, _keys2.default)(sortOptions).map(this.mapSortByOptions);
            var placeholderMessage = isLoading ? formatMessage({ id: 'loading' }) : totalItemsCount + ' ' + type;

            return (0, _jsx3.default)('div', {
                className: _PaginateSortFilter2.default['paginate-sort-filter'] + ' ' + className
            }, void 0, !empty && (0, _jsx3.default)(_Form2.default, {
                className: _PaginateSortFilter2.default.controls,
                inline: true,
                onSubmit: this.preventDefault
            }, void 0, (0, _jsx3.default)(_FormGroup2.default, {
                className: _PaginateSortFilter2.default.search,
                controlId: 'search',
                validationState: 'success'
            }, void 0, (0, _jsx3.default)(_ControlLabel2.default, {}, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'search'
            }), ':\xA0'), (0, _jsx3.default)(_FormControl2.default, {
                type: 'search',
                inputRef: function inputRef(ref) {
                    _this2.input = ref;
                },
                placeholder: placeholderMessage,
                onChange: this.handleSearchChange
            }), (0, _jsx3.default)(_FormControl2.default.Feedback, {
                bsClass: _PaginateSortFilter2.default['search-icon']
            }, void 0, (0, _jsx3.default)(_reactFontawesome2.default, {
                icon: ['fas', 'search'],
                style: { height: '14px', width: '14px' }
            }))), isLoading && (0, _jsx3.default)('div', {
                className: _PaginateSortFilter2.default['my-bids-throbber']
            }, void 0, (0, _jsx3.default)(_caterwaulComponents.Throbber, {
                className: _PaginateSortFilter2.default.throbber,
                color: '#0097BA'
            }), throbberMessage), (0, _jsx3.default)(_components.Input, {
                className: _PaginateSortFilter2.default['page-size'],
                label: (0, _jsx3.default)('span', {}, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                    id: 'view'
                }), ':\xA0'),
                onChange: this.handlePageSizeChange,
                placeholder: formatMessage({ id: 'select' }),
                small: true,
                type: 'select',
                value: pageSize
            }, void 0, viewOptions), (0, _jsx3.default)(_components.Input, {
                className: _PaginateSortFilter2.default['sort-by'],
                label: (0, _jsx3.default)('span', {}, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                    id: 'sort'
                }), ':\xA0'),
                onChange: this.handleSortChange,
                placeholder: formatMessage({ id: 'select' }),
                small: true,
                type: 'select',
                value: sortOrder
            }, void 0, 'options=', sortByOptions)), (0, _jsx3.default)(_SearchStatus2.default, {
                itemCount: filteredItemCount,
                search: searchTerms,
                clear: this.clearSearch
            }), !empty ? (0, _jsx3.default)('div', {
                className: _PaginateSortFilter2.default['grid-wrapper']
            }, void 0, children) : (0, _jsx3.default)(_NoResults2.default, {}, void 0, emptyMessage), !!items.length && (0, _jsx3.default)(_components.PaginationWrapper, {
                availableViews: viewsToShow,
                baseUrl: baseUrl,
                items: items,
                filteredItemCount: filteredItemCount,
                onPageChange: this.changePage,
                onPageSizeChange: this.changePageSize,
                onSubmit: this.preventDefault,
                page: page,
                pageSize: pageSize,
                pathname: pathname,
                totalItemsCount: totalItemsCount
            }));
        }
    }]);
    return PaginateSortFilter;
}(_react.Component), _class.contextTypes = {
    intl: _propTypes2.default.object.isRequired
}, _class.defaultProps = {
    className: '',
    isLoading: false,
    items: [],
    page: 1,
    searchTerms: '',
    throbberMessage: '',
    totalItemsCount: 0,
    type: 'lots',
    viewsToShow: VIEWS_TO_SHOW
}, _temp);
exports.default = PaginateSortFilter;
module.exports = exports['default'];

/***/ }),

/***/ "W0mi":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _redux = __webpack_require__("2KeS");

var _reactRedux = __webpack_require__("RH2O");

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("GiK3");

var _analytics = __webpack_require__("yxCd");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FullStory = (_dec = (0, _reactRedux.connect)(function () {
    return {};
}, function (dispatch) {
    return (0, _redux.bindActionCreators)({
        saveFullStorySessionUrl: _analytics.saveFullStorySessionUrl
    }, dispatch);
}), _dec(_class = function (_PureComponent) {
    (0, _inherits3.default)(FullStory, _PureComponent);

    function FullStory() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, FullStory);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = FullStory.__proto__ || (0, _getPrototypeOf2.default)(FullStory)).call.apply(_ref, [this].concat(args))), _this), _this.tryToSaveSessionUrl = function () {
            var sessionUrl = '';
            if (window.FS && window.FS.getCurrentSessionURL) {
                sessionUrl = window.FS.getCurrentSessionURL();
                if (sessionUrl) {
                    _this.props.saveFullStorySessionUrl(sessionUrl);
                }
            }
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(FullStory, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            this.tryToSaveSessionUrl();
            window['_fs_ready'] = function () {
                _this2.tryToSaveSessionUrl();
            };
        }
    }, {
        key: 'render',
        value: function render() {
            return null;
        }
    }]);
    return FullStory;
}(_react.PureComponent)) || _class);
exports.default = FullStory;
module.exports = exports['default'];

/***/ }),

/***/ "W5uo":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"seemore":"seemore___3uU-3"};

/***/ }),

/***/ "WGE/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__("GiK3");

var _reactCookie = __webpack_require__("Zld1");

var _reactCookie2 = _interopRequireDefault(_reactCookie);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Auth = function (_Component) {
    (0, _inherits3.default)(Auth, _Component);

    function Auth() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, Auth);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Auth.__proto__ || (0, _getPrototypeOf2.default)(Auth)).call.apply(_ref, [this].concat(args))), _this), _this.getExp = function () {
            var token = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

            var splitToken = token.split('.');
            if (splitToken.length < 2) {
                console.warn('Failed to decode JWT expiration');
                return;
            }
            try {
                var payload = JSON.parse(atob(splitToken[1]));
                return new Date(payload.exp * 1000);
            } catch (e) {
                console.warn('Failed to decode JWT expiration', e);
            }
        }, _this.setAuthCookie = function (authToken, expires) {
            _reactCookie2.default.save('bidder-auth', authToken, {
                domain: '.liveauctioneers.com',
                expires: expires,
                path: '/'
            });
        }, _this.setMainhostCookies = function (mainhostLogin, expires) {
            _reactCookie2.default.save('5Xq_name', mainhostLogin.authName, {
                domain: '.liveauctioneers.com',
                expires: expires,
                path: '/'
            });
            _reactCookie2.default.save('5Xq_nuid', mainhostLogin.authNuid, {
                domain: '.liveauctioneers.com',
                expires: expires,
                path: '/'
            });
            _reactCookie2.default.save('5Xq_nverify', mainhostLogin.authVerify, {
                domain: '.liveauctioneers.com',
                expires: expires,
                path: '/'
            });
        }, _this.unsetCookies = function () {
            _reactCookie2.default.remove('auctioneer-auth', { domain: '.liveauctioneers.com', path: '/' });
            _reactCookie2.default.remove('bidder-auth', { domain: '.liveauctioneers.com', path: '/' });
            _reactCookie2.default.remove('5Xq_name', { domain: '.liveauctioneers.com', path: '/' });
            _reactCookie2.default.remove('5Xq_nuid', { domain: '.liveauctioneers.com', path: '/' });
            _reactCookie2.default.remove('5Xq_nverify', { domain: '.liveauctioneers.com', path: '/' });
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(Auth, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            var nextAuthToken = nextProps.authToken,
                nextMainhostLogin = nextProps.mainhostLogin,
                nextUserLoggedIn = nextProps.userLoggedIn;


            if (!this.props.authToken && nextAuthToken || !!nextAuthToken && this.props.authToken !== nextAuthToken) {
                var expires = this.getExp(nextAuthToken);

                this.setAuthCookie(nextAuthToken, expires);
                if (nextMainhostLogin.authVerify) {
                    this.setMainhostCookies(nextMainhostLogin, expires);
                }
            }

            if (this.props.userLoggedIn && !nextUserLoggedIn) {
                this.unsetCookies();
            }
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps) {
            if (this.props.userData && !prevProps.userData) {
                this.props.recordAnalyticsForIdentify({ bidder: this.props.userData });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            return null;
        }
    }]);
    return Auth;
}(_react.Component);

exports.default = Auth;
module.exports = exports['default'];

/***/ }),

/***/ "WH74":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"search-status":"search-status___3K4mv","no-match":"no-match___1q6FH","space":"space___2NO7v","match":"match___PaKCt","results-for":"results-for___3ik-J","searching-for":"searching-for___3uOf_","search":"search___3hblH","throbber-wrapper":"throbber-wrapper___UNLdM","throbber":"throbber___-OiqL","clear":"clear___2xtP9"};

/***/ }),

/***/ "WWzX":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fetchItemFacetsIfNeeded = exports.isItemFacetsLoading = exports.getLoadTimeForItemFacets = exports.getItemFacets = exports.LOAD_ITEM_FACETS_SUCCESS = exports.LOAD_ITEM_FACETS_REQUEST = exports.LOAD_ITEM_FACETS_FAIL = undefined;

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;

var _api = __webpack_require__("zFQO");

var _cloneDeep = __webpack_require__("kvU2");

var _cloneDeep2 = _interopRequireDefault(_cloneDeep);

var _reselect = __webpack_require__("bndy");

var _difference = __webpack_require__("WlNK");

var _difference2 = _interopRequireDefault(_difference);

var _config = __webpack_require__("iS9E");

var _isEmpty = __webpack_require__("lHK6");

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _ms = __webpack_require__("EarI");

var _ms2 = _interopRequireDefault(_ms);

var _union = __webpack_require__("gszD");

var _union2 = _interopRequireDefault(_union);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Action Types */
var LOAD_ITEM_FACETS_FAIL = exports.LOAD_ITEM_FACETS_FAIL = 'la/domain/itemFacet/LOAD_FAIL';
var LOAD_ITEM_FACETS_REQUEST = exports.LOAD_ITEM_FACETS_REQUEST = 'la/domain/itemFacet/LOAD_REQUEST';
var LOAD_ITEM_FACETS_SUCCESS = exports.LOAD_ITEM_FACETS_SUCCESS = 'la/domain/itemFacet/LOAD_SUCCESS';

var REDUX_STORE_TIME = (0, _ms2.default)('30m');

/* reducer */
var DEFAULT_STATE = {
    byId: {},
    loaded: {},
    loading: []
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var existing = void 0;
    var loaded = void 0;
    var loading = void 0;
    var time = void 0;

    switch (action.type) {
        case LOAD_ITEM_FACETS_FAIL:
            return (0, _extends3.default)({}, state, {
                loading: (0, _difference2.default)((0, _cloneDeep2.default)(state.loading), action.meta.itemIds)
            });
        case LOAD_ITEM_FACETS_REQUEST:
            return (0, _extends3.default)({}, state, {
                loading: (0, _union2.default)((0, _cloneDeep2.default)(state.loading), action.payload)
            });
        case LOAD_ITEM_FACETS_SUCCESS:
            existing = (0, _cloneDeep2.default)(state.byId);
            loaded = (0, _cloneDeep2.default)(state.loaded);
            loading = (0, _cloneDeep2.default)(state.loading);
            time = action.meta.actionTime;

            (0, _cloneDeep2.default)(action.payload).forEach(function (facets) {
                var itemId = facets.itemId;

                delete facets.itemId;
                existing[itemId] = (0, _extends3.default)({}, facets);
                loaded[itemId] = time;
                loading = (0, _difference2.default)(loading, [itemId]);
            });

            return (0, _extends3.default)({}, state, {
                byId: existing,
                loaded: loaded,
                loading: loading
            });
        default:
            return state;
    }
}

/* SELECTORS */
var stateSelector = function stateSelector(state) {
    return state.domain.itemFacets;
};
var idSelector = function idSelector(state, id) {
    return id;
};

var byIdSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.byId;
});

var loadedSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.loaded;
});

var loadingSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.loading;
});

var getItemFacets = exports.getItemFacets = (0, _reselect.createSelector)([byIdSelector, idSelector], function (byId, id) {
    return (0, _cloneDeep2.default)(byId[id]) || {};
});

var getLoadTimeForItemFacets = exports.getLoadTimeForItemFacets = (0, _reselect.createSelector)([loadedSelector, idSelector], function (loaded, id) {
    return loaded[id] || 0;
});

var isItemFacetsLoading = exports.isItemFacetsLoading = (0, _reselect.createSelector)([loadingSelector, idSelector], function (loading, id) {
    return loading.includes(id);
});

var shouldFetchItemFacets = function shouldFetchItemFacets(state, itemId) {
    var data = getItemFacets(state, itemId);
    if (!(0, _isEmpty2.default)(data)) {
        var loaded = getLoadTimeForItemFacets(state, itemId);
        var time = Date.now();
        var diff = time - loaded;
        if (diff < REDUX_STORE_TIME) return false;
    }
    var loading = isItemFacetsLoading(state, itemId);
    return !loading;
};

var whichItemFacetsNeeded = function whichItemFacetsNeeded(state, itemIds) {
    return itemIds.filter(function (itemId) {
        return shouldFetchItemFacets(state, itemId);
    });
};

/* ACTION CREATORS */
var loadItemFacetsFail = function loadItemFacetsFail(itemIds, error) {
    return {
        error: true,
        meta: { itemIds: itemIds },
        payload: error,
        type: LOAD_ITEM_FACETS_FAIL
    };
};

var loadItemFacetsRequest = function loadItemFacetsRequest(itemIds) {
    return {
        payload: itemIds,
        type: LOAD_ITEM_FACETS_REQUEST
    };
};

var loadItemFacetsSuccess = function loadItemFacetsSuccess(itemIds, results) {
    return {
        meta: { actionTime: Date.now(), itemIds: itemIds },
        payload: results,
        type: LOAD_ITEM_FACETS_SUCCESS
    };
};

var loadItemFacets = function loadItemFacets(itemIds) {
    return function (dispatch, getState) {
        var state = getState();
        var deployment = (0, _config.getDeployment)(state);
        dispatch(loadItemFacetsRequest(itemIds));
        return _api.ItemFacets.fetchItemFacets({ deployment: deployment, ids: itemIds }).then(function (response) {
            dispatch(loadItemFacetsSuccess(itemIds, response.data));
        }).catch(function (error) {
            dispatch(loadItemFacetsFail(itemIds, error));
        });
    };
};

var fetchItemFacetsIfNeeded = exports.fetchItemFacetsIfNeeded = function fetchItemFacetsIfNeeded(itemIds) {
    return function (dispatch, getState) {
        var neededItems = whichItemFacetsNeeded(getState(), itemIds);
        if (neededItems.length) {
            return dispatch(loadItemFacets(neededItems));
        }
        return _promise2.default.resolve();
    };
};

/***/ }),

/***/ "WcsR":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = __webpack_require__("dcb+");

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__("Pq8k");

var _components = __webpack_require__("bGai");

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _WhiteLabelCrown = __webpack_require__("a3vv");

var _WhiteLabelCrown2 = _interopRequireDefault(_WhiteLabelCrown);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WhiteLabelCrown = function (_PureComponent) {
    (0, _inherits3.default)(WhiteLabelCrown, _PureComponent);

    function WhiteLabelCrown() {
        (0, _classCallCheck3.default)(this, WhiteLabelCrown);
        return (0, _possibleConstructorReturn3.default)(this, (WhiteLabelCrown.__proto__ || (0, _getPrototypeOf2.default)(WhiteLabelCrown)).apply(this, arguments));
    }

    (0, _createClass3.default)(WhiteLabelCrown, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                name = _props.name,
                url = _props.url;


            return (0, _jsx3.default)('div', {
                className: _WhiteLabelCrown2.default.crown
            }, void 0, (0, _jsx3.default)('div', {
                className: _WhiteLabelCrown2.default['crown-inner']
            }, void 0, url.length > 0 && (0, _jsx3.default)(_components.Link, {
                to: url,
                secondary: true
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'return_to',
                values: { name: name }
            }))));
        }
    }]);
    return WhiteLabelCrown;
}(_react.PureComponent);

exports.default = WhiteLabelCrown;
module.exports = exports['default'];

/***/ }),

/***/ "X4s9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _assign = __webpack_require__("woOf");

var _assign2 = _interopRequireDefault(_assign);

var _keys = __webpack_require__("fZjL");

var _keys2 = _interopRequireDefault(_keys);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var flattenMessages = function flattenMessages(nestedMessages) {
    var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

    return (0, _keys2.default)(nestedMessages).reduce(function (messages, key) {
        var value = nestedMessages[key];
        var prefixedKey = prefix ? prefix + '.' + key : key;

        if (typeof value === 'string') {
            messages[prefixedKey] = value;
        } else {
            (0, _assign2.default)(messages, flattenMessages(value, prefixedKey));
        }

        return messages;
    }, {});
};

exports.default = flattenMessages;
module.exports = exports['default'];

/***/ }),

/***/ "XTPq":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fetchSearchFacetsIfNeeded = exports.getFetchFacetsSubmitted = exports.getRawArchivedSearchFacets = exports.getRawUpcomingSearchFacets = exports.LOAD_ARCHIVED_FACETS_SUCCESS = exports.LOAD_UPCOMING_FACETS_SUCCESS = exports.LOAD_FACETS_REQUEST = exports.LOAD_FACETS_FAIL = undefined;

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _toConsumableArray2 = __webpack_require__("Gu7T");

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.getRawSearchFacets = getRawSearchFacets;
exports.getRawSearchFacetsByParams = getRawSearchFacetsByParams;
exports.getArchivedAndUpcomingFacetValues = getArchivedAndUpcomingFacetValues;
exports.getSearchAuctionHouseFacetValues = getSearchAuctionHouseFacetValues;
exports.getSearchCountryFacetValues = getSearchCountryFacetValues;

var _user = __webpack_require__("CFLi");

var _search = __webpack_require__("9ad9");

var _api = __webpack_require__("zFQO");

var _cloneDeep = __webpack_require__("kvU2");

var _cloneDeep2 = _interopRequireDefault(_cloneDeep);

var _reselect = __webpack_require__("bndy");

var _config = __webpack_require__("iS9E");

var _uniqBy = __webpack_require__("VXg5");

var _uniqBy2 = _interopRequireDefault(_uniqBy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOAD_FACETS_FAIL = exports.LOAD_FACETS_FAIL = 'LOAD_FACETS_FAIL';
var LOAD_FACETS_REQUEST = exports.LOAD_FACETS_REQUEST = 'LOAD_FACETS_REQUEST';
var LOAD_UPCOMING_FACETS_SUCCESS = exports.LOAD_UPCOMING_FACETS_SUCCESS = 'LOAD_UPCOMING_FACETS_SUCCESS';
var LOAD_ARCHIVED_FACETS_SUCCESS = exports.LOAD_ARCHIVED_FACETS_SUCCESS = 'LOAD_ARCHIVED_FACETS_SUCCESS';

// reducer
var DEFAULT_STATE = {
    error: false,
    facets: {
        archived: [],
        upcoming: []
    },
    submitted: false,
    success: false
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        case LOAD_FACETS_REQUEST:
            return (0, _extends3.default)({}, state, {
                error: false,
                submitted: true,
                success: false
            });
        case LOAD_UPCOMING_FACETS_SUCCESS:
            return (0, _extends3.default)({}, state, {
                facets: (0, _extends3.default)({}, state.facets, {
                    upcoming: action.payload.facets
                }),
                submitted: false,
                success: true
            });
        case LOAD_ARCHIVED_FACETS_SUCCESS:
            return (0, _extends3.default)({}, state, {
                facets: (0, _extends3.default)({}, state.facets, {
                    archived: action.payload.facets
                }),
                submitted: false,
                success: true
            });
        case LOAD_FACETS_FAIL:
            return (0, _extends3.default)({}, state, {
                error: true,
                submitted: false,
                success: false
            });
        default:
            return state;
    }
}

/* SELECTORS */
var stateSelector = function stateSelector(state) {
    return state.ui.searchFacets;
};
var searchFacetsSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.facets;
});

var getRawUpcomingSearchFacets = exports.getRawUpcomingSearchFacets = (0, _reselect.createSelector)(searchFacetsSelector, _user.getUserExcludedFacets, function (facets, exclusions) {
    return (0, _user.annotateFacetExclusions)(facets.upcoming, exclusions);
});

var getRawArchivedSearchFacets = exports.getRawArchivedSearchFacets = (0, _reselect.createSelector)(searchFacetsSelector, _user.getUserExcludedFacets, function (facets, exclusions) {
    return (0, _user.annotateFacetExclusions)(facets.archived, exclusions);
});

function getRawSearchFacets(state) {
    var archiveSearch = (0, _search.isArchivedSearch)(state);
    return archiveSearch ? getRawArchivedSearchFacets(state) : getRawUpcomingSearchFacets(state);
}

function getRawSearchFacetsByParams(state, searchParams) {
    var archiveSearch = (0, _search.isArchivedSearchByParams)(searchParams);
    return archiveSearch ? getRawArchivedSearchFacets(state) : getRawUpcomingSearchFacets(state);
}

function getArchivedAndUpcomingFacetValues(state, facetId) {
    function auctionHouseFilter(facet) {
        return facet.id === facetId;
    }
    var facets = [];
    var doneFacets = [];

    if (getRawUpcomingSearchFacets(state).length) {
        var filtered = getRawUpcomingSearchFacets(state).filter(auctionHouseFilter);
        if (filtered.length) {
            facets = getRawUpcomingSearchFacets(state).filter(auctionHouseFilter)[0].options;
        }
    }
    if (getRawArchivedSearchFacets(state).length) {
        var _filtered = getRawArchivedSearchFacets(state).filter(auctionHouseFilter);
        if (_filtered.length) {
            doneFacets = getRawArchivedSearchFacets(state).filter(auctionHouseFilter)[0].options;
        }
    }

    var uniq = (0, _uniqBy2.default)([].concat((0, _toConsumableArray3.default)(facets), (0, _toConsumableArray3.default)(doneFacets)), function (facet) {
        return facet.id;
    });
    return uniq.length ? (0, _cloneDeep2.default)(uniq) : [];
}

function getSearchAuctionHouseFacetValues(state) {
    return getArchivedAndUpcomingFacetValues(state, 'auctionHouse');
}

function getSearchCountryFacetValues(state) {
    return getArchivedAndUpcomingFacetValues(state, 'countryCode');
}

var getFetchFacetsSubmitted = exports.getFetchFacetsSubmitted = function getFetchFacetsSubmitted(state) {
    return state.ui.searchFacets.submitted;
};

var shouldFetchUpcomingFacets = function shouldFetchUpcomingFacets(state) {
    return state.ui.searchFacets.error || state.ui.searchFacets.facets && state.ui.searchFacets.facets.upcoming && state.ui.searchFacets.facets.upcoming.length === 0;
};

var shouldFetchArchivedFacets = function shouldFetchArchivedFacets(state) {
    return state.ui.searchFacets.error || state.ui.searchFacets.facets && state.ui.searchFacets.facets.archived && state.ui.searchFacets.facets.archived.length === 0;
};

/* ACTION CREATORS */
var loadFacetsResultsFail = function loadFacetsResultsFail(error) {
    return {
        error: true,
        payload: error,
        type: LOAD_FACETS_FAIL
    };
};

var loadFacetsResultsRequest = function loadFacetsResultsRequest() {
    return {
        type: LOAD_FACETS_REQUEST
    };
};

var loadUpcomingFacetsResultsSuccess = function loadUpcomingFacetsResultsSuccess(results) {
    return {
        payload: results,
        type: LOAD_UPCOMING_FACETS_SUCCESS
    };
};

var loadArchivedFacetsResultsSuccess = function loadArchivedFacetsResultsSuccess(results) {
    return {
        payload: results,
        type: LOAD_ARCHIVED_FACETS_SUCCESS
    };
};

/* UTILITY FUNCTIONS */
var loadFacets = function loadFacets(archiveSearch) {
    return function (dispatch, getState) {
        var state = getState();
        var deployment = (0, _config.getDeployment)(state);
        dispatch(loadFacetsResultsRequest());
        var searchStatus = archiveSearch ? _search.DEFAULT_ARCHIVE_STATUSES : _search.DEFAULT_LIVE_STATUSES;
        var searchQuery = {
            options: {
                status: searchStatus
            }
        };

        return _api.Search.fetchSearchFacetsResults({ deployment: deployment, searchQuery: searchQuery }).then(function (results) {
            if (results.errorMessage) {
                dispatch(loadFacetsResultsFail(results));
            } else {
                var successResult = archiveSearch ? loadArchivedFacetsResultsSuccess(results) : loadUpcomingFacetsResultsSuccess(results);
                dispatch(successResult);
            }
        }).catch(function (error) {
            dispatch(loadFacetsResultsFail(error));
        });
    };
};

var fetchSearchFacetsIfNeeded = exports.fetchSearchFacetsIfNeeded = function fetchSearchFacetsIfNeeded(archiveSearch) {
    return function (dispatch, getState) {
        var state = getState();
        var shouldLoadFacets = archiveSearch ? shouldFetchArchivedFacets(state) : shouldFetchUpcomingFacets(state);
        if (shouldLoadFacets) {
            return dispatch(loadFacets(archiveSearch));
        }
        return _promise2.default.resolve();
    };
};

/***/ }),

/***/ "XnP6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var catalogItemsSortOrders = {
    /*eslint-disable */
    PRICE_HIGHEST_FIRST: 'PRICE_HIGHEST_FIRST',
    PRICE_LOWEST_FIRST: 'PRICE_LOWEST_FIRST',
    ESTIMATE_HIGHEST_FIRST: 'ESTIMATE_HIGHEST_FIRST',
    ESTIMATE_LOWEST_FIRST: 'ESTIMATE_LOWEST_FIRST',
    MOST_BIDS: 'MOST_BIDS',
    LEAST_BIDS: 'LEAST_BIDS',
    LOT_NUMBER_HIGHEST_FIRST: 'LOT_NUMBER_HIGHEST_FIRST',
    LOT_NUMBER_LOWEST_FIRST: 'LOT_NUMBER_LOWEST_FIRST'
    /*eslint-enable */
};

exports.default = catalogItemsSortOrders;
module.exports = exports['default'];

/***/ }),

/***/ "XoDl":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = __webpack_require__("dcb+");

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _urls = __webpack_require__("CakR");

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propsComparer = __webpack_require__("wsGv");

var _propsComparer2 = _interopRequireDefault(_propsComparer);

var _classnames = __webpack_require__("HW6M");

var _classnames2 = _interopRequireDefault(_classnames);

var _reactIntl = __webpack_require__("Pq8k");

var _discoverItems = __webpack_require__("nmQq");

var _categoryGrabber = __webpack_require__("Gd4V");

var _components = __webpack_require__("bGai");

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _DiscoverItems = __webpack_require__("4aul");

var _DiscoverItems2 = _interopRequireDefault(_DiscoverItems);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DiscoverItems = function (_Component) {
    (0, _inherits3.default)(DiscoverItems, _Component);

    function DiscoverItems() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, DiscoverItems);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = DiscoverItems.__proto__ || (0, _getPrototypeOf2.default)(DiscoverItems)).call.apply(_ref, [this].concat(args))), _this), _this.getAuctionHouseLink = function () {
            return (0, _jsx3.default)('div', {}, _this.props.seller.sellerId + '-' + _this.props.seller.name, (0, _jsx3.default)(_components.Link, {
                route: true,
                to: (0, _urls.getSellerUrl)(_this.props.seller.sellerId, _this.props.seller.name)
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'more_auctions_auctioneer'
            })));
        }, _this.getSimilarItemsLink = function () {
            var searchUrl = (0, _urls.getSimilarItemsUrl)(_this.props.item.title);

            return (0, _jsx3.default)('div', {}, 'similar-items', (0, _jsx3.default)(_components.Link, {
                route: true,
                to: searchUrl
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'similar_items'
            })));
        }, _this.getAuctioneerSimilarItemsLink = function () {
            var _this$props$item$titl = _this.props.item.title,
                title = _this$props$item$titl === undefined ? '' : _this$props$item$titl;

            var keyword = title.split(/\s+/g).map(function (word) {
                return '"' + word + '"';
            }).join(' OR ').replace(/"/g, '\\"');
            var params = '?parameters=' + encodeURIComponent('{"keyword":"' + keyword + '","status":["online", "live", "upcoming"], "house_id": "' + _this.props.seller.sellerId + '"}');
            var searchUrl = '/search' + params;
            return (0, _jsx3.default)('div', {}, 'similar-auctioneer-items', (0, _jsx3.default)(_components.Link, {
                route: true,
                to: searchUrl
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'similar_items_auctioneer'
            })));
        }, _this.getAuctionPriceResultsLink = function () {
            var facets = _this.props.facets;

            if (facets && facets.creators && facets.creators.length > 0) {
                var creator = (0, _categoryGrabber.getCategoryLevel)(facets.creators[0]);
                return (0, _jsx3.default)('div', {}, 'creator-price-guide-link', (0, _jsx3.default)(_components.Link, {
                    route: true,
                    to: (0, _urls.getPriceGuideUrl)(creator.categoryUrl, creator.categoryId)
                }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                    id: 'price_guid_discover',
                    values: { token: creator.categoryLabel }
                })));
            }
            return null;
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(DiscoverItems, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps) {
            return (0, _propsComparer2.default)(this.props, nextProps, ['className', 'facets', 'item', 'seller']);
        }
    }, {
        key: 'render',
        value: function render() {
            var auctionHouse = this.getAuctionHouseLink();
            var similarItems = this.getSimilarItemsLink();
            var similarAuctioneerItems = this.getAuctioneerSimilarItemsLink();
            var auctionPriceResultsLink = this.getAuctionPriceResultsLink();
            var links = (0, _discoverItems.generateDiscoverLinks)(this.props.facets, DiscoverItems.createCategoryLandingLink);
            var classes = (0, _classnames2.default)(_DiscoverItems2.default['discover-items'], this.props.className);
            return (0, _jsx3.default)('div', {
                className: classes
            }, void 0, (0, _jsx3.default)('div', {
                className: _DiscoverItems2.default.header
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'discover_items'
            })), (0, _jsx3.default)('div', {
                className: _DiscoverItems2.default.links
            }, void 0, links, auctionPriceResultsLink, auctionHouse, similarAuctioneerItems, similarItems));
        }
    }], [{
        key: 'createCategoryLandingLink',
        value: function createCategoryLandingLink(mainItem, secondItem) {
            var link = '';
            mainItem = (0, _categoryGrabber.getCategoryLevel)(mainItem);
            secondItem = (0, _categoryGrabber.getCategoryLevel)(secondItem);
            if (secondItem.categoryUrl) {
                link = (0, _jsx3.default)('div', {}, mainItem.categoryLabel + '-' + secondItem.categoryLabel, (0, _jsx3.default)(_components.Link, {
                    route: true,
                    to: '/c/' + mainItem.categoryUrl + '/' + secondItem.categoryUrl + '/' + mainItem.categoryId + '/' + secondItem.categoryId + '/'
                }, void 0, secondItem.categoryLabel + ' ' + mainItem.categoryLabel));
            } else if (mainItem) {
                link = (0, _jsx3.default)('div', {}, mainItem.categoryLabel + '}', (0, _jsx3.default)(_components.Link, {
                    route: true,
                    to: '/c/' + mainItem.categoryUrl + '/' + mainItem.categoryId + '/'
                }, void 0, '' + mainItem.categoryLabel));
            }
            return link;
        }
    }]);
    return DiscoverItems;
}(_react.Component);

exports.default = DiscoverItems;
module.exports = exports['default'];

/***/ }),

/***/ "Y7dY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"megaNav":"megaNav___2Zpak","seo":"seo___2yxLn","image":"image___2VCbW","container":"container___34mWo","column":"column___1yse7","wrapper":"wrapper___34buI","column-title":"column-title___39gVK"};

/***/ }),

/***/ "Y8Cm":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = __webpack_require__("dcb+");

var _jsx3 = _interopRequireDefault(_jsx2);

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Polyfill for webpack, just in case
if (false) require.ensure = function (d, c) {
    c(require);
};

var TermsModalLoader = function (_Component) {
    (0, _inherits3.default)(TermsModalLoader, _Component);

    function TermsModalLoader(props, context) {
        (0, _classCallCheck3.default)(this, TermsModalLoader);

        var _this = (0, _possibleConstructorReturn3.default)(this, (TermsModalLoader.__proto__ || (0, _getPrototypeOf2.default)(TermsModalLoader)).call(this, props, context));

        _this.state = {
            Component: null,
            mounted: false
        };
        return _this;
    }

    (0, _createClass3.default)(TermsModalLoader, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            var _this2 = this;

            return new _promise2.default(function (resolve) {
                __webpack_require__.e/* require.ensure */(50).then((function () {
                    resolve(__webpack_require__("LKlO"));
                }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            }).then(function (container) {
                _this2.setState({ Component: container });
            });
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.setState({ mounted: true });
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.setState({ mounted: false });
        }
    }, {
        key: 'render',
        value: function render() {
            var _state = this.state,
                Component = _state.Component,
                mounted = _state.mounted;

            return mounted && Component !== null ? (0, _jsx3.default)(Component, {}) : null;
        }
    }]);
    return TermsModalLoader;
}(_react.Component);

exports.default = TermsModalLoader;
module.exports = exports['default'];

/***/ }),

/***/ "YBb+":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx2 = __webpack_require__("dcb+");

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _config = __webpack_require__("iS9E");

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__("RH2O");

var _LACrown = __webpack_require__("/7aV");

var _LACrown2 = _interopRequireDefault(_LACrown);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(state) {
    return {
        baseUrl: (0, _config.getBaseUrl)(state),
        classicBaseUrl: (0, _config.getClassicBaseUrl)(state)
    };
};

var LACrownContainer = function (_Component) {
    (0, _inherits3.default)(LACrownContainer, _Component);

    function LACrownContainer() {
        (0, _classCallCheck3.default)(this, LACrownContainer);
        return (0, _possibleConstructorReturn3.default)(this, (LACrownContainer.__proto__ || (0, _getPrototypeOf2.default)(LACrownContainer)).apply(this, arguments));
    }

    (0, _createClass3.default)(LACrownContainer, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                baseUrl = _props.baseUrl,
                classicBaseUrl = _props.classicBaseUrl,
                location = _props.location;


            return (0, _jsx3.default)(_LACrown2.default, {
                baseUrl: baseUrl,
                classicBaseUrl: classicBaseUrl,
                location: location
            });
        }
    }]);
    return LACrownContainer;
}(_react.Component);

exports.default = (0, _reactRedux.connect)(mapStateToProps)(LACrownContainer);
module.exports = exports['default'];

/***/ }),

/***/ "YLee":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (html) {
    var wrapper = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'div';
    var old = arguments[2];

    var filter = old ? gentleOldFilter : gentleFilter;
    var safeHtml = filter.process(html).trim();
    try {
        safeHtml = htmlToReactParser.parse('<' + wrapper + '>' + safeHtml + '</' + wrapper + '>');
    } catch (e) {
        safeHtml = bruteFilter.process(html).trim();
    }
    return safeHtml;
};

var _htmlToReact = __webpack_require__("ohTo");

var _xss = __webpack_require__("NG4M");

var _xss2 = _interopRequireDefault(_xss);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// gently remove disallowed tags
var gentleOptions = {
    stripIgnoreTag: true,
    stripIgnoreTagBody: ['script', 'style'],
    whiteList: {
        a: ['alt', 'href', 'target'],
        b: [],
        br: [],
        i: [],
        img: ['width', 'height', 'src', 'srcset', 'title'],
        li: [],
        ol: [],
        p: [],
        strong: [],
        ul: []
    }
};
var gentleFilter = new _xss2.default.FilterXSS(gentleOptions);

var gentleOldOptions = {
    stripIgnoreTag: true,
    stripIgnoreTagBody: ['script', 'style', 'img'],
    whiteList: {
        a: ['alt', 'target'],
        b: [],
        br: [],
        i: [],
        li: [],
        ol: [],
        p: [],
        strong: [],
        ul: []
    }
};
var gentleOldFilter = new _xss2.default.FilterXSS(gentleOldOptions);

// Create a filter for removing all the html in the case that we fail parsing
var bruteOptions = {
    stripIgnoreTag: true, // filter out all HTML not in the whilelist
    stripIgnoreTagBody: ['script', 'style'], // the script tag is a special case, we need to filter out its content
    whiteList: [] // empty, means filter out all tags
};
var bruteFilter = new _xss2.default.FilterXSS(bruteOptions);

var htmlToReactParser = new _htmlToReact.Parser();

module.exports = exports['default'];

/***/ }),

/***/ "YaZr":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = __webpack_require__("dcb+");

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _OverlayTrigger = __webpack_require__("+uBL");

var _OverlayTrigger2 = _interopRequireDefault(_OverlayTrigger);

var _Popover = __webpack_require__("fdtx");

var _Popover2 = _interopRequireDefault(_Popover);

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propsComparer = __webpack_require__("wsGv");

var _propsComparer2 = _interopRequireDefault(_propsComparer);

var _reactIntl = __webpack_require__("Pq8k");

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ReservePopover = function (_Component) {
    (0, _inherits3.default)(ReservePopover, _Component);

    function ReservePopover() {
        (0, _classCallCheck3.default)(this, ReservePopover);
        return (0, _possibleConstructorReturn3.default)(this, (ReservePopover.__proto__ || (0, _getPrototypeOf2.default)(ReservePopover)).apply(this, arguments));
    }

    (0, _createClass3.default)(ReservePopover, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps) {
            return (0, _propsComparer2.default)(this.props, nextProps, ['id', 'styles']);
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                id = _props.id,
                styles = _props.styles;

            var reservePopover = (0, _jsx3.default)(_Popover2.default, {
                id: id,
                bsClass: styles['reserve-dispute-text'] + ' popover'
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'reserve_dispute_popover_text'
            }));
            var reserveOverlay = (0, _jsx3.default)(_OverlayTrigger2.default, {
                trigger: 'click',
                placement: 'bottom',
                overlay: reservePopover,
                rootClose: true
            }, void 0, (0, _jsx3.default)('span', {
                className: styles.reserve
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'reserve'
            })));
            return reserveOverlay;
        }
    }]);
    return ReservePopover;
}(_react.Component);

exports.default = ReservePopover;
module.exports = exports['default'];

/***/ }),

/***/ "YcIK":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fetchItemShippingsIfNeeded = exports.isItemShippingLoading = exports.getLoadTimeForItemShipping = exports.getItemShipping = exports.LOAD_ITEM_SHIPPING_SUCCESS = exports.LOAD_ITEM_SHIPPING_REQUEST = exports.LOAD_ITEM_SHIPPING_FAIL = undefined;

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;

var _api = __webpack_require__("zFQO");

var _cloneDeep = __webpack_require__("kvU2");

var _cloneDeep2 = _interopRequireDefault(_cloneDeep);

var _reselect = __webpack_require__("bndy");

var _difference = __webpack_require__("WlNK");

var _difference2 = _interopRequireDefault(_difference);

var _config = __webpack_require__("iS9E");

var _ms = __webpack_require__("EarI");

var _ms2 = _interopRequireDefault(_ms);

var _union = __webpack_require__("gszD");

var _union2 = _interopRequireDefault(_union);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Action Types */
var LOAD_ITEM_SHIPPING_FAIL = exports.LOAD_ITEM_SHIPPING_FAIL = 'la/domain/itemShipping/LOAD_FAIL';
var LOAD_ITEM_SHIPPING_REQUEST = exports.LOAD_ITEM_SHIPPING_REQUEST = 'la/domain/itemShipping/LOAD_REQUEST';
var LOAD_ITEM_SHIPPING_SUCCESS = exports.LOAD_ITEM_SHIPPING_SUCCESS = 'la/domain/itemShipping/LOAD_SUCCESS';

var REDUX_STORE_TIME = (0, _ms2.default)('30m');

/* reducer */
var DEFAULT_STATE = {
    byId: {},
    loaded: {},
    loading: []
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var existing = void 0;
    var loaded = void 0;
    var loading = void 0;
    var time = void 0;

    switch (action.type) {
        case LOAD_ITEM_SHIPPING_FAIL:
            return (0, _extends3.default)({}, state, {
                loading: (0, _difference2.default)(state.loading, action.meta.itemIds)
            });
        case LOAD_ITEM_SHIPPING_REQUEST:
            return (0, _extends3.default)({}, state, {
                loading: (0, _union2.default)(state.loading, action.payload)
            });
        case LOAD_ITEM_SHIPPING_SUCCESS:
            existing = (0, _cloneDeep2.default)(state.byId);
            loaded = (0, _cloneDeep2.default)(state.loaded);
            loading = (0, _cloneDeep2.default)(state.loading);
            time = action.meta.actionTime;

            if (action.payload.itemShippings) {
                action.payload.itemShippings.forEach(function (x) {
                    existing[x.itemId] = (0, _extends3.default)({}, x);
                    loaded[x.itemId] = time;
                    loading = (0, _difference2.default)(loading, [x.itemId]);
                });
            }

            return (0, _extends3.default)({}, state, {
                byId: existing,
                loaded: loaded,
                loading: loading
            });
        default:
            return state;
    }
}

/* SELECTORS */
var stateSelector = function stateSelector(state) {
    return state.domain.itemShipping;
};
var idSelector = function idSelector(state, id) {
    return id;
};

var byIdSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.byId;
});

var loadedSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.loaded;
});

var loadingSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.loading;
});

// takes in a (state, id) and passes both params to every function on
// the way down.
var getItemShipping = exports.getItemShipping = (0, _reselect.createSelector)([byIdSelector, idSelector], function (byId, id) {
    return byId[id] || {};
});

var getLoadTimeForItemShipping = exports.getLoadTimeForItemShipping = (0, _reselect.createSelector)([loadedSelector, idSelector], function (loaded, id) {
    return loaded[id] || 0;
});

var isItemShippingLoading = exports.isItemShippingLoading = (0, _reselect.createSelector)([loadingSelector, idSelector], function (loading, id) {
    return loading.includes(id);
});

var shouldFetchItemShipping = function shouldFetchItemShipping(state, itemId) {
    if (!itemId) return false;
    var item = getItemShipping(state, itemId);
    if (item) {
        var loaded = getLoadTimeForItemShipping(state, itemId);
        var time = Date.now();
        var diff = time - loaded;
        if (diff < REDUX_STORE_TIME) return false;
    }
    var loading = isItemShippingLoading(state, itemId);
    return !loading;
};

var whichItemShippingsNeeded = function whichItemShippingsNeeded(state, itemIds) {
    return itemIds.filter(function (itemId) {
        return shouldFetchItemShipping(state, itemId);
    });
};

/* ACTION CREATORS */
var loadItemShippings = function loadItemShippings(itemIds) {
    return function (dispatch, getState) {
        var state = getState();
        var deployment = (0, _config.getDeployment)(state);
        dispatch({
            payload: itemIds,
            type: LOAD_ITEM_SHIPPING_REQUEST
        });
        return _api.Item.fetchItemShippingsByIds({ deployment: deployment, itemIds: itemIds }).then(function (response) {
            dispatch({
                meta: { actionTime: Date.now(), itemIds: itemIds },
                payload: response.data,
                type: LOAD_ITEM_SHIPPING_SUCCESS
            });
        }).catch(function (error) {
            dispatch({
                error: true,
                meta: { itemIds: itemIds },
                payload: error,
                type: LOAD_ITEM_SHIPPING_FAIL
            });
        });
    };
};

var fetchItemShippingsIfNeeded = exports.fetchItemShippingsIfNeeded = function fetchItemShippingsIfNeeded(itemIds) {
    return function (dispatch, getState) {
        var needed = whichItemShippingsNeeded(getState(), itemIds);
        if (needed.length) {
            return dispatch(loadItemShippings(needed));
        }
        return _promise2.default.resolve();
    };
};

/***/ }),

/***/ "Ycpv":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    AUCTION_HOUSE_ID: 'auctionHouse',
    BUYERS_PREMIUM_ID: 'hasBuyersPremium',
    CATEGORY_ID: 'F1',
    COUNTRY_CODE_ID: 'countryCode',
    CREATOR_ID: 'creator',
    CURRENCY_ID: 'currency',
    CURRENT_BID_ID: 'currentBid',
    DISTANCE_ID: 'distance',
    ESTIMATED_PRICE_ID: 'estimate',
    HAMMER_PRICE_ID: 'hammerPrice',
    MATERIALS_AND_TECHNIQUES_ID: 'materialsAndTechniques',
    ORIGIN_ID: 'F2',
    STYLE_PERIOD_ID: 'stylePeriod'
};
module.exports = exports['default'];

/***/ }),

/***/ "YgC6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = __webpack_require__("dcb+");

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _components = __webpack_require__("bGai");

var _reactIntl = __webpack_require__("Pq8k");

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propsComparer = __webpack_require__("wsGv");

var _propsComparer2 = _interopRequireDefault(_propsComparer);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _live = __webpack_require__("o2ZH");

var _CardCta = __webpack_require__("O+2Z");

var _CardCta2 = _interopRequireDefault(_CardCta);

var _WhyCantRetractBidPopover = __webpack_require__("hvUq");

var _WhyCantRetractBidPopover2 = _interopRequireDefault(_WhyCantRetractBidPopover);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CardCta = (_temp2 = _class = function (_Component) {
    (0, _inherits3.default)(CardCta, _Component);

    function CardCta() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, CardCta);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = CardCta.__proto__ || (0, _getPrototypeOf2.default)(CardCta)).call.apply(_ref, [this].concat(args))), _this), _this.openBidModal = function () {
            _this.props.openAbstenteeBidModal(_this.props.item.itemId, 0);
        }, _this.openRetractBidModal = function () {
            _this.props.openRetractBidModal(_this.props.item.itemId);
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(CardCta, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps) {
            return (0, _propsComparer2.default)(this.props, nextProps, ['currency', 'catalogStatus', 'catalogId', 'isCatalogOnly', 'itemUrl', 'saleStartTs']) || (0, _propsComparer2.default)(this.props.item, nextProps.item, ['isAvailable', 'isPassed']) || (0, _propsComparer2.default)(this.props.biddingInfo, nextProps.biddingInfo, ['bidderHasHighBid', 'bidderMaxBid']);
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                biddingInfo = _props.biddingInfo,
                catalogId = _props.catalogId,
                catalogRegistration = _props.catalogRegistration,
                catalogStatus = _props.catalogStatus,
                currency = _props.currency,
                isCatalogOnly = _props.isCatalogOnly,
                itemUrl = _props.itemUrl,
                saleStartTs = _props.saleStartTs,
                sellerId = _props.sellerId,
                showSendSellerMessageModal = _props.showSendSellerMessageModal;
            var blockedByAuctioneer = catalogRegistration.blockedByAuctioneer,
                declined = catalogRegistration.declined,
                suspended = catalogRegistration.suspended;
            var bidderHasHighBid = biddingInfo.bidderHasHighBid,
                bidderMaxBid = biddingInfo.bidderMaxBid;


            var showLiveButton = (0, _live.shouldShowLive)(catalogStatus, isCatalogOnly, saleStartTs);

            if (!bidderMaxBid) {
                return null;
            }

            var bidAmount = (0, _jsx3.default)(_reactIntl.FormattedNumber, {
                currency: currency,
                maximumFractionDigits: 0,
                minimumFractionDigits: 0,
                style: 'currency',
                value: bidderMaxBid
            });

            var link = '';
            if (blockedByAuctioneer || suspended) {
                link = (0, _jsx3.default)(_components.Link, {
                    to: 'http://liveauctioneers.desk.com/',
                    className: _CardCta2.default['help-button']
                }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                    id: 'help_center'
                }));
            } else if (declined) {
                link = (0, _jsx3.default)(_components.ShouldLogInContainer, {
                    requireLogin: true,
                    requireCompleteProfile: true,
                    runFunction: showSendSellerMessageModal
                }, void 0, (0, _jsx3.default)(_components.Link, {}, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                    id: 'contact_auctioneer'
                })));
            } else if (catalogStatus === 'done') {
                link = (0, _jsx3.default)(_components.Link, {
                    to: itemUrl,
                    route: true
                }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                    id: 'view_similar_items'
                }));
            } else if (showLiveButton) {
                link = (0, _jsx3.default)(_components.BidConsoleOpener, {
                    catalogId: catalogId,
                    sellerId: sellerId
                }, void 0, (0, _jsx3.default)(_components.Link, {
                    className: _CardCta2.default.live
                }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                    id: 'enter_live_auction'
                })));
            } else {
                link = (0, _jsx3.default)(_components.Link, {
                    onClick: this.openBidModal
                }, void 0, bidderHasHighBid ? (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                    id: 'increase_max_of',
                    values: { bidAmount: bidAmount }
                }) : (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                    id: 'increase_bid_of',
                    values: { bidAmount: bidAmount }
                }));
            }

            var retractButton = void 0;
            if (catalogStatus === 'done') {
                retractButton = (0, _jsx3.default)('span', {
                    disabled: true,
                    className: _CardCta2.default.retract
                }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                    id: 'retract'
                }));
            } else if (catalogStatus === 'live') {
                retractButton = (0, _jsx3.default)('span', {
                    className: _CardCta2.default.retract
                }, void 0, (0, _jsx3.default)(_WhyCantRetractBidPopover2.default, {
                    id: 'whyCantRetractBidPopover',
                    styles: _CardCta2.default
                }));
            } else {
                retractButton = (0, _jsx3.default)('span', {
                    className: _CardCta2.default.retract,
                    onClick: this.openRetractBidModal
                }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                    id: 'retract'
                }));
            }

            return (0, _jsx3.default)('div', {
                className: _CardCta2.default['item-card-control']
            }, void 0, link, retractButton);
        }
    }]);
    return CardCta;
}(_react.Component), _class.defaultProps = {
    biddingInfo: {
        bidderMaxBid: 0
    },
    catalogRegistration: {
        blockedByAuctioneer: false,
        declined: false,
        suspended: false
    },
    catalogStatus: '',
    currency: 'USD',
    item: {}
}, _temp2);
exports.default = CardCta;
module.exports = exports['default'];

/***/ }),

/***/ "Ykd8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _saveSearch = __webpack_require__("6Sk3");

var SaveSearch = {
    deleteSavedSearch: _saveSearch.SaveSearchRemote.deleteSavedSearch,
    fetchSavedSearches: _saveSearch.SaveSearchRemote.fetchSavedSearches,
    fetchSavedSearchItems: _saveSearch.SaveSearchRemote.fetchSavedSearchItems,
    postDeleteSavedSearches: _saveSearch.SaveSearchRemote.postDeleteSavedSearches,
    postIsSavedSearch: _saveSearch.SaveSearchRemote.postIsSavedSearch,
    postSaveSearch: _saveSearch.SaveSearchRemote.postSaveSearch,
    postSubscribeToSavedSearches: _saveSearch.SaveSearchRemote.postSubscribeToSavedSearches,
    postUnsubscribeFromSavedSearches: _saveSearch.SaveSearchRemote.postUnsubscribeFromSavedSearches
};

exports.default = SaveSearch;
module.exports = exports['default'];

/***/ }),

/***/ "Z/Sy":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.BiddingInfoMock = undefined;

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _mockData = __webpack_require__("6VmH");

var _delay = __webpack_require__("kRHc");

var _delay2 = _interopRequireDefault(_delay);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BiddingInfoMock = exports.BiddingInfoMock = {
    fetchCatalogBidding: function fetchCatalogBidding(catalogId) {
        return new _promise2.default(function (resolve) {
            setTimeout(function () {
                var items = (0, _mockData.getTestItemsForCatalog)(catalogId);
                var itemIds = items.map(function (x) {
                    return x.itemId;
                });
                var infos = _mockData.mockBiddingInfos.filter(function (x) {
                    return itemIds.includes(x.itemId);
                });
                resolve({
                    data: infos
                });
            }, _delay2.default);
        });
    }
};

/***/ }),

/***/ "Z0wO":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = __webpack_require__("dcb+");

var _jsx3 = _interopRequireDefault(_jsx2);

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Polyfill for webpack, just in case
if (false) require.ensure = function (d, c) {
    c(require);
};

var AddSearchAlertModalLoader = function (_Component) {
    (0, _inherits3.default)(AddSearchAlertModalLoader, _Component);

    function AddSearchAlertModalLoader(props, context) {
        (0, _classCallCheck3.default)(this, AddSearchAlertModalLoader);

        var _this = (0, _possibleConstructorReturn3.default)(this, (AddSearchAlertModalLoader.__proto__ || (0, _getPrototypeOf2.default)(AddSearchAlertModalLoader)).call(this, props, context));

        _this.state = {
            Component: null,
            mounted: false
        };
        return _this;
    }

    (0, _createClass3.default)(AddSearchAlertModalLoader, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            var _this2 = this;

            return new _promise2.default(function (resolve) {
                __webpack_require__.e/* require.ensure */(49).then((function () {
                    resolve(__webpack_require__("Me27"));
                }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            }).then(function (container) {
                _this2.setState({ Component: container });
            });
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.setState({ mounted: true });
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.setState({ mounted: false });
        }
    }, {
        key: 'render',
        value: function render() {
            var _state = this.state,
                Component = _state.Component,
                mounted = _state.mounted;

            return mounted && Component !== null ? (0, _jsx3.default)(Component, {}) : null;
        }
    }]);
    return AddSearchAlertModalLoader;
}(_react.Component);

exports.default = AddSearchAlertModalLoader;
module.exports = exports['default'];

/***/ }),

/***/ "ZW0g":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

var _jsx2 = __webpack_require__("dcb+");

var _jsx3 = _interopRequireDefault(_jsx2);

var _toConsumableArray2 = __webpack_require__("Gu7T");

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propsComparer = __webpack_require__("wsGv");

var _propsComparer2 = _interopRequireDefault(_propsComparer);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactCustomScrollbars = __webpack_require__("8ri3");

var _ScrollBar = __webpack_require__("MJII");

var _ScrollBar2 = _interopRequireDefault(_ScrollBar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ScrollBar = (_temp = _class = function (_Component) {
    (0, _inherits3.default)(ScrollBar, _Component);

    function ScrollBar() {
        (0, _classCallCheck3.default)(this, ScrollBar);
        return (0, _possibleConstructorReturn3.default)(this, (ScrollBar.__proto__ || (0, _getPrototypeOf2.default)(ScrollBar)).apply(this, arguments));
    }

    (0, _createClass3.default)(ScrollBar, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps) {
            return (0, _propsComparer2.default)(this.props, nextProps, ['className', 'maxHeight', 'showScrollBar', 'children']);
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                className = _props.className,
                maxHeight = _props.maxHeight,
                showScrollBar = _props.showScrollBar;


            var classes = [].concat((0, _toConsumableArray3.default)(className.split(' ')), [_ScrollBar2.default.seeMoreItems]).join(' ').trim();
            var trackClass = showScrollBar ? _ScrollBar2.default['scroll-track'] : _ScrollBar2.default['hide-scroll-track'];
            var thumbClass = showScrollBar ? _ScrollBar2.default['scroll-thumb'] : _ScrollBar2.default['hide-scroll-thumb'];
            return (0, _jsx3.default)(_reactCustomScrollbars.Scrollbars, {
                autoHeight: true,
                autoHeightMax: maxHeight,
                hideTracksWhenNotNeeded: true,
                renderView: function renderView(props) {
                    return _react2.default.createElement('div', (0, _extends3.default)({}, props, { className: classes }));
                },
                renderTrackVertical: function renderTrackVertical(props) {
                    return _react2.default.createElement('div', (0, _extends3.default)({}, props, { className: trackClass }));
                },
                renderThumbVertical: function renderThumbVertical(props) {
                    return _react2.default.createElement('div', (0, _extends3.default)({}, props, { className: thumbClass }));
                },
                universal: true
            }, void 0, this.props.children);
        }
    }]);
    return ScrollBar;
}(_react.Component), _class.defaultProps = {
    className: '',
    maxHeight: 600,
    showScrollBar: true
}, _temp);
exports.default = ScrollBar;
module.exports = exports['default'];

/***/ }),

/***/ "ZXiL":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = __webpack_require__("dcb+");

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propsComparer = __webpack_require__("wsGv");

var _propsComparer2 = _interopRequireDefault(_propsComparer);

var _Carousel = __webpack_require__("Q90x");

var _Carousel2 = _interopRequireDefault(_Carousel);

var _classnames = __webpack_require__("HW6M");

var _classnames2 = _interopRequireDefault(_classnames);

var _components = __webpack_require__("bGai");

var _noop = __webpack_require__("9vKl");

var _noop2 = _interopRequireDefault(_noop);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ItemCardCarousel = __webpack_require__("orCU");

var _ItemCardCarousel2 = _interopRequireDefault(_ItemCardCarousel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ItemCardCarousel = (_temp2 = _class = function (_Component) {
    (0, _inherits3.default)(ItemCardCarousel, _Component);

    function ItemCardCarousel() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, ItemCardCarousel);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ItemCardCarousel.__proto__ || (0, _getPrototypeOf2.default)(ItemCardCarousel)).call.apply(_ref, [this].concat(args))), _this), _this.mapCarouselItems = function (item, itemIndex) {
            var _this$props = _this.props,
                showDate = _this$props.showDate,
                showEstimate = _this$props.showEstimate;

            if (item) {
                return (0, _jsx3.default)('div', {}, itemIndex, (0, _jsx3.default)(_components.ItemCard, {
                    cardViewModel: item,
                    hideLotNumbers: true,
                    hideSeller: true,
                    showDate: showDate,
                    showEstimate: showEstimate,
                    className: _ItemCardCarousel2.default.item,
                    last: false
                }));
            }
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(ItemCardCarousel, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps) {
            return (0, _propsComparer2.default)(this.props, nextProps, ['className', 'headerMessage', 'index', 'items']);
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                afterChange = _props.afterChange,
                className = _props.className,
                headerMessage = _props.headerMessage,
                index = _props.index,
                items = _props.items;


            var carouselItems = items.map(this.mapCarouselItems);

            // don't draw the carousel if we've got nothing to draw
            if (carouselItems.length < 2) {
                return null;
            }

            var classes = (0, _classnames2.default)(_ItemCardCarousel2.default.container, className);

            return (0, _jsx3.default)('div', {
                className: classes
            }, void 0, (0, _jsx3.default)('div', {
                className: _ItemCardCarousel2.default.header
            }, void 0, (0, _jsx3.default)('h2', {}, void 0, headerMessage)), (0, _jsx3.default)(_Carousel2.default, {
                afterChange: afterChange,
                index: index
            }, void 0, carouselItems));
        }
    }]);
    return ItemCardCarousel;
}(_react.Component), _class.defaultProps = {
    afterChange: _noop2.default,
    showDate: true,
    showEstimate: false
}, _temp2);
exports.default = ItemCardCarousel;
module.exports = exports['default'];

/***/ }),

/***/ "ZbCA":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _itemFacets = __webpack_require__("V37k");

var _itemFacets2 = __webpack_require__("3aW2");

var ItemFacets = {
    fetchItemFacets: function fetchItemFacets(params) {
        return  false ? _itemFacets.ItemFacetsMock.fetchItemFacets(params) : _itemFacets2.ItemFacetsRemote.fetchItemFacets(params);
    }
};

exports.default = ItemFacets;
module.exports = exports['default'];

/***/ }),

/***/ "ZsVc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "a3vv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"crown":"crown___2nOlG","crown-inner":"crown-inner___1Fiji"};

/***/ }),

/***/ "aIJS":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.HealthCheck = undefined;

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _helpers = __webpack_require__("SY39");

var _superagent = __webpack_require__("GG98");

var _superagent2 = _interopRequireDefault(_superagent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HealthCheck = exports.HealthCheck = {
    fetchHealthCheckData: function fetchHealthCheckData() {
        return new _promise2.default(function (resolve, reject) {
            var request = _superagent2.default.get('/healthcheck');
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response });
            });
        });
    }
};

/***/ }),

/***/ "aN2S":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isUiTablet = exports.isUiMicrosoftBrowser = exports.getMobileBrowserOS = exports.isUiMobile = exports.getUiBrowser = undefined;
exports.default = reducer;

var _reselect = __webpack_require__("bndy");

// reducer
var DEFAULT_STATE = {
    deviceType: '',
    microsoftBrowser: false,
    mobile: ''
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        default:
            return state;
    }
}

/* SELECTORS */
var stateSelector = function stateSelector(state) {
    return state.ui.browser;
};

var getUiBrowser = exports.getUiBrowser = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state;
});

var isUiMobile = exports.isUiMobile = (0, _reselect.createSelector)(getUiBrowser, function (uiBrowser) {
    return uiBrowser.mobile;
});

var getMobileBrowserOS = exports.getMobileBrowserOS = (0, _reselect.createSelector)(getUiBrowser, function (uiBrowser) {
    return uiBrowser.mobile ? uiBrowser.os : '';
});

var isUiMicrosoftBrowser = exports.isUiMicrosoftBrowser = (0, _reselect.createSelector)(getUiBrowser, function (uiBrowser) {
    return uiBrowser.microsoftBrowser;
});

var isUiTablet = exports.isUiTablet = (0, _reselect.createSelector)(isUiMobile, function (mobile) {
    return mobile === 'tablet';
});

/***/ }),

/***/ "awYM":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = __webpack_require__("dcb+");

var _jsx3 = _interopRequireDefault(_jsx2);

var _toConsumableArray2 = __webpack_require__("Gu7T");

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propsComparer = __webpack_require__("wsGv");

var _propsComparer2 = _interopRequireDefault(_propsComparer);

var _reactIntl = __webpack_require__("Pq8k");

var _components = __webpack_require__("bGai");

var _noop = __webpack_require__("9vKl");

var _noop2 = _interopRequireDefault(_noop);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _SeeMoreItems = __webpack_require__("W5uo");

var _SeeMoreItems2 = _interopRequireDefault(_SeeMoreItems);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SeeMoreItems = (_temp = _class = function (_Component) {
    (0, _inherits3.default)(SeeMoreItems, _Component);

    function SeeMoreItems(props, context) {
        (0, _classCallCheck3.default)(this, SeeMoreItems);

        var _this = (0, _possibleConstructorReturn3.default)(this, (SeeMoreItems.__proto__ || (0, _getPrototypeOf2.default)(SeeMoreItems)).call(this, props, context));

        _this.onSeeLess = function () {
            _this.changeSeeMore();
            _this.props.onSeeLessItemsClick();
        };

        _this.onSeeMore = function () {
            _this.changeSeeMore();
            _this.props.onSeeMoreItemsClick();
        };

        _this.changeSeeMore = function () {
            var seeMore = !_this.state.seeMore;
            _this.setState({ seeMore: seeMore });
        };

        _this.state = {
            seeMore: false
        };
        return _this;
    }

    (0, _createClass3.default)(SeeMoreItems, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (this.props.items.length !== nextProps.items.length) {
                this.setState({ seeMore: false });
            }
        }
    }, {
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps, nextState) {
            return (0, _propsComparer2.default)(this.props, nextProps, ['className', 'hideSeeLess', 'items', 'linkClassName', 'seeLessFormattedMessageId', 'seeMoreFormattedMessageId', 'showItemCount']) || (0, _propsComparer2.default)(this.state, nextState, ['seeMore']);
        }
    }, {
        key: 'render',
        value: function render() {
            var seeMore = this.state.seeMore;
            var _props = this.props,
                className = _props.className,
                hideSeeLess = _props.hideSeeLess,
                items = _props.items,
                linkClassName = _props.linkClassName,
                seeLessFormattedMessageId = _props.seeLessFormattedMessageId,
                seeMoreFormattedMessageId = _props.seeMoreFormattedMessageId,
                showItemCount = _props.showItemCount;


            var slicedItems = seeMore ? items : items.slice(0, showItemCount);
            var linkClasses = [].concat((0, _toConsumableArray3.default)(linkClassName.split(' ')), [_SeeMoreItems2.default.seemore]).join(' ').trim();
            var showSeeMore = items.length > showItemCount && !seeMore;
            var showSeeLess = !showSeeMore && !hideSeeLess && items.length > showItemCount;
            return (0, _jsx3.default)('div', {
                className: className
            }, void 0, slicedItems, showSeeMore && (0, _jsx3.default)(_components.Link, {
                className: linkClasses,
                onClick: this.onSeeMore
            }, 'see-more', (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: seeMoreFormattedMessageId
            })), showSeeLess && (0, _jsx3.default)(_components.Link, {
                className: linkClasses,
                onClick: this.onSeeMore
            }, 'see-less', (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: seeLessFormattedMessageId
            })));
        }
    }]);
    return SeeMoreItems;
}(_react.Component), _class.defaultProps = {
    className: '',
    hideSeeLess: false,
    linkClassName: '',
    onSeeLessItemsClick: _noop2.default,
    onSeeMoreItemsClick: _noop2.default,
    seeLessFormattedMessageId: 'search_see_less',
    seeMoreFormattedMessageId: 'search_see_all'
}, _temp);
exports.default = SeeMoreItems;
module.exports = exports['default'];

/***/ }),

/***/ "bCbI":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = __webpack_require__("dcb+");

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propsComparer = __webpack_require__("wsGv");

var _propsComparer2 = _interopRequireDefault(_propsComparer);

var _Button = __webpack_require__("KluA");

var _Button2 = _interopRequireDefault(_Button);

var _Link = __webpack_require__("rkxl");

var _Link2 = _interopRequireDefault(_Link);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Returns a react router <Link /> that looks like a bootstrap button.
 */
var ButtonLink = (_temp = _class = function (_Component) {
    (0, _inherits3.default)(ButtonLink, _Component);

    function ButtonLink() {
        (0, _classCallCheck3.default)(this, ButtonLink);
        return (0, _possibleConstructorReturn3.default)(this, (ButtonLink.__proto__ || (0, _getPrototypeOf2.default)(ButtonLink)).apply(this, arguments));
    }

    (0, _createClass3.default)(ButtonLink, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps) {
            return (0, _propsComparer2.default)(this.props, nextProps, ['children', 'className', 'external', 'linkClassName', 'rel', 'secondary', 'small', 'target', 'url']);
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                className = _props.className,
                children = _props.children,
                external = _props.external,
                linkClassName = _props.linkClassName,
                secondary = _props.secondary,
                small = _props.small,
                rel = _props.rel,
                target = _props.target,
                url = _props.url;

            var button = (0, _jsx3.default)(_Button2.default, {
                className: className,
                primary: true,
                secondary: secondary,
                small: small
            }, void 0, children);

            return external ? (0, _jsx3.default)(_Link2.default, {
                to: url,
                target: target,
                rel: rel,
                className: linkClassName
            }, void 0, button) : (0, _jsx3.default)(_Link2.default, {
                route: true,
                to: url,
                rel: rel,
                className: linkClassName
            }, void 0, button);
        }
    }]);
    return ButtonLink;
}(_react.Component), _class.defaultProps = {
    className: '',
    external: false,
    linkClassName: '',
    secondary: false,
    small: false
}, _temp);
exports.default = ButtonLink;
module.exports = exports['default'];

/***/ }),

/***/ "bDm4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

var _ = __webpack_require__("cjn6");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var savedSearchItemSortOrders = (0, _extends3.default)({}, _.itemSortOrders, {
    RESULT_RECENT_FIRST: 'RESULT_RECENT_FIRST',
    RESULT_OLDEST_FIRST: 'RESULT_OLDEST_FIRST'
}); /*eslint-disable sort-keys */
exports.default = savedSearchItemSortOrders;
module.exports = exports['default'];

/***/ }),

/***/ "bGai":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _AddThis = __webpack_require__("QJRV");

Object.defineProperty(exports, 'AddThis', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_AddThis).default;
  }
});

var _AuctioneerAddress = __webpack_require__("PbmM");

Object.defineProperty(exports, 'AuctioneerAddress', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_AuctioneerAddress).default;
  }
});

var _AuctioneerInfo = __webpack_require__("vwV8");

Object.defineProperty(exports, 'AuctioneerInfo', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_AuctioneerInfo).default;
  }
});

var _BidConsoleOpener = __webpack_require__("k+pu");

Object.defineProperty(exports, 'BidConsoleOpener', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_BidConsoleOpener).default;
  }
});

var _BidIncrements = __webpack_require__("hXxF");

Object.defineProperty(exports, 'BidIncrements', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_BidIncrements).default;
  }
});

var _Breadcrumb = __webpack_require__("M8WM");

Object.defineProperty(exports, 'Breadcrumb', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Breadcrumb).default;
  }
});

var _BreadcrumbList = __webpack_require__("CiCz");

Object.defineProperty(exports, 'BreadcrumbList', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_BreadcrumbList).default;
  }
});

var _Button = __webpack_require__("KluA");

Object.defineProperty(exports, 'Button', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Button).default;
  }
});

var _ButtonLink = __webpack_require__("bCbI");

Object.defineProperty(exports, 'ButtonLink', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ButtonLink).default;
  }
});

var _BuyersPremium = __webpack_require__("Tlyl");

Object.defineProperty(exports, 'BuyersPremium', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_BuyersPremium).default;
  }
});

var _CatalogCard = __webpack_require__("Kk/C");

Object.defineProperty(exports, 'CatalogCard', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_CatalogCard).default;
  }
});

var _CatalogDate = __webpack_require__("vCo/");

Object.defineProperty(exports, 'CatalogDate', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_CatalogDate).default;
  }
});

var _CatalogGrid = __webpack_require__("zz0d");

Object.defineProperty(exports, 'CatalogGrid', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_CatalogGrid).default;
  }
});

var _CoverLots = __webpack_require__("L9QP");

Object.defineProperty(exports, 'CoverLots', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_CoverLots).default;
  }
});

var _CuratorInfo = __webpack_require__("CyO3");

Object.defineProperty(exports, 'CuratorInfo', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_CuratorInfo).default;
  }
});

var _DiscoverItems = __webpack_require__("XoDl");

Object.defineProperty(exports, 'DiscoverItems', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_DiscoverItems).default;
  }
});

var _DropDownMenu = __webpack_require__("r3q8");

Object.defineProperty(exports, 'DropDownMenu', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_DropDownMenu).default;
  }
});

var _EnsureLoggedInContainer = __webpack_require__("OylW");

Object.defineProperty(exports, 'EnsureLoggedInContainer', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_EnsureLoggedInContainer).default;
  }
});

var _FollowSellerContainer = __webpack_require__("1G/f");

Object.defineProperty(exports, 'FollowSellerContainer', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_FollowSellerContainer).default;
  }
});

var _FormInput = __webpack_require__("MFq5");

Object.defineProperty(exports, 'FormInput', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_FormInput).default;
  }
});

var _GoogleMapSmall = __webpack_require__("HlCz");

Object.defineProperty(exports, 'GoogleMapSmall', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_GoogleMapSmall).default;
  }
});

var _ImageWithFallback = __webpack_require__("pjS5");

Object.defineProperty(exports, 'ImageWithFallback', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ImageWithFallback).default;
  }
});

var _Input = __webpack_require__("Alk2");

Object.defineProperty(exports, 'Input', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Input).default;
  }
});

var _ItemCard = __webpack_require__("g2OR");

Object.defineProperty(exports, 'ItemCard', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ItemCard).default;
  }
});

var _ItemCardCarousel = __webpack_require__("ZXiL");

Object.defineProperty(exports, 'ItemCardCarousel', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ItemCardCarousel).default;
  }
});

var _ItemGrid = __webpack_require__("iLJB");

Object.defineProperty(exports, 'ItemGrid', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ItemGrid).default;
  }
});

var _ItemPriceGatewayContainer = __webpack_require__("zfVU");

Object.defineProperty(exports, 'ItemPriceGatewayContainer', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ItemPriceGatewayContainer).default;
  }
});

var _ItemSaveContainer = __webpack_require__("/j9A");

Object.defineProperty(exports, 'ItemSaveContainer', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ItemSaveContainer).default;
  }
});

var _Link = __webpack_require__("rkxl");

Object.defineProperty(exports, 'Link', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Link).default;
  }
});

var _Modal = __webpack_require__("ub8h");

Object.defineProperty(exports, 'Modal', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Modal).default;
  }
});

var _ModalHeader = __webpack_require__("TFOM");

Object.defineProperty(exports, 'ModalHeader', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ModalHeader).default;
  }
});

var _NoResults = __webpack_require__("7oIq");

Object.defineProperty(exports, 'NoResults', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_NoResults).default;
  }
});

var _PaginateSortFilter = __webpack_require__("VxOq");

Object.defineProperty(exports, 'PaginateSortFilter', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_PaginateSortFilter).default;
  }
});

var _PaginationWrapper = __webpack_require__("+Feu");

Object.defineProperty(exports, 'PaginationWrapper', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_PaginationWrapper).default;
  }
});

var _Panel = __webpack_require__("oQLi");

Object.defineProperty(exports, 'Panel', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Panel).default;
  }
});

var _PasswordInput = __webpack_require__("iUDN");

Object.defineProperty(exports, 'PasswordInput', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_PasswordInput).default;
  }
});

var _RegisterLinkContainer = __webpack_require__("TMJx");

Object.defineProperty(exports, 'RegisterLinkContainer', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_RegisterLinkContainer).default;
  }
});

var _ScrollBar = __webpack_require__("ZW0g");

Object.defineProperty(exports, 'ScrollBar', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ScrollBar).default;
  }
});

var _SearchInput = __webpack_require__("LXPM");

Object.defineProperty(exports, 'SearchInput', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_SearchInput).default;
  }
});

var _SeeMoreItems = __webpack_require__("awYM");

Object.defineProperty(exports, 'SeeMoreItems', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_SeeMoreItems).default;
  }
});

var _ShouldLogInContainer = __webpack_require__("iKXC");

Object.defineProperty(exports, 'ShouldLogInContainer', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ShouldLogInContainer).default;
  }
});

var _SimilarItemsContainer = __webpack_require__("CRk2");

Object.defineProperty(exports, 'SimilarItemsContainer', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_SimilarItemsContainer).default;
  }
});

var _StatusBanner = __webpack_require__("Lvxz");

Object.defineProperty(exports, 'StatusBanner', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_StatusBanner).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ "bRXb":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _catalog = __webpack_require__("eyX+");

var _catalog2 = __webpack_require__("zsa3");

var Catalog = {
    fetchCatalogItems: function fetchCatalogItems(params) {
        return  false ? _catalog.CatalogMock.fetchCatalogItems(params) : _catalog2.CatalogRemote.fetchCatalogItems(params);
    },
    fetchCatalogsByIds: function fetchCatalogsByIds(params) {
        return  false ? _catalog.CatalogMock.fetchCatalogsByIds(params) : _catalog2.CatalogRemote.fetchCatalogsByIds(params);
    },
    fetchCuratorsForCatalog: _catalog2.CatalogRemote.fetchCuratorsForCatalog,
    fetchRegisteredCatalogs: _catalog2.CatalogRemote.fetchRegisteredCatalogs,
    fetchUpcomingCatalogs: _catalog2.CatalogRemote.fetchUpcomingCatalogs,
    postCatalogItems: _catalog2.CatalogRemote.postCatalogItems,
    postRegisterForCatalog: _catalog2.CatalogRemote.postRegisterForCatalog
};

exports.default = Catalog;
module.exports = exports['default'];

/***/ }),

/***/ "bSWU":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.BidderRemote = undefined;

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _helpers = __webpack_require__("SY39");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var transformRequest = function transformRequest(details) {
    var transformed = {
        addr1: details.address1,
        addr2: details.address2,
        city: details.city,
        country: details.country,
        fname: details.firstName,
        lname: details.lastName,
        phone: details.mobile,
        postal_code: details.zipcode,
        sms_phone: details.mobile,
        state: details.state,
        username: details.username
    };

    if (details.email) {
        transformed.email_address = details.email;
    }
    return transformed;
};

var transform = function transform(details) {
    var bidder = details.bidder,
        auth_tokens = details.auth_tokens,
        token = details.token,
        success = details.success;
    var address = bidder.address,
        address2 = bidder.address2,
        bidder_id = bidder.bidder_id,
        city = bidder.city,
        country = bidder.country,
        join_date = bidder.join_date,
        email = bidder.email,
        firstName = bidder.firstName,
        lastName = bidder.lastName,
        mobileNumber = bidder.mobileNumber,
        phoneNumber = bidder.phoneNumber,
        standing = bidder.standing,
        state = bidder.state,
        username = bidder.username,
        zip = bidder.zip,
        profile_complete = bidder.profile_complete;


    return {
        bidder: {
            address: address,
            address2: address2,
            bidderId: bidder_id,
            city: city,
            country: country,
            createdDate: join_date,
            creditCardValidated: false,
            email: email,
            firstName: firstName,
            lastName: lastName,
            mobileNumber: mobileNumber,
            phoneNumber: phoneNumber,
            profileComplete: !!profile_complete,
            standing: standing,
            state: state,
            username: username,
            zip: zip
        },
        mainhostLogin: auth_tokens,
        success: success,
        token: token
    };
    /* eslint-enable */
};

var BidderRemote = exports.BidderRemote = {
    fetchBidderData: function fetchBidderData(_ref) {
        var authToken = _ref.authToken,
            deployment = _ref.deployment;
        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makeGet)('<ITEM-API>auth/spauser', deployment);
            (0, _helpers.addAuthToken)(request, authToken);
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response });
            });
        });
    },
    postCompleteAccount: function postCompleteAccount(_ref2) {
        var authToken = _ref2.authToken,
            bidderDetails = _ref2.bidderDetails,
            deployment = _ref2.deployment;
        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makePost)('<MAINHOST-API>api/u_bidr', deployment);
            (0, _helpers.addAuthToken)(request, authToken);
            request.query({ client_version: '4.3' });
            request.type('form');
            if (bidderDetails) {
                // why is there an if?
                request.send(transformRequest(bidderDetails));
            }
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response, transform: transform });
            });
        });
    },
    postCreateAccount: function postCreateAccount(_ref3) {
        var deployment = _ref3.deployment,
            emailAddress = _ref3.emailAddress;
        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makePost)('<USER-API>', deployment, 'createuser');
            request.send({
                client_version: '4.3',
                email_address: emailAddress,
                signup_client: 'web'
            });
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response });
            });
        });
    },
    postLogin: function postLogin(_ref4) {
        var deployment = _ref4.deployment,
            mainhostLogin = _ref4.mainhostLogin,
            password = _ref4.password,
            username = _ref4.username;
        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makePost)('<ITEM-API>auth/spalogin', deployment);
            request.type('form');
            request.send((0, _extends3.default)({ password: password, username: username }, mainhostLogin));
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response });
            });
        });
    },
    postSetPassword: function postSetPassword(_ref5) {
        var authToken = _ref5.authToken,
            deployment = _ref5.deployment,
            password = _ref5.password;
        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makePost)('<USER-API>', deployment, 'createpassword');
            (0, _helpers.addAuthToken)(request, authToken);
            request.send({ password: password });
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response });
            });
        });
    },
    postSetSearchFacetOptionExclusion: function postSetSearchFacetOptionExclusion(_ref6) {
        var authToken = _ref6.authToken,
            deployment = _ref6.deployment,
            exclude = _ref6.exclude,
            facetId = _ref6.facetId,
            optionId = _ref6.optionId;
        return new _promise2.default(function (resolve, reject) {
            var requestURL = void 0;
            // transform the `exclude` bool into a number (0 or 1)
            var excludeBit = ~~exclude;

            switch (facetId) {
                case 'auctionHouse':
                    requestURL = '<ITEM-API>search/exclusion/seller/' + optionId + '/' + excludeBit;
                    break;
                default:
                    return reject('Excluding search results by ' + facetId + ' is not yet supported.');
            }
            var request = (0, _helpers.makePost)(requestURL, deployment);

            (0, _helpers.addAuthToken)(request, authToken);
            request.send();
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response });
            });
        });
    }
};

/***/ }),

/***/ "bigW":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.BiddingInfoRemote = undefined;

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _helpers = __webpack_require__("SY39");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BiddingInfoRemote = exports.BiddingInfoRemote = {
    fetchCatalogBidding: function fetchCatalogBidding(_ref) {
        var authToken = _ref.authToken,
            catalogId = _ref.catalogId,
            deployment = _ref.deployment;
        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makeGet)('<ITEM-API>spa/small/catalog/' + catalogId + '/bidding', deployment);
            (0, _helpers.addAuthToken)(request, authToken);
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response });
            });
        });
    },
    fetchItemBidding: function fetchItemBidding(_ref2) {
        var authToken = _ref2.authToken,
            deployment = _ref2.deployment,
            itemId = _ref2.itemId;
        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makeGet)('<ITEM-API>spa/small/item/' + itemId + '/bidding', deployment);
            (0, _helpers.addAuthToken)(request, authToken);
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response });
            });
        });
    }
};

/***/ }),

/***/ "blov":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"carousel-container":"carousel-container___1sJBH","similar-items":"similar-items___vhLDK","similar-items-header":"similar-items-header___3qTUB","center-text":"center-text___1oJV_","similar-grid":"similar-grid___3ghMy","similar-cards":"similar-cards___2pgbe","see-similar-cta":"see-similar-cta___27p_v"};

/***/ }),

/***/ "bzca":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"footer":"footer___gC3z-"};

/***/ }),

/***/ "c28x":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _bid = __webpack_require__("2+GA");

var Bid = {
    postPlaceAbsenteeBid: _bid.BidRemote.postPlaceAbsenteeBid,
    postPlaceLiveBid: _bid.BidRemote.postPlaceLiveBid,
    postRetractBid: _bid.BidRemote.postRetractBid
};

exports.default = Bid;
module.exports = exports['default'];

/***/ }),

/***/ "c5lA":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fetchSavedSearchItemsIfNeeded = exports.getSavedSearchItem = exports.isSavedSearchItemsLoading = exports.getSortedSavedSearchItemIds = exports.getSavedSearchItemIds = exports.LOAD_SAVED_SEARCH_ITEMS_SUCCESS = exports.LOAD_SAVED_SEARCH_ITEMS_REQUEST = exports.LOAD_SAVED_SEARCH_ITEMS_FAIL = undefined;

var _regenerator = __webpack_require__("Xxa5");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _asyncToGenerator2 = __webpack_require__("exGp");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _keys = __webpack_require__("fZjL");

var _keys2 = _interopRequireDefault(_keys);

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;

var _api = __webpack_require__("zFQO");

var _reselect = __webpack_require__("bndy");

var _user = __webpack_require__("CFLi");

var _config = __webpack_require__("iS9E");

var _ms = __webpack_require__("EarI");

var _ms2 = _interopRequireDefault(_ms);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Action Types */
var LOAD_SAVED_SEARCH_ITEMS_FAIL = exports.LOAD_SAVED_SEARCH_ITEMS_FAIL = 'la/user/savedSearchItem/LOAD_FAIL';
var LOAD_SAVED_SEARCH_ITEMS_REQUEST = exports.LOAD_SAVED_SEARCH_ITEMS_REQUEST = 'la/user/savedSearchItem/LOAD_REQUEST';
var LOAD_SAVED_SEARCH_ITEMS_SUCCESS = exports.LOAD_SAVED_SEARCH_ITEMS_SUCCESS = 'la/user/savedSearchItem/LOAD_SUCCESS';

var REDUX_STORE_TIME = (0, _ms2.default)('30m');

/* reducer */
var DEFAULT_STATE = {
    byId: {},
    ids: [],
    loaded: 0,
    loading: false
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var byId = void 0;
    var ids = void 0;

    switch (action.type) {
        case LOAD_SAVED_SEARCH_ITEMS_FAIL:
            return (0, _extends3.default)({}, state, {
                loading: false
            });
        case LOAD_SAVED_SEARCH_ITEMS_REQUEST:
            return (0, _extends3.default)({}, state, {
                loading: true
            });
        case LOAD_SAVED_SEARCH_ITEMS_SUCCESS:
            byId = {};
            ids = [];
            action.payload.forEach(function (x) {
                byId[x.itemId] = {
                    itemId: x.itemId,
                    publishDate: x.publishDate,
                    publishTs: Date.parse(x.publishDate) / 1000
                };
                ids.push(x.itemId);
            });
            return (0, _extends3.default)({}, state, {
                byId: byId,
                ids: ids,
                loaded: action.meta.actionTime,
                loading: false
            });
        default:
            return state;
    }
}

/* SELECTORS */
var stateSelector = function stateSelector(state) {
    return state.user.savedSearchItem;
};
var idSelector = function idSelector(state, id) {
    return id;
};

var byISelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.byId;
});

var getSavedSearchItemIds = exports.getSavedSearchItemIds = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.ids || [];
});

var getSortedSavedSearchItemIds = exports.getSortedSavedSearchItemIds = (0, _reselect.createSelector)(byISelector, function (byId) {
    var toBeSorted = (0, _keys2.default)(byId).map(function (x) {
        return byId[x];
    });
    var sorted = toBeSorted.sort(function (a, b) {
        return b.publishTs - a.publishTs;
    });
    return sorted.map(function (x) {
        return x.itemId;
    });
});

var getLoadTimeForSavedSearchItems = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.loaded || 0;
});

var isSavedSearchItemsLoading = exports.isSavedSearchItemsLoading = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.loading || false;
});

var getSavedSearchItem = exports.getSavedSearchItem = (0, _reselect.createSelector)([byISelector, idSelector], function (byId, id) {
    return byId[id] || {
        itemId: id,
        publishTs: 0
    };
});

var shouldFetchSavedSearchItems = function shouldFetchSavedSearchItems(state) {
    var loaded = getLoadTimeForSavedSearchItems(state);
    var time = Date.now();
    var diff = time - loaded;
    if (diff < REDUX_STORE_TIME) return false;
    return !isSavedSearchItemsLoading(state);
};

/* ACTION CREATORS */
var fetchSavedSearchItemsIfNeeded = exports.fetchSavedSearchItemsIfNeeded = function fetchSavedSearchItemsIfNeeded() {
    return function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch, getState) {
            var state, authToken, deployment, response;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            state = getState();

                            if (!shouldFetchSavedSearchItems(state)) {
                                _context.next = 15;
                                break;
                            }

                            authToken = (0, _user.getAuthToken)(state);
                            deployment = (0, _config.getDeployment)(state);
                            _context.prev = 4;

                            dispatch({
                                type: LOAD_SAVED_SEARCH_ITEMS_REQUEST
                            });
                            _context.next = 8;
                            return _api.SaveSearch.fetchSavedSearchItems({ authToken: authToken, deployment: deployment });

                        case 8:
                            response = _context.sent;

                            dispatch({
                                meta: { actionTime: Date.now() },
                                payload: response.data,
                                type: LOAD_SAVED_SEARCH_ITEMS_SUCCESS
                            });
                            // start downloading the items
                            // const state2 = getState();
                            // const itemIds = getSavedSearchItemIds(state2);
                            // dispatch(fetchItemsIfNeeded(itemIds, 'saved-search-items'));
                            _context.next = 15;
                            break;

                        case 12:
                            _context.prev = 12;
                            _context.t0 = _context['catch'](4);

                            dispatch({
                                error: true,
                                payload: _context.t0,
                                type: LOAD_SAVED_SEARCH_ITEMS_FAIL
                            });

                        case 15:
                            return _context.abrupt('return', _promise2.default.resolve());

                        case 16:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, undefined, [[4, 12]]);
        }));

        return function (_x3, _x4) {
            return _ref.apply(this, arguments);
        };
    }();
};

/***/ }),

/***/ "cD6S":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = __webpack_require__("dcb+");

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__("Pq8k");

var _Mobile = __webpack_require__("9T3g");

var _Mobile2 = _interopRequireDefault(_Mobile);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Mobile = function (_PureComponent) {
    (0, _inherits3.default)(Mobile, _PureComponent);

    function Mobile() {
        (0, _classCallCheck3.default)(this, Mobile);
        return (0, _possibleConstructorReturn3.default)(this, (Mobile.__proto__ || (0, _getPrototypeOf2.default)(Mobile)).apply(this, arguments));
    }

    (0, _createClass3.default)(Mobile, [{
        key: 'render',
        value: function render() {
            return (0, _jsx3.default)('div', {
                className: _Mobile2.default.mobile
            }, void 0, (0, _jsx3.default)('img', {
                src: 'https://p1.liveauctioneers.com/dist/images/IPhone_Small.png',
                alt: 'mobile'
            }), (0, _jsx3.default)('div', {
                className: _Mobile2.default.mobileInner
            }, void 0, (0, _jsx3.default)('div', {
                className: _Mobile2.default.header
            }, void 0, (0, _jsx3.default)('div', {
                className: _Mobile2.default.headerDesktop
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'bid_anywhere_with_the_app'
            })), (0, _jsx3.default)('div', {
                className: _Mobile2.default.headerMobile
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'bid_anywhere_anytime_mobile'
            }))), (0, _jsx3.default)('div', {
                className: _Mobile2.default.links
            }, void 0, (0, _jsx3.default)('a', {
                className: _Mobile2.default['app-store-link'] + ' ' + _Mobile2.default.ios,
                href: 'https://itunes.apple.com/us/app/live-auctions/id321243082',
                target: 'blank',
                title: 'Available on the App Store'
            }), (0, _jsx3.default)('a', {
                className: _Mobile2.default['app-store-link'] + ' ' + _Mobile2.default.android,
                href: 'https://play.google.com/store/apps/details?id=com.liveauctioneers.and',
                target: 'blank',
                title: 'Android App on Google Play'
            }))));
        }
    }]);
    return Mobile;
}(_react.PureComponent);

exports.default = Mobile;
module.exports = exports['default'];

/***/ }),

/***/ "cOev":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var riskfied = function () {
    return function (store) {
        return function (next) {
            return function (action) {
                switch (action.type) {
                    case '@@router/LOCATION_CHANGE':
                        if (typeof window !== 'undefined' && window.RISKX) {
                            var _action$payload = action.payload,
                                pathname = _action$payload.pathname,
                                search = _action$payload.search;

                            window.RISKX.go('' + pathname + search);
                        }
                        break;
                    default:
                        break;
                }
                return next(action);
            };
        };
    };
}();

exports.default = riskfied;
module.exports = exports['default'];

/***/ }),

/***/ "cYj3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isWhiteLabel = exports.getWhiteLabelSiteUrl = exports.getWhiteLabelSiteName = exports.getWhiteLabelSellerId = exports.getWhiteLabelName = exports.getWhiteLabelLogo = exports.getHostName = undefined;
exports.default = reducer;

var _reselect = __webpack_require__("bndy");

// reducer
var DEFAULT_STATE = {
    hostname: '',
    isWhiteLabel: false,
    logo: '',
    sellerId: 0,
    siteName: '',
    siteUrl: ''
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        default:
            return state;
    }
}

/* SELECTORS */
var stateSelector = function stateSelector(state) {
    return state.whiteLabel;
};

var getHostName = exports.getHostName = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state ? state.hostname : '';
});

var getWhiteLabelLogo = exports.getWhiteLabelLogo = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.logo;
});
var getWhiteLabelName = exports.getWhiteLabelName = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.name;
});
var getWhiteLabelSellerId = exports.getWhiteLabelSellerId = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.sellerId;
});
var getWhiteLabelSiteName = exports.getWhiteLabelSiteName = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.siteName;
});
var getWhiteLabelSiteUrl = exports.getWhiteLabelSiteUrl = (0, _reselect.createSelector)(stateSelector, function (state) {
    if (!state.siteUrl.includes('http')) {
        return '//' + state.siteUrl;
    }
    return state.siteUrl;
});
var isWhiteLabel = exports.isWhiteLabel = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.isWhiteLabel;
});

/***/ }),

/***/ "cjn6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _catalogSortOrders = __webpack_require__("pBUe");

Object.defineProperty(exports, 'catalogSortOrders', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_catalogSortOrders).default;
  }
});

var _catalogItemsSortOrders = __webpack_require__("XnP6");

Object.defineProperty(exports, 'catalogItemsSortOrders', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_catalogItemsSortOrders).default;
  }
});

var _itemSortOrders = __webpack_require__("HJpS");

Object.defineProperty(exports, 'itemSortOrders', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_itemSortOrders).default;
  }
});

var _modalTypes = __webpack_require__("GlFK");

Object.defineProperty(exports, 'modalTypes', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_modalTypes).default;
  }
});

var _myBidsSortOrders = __webpack_require__("11Md");

Object.defineProperty(exports, 'myBidsSortOrders', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_myBidsSortOrders).default;
  }
});

var _savedItemSortOrders = __webpack_require__("H1j4");

Object.defineProperty(exports, 'savedItemSortOrders', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_savedItemSortOrders).default;
  }
});

var _savedSearchItemSortOrders = __webpack_require__("bDm4");

Object.defineProperty(exports, 'savedSearchItemSortOrders', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_savedSearchItemSortOrders).default;
  }
});

var _savedSearchSortOrders = __webpack_require__("NmEf");

Object.defineProperty(exports, 'savedSearchSortOrders', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_savedSearchSortOrders).default;
  }
});

var _sellerSortOrders = __webpack_require__("M8Jj");

Object.defineProperty(exports, 'sellerSortOrders', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_sellerSortOrders).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ "cq7Z":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"trust":"trust___1K9WX","centered":"centered___1cTO5","images":"images___1lQrU","column-title":"column-title___1gHpp","shop":"shop___1vFgj","column-content":"column-content___181WM","nbc":"nbc___3_Y_r","abc":"abc___3W6gL","today":"today___2qZi0","chicago-tribune":"chicago-tribune___2QjLT","architectural-digest":"architectural-digest___3aRXR","column-content-left":"column-content-left___3zkNb","column-content-right":"column-content-right___3TYtT","separator":"separator___BWYSi"};

/***/ }),

/***/ "d3Wo":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx2 = __webpack_require__("dcb+");

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__("RH2O");

var _config = __webpack_require__("iS9E");

var _whiteLabel = __webpack_require__("cYj3");

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _WhiteLabelFooter = __webpack_require__("ja8H");

var _WhiteLabelFooter2 = _interopRequireDefault(_WhiteLabelFooter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(state) {
    return {
        baseUrl: (0, _config.getBaseUrl)(state),
        name: (0, _whiteLabel.getWhiteLabelName)(state)
    };
};

var WhiteLabelFooterContainer = function (_PureComponent) {
    (0, _inherits3.default)(WhiteLabelFooterContainer, _PureComponent);

    function WhiteLabelFooterContainer() {
        (0, _classCallCheck3.default)(this, WhiteLabelFooterContainer);
        return (0, _possibleConstructorReturn3.default)(this, (WhiteLabelFooterContainer.__proto__ || (0, _getPrototypeOf2.default)(WhiteLabelFooterContainer)).apply(this, arguments));
    }

    (0, _createClass3.default)(WhiteLabelFooterContainer, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                baseUrl = _props.baseUrl,
                name = _props.name;


            return (0, _jsx3.default)(_WhiteLabelFooter2.default, {
                baseUrl: baseUrl,
                name: name
            });
        }
    }]);
    return WhiteLabelFooterContainer;
}(_react.PureComponent);

exports.default = (0, _reactRedux.connect)(mapStateToProps)(WhiteLabelFooterContainer);
module.exports = exports['default'];

/***/ }),

/***/ "dJZv":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CatalogDetailRemote = undefined;

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _helpers = __webpack_require__("SY39");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CatalogDetailRemote = exports.CatalogDetailRemote = {
    fetchCatalogDetailsByIds: function fetchCatalogDetailsByIds(_ref) {
        var authToken = _ref.authToken,
            catalogIds = _ref.catalogIds,
            deployment = _ref.deployment;
        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makePost)('<ITEM-API>spa/small/catalog-detail', deployment);
            (0, _helpers.addAuthToken)(request, authToken);
            request.send({ ids: catalogIds });
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response });
            });
        });
    }
};

/***/ }),

/***/ "dYLj":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLocale = undefined;

var _reselect = __webpack_require__("bndy");

/* SELECTORS */
var intlSelector = (0, _reselect.createSelector)(function (state) {
  return state;
}, function (s) {
  return s.intl;
});

var getLocale = exports.getLocale = (0, _reselect.createSelector)(intlSelector, function (intl) {
  return intl.locale || 'en';
});

/***/ }),

/***/ "dekO":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ItemDetailMock = undefined;

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _delay = __webpack_require__("kRHc");

var _delay2 = _interopRequireDefault(_delay);

var _mockData = __webpack_require__("6VmH");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ItemDetailMock = exports.ItemDetailMock = {
    fetchItemDetailsByIds: function fetchItemDetailsByIds(itemIds) {
        return new _promise2.default(function (resolve) {
            setTimeout(function () {
                var itemDescriptions = itemIds.map(function (x) {
                    return (0, _mockData.getTestItemDetails)(x);
                });
                resolve({
                    data: {
                        data: itemDescriptions
                    }
                });
            }, _delay2.default);
        });
    }
};

/***/ }),

/***/ "doBk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"status-banner-message":"status-banner-message___3ibw4","icon":"icon___37cVC","alert":"alert___2pUFK","message":"message___2Q8kg","header":"header___3_Kqy","body":"body___3SsXd","reserve":"reserve___SYrdC"};

/***/ }),

/***/ "e6NR":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SellerRemote = undefined;

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _helpers = __webpack_require__("SY39");

var _take = __webpack_require__("m4tL");

var _take2 = _interopRequireDefault(_take);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SellerRemote = exports.SellerRemote = {
    fetchSellers: function fetchSellers(_ref) {
        var deployment = _ref.deployment;
        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makeGet)('<ITEM-API>spa/small/sellers', deployment);
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response });
            });
        });
    },
    fetchSellersByIds: function fetchSellersByIds(_ref2) {
        var authToken = _ref2.authToken,
            deployment = _ref2.deployment,
            sellerIds = _ref2.sellerIds;
        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makePost)('<ITEM-API>spa/small/sellers', deployment);
            (0, _helpers.addAuthToken)(request, authToken);
            request.send({ ids: sellerIds });
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response });
            });
        });
    },
    postFollow: function postFollow(_ref3) {
        var authToken = _ref3.authToken,
            deployment = _ref3.deployment,
            sellerId = _ref3.sellerId;
        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makePost)('<ITEM-API>follow-seller/' + sellerId, deployment);
            (0, _helpers.addAuthToken)(request, authToken);
            request.type('form');
            request.send({ sellerId: sellerId });
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response });
            });
        });
    },
    postMessage: function postMessage(_ref4) {
        var authToken = _ref4.authToken,
            deployment = _ref4.deployment,
            messageDetails = _ref4.messageDetails;
        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makePost)('<MAINHOST-API>api/s_msg', deployment);
            (0, _helpers.addAuthToken)(request, authToken);
            request.query({ client_version: '4.3' });

            if (!messageDetails) reject(new Error('no message details sent'));

            var catalogId = messageDetails.catalogId,
                files = messageDetails.files,
                sellerId = messageDetails.sellerId,
                message = messageDetails.message,
                itemId = messageDetails.itemId,
                subject = messageDetails.subject;


            request.field('cat_id', catalogId || 0).field('cc_sender', false).field('house_id', sellerId).field('lot_id', itemId || 0).field('message_text', message).field('subject', subject);

            (0, _take2.default)(files || [], 5).forEach(function (f, idx) {
                var fieldName = idx === 0 ? 'attach' : 'attach' + idx;
                request.attach(fieldName, f);
            });

            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response });
            });
        });
    },
    postUnfollow: function postUnfollow(_ref5) {
        var authToken = _ref5.authToken,
            deployment = _ref5.deployment,
            sellerId = _ref5.sellerId;
        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makePost)('<ITEM-API>unfollow-seller/' + sellerId, deployment);
            (0, _helpers.addAuthToken)(request, authToken);
            request.type('form');
            request.send({ sellerId: sellerId });
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response });
            });
        });
    }
};

/***/ }),

/***/ "eNmu":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
/* eslint-disable sort-keys, max-len */
var en = {
    main: {
        auctionCentralNews: 'Auction Central News',
        auctionResultsDatabase: 'Auction Results Database'
    },

    // components
    acceptedCards: {
        text: 'We accept the following cards:'
    },
    addSearchAlert: {
        button: 'Follow Search',
        label: 'Add Keyword Alert:',
        placeholder: 'i.e. Rolex, Eames Chair…'
    },
    creditCardForm: {
        submit: 'Save my card'
    },
    paymentProcessedNotification: {
        title: 'Checkout Confirmation - LiveAuctioneers',
        description: '',
        header: 'Thank you, your payment has been processed',
        message: 'An email confirmation has been sent. If shipping has not already been arranged, please contact your preferred shipping agent or {house} to arrange for shipping or pick-up.'
    },
    shippingAndPayment: {
        header: 'Shipping & Payment'
    },
    shippingDetails: {
        inquireInternational: 'Ask for international rates',
        shippingToUS: '{domesticShippingCost} shipping to contiguous United States',
        shipsFromAgent: 'Ships from verified Jasper52 seller #{agentId}',
        shipsFromAgentIn: 'Ships from verified Jasper52 seller #{agentId} in {fromLocation}'
    },

    terms_modal: {
        cta: 'Back to Checkout'
    },

    // forms
    formErrors: {
        cardNumberEmpty: 'Enter a valid credit card number.',
        cardNumberInvalid: 'Enter a valid credit card number.',
        cvcCodeEmpty: 'Enter a valid security code.',
        cvcCodeInvalid: 'Enter a valid security code.',
        expirationMonthEmpty: 'Enter a valid month.',
        expirationMonthInvalid: 'Enter a valid month.',
        expirationYearEmpty: 'Enter a valid year.',
        expirationDateInvalid: 'Enter a valid expiration date.',
        firstNameEmpty: 'Enter a first name.',
        lastNameEmpty: 'Enter a last name.',
        passwordConfirmMatch: 'Passwords must match',
        passwordEmpty: 'Password cannot be empty',
        passwordLength: 'Password must be greater than 6 characters',
        addressEmpty: 'Address cannot be empty',
        cityEmpty: 'City cannot be empty',
        countryEmpty: 'Country cannot be empty',
        mobileNumberEmpty: 'Mobile phone number cannot be empty',
        stateEmpty: 'State cannot be empty',
        zipEmpty: 'Zip/Postal Code cannot be empty'
    },
    formLabels: {
        cardNumber: 'Card number',
        cvcCode: 'Security code',
        confirmNewPassword: 'Confirm new password',
        expirationMonth: 'Expiration date',
        expirationYear: 'Expiration year',
        firstName: 'First name',
        lastName: 'Last name',
        newPassword: 'New password',
        address: 'Address',
        address2: 'Address 2',
        optional_parenthesis: '(optional)',
        city: 'City',
        country: 'Country',
        mobileNumber: 'Mobile Phone Number',
        state: 'State',
        zip: 'Zip/Postal Code'
    },

    // modals
    addCreditCardModal: {
        error: 'There was an error adding your credit card.',
        footer: 'Note: Your card will not be charged at this time.',
        header: 'Get approved faster with a card on file',
        success: 'Credit card added successfully',
        returnToProfile: 'Return to profile'
    },

    // pages
    aboutUs: {
        content1: 'LiveAuctioneers brings an international audience of millions to the heart of the bidding action in art, antiques, jewelry and collectibles auctions across the globe.',
        content2: 'With fascinating objects up for bid in 47 countries—instantly translated to your language and currency—LiveAuctioneers is a worldwide marketplace with treasures waiting to be discovered, whether you\'re an avid collector or a first-time visitor.',
        content3: 'By hosting thousands of auctions in real time via the Internet, the site allows unprecedented access to remote sales, and savvy bidders can often land desired items at very desirable prices. Leave an absentee bid, or fully engage in the auction action—it\'s up to you. All bidding takes place via the Secure Bidder Network (SBN), which keeps absentee bids for upcoming sales private until the item is opened on the day of the sale.',
        content4: 'LiveAuctioneers revolutionized the industry from the start. In 2002, the NYC-based company formed a marketing partnership with eBay to introduce eBay Live Auctions. This alliance of LiveAuctioneers and eBay enabled auction houses worldwide to go online with their live sales — a development that changed the auction business forever. In 2009, the debut of LiveAuctioneers\' iPhone and Android apps, with live-bidding capabilities, opened up a new mobile pipeline to bid anytime, from anywhere, with complete anonymity.',
        content5: 'Now in its 14th year, LiveAuctioneers has become the Web\'s leading auction-related site. LiveAuctioneers also provides a constant stream of industry intelligence via:',
        content6: 'The easy-to-use {auctionResults}, a vast database with 12.9 million results that offers keyword-search access to bona fide auction outcomes, recent to historical. The updated archive is the #1 free online resource for the trade, appraisers, collectors, designers, arts institutions, estate officers, journalists, students and others on the research hunt;',
        content7: '{auctionCentral}, the global destination for the latest auction headlines, mixing timely items with articles by experts on all things design.',
        description: 'Exceptional Items from Trusted\nAuction Houses',
        title: 'About Us'
    },
    accountSettings: {
        description: 'Change your account settings',
        title: 'Account Settings',
        addCardOnFileButton: 'Add Credit Card',
        updateCardOnFileButton: 'Update Credit Card on File'
    },
    addCreditCard: {
        description: 'Add a credit card',
        title: 'Add credit card'
    },
    passwordReset: {
        description: 'Reset your password',
        title: 'Reset Your Password',
        submit: 'Set new password',
        error: 'There was an error resetting your password.',
        errorIncorrectCode: 'The password reset code is incorrect.',
        errorResetCodeExpired: 'The password reset code has expired.',
        errorTryAgain: 'Click here to try again.',
        success: 'You\'ve successfully reset your password and logged in.',
        returnHome: 'Continue to LiveAuctioneers',
        confirmNewPassword: 'Confirm New Password'
    },

    // Head Data
    get_in_on_the_auction: 'Get in on the auction — bid LIVE online on art, antiques, jewelry and collectibles. Find online auctions from around the world at LiveAuctioneers.',
    bid_in_online_auctions: 'Bid in Online Auctions - LiveAuctioneers',
    // Header
    lot_number: 'Lot Number',
    lot_number_short: 'Lot #',
    starting_bid: 'Starting Bid',
    auctioneer: 'Auctioneer',
    auction: 'Auction',
    date: 'Date',

    // Crown
    directory: 'Directory',
    price_results: 'Price Results',
    news: 'News',
    help: 'Help',
    consign: 'Consign',

    // Outdated Browser Modal
    did_you_know_that_your_web_browser: 'Did you know that your web browser is a little outdated? You\'re using {formalName} version {majorVersion}.',
    browsers_for_best_experience: 'For the best LiveAuctioneers experience, please upgrade to a newer version of {chrome}, {firefox}, {safari}, or {edge}.',
    chrome: 'Google Chrome',
    edge: 'Microsoft Edge',
    firefox: 'Mozilla Firefox',
    ie: 'Microsoft Edge',
    safari: 'Apple Safari',

    // Search
    search_placeholder: 'Search for items and auction houses',
    log_in: 'Log In',
    log_out: 'Log Out',
    sign_up: 'Join',
    me: 'me',
    saved_items: 'Saved Items',
    my_bids: 'My Bids',
    my_auctions: 'My Auctions',
    won_items: 'Won Items',
    messages: 'Messages',
    saved_searches_and_alerts: 'Followed Searches and Alerts',
    followed_auctioneers: 'Followed Auctioneers',
    account_settings: 'Account Settings',
    auction_houses: 'Auction Houses',
    auction_price_results: 'Auction Price Results',
    deleted_item_1: 'is no longer available.',
    deleted_item_2: 'Create a search alert',
    deleted_item_3: 'or find similar items below.',

    // Navigation
    today: 'Today',
    art: 'Art',
    jewelry: 'Jewelry',
    asian_antiques: 'Asian Antiques',
    furniture: 'Furniture',
    collectibles: 'Collectibles',
    home_and_garden: 'Home & Garden',
    fashion: 'Fashion',
    memorabilia: 'Memorabilia',
    coins: 'Coins',

    // Home
    home: 'Home',
    online_auctions: 'Online Auctions',
    home_title: 'Bid in Online Auctions - LiveAuctioneers',
    exceptional_items_from_trusted_auction_houses: 'Exceptional Items from Trusted\nAuction Houses',
    items_auctioned: 'Items Auctioned',
    in_secure_bids: 'In Secure Bids',
    items_available: 'Items Available',
    licensed_auction_experts: 'Licensed Auction Experts',
    bidding_steps: '4 Easy Steps to Start Bidding',
    browse_by_category: 'Featured Categories',
    featured_auctions: 'Featured Auctions',
    trending_items: 'Trending Items',
    upcoming_auctions_live_count: '{liveCount} Live & Upcoming Auctions',
    upcoming_items: '{liveCount} Upcoming Items',
    past_items: 'See All {pastCount} Past Auctions',
    become_title: 'Become a Member',
    become_text: 'Join the community with the largest collection of storied objects.',
    browse_title: 'Browse',
    browse_text: 'Discover new treasures with our robust search feature or explore by category.',
    bid_title: 'Bid Anytime',
    bid_text: 'Enter an amount and place bids online anytime before an auction begins.',
    pay_title: 'Pay Only If You Win',
    pay_text: 'Complete your transaction only after you bid and win. Items are then delivered to your door.',
    explore: 'Explore',
    live_auction: 'Live Auction',
    liveauctioneers: 'LiveAuctioneers',
    sitemap: 'Sitemap',
    auctioneer_directory: 'Auctioneer Directory',
    auction_previews: 'Auction Previews',
    auction_results: 'Auction Results',
    be_informed: 'Be Informed',
    top_news: 'Top News',

    // Live Items
    watch_live_auction: 'Watch Live Auction',
    live: 'Bid Live',
    bids: 'Bids',
    lot_passed_not_disclosed: 'Lot Passed / Not Disclosed',
    select_maximum_bid: 'Select Maximum Bid',
    increase_your_maximum_bid: 'Increase Your Maximum Bid',
    place_bid: 'Place Bid',
    automatic_bidding: 'Automatic Bidding',
    estimate: 'Estimate',
    short_estimate: 'Est.',
    short_estimate_values: 'Est. {low} - {high}',
    save_item: 'Save Item',
    item_saved: 'Item Saved',
    interested_in_this_item: 'Interested in this item?',
    register_for_auction: 'Register for Auction',
    save_to_saved_items: 'Save to \'Saved Items\' to access later.',
    registration_declined: 'Registration Declined',
    account_suspended: 'Account Suspended',
    help_center: 'Help Center',
    auctioneer_has_declined_registration: 'The auctioneer has declined your registration.',
    registration_pending: 'Registration Pending',
    registration_approved: 'Registration Approved',
    download_our_app: 'Download Our App',
    and_get_bid_notifications: '& get bid notifications',
    lot_number_from: 'Lot {lotNumber} from',

    you_are_the_leading_bidder: 'You are the leading LiveAuctioneers bidder!',
    you_have_been_outbid: 'You have been outbid!',
    increase_your_chances: 'Increase your chances of winning by bidding higher.',
    increase_bid: 'Increase bid',
    bid_in_the_live_auction: 'Bid in the live auction for the best chance of winning.',
    why_cant_i_place_absentee_bid: 'Why can\'t I place an absentee bid?',
    why_cant_i_place_absentee_bid_popover_text: 'Absentee bids cannot be placed on items after the auction has started. Enter the live auction to bid on the item.',
    why_cant_i_retract_bid_popover_text: 'Bids may not be retracted after an auction has started.',
    item_lot_number: 'Lot {lotNumber}',
    search_items_helper: 'Lot # or Lot Title',
    request_online_bidding: 'Request online bidding',
    online_bidding_requested: 'Online bidding requested',
    why_cant_bid: 'Why can\'t I bid?',
    no_bid_reason: 'Online bidding isn\'t available for this catalog. To request online bidding {link} and you’ll be notified if bidding is made available.',
    request_submitted: 'Request submitted',
    request_submitted_long: 'We\'ll send you an email if the catalog begins accepting bids.',
    click_here: 'click here',

    // Ended Items
    ask_auctioneer: 'Ask Auctioneer',
    sell_similar_item: 'Sell a Similar Item',
    my_bid: 'My bid',
    bidder: 'Bidder',
    bid_history: 'Bid History',
    view_bid_history: 'View Bid history',
    lot_passed: 'Lot Passed',
    auction_ended_on: 'Auction ended on {date}',
    see_more_items: 'See More Items',
    view_details: 'view details',
    dont_miss_next: 'Don\'t Miss Your Next Treasure.',
    set_up_search_alert: 'Set up a search alert to hear when {sellerName} lists new auctions.',
    set_up_item_search_alert: 'Set up a search alert to hear when {token} items arrive.',
    welcome_message: 'Welcome to the world\'s largest marketplace for fine art, antiques & collectibles.',

    price: 'Price',
    bid_increment: 'Bid Increment',

    // Items
    more_items_from: 'More Items From',
    in: 'in',
    by: 'by',
    // Discover Items
    discover_items: 'Discover Items You\'ll Love',
    discover_related_items: 'Discover Related Items Available Now',
    similar_items_auctioneer: 'Similar items from this auctioneer',
    more_auctions_auctioneer: 'More auctions from this auctioneer',
    // Curators
    auction_curated_by: 'Auction Curated By',

    // Countdown
    days: 'Days',
    day: 'Day',
    hrs: 'Hrs', // abrev for Hours
    hr: 'Hr', // abrev for Hour
    until_auction_starts: 'Until Auction Starts',
    min: 'Min',
    left: 'Left',

    // Item Description:
    accepted_payment_methods: 'Accepted payment methods',
    auction_terms_and_info: 'Auction Terms & Info',
    bid_increments: 'Bid Increments',
    condition: 'Condition',
    details: 'Details',
    lot_details: 'Lot {lotNumber} Details',
    payment: 'Payment',
    terms: 'Terms',
    shipping: 'Shipping',
    shipping_and_payment: 'Shipping & Payment',

    // Similar Items
    bid_most_popular_items: 'Other Popular Items',
    bid_on_similar_items: 'Bid on Similar Items',
    // Item Card
    bid: 'Bid',
    sold_for: 'Sold for',
    lot: 'Lot',

    // Saved Items
    loading_saved_items: 'Loading Your Saved Items {loaded}/{loading}',
    empty_saved_items_message_part_1: 'Looks like you haven’t saved any items, yet.',
    empty_saved_items_message_part_2: 'To save an item, search for items you love, and tap the {heart} icon.',
    empty_saved_items_message_part_3: 'You’ll be alerted when your saved items are coming up at auction. {link}.',
    start_your_search_now: 'Start your search now',

    // Shared
    // AuctionInfo
    ask_a_question: 'Ask a Question',

    // Modals
    // HEALTHCHECK
    healthcheck_dashboard: 'Healthcheck Dashboard',
    refresh: 'Refresh',

    // Install Flash
    enjoy_the_live_auction: 'Enjoy the live auction!',
    having_trouble: 'Having trouble?',
    you_may_need_to_install_flash: 'You may need to install flash.',
    get_adobe_flash: 'Get Adobe Flash',
    we_also_recommend_trying_chrome: 'We also recommend trying Google Chrome.',
    get_google_chrome: 'Get Google Chrome',
    still_having_issues: 'Still having issues?',
    contact_our_support_team: 'Contact our Support Team',
    exit_and_continue_browsing: 'Exit and continue browsing',

    // Complete Account
    first_name: 'first name',
    last_name: 'last name',
    address_1: 'Address 1',
    address_2: 'Address 2',
    optional_parenthesis: '(optional)',
    address: 'address',
    country: 'country',
    city: 'city',
    state: 'state',
    zip_code: 'Zip/Postal Code',
    mobile_phone: 'Mobile Phone Number',
    phone_number: 'Phone',
    skip_this_step: 'Skip This Step For Now',
    complete_your_profile_to_start: 'Complete your profile to start bidding.',
    fill_out_later: 'You can always fill this out later.',
    you_must_enter_a_valid: 'You must enter a valid {token}.',
    enter_a_valid: 'Enter a valid {token}.',
    one_last_thing: 'One last thing!',
    state_province: 'state/province',

    // Complete Account Modal
    modal_zip_code: 'zip/postal code',
    modal_mobile_phone: 'mobile phone number',
    enter_a_token: 'Enter a {token}.',
    choose_from_dropdown: 'Choose a {token}.',

    // Sign up
    we_experienced_a_server_error: 'Sorry, we\'ve experienced a server error.',
    username_already_exists: 'You\'re already registered. Log in below:',
    create_account: 'Create Account',
    already_have_an_account_sign_in_here: 'Already have an account? {link}',
    sign_in_here: 'Sign in here',
    sign_up_for_a_free_membership: 'Sign up and begin your treasure hunt.',
    start_now: 'START NOW',
    terms_and_privacy: 'By signing up, you agree to our {tosLink} and {privacyLink}.',
    show: 'show',
    hide: 'hide',
    all_set: 'ALL SET',
    finish_creation: 'Yes! Finish creating your account to join the world\'s largest treasure hunt.',
    enter_a_valid_email_address: 'Please enter a valid email address.',
    enter_a_valid_password: 'Please enter a password.',

    // Login
    email_or_username: 'EMAIL ADDRESS / USERNAME',
    password: 'Password',
    submit: 'Submit',
    forgot_password: 'Forgot Password?',
    need_an_account: 'Need an account?',
    dont_have_an_account: 'Don\'t have an account?',
    sign_up_here: 'Sign up here',
    incorrect_username_or_password: 'Your username or password is incorrect.',
    incorrect_password: 'Incorrect password',
    you_must_enter_a_password: 'Please enter a password.',
    log_in_to_begin_your_treasure_hunt: 'Log in to begin your treasure hunt.',

    // Download Mobile Modals
    bid_live_using_mobile_apps: 'Bid LIVE using our mobile apps',
    enter_the_live_auction_on_our_app: 'Enter the live auction on our free {os} app',
    get_the_free_app_now: 'Get the free app now',
    no_app: 'We don\'t currently have a live bidding app for your device.',
    online_bidding_on_the_go: 'Online bidding, on the go…',
    use_our_apps_to_bid: 'Use our apps to bid on thousands of antique, fine art, and collectible items from around the world. Preview items in upcoming auctions, place bids in advance, watch and bid on live auctions and more—no matter where you are.',

    // Place Bid
    well_send_you_an_email: 'We\'ll send you an email once you\'ve been approved to bid.',
    reserve: 'reserve',
    reserve_not_met_bidder_message: 'Bid Recorded, Reserve not met.',
    reserve_bid_has_been_recorded: 'Your bid has been recorded, but the reserve hasn\'t been met. Unless the {reserve} is met, the lot will not be sold.',
    reserve_dispute_popover_text: 'The reserve is the minimum price the auction house will accept. In order to win, a bidder must meet or exceed the reserve and have the highest bid.',
    confirm_bid: 'Confirm Bid',
    bid_again: 'Bid Again',
    no_thanks: 'No Thanks',
    buyers_premium: 'Buyer\'s Premium',
    total: 'Total',
    your_maximum_bid: 'Your Maximum Bid',
    new_maximum_bid: 'New Maximum Bid',
    all_bids_must_be_approved: 'All bids must be approved by the auctioneer.',
    you_have_been_outbid_modal: 'You have been outbid by someone else\'s bid',
    you_can_still_win: 'You can still win. Bid higher.',
    by_clicking_confirm: 'By clicking Confirm you\'re committing to buy this item if you win and you are agreeing to the auctioneer\'s ',
    terms_of_sale: 'Terms of Sale.',

    // Retract Bid
    retract: 'Retract',
    retract_bid: 'Retract Bid',
    retract_long: 'We understand that sometimes things come up; however, retractions are disruptive. LiveAuctioneers may suspend bidders who frequently retract bids.',
    retract_why: 'Why are you retracting your bid?',
    retract_confirm: 'Your bid has been retracted',
    retract_dismiss: 'Back to browsing',
    retract_error: 'Error',

    //  password
    set_new_password: 'Set a new password.',
    set_password: 'SET PASSWORD',
    check_your_email: 'Check your email.',
    current_password: 'Current Password',
    new_password: 'New Password',
    confirm_new_password: 'Confirm New Password',
    please_enter_email_below: 'Please enter your email below.',
    send_reset_password: 'We\'ll send you a link to reset your password.',
    email: 'Email',
    email_address: 'Email Address',
    you_must_enter_a_valid_email_address: 'Please enter a valid email address.',
    your_passwords_dont_match: 'Your passwords do not match',
    your_passwords_must_match: 'Passwords must match.',
    your_password_length: 'Your password must be at least 6 characters.',
    your_password_reset: 'Your password has been successfully changed.',
    send_reset_instructions: 'Send Reset Instructions',
    follow_auctioneer: 'Follow Auctioneer',
    following_auctioneer: 'Following Auctioneer',
    we_have_sent: 'We sent you an email with instructions on how to reset your password.',
    if_you_do_not_receive: 'If you don\'t receive the email within a few minutes, {link} to try again.',
    resend_the_email: 'resend the email',
    back_to_browsing: 'Back To Browsing',
    back_to_bid: 'Back To Bid',
    bid_error: 'We\'re sorry, your bid was not successfully placed because of an error we encountered. Please place it again.',

    input_error: 'Input error',
    confirm_changes: 'Confirm Changes',
    confirm_changes_password: 'Please enter your password below to confirm your changes.',
    your_changes_have_been_saved: 'Your changes have been saved.',
    changes_saved: 'Changes Saved',

    // Auction Results
    auction_results_page_title: 'Search Auction Price Results - Live Auctioneers',
    auction_results_page_description: 'Search sold items.',
    auction_results_description: 'LiveAuctioneers’ Auction Price Results Database is a free research tool for those who want to buy or sell. Access 21 million art, antique, jewelry, furniture, collectible, and fashion results that were auctioned off from thousands of global auction houses. Search by keyword and refine by auction house, location, origin, style & period, creator, materials, techniques, and more to research and determine the value of items in your existing or future collection. Auction results are updated daily with new hammer prices so you can always access recently sold to historical results dating back to 1999. Whether you’re a collector wanting to know what price to pay; a consignor looking to learn the value of your property; an appraiser or estate office trying to evaluate a client’s possessions; or a journalist researching a given subject, our database is a valuable tool.',
    search_auction_price_results: 'Search Auction Price Results',
    see_auction_price_results_for: 'See {token} Auction Price Results',
    see_upcoming_category_items: 'See Upcoming {token} items',
    price_guide_results_how_much: 'How much is your',
    price_guide_results_worth: 'worth?',
    price_guide_results_value_of: 'Learn the market value of your',
    price_guide_results: 'Prices and Auction Results',
    price_guide_results_in: 'prices and auction results in',
    price_guide_results_research: 'Research',
    price_guide_title: 'Prices -',
    price_guid_discover: '{token} Prices and Auction Results',
    follow_search_tooltip: 'Follow to get email alerts when new {token} items arrive.',

    // Register
    back: 'Back',
    confirm: 'Confirm',
    register: 'Register',
    pending_approval: 'Pending Approval',
    bid_is_a_contract: 'Your bid is a contract',
    have_a_question_about_terms: 'Have a question about the terms?',
    auctioneer_terms_of_sale: 'Auctioneer terms of sale',
    terms_and_condtions_of_sale: 'Terms and Conditions of Sale',
    yes_i_agree_to_the_terms: 'Yes, I agree to the terms of sale.',
    you_must_agree_to_the_terms: 'You must agree to the terms of sale.',
    place_a_bid_only_if_youre_serious: 'Place a bid only if you\'re serious about buying the item.',
    if_you_are_the_successful_and_winning_bidder: 'If you are the successful and winning bidder, you have entered into a legally binding contract to purchase the property from the seller.',
    you_should_contact_the_seller_to_resolve: 'You should contact the seller to resolve any questions before bidding.  You can find this option on the item\'s detail screen.',
    your_auction_registration_is_pending: 'Your auction registration is pending approval from the auctioneer.  Once you\'ve been approved you\'ll receive an email from us.',

    // Send Seller Message
    to: 'To',
    subject: 'Subject',
    get_answers_here: 'Get Answers Here',
    have_a_general_question: 'Have a general question?',
    message_the_auction_house: 'Message the Auction House',
    message: 'Message',
    send_message: 'Send Message',
    you_must_enter_a_message: 'You must enter a message.',
    looks_like_something_went_wrong: 'Looks like something went wrong on our end. Please try again.',
    message_sent: 'Your message has been sent',
    j52_question: 'Have a question about Jasper52?',

    // Submit Consignment Modal
    consignment_item_description: 'Include details like what is it made of, who made it, when, the items condition, included documentations, marks or signatures.',
    item_desc_too_short: 'Your item description should be at least 30 characters',
    image_not_correct_format: 'All images must be .jpg or .png format',
    only_five_images_allowed: '5 images is the upload max. The auctioneer will be in contact should they need more photos.',
    why_consign_with: 'Why Consign with {sellerName}?',
    submit_consignment: 'Submit Consignment',
    licensed_auctioneer: 'Licensed auctioneer & expert appraiser',
    reach_millions: 'Reach millions on LiveAuctioneers',
    discover_the_value: 'Discover the value of your item',
    consign_with: 'Consign with {sellerName}',
    click_to_upload: 'Click to Upload Photos',
    item_images: 'Item Images',
    tell_us_about_your_thing: 'Tell us about your item(s)',
    add_photos: 'Add Photos',
    add_photos_description: 'Please submit up to 5 photos. Photos are very important for assessing the value.',
    thank_you: 'Thank You',
    consignment_review_notice: '{sellerName} aims to review each and every piece that passes through our inbox. If there is an interest, we may reach out in a few business days',
    keep_browsing: 'Keep Browsing',

    // Seller
    auction_ended: 'Auction Ended',
    ended: 'Ended',
    past: 'Past',
    page: 'page',
    upcoming: 'Upcoming',
    about_auctioneer: 'About Auctioneer',
    ends_sometime_onwards: 'Ends {endTime} {timeZoneAbbr} onwards',
    general_question: 'General Question',
    no_upcoming_auctions: '{auctionHouse} has no upcoming auctions. Follow this auctioneer to hear about new auctions.',
    past_auctions: 'Past Auctions',
    register_to_bid: 'Register to Bid',
    read_less: 'Read Less',
    read_more: 'Read More',
    starts: 'Starts {startDate}',
    upcoming_auctions: 'Upcoming Auctions',
    upcoming_auctions_from: 'Upcoming Auctions from {name}',
    past_auctions_from: 'Past Auctions from {name}',
    search_upcoming_items: 'Search upcoming items',
    record_results_for: 'Record Auction Results for {name}',
    consign_item: 'Consign Item',
    see_all_price_results: 'See all price results',
    follow_this: 'Follow this',
    no_upcoming_auctions_message_not_followed: '{name} has no upcoming auctions. {cta} auctioneer to hear about new auctions.',
    no_upcoming_auctions_message_followed: 'You\'re following {name}. We\'ll email you when this auctioneer lists new auctions.',

    // Seller Directory
    auction_house_directory: 'Auction House Directory',
    search_directory: 'Search',
    enter_auction_name: 'Enter Auction Name:',
    see_upcoming_auctions: 'See Upcoming Auctions Near Me',
    find_4000_auction_houses: 'Find 4,000+ Auction Houses…',
    united_states: 'United States',
    europe: 'Europe',
    all_around_the_world: 'All Around the World',
    auction_house_directory_on_liveauctioneers: 'Auction House Directory on LiveAuctioneers',
    loading_auctioneers: 'Loading Auctioneers',
    directory_description: 'Find the auction house you are looking for in our 4,000+ registered auction houses',

    // Near me page
    loading_auctions: 'Loading Auctions',

    // footer
    // mobile
    bid_anywhere_anytime: 'Bid Anywhere, Anytime. Download the LiveAuctioneers App.',
    available_on_the_app_store: 'Available on the App Store',
    android_app_on_google_play: 'Android App on Google Play',
    bid_anywhere_with_the_app: 'Bid Anywhere with the LiveAuctioneers App.',

    // SEO
    popular_searches: 'Popular Searches',
    artists_and_creators: 'Artists & Creators',
    brands: 'Brands',
    style_periods: 'Style Periods',
    origins: 'Origins',

    // Support
    company: 'Company',
    about: 'About',
    careers: 'Careers',
    press: 'Press',
    auction_central_news: 'Auction Central News',
    support_center: 'Get Help',
    contact_us: 'Contact Us',
    winning: 'Winning',
    how_auctions_work: 'How Auctions Work',
    auction_calendar: 'Auction Calendar',
    auctions_near_you: 'Auctions Near You',
    auctions_near_me: 'Auctions Near Me',
    past_auction_results: 'Past Auction Results',
    all_auctions: 'All Auctions',
    auction_result_search: 'Auction Result Search',
    mobile: 'Mobile',
    selling: 'Selling',
    why_sell: 'Why Sell',
    become_a_seller: 'Become A Seller',
    consign_an_item: 'Consign An Item',
    auctioneer_sign_in: 'Auctioneer Sign In',
    using: 'Using',
    the_new_liveauctioneers_site: 'The New LiveAuctioneers Site',
    classic_site: 'Classic Site',
    copyright: '2002-{year} LiveAuctioneers. All Rights Reserved.',
    terms_and_conditions: 'Terms & Conditions',
    pr_services: 'PR Services',
    privacy_policy: 'Privacy Policy',
    loading: 'loading…',

    // Trust
    as_seen_on: 'As Seen On',
    shop_with_confidence: 'Shop With Confidence',
    since_2002_liveauctioneers_has_made_items: 'Since 2002, LiveAuctioneers has made exceptional items available for safe purchase in secure online auctions.',

    sorry_we_cant_find: 'Sorry! We can\'t find what you\'re looking for.',

    // Catalog Page
    search: 'Search',
    sort: 'Sort',
    select: 'Select',
    estimate_highest_first: 'Estimate: Highest',
    estimate_lowest_first: 'Estimate: Lowest',
    least_bids: 'Least Bids',
    most_bids: 'Most Bids',
    lot_number_highest_first: 'Lot Number: Highest',
    lot_number_lowest_first: 'Lot Number: Lowest',
    price_highest_first: 'Price: Highest',
    price_lowest_first: 'Price: Lowest',
    date_ascending: 'Date: Ascending',
    date_descending: 'Date: Descending',
    time_ending_furthest: 'Time: Ending Furthest',
    time_soonest_first: 'Time: Starting Soonest',
    saved_recent_first: 'Saved: Recent First',
    saved_oldest_first: 'Saved: Oldest First',
    bid_recent_first: 'Bid: Recent First',
    bid_oldest_first: 'Bid: Oldest First',
    result_recent_first: 'Result: Recent First',
    result_oldest_first: 'Result: Oldest First',
    name_highest_first: 'Name: Z to A',
    name_lowest_first: 'Name: A to Z',
    upcoming_highest_first: 'Upcoming Count: Decending',
    upcoming_lowest_first: 'Upcoming Count: Ascending',
    last_sent_ascending: 'Last Sent: Ascending',
    last_sent_descending: 'Last Sent: Descending',
    search_term_ascending: 'Search Term: A-Z',
    search_term_descending: 'Search Term: Z-A',
    less: 'Less',
    more: 'More',
    lots: 'Lots',
    done: 'Done',
    location: 'Location',
    auction_and_auctioneer_information: 'Auction & Auctioneer Information',
    contact_auctioneer: 'Contact Auctioneer',
    preview: 'Preview',
    view: 'View',
    all: 'All',
    auction_info: 'Auction Info',
    previous: 'Previous',
    next: 'Next',
    approved_to_bid: 'Approved to bid',
    you_can_bid_on_any_of_the_items: 'You can bid on any of the items in this auction.',
    try_another_search: 'Please try another search term.',
    results_for: '{count} results for',
    clear: 'Clear',
    loading_results: 'Loading Results…',
    show_all_upcoming_auctions: 'Show all upcoming auctions',

    // Search
    you_must_enter_a_min_value_less_than_max: 'Min must be less than the max.',
    you_must_enter_at_lease_one: 'Enter at least a min or max value.',
    you_must_enter_a_valid_zip_code: 'Enter a valid zip code.',
    search_item_count_items: '{count} items',
    search_show_results_for: 'Show results for:',
    search_see_more: '+ Show More',
    search_see_all: 'Show All',
    search_see_less: '- Show Less',
    search_distance_view_less_countries: 'Show Fewer Countries',
    search_distance_view_more_countries: 'Show More Countries',
    search_sort: 'SORT:',
    search_no_auction_house_found: 'No auction houses found.',
    search_no_creator_found: 'No creators found.',
    search_term_for: 'for',
    search_home: 'Home',
    search_see: 'See',
    search_upcoming_item: 'Upcoming Item',
    search_sold_item: 'Sold Item',
    search_results: 'results',
    search_minimum: 'min',
    search_maximum: 'max',
    search_no_results: 'No luck! We couldn\'t find any items matching your criteria.',
    search_no_results_create_alert: 'to get email alerts when new items matching your criteria are available at auction.',
    search_no_results_saved_alert: 'Following Search! We will send you email alerts when new items matching your criteria are available at auction.',
    search_error_1: 'Oops! We are having temporary technical difficulties.',
    search_error_2: 'Please try refreshing the page in 10 seconds, or ',
    search_error_contact_support: 'contact our Support Team',
    search_error_3: ' if the problem persists.',
    within: 'Within',
    anywhere: 'Anywhere',

    alert_created: 'Alert Created',
    your_alert_has_been_created: 'Your alert has been created.',

    // Upcoming Item Search Sorts
    '-relevance_upcoming': 'Best Match',
    '-popularity_upcoming': 'Most Popular',
    '-publishDate_upcoming': 'Newly Listed',
    saleStart_upcoming: 'Time: Starting Soonest',
    '-saleStart_upcoming': 'Time: Starting Furthest',
    '-currentBid_upcoming': 'Price: Highest',
    currentBid_upcoming: 'Price: Lowest',
    '-estimatedPrice_upcoming': 'Estimate: Highest',
    estimatedPrice_upcoming: 'Estimate: Lowest',
    '-bidCount_upcoming': 'Most Bids',
    bidCount_upcoming: 'Least Bids',

    // Sold Item Search Sorts
    '-relevance_sold': 'Best Match',
    '-popularity_sold': 'Most Popular',
    '-publishDate_sold': 'Newly Listed',
    saleStart_sold: 'Time: Oldest',
    '-saleStart_sold': 'Time: Newest',
    '-bidCount_sold': 'Most Bids',
    bidCount_sold: 'Least Bids',
    '-hammerPrice_sold': 'Price: Highest',
    hammerPrice_sold: 'Price: Lowest',

    // My Auctions Page
    approved: 'Approved',
    pending: 'Pending',
    auctions: 'Auctions',
    empty_approved_auction_message_part_1: 'Looks like you aren\'t registered to bid in any upcoming auctions.',
    empty_approved_auction_message_part_2: '{link} you love and register to bid in the auctions to win.',
    empty_pending_auction_message_part_1: 'You have no current pending registration approvals.',
    empty_pending_auction_message_part_2: '{link} and register to bid in an upcoming sale.',
    search_for_items: 'Search for items',
    search_for_items_now: 'Search for items now',

    // My bids page
    you_are_leading: 'You\'re Leading',
    reserve_not_met: 'Reserve Not Met',
    outbid: 'Outbid',
    not_approved: 'Not Approved',
    you_won: 'You Won!',
    lost: 'Lost',
    increase_bid_of: 'Increase Bid of {bidAmount}',
    increase_max_of: 'Increase Max Bid of {bidAmount}',
    enter_live_auction: 'Enter Live Auction',
    similar_items: 'Similar Items',
    view_similar_items: 'View Similar Items',
    the_item_is_damaged: 'The item is damaged or misrepresented',
    change_of_mind: 'Change of mind',
    found_another_item: 'Found another item',
    other: 'Other',
    please_explain: 'Please explain…',
    loading_my_bids: 'Loading Your Bids {loaded}/{loading}',
    empty_upcoming_bids_message_part_1: 'Looks like you don’t have any bids in upcoming auctions.',
    empty_upcoming_bids_message_part_2: 'Let’s fix that. {link} and start bidding (and winning!)',
    empty_past_bids_message_part_1: 'Bids for items in upcoming or live auctions will be in the Upcoming Tab.',
    empty_past_bids_message_part_2: 'After the auction, you\'ll find the items that you\'ve bid on here.',
    empty_past_bids_message_part_3: 'Head on over to {link} and start bidding (and winning!)',
    search_for_unique_items: 'search for unique items',
    search_for_unique_items_cap_start: 'Search for unique items',

    // Followed auctioneers
    auctioneers: 'Auctioneers',
    upcoming_auct: 'upcoming auctions',
    unfollow: 'unfollow',
    loading_followed_auctioneers: 'Loading Your Followed Auctioneers {loaded}/{loading}',
    fourk_experts: '4,000+ licensed auction experts',
    no_upcoming: 'No upcoming auctions',
    follow_any: 'Follow any of our {experts} to access their profile, auctions, and items.',
    click_follow: 'Click the "Follow" button on any auctioneer profile to add them to your list.',
    empty_save_message_part_1: 'Looks like you aren’t following any auction houses.',
    empty_save_message_part_2: 'You can keep up to date with your favorite auctioneers, by pressing the \'Follow\' button on their auctioneer profile page.',
    empty_save_message_part_3: 'Head on over to the {link} to find auctioneers in your area.',

    // Followed searches and alerts
    saved_searches: 'Followed Searches and Alerts',
    searches: 'Searches',
    never_miss_out: 'Never miss out on the items you\'re interested in.',
    add_alerts: 'Follow Searches to get a daily email of new matches and to browse them on this page.',
    recent_results: 'Recent Results',
    manage_alerts: 'Manage Alerts',
    sent: 'Sent',
    remove: 'Remove',
    never: 'Never',
    advanced_alerts: 'Advanced Alerts',
    advanced_alerts_popover_text: 'Create search alerts that are refined by auction house, price range, location, and more. Search for items, refine your results, and then click "Create Search Alert"',
    loading_saved_searches: 'Loading Your Followed Searches {loaded}/{loading}',
    loading_saved_search_items: 'Loading Your Followed Search Items {loaded}/{loading}',
    empty_manage_alerts_message_part_1: 'You haven’t saved any searches!',
    empty_manage_alerts_message_part_2: 'Enter a search term in the box above and click \'Follow Search\' to add a search alert. You\'ll be notified when items matching that term are available for bidding.',
    empty_manage_alerts_message_part_3: 'Search alerts can also be created on the {link}. Enter a search term, filter down by your wanted criteria and click onto \'Follow Search\'.',
    search_page: 'search page',
    empty_recent_results_message_part_1: 'Bummer. There are no recent items that match any of your saved searches.',
    empty_recent_results_message_part_2: 'Matching items may appear in time. Expand your treasure hunt and {link} to find more interesting items.',
    save_new_searches: 'save new searches',

    // Category Pages
    follow_category: 'Follow',
    unfollow_category: 'Unfollow',
    following_category: 'Following',
    next_treasure: 'Don\'t Miss Your Next Treasure.',
    no_items_available: 'We have no {title} items available now.  Set up a search alert to hear when it arrives.',
    category_meta_vintage: 'Vintage',
    category_meta_shop_for: 'Shop for vintage',
    category_meta_at_auction: 'at auction',
    category_meta_from: 'from',
    category_meta_for_sale: 'for Sale & Antique',
    category_meta_starting_bids: ', starting bids at $1. With over',
    category_meta_lots_available: 'lots available for antique',
    category_meta_and: 'and',
    category_meta_miss_out: 'upcoming auctions, you won\'t want to miss out.',
    category_root_description: 'Free online bidding auctions available worldwide. Find online auctions for vintage jewelry, artwork, furniture and many other exceptional antiquities.  Available are local auctions online and pick up in-store, or arrange shipping from auctions near you. Thousands of auctions are ending every month, find your treasure.',
    category_root_title: 'Best Online Auctions | Live Auctions - LiveAuctioneers.com',

    // Follow Search
    save_search_save: 'FOLLOW SEARCH',
    save_search_saved: 'FOLLOWING SEARCH',
    save_search_create_search_alert_link: 'Follow this search',

    // Search Facets
    search_facet_title_auctionHouse: 'Auction House',
    search_facet_title_F1: 'Categories',
    search_facet_title_F2: 'Origin',
    search_facet_title_countryCode: 'Location',
    search_facet_title_currentBid: 'Current Bid',
    search_facet_title_materialsAndTechniques: 'Material / Technique',
    search_facet_title_stylePeriod: 'Style / Period',
    search_facet_title_creator: 'Creator',
    search_facet_title_estimate: 'Estimate',
    search_facet_title_hammerPrice: 'Sold For',
    search_facet_add_exclusion: 'Exclude',
    search_facet_remove_exclusion: 'Include',

    // Search Input
    search_input_sold: 'Sold',
    search_input_upcoming: 'Upcoming',
    search_input_search_past_auction_price_results: 'Search past auction price results',
    search_input_search_for_items_and_auction_houses: 'Search for items and auction houses',

    // Breadcrumbs
    back_to_auction: 'Back to Auction',
    back_to_search: 'Back to Search',
    view_auction: 'View Auction',

    // Account Settings Page
    my_profile: 'My Profile',
    email_preferences: 'Email Preferences',
    change_password: 'Change Password',
    account_update_error: 'We\'re sorry, we were unable to update your account at this time. Please try again.',
    newsletters: 'Newsletters',
    frequency: 'Frequency',
    email_alerts: 'Email Alerts',
    real_time_alerts: 'Real Time Alerts',

    // Near me page
    find_auctions_near_me: 'Find Auctions Near Me',
    find_auctions_description: 'Find auctions from thousands of auctioneers near you on an interactive map. Then bid live online on art, antiques, jewelry and collectibles from around the world.',
    find_auctions_on_a_map: 'Find auctions near an area on a map. Then browse auction catalogs from thousands of auctioneers to bid live online on art, antiques, jewelry, and collectibles.',
    enter_location: 'Enter Location:',
    city_zip_or_postal_code: 'City, ZIP, or Postal Code…',

    // Seller Testimonials page
    seller_testimonials: 'Seller Testimonials',
    what_our_clients_say: 'What our clients say about us',
    comment1_0: '“The New York Times, New York Post, CBS This Morning, The Huffington Post, Associated Press, The Miami Herald, Vogue Italia, Canadian-Latin American-German press agencies, print media and websites-blogs-tweets-Facebook entries worldwide… all writing, tweeting and talking about our January 19, 2013, auction and all because LiveAuctioneers PR Services let the world know about it.',
    comment1_1: 'The result: our best auction to date, with 690 registered bidders, 568 bids, 186,000 page views, 20,000+ visitors and $330,000 in winning bids, and all that just on LiveAuctioneers.com! That doesn’t include, as a result of your PR work, the record 400+ in-house bidders, phone bidders or left bids that all contributed to a million-dollar auction. The sheer numbers, in terms of sales and bidders, were way beyond our expectations, but you gave us even more, something you can’t pay for… EDITORIAL, exposing our auction house all over the world!',
    comment1_2: 'You shared our passion about the auction, worked hard (even on nights and weekends) and relentlessly pursued every possible PR lead. We really don’t know how to thank you; you have energized and set the new standard for Palm Beach Modern Auctions.',
    comment1_3: 'I would recommend your services to any auction house looking to increase their sales or company presence in the auction world.”',
    comment2: '“Collectors all over the world really like LiveAuctioneers. The format is simple to use, and it has become a very good highway for bidding in our sales. The age of reservation about bidding online is over; it took a company like LiveAuctioneers, which has proven itself, to make that happen. We have been very pleased.”',
    comment3: '“LiveAuctioneers allows us to reach an entirely new audience of potential buyers around the world who can then take part in our auctions ‘live’ on the day. It has had a significant impact on the success of our business.”',
    comment4: '“I used to pride myself in having a strong international clientele through phone, mail and fax bidding, but with the addition of LiveAuctioneers, my worldwide client base has increased exponentially. After my last sale, I shipped merchandise to Finland, Denmark, France, Germany, Austria, England, Belgium, the Netherlands, Portugal, Spain, Mexico, New Zealand, Australia, Japan, Canada, Singapore and even to one bidder in Czechoslovakia. It’s amazing that all these people are just a mouse click away.”',
    comment5: '“In a nutshell, I wouldn’t be in business without LiveAuctioneers. Our auctions average a 35-40% sell-through with the site, and on many occasions we’ve approached the 50% mark online. LiveAuctioneers has brought us customers from all over the world, including some very good regular buyers in Turkey, Israel and other countries.”',
    comment6: '“This last sale was a huge success and the participation through LiveAuctioneers was one of, if not the, highest, so far. It was one of our higher-end sales. We’re seeing a shift in the population that typically bids with us online—a good shift.”',
    comment7: '“Online bidding is the staple of any successful auction these days. And having a great online bidding system, like LiveAuctioneers, is critical.”',
    comment8: '“Thanks so much for an awesome auction. You all have been a huge part of our business. It seems almost flawless and the bidders seem to find the process so much easier. You all have really built something valuable!”',
    comment9: '“Thank you for your help in getting us started. Had it not been for the assistance of your tremendously helpful staff, the auction would not have been the success that it was. Our low estimates were in the $120,000 range, and actual sales were $264,000. Not bad at all!”',
    comment10: '“Working with LiveAuctioneers was a fantastic experience for my nonprofit organization. As a public charity, we rely on a variety of means to raise funds. You folks helped us launch our first-ever online auction and it was a tremendous success on a few different levels. First, we exceeded our revenue goals. But perhaps equally important, we did this without eating up a lot of our small staff’s valuable time. The tools that LiveAuctioneers provided us with were invaluable and easy to use. I look forward to working with you again in the future.”',
    comment11: '“It’s been a week since our New Year’s auction and we have been struggling to find the right words to describe our first experience with LiveAuctioneers PR Services. Beyond expectations? Incredible? We could not believe the response, not just in the U.S. but around the world. We sold $70,000 to Russian bidders and close to $80,000 to China, in addition to the U.S. and other countries. We were on TV, radio, in newspapers and magazines, on collector sites, the Internet and on top of the search engines. Fabulous! We had over 70,000 hits on LiveAuctioneers, alone, before the auction. Beyond expectations! Just before the auction we took a late consignment and mentioned it to Catherine at LiveAuctioneers. Two days later, it was picked up by major collector sites. Incredible!”',
    comment12: '“Just wanted to take the time to tell you that you and your staff are doing a great job! My staff couldn’t be happier with how things are going for us with LiveAuctioneers. The new reports are fabulous. The gentlemen that handle the phones are courteous and oh so patient. Kudos.”',
    comment13_0: '“There is no denying that LiveAuctioneers has helped our auction company expand our business. Since we started using their online auction service, our prices have only increased. We have seen thousands of people look at our auctions and have received hundreds of absentee bids, and this is just for one auction! Having several of these auctions has only proved that we are reaching a broader audience than we could have ever imagined.',
    comment13_1: 'We just held a ‘country store-style’ auction a few weeks ago. Many items sold to online bidders for 2x or 3x the value that we could have gotten here at our auction house. Some items had 30-60 bids; the majority of the bidders were online. It is hard to believe the whole world is watching your auction house, but it is true. For this sale alone, we had hundreds of bidders from all across the U.S. and various countries. Working with LiveAuctioneers has been a great experience. With just a little extra work, our auction company is now known across the world.”',
    comment14: '“It’s now the third live auction we have done with LiveAuctioneers, and all we can say is: thank you! Thank you for your professional and fast support, thank you for your effort to improve and adjust your system to the needs of your customers. It’s good to have real people on the phone when you need them and it’s good to get an answer no matter how dull the question. Life would be easier on the web and a better place if there were more companies like LiveAuctioneers.”',
    comment15: '“It was an immense pleasure to have LiveAuctioneers help us through our first live auction 5 months ago. They are a benchmark for what excellent support should be.”',
    comment16: '“Stout Auctions has used LiveAuctioneers numerous times and we have been exceedingly happy with the results and the service they have offered. One improvement in particular convinced me to write this, and that service is the new invoicing system. No one else has an invoicing system like LiveAuctioneers; it literally saves me a full day of sorting out buyers, shipping costs, emails etc. Keep this up and you’re going to have to buy eBay!”',
    comment17: '“I have just been reviewing the new bidder approval process for our current auction. I must say that I am always stunned at how well LiveAuctioneers pioneers this industry we all love. This approval process is ingenious. I am quite sure that a tremendous amount of time and resources were poured into creating this option to assist the auction houses. I am proud to have our auction house as one of your clients. Thank you for breaking down the walls for all us brick & mortar auction galleries who just simply cannot do what you have done, and have done better than anyone else. Continue to educate the world about the joy of auctions and you will always have my support.”',
    comment18: '“After using other service providers with online auctions (via eBay and others), we are very pleased with LiveAuctioneers. The service has been great, the back-end administration features are excellent, and the ease of use is appreciated as well. We are most pleased with the post-auction reports and the detailed item reports, allowing us to tweak item descriptions to find the most buyers. We’ll continue to use LiveAuctioneers as our service provider for our online auctions. Thanks!”',
    comment19: '“Your entire company is nothing short of fantastic!“',

    // Privacy Policy Page
    la_privacy_policy: 'LiveAuctioneers Privacy Policy',
    our_commitment_to_privacy: 'Our Commitment To Privacy',
    commitment_to_privacy_body: 'LiveAuctioneers is committed to maintaining user privacy on the Live Auctioneers\' website at www.liveauctioneers.com (the "Site"). Our Private Policy governs use of personal information provided to us through the use of the Site. By accessing the Site you agree to be bound by the terms and conditions of this Privacy Policy. If you do not agree to its terms and conditions, you should not use or access our Site. By accepting the Privacy Policy, you expressly consent to our use and disclosure of your personal information in accordance with the policy. The Privacy Policy is incorporated into and subject to the terms of any agreement you sign with LiveAuctioneers and becomes applicable upon our acceptance of you as a registered user. If you have any additional questions about our Privacy Policy, please feel free to contact us at {mailTo}',
    use_of_site_by_children: 'Use of Our Site by Children',
    child_policy_body: 'Children (persons under the age of 18) are not eligible to use the Site unsupervised and we ask that children do not submit any personal information. If you are under the age of 18, you may only use this Site in conjunction with and under the supervision of parents or guardians.',
    information_we_collect: 'Information We Collect',
    information_collect_body: 'If you choose to use our services, we may require that you provide contact and identity information, billing information, shipping information, as well as other personal information as indicated on the forms throughout the Site. Where possible, we indicate fields that are required and those that are optional. You are not required to provide information if you choose not to use a particular service or feature. Please be advised that we may use your financial information, including credit card information, to verify the accuracy of your name, address, and other personal information, as well as to bill you for use of our services. Certain information is automatically tracked based on your activity on the Site. We use this information for internal research on user demographics, interests, and behavior so as to better understand, protect and serve you and our community. This information may include the URL that you previously visited (whether this URL is on the Site or not), the subsequent URL you visited (whether this URL is on the Site or not), your computer browser information, and your IP address. We may collect browser and Internet-related information through access to our Site, via cookies, and/or web beacons. If you send us personal correspondence, such as emails or letters, or if other users or third parties send us correspondence regarding your activities or postings on the Site, we may accumulate such information into a file specific to you.',
    our_use_of_your_information: 'Our Use of Your Information',
    our_use_your_information_body: 'We use your personal information to facilitate the services you personally request. Your contact information and bidding history will be passed onto the Auction Companies during the auction sign-up process for them to make a decision whether you are able to bid in their auction. We also use your personal file information and activity information to: resolve disputes; troubleshoot problems; collect fees owed; measure consumer interest in our products and services; inform you about online and offline offers, products, services, and updates; customize your experience; detect and protect us against error, fraud and other criminal activity; enforce applicable agreements; and as otherwise described to you at the time of collection. Providing us with your personal information indicates that you agree to our use of any personal information to improve our marketing and promotional efforts, to analyze Site usage, improve our content and product offerings, and customize the Site\'s content, layout, and services. In turn, we are able to improve the Site and better tailor it to meet your needs, providing you with a smooth, efficient, safe and customized experience. We also reserve the right to use your information to make contact and deliver information that, in some cases, is targeted to your interests. Examples include targeted banner advertisements, administrative notices, product offerings, and communication relevant to your use of the Site. By accepting this Privacy Policy, you expressly agree to receive this information, however, you may contact us at {mailTo} should you wish to cease receipt of such information.',
    our_disclosure_of_your_information: 'Our Disclosure of Your Information',
    our_disclosure_your_information_body: 'While we use your information to provide you with access to our site and services, we also use your information to contact you regarding our services, offerings, or information you may have requested. We use your information to improve and personalize our Site so as to make it easier, safer, and quicker to use. Due to the existing regulatory environment, we cannot ensure that all of your private communication and other personal information will never be disclosed in ways not otherwise described in this Privacy Policy. By way of example (without limiting the foregoing), we may be forced under certain circumstances to disclose personal information to the government or third parties, unaffiliated parties may unlawfully intercept or access transmissions or private communication, or users may abuse or misuse your personal information collected from the Site. Therefore, although we use industry standard practices to protect your privacy, we do not promise, and you should not expect, that your personal information or private communication will always remain completely private.',
    security: 'Security',
    security_body: 'We store your information in the United States. In order to prevent unauthorized access, maintain data accuracy, and ensure appropriate use of information, we use industry-leading technical and administrative practices and procedures that safeguard and secure your information.',
    notice: 'Notice',
    notice_body: 'We may occasionally choose to amend this Privacy Policy to better reflect our use and protection of your information. In the event of revision, all terms shall become effective within 15 days of initial posting to the Site.',
    last_updated: 'Last updated: February 6, 2013',

    // Features Page
    features_and_services: 'Features & Services for Auctioneers',
    feature_blurb: 'Live online auctions deliver a powerful trifecta: the potential of thousands of new customers, increased average hammer prices and dramatically fewer unsold items. Using LiveAuctioneers tools and features, you can track and analyze performance while tapping into the global Internet marketplace to build your business:',
    live_bidding: 'Live Bidding',
    live_bidding_blurb: 'This allows bidders to place bids at the same time as the auction is actually taking place. The process is similar to telephone bidding, but much faster. Bidders can bid online using their computer, or via iPhone, iPad or Android apps.',
    absentee_bidding: 'Absentee Bidding',
    absentee_bidding_blurb: 'Once visitors have found an item that interests them, they can leave a bid online. A simple bidding form on the item description page allows them to leave a maximum bid before the sale starts. The bid is recorded and presented to the auctioneer via the live console when the auction starts.',
    auctioneer_dashboard: 'Auctioneer Dashboard',
    auctioneer_dashboard_blurb: 'The go-to for everything involving a LiveAuctioneers account. From step-by-step auction set-up to bidder registration and approval, it\'s all organized, along with email messaging, access to marketing services and helpful guides and forms, just a click away.',
    our_network: 'Our Network',
    our_network_blurb: 'Our live network runs on multiple server clusters located in two different regions of the US to ensure redundancy. Our East Coast and Southern US data centers have fully redundant battery power, generator back-up and massive connectivity, utilizing such reliable network providers as Level 3, Global Crossing and Congent. A team of technologists dedicated to network and server maintenance ensures the reliability of a complex custom system configuration to handle millions of live bidding transactions daily.',
    catalog_set_up: 'Catalog Set-up',
    catalog_set_up_blurb: 'Item descriptions, images, estimated selling prices and contact details encourage visitors to view your catalogs before registering to bid. After a catalog has been published on LiveAuctioneers, registered bidders can view items and leave absentee bids, or wait to bid live on the day of the sale.',
    bidder_management: 'Bidder Management & Approve, Block, Set as Regular',
    bidder_management_blurb: 'This feature enables your company to review and approve bidders based on past online activity. It can be done manually or with set criteria, which automatically approves bidders meeting those conditions.',
    inbox_messaging: 'Inbox Messaging',
    inbox_messaging_blurb: 'This makes communication with bidders easy and centralized, offering you the chance to receive and reply to bidder questions throughout the auction process. All bidder conversations are threaded, linked to bidder profiles, and can be sorted info folders.',
    statistics_tracking: 'Statistics Tracking',
    statistics_tracking_blurb: 'Tracks how many times each item was viewed, number of visitors and referring URLs.',
    self_service_upload: 'Self-Service Upload',
    self_service_upload_blurb: 'Makes it possible for you to upload images and catalogs directly into the LiveAuctioneers system 24/7.',
    automated_online_console: 'Automated Online Console',
    automated_online_console_blurb: 'The automated console has the same look and feel of a standard auction, with the key added benefit of running an unmanned online auction, if you prefer.',
    end_of_auction_report: 'End-of-Auction Report',
    end_of_auction_report_blurb: 'A performance report sent via email with critical statistics: sales totals, visits, hits, bidder registrations and more from a recent auction.',
    live_items_widget: 'Live Items Widget and Live Catalog Widget',
    live_items_widget_blurb: 'Live Items Widget displays live items directly on the your website in a 220x200 window. Live Catalog Widget displays the entire catalog on your website in the gallery layout.',
    qr_code: 'QR Code',
    qr_code_blurb: 'A QR code image can be added to your print ads, allowing smart phone users to go directly to your catalog.',
    staff_permission_levels: 'Staff Permission Levels',
    staff_permission_levels_blurb: 'Permission access levels for your staff can be set within a LiveAuctioneers account.',
    weekly_newsletter: 'Weekly Newsletter',
    weekly_newsletter_blurb: 'This newsletter is sent to bidders weekly, with links to upcoming auctions.',
    help_files: 'Help Files',
    help_files_blurb: 'This comprehensive tool helps to answer questions about running a sale online, including demo videos and detailed steps.',
    bidder_contact_and_invoicing: 'Bidder Contact and Invoicing',
    bidder_contact_and_invoicing_blurb: 'This feature enables you to contact winning bidders with customized emails or invoices within minutes of the auction close, avoiding the time-consuming task of invoicing. LiveAuctioneers\' fully automated system also allows a buyer to complete his/her purchase online.',
    paypal: 'PayPal',
    paypal_blurb: 'The platform receives automated bidder payment notifications from PayPal.',
    accounting: 'Accounting',
    accounting_blurb: 'This makes it easy to track auction accounting information.',
    white_label_platform: 'White-Label Platform',
    white_label_platform_blurb: 'This option allows you to customize the live bidding console and run live auctions directly from your website.',
    api_integration: 'API Integration',
    api_integration_blurb: 'Your auction management software can seamlessly integrate with LiveAuctioneers\' database through this function.',

    // How it Works Page
    how_to_buy_at_auction: 'How to Buy at Auction',
    bidding_on_la_is_easy: ' Bidding on LiveAuctioneers is easy - and you can do it from any internet connect device, anywhere!',
    step_one: 'Register For Free',
    step_one_blurb: 'Join the community with the largest collection of storied items.',
    step_two: 'Place Your Bids',
    step_two_blurb: 'Many items start at just $1. Place bids and get approved.',
    step_three: 'Ensure You Win',
    step_three_blurb: ' Watch the live auction to ensure you win. See all the action.',
    step_four: 'Pay If You Win',
    step_four_blurb: 'Only if you win will you be asked to pay and arrange shipping.',

    // Price Gateway
    price_gateway_item_page: 'Sign Up For Sold Price',
    price_gateway_card: 'See Sold Price',

    auction_terminology: 'Auction Terminology',

    intellectual_property: 'Intellectual Property',

    // buyers premium
    middle_low_cut_off: '{middle}% above',
    middle_cut_off: '{middle}% up to',
    high_cut_off: '{high}% above',
    low_cut_off: '{low}% up to',
    low_percentage: '{low}%',

    // banners
    be_a_part_of_the_savviest: 'Be a part of the savviest, smartest group of collectors worldwide',
    hunt_like_a_vintage_shop_owner: 'Hunt like a vintage shop owner',
    join_the_community: 'Join the community',
    start_your_treasure_hunt: 'Start your treasure hunt',
    access_200000_new_items_every_week: 'Access 200,000 new items every week, from anywhere',
    your_next_great_find: 'Your next great find is here',
    get_started: 'Get started',

    lets_go_treasure_hunting: 'Let\'s go treasure hunting',
    browse_popular_items: 'Browse popular items',
    find_exceptional_fine_art: 'Find exceptional fine art, collectibles, and décor in online auctions',

    // won-items
    won: 'Won',
    ask_house: 'Contact Auction House',
    make_payment: 'MAKE A PAYMENT',
    dispute_tooltip_message: 'A dispute has been filed by the acution house. Please make a payment or contact the auction house to resolve this issue.',

    wonitems: {
        catalog: {
            total_label: 'Total: {amount}'
        },
        badges: {
            payment_due: 'Payment Due',
            overdue: 'Overdue. {dispute}',
            dispute_filed: 'Dispute filed',
            paid: 'Paid',
            tooltip_message: 'A dispute has been filed by the acution house. Please make a payment or contact the auction house to resolve this issue.'
        }
    },

    explore_collections_from_the_worlds_top: 'Explore collections from the world\'s top auction specialists',
    browse_collectibles: 'Browse collectibles',

    search_auction_results_from: 'Search auction results from 1000s of auctioneers',
    find_the_perfect_auction_house: 'Find the perfect auction house to sell your items',
    search_price_results: 'Search Price Results',

    // consignments
    consign_items_to_an_auction: 'Consign Items To An Auction',
    why_consign_with_us: 'Why Consign with Us',
    how_did_you_aquire: 'How did you acquire this item?',
    how_to_consign_items_to_seller: 'How to Consign Items with {sellerName}',
    consign_description_1: 'LiveAuctioneers\' mission is to connect buyers with sellers of quality goods. If you own an item(s) you would like to consign, we can help make that key connection to our more than 4,000 auctioneers.',
    consign_description_1_seller: 'LiveAuctioneers\' mission is to connect buyers with sellers of quality goods. If you own an item(s) you would like to consign, we can help connect you with {sellerName}.',
    consign_description_2_title: 'Consignment Process:',
    consign_description_2: 'We assist in the sale of your property by providing a secure, neutral platform in which buyers and sellers worldwide may establish contact. Please complete the online form with item details. Your item will be listed and available for review and evaluation by all auctioneers on our site. If an auctioneer is interested in your item, their staff will get in touch with you.',
    consign_description_2_seller: '{title} We assist in the sale of your property by providing a secure, neutral platform in which buyers and sellers worldwide may establish contact. Please complete the online form with item details. Your item will be listed and available for review and evaluation by {sellerName}. If {sellerName} is interested in your item, their staff will get in touch with you.',
    consign_description_3_title: 'Please Note:',
    consign_description_3: '{title} Estimates are not provided through this process. If you are seeking an estimate for your item, please contact a local auction house. LiveAuctioneers does not act as an agent for your merchandise, nor do we in any way make representations with respect to the authenticity or value of your material goods.',
    photo: 'Photo',
    value: 'Value',
    i_bought_it: 'I bought it',
    i_inherited_it: 'I inherited it',
    i_found_it: 'I found it',
    it_was_a_gift_it: 'It was a gift',
    log_in_to_consign: 'Log in to consign',
    successfully_submitted: 'Successfully Submitted',
    general_description: 'General Description',
    description: 'Description',
    physical_details: 'Physical Details',
    consignment_submitted: 'Consignment Submitted',
    submit_another_consignment: 'Submit Another Consignment',
    browse_la: 'Browse LiveAuctioneers',
    your_consignment_has_been_submitted: 'Your consignment has been submitted. If an auctioneer is interested, they will contact you directly.',
    other_help: 'Further information that will help in the sale of your property',
    description_help: 'Please describe your item an as much details as possible. Please include details like what is it made of, who made it, when, the items condition, included documentations, marks or signatures',
    details_help: 'Dimensions, manufacturers’ marks, condition (and details regarding any exceptions to condition), material or medium (if artwork), etc.',
    category: 'Category',
    your_item_is_being_shared: 'Your item is now being shared with 4000 of the world\'s best auction houses.  What happens next? * If an auction house is interested, they\'ll contact you directly via e-mail.',
    twentieth_century: '20th Century',
    autographs: 'Autographs',
    books: 'Books',
    commercial: 'Commercial',
    decorative_arts: 'Decorative Arts',
    entertainment: 'Entertainment',
    fine_art: 'Fine Art',
    rugs_and_carpets: 'Rugs/Carpets',
    toys: 'Toys',
    please_choose_a_photo: 'Please choose a photo to upload.',
    there_was_an_error_submitting_consignment: 'We experienced an error trying to submit your consignment.  Please try again later.',

    item_description: 'Item Description',

    ok: 'ok',
    cancel: 'cancel',

    // auction calendar
    auction_date: 'Auction Date',
    select_a_date: 'Select a Date',
    auction_house: 'Auction House',
    auction_status: 'Auction Status',
    auction_calendar_title: 'Auction Calendar - Upcoming Online Auctions & Local Auctions',
    auction_calendar_description: 'Find all the upcoming online auctions happening today, this week or even months ahead. With over {count} auctions ending today, bid with auctions around the world or local auctions near you.',

    // bidding console
    current_bid: 'Current Bid',
    popular_lots_in_this_auction: 'Popular Lots in This Auction',
    house_is_delighted_your_here: '{name} is delighted you\'re here!',
    view_the_catalog: 'View the Catalog',
    catalog_will_start_shortly: 'Stay tuned. Auction will begin shortly',
    images_label: '{currentImageNumber} of {totalImages}',
    auction_has_ended: '{title} has ended',
    follow_seller_to_hear_about_their_next_auction: 'Follow {name} to hear about their next auction.',
    lot_number_and_title: 'Lot {lotNumber}: {title}',
    view_other_live_auctions: 'View Other Live Auctions',
    lot_sold_for: 'Lot {lotNumber} sold for {amount} to {source}',
    competing_bid_amount: '{amount}: Competing Bid',
    you_ve_won_lot: 'You\'ve won Lot {lotNumber}',
    liveauctioneers_bid_amount: '{amount}: LiveAuctioneers Bidder {paddleNumber}',
    you_been_outbid_by_liveauctioneers: 'You\'ve Been Outbid by Bidder {paddleNumber}',
    you_been_outbid_by_competing: 'You\'ve Been Outbid by a Competing Bidder',
    my_bid_amount: '{amount}: My Bid',
    liveauctioneers_bidder: 'Bidder {paddleNumber}',
    competing_bid: 'Competing Bidder',
    ask_price_changed_to: 'Ask Price Changed: {amount}',
    lot_opened_asking: 'Lot {lotNumber} Opened - Ask {amount}',
    youre_winning: 'You\'re Winning',
    your_bid_has_been_sent: 'Your bid has been sent',
    youve_been_outbid_bid: 'You\'ve Been Outbid, Bid {amount}',
    bid_amount: 'Bid {amount}',
    my_bid_submitted: 'My bid for {amount} submitted',
    lot_closed: 'Lot Closed',
    your_registration_has_been_approved: 'Your registration has been approved',

    last_bid_retracted: 'Last bid of {amount} retracted',
    my_bid_retracted: 'Your bid for {amount} was retracted',
    lot_number_closed: 'Lot {lotNumber} Closed',
    lot_number_passed: 'Lot {lotNumber} Passed',
    lot_number_reopened: 'Lot {lotNumber} Re-Opened',
    lot_number_skipped: 'Lot {lotNumber} Skipped',
    lot_number_unsold: 'Lot {lotNumber} Unsold',
    placed_bid_on: 'Placed bid of {amount} on {lotNumber}',
    disconnected_from_auction: 'Disconnected from the Auction',
    trying_to_reconnect: 'Trying to reconnect…',

    back_to_top_button: 'BACK TO TOP',

    // catalog ad
    explore_auction: 'Explore Auction',
    your_ad_here: 'Your ad here?',
    advertisement: 'Advertisement',

    // whitelabel header
    return_to: 'Return to {name}',

    // whitelabel footer
    powered_by: '{name} {onlineAuctions} by:',
    onlineAuctions: 'online auctions',
    copyright_whitelabel: 'Ⓒ {year} LiveAuctioneers. {terms} {privacy}',
    privacy: 'Privacy',
    bid_anywhere_anytime_mobile: 'Bid Anywhere with LiveAuctioneers.',

    free: 'Free',

    // Checkout Page
    checkout: {
        crown: {
            cta: 'Continue bidding on other items'
        },
        page: {
            title: 'LiveAuctioneers Secure Checkout',
            description: 'Get in on the auction — bid LIVE online on art, antiques, jewelry and collectibles. Find online auctions from around the world at LiveAuctioneers.'
        },
        shipping: {
            title: '1. Shipping Address',
            checkbox_label: 'Use my saved address as my Shipping Address',
            save_button_text: 'Save and Continue',
            edit_label: 'Edit',
            cancel_label: 'Cancel'
        },
        payment: {
            title: '2. Payment Type',
            stripe: {
                title: 'Safety & Security',
                description: 'Our Payment provider, Stripe, meets the strictest requirements of PCI-DDS.',
                list_title: 'Your card information…',
                item_1: 'never hits our servers',
                item_2: 'is completely encrypted',
                item_3: 'is never passed to an auctioneer'
            },
            checkbox_label: 'Use my Shipping Address as my Billing Address',
            edit_label: 'Edit',
            cancel_label: 'Cancel',
            alert_label: 'Add'
        },
        title: 'Checkout',
        subtitle: 'LiveAuctioneers provides a secure way to quickly pay for your items',
        invoice_summary: {
            title: 'Charges Summary',
            loading: 'Loading your invoice…',
            payments_title: 'Payments Summary',
            items_total: 'Items Total',
            buyers_premium: 'Buyer\'s Premium',
            sales_tax: 'Sales Tax',
            processing_fee: 'Processing Fee',
            shipping: 'Shipping'
        },
        balance: {
            note: 'Note:',
            message: '{strong} You\'ll have the opportunity to arrange shipping with the auctioneer after paying for the item. By paying for this item, you agree to the {terms} set by the auctioneer.',
            total: 'Balance Due',
            cta: 'Pay Now'
        },
        review: {
            list: {
                first_column_header: 'Items in cart ({count})',
                second_column_header: 'Item Price'
            },
            title: '3. Review Order',
            button: 'Pay Now',
            note: 'Note:',
            message: '{strong} You\'ll have the opportunity to arrange shipping with the auctioneer after paying for the item. By paying for this item, you agree to the {terms} set by the auctioneer.',
            total: 'Total:'
        },
        total: 'Total'
    }
};

exports.default = en;
module.exports = exports['default'];

/***/ }),

/***/ "eUWk":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.submitRegisterForCatalog = exports.registerForCatalogSuccess = exports.registerForCatalogRequest = exports.registerForCatalogFail = exports.getUserRegisterForCatalog = exports.getUserCatalogIdForRegistration = exports.REGISTER_FOR_CATALOG_SUCCESS = exports.REGISTER_FOR_CATALOG_REQUEST = exports.REGISTER_FOR_CATALOG_FAIL = undefined;

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;

var _modal = __webpack_require__("u90i");

var _api = __webpack_require__("zFQO");

var _reselect = __webpack_require__("bndy");

var _user = __webpack_require__("CFLi");

var _config = __webpack_require__("iS9E");

var _analytics = __webpack_require__("yxCd");

var _biddable = __webpack_require__("g3g9");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Action Types */
var REGISTER_FOR_CATALOG_FAIL = exports.REGISTER_FOR_CATALOG_FAIL = 'la/ui/registerForCatalog/FAIL';
var REGISTER_FOR_CATALOG_REQUEST = exports.REGISTER_FOR_CATALOG_REQUEST = 'la/ui/registerForCatalog/REQUEST';
var REGISTER_FOR_CATALOG_SUCCESS = exports.REGISTER_FOR_CATALOG_SUCCESS = 'la/ui/registerForCatalog/SUCCESS';

/* reducer */
var DEFAULT_STATE = {
    catalogId: null,
    error: false,
    fromBiddingConsole: false,
    submitted: false,
    success: false
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        case _modal.OPEN_REGISTER_FOR_CATALOG_MODAL:
            return (0, _extends3.default)({}, state, {
                catalogId: action.payload.catalogId,
                fromBiddingConsole: action.payload.fromBiddingConsole ? action.payload.fromBiddingConsole : false
            });
        case REGISTER_FOR_CATALOG_FAIL:
            return (0, _extends3.default)({}, state, {
                error: true,
                submitted: false,
                success: false
            });
        case REGISTER_FOR_CATALOG_REQUEST:
            return (0, _extends3.default)({}, state, {
                submitted: true,
                success: false
            });
        case REGISTER_FOR_CATALOG_SUCCESS:
            return (0, _extends3.default)({}, state, {
                submitted: false,
                success: true
            });
        default:
            return state;
    }
}

/* SELECTORS */
var registerForCatalogSelector = function registerForCatalogSelector(state) {
    return state.user.registerForCatalog;
};

var getUserCatalogIdForRegistration = exports.getUserCatalogIdForRegistration = (0, _reselect.createSelector)(registerForCatalogSelector, function (catalogRegistrations) {
    return catalogRegistrations.catalogId;
});

var getUserRegisterForCatalog = exports.getUserRegisterForCatalog = (0, _reselect.createSelector)(registerForCatalogSelector, function (catalogRegistrations) {
    return catalogRegistrations;
});

/* ACTION CREATORS */
var registerForCatalogFail = exports.registerForCatalogFail = function registerForCatalogFail(catalogId, error) {
    return {
        error: true,
        meta: { catalogId: catalogId },
        payload: error,
        type: REGISTER_FOR_CATALOG_FAIL
    };
};

var registerForCatalogRequest = exports.registerForCatalogRequest = function registerForCatalogRequest(catalogId) {
    return {
        payload: catalogId,
        type: REGISTER_FOR_CATALOG_REQUEST
    };
};

var registerForCatalogSuccess = exports.registerForCatalogSuccess = function registerForCatalogSuccess(catalogId, analytics) {
    return {
        meta: analytics,
        payload: catalogId,
        type: REGISTER_FOR_CATALOG_SUCCESS
    };
};

var submitRegisterForCatalog = exports.submitRegisterForCatalog = function submitRegisterForCatalog(catalogId, preventAddCreditCardModal) {
    return function (dispatch, getState) {
        var state = getState();
        var authToken = (0, _user.getAuthToken)(state);
        var deployment = (0, _config.getDeployment)(state);
        dispatch(registerForCatalogRequest(catalogId));
        return _api.Catalog.postRegisterForCatalog({ authToken: authToken, catalogId: catalogId, deployment: deployment }).then(function (response) {
            var analytics = (0, _analytics.getRequestedAuctionRegistrationAnalytics)(state, catalogId);
            if (response.success) {
                dispatch(registerForCatalogSuccess(catalogId, analytics));
                dispatch((0, _modal.closeModalAndCheckCreditCard)(preventAddCreditCardModal));
            } else {
                dispatch(registerForCatalogFail(catalogId, response.message));
            }
        }).then(function () {
            dispatch((0, _biddable.openBiddableModal)(catalogId));
        }).catch(function (error) {
            dispatch(registerForCatalogFail(catalogId, error));
        });
    };
};

/***/ }),

/***/ "eqvY":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx2 = __webpack_require__("dcb+");

var _jsx3 = _interopRequireDefault(_jsx2);

var _reactRouter = __webpack_require__("CIox");

var _App = __webpack_require__("TJgB");

var _App2 = _interopRequireDefault(_App);

var _components = __webpack_require__("bGai");

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Polyfill for webpack, just in case
if (false) require.ensure = function (d, c) {
    c(require);
};

var getAboutUsPage = function getAboutUsPage(a, cb) {
    return __webpack_require__.e/* require.ensure */(47).then((function (require) {
        cb(null, __webpack_require__("2vcy"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var getAccountSettingsPage = function getAccountSettingsPage(a, cb) {
    return __webpack_require__.e/* require.ensure */(13).then((function (require) {
        cb(null, __webpack_require__("y8q8"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var getAddCreditCardPage = function getAddCreditCardPage(a, cb) {
    return __webpack_require__.e/* require.ensure */(46).then((function (require) {
        cb(null, __webpack_require__("ZX19"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var getAuctionResultsPage = function getAuctionResultsPage(a, cb) {
    return __webpack_require__.e/* require.ensure */(45).then((function (require) {
        cb(null, __webpack_require__("QHbc"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var getBiddingConsolePage = function getBiddingConsolePage(a, cb) {
    return __webpack_require__.e/* require.ensure */(7).then((function (require) {
        cb(null, __webpack_require__("RcGB"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var getCatalogPage = function getCatalogPage(a, cb) {
    return __webpack_require__.e/* require.ensure */(12).then((function (require) {
        cb(null, __webpack_require__("Kj75"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var getCategoryPage = function getCategoryPage(a, cb) {
    return __webpack_require__.e/* require.ensure */(4).then((function (require) {
        cb(null, __webpack_require__("e2L2"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var getCheckoutPage = function getCheckoutPage(a, cb) {
    return __webpack_require__.e/* require.ensure */(9).then((function (require) {
        cb(null, __webpack_require__("m75m"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var getConsignmentsPage = function getConsignmentsPage(a, cb) {
    return __webpack_require__.e/* require.ensure */(21).then((function (require) {
        cb(null, __webpack_require__("Ywgv"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var getCheckoutConfirmationPage = function getCheckoutConfirmationPage(a, cb) {
    return __webpack_require__.e/* require.ensure */(14).then((function (require) {
        cb(null, __webpack_require__("x/Fh"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var getFeaturesPage = function getFeaturesPage(a, cb) {
    return __webpack_require__.e/* require.ensure */(44).then((function (require) {
        cb(null, __webpack_require__("PFl4"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var getFollowedSellersPage = function getFollowedSellersPage(a, cb) {
    return __webpack_require__.e/* require.ensure */(22).then((function (require) {
        cb(null, __webpack_require__("xCPK"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var getHomePage = function getHomePage(a, cb) {
    return __webpack_require__.e/* require.ensure */(6).then((function (require) {
        cb(null, __webpack_require__("HkvA"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var getHowItWorksPage = function getHowItWorksPage(a, cb) {
    return __webpack_require__.e/* require.ensure */(43).then((function (require) {
        cb(null, __webpack_require__("/t4h"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var getIntellectualPropertyPage = function getIntellectualPropertyPage(a, cb) {
    return __webpack_require__.e/* require.ensure */(42).then((function (require) {
        cb(null, __webpack_require__("qGAL"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var getItemPage = function getItemPage(a, cb) {
    return __webpack_require__.e/* require.ensure */(1).then((function (require) {
        cb(null, __webpack_require__("DG4J"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var getMessagesPage = function getMessagesPage(a, cb) {
    return __webpack_require__.e/* require.ensure */(41).then((function (require) {
        cb(null, __webpack_require__("59hI"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var getMobilePage = function getMobilePage(a, cb) {
    return __webpack_require__.e/* require.ensure */(40).then((function (require) {
        cb(null, __webpack_require__("6s/h"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var getMyAuctionsPage = function getMyAuctionsPage(a, cb) {
    return __webpack_require__.e/* require.ensure */(17).then((function (require) {
        cb(null, __webpack_require__("9c6n"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var getMyBidsPage = function getMyBidsPage(a, cb) {
    return __webpack_require__.e/* require.ensure */(16).then((function (require) {
        cb(null, __webpack_require__("pvD7"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

// All three saved search page chunks need to have the same name, or the page will not load
var getMySavedSearchPage = function getMySavedSearchPage(a, cb) {
    return __webpack_require__.e/* require.ensure */(0).then((function (require) {
        cb(null, __webpack_require__("Fd5s"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var getMySavedSearchPageManage = function getMySavedSearchPageManage(a, cb) {
    return __webpack_require__.e/* require.ensure */(0).then((function (require) {
        cb(null, __webpack_require__("I73l"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var getMySavedSearchPageRecent = function getMySavedSearchPageRecent(a, cb) {
    return __webpack_require__.e/* require.ensure */(0).then((function (require) {
        cb(null, __webpack_require__("jVJi"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var getNearMePage = function getNearMePage(a, cb) {
    return __webpack_require__.e/* require.ensure */(5).then((function (require) {
        cb(null, __webpack_require__("Owsw"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var getWonItemsPage = function getWonItemsPage(a, cb) {
    return __webpack_require__.e/* require.ensure */(11).then((function (require) {
        cb(null, __webpack_require__("DdPA"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var getNotFoundPage = function getNotFoundPage(a, cb) {
    return __webpack_require__.e/* require.ensure */(54).then((function (require) {
        cb(null, __webpack_require__("tGCO"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var getIconTestPage = function getIconTestPage(a, cb) {
    return __webpack_require__.e/* require.ensure */(55).then((function (require) {
        cb(null, __webpack_require__("+aPK"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var getPasswordResetPage = function getPasswordResetPage(a, cb) {
    return __webpack_require__.e/* require.ensure */(38).then((function (require) {
        cb(null, __webpack_require__("VKRv"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var getPrivacyPage = function getPrivacyPage(a, cb) {
    return __webpack_require__.e/* require.ensure */(37).then((function (require) {
        cb(null, __webpack_require__("Mlwf"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var getPRServicesPage = function getPRServicesPage(a, cb) {
    return __webpack_require__.e/* require.ensure */(39).then((function (require) {
        cb(null, __webpack_require__("uGPH"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var getSavedItemsPage = function getSavedItemsPage(a, cb) {
    return __webpack_require__.e/* require.ensure */(27).then((function (require) {
        cb(null, __webpack_require__("tmsO"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var getCatalogSearchPage = function getCatalogSearchPage(a, cb) {
    return __webpack_require__.e/* require.ensure */(8).then((function (require) {
        cb(null, __webpack_require__("/jAy"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var getSearchPage = function getSearchPage(a, cb) {
    return __webpack_require__.e/* require.ensure */(3).then((function (require) {
        cb(null, __webpack_require__("6klq"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var getDirectoryPage = function getDirectoryPage(a, cb) {
    return __webpack_require__.e/* require.ensure */(15).then((function (require) {
        cb(null, __webpack_require__("umw/"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var getSellerPage = function getSellerPage(a, cb) {
    return __webpack_require__.e/* require.ensure */(10).then((function (require) {
        cb(null, __webpack_require__("PXpE"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var getSellerTestimonialsPage = function getSellerTestimonialsPage(a, cb) {
    return __webpack_require__.e/* require.ensure */(36).then((function (require) {
        cb(null, __webpack_require__("rMlP"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var getTerminologyPage = function getTerminologyPage(a, cb) {
    return __webpack_require__.e/* require.ensure */(35).then((function (require) {
        cb(null, __webpack_require__("4YSI"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var getTermsAndConditionsPage = function getTermsAndConditionsPage(a, cb) {
    return __webpack_require__.e/* require.ensure */(34).then((function (require) {
        cb(null, __webpack_require__("HESY"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

exports.default = function (isWhiteLabel) {
    var homeRoute = isWhiteLabel ? (0, _jsx3.default)(_reactRouter.IndexRoute, {
        getComponents: getSellerPage
    }) : (0, _jsx3.default)(_reactRouter.IndexRoute, {
        getComponents: getHomePage
    });

    return (0, _jsx3.default)(_reactRouter.Route, {
        component: _App2.default,
        path: '/'
    }, void 0, homeRoute, (0, _jsx3.default)(_reactRouter.Route, {
        getComponents: getAboutUsPage,
        path: 'about'
    }), (0, _jsx3.default)(_reactRouter.Route, {
        getComponents: getAuctionResultsPage,
        path: 'auction-results'
    }), (0, _jsx3.default)(_reactRouter.Route, {
        getComponents: getDirectoryPage,
        path: 'auctioneer/directory'
    }), (0, _jsx3.default)(_reactRouter.Route, {
        getComponents: getSellerPage,
        path: 'auctioneer/:sellerId/:sellerName'
    }), (0, _jsx3.default)(_reactRouter.Route, {
        getComponents: getBiddingConsolePage,
        path: 'console/:catalogId'
    }), (0, _jsx3.default)(_reactRouter.Route, {
        getComponents: getCategoryPage,
        path: 'c'
    }), (0, _jsx3.default)(_reactRouter.Route, {
        getComponents: getCategoryPage,
        path: 'c/:categoryName/:categoryId'
    }), (0, _jsx3.default)(_reactRouter.Route, {
        getComponents: getCategoryPage,
        path: 'c/:categoryName/:categoryName2/:categoryId/:categoryId2'
    }), (0, _jsx3.default)(_reactRouter.Route, {
        getComponents: getCategoryPage,
        path: 'price-guide/:categoryName/:categoryId'
    }), (0, _jsx3.default)(_reactRouter.Route, {
        getComponents: getAuctionResultsPage,
        path: 'price-guide'
    }), (0, _jsx3.default)(_reactRouter.Route, {
        getComponents: getCatalogSearchPage,
        path: 'catalog/search'
    }), (0, _jsx3.default)(_reactRouter.Route, {
        getComponents: getCatalogPage,
        path: 'catalog/:catalogId'
    }), (0, _jsx3.default)(_reactRouter.Route, {
        getComponents: getConsignmentsPage,
        path: 'consignments'
    }), (0, _jsx3.default)(_reactRouter.Route, {
        getComponents: getConsignmentsPage,
        path: 'consignments/:sellerId'
    }), (0, _jsx3.default)(_reactRouter.Route, {
        getComponents: getFeaturesPage,
        path: 'features'
    }), (0, _jsx3.default)(_reactRouter.Route, {
        getComponents: getMobilePage,
        path: 'mobile'
    }), (0, _jsx3.default)(_reactRouter.Route, {
        getComponents: getNearMePage,
        path: 'find-auctions-near-me'
    }), (0, _jsx3.default)(_reactRouter.Route, {
        getComponents: getHowItWorksPage,
        path: 'how-it-works'
    }), (0, _jsx3.default)(_reactRouter.Route, {
        getComponents: getItemPage,
        path: 'item/:itemId'
    }), (0, _jsx3.default)(_reactRouter.Route, {
        getComponents: getPasswordResetPage,
        path: 'password_reset/:bidderId/:hash'
    }), (0, _jsx3.default)(_reactRouter.Route, {
        getComponents: getPRServicesPage,
        path: 'prservices'
    }), (0, _jsx3.default)(_reactRouter.Route, {
        getComponents: getPrivacyPage,
        path: 'privacy'
    }), (0, _jsx3.default)(_reactRouter.Route, {
        getComponents: getSearchPage,
        path: 'search'
    }), (0, _jsx3.default)(_reactRouter.Route, {
        getComponents: getSellerTestimonialsPage,
        path: 'seller-testimonials'
    }), (0, _jsx3.default)(_reactRouter.Route, {
        getComponents: getTermsAndConditionsPage,
        path: 'termsandconditions'
    }), (0, _jsx3.default)(_reactRouter.Route, {
        getComponents: getTerminologyPage,
        path: 'terminology'
    }), (0, _jsx3.default)(_reactRouter.Route, {
        getComponents: getIntellectualPropertyPage,
        path: 'intellectualproperty'
    }), (0, _jsx3.default)(_reactRouter.Route, {
        component: _components.EnsureLoggedInContainer
    }, void 0, (0, _jsx3.default)(_reactRouter.Route, {
        getComponents: getCheckoutConfirmationPage,
        path: 'confirmation/:sellerId/:itemId'
    }), (0, _jsx3.default)(_reactRouter.Route, {
        getComponents: getAccountSettingsPage,
        path: 'dashboard/profile'
    }), (0, _jsx3.default)(_reactRouter.Route, {
        getComponents: getAddCreditCardPage,
        path: 'dashboard/cardonfile'
    }), (0, _jsx3.default)(_reactRouter.Route, {
        getComponents: getFollowedSellersPage,
        path: 'dashboard/followed-auctioneers'
    }), (0, _jsx3.default)(_reactRouter.Route, {
        getComponents: getMessagesPage,
        path: 'dashboard/messages'
    }), (0, _jsx3.default)(_reactRouter.Route, {
        getComponents: getMyBidsPage,
        path: 'dashboard/my-bids'
    }), (0, _jsx3.default)(_reactRouter.Route, {
        getComponents: getMyAuctionsPage,
        path: 'dashboard/my-auctions'
    }), (0, _jsx3.default)(_reactRouter.Route, {
        getComponents: getMySavedSearchPage,
        path: 'dashboard/search-and-alerts'
    }, void 0, (0, _jsx3.default)(_reactRouter.IndexRoute, {
        getComponents: getMySavedSearchPageRecent
    }), (0, _jsx3.default)(_reactRouter.Route, {
        getComponents: getMySavedSearchPageManage,
        path: 'manage'
    })), (0, _jsx3.default)(_reactRouter.Route, {
        getComponents: getSavedItemsPage,
        path: 'dashboard/saved-items'
    }), (0, _jsx3.default)(_reactRouter.Route, {
        getComponents: getCheckoutPage,
        path: 'checkout/:catalogId'
    }), (0, _jsx3.default)(_reactRouter.Route, {
        getComponents: getWonItemsPage,
        path: 'dashboard/won-items'
    })), (0, _jsx3.default)(_reactRouter.Route, {
        getComponents: getIconTestPage,
        path: 'icon-test'
    }), (0, _jsx3.default)(_reactRouter.Route, {
        getComponents: getNotFoundPage,
        path: '*',
        status: 404
    }));
};

module.exports = exports['default'];

/***/ }),

/***/ "etkc":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var A = function (_Component) {
    (0, _inherits3.default)(A, _Component);

    function A() {
        (0, _classCallCheck3.default)(this, A);
        return (0, _possibleConstructorReturn3.default)(this, (A.__proto__ || (0, _getPrototypeOf2.default)(A)).apply(this, arguments));
    }

    (0, _createClass3.default)(A, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement('a', this.props);
        }
    }]);
    return A;
}(_react.Component);

exports.default = A;
module.exports = exports['default'];

/***/ }),

/***/ "eyX+":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CatalogMock = undefined;

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _mockData = __webpack_require__("6VmH");

var _delay = __webpack_require__("kRHc");

var _delay2 = _interopRequireDefault(_delay);

var _union = __webpack_require__("gszD");

var _union2 = _interopRequireDefault(_union);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CatalogMock = exports.CatalogMock = {
    fetchCatalogItems: function fetchCatalogItems(catalogIds) {
        return new _promise2.default(function (resolve) {
            setTimeout(function () {
                var items = catalogIds.reduce(function (previous, id) {
                    return (0, _union2.default)(previous, (0, _mockData.getTestItemsForCatalog)(id));
                }, []);
                resolve({
                    data: items
                });
            }, _delay2.default);
        });
    },
    fetchCatalogsByIds: function fetchCatalogsByIds(catalogIds) {
        return new _promise2.default(function (resolve) {
            setTimeout(function () {
                var catalogs = catalogIds.map(function (x) {
                    return (0, _mockData.getTestCatalog)(x);
                });
                var bidIncrements = [];
                var sellers = [];

                catalogs.forEach(function (item) {
                    bidIncrements = (0, _union2.default)(bidIncrements, [(0, _mockData.getTestBidIncrementForCatalog)(item.catalogId)]);
                    sellers = (0, _union2.default)(sellers, [(0, _mockData.getTestSeller)(item.sellerId)]);
                });
                resolve({
                    data: {
                        bidIncrements: bidIncrements,
                        catalogs: catalogs,
                        sellers: sellers
                    }
                });
            }, _delay2.default);
        });
    }
};

/***/ }),

/***/ "f9A3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Checkout = undefined;

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _helpers = __webpack_require__("SY39");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var transform = function transform(_ref) {
    var invoice = _ref.invoice,
        results = _ref.results;
    var balanceDue = invoice.balance_due,
        id = invoice.id,
        invoiceTotal = invoice.invoice_total,
        sent = invoice.is_sent,
        itemTotal = invoice.item_total,
        buyersPremium = invoice.buyers_premium_total,
        currency = invoice.currency,
        otherCharges = invoice.other_charges,
        payments = invoice.payments,
        paymentsTotal = invoice.payments_total,
        processing_fee = invoice.processing_fee,
        sales_tax = invoice.sales_tax,
        shipping_charge = invoice.shipping_charge;


    var items = results.map(function (item) {
        return {
            catalogId: item.catID,
            imageVersion: item.imageVersion,
            itemId: item.lotID,
            salePrice: item.sale_price,
            sellerId: item.houseID,
            sellerName: item.name,
            title: item.title
        };
    });

    return {
        data: {
            invoice: {
                balanceDue: balanceDue,
                buyersPremium: buyersPremium,
                currency: currency.cur_code,
                id: id,
                invoiceTotal: invoiceTotal,
                itemTotal: itemTotal,
                otherCharges: otherCharges,
                payments: payments,
                paymentsTotal: paymentsTotal,
                processingFee: Number(processing_fee),
                salesTax: Number(sales_tax),
                sent: !!sent,
                shipping: Number(shipping_charge)
            },
            items: items
        },
        message: !!id ? 'Successfully retrieved the invoice.' : 'Error getting the invoice',
        success: !!id
    };
};

var Checkout = exports.Checkout = {
    fetchInvoice: function fetchInvoice(_ref2) {
        var authToken = _ref2.authToken,
            bidderId = _ref2.bidderId,
            catalogId = _ref2.catalogId,
            deployment = _ref2.deployment;

        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makeGet)('<MAINHOST-API>api/bidders/' + bidderId + '/wonitems/catalogs/' + catalogId, deployment);
            request.query({ client_version: '5.0', page: 1, pagesize: 1250 });
            (0, _helpers.addAuthToken)(request, authToken);
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response, transform: transform });
            });
        });
    }
};

/***/ }),

/***/ "fFJ6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = __webpack_require__("dcb+");

var _jsx3 = _interopRequireDefault(_jsx2);

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Polyfill for webpack, just in case
if (false) require.ensure = function (d, c) {
    c(require);
};

var SendSellerMessageModalLoader = function (_Component) {
    (0, _inherits3.default)(SendSellerMessageModalLoader, _Component);

    function SendSellerMessageModalLoader(props, context) {
        (0, _classCallCheck3.default)(this, SendSellerMessageModalLoader);

        var _this = (0, _possibleConstructorReturn3.default)(this, (SendSellerMessageModalLoader.__proto__ || (0, _getPrototypeOf2.default)(SendSellerMessageModalLoader)).call(this, props, context));

        _this.state = {
            Component: null,
            mounted: false
        };
        return _this;
    }

    (0, _createClass3.default)(SendSellerMessageModalLoader, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            var _this2 = this;

            return new _promise2.default(function (resolve) {
                __webpack_require__.e/* require.ensure */(25).then((function () {
                    resolve(__webpack_require__("LYll"));
                }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            }).then(function (container) {
                _this2.setState({ Component: container });
            });
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.setState({ mounted: true });
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.setState({ mounted: false });
        }
    }, {
        key: 'render',
        value: function render() {
            var _state = this.state,
                Component = _state.Component,
                mounted = _state.mounted;

            return mounted && Component !== null ? (0, _jsx3.default)(Component, {}) : null;
        }
    }]);
    return SendSellerMessageModalLoader;
}(_react.Component);

exports.default = SendSellerMessageModalLoader;
module.exports = exports['default'];

/***/ }),

/***/ "fR6t":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = __webpack_require__("dcb+");

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _components = __webpack_require__("bGai");

var _urls = __webpack_require__("CakR");

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _reactFontawesome = __webpack_require__("f7W8");

var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);

var _reactIntl = __webpack_require__("Pq8k");

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _AllAuctions = __webpack_require__("I0kU");

var _AllAuctions2 = _interopRequireDefault(_AllAuctions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AllAuctions = function (_Component) {
    (0, _inherits3.default)(AllAuctions, _Component);

    function AllAuctions() {
        (0, _classCallCheck3.default)(this, AllAuctions);
        return (0, _possibleConstructorReturn3.default)(this, (AllAuctions.__proto__ || (0, _getPrototypeOf2.default)(AllAuctions)).apply(this, arguments));
    }

    (0, _createClass3.default)(AllAuctions, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate() {
            return false;
        }
    }, {
        key: 'render',
        value: function render() {
            var parent = this.props.parent;

            var calendarUrl = (0, _urls.getAllUpcomingAuctionsUrl)();

            var links = [(0, _jsx3.default)(_components.Link, {
                className: _AllAuctions2.default.link,
                route: true,
                to: calendarUrl
            }, 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'auction_calendar'
            }), (0, _jsx3.default)(_reactFontawesome2.default, {
                icon: ['far', 'calendar-alt'],
                className: _AllAuctions2.default.calendar
            })), (0, _jsx3.default)(_components.Link, {
                className: _AllAuctions2.default.link,
                route: true,
                to: '/find-auctions-near-me'
            }, 1, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'auctions_near_me'
            })), (0, _jsx3.default)(_components.Link, {
                className: _AllAuctions2.default.link,
                route: true,
                to: (0, _urls.getAuctioneerDirectoryUrl)()
            }, 2, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'auction_house_directory'
            })), (0, _jsx3.default)(_components.Link, {
                className: _AllAuctions2.default.link,
                route: true,
                to: (0, _urls.getAuctionResultsUrl)()
            }, 3, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'past_auction_results'
            }))];

            var title = (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'all_auctions'
            });

            return (0, _jsx3.default)(_components.DropDownMenu, {
                links: links,
                parent: parent,
                placement: 'bottom',
                title: title,
                titleClass: _AllAuctions2.default['auction-title'],
                dropdownClass: _AllAuctions2.default.aDropDown
            });
        }
    }]);
    return AllAuctions;
}(_react.Component);

exports.default = AllAuctions;
module.exports = exports['default'];

/***/ }),

/***/ "fWpZ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.submitPasswordReset = exports.getUiPasswordReset = exports.PASSWORD_RESET_SUCCESS = exports.PASSWORD_RESET_REQUEST = exports.PASSWORD_RESET_FAIL = undefined;

var _regenerator = __webpack_require__("Xxa5");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__("exGp");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;

var _api = __webpack_require__("zFQO");

var _reselect = __webpack_require__("bndy");

var _config = __webpack_require__("iS9E");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Action Types */
var PASSWORD_RESET_FAIL = exports.PASSWORD_RESET_FAIL = 'la/ui/passwordReset/FAIL';
var PASSWORD_RESET_REQUEST = exports.PASSWORD_RESET_REQUEST = 'la/ui/passwordReset/REQUEST';
var PASSWORD_RESET_SUCCESS = exports.PASSWORD_RESET_SUCCESS = 'la/ui/passwordReset/SUCCESS';

// reducer
var DEFAULT_STATE = {
    error: false,
    errorMessage: null,
    submitted: false,
    success: false
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        case PASSWORD_RESET_REQUEST:
            return (0, _extends3.default)({}, state, {
                error: false,
                errorMessage: null,
                submitted: true,
                success: false
            });
        case PASSWORD_RESET_SUCCESS:
            return (0, _extends3.default)({}, state, {
                submitted: false,
                success: true
            });
        case PASSWORD_RESET_FAIL:
            return (0, _extends3.default)({}, state, {
                error: true,
                errorMessage: action.payload,
                submitted: false,
                success: false
            });
        default:
            return state;
    }
}

/* SELECTORS */
var stateSelector = function stateSelector(state) {
    return state.ui.passwordReset;
};

var getUiPasswordReset = exports.getUiPasswordReset = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state;
});

/* ACTION CREATORS */
var submitPasswordReset = exports.submitPasswordReset = function submitPasswordReset(_ref) {
    var bidderId = _ref.bidderId,
        hash = _ref.hash,
        newPassword = _ref.newPassword;
    return function () {
        var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch, getState) {
            var state, deployment, response;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.prev = 0;
                            state = getState();
                            deployment = (0, _config.getDeployment)(state);

                            dispatch({
                                payload: bidderId,
                                type: PASSWORD_RESET_REQUEST
                            });
                            _context.next = 6;
                            return _api.Auth.postResetPassword({ bidderId: bidderId, deployment: deployment, hash: hash, newPassword: newPassword });

                        case 6:
                            _context.next = 8;
                            return _context.sent;

                        case 8:
                            response = _context.sent;

                            dispatch({
                                meta: { actionTime: Date.now() },
                                payload: response.data,
                                type: PASSWORD_RESET_SUCCESS
                            });
                            _context.next = 15;
                            break;

                        case 12:
                            _context.prev = 12;
                            _context.t0 = _context['catch'](0);

                            dispatch({
                                error: true,
                                meta: { bidderId: bidderId },
                                payload: _context.t0,
                                type: PASSWORD_RESET_FAIL
                            });

                        case 15:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, undefined, [[0, 12]]);
        }));

        return function (_x3, _x4) {
            return _ref2.apply(this, arguments);
        };
    }();
};

/***/ }),

/***/ "fr8l":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fetchCoverLotsIfNeeded = exports.isCoverLotsLoading = exports.getLoadTimeForCoverLots = exports.getCoverLots = exports.LOAD_COVER_LOTS_SUCCESS = exports.LOAD_COVER_LOTS_REQUEST = exports.LOAD_COVER_LOTS_FAIL = undefined;

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;

var _api = __webpack_require__("zFQO");

var _cloneDeep = __webpack_require__("kvU2");

var _cloneDeep2 = _interopRequireDefault(_cloneDeep);

var _reselect = __webpack_require__("bndy");

var _difference = __webpack_require__("WlNK");

var _difference2 = _interopRequireDefault(_difference);

var _config = __webpack_require__("iS9E");

var _home = __webpack_require__("TSUT");

var _upcomingCatalogs = __webpack_require__("39qi");

var _ms = __webpack_require__("EarI");

var _ms2 = _interopRequireDefault(_ms);

var _union = __webpack_require__("gszD");

var _union2 = _interopRequireDefault(_union);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Action Types */
var LOAD_COVER_LOTS_FAIL = exports.LOAD_COVER_LOTS_FAIL = 'la/domain/coverLots/LOAD_FAIL';
var LOAD_COVER_LOTS_REQUEST = exports.LOAD_COVER_LOTS_REQUEST = 'la/domain/coverLots/LOAD_REQUEST';
var LOAD_COVER_LOTS_SUCCESS = exports.LOAD_COVER_LOTS_SUCCESS = 'la/domain/coverLots/LOAD_SUCCESS';

var REDUX_STORE_TIME = (0, _ms2.default)('30m');

/* reducer */
var DEFAULT_STATE = {
    byId: {},
    loaded: {},
    loading: []
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var existing = void 0;
    var loaded = void 0;
    var loading = void 0;
    var time = void 0;

    switch (action.type) {
        case LOAD_COVER_LOTS_FAIL:
            return (0, _extends3.default)({}, state, {
                loading: (0, _difference2.default)(state.loading, action.payload)
            });
        case LOAD_COVER_LOTS_REQUEST:
            return (0, _extends3.default)({}, state, {
                loading: (0, _union2.default)(state.loading, action.payload)
            });
        case LOAD_COVER_LOTS_SUCCESS:
            existing = (0, _cloneDeep2.default)(state.byId);
            loaded = (0, _extends3.default)({}, state.loaded);
            loading = (0, _cloneDeep2.default)(state.loading);
            time = action.meta.actionTime;

            action.payload.forEach(function (item) {
                existing[item.catalogId] = (0, _extends3.default)({}, item);
                loaded[item.catalogId] = time;
                loading = (0, _difference2.default)(loading, [item.catalogId]);
            });
            return (0, _extends3.default)({}, state, {
                byId: existing,
                loaded: loaded,
                loading: loading
            });
        case _home.LOAD_HOME_DATA_SUCCESS:
        case _upcomingCatalogs.LOAD_UPCOMING_CATALOGS_SUCCESS:
            existing = (0, _cloneDeep2.default)(state.byId);
            loaded = (0, _extends3.default)({}, state.loaded);
            loading = (0, _cloneDeep2.default)(state.loading);
            time = action.meta.actionTime;

            if (action.payload.smallCoverLots) {
                action.payload.smallCoverLots.forEach(function (item) {
                    existing[item.catalogId] = (0, _extends3.default)({}, item);
                    loaded[item.catalogId] = time;
                    loading = (0, _difference2.default)(loading, [item.catalogId]);
                });
            }
            return (0, _extends3.default)({}, state, {
                byId: existing,
                loaded: loaded,
                loading: loading
            });
        default:
            return state;
    }
}

/* SELECTORS */
var stateSelector = function stateSelector(state) {
    return state.domain.coverLots;
};
var idSelector = function idSelector(state, id) {
    return id;
};

var byIdSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.byId;
});

var loadedSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.loaded;
});

var loadingSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.loading;
});

var getCoverLots = exports.getCoverLots = (0, _reselect.createSelector)([byIdSelector, idSelector], function (byId, id) {
    return byId[id] || { catalogId: 0, results: [{}, {}, {}] };
});

var getLoadTimeForCoverLots = exports.getLoadTimeForCoverLots = (0, _reselect.createSelector)([loadedSelector, idSelector], function (loaded, id) {
    return loaded[id] || 0;
});

var isCoverLotsLoading = exports.isCoverLotsLoading = (0, _reselect.createSelector)([loadingSelector, idSelector], function (loading, id) {
    return loading.includes(id);
});

var shouldFetchCoverLots = function shouldFetchCoverLots(state, catalogId) {
    if (!catalogId) return false;
    var item = getCoverLots(state, catalogId);
    if (item) {
        var loaded = getLoadTimeForCoverLots(state, catalogId);
        var time = Date.now();
        var diff = time - loaded;
        if (diff < REDUX_STORE_TIME) return false;
    }
    var loading = isCoverLotsLoading(state, catalogId);
    return !loading;
};

var coverLotsToFetch = function coverLotsToFetch(state, catalogIds) {
    return catalogIds.filter(function (id) {
        return shouldFetchCoverLots(state, id);
    });
};

/* ACTION CREATORS */
var loadCoverLotsFail = function loadCoverLotsFail(catalogIds, error) {
    return {
        error: true,
        meta: { catalogIds: catalogIds },
        payload: error,
        type: LOAD_COVER_LOTS_FAIL
    };
};

var loadCoverLotsRequest = function loadCoverLotsRequest(catalogIds) {
    return {
        payload: catalogIds,
        type: LOAD_COVER_LOTS_REQUEST
    };
};

var loadCoverLotsSuccess = function loadCoverLotsSuccess(catalogIds, results) {
    return {
        meta: { actionTime: Date.now(), catalogIds: catalogIds },
        payload: results,
        type: LOAD_COVER_LOTS_SUCCESS
    };
};

var loadCoverLots = function loadCoverLots(catalogIds) {
    return function (dispatch, getState) {
        var state = getState();
        var deployment = (0, _config.getDeployment)(state);
        dispatch(loadCoverLotsRequest(catalogIds));
        return _api.CoverLots.fetchCoverLots({ catalogIds: catalogIds, deployment: deployment }).then(function (response) {
            dispatch(loadCoverLotsSuccess(catalogIds, response.data));
        }).catch(function (error) {
            dispatch(loadCoverLotsFail(catalogIds, error));
        });
    };
};

var fetchCoverLotsIfNeeded = exports.fetchCoverLotsIfNeeded = function fetchCoverLotsIfNeeded(catalogIds) {
    return function (dispatch, getState) {
        var coverLotsToLoad = coverLotsToFetch(getState(), catalogIds);
        if (coverLotsToLoad.length) {
            return dispatch(loadCoverLots(coverLotsToLoad));
        }
        return _promise2.default.resolve();
    };
};

/***/ }),

/***/ "frA2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _toConsumableArray2 = __webpack_require__("Gu7T");

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;

var _dates = __webpack_require__("TbAp");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DEFAULT_STATE = [];

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    if (action.type && action.type.substring(action.type.length - 4) === 'FAIL') {
        var timestamp = Date.now();
        var date = (0, _dates.errorDate)(timestamp);
        var error = (0, _extends3.default)({}, action, {
            date: date,
            timestamp: timestamp
        });

        return [].concat((0, _toConsumableArray3.default)(state), [error]);
    }

    return state;
}
module.exports = exports['default'];

/***/ }),

/***/ "fuBz":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fetchListingAgentsIfNeeded = exports.isListingAgentLoading = exports.getLoadTimeForListingAgent = exports.getListingAgent = exports.LOAD_LISTING_AGENT_SUCCESS = exports.LOAD_LISTING_AGENT_REQUEST = exports.LOAD_LISTING_AGENT_FAIL = undefined;

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;

var _api = __webpack_require__("zFQO");

var _cloneDeep = __webpack_require__("kvU2");

var _cloneDeep2 = _interopRequireDefault(_cloneDeep);

var _reselect = __webpack_require__("bndy");

var _difference = __webpack_require__("WlNK");

var _difference2 = _interopRequireDefault(_difference);

var _config = __webpack_require__("iS9E");

var _ms = __webpack_require__("EarI");

var _ms2 = _interopRequireDefault(_ms);

var _union = __webpack_require__("gszD");

var _union2 = _interopRequireDefault(_union);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Action Types */
var LOAD_LISTING_AGENT_FAIL = exports.LOAD_LISTING_AGENT_FAIL = 'la/domain/listingAgent/LOAD_FAIL';
var LOAD_LISTING_AGENT_REQUEST = exports.LOAD_LISTING_AGENT_REQUEST = 'la/domain/listingAgent/LOAD_REQUEST';
var LOAD_LISTING_AGENT_SUCCESS = exports.LOAD_LISTING_AGENT_SUCCESS = 'la/domain/listingAgent/LOAD_SUCCESS';

var REDUX_STORE_TIME = (0, _ms2.default)('30m');

/* reducer */
var DEFAULT_STATE = {
    byId: {},
    loaded: {},
    loading: []
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var existing = void 0;
    var loaded = void 0;
    var loading = void 0;
    var time = void 0;

    switch (action.type) {
        case LOAD_LISTING_AGENT_FAIL:
            return (0, _extends3.default)({}, state, {
                loading: (0, _difference2.default)(state.loading, action.meta.agentIds)
            });
        case LOAD_LISTING_AGENT_REQUEST:
            return (0, _extends3.default)({}, state, {
                loading: (0, _union2.default)(state.loading, action.payload)
            });
        case LOAD_LISTING_AGENT_SUCCESS:
            existing = (0, _cloneDeep2.default)(state.byId);
            loaded = (0, _extends3.default)({}, state.loaded);
            loading = (0, _cloneDeep2.default)(state.loading);
            time = action.meta.actionTime;

            if (action.payload.listingAgents) {
                action.payload.listingAgents.forEach(function (x) {
                    existing[x.agentId] = (0, _extends3.default)({}, x);
                    loaded[x.agentId] = time;
                    loading = (0, _difference2.default)(loading, [x.agentId]);
                });
            }

            return (0, _extends3.default)({}, state, {
                byId: existing,
                loaded: loaded,
                loading: loading
            });
        default:
            return state;
    }
}

/* SELECTORS */
var stateSelector = function stateSelector(state) {
    return state.domain.listingAgent;
};
var idSelector = function idSelector(state, id) {
    return id;
};

var byIdSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.byId;
});

var loadedSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.loaded;
});

var loadingSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.loading;
});

// takes in a (state, id) and passes both params to every function on
// the way down.
var getListingAgent = exports.getListingAgent = (0, _reselect.createSelector)([byIdSelector, idSelector], function (byId, id) {
    return byId[id] || {};
});

var getLoadTimeForListingAgent = exports.getLoadTimeForListingAgent = (0, _reselect.createSelector)([loadedSelector, idSelector], function (loaded, id) {
    return loaded[id] || 0;
});

var isListingAgentLoading = exports.isListingAgentLoading = (0, _reselect.createSelector)([loadingSelector, idSelector], function (loading, id) {
    return loading.includes(id);
});

var shouldFetchListingAgent = function shouldFetchListingAgent(state, agentId) {
    if (!agentId) return false;
    var item = getListingAgent(state, agentId);
    if (item) {
        var loaded = getLoadTimeForListingAgent(state, agentId);
        var time = Date.now();
        var diff = time - loaded;
        if (diff < REDUX_STORE_TIME) return false;
    }
    var loading = isListingAgentLoading(state, agentId);
    return !loading;
};

var whichListingAgentsNeeded = function whichListingAgentsNeeded(state, agentIds) {
    return agentIds.filter(function (agentId) {
        return shouldFetchListingAgent(state, agentId);
    });
};

/* ACTION CREATORS */
var loadListingAgents = function loadListingAgents(agentIds) {
    return function (dispatch, getState) {
        var state = getState();
        var deployment = (0, _config.getDeployment)(state);
        dispatch({
            payload: agentIds,
            type: LOAD_LISTING_AGENT_REQUEST
        });
        return _api.Item.fetchListingAgentsByIds({ agentIds: agentIds, deployment: deployment }).then(function (response) {
            dispatch({
                meta: { actionTime: Date.now(), agentIds: agentIds },
                payload: response.data,
                type: LOAD_LISTING_AGENT_SUCCESS
            });
        }).catch(function (error) {
            dispatch({
                error: true,
                meta: { agentIds: agentIds },
                payload: error,
                type: LOAD_LISTING_AGENT_FAIL
            });
        });
    };
};

var fetchListingAgentsIfNeeded = exports.fetchListingAgentsIfNeeded = function fetchListingAgentsIfNeeded(agentIds) {
    return function (dispatch, getState) {
        var needed = whichListingAgentsNeeded(getState(), agentIds);
        if (needed.length) {
            return dispatch(loadListingAgents(needed));
        }
        return _promise2.default.resolve();
    };
};

/***/ }),

/***/ "g19V":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = __webpack_require__("dcb+");

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _components = __webpack_require__("bGai");

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propsComparer = __webpack_require__("wsGv");

var _propsComparer2 = _interopRequireDefault(_propsComparer);

var _reactIntl = __webpack_require__("Pq8k");

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _LoggedIn = __webpack_require__("0cas");

var _LoggedIn2 = _interopRequireDefault(_LoggedIn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LoggedIn = function (_Component) {
    (0, _inherits3.default)(LoggedIn, _Component);

    function LoggedIn(props, context) {
        (0, _classCallCheck3.default)(this, LoggedIn);

        var _this = (0, _possibleConstructorReturn3.default)(this, (LoggedIn.__proto__ || (0, _getPrototypeOf2.default)(LoggedIn)).call(this, props, context));

        _this.logOut = function () {
            _this.props.logOutBidder();
        };

        _this.state = {
            mobile: props.mobile && props.mobile === 'phone'
        };
        return _this;
    }

    (0, _createClass3.default)(LoggedIn, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (this.props.windowWidth !== nextProps.windowWidth) {
                if (nextProps.windowWidth < 768 && !this.state.mobile) {
                    this.setState({ mobile: true });
                }
                if (nextProps.windowWidth >= 768 && this.state.mobile) {
                    this.setState({ mobile: false });
                }
            }
        }
    }, {
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps, nextState) {
            return (0, _propsComparer2.default)(this.props, nextProps, ['windowWidth']) || (0, _propsComparer2.default)(this.state, nextState, ['mobile']);
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                parent = _props.parent,
                whiteLabel = _props.whiteLabel;
            var mobile = this.state.mobile;


            var links = [];
            links.push((0, _jsx3.default)(_components.Link, {
                className: _LoggedIn2.default.link,
                route: true,
                to: '/dashboard/saved-items'
            }, 'saved-items', (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'saved_items'
            })));
            links.push((0, _jsx3.default)(_components.Link, {
                className: _LoggedIn2.default.link,
                route: true,
                to: '/dashboard/my-bids'
            }, 'my-bids', (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'my_bids'
            })));
            links.push((0, _jsx3.default)(_components.Link, {
                route: true,
                to: '/dashboard/my-auctions'
            }, 'my-auctions', (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'my_auctions'
            })));
            links.push((0, _jsx3.default)(_components.Link, {
                route: true,
                to: '/dashboard/won-items'
            }, 'won-items', (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'won_items'
            })));
            links.push((0, _jsx3.default)(_components.Link, {
                route: true,
                to: '/dashboard/messages'
            }, 'messages', (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'messages'
            })));
            if (!whiteLabel) {
                links.push((0, _jsx3.default)(_components.Link, {
                    route: true,
                    to: '/dashboard/search-and-alerts/'
                }, 'search-and-alerts', (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                    id: 'saved_searches_and_alerts'
                })));
            }
            if (!whiteLabel) {
                links.push((0, _jsx3.default)(_components.Link, {
                    route: true,
                    to: '/dashboard/followed-auctioneers'
                }, 'followed-sellers', (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                    id: 'followed_auctioneers'
                })));
            }
            links.push((0, _jsx3.default)(_components.Link, {
                route: true,
                to: '/dashboard/profile'
            }, 'profile', (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'account_settings'
            })));
            links.push((0, _jsx3.default)(_components.Link, {
                className: _LoggedIn2.default['log-out'],
                onClick: this.logOut
            }, 'log-out', (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'log_out'
            })));

            var title = (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'me'
            });

            return (0, _jsx3.default)('div', {
                className: _LoggedIn2.default['logged-in']
            }, void 0, !mobile && links.splice(0, 2), (0, _jsx3.default)(_components.DropDownMenu, {
                links: links,
                mobile: this.props.mobile,
                dropdownClass: _LoggedIn2.default['me-button'],
                parent: parent,
                placement: 'bottom',
                popoverClass: _LoggedIn2.default.popover,
                title: title,
                titleClass: _LoggedIn2.default.me
            }));
        }
    }]);
    return LoggedIn;
}(_react.Component);

exports.default = LoggedIn;
module.exports = exports['default'];

/***/ }),

/***/ "g2OR":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = __webpack_require__("dcb+");

var _jsx3 = _interopRequireDefault(_jsx2);

var _toConsumableArray2 = __webpack_require__("Gu7T");

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;
// import classNames from 'classnames';


var _components = __webpack_require__("bGai");

var _reactIntl = __webpack_require__("Pq8k");

var _urls = __webpack_require__("CakR");

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propsComparer = __webpack_require__("wsGv");

var _propsComparer2 = _interopRequireDefault(_propsComparer);

var _CardCta = __webpack_require__("YgC6");

var _CardCta2 = _interopRequireDefault(_CardCta);

var _CardStatusBanner = __webpack_require__("SCYO");

var _CardStatusBanner2 = _interopRequireDefault(_CardStatusBanner);

var _noop = __webpack_require__("9vKl");

var _noop2 = _interopRequireDefault(_noop);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _safelyRender = __webpack_require__("YLee");

var _safelyRender2 = _interopRequireDefault(_safelyRender);

var _live = __webpack_require__("o2ZH");

var _ItemCard = __webpack_require__("sPdJ");

var _ItemCard2 = _interopRequireDefault(_ItemCard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// potential cases for item cards
/*
    - in a 'live' auction
        - available                                         -live-available
        - sold                                              -live-sold
        - passed                                            -live-passed

    - in an 'online' auction
        - less than 24 hours before the auction starts      -online-soon
        - more than 24 hours before the auction starts      -online-upcoming

    - in a 'done' auction
        - sold                                              -done-sold
        - passed                                            -done-passed

    also, there may be modifiers for search cards

*/

var ItemCard = (_temp2 = _class = function (_Component) {
    (0, _inherits3.default)(ItemCard, _Component);

    function ItemCard() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, ItemCard);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ItemCard.__proto__ || (0, _getPrototypeOf2.default)(ItemCard)).call.apply(_ref, [this].concat(args))), _this), _this.showSendSellerMessageModal = function () {
            var _this$props = _this.props,
                cardViewModel = _this$props.cardViewModel,
                openSendSellerMessageModal = _this$props.openSendSellerMessageModal;
            var catalog = cardViewModel.catalog,
                seller = cardViewModel.seller;
            var sellerId = seller.sellerId,
                sellerName = seller.name;


            var messageDetails = {};
            var subject = _this.context.intl.formatMessage({
                id: 'registration_declined'
            }) + ': ' + catalog.title;

            openSendSellerMessageModal(messageDetails, sellerId, sellerName, subject);
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(ItemCard, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps) {
            var _props$cardViewModel = this.props.cardViewModel,
                cardViewModel = _props$cardViewModel === undefined ? {} : _props$cardViewModel;
            var nextCardViewModel = nextProps.cardViewModel;
            var biddingInfo = cardViewModel.biddingInfo,
                catalog = cardViewModel.catalog,
                item = cardViewModel.item,
                seller = cardViewModel.seller;


            return (0, _propsComparer2.default)(this.props, nextProps, ['className', 'hideLotNumbers', 'hideSeller', 'last', 'showBidStatus', 'showCta']) || (0, _propsComparer2.default)(biddingInfo, nextCardViewModel.biddingInfo, ['bidActivityCount', 'leadingBid']) || (0, _propsComparer2.default)(item, nextCardViewModel.item, ['itemId']) || (0, _propsComparer2.default)(seller, nextCardViewModel.seller, ['sellerId']) || (0, _propsComparer2.default)(catalog, nextCardViewModel.catalog, ['catalogId']);
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                cardViewModel = _props.cardViewModel,
                className = _props.className,
                hideLotNumbers = _props.hideLotNumbers,
                hideSeller = _props.hideSeller,
                last = _props.last,
                openAbstenteeBidModal = _props.openAbstenteeBidModal,
                openRetractBidModal = _props.openRetractBidModal,
                showBidStatus = _props.showBidStatus,
                showCta = _props.showCta,
                showDate = _props.showDate,
                showEstimate = _props.showEstimate,
                trackClick = _props.trackClick;
            var biddingInfo = cardViewModel.biddingInfo,
                catalog = cardViewModel.catalog,
                catalogRegistration = cardViewModel.catalogRegistration,
                item = cardViewModel.item,
                seller = cardViewModel.seller;
            var bidActivityCount = biddingInfo.bidActivityCount,
                leadingBid = biddingInfo.leadingBid;
            var catalogId = catalog.catalogId,
                catalogStatus = catalog.catalogStatus,
                _catalog$currency = catalog.currency,
                currency = _catalog$currency === undefined ? 'usd' : _catalog$currency,
                isCatalogOnly = catalog.isCatalogOnly,
                saleStartTs = catalog.saleStartTs,
                catalogTitle = catalog.title;
            var imageVersion = item.imageVersion,
                isAvailable = item.isAvailable,
                isPassed = item.isPassed,
                isSold = item.isSold,
                itemId = item.itemId,
                highBidEstimate = item.highBidEstimate,
                lotNumber = item.lotNumber,
                lowBidEstimate = item.lowBidEstimate,
                photo = item.photo,
                photos = item.photos,
                salePrice = item.salePrice,
                startPrice = item.startPrice,
                title = item.title;
            var sellerId = seller.sellerId,
                sellerName = seller.name;


            var firstPhoto = void 0;
            if (photo) {
                // came from the catalog page items
                firstPhoto = photo;
            } else if (photos && photos.length > 0) {
                firstPhoto = photos[0];
            } else {
                firstPhoto = '';
            }

            var classes = [].concat((0, _toConsumableArray3.default)(className.split(' ')), [_ItemCard2.default['item-card'], !item.title ? _ItemCard2.default.placeholder : '', last ? _ItemCard2.default['last-card'] : '']).join(' ').trim();
            var currentPrice = leadingBid || salePrice || startPrice || 0;
            var safeTitle = (0, _safelyRender2.default)(title, 'span');
            var safeSellerName = (0, _safelyRender2.default)(sellerName, 'span');
            var itemUrl = (0, _urls.getItemUrl)(itemId, title);
            var imageUrl = (0, _urls.getItemCardImageUrl)(sellerId, catalogId, itemId, firstPhoto, imageVersion);
            var lotNumberDisplay = lotNumber ? (0, _jsx3.default)('span', {
                className: _ItemCard2.default['lot-number']
            }, void 0, lotNumber, ':\xA0') : (0, _jsx3.default)('span', {
                className: _ItemCard2.default['lot-number']
            }, void 0, '\xA0', '0000');

            var estimateRange = {
                high: (0, _jsx3.default)(_reactIntl.FormattedNumber, {
                    value: highBidEstimate,
                    style: 'currency',
                    currency: currency,
                    maximumFractionDigits: 0,
                    minimumFractionDigits: 0
                }),
                low: (0, _jsx3.default)(_reactIntl.FormattedNumber, {
                    value: lowBidEstimate,
                    style: 'currency',
                    currency: currency,
                    maximumFractionDigits: 0,
                    minimumFractionDigits: 0
                })
            };

            var showLiveButton = (0, _live.shouldShowLive)(catalogStatus, isCatalogOnly, saleStartTs);

            return (0, _jsx3.default)('div', {
                className: classes,
                onClick: trackClick
            }, void 0, (0, _jsx3.default)(_components.ItemSaveContainer, {
                className: _ItemCard2.default['item-save'],
                itemId: itemId
            }), (0, _jsx3.default)(_components.Link, {
                className: _ItemCard2.default['item-image-link-container'],
                route: true,
                to: itemUrl
            }, void 0, (0, _jsx3.default)('div', {
                className: _ItemCard2.default['image-container']
            }, void 0, (0, _jsx3.default)(_components.ImageWithFallback, {
                alt: title,
                className: _ItemCard2.default.image,
                forceFallback: !item,
                src: imageUrl
            }), showBidStatus && (0, _jsx3.default)(_CardStatusBanner2.default, {
                biddingInfo: biddingInfo,
                catalogRegistration: catalogRegistration,
                item: item
            }))), (0, _jsx3.default)('div', {
                className: _ItemCard2.default['item-title-container']
            }, void 0, title ? (0, _jsx3.default)(_components.Link, {
                className: _ItemCard2.default['item-title'],
                route: true,
                to: itemUrl,
                primary: true
            }, void 0, !hideLotNumbers && lotNumberDisplay, safeTitle) : (0, _jsx3.default)('span', {
                className: _ItemCard2.default['item-title']
            }, void 0, 'Lorem ipsum dolor sit amet, consectetur adipiscing elit')), (0, _jsx3.default)('div', {
                className: _ItemCard2.default['estimate-house-time-container']
            }, void 0, showEstimate && (0, _jsx3.default)('div', {
                className: _ItemCard2.default['estimate-link-container']
            }, void 0, (0, _jsx3.default)('span', {
                className: _ItemCard2.default['estimate-name-container']
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'short_estimate_values',
                values: estimateRange
            }))), !hideSeller && (0, _jsx3.default)('div', {
                className: _ItemCard2.default['auctioneer-link-container']
            }, void 0, (0, _jsx3.default)('span', {
                className: _ItemCard2.default['auctioneer-name-container']
            }, void 0, sellerName ? (0, _jsx3.default)(_components.Link, {
                className: _ItemCard2.default['auctioneer-link'],
                route: true,
                to: (0, _urls.getSellerUrl)(sellerId, sellerName),
                primaryWeak: true
            }, void 0, safeSellerName) : (0, _jsx3.default)('span', {
                className: _ItemCard2.default['auctioneer-link']
            }, void 0, 'Jasper52'))), (0, _jsx3.default)('div', {
                className: _ItemCard2.default['catalog-countdown-container']
            }, void 0, showLiveButton ? (0, _jsx3.default)('span', {
                className: _ItemCard2.default['item-is-live']
            }, void 0, (0, _jsx3.default)(_components.BidConsoleOpener, {
                catalogId: catalogId,
                sellerId: sellerId
            }, void 0, (0, _jsx3.default)('span', {
                className: _ItemCard2.default['item-is-live-link']
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'live'
            })))) : (0, _jsx3.default)(_components.CatalogDate, {
                date: saleStartTs,
                showDate: showDate
            }))), (0, _jsx3.default)('div', {
                className: _ItemCard2.default['item-bids-container']
            }, void 0, isAvailable ? (0, _jsx3.default)('span', {
                className: _ItemCard2.default['item-current-bid-container']
            }, void 0, (0, _jsx3.default)('span', {
                className: _ItemCard2.default['item-current-bid']
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedNumber, {
                value: currentPrice,
                style: 'currency',
                currency: currency,
                maximumFractionDigits: 0,
                minimumFractionDigits: 0
            })), bidActivityCount === 0 ? '' : (0, _jsx3.default)('span', {
                className: _ItemCard2.default['item-bid-count']
            }, void 0, bidActivityCount, '\xA0', bidActivityCount === 1 ? (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'bid'
            }) : (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'bids'
            }))) : (0, _jsx3.default)('span', {
                className: _ItemCard2.default['item-sold-bid-container']
            }, void 0, (0, _jsx3.default)('span', {
                className: _ItemCard2.default['item-sold-bid']
            }, void 0, !!isPassed && (0, _jsx3.default)(_components.ItemPriceGatewayContainer, {
                itemCard: true,
                containerClassName: _ItemCard2.default['price-gateway-container']
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'lot_passed'
            })), !!isSold && (0, _jsx3.default)(_components.ItemPriceGatewayContainer, {
                itemCard: true,
                containerClassName: _ItemCard2.default['price-gateway-container']
            }, void 0, (0, _jsx3.default)('span', {}, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'sold_for'
            }, 0), '\xA0', (0, _jsx3.default)(_reactIntl.FormattedNumber, {
                value: salePrice,
                style: 'currency',
                currency: currency,
                maximumFractionDigits: 0,
                minimumFractionDigits: 0
            }, 1)))))), showCta && (0, _jsx3.default)(_CardCta2.default, {
                biddingInfo: biddingInfo,
                catalogId: catalogId,
                catalogRegistration: catalogRegistration,
                catalogStatus: catalogStatus,
                catalogTitle: catalogTitle,
                currency: currency,
                isCatalogOnly: isCatalogOnly,
                item: item,
                itemUrl: itemUrl,
                openAbstenteeBidModal: openAbstenteeBidModal,
                openRetractBidModal: openRetractBidModal,
                saleStartTs: saleStartTs,
                sellerId: sellerId,
                sellerName: sellerName,
                showSendSellerMessageModal: this.showSendSellerMessageModal
            }));
        }
    }]);
    return ItemCard;
}(_react.Component), _class.contextTypes = {
    intl: _propTypes2.default.object.isRequired
}, _class.defaultProps = {
    cardViewModel: {
        biddingInfo: {},
        catalog: {
            currency: 'usd'
        },
        catalogRegistration: {},
        item: {
            salePrice: 0,
            title: ''
        },
        seller: {}
    },
    className: '',
    hideLotNumbers: false,
    hideSeller: false,
    last: false,
    openAbstenteeBidModal: _noop2.default,
    openRetractBidModal: _noop2.default,
    openSendSellerMessageModal: _noop2.default,
    showBidStatus: false,
    showCta: false,
    showDate: true,
    showEstimate: false,
    trackClick: _noop2.default
}, _temp2);
exports.default = ItemCard;
module.exports = exports['default'];

/***/ }),

/***/ "g3g9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.openBiddableModal = exports.biddableTransactionCompleted = exports.isInstantApprovalEnabled = exports.ESCROW_DEPOSIT_SENT = undefined;

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;

var _helpers = __webpack_require__("SY39");

var _reselect = __webpack_require__("bndy");

var _modal = __webpack_require__("u90i");

var _user = __webpack_require__("CFLi");

var _config = __webpack_require__("iS9E");

var _intl = __webpack_require__("dYLj");

var _browser = __webpack_require__("aN2S");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Action Types */
var ESCROW_DEPOSIT_SENT = exports.ESCROW_DEPOSIT_SENT = 'la/user/biddable/ESCROW_DEPOSIT_SENT';

// reducer
var DEFAULT_STATE = {
    instantApprovalEnabled: false
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        case ESCROW_DEPOSIT_SENT:
            return (0, _extends3.default)({}, state);
        default:
            return state;
    }
}

var getForceInstantApprovalEnabled = function getForceInstantApprovalEnabled() {
    return typeof window === 'undefined' ? false : window.forceInstantApprovalEnabled;
};
var getInstantDepositWidget = function getInstantDepositWidget() {
    return typeof window === 'undefined' ? false : window.InstantDepositWidget;
};

/* SELECTORS */
var stateSelector = function stateSelector(state) {
    return state.user.biddable;
};
var isInstantApprovalEnabled = exports.isInstantApprovalEnabled = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.instantApprovalEnabled;
});

/* Action Creators */
var biddableTransactionCompleted = exports.biddableTransactionCompleted = function biddableTransactionCompleted() {
    return { type: ESCROW_DEPOSIT_SENT };
};
var openBiddableModal = exports.openBiddableModal = function openBiddableModal(catalogId) {
    return function (dispatch, getState) {
        var state = getState();

        var isMobile = !!(0, _browser.isUiMobile)(state);
        var hideInstantApproval = !(isInstantApprovalEnabled(state) || getForceInstantApprovalEnabled());

        if (hideInstantApproval || isMobile) {
            return _promise2.default.resolve();
        }

        var InstantDepositWidget = getInstantDepositWidget();
        if (!InstantDepositWidget) {
            return _promise2.default.reject(new Error('Instant approval is turned on but no biddable integration was found.'));
        }

        var authToken = (0, _user.getAuthToken)(state);
        var deployment = (0, _config.getDeployment)(state);
        var depositUrl = (0, _helpers.buildUrl)('<ESCROW-API>', deployment, 'deposit');
        try {
            var widget = new InstantDepositWidget({
                brandingCssOptions: {
                    // Defines the accent color (default: #D43E85)
                    brandColor: '#0097BA',
                    // Defines the button border radius (default: 4px)
                    buttonBorderRadius: '2px'
                },
                callback: function callback() {
                    var error = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
                    var result = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

                    if (error) {
                        console.log(error);
                    }
                    dispatch(biddableTransactionCompleted());
                },
                data: {
                    catalogId: catalogId,
                    creationTxValue: '1336950000000001',
                    token: authToken
                },
                depositUrl: depositUrl,
                languange: (0, _intl.getLocale)(state) || 'en',
                links: {
                    blockinfo: '#',
                    buyTokens: '#',
                    faq: '#'
                },
                platformName: 'LiveAuctioneers'
            });

            // close all of the other modals just in case
            dispatch((0, _modal.dismissModal)());

            widget.openPopup();
            return _promise2.default.resolve();
        } catch (e) {
            return _promise2.default.reject(e);
        }
    };
};

/***/ }),

/***/ "grTh":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.LiveCatalogStatusRemote = undefined;

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _helpers = __webpack_require__("SY39");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var transform = function transform(body) {
    var _body$data = body.data,
        approved = _body$data.Approved,
        description = _body$data.AuctionDescription,
        catalogId = _body$data.AuctionId,
        title = _body$data.AuctionTitle,
        currentItem = _body$data.CurrentLot,
        lastUpdated = _body$data.LastUpdated,
        itemCount = _body$data.LotCount;

    var _ref = currentItem || {},
        itemId = _ref.LotId,
        lotNumber = _ref.LotNumber,
        lotTitle = _ref.LotTitle,
        lotDescription = _ref.LotDescription,
        askPrice = _ref.AskPrice,
        leadingBidder = _ref.LeadingBidderId,
        lowEstimate = _ref.LowEstimate,
        leadingBid = _ref.HighBid,
        highEstimate = _ref.HighEstimate,
        reserverPrice = _ref.ReservePrice;

    return {
        data: {
            approved: approved,
            catalogId: catalogId,
            currentItem: {
                askPrice: askPrice,
                highEstimate: highEstimate,
                itemId: itemId,
                leadingBid: leadingBid,
                leadingBidder: leadingBidder,
                lotDescription: lotDescription,
                lotNumber: lotNumber,
                lotTitle: lotTitle,
                lowEstimate: lowEstimate,
                reserverPrice: reserverPrice
            },
            description: description,
            itemCount: itemCount,
            lastUpdated: lastUpdated,
            status: !!currentItem.LotId ? 'live' : 'online',
            title: title
        }
    };
};

var LiveCatalogStatusRemote = exports.LiveCatalogStatusRemote = {
    fetchLiveCatalogStatus: function fetchLiveCatalogStatus(_ref2) {
        var Token = _ref2.authToken,
            bidderId = _ref2.bidderId,
            AuctionId = _ref2.catalogId,
            deployment = _ref2.deployment,
            Email = _ref2.Email;
        return new _promise2.default(function (resolve, reject) {
            var requestFuction = !!bidderId && !!Email ? _helpers.makePost : _helpers.makeGet;
            var request = requestFuction('<CLERK-SERVICE>clerk/auction/' + AuctionId, deployment);

            if (bidderId && Email) {
                (0, _helpers.addAuthToken)(request, Token);
                request.send({
                    AuctionId: AuctionId,
                    Email: Email,
                    Token: Token
                });
            }

            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response, success404: true, transform: transform });
            });
        });
    }
};

/***/ }),

/***/ "hUkZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"link":"link___33BvM","primary":"primary___3oM0T","primary-weak":"primary-weak___3oVtF","secondary":"secondary___3t2Ai"};

/***/ }),

/***/ "hXxF":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = __webpack_require__("dcb+");

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _reactIntl = __webpack_require__("Pq8k");

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propsComparer = __webpack_require__("wsGv");

var _propsComparer2 = _interopRequireDefault(_propsComparer);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _BidIncrements = __webpack_require__("NCJW");

var _BidIncrements2 = _interopRequireDefault(_BidIncrements);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BidIncrements = (_temp2 = _class = function (_Component) {
    (0, _inherits3.default)(BidIncrements, _Component);

    function BidIncrements() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, BidIncrements);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = BidIncrements.__proto__ || (0, _getPrototypeOf2.default)(BidIncrements)).call.apply(_ref, [this].concat(args))), _this), _this.mapBidIncrements = function (item, index) {
            return (0, _jsx3.default)('div', {
                className: _BidIncrements2.default.row
            }, index, (0, _jsx3.default)(_reactIntl.FormattedNumber, {
                value: item.fromAmount,
                style: 'currency',
                currency: _this.props.currency
            }), (0, _jsx3.default)(_reactIntl.FormattedNumber, {
                value: item.incAmount,
                style: 'currency',
                currency: _this.props.currency
            }));
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(BidIncrements, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps) {
            return (0, _propsComparer2.default)(this.props, nextProps, ['currency', 'bidIncrements']);
        }
    }, {
        key: 'render',
        value: function render() {
            var bidIncrements = this.props.bidIncrements;


            return (0, _jsx3.default)('div', {
                className: _BidIncrements2.default.table
            }, void 0, (0, _jsx3.default)('div', {
                className: _BidIncrements2.default.row
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'price'
            }), (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'bid_increment'
            })), bidIncrements.map(this.mapBidIncrements));
        }
    }]);
    return BidIncrements;
}(_react.Component), _class.defaultProps = {
    bidIncrements: [],
    currency: 'usd'
}, _temp2);
exports.default = BidIncrements;
module.exports = exports['default'];

/***/ }),

/***/ "hmCE":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CatalogDetailMock = undefined;

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _delay = __webpack_require__("kRHc");

var _delay2 = _interopRequireDefault(_delay);

var _mockData = __webpack_require__("6VmH");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CatalogDetailMock = exports.CatalogDetailMock = {
    fetchCatalogDetailsByIds: function fetchCatalogDetailsByIds(catalogIds) {
        return new _promise2.default(function (resolve) {
            setTimeout(function () {
                var catalogTerms = catalogIds.map(function (x) {
                    return (0, _mockData.getTestCatalogDetails)(x);
                });
                resolve({
                    data: {
                        data: catalogTerms
                    }
                });
            }, _delay2.default);
        });
    }
};

/***/ }),

/***/ "hvUq":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = __webpack_require__("dcb+");

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _OverlayTrigger = __webpack_require__("+uBL");

var _OverlayTrigger2 = _interopRequireDefault(_OverlayTrigger);

var _Popover = __webpack_require__("fdtx");

var _Popover2 = _interopRequireDefault(_Popover);

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propsComparer = __webpack_require__("wsGv");

var _propsComparer2 = _interopRequireDefault(_propsComparer);

var _reactIntl = __webpack_require__("Pq8k");

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WhyCantRetractBidPopover = function (_Component) {
    (0, _inherits3.default)(WhyCantRetractBidPopover, _Component);

    function WhyCantRetractBidPopover() {
        (0, _classCallCheck3.default)(this, WhyCantRetractBidPopover);
        return (0, _possibleConstructorReturn3.default)(this, (WhyCantRetractBidPopover.__proto__ || (0, _getPrototypeOf2.default)(WhyCantRetractBidPopover)).apply(this, arguments));
    }

    (0, _createClass3.default)(WhyCantRetractBidPopover, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps) {
            return (0, _propsComparer2.default)(this.props, nextProps, ['id', 'styles']);
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                id = _props.id,
                styles = _props.styles;

            var whyCantRetractBidPopover = (0, _jsx3.default)(_Popover2.default, {
                id: id,
                bsClass: styles['why-cant-i-retract-bid-popover-text'] + ' popover'
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'why_cant_i_retract_bid_popover_text'
            }));
            var whyCantRetractBidOverlay = (0, _jsx3.default)(_OverlayTrigger2.default, {
                trigger: ['click'],
                placement: 'top',
                overlay: whyCantRetractBidPopover,
                rootClose: true
            }, void 0, (0, _jsx3.default)('a', {
                role: 'button',
                tabIndex: '0'
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'retract'
            })));
            return whyCantRetractBidOverlay;
        }
    }]);
    return WhyCantRetractBidPopover;
}(_react.Component);

exports.default = WhyCantRetractBidPopover;
module.exports = exports['default'];

/***/ }),

/***/ "i+lj":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.changeMoreItemsFromCatalogIndex = exports.getMoreItemsFromCatalogIndex = exports.CHANGE_MORE_ITEMS_FROM_CATALOG_INDEX = undefined;

var _defineProperty2 = __webpack_require__("bOdI");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends3 = __webpack_require__("Dd8w");

var _extends4 = _interopRequireDefault(_extends3);

exports.default = reducer;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Action Types */
var CHANGE_MORE_ITEMS_FROM_CATALOG_INDEX = exports.CHANGE_MORE_ITEMS_FROM_CATALOG_INDEX = 'CHANGE_MORE_ITEMS_FROM_CATALOG_INDEX';

// reducer
var DEFAULT_STATE = {};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        case CHANGE_MORE_ITEMS_FROM_CATALOG_INDEX:
            return (0, _extends4.default)({}, state, (0, _defineProperty3.default)({}, action.payload.itemId, action.payload.newIndex));
        default:
            return state;
    }
}

/* SELECTORS */
var getMoreItemsFromCatalogIndex = exports.getMoreItemsFromCatalogIndex = function getMoreItemsFromCatalogIndex(state, itemId, fallbackIndex) {
    return state.ui.moreItemsFromCatalogIndex[itemId] || fallbackIndex || 0;
};

/* ACTION CREATORS */
var changeMoreItemsFromCatalogIndex = exports.changeMoreItemsFromCatalogIndex = function changeMoreItemsFromCatalogIndex(itemId, newIndex) {
    return {
        payload: { itemId: itemId, newIndex: newIndex },
        type: CHANGE_MORE_ITEMS_FROM_CATALOG_INDEX
    };
};

/***/ }),

/***/ "i2pf":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.AuthRemote = undefined;

var _slicedToArray2 = __webpack_require__("d7EF");

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _helpers = __webpack_require__("SY39");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AuthRemote = exports.AuthRemote = {
    postAddCreditCard: function postAddCreditCard(_ref) {
        var authToken = _ref.authToken,
            bidderId = _ref.bidderId,
            cardToken = _ref.cardToken,
            deployment = _ref.deployment;
        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makePost)('<MAINHOST-API>api/bidders/' + bidderId + '/stripe/customer', deployment);
            (0, _helpers.addAuthToken)(request, authToken);
            request.send({ card_token: cardToken });
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response });
            });
        });
    },
    postConfirmPassword: function postConfirmPassword(_ref2) {
        var deployment = _ref2.deployment,
            password = _ref2.password,
            username = _ref2.username;
        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makePost)('<ITEM-API>auth/spalogin', deployment);
            request.send({ password: password, username: username });
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response });
            });
        });
    },
    postForgotPassword: function postForgotPassword(_ref3) {
        var authToken = _ref3.authToken,
            deployment = _ref3.deployment,
            emailAddress = _ref3.emailAddress;
        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makePost)('<MAINHOST-API>api/pw_reset', deployment);
            (0, _helpers.addAuthToken)(request, authToken);

            var _emailAddress$split = emailAddress.split('@'),
                _emailAddress$split2 = (0, _slicedToArray3.default)(_emailAddress$split, 2),
                username = _emailAddress$split2[0],
                domain = _emailAddress$split2[1];

            request.query({ client_version: '4.3' });
            request.type('form');
            request.send({ email: username.replace('+', '%2B') + '@' + domain }); // To allow emails with pluses
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response });
            });
        });
    },
    postPayment: function postPayment(_ref4) {
        var shipping_address = _ref4.address,
            amount = _ref4.amount,
            authToken = _ref4.authToken,
            bidderId = _ref4.bidderId,
            card_token = _ref4.cardToken,
            catalogId = _ref4.catalogId,
            currency = _ref4.currency,
            deployment = _ref4.deployment;
        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makePost)('<MAINHOST-API>api/bidders/' + bidderId + '/wonitems/catalogs/' + catalogId + '/payments', deployment);
            (0, _helpers.addAuthToken)(request, authToken);
            request.send({ amount: amount, card_token: card_token, currency: currency, shipping_address: shipping_address });
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response });
            });
        });
    },
    postResetPassword: function postResetPassword(_ref5) {
        var bidderId = _ref5.bidderId,
            deployment = _ref5.deployment,
            hash = _ref5.hash,
            newPassword = _ref5.newPassword;
        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makePost)('<ITEM-API>auth/spa/reset-password', deployment);
            request.send({ bidderId: bidderId, hash: hash, newPassword: newPassword });
            request.end(function (err, response) {
                return (0, _helpers.handleResponseUseItemApiError)({ err: err, reject: reject, resolve: resolve, response: response });
            });
        });
    },
    postUpdatePassword: function postUpdatePassword(_ref6) {
        var authToken = _ref6.authToken,
            deployment = _ref6.deployment,
            newPassword = _ref6.newPassword,
            oldPassword = _ref6.oldPassword;
        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makePost)('<ITEM-API>auth/update-password', deployment);
            (0, _helpers.addAuthToken)(request, authToken);
            request.send({ newPassword: newPassword, oldPassword: oldPassword });
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response });
            });
        });
    },
    putAddCreditCard: function putAddCreditCard(_ref7) {
        var authToken = _ref7.authToken,
            bidderId = _ref7.bidderId,
            cardToken = _ref7.cardToken,
            deployment = _ref7.deployment;
        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makePut)('<MAINHOST-API>api/bidders/' + bidderId + '/stripe/customer', deployment);
            (0, _helpers.addAuthToken)(request, authToken);
            request.send({ card_token: cardToken });
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response });
            });
        });
    }
};

/***/ }),

/***/ "i7yC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"cover-lots":"cover-lots___3IoAK","primary-img-container":"primary-img-container___26Z4E","primary":"primary___2lD-U","secondary-img-container":"secondary-img-container___Buijy","img-container":"img-container___26zUq","secondary":"secondary___3SuZ8"};

/***/ }),

/***/ "iKXC":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = __webpack_require__("dcb+");

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _shouldLogin = __webpack_require__("57qU");

var _user = __webpack_require__("CFLi");

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propsComparer = __webpack_require__("wsGv");

var _propsComparer2 = _interopRequireDefault(_propsComparer);

var _redux = __webpack_require__("2KeS");

var _reactRedux = __webpack_require__("RH2O");

var _modal = __webpack_require__("u90i");

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _uuid = __webpack_require__("DlMc");

var _uuid2 = _interopRequireDefault(_uuid);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ShouldLogInContainer = (_dec = (0, _reactRedux.connect)(function (state) {
    var userLoggedIn = (0, _user.isUserLoggedIn)(state);
    var isCompleteProfile = (0, _user.isProfileComplete)(state);
    var triggerId = (0, _shouldLogin.getTriggerId)(state);
    var tracking = (0, _shouldLogin.isTracking)(state);
    var loginModalOpen = (0, _shouldLogin.isLoginModalOpen)(state);
    var completeAccountModalOpen = (0, _shouldLogin.isCompleteAccountModalOpen)(state);
    var confirmPasswordTriggered = (0, _user.isConfirmPasswordTriggered)(state);
    var userAtLeastPartiallyRegistered = (0, _user.isUserAtLeastPartiallyRegistered)(state);
    var userIsPartiallyRegistered = (0, _user.isUserPartiallyRegistered)(state);

    return {
        completeAccountModalOpen: completeAccountModalOpen,
        confirmPasswordTriggered: confirmPasswordTriggered,
        isCompleteProfile: isCompleteProfile,
        loginModalOpen: loginModalOpen,
        tracking: tracking,
        triggerId: triggerId,
        userAtLeastPartiallyRegistered: userAtLeastPartiallyRegistered,
        userIsPartiallyRegistered: userIsPartiallyRegistered,
        userLoggedIn: userLoggedIn
    };
}, function (dispatch) {
    return (0, _redux.bindActionCreators)({
        openCompleteAccountModalFromChecker: _shouldLogin.openCompleteAccountModalFromChecker,
        openConfirmPasswordModalFromChecker: _shouldLogin.openConfirmPasswordModalFromChecker,
        openCreateAccountModal: _modal.openCreateAccountModal,
        openLoginModalFromChecker: _shouldLogin.openLoginModalFromChecker,
        openSetPasswordModalFromChecker: _shouldLogin.openSetPasswordModalFromChecker,
        stopTracker: _shouldLogin.stopTracker
    }, dispatch);
}), _dec(_class = (_temp = _class2 = function (_Component) {
    (0, _inherits3.default)(ShouldLogInContainer, _Component);

    function ShouldLogInContainer(props, context) {
        (0, _classCallCheck3.default)(this, ShouldLogInContainer);

        var _this = (0, _possibleConstructorReturn3.default)(this, (ShouldLogInContainer.__proto__ || (0, _getPrototypeOf2.default)(ShouldLogInContainer)).call(this, props, context));

        _this.determineModalFlow = function (userIsPartiallyRegistered) {
            if (userIsPartiallyRegistered) {
                _this.props.openSetPasswordModalFromChecker(_this.state.guid);
            } else {
                _this.props.openLoginModalFromChecker(_this.state.guid);
            }
        };

        _this.handleClick = function () {
            var _this$props = _this.props,
                forceConfirmPassword = _this$props.forceConfirmPassword,
                forceSignUp = _this$props.forceSignUp,
                userLoggedIn = _this$props.userLoggedIn,
                requireLogin = _this$props.requireLogin,
                isCompleteProfile = _this$props.isCompleteProfile,
                requireCompleteProfile = _this$props.requireCompleteProfile,
                requireUserAtLeastPartiallyRegistered = _this$props.requireUserAtLeastPartiallyRegistered,
                runFunction = _this$props.runFunction,
                runFunctionArgument = _this$props.runFunctionArgument,
                userIsPartiallyRegistered = _this$props.userIsPartiallyRegistered,
                userAtLeastPartiallyRegistered = _this$props.userAtLeastPartiallyRegistered;


            if (forceConfirmPassword) {
                _this.props.openConfirmPasswordModalFromChecker(_this.state.guid);
            } else if (forceSignUp) {
                _this.props.openCreateAccountModal();
            } else if (!userLoggedIn && requireLogin) {
                _this.determineModalFlow(userIsPartiallyRegistered);
            } else if (!isCompleteProfile && requireCompleteProfile) {
                _this.props.openCompleteAccountModalFromChecker(_this.state.guid);
            } else if (!userAtLeastPartiallyRegistered && requireUserAtLeastPartiallyRegistered) {
                _this.determineModalFlow(userIsPartiallyRegistered);
            } else {
                runFunction(runFunctionArgument);
            }
        };

        _this.state = { guid: _uuid2.default.v4() };
        return _this;
    }

    (0, _createClass3.default)(ShouldLogInContainer, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            var _props = this.props,
                forceConfirmPassword = _props.forceConfirmPassword,
                requireLogin = _props.requireLogin,
                requireCompleteProfile = _props.requireCompleteProfile,
                runFunction = _props.runFunction,
                runFunctionArgument = _props.runFunctionArgument;
            var userLoggedIn = nextProps.userLoggedIn,
                isCompleteProfile = nextProps.isCompleteProfile,
                tracking = nextProps.tracking,
                loginModalOpen = nextProps.loginModalOpen,
                completeAccountModalOpen = nextProps.completeAccountModalOpen,
                triggerId = nextProps.triggerId;


            if (this.state.guid === triggerId && tracking) {
                if (forceConfirmPassword) {
                    if (this.props.confirmPasswordTriggered && this.props.confirmPasswordTriggered !== nextProps.confirmPasswordTriggered) {
                        this.props.stopTracker();
                        runFunction(runFunctionArgument);
                    }
                } else {
                    if (!loginModalOpen && !completeAccountModalOpen && (userLoggedIn || !requireLogin) && (isCompleteProfile || !requireCompleteProfile)) {
                        this.props.stopTracker();
                        runFunction(runFunctionArgument);
                    }

                    if (userLoggedIn && !loginModalOpen && requireCompleteProfile && !isCompleteProfile && !completeAccountModalOpen) {
                        this.props.openCompleteAccountModalFromChecker(triggerId);
                    }
                }
            }
        }
    }, {
        key: 'shouldUpdateComponent',
        value: function shouldUpdateComponent(nextProps) {
            return (0, _propsComparer2.default)(this.props, nextProps, ['className', 'completeAccountModalOpen', 'confirmPasswordTriggered', 'forceConfirmPassword', 'forceSignUp', 'isCompleteProfile', 'loginModalOpen', 'requireCompleteProfile', 'requireLogin', 'runFunctionArgument', 'tracking', 'triggerId', 'userLoggedIn', 'children']);
        }
    }, {
        key: 'render',
        value: function render() {
            var className = this.props.className;

            return (0, _jsx3.default)('span', {
                className: className,
                onClick: this.handleClick
            }, void 0, this.props.children);
        }
    }]);
    return ShouldLogInContainer;
}(_react.Component), _class2.defaultProps = {
    className: '',
    loginModalOpen: false,
    requireCompleteProfile: false,
    requireLogin: true,
    tracking: false
}, _temp)) || _class);
exports.default = ShouldLogInContainer;
module.exports = exports['default'];

/***/ }),

/***/ "iLJB":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = __webpack_require__("dcb+");

var _jsx3 = _interopRequireDefault(_jsx2);

var _toConsumableArray2 = __webpack_require__("Gu7T");

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propsComparer = __webpack_require__("wsGv");

var _propsComparer2 = _interopRequireDefault(_propsComparer);

var _isEmpty = __webpack_require__("lHK6");

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _ItemCard = __webpack_require__("g2OR");

var _ItemCard2 = _interopRequireDefault(_ItemCard);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ItemGrid = __webpack_require__("M7vW");

var _ItemGrid2 = _interopRequireDefault(_ItemGrid);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ItemGrid = (_temp2 = _class = function (_Component) {
    (0, _inherits3.default)(ItemGrid, _Component);

    function ItemGrid() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, ItemGrid);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ItemGrid.__proto__ || (0, _getPrototypeOf2.default)(ItemGrid)).call.apply(_ref, [this].concat(args))), _this), _this.buildItemCards = function (card, index) {
            var _this$props = _this.props,
                cardViewModels = _this$props.cardViewModels,
                hideLotNumbers = _this$props.hideLotNumbers,
                hideSeller = _this$props.hideSeller,
                itemCardClass = _this$props.itemCardClass,
                openAbstenteeBidModal = _this$props.openAbstenteeBidModal,
                openRetractBidModal = _this$props.openRetractBidModal,
                openSendSellerMessageModal = _this$props.openSendSellerMessageModal,
                showBidStatusOnCards = _this$props.showBidStatusOnCards,
                showCtaOnCards = _this$props.showCtaOnCards,
                showDate = _this$props.showDate,
                showEstimate = _this$props.showEstimate,
                trackClick = _this$props.trackClick;


            var lastItemIndex = cardViewModels.length - 1;
            var itemCardProps = {
                className: itemCardClass,
                hideLotNumbers: hideLotNumbers,
                hideSeller: hideSeller,
                key: index,
                last: index === lastItemIndex,
                openAbstenteeBidModal: openAbstenteeBidModal,
                openRetractBidModal: openRetractBidModal,
                openSendSellerMessageModal: openSendSellerMessageModal,
                showBidStatus: showBidStatusOnCards,
                showCta: showCtaOnCards,
                showDate: showDate,
                showEstimate: showEstimate
            };
            if (card && !(0, _isEmpty2.default)(card) && !(0, _isEmpty2.default)(card.item)) {
                itemCardProps.cardViewModel = card;
            }
            if (trackClick) {
                itemCardProps.trackClick = function () {
                    return trackClick(card.item.itemId);
                };
            }
            return _react2.default.createElement(_ItemCard2.default, itemCardProps);
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(ItemGrid, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps) {
            return (0, _propsComparer2.default)(this.props, nextProps, ['hideLotNumbers', 'className', 'itemCardClass', 'hideLotNumbers', 'showBidStatusOnCards', 'showCtaOnCards', 'cardViewModels']);
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                cardViewModels = _props.cardViewModels,
                className = _props.className;


            var classes = [].concat((0, _toConsumableArray3.default)(className.split(' ')), [_ItemGrid2.default['item-grid']]).join(' ').trim();
            return (0, _jsx3.default)('div', {
                className: classes
            }, void 0, cardViewModels.map(this.buildItemCards));
        }
    }]);
    return ItemGrid;
}(_react.Component), _class.defaultProps = {
    cardViewModels: [],
    className: '',
    hideLotNumbers: false,
    hideSeller: false,
    itemCardClass: '',
    showBidStatusOnCards: false,
    showCtaOnCards: false,
    showDate: true
}, _temp2);
exports.default = ItemGrid;
module.exports = exports['default'];

/***/ }),

/***/ "iMUO":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fetchSellerUpcomingCatalogsIfNeeded = exports.isSellerUpcomingCatalogsLoading = exports.getLoadTimeForSellerUpcomingCatalogs = exports.getSellerUpcomingCatalogs = exports.LOAD_SELLER_UPCOMING_CATALOGS_SUCCESS = exports.LOAD_SELLER_UPCOMING_CATALOGS_REQUEST = exports.LOAD_SELLER_UPCOMING_CATALOGS_FAIL = undefined;

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _regenerator = __webpack_require__("Xxa5");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__("exGp");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _defineProperty2 = __webpack_require__("bOdI");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends4 = __webpack_require__("Dd8w");

var _extends5 = _interopRequireDefault(_extends4);

exports.default = reducer;

var _api = __webpack_require__("zFQO");

var _reselect = __webpack_require__("bndy");

var _difference = __webpack_require__("WlNK");

var _difference2 = _interopRequireDefault(_difference);

var _user = __webpack_require__("CFLi");

var _config = __webpack_require__("iS9E");

var _ms = __webpack_require__("EarI");

var _ms2 = _interopRequireDefault(_ms);

var _union = __webpack_require__("gszD");

var _union2 = _interopRequireDefault(_union);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOAD_SELLER_UPCOMING_CATALOGS_FAIL = exports.LOAD_SELLER_UPCOMING_CATALOGS_FAIL = 'la/domain/sellerUpcomingCatalogs/LOAD_FAIL';
var LOAD_SELLER_UPCOMING_CATALOGS_REQUEST = exports.LOAD_SELLER_UPCOMING_CATALOGS_REQUEST = 'la/domain/sellerUpcomingCatalogs/LOAD_REQUEST';
var LOAD_SELLER_UPCOMING_CATALOGS_SUCCESS = exports.LOAD_SELLER_UPCOMING_CATALOGS_SUCCESS = 'la/domain/sellerUpcomingCatalogs/LOAD_SUCCESS';

var REDUX_STORE_TIME = (0, _ms2.default)('30m');

var DEFAULT_STATE = {
    byId: {},
    loaded: {},
    loading: []
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        case LOAD_SELLER_UPCOMING_CATALOGS_FAIL:
            return (0, _extends5.default)({}, state, {
                loading: (0, _difference2.default)(state.loading, [action.meta.sellerId])
            });
        case LOAD_SELLER_UPCOMING_CATALOGS_REQUEST:
            return (0, _extends5.default)({}, state, {
                loading: (0, _union2.default)(state.loading, [action.payload])
            });
        case LOAD_SELLER_UPCOMING_CATALOGS_SUCCESS:
            var sellerId = action.meta.sellerId;

            return (0, _extends5.default)({}, state, {
                byId: (0, _extends5.default)({}, state.byId, (0, _defineProperty3.default)({}, sellerId, action.payload.catalogs.map(function (catalog) {
                    return catalog.catalogId;
                }))),
                loaded: (0, _extends5.default)({}, state.loaded, (0, _defineProperty3.default)({}, sellerId, action.meta.actionTime)),
                loading: (0, _difference2.default)(state.loading, [sellerId])
            });
        default:
            return state;
    }
}

/* SELECTORS */
var stateSelector = function stateSelector(state) {
    return state.domain.sellerUpcomingCatalogs;
};
var idSelector = function idSelector(state, id) {
    return id;
};

var byIdSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.byId;
});

var loadedSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.loaded;
});

var loadingSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.loading;
});

// takes in a (state, id) and returns the data
var getSellerUpcomingCatalogs = exports.getSellerUpcomingCatalogs = (0, _reselect.createSelector)([byIdSelector, idSelector], function (byId, id) {
    return byId[id] || [];
});

// takes in a (state, id) and returns the load time
var getLoadTimeForSellerUpcomingCatalogs = exports.getLoadTimeForSellerUpcomingCatalogs = (0, _reselect.createSelector)([loadedSelector, idSelector], function (loaded, id) {
    return loaded[id] || 0;
});

// takes in a (state, id) and returns the is loading
var isSellerUpcomingCatalogsLoading = exports.isSellerUpcomingCatalogsLoading = (0, _reselect.createSelector)([loadingSelector, idSelector], function (loading, id) {
    return loading.includes(id);
});

var shouldFetchUpcomingCatalogs = function shouldFetchUpcomingCatalogs(state, sellerId) {
    if (!sellerId) return false;
    var item = getSellerUpcomingCatalogs(state, sellerId);
    if (item.length) {
        var loaded = getLoadTimeForSellerUpcomingCatalogs(state, sellerId);
        var time = Date.now();
        var diff = time - loaded;
        if (diff < REDUX_STORE_TIME) return false;
    }
    var loading = isSellerUpcomingCatalogsLoading(state, sellerId);
    return !loading;
};

/* ACTION CREATORS */
var loadUpcomingCatalogs = function loadUpcomingCatalogs(sellerId) {
    return function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch, getState) {
            var state, authToken, deployment, response;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.prev = 0;
                            state = getState();
                            authToken = (0, _user.getAuthToken)(state);
                            deployment = (0, _config.getDeployment)(state);

                            dispatch({
                                payload: sellerId,
                                type: LOAD_SELLER_UPCOMING_CATALOGS_REQUEST
                            });
                            _context.next = 7;
                            return _api.SellerCatalogs.fetchSellerUpcomingCatalogsById({
                                authToken: authToken,
                                deployment: deployment,
                                sellerId: sellerId
                            });

                        case 7:
                            response = _context.sent;

                            dispatch({
                                meta: { actionTime: Date.now(), sellerId: sellerId },
                                payload: response.data,
                                type: LOAD_SELLER_UPCOMING_CATALOGS_SUCCESS
                            });
                            _context.next = 14;
                            break;

                        case 11:
                            _context.prev = 11;
                            _context.t0 = _context['catch'](0);

                            dispatch({
                                error: true,
                                meta: { sellerId: sellerId },
                                payload: _context.t0,
                                type: LOAD_SELLER_UPCOMING_CATALOGS_FAIL
                            });

                        case 14:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, undefined, [[0, 11]]);
        }));

        return function (_x3, _x4) {
            return _ref.apply(this, arguments);
        };
    }();
};

var fetchSellerUpcomingCatalogsIfNeeded = exports.fetchSellerUpcomingCatalogsIfNeeded = function fetchSellerUpcomingCatalogsIfNeeded(sellerId) {
    return function (dispatch, getState) {
        if (shouldFetchUpcomingCatalogs(getState(), sellerId)) {
            return dispatch(loadUpcomingCatalogs(sellerId));
        }
        return _promise2.default.resolve();
    };
};

/***/ }),

/***/ "iS9E":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getReferralCandy = exports.getStripePublishKey = exports.getSoastaMPulseApiKey = exports.getSegmentWriteKey = exports.getSailthruCustomerId = exports.getPubNubSubscribeKey = exports.getGoogleApiKey = exports.getDeployment = exports.getCuratorBaseUrl = exports.getClassicBaseUrl = exports.getBuildNumber = exports.getBiddableDepositUrl = exports.getBaseUrl = undefined;
exports.default = reducer;

var _reselect = __webpack_require__("bndy");

/* reducer */
var DEFAULT_STATE = {};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        default:
            return state;
    }
}

/* SELECTORS */
var stateSelector = function stateSelector(state) {
    return state.config;
};

var getBaseUrl = exports.getBaseUrl = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.baseUrl || '';
});
var getBiddableDepositUrl = exports.getBiddableDepositUrl = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.biddableDepositUrl || '';
});
var getBuildNumber = exports.getBuildNumber = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.buildNumber || '';
});
var getClassicBaseUrl = exports.getClassicBaseUrl = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.classicBaseUrl || '';
});
var getCuratorBaseUrl = exports.getCuratorBaseUrl = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.curatorImgUrl || '';
});
var getDeployment = exports.getDeployment = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.deployment || '';
});
var getGoogleApiKey = exports.getGoogleApiKey = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.googleApiKey || '';
});
var getPubNubSubscribeKey = exports.getPubNubSubscribeKey = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.pubNubSubscribeKey || '';
});
var getSailthruCustomerId = exports.getSailthruCustomerId = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.sailthruCustomerId || '';
});
var getSegmentWriteKey = exports.getSegmentWriteKey = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.segmentWriteKey || '';
});
var getSoastaMPulseApiKey = exports.getSoastaMPulseApiKey = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.soastaMPulseApiKey || '';
});
var getStripePublishKey = exports.getStripePublishKey = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.stripePublishKey || '';
});
var getReferralCandy = exports.getReferralCandy = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.referralCandy || '';
});

/***/ }),

/***/ "iUDN":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = __webpack_require__("dcb+");

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _reactFontawesome = __webpack_require__("f7W8");

var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);

var _reactIntl = __webpack_require__("Pq8k");

var _components = __webpack_require__("bGai");

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _PasswordInput = __webpack_require__("Mz5s");

var _PasswordInput2 = _interopRequireDefault(_PasswordInput);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PasswordInput = (_temp = _class = function (_Component) {
    (0, _inherits3.default)(PasswordInput, _Component);

    function PasswordInput(props, context) {
        (0, _classCallCheck3.default)(this, PasswordInput);

        var _this = (0, _possibleConstructorReturn3.default)(this, (PasswordInput.__proto__ || (0, _getPrototypeOf2.default)(PasswordInput)).call(this, props, context));

        _this.onValueChange = function (event) {
            _this.props.onValueChange(event.target.value, _this.props.id);
        };

        _this.getPasswordLabel = function (icon, showLabel) {
            var label = _this.props.label;

            return (0, _jsx3.default)('div', {
                className: _PasswordInput2.default['password-label']
            }, void 0, (0, _jsx3.default)('span', {
                className: _PasswordInput2.default.label
            }, void 0, label), (0, _jsx3.default)('span', {
                className: _PasswordInput2.default.eye,
                onClick: _this.showHide
            }, void 0, (0, _jsx3.default)(_reactFontawesome2.default, {
                className: _PasswordInput2.default.icon,
                icon: icon
            }), (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: showLabel
            })));
        };

        _this.showHide = function (event) {
            event.preventDefault();
            event.stopPropagation();
            _this.setState({
                passwordInputType: _this.state.passwordInputType === 'password' ? 'text' : 'password'
            });
        };

        _this.state = {
            passwordInputType: props.isMobile ? 'text' : 'password'
        };
        _this.showHide = _this.showHide.bind(_this);
        return _this;
    }

    (0, _createClass3.default)(PasswordInput, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                handleEnterKeyPress = _props.handleEnterKeyPress,
                id = _props.id,
                errorMessage = _props.errorMessage,
                valid = _props.valid;
            var passwordInputType = this.state.passwordInputType;


            var icon = passwordInputType === 'password' ? ['far', 'eye'] : ['far', 'eye-slash'];
            var showLabel = passwordInputType === 'password' ? 'show' : 'hide';
            var passwordLabel = this.getPasswordLabel(icon, showLabel);

            return (0, _jsx3.default)(_components.Input, {
                autoCapitalize: false,
                autoComplete: false,
                autoCorrect: false,
                dontRecordForFullstory: true,
                errorMessage: errorMessage || (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                    id: 'your_password_length'
                }),
                id: id,
                label: passwordLabel,
                onChange: this.onValueChange,
                onKeyPress: handleEnterKeyPress,
                type: passwordInputType,
                valid: valid,
                wide: true
            });
        }
    }]);
    return PasswordInput;
}(_react.Component), _class.defaultProps = {
    errorMessage: (0, _jsx3.default)(_reactIntl.FormattedMessage, {
        id: 'your_password_length'
    }),
    id: 'pw',
    label: (0, _jsx3.default)(_reactIntl.FormattedMessage, {
        id: 'password'
    })
}, _temp);
exports.default = PasswordInput;
module.exports = exports['default'];

/***/ }),

/***/ "iYVZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "iZFz":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _sellerRecordResults = __webpack_require__("I7qg");

var SellerRecordResults = {
    fetchSellerRecordResultsById: _sellerRecordResults.SellerRecordResultsRemote.fetchSellerRecordResultsById
};

exports.default = SellerRecordResults;
module.exports = exports['default'];

/***/ }),

/***/ "ibTp":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = __webpack_require__("dcb+");

var _jsx3 = _interopRequireDefault(_jsx2);

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Polyfill for webpack, just in case
if (false) require.ensure = function (d, c) {
    c(require);
};

var ItemDescriptionModalLoader = function (_Component) {
    (0, _inherits3.default)(ItemDescriptionModalLoader, _Component);

    function ItemDescriptionModalLoader(props, context) {
        (0, _classCallCheck3.default)(this, ItemDescriptionModalLoader);

        var _this = (0, _possibleConstructorReturn3.default)(this, (ItemDescriptionModalLoader.__proto__ || (0, _getPrototypeOf2.default)(ItemDescriptionModalLoader)).call(this, props, context));

        _this.state = {
            Component: null,
            mounted: false
        };
        return _this;
    }

    (0, _createClass3.default)(ItemDescriptionModalLoader, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            var _this2 = this;

            return new _promise2.default(function (resolve) {
                __webpack_require__.e/* require.ensure */(51).then((function () {
                    resolve(__webpack_require__("IIub"));
                }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            }).then(function (container) {
                _this2.setState({ Component: container });
            });
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.setState({ mounted: true });
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.setState({ mounted: false });
        }
    }, {
        key: 'render',
        value: function render() {
            var _state = this.state,
                Component = _state.Component,
                mounted = _state.mounted;

            return mounted && Component !== null ? (0, _jsx3.default)(Component, {}) : null;
        }
    }]);
    return ItemDescriptionModalLoader;
}(_react.Component);

exports.default = ItemDescriptionModalLoader;
module.exports = exports['default'];

/***/ }),

/***/ "ibbh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"la-notification-bar":"la-notification-bar___21gto","notification-message":"notification-message___3VGJ-","message-status":"message-status___3Gfbw","icon":"icon___1hNyD","message-body":"message-body___lZk86","message-headline":"message-headline___3p9M4"};

/***/ }),

/***/ "ij/i":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"buyers-premium":"buyers-premium___3Y9Vb"};

/***/ }),

/***/ "imzI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"header":"header___3gqz7","logo":"logo___3aXyn","content":"content___32LGH","content-large":"content-large___1y2wb","close-button":"close-button___kFIY1"};

/***/ }),

/***/ "iwOt":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = __webpack_require__("dcb+");

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propsComparer = __webpack_require__("wsGv");

var _propsComparer2 = _interopRequireDefault(_propsComparer);

var _Button = __webpack_require__("KluA");

var _Button2 = _interopRequireDefault(_Button);

var _reactFontawesome = __webpack_require__("f7W8");

var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);

var _reactIntl = __webpack_require__("Pq8k");

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _FollowSellerButton = __webpack_require__("lArx");

var _FollowSellerButton2 = _interopRequireDefault(_FollowSellerButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FollowSellerButton = (_temp = _class = function (_Component) {
    (0, _inherits3.default)(FollowSellerButton, _Component);

    function FollowSellerButton() {
        (0, _classCallCheck3.default)(this, FollowSellerButton);
        return (0, _possibleConstructorReturn3.default)(this, (FollowSellerButton.__proto__ || (0, _getPrototypeOf2.default)(FollowSellerButton)).apply(this, arguments));
    }

    (0, _createClass3.default)(FollowSellerButton, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps) {
            return (0, _propsComparer2.default)(this.props, nextProps, ['children', 'followed']);
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                children = _props.children,
                followed = _props.followed;


            if (children) {
                return (0, _jsx3.default)('div', {}, void 0, (0, _jsx3.default)(_Button2.default, {
                    primary: !followed,
                    secondary: followed
                }, void 0, children));
            }

            return (0, _jsx3.default)('div', {}, void 0, (0, _jsx3.default)(_Button2.default, {
                primary: !followed,
                secondary: followed
            }, void 0, (0, _jsx3.default)(_reactFontawesome2.default, {
                icon: ['fas', 'envelope'],
                className: _FollowSellerButton2.default.icon
            }), !followed ? (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'follow_auctioneer'
            }) : (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'following_auctioneer'
            })));
        }
    }]);
    return FollowSellerButton;
}(_react.Component), _class.defaultProps = {
    followed: false
}, _temp);
exports.default = FollowSellerButton;
module.exports = exports['default'];

/***/ }),

/***/ "jQDs":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    AUCTION_HOUSE_ID: 'house_id',
    CAMPAIGN_ID: 'campaignId',
    CATEGORY_ID: 'category_id',
    COUNTRY_CODE_ID: 'country',
    CURRENCY_ID: 'currency',
    CURRENT_BID_ID: 'current_bid',
    DISTANCE_ID: 'distance',
    ESTIMATED_PRICE_ID: 'estimated_price',
    HAMMER_PRICE_ID: 'hammer_price',
    KEYWORD: 'keyword',
    PAGE: 'page',
    PAGE_SIZE: 'pageSize',
    PAGE_SIZE_LEGACY_SUPPORT: 'pagesize',
    SORT: 'sort',
    STATUS: 'status'
};
module.exports = exports['default'];

/***/ }),

/***/ "ja8H":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = __webpack_require__("dcb+");

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _Links = __webpack_require__("n0xG");

var _Links2 = _interopRequireDefault(_Links);

var _Mobile = __webpack_require__("cD6S");

var _Mobile2 = _interopRequireDefault(_Mobile);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _WhiteLabelFooter = __webpack_require__("bzca");

var _WhiteLabelFooter2 = _interopRequireDefault(_WhiteLabelFooter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WhiteLabelFooter = function (_PureComponent) {
    (0, _inherits3.default)(WhiteLabelFooter, _PureComponent);

    function WhiteLabelFooter() {
        (0, _classCallCheck3.default)(this, WhiteLabelFooter);
        return (0, _possibleConstructorReturn3.default)(this, (WhiteLabelFooter.__proto__ || (0, _getPrototypeOf2.default)(WhiteLabelFooter)).apply(this, arguments));
    }

    (0, _createClass3.default)(WhiteLabelFooter, [{
        key: 'render',
        value: function render() {
            var name = this.props.name;


            return (0, _jsx3.default)('div', {
                className: _WhiteLabelFooter2.default.footer
            }, void 0, (0, _jsx3.default)(_Mobile2.default, {}), (0, _jsx3.default)(_Links2.default, {
                name: name
            }));
        }
    }]);
    return WhiteLabelFooter;
}(_react.PureComponent);

exports.default = WhiteLabelFooter;
module.exports = exports['default'];

/***/ }),

/***/ "k+pu":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;

var _urls = __webpack_require__("CakR");

var _browser = __webpack_require__("aN2S");

var _modal = __webpack_require__("u90i");

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propsComparer = __webpack_require__("wsGv");

var _propsComparer2 = _interopRequireDefault(_propsComparer);

var _redux = __webpack_require__("2KeS");

var _reactRedux = __webpack_require__("RH2O");

var _config = __webpack_require__("iS9E");

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouterRedux = __webpack_require__("jZgO");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MOBILE_LIVE_BIDDING_HOUSES = [869, // Acme
989, // SAA
5542, 5775, 6103, 1496, 1331, 3423, 6190, 6100, 5224, 3626, 546, 5782, 5923, 3393, 6030, 6106, 989, 1295, 5291, 4857, 1714];

var CONSOLE_QUERY_PARAMS = 'htoolbar=no,resizable=yes,location=no,status=no,menubar=no,scrollbars=no,height=690,width=980';

var BidConsoleOpener = (_dec = (0, _reactRedux.connect)(function (state) {
    var baseUrl = (0, _config.getBaseUrl)(state);
    var mobile = (0, _browser.isUiMobile)(state);
    var browser = (0, _browser.getUiBrowser)(state);
    return { baseUrl: baseUrl, browser: browser, mobile: mobile };
}, function (dispatch) {
    return (0, _redux.bindActionCreators)({
        openDownloadMobileModal: _modal.openDownloadMobileModal,
        openInstallFlashModal: _modal.openInstallFlashModal,
        push: _reactRouterRedux.push
    }, dispatch);
}), _dec(_class = (_temp2 = _class2 = function (_Component) {
    (0, _inherits3.default)(BidConsoleOpener, _Component);

    function BidConsoleOpener() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, BidConsoleOpener);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = BidConsoleOpener.__proto__ || (0, _getPrototypeOf2.default)(BidConsoleOpener)).call.apply(_ref, [this].concat(args))), _this), _this.openBidConsole = function () {
            var _this$props = _this.props,
                browser = _this$props.browser,
                catalogId = _this$props.catalogId,
                baseUrl = _this$props.baseUrl,
                mobile = _this$props.mobile,
                sellerId = _this$props.sellerId;


            if (mobile) {
                if (MOBILE_LIVE_BIDDING_HOUSES.includes(sellerId)) {
                    _this.props.push({
                        pathname: (0, _urls.getLiveBiddingUrl)(catalogId)
                    });
                } else {
                    _this.props.openDownloadMobileModal();
                }
            } else {
                if (browser.name === 'firefox') {
                    _this.props.openInstallFlashModal();
                }
                window.open((0, _urls.getCatalogConsoleUrl)(baseUrl, catalogId), '/bidapplet' + catalogId, CONSOLE_QUERY_PARAMS);
            }
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(BidConsoleOpener, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps) {
            return (0, _propsComparer2.default)(this.props, nextProps, ['catalogId', 'mobile']);
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.cloneElement(_react.Children.only(this.props.children), {
                onClick: this.openBidConsole
            });
        }
    }]);
    return BidConsoleOpener;
}(_react.Component), _class2.defaultProps = {
    catalogId: 0,
    children: '',
    mobile: ''
}, _temp2)) || _class);
exports.default = BidConsoleOpener;
module.exports = exports['default'];

/***/ }),

/***/ "k57w":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = __webpack_require__("dcb+");

var _jsx3 = _interopRequireDefault(_jsx2);

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Polyfill for webpack, just in case
if (false) require.ensure = function (d, c) {
    c(require);
};

var CompleteAccountModalLoader = function (_Component) {
    (0, _inherits3.default)(CompleteAccountModalLoader, _Component);

    function CompleteAccountModalLoader(props, context) {
        (0, _classCallCheck3.default)(this, CompleteAccountModalLoader);

        var _this = (0, _possibleConstructorReturn3.default)(this, (CompleteAccountModalLoader.__proto__ || (0, _getPrototypeOf2.default)(CompleteAccountModalLoader)).call(this, props, context));

        _this.state = {
            Component: null,
            mounted: false
        };
        return _this;
    }

    (0, _createClass3.default)(CompleteAccountModalLoader, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            var _this2 = this;

            return new _promise2.default(function (resolve) {
                __webpack_require__.e/* require.ensure */(32).then((function () {
                    resolve(__webpack_require__("J9MJ"));
                }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            }).then(function (container) {
                _this2.setState({ Component: container });
            });
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.setState({ mounted: true });
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.setState({ mounted: false });
        }
    }, {
        key: 'render',
        value: function render() {
            var _state = this.state,
                Component = _state.Component,
                mounted = _state.mounted;

            return mounted && Component !== null ? (0, _jsx3.default)(Component, {}) : null;
        }
    }]);
    return CompleteAccountModalLoader;
}(_react.Component);

exports.default = CompleteAccountModalLoader;
module.exports = exports['default'];

/***/ }),

/***/ "kA98":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _emailList = __webpack_require__("Ukn/");

var EmailList = {
    fetchEmailLists: _emailList.EmailListRemote.fetchEmailLists,
    postSubscribeToEmailList: _emailList.EmailListRemote.postSubscribeToEmailList,
    postUnsubscribeFromEmailList: _emailList.EmailListRemote.postUnsubscribeFromEmailList
};

exports.default = EmailList;
module.exports = exports['default'];

/***/ }),

/***/ "kIRm":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _sellerCatalogs = __webpack_require__("rdp+");

var SellerCatalogs = {
    fetchSellerEndedCatalogsById: _sellerCatalogs.SellerCatalogsRemote.fetchSellerEndedCatalogsById,
    fetchSellerUpcomingCatalogsById: _sellerCatalogs.SellerCatalogsRemote.fetchSellerUpcomingCatalogsById
};

exports.default = SellerCatalogs;
module.exports = exports['default'];

/***/ }),

/***/ "kRHc":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = 10; // in milliseconds

module.exports = exports["default"];

/***/ }),

/***/ "kcnD":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.submitConsignment = exports.getSubmitConsignment = exports.SUBMIT_CONSIGNMENT_SUCCESS = exports.SUBMIT_CONSIGNMENT_REQUEST = exports.SUBMIT_CONSIGNMENT_FAIL = undefined;

var _regenerator = __webpack_require__("Xxa5");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__("exGp");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;

var _user = __webpack_require__("CFLi");

var _api = __webpack_require__("zFQO");

var _reselect = __webpack_require__("bndy");

var _config = __webpack_require__("iS9E");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Action Types */
var SUBMIT_CONSIGNMENT_FAIL = exports.SUBMIT_CONSIGNMENT_FAIL = 'la/user/consignment/FAIL';
var SUBMIT_CONSIGNMENT_REQUEST = exports.SUBMIT_CONSIGNMENT_REQUEST = 'la/user/consignment/REQUEST';
var SUBMIT_CONSIGNMENT_SUCCESS = exports.SUBMIT_CONSIGNMENT_SUCCESS = 'la/user/consignment/SUCCESS';

// reducer
var DEFAULT_STATE = {
    error: false,
    submitted: false,
    success: false
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        case SUBMIT_CONSIGNMENT_REQUEST:
            return (0, _extends3.default)({}, state, {
                error: false,
                submitted: true,
                success: false
            });

        case SUBMIT_CONSIGNMENT_SUCCESS:
            return (0, _extends3.default)({}, state, {
                submitted: false,
                success: true
            });

        case SUBMIT_CONSIGNMENT_FAIL:
            return (0, _extends3.default)({}, state, {
                error: true,
                errorMessage: action.payload,
                submitted: false,
                success: false
            });

        default:
            return state;
    }
}

var submitConsignmentSelector = function submitConsignmentSelector(state) {
    return state.ui.consignment;
};

var getSubmitConsignment = exports.getSubmitConsignment = (0, _reselect.createSelector)(submitConsignmentSelector, function (consignment) {
    return consignment;
});

/* ACTION CREATORS */
var submitConsignment = exports.submitConsignment = function submitConsignment(form, file) {
    return function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch, getState) {
            var state, authToken, deployment, userData;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.prev = 0;
                            state = getState();
                            authToken = (0, _user.getAuthToken)(state);
                            deployment = (0, _config.getDeployment)(state);
                            userData = (0, _user.getUserData)(state);

                            dispatch({
                                type: SUBMIT_CONSIGNMENT_REQUEST
                            });
                            _context.next = 8;
                            return _api.Consignment.postConsignment({ authToken: authToken, deployment: deployment, file: file, form: form, userData: userData });

                        case 8:
                            dispatch({
                                payload: form,
                                type: SUBMIT_CONSIGNMENT_SUCCESS
                            });
                            _context.next = 14;
                            break;

                        case 11:
                            _context.prev = 11;
                            _context.t0 = _context['catch'](0);

                            dispatch({
                                error: true,
                                payload: _context.t0,
                                type: SUBMIT_CONSIGNMENT_FAIL
                            });

                        case 14:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, undefined, [[0, 11]]);
        }));

        return function (_x3, _x4) {
            return _ref.apply(this, arguments);
        };
    }();
};

/***/ }),

/***/ "kqxN":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = __webpack_require__("dcb+");

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _reactFontawesome = __webpack_require__("f7W8");

var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);

var _reactIntl = __webpack_require__("Pq8k");

var _components = __webpack_require__("bGai");

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _BannerOutdatedBrowser = __webpack_require__("ibbh");

var _BannerOutdatedBrowser2 = _interopRequireDefault(_BannerOutdatedBrowser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BannerOutdatedBrowser = function (_PureComponent) {
    (0, _inherits3.default)(BannerOutdatedBrowser, _PureComponent);

    function BannerOutdatedBrowser() {
        (0, _classCallCheck3.default)(this, BannerOutdatedBrowser);
        return (0, _possibleConstructorReturn3.default)(this, (BannerOutdatedBrowser.__proto__ || (0, _getPrototypeOf2.default)(BannerOutdatedBrowser)).apply(this, arguments));
    }

    (0, _createClass3.default)(BannerOutdatedBrowser, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                name = _props.name,
                majorVersion = _props.majorVersion;


            var formalName = (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: name
            });
            var chrome = (0, _jsx3.default)(_components.Link, {
                to: 'https://www.google.com/chrome/browser/desktop/',
                target: '_blank',
                rel: 'noopener'
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'chrome'
            }));
            var firefox = (0, _jsx3.default)(_components.Link, {
                to: 'https://www.mozilla.org/en-US/firefox/new/',
                target: '_blank',
                rel: 'noopener'
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'firefox'
            }));
            var edge = (0, _jsx3.default)(_components.Link, {
                to: 'https://www.microsoft.com/en-us/windows/microsoft-edge',
                target: '_blank',
                rel: 'noopener'
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'edge'
            }));
            var safari = (0, _jsx3.default)(_components.Link, {
                to: 'https://support.apple.com/downloads/safari',
                target: '_blank',
                rel: 'noopener'
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'safari'
            }));

            return (0, _jsx3.default)('div', {
                className: _BannerOutdatedBrowser2.default['la-notification-bar']
            }, void 0, (0, _jsx3.default)('div', {
                className: _BannerOutdatedBrowser2.default['notification-message']
            }, void 0, (0, _jsx3.default)('div', {
                className: _BannerOutdatedBrowser2.default['message-status']
            }, void 0, (0, _jsx3.default)(_reactFontawesome2.default, {
                className: _BannerOutdatedBrowser2.default.icon,
                icon: ['fas', 'exclamation-circle']
            })), (0, _jsx3.default)('div', {
                className: _BannerOutdatedBrowser2.default['message-body']
            }, void 0, (0, _jsx3.default)('span', {
                className: _BannerOutdatedBrowser2.default['message-headline']
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'did_you_know_that_your_web_browser',
                values: { formalName: formalName, majorVersion: majorVersion }
            })), (0, _jsx3.default)('div', {}, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'browsers_for_best_experience',
                values: { chrome: chrome, edge: edge, firefox: firefox, safari: safari }
            })))));
        }
    }]);
    return BannerOutdatedBrowser;
}(_react.PureComponent);

exports.default = BannerOutdatedBrowser;
module.exports = exports['default'];

/***/ }),

/***/ "lArx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"icon":"icon___tNY7e"};

/***/ }),

/***/ "lHUE":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = __webpack_require__("dcb+");

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__("RH2O");

var _analytics = __webpack_require__("yxCd");

var _user = __webpack_require__("CFLi");

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DeskPopup = (_dec = (0, _reactRedux.connect)(function (state) {
    return {
        fullStorySessionUrl: (0, _analytics.getFullStorySessionUrl)(state),
        userData: (0, _user.getUserData)(state)
    };
}), _dec(_class = function (_PureComponent) {
    (0, _inherits3.default)(DeskPopup, _PureComponent);

    function DeskPopup() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, DeskPopup);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = DeskPopup.__proto__ || (0, _getPrototypeOf2.default)(DeskPopup)).call.apply(_ref, [this].concat(args))), _this), _this.formLinkClick = function () {
            var _this$props = _this.props,
                fullStorySessionUrl = _this$props.fullStorySessionUrl,
                userData = _this$props.userData;
            var email = userData.email,
                firstName = userData.firstName,
                lastName = userData.lastName;

            var emailToUse = email || '';
            var nameToUse = firstName || lastName ? (firstName + ' ' + lastName).trim() : '';

            var fields = [];
            nameToUse && fields.push('interaction[name]=' + encodeURIComponent(nameToUse));
            emailToUse && fields.push('interaction[email]=' + emailToUse);
            fields.push('email[subject]=' + encodeURIComponent('Website Feedback'));
            fields.push('ticket[labels_new]=' + encodeURIComponent('Qualaroo Feedback'));
            fullStorySessionUrl && fields.push('ticket[custom_fullstory]=' + encodeURIComponent(fullStorySessionUrl));

            var url = 'https://liveauctioneers.desk.com/customer/widget/emails/new' + (fields.length ? '?' + fields.join('&') : '');

            document.getElementsByTagName('body')[0].classList.add('body-modal-open');
            document.getElementById('desk-form').src = url;
            document.getElementById('desk-form-overlay').style.display = 'block';
            document.getElementById('desk-form-container').style.display = 'block';
            document.getElementById('desk-form-link-container').style.display = 'none';
            return false;
        }, _this.formCloseClick = function () {
            document.getElementsByTagName('body')[0].classList.remove('body-modal-open');
            document.getElementById('desk-form').src = '';
            document.getElementById('desk-form-overlay').style.display = 'none';
            document.getElementById('desk-form-container').style.display = 'none';
            document.getElementById('desk-form-link-container').style.display = 'block';
            return false;
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(DeskPopup, [{
        key: 'render',
        value: function render() {
            return (0, _jsx3.default)(_react.Fragment, {}, void 0, (0, _jsx3.default)('div', {
                className: 'form-overlay',
                id: 'desk-form-overlay'
            }), (0, _jsx3.default)('div', {
                className: 'form-container',
                id: 'desk-form-container'
            }, void 0, (0, _jsx3.default)('a', {
                className: 'form-close',
                href: '#',
                onClick: this.formCloseClick
            }, void 0, '\xD7'), (0, _jsx3.default)('iframe', {
                className: 'form',
                frameBorder: '0',
                id: 'desk-form'
            })), (0, _jsx3.default)('div', {
                className: 'form-link-container',
                id: 'desk-form-link-container'
            }, void 0, (0, _jsx3.default)('a', {
                className: 'form-link',
                href: '#',
                onClick: this.formLinkClick
            }, void 0, 'Feedback')));
        }
    }]);
    return DeskPopup;
}(_react.PureComponent)) || _class);
exports.default = DeskPopup;
module.exports = exports['default'];

/***/ }),

/***/ "lSbF":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _item = __webpack_require__("Agmk");

var _item2 = __webpack_require__("B1jV");

var Item = {
    fetchItemsByIds: function fetchItemsByIds(params) {
        return  false ? _item.ItemMock.fetchItemsByIds(params) : _item2.ItemRemote.fetchItemsByIds(params);
    },
    fetchItemShippingsByIds: _item2.ItemRemote.fetchItemShippingsByIds,
    fetchListingAgentsByIds: _item2.ItemRemote.fetchListingAgentsByIds
};

exports.default = Item;
module.exports = exports['default'];

/***/ }),

/***/ "lT8R":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx2 = __webpack_require__("dcb+");

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _config = __webpack_require__("iS9E");

var _modal = __webpack_require__("u90i");

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _redux = __webpack_require__("2KeS");

var _reactRedux = __webpack_require__("RH2O");

var _user = __webpack_require__("CFLi");

var _LAFooter = __webpack_require__("Pv7X");

var _LAFooter2 = _interopRequireDefault(_LAFooter);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(state) {
    return {
        baseUrl: (0, _config.getBaseUrl)(state),
        classicBaseUrl: (0, _config.getClassicBaseUrl)(state),
        userData: (0, _user.getUserData)(state)
    };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return (0, _redux.bindActionCreators)({
        openDownloadMobileModal: _modal.openDownloadMobileModal,
        openHealthcheckModal: _modal.openHealthcheckModal
    }, dispatch);
};

var LAFooterContainer = function (_PureComponent) {
    (0, _inherits3.default)(LAFooterContainer, _PureComponent);

    function LAFooterContainer() {
        (0, _classCallCheck3.default)(this, LAFooterContainer);
        return (0, _possibleConstructorReturn3.default)(this, (LAFooterContainer.__proto__ || (0, _getPrototypeOf2.default)(LAFooterContainer)).apply(this, arguments));
    }

    (0, _createClass3.default)(LAFooterContainer, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                baseUrl = _props.baseUrl,
                classicBaseUrl = _props.classicBaseUrl,
                userData = _props.userData;


            return (0, _jsx3.default)(_LAFooter2.default, {
                baseUrl: baseUrl,
                classicBaseUrl: classicBaseUrl,
                openDownloadMobileModal: this.props.openDownloadMobileModal,
                openHealthcheckModal: this.props.openHealthcheckModal,
                userData: userData
            });
        }
    }]);
    return LAFooterContainer;
}(_react.PureComponent);

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(LAFooterContainer);
module.exports = exports['default'];

/***/ }),

/***/ "lXgo":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"active":"active___1uQGe","navLink":"navLink___32eYI"};

/***/ }),

/***/ "lp2g":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.changeImageGalleryActiveIndex = exports.getImageGalleryActiveImage = exports.CHANGE_IMAGE_GALLERY_ACTIVE_INDEX = undefined;

var _defineProperty2 = __webpack_require__("bOdI");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends3 = __webpack_require__("Dd8w");

var _extends4 = _interopRequireDefault(_extends3);

exports.default = reducer;

var _reselect = __webpack_require__("bndy");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Action Types */
var CHANGE_IMAGE_GALLERY_ACTIVE_INDEX = exports.CHANGE_IMAGE_GALLERY_ACTIVE_INDEX = 'CHANGE_IMAGE_GALLERY_ACTIVE_INDEX';

// reducer
var DEFAULT_STATE = {};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        case CHANGE_IMAGE_GALLERY_ACTIVE_INDEX:
            return (0, _extends4.default)({}, state, (0, _defineProperty3.default)({}, action.payload.itemId, action.payload.newIndex));
        default:
            return state;
    }
}

/* SELECTORS */
var stateSelector = function stateSelector(state) {
    return state.ui.imageGalleryActiveImage;
};
var idSelector = function idSelector(state, id) {
    return id;
};

var getImageGalleryActiveImage = exports.getImageGalleryActiveImage = (0, _reselect.createSelector)([stateSelector, idSelector], function (state, id) {
    return state[id] || 0;
});

/* ACTION CREATORS */
var changeImageGalleryActiveIndex = exports.changeImageGalleryActiveIndex = function changeImageGalleryActiveIndex(itemId, newIndex) {
    return {
        payload: { itemId: itemId, newIndex: newIndex },
        type: CHANGE_IMAGE_GALLERY_ACTIVE_INDEX
    };
};

/***/ }),

/***/ "luc6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"modal-overlay":"modal-overlay___35KxM","modal-overlay--after-open":"modal-overlay--after-open___1wKIj","modal-overlay--before-close":"modal-overlay--before-close___3mY1e","modal-content":"modal-content___1Rcx8","modal-content-size":"modal-content-size___1pjXJ","modal-content--after-open":"modal-content--after-open___2M0au","modal-content--before-close":"modal-content--before-close___1N4bk","modal-content-large":"modal-content-large___335NS","modal-content-small":"modal-content-small___2jw6P","modal-header":"modal-header___Wln4M","close":"close___1BzI1","modal-header-default":"modal-header-default___2FSKh","modal-body":"modal-body___1SRyX","modal-body-default":"modal-body-default___1HKRO","modal-footer":"modal-footer___-xP33","modal-right":"modal-right___351NU","modal-leftImage":"modal-leftImage___3VFxT","ReactModal__Body--open":"ReactModal__Body--open____cAS5"};

/***/ }),

/***/ "m1mj":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = __webpack_require__("dcb+");

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propsComparer = __webpack_require__("wsGv");

var _propsComparer2 = _interopRequireDefault(_propsComparer);

var _reactFontawesome = __webpack_require__("f7W8");

var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _StatusBannerMessage = __webpack_require__("doBk");

var _StatusBannerMessage2 = _interopRequireDefault(_StatusBannerMessage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StatusBannerMessage = (_temp = _class = function (_Component) {
    (0, _inherits3.default)(StatusBannerMessage, _Component);

    function StatusBannerMessage() {
        (0, _classCallCheck3.default)(this, StatusBannerMessage);
        return (0, _possibleConstructorReturn3.default)(this, (StatusBannerMessage.__proto__ || (0, _getPrototypeOf2.default)(StatusBannerMessage)).apply(this, arguments));
    }

    (0, _createClass3.default)(StatusBannerMessage, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps) {
            return (0, _propsComparer2.default)(this.props, nextProps, ['alert', 'header', 'iconName', 'message']);
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                alert = _props.alert,
                header = _props.header,
                iconName = _props.iconName,
                message = _props.message;

            var iconClasses = alert ? _StatusBannerMessage2.default.icon + ' ' + _StatusBannerMessage2.default.alert : _StatusBannerMessage2.default.icon;
            var messageClasses = alert ? _StatusBannerMessage2.default.message + ' ' + _StatusBannerMessage2.default.alert : _StatusBannerMessage2.default.message;

            return (0, _jsx3.default)('div', {
                className: _StatusBannerMessage2.default['status-banner-message']
            }, void 0, (0, _jsx3.default)(_reactFontawesome2.default, {
                icon: iconName,
                className: iconClasses
            }), (0, _jsx3.default)('div', {
                className: messageClasses
            }, void 0, (0, _jsx3.default)('span', {
                className: _StatusBannerMessage2.default.header
            }, void 0, header), (0, _jsx3.default)('span', {
                className: _StatusBannerMessage2.default.body
            }, void 0, message)));
        }
    }]);
    return StatusBannerMessage;
}(_react.Component), _class.defaultProps = {
    alert: false,
    message: ''
}, _temp);
exports.default = StatusBannerMessage;
module.exports = exports['default'];

/***/ }),

/***/ "m9FA":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fetchItemBiddingIfNeeded = exports.fetchCatalogBiddingIfNeeded = exports.getMyBidItemIds = exports.getBiddingInfos = exports.getBiddingInfo = exports.LOAD_CATALOG_BIDDING_SUCCESS = exports.LOAD_CATALOG_BIDDING_REQUEST = exports.LOAD_CATALOG_BIDDING_FAIL = exports.LOAD_ITEM_BIDDING_SUCCESS = exports.LOAD_ITEM_BIDDING_REQUEST = exports.LOAD_ITEM_BIDDING_FAIL = undefined;

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _regenerator = __webpack_require__("Xxa5");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__("exGp");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _defineProperty2 = __webpack_require__("bOdI");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _keys = __webpack_require__("fZjL");

var _keys2 = _interopRequireDefault(_keys);

var _extends4 = __webpack_require__("Dd8w");

var _extends5 = _interopRequireDefault(_extends4);

exports.default = reducer;

var _user = __webpack_require__("CFLi");

var _absenteeBid = __webpack_require__("5Fhj");

var _api = __webpack_require__("zFQO");

var _cloneDeep = __webpack_require__("kvU2");

var _cloneDeep2 = _interopRequireDefault(_cloneDeep);

var _reselect = __webpack_require__("bndy");

var _difference = __webpack_require__("WlNK");

var _difference2 = _interopRequireDefault(_difference);

var _config = __webpack_require__("iS9E");

var _home = __webpack_require__("TSUT");

var _item = __webpack_require__("Gk4U");

var _login = __webpack_require__("SpFG");

var _ms = __webpack_require__("EarI");

var _ms2 = _interopRequireDefault(_ms);

var _passwordReset = __webpack_require__("fWpZ");

var _retractBid = __webpack_require__("M0zy");

var _loaded = __webpack_require__("N5um");

var _union = __webpack_require__("gszD");

var _union2 = _interopRequireDefault(_union);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Action Types */
var LOAD_ITEM_BIDDING_FAIL = exports.LOAD_ITEM_BIDDING_FAIL = 'la/domain/itemBidding/LOAD_FAIL';
var LOAD_ITEM_BIDDING_REQUEST = exports.LOAD_ITEM_BIDDING_REQUEST = 'la/domain/itemBidding/LOAD_REQUEST';
var LOAD_ITEM_BIDDING_SUCCESS = exports.LOAD_ITEM_BIDDING_SUCCESS = 'la/domain/itemBidding/LOAD_SUCCESS';

var LOAD_CATALOG_BIDDING_FAIL = exports.LOAD_CATALOG_BIDDING_FAIL = 'la/domain/catalogBidding/LOAD_FAIL';
var LOAD_CATALOG_BIDDING_REQUEST = exports.LOAD_CATALOG_BIDDING_REQUEST = 'la/domain/catalogBidding/LOAD_REQUEST';
var LOAD_CATALOG_BIDDING_SUCCESS = exports.LOAD_CATALOG_BIDDING_SUCCESS = 'la/domain/catalogBidding/LOAD_SUCCESS';

var REDUX_STORE_TIME_ITEM = (0, _ms2.default)('20s');

// reducer
var DEFAULT_STATE = {
    byId: {},
    loaded: {},
    loading: []
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var existing = void 0;
    var loaded = void 0;
    var loading = void 0;
    var time = void 0;

    switch (action.type) {
        case LOAD_ITEM_BIDDING_FAIL:
            return (0, _extends5.default)({}, state, {
                loading: (0, _difference2.default)(state.loading, [action.meta.itemId])
            });
        case LOAD_ITEM_BIDDING_REQUEST:
            return (0, _extends5.default)({}, state, {
                loading: (0, _union2.default)(state.loading, [action.payload])
            });
        case LOAD_ITEM_BIDDING_SUCCESS:
        case LOAD_CATALOG_BIDDING_SUCCESS:
            existing = (0, _cloneDeep2.default)(state.byId);
            loaded = (0, _extends5.default)({}, state.loaded);
            loading = (0, _cloneDeep2.default)(state.loading);
            time = action.meta.actionTime;

            action.payload.forEach(function (item) {
                existing[item.itemId] = (0, _extends5.default)({}, item);
                loaded[item.itemId] = time;
                loading = (0, _difference2.default)(loading, [item.itemId]);
            });
            return (0, _extends5.default)({}, state, {
                byId: existing,
                loaded: loaded,
                loading: loading
            });
        case _user.LOAD_BIDDER_DATA_SUCCESS:
        case _home.LOAD_HOME_DATA_SUCCESS:
        case _item.LOAD_ITEMS_SUCCESS:
        case _login.LOGIN_SUCCESS:
        case _passwordReset.PASSWORD_RESET_SUCCESS:
            existing = (0, _cloneDeep2.default)(state.byId);
            loaded = (0, _extends5.default)({}, state.loaded);
            loading = (0, _cloneDeep2.default)(state.loading);
            time = action.meta.actionTime;

            if (action.payload.biddingInfos) {
                action.payload.biddingInfos.forEach(function (item) {
                    existing[item.itemId] = (0, _extends5.default)({}, item);
                    loaded[item.itemId] = time;
                    loading = (0, _difference2.default)(loading, [item.itemId]);
                });
            }
            return (0, _extends5.default)({}, state, {
                byId: existing,
                loaded: loaded,
                loading: loading
            });
        case _user.LOG_OUT_BIDDER:
            existing = (0, _cloneDeep2.default)(state.byId);
            (0, _keys2.default)(existing).forEach(function (key) {
                var item = existing[key];
                item.bidderHasBid = false;
                item.bidderHasHighBid = false;
                item.bidderMaxBid = 0;
            });
            return (0, _extends5.default)({}, state, {
                byId: existing
            });
        case _absenteeBid.ABSENTEE_BID_SUCCESS:
            var itemId = action.meta.itemId;
            var _action$payload = action.payload,
                isReserveMet = _action$payload.isReserveMet,
                leadingBid = _action$payload.leadingBid;

            var newBidInfo = (0, _cloneDeep2.default)(state.byId[itemId]);
            newBidInfo.bidActivityCount = newBidInfo.bidActivityCount + 1;
            newBidInfo.bidderBidTimestamp = action.meta.actionTime;
            newBidInfo.bidderHasBid = true;
            newBidInfo.bidderHasHighBid = action.payload.isCurrentHighBid;
            newBidInfo.bidderMaxBid = Number(action.payload.currentBid);
            newBidInfo.leadingBid = leadingBid;
            newBidInfo.isReserveMet = isReserveMet;
            return (0, _extends5.default)({}, state, {
                byId: (0, _extends5.default)({}, state.byId, (0, _defineProperty3.default)({}, itemId, newBidInfo))
            });
        case _retractBid.RETRACT_BID_SUCCESS:
            var retractedItemId = action.payload;

            existing = (0, _cloneDeep2.default)(state.byId[retractedItemId]);
            existing.bidderHasBid = false;
            existing.bidderHasHighBid = false;
            existing.bidderMaxBid = 0;
            return (0, _extends5.default)({}, state, {
                byId: (0, _extends5.default)({}, state.byId, (0, _defineProperty3.default)({}, retractedItemId, existing))
            });
        default:
            return state;
    }
}

/* SELECTORS */
var stateSelector = function stateSelector(state) {
    return state.domain.biddingInfo;
};
var globalStateSelector = function globalStateSelector(state) {
    return state;
};
var idSelector = function idSelector(state, id) {
    return id;
};

var byIdSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.byId;
});

var loadedSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.loaded;
});

var loadingSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.loading;
});

var getBiddingInfo = exports.getBiddingInfo = (0, _reselect.createSelector)([byIdSelector, idSelector], function (byId, id) {
    return byId[id] || {
        bidActivityCount: 0,
        bidCount: 0,
        bidderBidTimestamp: 0,
        bidderHasBid: false,
        bidderHasHighBid: false,
        bidderMaxBid: 0,
        isReserveMet: false,
        itemId: id,
        leadingBid: 0
    };
});

var getLoadTimeForItemBidding = (0, _reselect.createSelector)([loadedSelector, idSelector], function (loaded, id) {
    return loaded[id] || 0;
});

var isItemBiddingLoading = (0, _reselect.createSelector)([loadingSelector, idSelector], function (loading, id) {
    return loading.includes(id);
});

var getBiddingInfos = exports.getBiddingInfos = (0, _reselect.createSelector)([globalStateSelector, idSelector], function (state, itemIds) {
    return itemIds.map(function (id) {
        return getBiddingInfo(state, id);
    });
});

var shouldFetchBiddingInfoForItem = (0, _reselect.createSelector)([idSelector, getLoadTimeForItemBidding, isItemBiddingLoading], function (itemId, loaded, loading) {
    if (!itemId) return false;
    var time = Date.now();
    var diff = time - loaded;
    if (diff < REDUX_STORE_TIME_ITEM) return false;
    return !loading;
});

var getMyBidItemIds = exports.getMyBidItemIds = (0, _reselect.createSelector)(byIdSelector, function (byId) {
    return (0, _keys2.default)(byId).map(function (key) {
        return byId[key];
    }).filter(function (item) {
        return item.bidderHasBid;
    }).map(function (item) {
        return item.itemId;
    });
});

/* ACTION CREATORS */
var fetchIfNeeded = function () {
    var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(_ref2) {
        var catalogId = _ref2.catalogId,
            dispatch = _ref2.dispatch,
            getState = _ref2.getState;
        var state, authToken, deployment, response;
        return _regenerator2.default.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        state = getState();

                        if (!(0, _loaded.shouldFetchBiddingInfoForCatalog)(state, catalogId)) {
                            _context.next = 15;
                            break;
                        }

                        _context.prev = 2;
                        authToken = (0, _user.getAuthToken)(state);
                        deployment = (0, _config.getDeployment)(state);

                        dispatch({
                            meta: { actionTime: Date.now() },
                            payload: catalogId,
                            type: LOAD_CATALOG_BIDDING_REQUEST
                        });
                        _context.next = 8;
                        return _api.BiddingInfo.fetchCatalogBidding({ authToken: authToken, catalogId: catalogId, deployment: deployment });

                    case 8:
                        response = _context.sent;

                        dispatch({
                            meta: { actionTime: Date.now(), catalogId: catalogId },
                            payload: response.data,
                            type: LOAD_CATALOG_BIDDING_SUCCESS
                        });
                        _context.next = 15;
                        break;

                    case 12:
                        _context.prev = 12;
                        _context.t0 = _context['catch'](2);

                        dispatch({
                            error: true,
                            meta: { catalogId: catalogId },
                            payload: _context.t0,
                            type: LOAD_CATALOG_BIDDING_FAIL
                        });

                    case 15:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, undefined, [[2, 12]]);
    }));

    return function fetchIfNeeded(_x3) {
        return _ref.apply(this, arguments);
    };
}();

var fetchCatalogBiddingIfNeeded = exports.fetchCatalogBiddingIfNeeded = function fetchCatalogBiddingIfNeeded(catalogId) {
    return function (dispatch, getState) {
        return Array.isArray(catalogId) ? _promise2.default.all(catalogId.map(function (id) {
            return fetchIfNeeded({ catalogId: id, dispatch: dispatch, getState: getState });
        })) : fetchIfNeeded({ catalogId: catalogId, dispatch: dispatch, getState: getState });
    };
};

var fetchItemBiddingIfNeeded = exports.fetchItemBiddingIfNeeded = function fetchItemBiddingIfNeeded(itemId) {
    return function () {
        var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(dispatch, getState) {
            var state, authToken, deployment, response;
            return _regenerator2.default.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            state = getState();

                            if (!shouldFetchBiddingInfoForItem(state, itemId)) {
                                _context2.next = 17;
                                break;
                            }

                            _context2.prev = 2;
                            authToken = (0, _user.getAuthToken)(state);
                            deployment = (0, _config.getDeployment)(state);

                            dispatch({
                                meta: { actionTime: Date.now() },
                                payload: itemId,
                                type: LOAD_ITEM_BIDDING_REQUEST
                            });
                            _context2.next = 8;
                            return _api.BiddingInfo.fetchItemBidding({ authToken: authToken, deployment: deployment, itemId: itemId });

                        case 8:
                            response = _context2.sent;

                            dispatch({
                                meta: { actionTime: Date.now(), itemId: itemId },
                                payload: response.data,
                                type: LOAD_ITEM_BIDDING_SUCCESS
                            });
                            _context2.next = 15;
                            break;

                        case 12:
                            _context2.prev = 12;
                            _context2.t0 = _context2['catch'](2);

                            dispatch({
                                error: true,
                                meta: { itemId: itemId },
                                payload: _context2.t0,
                                type: LOAD_ITEM_BIDDING_FAIL
                            });

                        case 15:
                            _context2.next = 18;
                            break;

                        case 17:
                            return _context2.abrupt('return', _promise2.default.resolve({}));

                        case 18:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, undefined, [[2, 12]]);
        }));

        return function (_x4, _x5) {
            return _ref3.apply(this, arguments);
        };
    }();
};

/***/ }),

/***/ "mHb4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"auctioneer-info":"auctioneer-info___rZQcY","details":"details___1bsrg","flag-name":"flag-name___2wGUI","flag":"flag___2nZyX","name":"name___pJ4S8","question":"question___2lwzS","seller-info-pipe":"seller-info-pipe___ZP2JO","image-container":"image-container___1MveE","image":"image___13AbE"};

/***/ }),

/***/ "mZDp":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _class;

var _set2 = __webpack_require__("4yG7");

var _set3 = _interopRequireDefault(_set2);

var _propsComparer = __webpack_require__("wsGv");

var _propsComparer2 = _interopRequireDefault(_propsComparer);

var _react = __webpack_require__("GiK3");

var _reactRedux = __webpack_require__("RH2O");

var _user = __webpack_require__("CFLi");

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SoastaGlobalSetter = (_dec = (0, _reactRedux.connect)(function (state) {
    var userData = (0, _user.getUserData)(state) || {};
    return (0, _extends3.default)({
        ANMS: 0,
        bidderId: 0
    }, userData);
}), _dec(_class = function (_Component) {
    (0, _inherits3.default)(SoastaGlobalSetter, _Component);

    function SoastaGlobalSetter() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, SoastaGlobalSetter);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SoastaGlobalSetter.__proto__ || (0, _getPrototypeOf2.default)(SoastaGlobalSetter)).call.apply(_ref, [this].concat(args))), _this), _this.setSoasta = function (props) {
            if (typeof window !== 'undefined') {
                // SSR doesn't use window
                var ANMS = props.ANMS,
                    bidderId = props.bidderId;

                var highANMS = ANMS > 4500 ? 1 : 0;
                (0, _set3.default)(window, 'soasta.user', { ANMS: ANMS, bidderId: bidderId, highANMS: highANMS });
                (0, _set3.default)(window, 'BOOMR.xhr_excludes', {
                    'api.sail-track.com': true,
                    'api.segment.com': true,
                    'c.go-mpulse.net': true,
                    'c.riskified.com': true,
                    'doubleclick.net': true,
                    'r.fullstory.com': true,
                    'sumo.com': true,
                    'www.youtube.com': true
                });
            }
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(SoastaGlobalSetter, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.setSoasta(this.props);
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            this.setSoasta(nextProps);
        }
    }, {
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps) {
            return (0, _propsComparer2.default)(this.props, nextProps, ['ANMS', 'bidderId']);
        }
    }, {
        key: 'render',
        value: function render() {
            return null;
        }
    }]);
    return SoastaGlobalSetter;
}(_react.Component)) || _class);
exports.default = SoastaGlobalSetter;
module.exports = exports['default'];

/***/ }),

/***/ "n0xG":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = __webpack_require__("dcb+");

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__("Pq8k");

var _components = __webpack_require__("bGai");

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Links = __webpack_require__("UuWU");

var _Links2 = _interopRequireDefault(_Links);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var year = new Date().getFullYear();

var Links = function (_PureComponent) {
    (0, _inherits3.default)(Links, _PureComponent);

    function Links() {
        (0, _classCallCheck3.default)(this, Links);
        return (0, _possibleConstructorReturn3.default)(this, (Links.__proto__ || (0, _getPrototypeOf2.default)(Links)).apply(this, arguments));
    }

    (0, _createClass3.default)(Links, [{
        key: 'render',
        value: function render() {
            var name = this.props.name;


            return (0, _jsx3.default)('div', {
                className: _Links2.default.links
            }, void 0, (0, _jsx3.default)('div', {
                className: _Links2.default.linksInner
            }, void 0, (0, _jsx3.default)('div', {
                className: _Links2.default.linksUpper
            }, void 0, (0, _jsx3.default)('span', {
                className: _Links2.default.name
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'powered_by',
                values: {
                    name: name,
                    onlineAuctions: (0, _jsx3.default)(_components.Link, {
                        className: _Links2.default.blackLink,
                        to: 'https://www.liveauctioneers.com'
                    }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                        id: 'onlineAuctions'
                    }))
                }
            })), (0, _jsx3.default)(_components.Link, {
                to: 'https://www.liveauctioneers.com/'
            }, void 0, (0, _jsx3.default)('img', {
                src: 'https://p1.liveauctioneers.com/dist/images/logo.svg',
                alt: 'liveauctioneers'
            }))), (0, _jsx3.default)('div', {
                className: _Links2.default.linksLower
            }, void 0, (0, _jsx3.default)('span', {
                className: _Links2.default.copyright
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'copyright_whitelabel',
                values: {
                    privacy: (0, _jsx3.default)(_components.Link, {
                        route: true,
                        to: '/privacy'
                    }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                        id: 'privacy'
                    })),
                    terms: (0, _jsx3.default)(_components.Link, {
                        route: true,
                        to: '/termsandconditions'
                    }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                        id: 'terms'
                    })),
                    year: year
                }
            })))));
        }
    }]);
    return Links;
}(_react.PureComponent);

exports.default = Links;
module.exports = exports['default'];

/***/ }),

/***/ "nQXN":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.submitIsSavedSearchCheck = exports.getSavedSearchId = exports.getSaveSearchCheckState = exports.SAVE_SEARCH_CHECK_SUCCESS = exports.SAVE_SEARCH_CHECK_REQUEST = exports.SAVE_SEARCH_CHECK_FAIL = undefined;

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;

var _api = __webpack_require__("zFQO");

var _user = __webpack_require__("CFLi");

var _config = __webpack_require__("iS9E");

var _ItemPageUtils = __webpack_require__("VWZ9");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Action Types */
var SAVE_SEARCH_CHECK_FAIL = exports.SAVE_SEARCH_CHECK_FAIL = 'la/ui/saveSearchCheck/FAIL';
var SAVE_SEARCH_CHECK_REQUEST = exports.SAVE_SEARCH_CHECK_REQUEST = 'la/ui/saveSearchCheck/REQUEST';
var SAVE_SEARCH_CHECK_SUCCESS = exports.SAVE_SEARCH_CHECK_SUCCESS = 'la/ui/saveSearchCheck/SUCCESS';

// reducer
var DEFAULT_STATE = {
    error: false,
    isSavedSearch: false,
    savedSearchId: 0,
    success: false
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        case SAVE_SEARCH_CHECK_FAIL:
            return (0, _extends3.default)({}, state, {
                error: true,
                isSavedSearch: false,
                savedSearchId: 0,
                success: false
            });
        case SAVE_SEARCH_CHECK_REQUEST:
            return (0, _extends3.default)({}, state, {
                success: false
            });
        case SAVE_SEARCH_CHECK_SUCCESS:
            var savedSearchId = action.payload ? action.payload.savedSearchId : 0;
            var isSavedSearch = savedSearchId > 0;
            return (0, _extends3.default)({}, state, {
                isSavedSearch: isSavedSearch,
                savedSearchId: savedSearchId,
                success: true
            });
        default:
            return state;
    }
}

/* SELECTORS */
var getSaveSearchCheckState = exports.getSaveSearchCheckState = function getSaveSearchCheckState(state) {
    return state.ui.saveSearchCheck;
};

var getSavedSearchId = exports.getSavedSearchId = function getSavedSearchId(state) {
    return state.ui.saveSearchCheck.savedSearchId;
};

/* ACTION CREATORS */
var submitIsSavedSearchCheck = exports.submitIsSavedSearchCheck = function submitIsSavedSearchCheck(searchParams, itemPageFacets) {
    return function (dispatch, getState) {
        if (itemPageFacets) {
            searchParams = (0, _ItemPageUtils.getItemSavedSearchQuery)(itemPageFacets);

            if (!searchParams.category_id) {
                return new _promise2.default(function (resolve) {
                    resolve(dispatch({
                        type: SAVE_SEARCH_CHECK_SUCCESS
                    }));
                });
            }
        }
        var state = getState();
        var authToken = (0, _user.getAuthToken)(state);
        var deployment = (0, _config.getDeployment)(state);
        dispatch({
            type: SAVE_SEARCH_CHECK_REQUEST
        });
        return _api.SaveSearch.postIsSavedSearch({ authToken: authToken, deployment: deployment, searchParams: searchParams }).then(function (response) {
            dispatch({
                payload: response,
                type: SAVE_SEARCH_CHECK_SUCCESS
            });
        }).catch(function () {
            dispatch({
                type: SAVE_SEARCH_CHECK_FAIL
            });
        });
    };
};

/***/ }),

/***/ "nUI6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.LostItems = undefined;

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _helpers = __webpack_require__("SY39");

var _wonLostCatalogsTransform = __webpack_require__("wTTR");

var _wonLostCatalogsTransform2 = _interopRequireDefault(_wonLostCatalogsTransform);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LostItems = exports.LostItems = {
    fetchLostItems: function fetchLostItems(_ref) {
        var authToken = _ref.authToken,
            bidderId = _ref.bidderId,
            catalogId = _ref.catalogId,
            deployment = _ref.deployment,
            _ref$page = _ref.page,
            page = _ref$page === undefined ? 1 : _ref$page,
            _ref$pageSize = _ref.pageSize,
            pageSize = _ref$pageSize === undefined ? 1250 : _ref$pageSize;

        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makeGet)('<MAINHOST-API>api/bidders/' + bidderId + '/lostitems', deployment);
            request.query({ client_version: '5.0', page: page, pagesize: pageSize });
            (0, _helpers.addAuthToken)(request, authToken);
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response, transform: _wonLostCatalogsTransform2.default });
            });
        });
    }
};

/***/ }),

/***/ "nmQq":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.generateDiscoverLinks = undefined;

var _isEqual = __webpack_require__("hygk");

var _isEqual2 = _interopRequireDefault(_isEqual);

var _uniqWith = __webpack_require__("ohRb");

var _uniqWith2 = _interopRequireDefault(_uniqWith);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var generateDiscoverLinks = exports.generateDiscoverLinks = function generateDiscoverLinks(facets, createCategoryLandingLink) {
    var discoverItems = [];
    var shouldCreateMat = true;
    var shouldCreateCreator = true;

    if (facets && facets.categories && facets.categories.length > 0 && facets.creators) {
        facets.creators.some(function (creator, index) {
            discoverItems.push(createCategoryLandingLink(facets.categories[0], creator));
            return index === 1;
        });

        shouldCreateCreator = false;
    }

    if (facets && facets.creators && facets.creators.length > 0 && shouldCreateCreator) {
        discoverItems.push(createCategoryLandingLink(facets.creators[0]));
    }

    if (facets && facets.materialsTechniques && facets.categories && facets.categories.length > 0) {
        facets.materialsTechniques.some(function (materialsTechniques, index) {
            discoverItems.push(createCategoryLandingLink(facets.categories[0], materialsTechniques));
            return index === 1;
        });

        shouldCreateMat = false;
    }

    if (facets && facets.materialsTechniques && facets.materialsTechniques.length > 0 && shouldCreateMat) {
        discoverItems.push(createCategoryLandingLink(facets.materialsTechniques[0]));
    }
    if (facets && facets.categories && facets.categories.length > 0) {
        discoverItems.push(createCategoryLandingLink(facets.categories[0]));
    }
    if (facets && facets.stylePeriods && facets.stylePeriods.length > 0) {
        discoverItems.push(createCategoryLandingLink(facets.stylePeriods[0]));
    }
    if (facets && facets.origins && facets.origins.length > 0) {
        discoverItems.push(createCategoryLandingLink(facets.origins[0]));
    }

    return (0, _uniqWith2.default)(discoverItems, _isEqual2.default);
};

/***/ }),

/***/ "o2ZH":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var shouldShowLive = exports.shouldShowLive = function shouldShowLive(catalogStatus, isCatalogOnly, saleStartTs) {
    var now = new Date();
    var secondsUntilStart = saleStartTs - now.getTime() / 1000;
    return !isCatalogOnly && (catalogStatus === 'live' || catalogStatus === 'online' && secondsUntilStart < 60 * 10);
};

/***/ }),

/***/ "oIDo":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fetchSavedItemCountsIfNeeded = exports.isSavedItemCountLoading = exports.getLoadTimeForSavedItemCount = exports.getSavedItemCount = exports.LOAD_SAVED_ITEM_COUNT_SUCCESS = exports.LOAD_SAVED_ITEM_COUNT_REQUEST = exports.LOAD_SAVED_ITEM_COUNT_FAIL = undefined;

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _regenerator = __webpack_require__("Xxa5");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__("exGp");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;

var _api = __webpack_require__("zFQO");

var _cloneDeep = __webpack_require__("kvU2");

var _cloneDeep2 = _interopRequireDefault(_cloneDeep);

var _reselect = __webpack_require__("bndy");

var _difference = __webpack_require__("WlNK");

var _difference2 = _interopRequireDefault(_difference);

var _config = __webpack_require__("iS9E");

var _ms = __webpack_require__("EarI");

var _ms2 = _interopRequireDefault(_ms);

var _union = __webpack_require__("gszD");

var _union2 = _interopRequireDefault(_union);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Action Types */
var LOAD_SAVED_ITEM_COUNT_FAIL = exports.LOAD_SAVED_ITEM_COUNT_FAIL = 'la/domain/savedItemCount/LOAD_FAIL';
var LOAD_SAVED_ITEM_COUNT_REQUEST = exports.LOAD_SAVED_ITEM_COUNT_REQUEST = 'la/domain/savedItemCount/LOAD_REQUEST';
var LOAD_SAVED_ITEM_COUNT_SUCCESS = exports.LOAD_SAVED_ITEM_COUNT_SUCCESS = 'la/domain/savedItemCount/LOAD_SUCCESS';

var REDUX_STORE_TIME = (0, _ms2.default)('30m');

/* reducer */
var DEFAULT_STATE = {
    byId: {},
    loaded: {},
    loading: []
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var existing = void 0;
    var loaded = void 0;
    var loading = void 0;
    var time = void 0;

    switch (action.type) {
        case LOAD_SAVED_ITEM_COUNT_FAIL:
            return (0, _extends3.default)({}, state, {
                loading: (0, _difference2.default)(state.loading, action.meta.itemIds)
            });
        case LOAD_SAVED_ITEM_COUNT_REQUEST:
            return (0, _extends3.default)({}, state, {
                loading: (0, _union2.default)(state.loading, action.payload)
            });
        case LOAD_SAVED_ITEM_COUNT_SUCCESS:
            existing = (0, _cloneDeep2.default)(state.byId);
            loaded = (0, _extends3.default)({}, state.loaded);
            loading = (0, _cloneDeep2.default)(state.loading);
            time = action.meta.actionTime;

            if (action.payload.savedItemCounts) {
                action.payload.savedItemCounts.forEach(function (x) {
                    existing[x.itemId] = (0, _extends3.default)({}, x);
                    loaded[x.itemId] = time;
                    loading = (0, _difference2.default)(loading, [x.itemId]);
                });
            }

            return (0, _extends3.default)({}, state, {
                byId: existing,
                loaded: loaded,
                loading: loading
            });
        default:
            return state;
    }
}

/* SELECTORS */
var stateSelector = function stateSelector(state) {
    return state.domain.savedItemCount;
};
var idSelector = function idSelector(state, id) {
    return id;
};

var byIdSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.byId;
});

var loadedSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.loaded;
});

var loadingSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.loading;
});

// takes in a (state, id) and returns the data
var getSavedItemCount = exports.getSavedItemCount = (0, _reselect.createSelector)([byIdSelector, idSelector], function (byId, id) {
    return byId[id] || { itemId: id, savedCount: 0 };
});

// takes in a (state, id) and returns the load time
var getLoadTimeForSavedItemCount = exports.getLoadTimeForSavedItemCount = (0, _reselect.createSelector)([loadedSelector, idSelector], function (loaded, id) {
    return loaded[id] || 0;
});

// takes in a (state, id) and returns the is loading
var isSavedItemCountLoading = exports.isSavedItemCountLoading = (0, _reselect.createSelector)([loadingSelector, idSelector], function (loading, id) {
    return loading.indexOf(id) !== -1;
});

var shouldFetchSavedItemCount = function shouldFetchSavedItemCount(state, itemId) {
    var data = getSavedItemCount(state, itemId);
    if (data.savedCount !== 0) {
        var loaded = getLoadTimeForSavedItemCount(state, itemId);
        var time = Date.now();
        var diff = time - loaded;
        if (diff < REDUX_STORE_TIME) return false;
    }
    var loading = isSavedItemCountLoading(state, itemId);
    return !loading;
};

var whichSavedItemCountsNeeded = function whichSavedItemCountsNeeded(state, itemIds) {
    return itemIds.filter(function (itemId) {
        return shouldFetchSavedItemCount(state, itemId);
    });
};

/* ACTION CREATORS */
var loadSavedItemCounts = function loadSavedItemCounts(itemIds) {
    return function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch, getState) {
            var state, deployment, response;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.prev = 0;
                            state = getState();
                            deployment = (0, _config.getDeployment)(state);

                            dispatch({
                                payload: itemIds,
                                type: LOAD_SAVED_ITEM_COUNT_REQUEST
                            });
                            _context.next = 6;
                            return _api.SaveItem.fetchSavedItemCounts({ deployment: deployment, itemIds: itemIds });

                        case 6:
                            response = _context.sent;

                            dispatch({
                                meta: { actionTime: Date.now(), itemIds: itemIds },
                                payload: response.data,
                                type: LOAD_SAVED_ITEM_COUNT_SUCCESS
                            });
                            _context.next = 13;
                            break;

                        case 10:
                            _context.prev = 10;
                            _context.t0 = _context['catch'](0);

                            dispatch({
                                error: true,
                                meta: { itemIds: itemIds },
                                payload: _context.t0,
                                type: LOAD_SAVED_ITEM_COUNT_FAIL
                            });

                        case 13:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, undefined, [[0, 10]]);
        }));

        return function (_x3, _x4) {
            return _ref.apply(this, arguments);
        };
    }();
};

var fetchSavedItemCountsIfNeeded = exports.fetchSavedItemCountsIfNeeded = function fetchSavedItemCountsIfNeeded(itemIds) {
    return function (dispatch, getState) {
        var needed = whichSavedItemCountsNeeded(getState(), itemIds);
        if (needed.length) {
            return dispatch(loadSavedItemCounts(needed));
        }
        return _promise2.default.resolve();
    };
};

/***/ }),

/***/ "oQLi":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _jsx2 = __webpack_require__("dcb+");

var _jsx3 = _interopRequireDefault(_jsx2);

var _class, _temp;

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propsComparer = __webpack_require__("wsGv");

var _propsComparer2 = _interopRequireDefault(_propsComparer);

var _Panel = __webpack_require__("1zx7");

var _Panel2 = _interopRequireDefault(_Panel);

var _reactFontawesome = __webpack_require__("f7W8");

var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Panel3 = __webpack_require__("qNQ/");

var _Panel4 = _interopRequireDefault(_Panel3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DownArrow = (0, _jsx3.default)(_reactFontawesome2.default, {
    className: _Panel4.default.arrow,
    icon: ['fas', 'caret-down']
});
var UpArrow = (0, _jsx3.default)(_reactFontawesome2.default, {
    className: _Panel4.default.arrow,
    icon: ['fas', 'caret-up']
});

var Panel = (_temp = _class = function (_Component) {
    (0, _inherits3.default)(Panel, _Component);

    function Panel() {
        (0, _classCallCheck3.default)(this, Panel);
        return (0, _possibleConstructorReturn3.default)(this, (Panel.__proto__ || (0, _getPrototypeOf2.default)(Panel)).apply(this, arguments));
    }

    (0, _createClass3.default)(Panel, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps) {
            return (0, _propsComparer2.default)(this.props, nextProps, ['children', 'eventKey', 'expanded', 'headerRole', 'headerTitle', 'panelRole']);
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                children = _props.children,
                eventKey = _props.eventKey,
                expanded = _props.expanded,
                headerRole = _props.headerRole,
                headerTitle = _props.headerTitle,
                onSelect = _props.onSelect,
                panelRole = _props.panelRole;


            var header = (0, _jsx3.default)('h2', {
                className: _Panel4.default.header + ' ' + _Panel4.default['print-header']
            }, void 0, ' ', headerTitle, ' ', expanded ? UpArrow : DownArrow, ' ');

            var panelProps = {
                className: _Panel4.default.panel,
                collapsible: true,
                eventKey: eventKey,
                expanded: expanded,
                header: header,
                headerRole: headerRole,
                onSelect: onSelect,
                panelRole: panelRole
            };

            return _react2.default.createElement(
                _Panel2.default,
                panelProps,
                children
            );
        }
    }]);
    return Panel;
}(_react.Component), _class.defaultProps = {
    headerTitle: ''
}, _temp);
exports.default = Panel;
module.exports = exports['default'];

/***/ }),

/***/ "oUvu":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fetchCatalogLocationsIfNeeded = exports.areCatalogLocationsLoading = exports.getCatalogLocations = exports.LOAD_CATALOG_LOCATIONS_SUCCESS = exports.LOAD_CATALOG_LOCATIONS_REQUEST = exports.LOAD_CATALOG_LOCATIONS_FAIL = undefined;

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;

var _api = __webpack_require__("zFQO");

var _reselect = __webpack_require__("bndy");

var _config = __webpack_require__("iS9E");

var _ms = __webpack_require__("EarI");

var _ms2 = _interopRequireDefault(_ms);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Action Types */
var LOAD_CATALOG_LOCATIONS_FAIL = exports.LOAD_CATALOG_LOCATIONS_FAIL = 'la/domain/catalogLocation/LOAD_FAIL';
var LOAD_CATALOG_LOCATIONS_REQUEST = exports.LOAD_CATALOG_LOCATIONS_REQUEST = 'la/domain/catalogLocation/LOAD_REQUEST';
var LOAD_CATALOG_LOCATIONS_SUCCESS = exports.LOAD_CATALOG_LOCATIONS_SUCCESS = 'la/domain/catalogLocation/LOAD_SUCCESS';

var REDUX_STORE_TIME = (0, _ms2.default)('30m');

/* reducer */
var DEFAULT_STATE = {
    loaded: 0,
    loading: false,
    locations: []
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        case LOAD_CATALOG_LOCATIONS_FAIL:
            return (0, _extends3.default)({}, state, {
                loading: false
            });
        case LOAD_CATALOG_LOCATIONS_REQUEST:
            return (0, _extends3.default)({}, state, {
                loading: true
            });
        case LOAD_CATALOG_LOCATIONS_SUCCESS:
            return (0, _extends3.default)({}, state, {
                loaded: action.meta.actionTime,
                loading: false,
                locations: action.payload
            });
        default:
            return state;
    }
}

/* SELECTORS */
var stateSelector = function stateSelector(state) {
    return state.domain.catalogLocation;
};

var getCatalogLocations = exports.getCatalogLocations = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.locations;
});

var getLoadTimeForCatalogLocations = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.loaded;
});

var areCatalogLocationsLoading = exports.areCatalogLocationsLoading = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.loading;
});

var shouldFetchCatalogLocations = function shouldFetchCatalogLocations(state) {
    var item = getCatalogLocations(state);
    if (item) {
        var loaded = getLoadTimeForCatalogLocations(state);
        var time = Date.now();
        var diff = time - loaded;
        if (diff < REDUX_STORE_TIME) return false;
    }
    var loading = areCatalogLocationsLoading(state);
    return !loading;
};

/* ACTION CREATORS */
var loadCatalogLocations = function loadCatalogLocations() {
    return function (dispatch, getState) {
        var state = getState();
        var deployment = (0, _config.getDeployment)(state);
        dispatch({
            type: LOAD_CATALOG_LOCATIONS_REQUEST
        });
        return _api.CatalogLocation.fetchCatalogLocations({ deployment: deployment }).then(function (response) {
            dispatch({
                meta: { actionTime: Date.now() },
                payload: response.data,
                type: LOAD_CATALOG_LOCATIONS_SUCCESS
            });
        }).catch(function (error) {
            dispatch({
                error: true,
                payload: error,
                type: LOAD_CATALOG_LOCATIONS_FAIL
            });
        });
    };
};

var fetchCatalogLocationsIfNeeded = exports.fetchCatalogLocationsIfNeeded = function fetchCatalogLocationsIfNeeded() {
    return function (dispatch, getState) {
        if (shouldFetchCatalogLocations(getState())) {
            return dispatch(loadCatalogLocations());
        }
        return _promise2.default.resolve();
    };
};

/***/ }),

/***/ "ohur":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"live-item-save":"live-item-save___q8bmK","button":"button___3jilm","icon":"icon___1UgVo","message-wrapper":"message-wrapper___2QDoe","title":"title___1GxHZ"};

/***/ }),

/***/ "orCU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"container___1EHDy","header":"header___3nkDv"};

/***/ }),

/***/ "osDh":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = __webpack_require__("dcb+");

var _jsx3 = _interopRequireDefault(_jsx2);

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Polyfill for webpack, just in case
if (false) require.ensure = function (d, c) {
    c(require);
};

var AbsenteeBidModalLoader = function (_Component) {
    (0, _inherits3.default)(AbsenteeBidModalLoader, _Component);

    function AbsenteeBidModalLoader(props, context) {
        (0, _classCallCheck3.default)(this, AbsenteeBidModalLoader);

        var _this = (0, _possibleConstructorReturn3.default)(this, (AbsenteeBidModalLoader.__proto__ || (0, _getPrototypeOf2.default)(AbsenteeBidModalLoader)).call(this, props, context));

        _this.state = {
            Component: null,
            mounted: false
        };
        return _this;
    }

    (0, _createClass3.default)(AbsenteeBidModalLoader, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            var _this2 = this;

            return new _promise2.default(function (resolve) {
                __webpack_require__.e/* require.ensure */(18).then((function () {
                    resolve(__webpack_require__("Blia"));
                }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            }).then(function (container) {
                _this2.setState({ Component: container });
            });
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.setState({ mounted: true });
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.setState({ mounted: false });
        }
    }, {
        key: 'render',
        value: function render() {
            var _state = this.state,
                Component = _state.Component,
                mounted = _state.mounted;

            return mounted && Component !== null ? (0, _jsx3.default)(Component, {}) : null;
        }
    }]);
    return AbsenteeBidModalLoader;
}(_react.Component);

exports.default = AbsenteeBidModalLoader;
module.exports = exports['default'];

/***/ }),

/***/ "owzB":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = __webpack_require__("dcb+");

var _jsx3 = _interopRequireDefault(_jsx2);

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Polyfill for webpack, just in case
if (false) require.ensure = function (d, c) {
    c(require);
};

var RegisterForCatalogModalLoader = function (_Component) {
    (0, _inherits3.default)(RegisterForCatalogModalLoader, _Component);

    function RegisterForCatalogModalLoader(props, context) {
        (0, _classCallCheck3.default)(this, RegisterForCatalogModalLoader);

        var _this = (0, _possibleConstructorReturn3.default)(this, (RegisterForCatalogModalLoader.__proto__ || (0, _getPrototypeOf2.default)(RegisterForCatalogModalLoader)).call(this, props, context));

        _this.state = {
            Component: null,
            mounted: false
        };
        return _this;
    }

    (0, _createClass3.default)(RegisterForCatalogModalLoader, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            var _this2 = this;

            return new _promise2.default(function (resolve) {
                __webpack_require__.e/* require.ensure */(24).then((function () {
                    resolve(__webpack_require__("FYH3"));
                }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            }).then(function (container) {
                _this2.setState({ Component: container });
            });
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.setState({ mounted: true });
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.setState({ mounted: false });
        }
    }, {
        key: 'render',
        value: function render() {
            var _state = this.state,
                Component = _state.Component,
                mounted = _state.mounted;

            return mounted && Component !== null ? (0, _jsx3.default)(Component, {}) : null;
        }
    }]);
    return RegisterForCatalogModalLoader;
}(_react.Component);

exports.default = RegisterForCatalogModalLoader;
module.exports = exports['default'];

/***/ }),

/***/ "ozIy":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fetchCatalogItemsIfNeeded = exports.LOAD_CATALOG_ITEMS_SUCCESS = exports.LOAD_CATALOG_ITEMS_REQUEST = exports.LOAD_CATALOG_ITEMS_FAIL = undefined;

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _fetchBatch = __webpack_require__("6OCT");

var _api = __webpack_require__("zFQO");

var _user = __webpack_require__("CFLi");

var _config = __webpack_require__("iS9E");

var _item = __webpack_require__("Gk4U");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FETCH_SET_SIZE = 1;

/* Action Types */
var LOAD_CATALOG_ITEMS_FAIL = exports.LOAD_CATALOG_ITEMS_FAIL = 'la/domain/catalogItems/LOAD_FAIL';
var LOAD_CATALOG_ITEMS_REQUEST = exports.LOAD_CATALOG_ITEMS_REQUEST = 'la/domain/catalogItems/LOAD_REQUEST';
var LOAD_CATALOG_ITEMS_SUCCESS = exports.LOAD_CATALOG_ITEMS_SUCCESS = 'la/domain/catalogItems/LOAD_SUCCESS';

/* ACTION CREATORS */
var loadCatalogItemsFail = function loadCatalogItemsFail(catalogId, error) {
    return {
        error: true,
        meta: { catalogId: catalogId },
        payload: error,
        type: LOAD_CATALOG_ITEMS_FAIL
    };
};

var loadCatalogItemsRequest = function loadCatalogItemsRequest(catalogId) {
    return {
        meta: { actionTime: Date.now() },
        payload: catalogId,
        type: LOAD_CATALOG_ITEMS_REQUEST
    };
};

// TODO: this function takes in catalogId, but others take catalogIds
var loadCatalogItemsSuccess = function loadCatalogItemsSuccess(catalogId, results) {
    return {
        meta: { actionTime: Date.now(), catalogId: catalogId },
        payload: results,
        type: LOAD_CATALOG_ITEMS_SUCCESS
    };
};

var loadCatalogItems = function loadCatalogItems(catalogIds, loadingId, cursor, page, count, itemId) {
    return function (dispatch, getState) {
        var state = getState();
        var authToken = (0, _user.getAuthToken)(state);
        var deployment = (0, _config.getDeployment)(state);
        dispatch(loadCatalogItemsRequest(catalogIds));
        return _api.Catalog.postCatalogItems({ authToken: authToken, catalogIds: catalogIds, count: count, cursor: cursor, deployment: deployment, itemId: itemId, page: page }).then(function (response) {
            return dispatch(loadCatalogItemsSuccess(catalogIds, response.data));
        }).catch(function (error) {
            dispatch(loadCatalogItemsFail(catalogIds, error));
            dispatch((0, _fetchBatch.loadBatchEnd)(loadingId));
        });
    };
};

var loadCatalogItemsInSets = function loadCatalogItemsInSets(ids, setSize, loadingId, cursor, page, count, itemId) {
    return function (dispatch) {
        if (global.__SERVER__) {
            return dispatch(loadCatalogItems(ids, loadingId, cursor, page, count)).then(function () {
                return dispatch((0, _fetchBatch.loadBatchEnd)(loadingId));
            });
        }
        var promises = [];
        while (ids.length > 0) {
            promises.push(dispatch(loadCatalogItems(ids.splice(0, setSize), loadingId, cursor, page, count, itemId)));
        }
        return _promise2.default.all(promises).then(function () {
            return dispatch((0, _fetchBatch.loadBatchEnd)(loadingId));
        });
    };
};

var fetchCatalogItemsIfNeeded = exports.fetchCatalogItemsIfNeeded = function fetchCatalogItemsIfNeeded(catalogIds) {
    var loadingId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'none';
    var cursor = arguments[2];
    var page = arguments[3];
    var count = arguments[4];
    var itemId = arguments[5];

    return function (dispatch, getState) {
        var needed = (0, _item.whichCatalogItemsNeeded)(getState(), catalogIds);
        if (needed.length) {
            dispatch((0, _fetchBatch.loadBatchStart)(loadingId));
            return dispatch(loadCatalogItemsInSets(needed, FETCH_SET_SIZE, loadingId, cursor, page, count, itemId));
        }
        return _promise2.default.resolve();
    };
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("DuR2")))

/***/ }),

/***/ "pBUe":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var catalogSortOrders = {
    /*eslint-disable */
    DATE_ASCENDING: 'DATE_ASCENDING',
    DATE_DESCENDING: 'DATE_DESCENDING'
    /*eslint-enable */
};

exports.default = catalogSortOrders;
module.exports = exports['default'];

/***/ }),

/***/ "pOp2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.submitConfirmPassword = exports.getUiConfirmPassword = exports.CONFIRM_PASSWORD_SUCCESS = exports.CONFIRM_PASSWORD_REQUEST = exports.CONFIRM_PASSWORD_FAIL = undefined;

var _regenerator = __webpack_require__("Xxa5");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__("exGp");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;

var _api = __webpack_require__("zFQO");

var _reselect = __webpack_require__("bndy");

var _user = __webpack_require__("CFLi");

var _config = __webpack_require__("iS9E");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Action Types */
var CONFIRM_PASSWORD_FAIL = exports.CONFIRM_PASSWORD_FAIL = 'la/ui/confirmPassword/FAIL';
var CONFIRM_PASSWORD_REQUEST = exports.CONFIRM_PASSWORD_REQUEST = 'la/ui/confirmPassword/REQUEST';
var CONFIRM_PASSWORD_SUCCESS = exports.CONFIRM_PASSWORD_SUCCESS = 'la/ui/confirmPassword/SUCCESS';

// reducer
var DEFAULT_STATE = {
    error: false,
    errorMessage: null,
    submitted: false,
    success: false
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        case CONFIRM_PASSWORD_REQUEST:
            return (0, _extends3.default)({}, state, {
                error: false,
                errorMessage: null,
                submitted: true,
                success: false
            });
        case CONFIRM_PASSWORD_SUCCESS:
            return (0, _extends3.default)({}, state, {
                submitted: false,
                success: true
            });
        case CONFIRM_PASSWORD_FAIL:
            return (0, _extends3.default)({}, state, {
                error: true,
                errorMessage: action.payload.message,
                submitted: false,
                success: false
            });
        default:
            return state;
    }
}

/* SELECTORS */
var stateSelector = function stateSelector(state) {
    return state.ui.confirmPassword;
};

var getUiConfirmPassword = exports.getUiConfirmPassword = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state;
});

/* ACTION CREATORS */
var submitConfirmPassword = exports.submitConfirmPassword = function submitConfirmPassword(password) {
    return function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch, getState) {
            var state, username, deployment, response;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.prev = 0;

                            dispatch({
                                type: CONFIRM_PASSWORD_REQUEST
                            });
                            state = getState();
                            username = (0, _user.getBidderEmail)(state);
                            deployment = (0, _config.getDeployment)(state);
                            _context.next = 7;
                            return _api.Auth.postConfirmPassword({ deployment: deployment, password: password, username: username });

                        case 7:
                            response = _context.sent;

                            dispatch({
                                meta: { actionTime: Date.now() },
                                payload: response.data,
                                type: CONFIRM_PASSWORD_SUCCESS
                            });
                            _context.next = 14;
                            break;

                        case 11:
                            _context.prev = 11;
                            _context.t0 = _context['catch'](0);

                            if (_context.t0.message === 'Failed to get the login.') {
                                dispatch({
                                    error: true,
                                    payload: { message: 'Invalid password' },
                                    type: CONFIRM_PASSWORD_FAIL
                                });
                            } else {
                                dispatch({
                                    error: true,
                                    payload: _context.t0,
                                    type: CONFIRM_PASSWORD_FAIL
                                });
                            }

                        case 14:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, undefined, [[0, 11]]);
        }));

        return function (_x3, _x4) {
            return _ref.apply(this, arguments);
        };
    }();
};

/***/ }),

/***/ "pf/a":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx2 = __webpack_require__("dcb+");

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _whiteLabel = __webpack_require__("cYj3");

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__("RH2O");

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _WhiteLabelCrown = __webpack_require__("WcsR");

var _WhiteLabelCrown2 = _interopRequireDefault(_WhiteLabelCrown);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(state) {
    return {
        name: (0, _whiteLabel.getWhiteLabelSiteName)(state),
        url: (0, _whiteLabel.getWhiteLabelSiteUrl)(state)
    };
};

var WhiteLabelCrownContainer = function (_Component) {
    (0, _inherits3.default)(WhiteLabelCrownContainer, _Component);

    function WhiteLabelCrownContainer() {
        (0, _classCallCheck3.default)(this, WhiteLabelCrownContainer);
        return (0, _possibleConstructorReturn3.default)(this, (WhiteLabelCrownContainer.__proto__ || (0, _getPrototypeOf2.default)(WhiteLabelCrownContainer)).apply(this, arguments));
    }

    (0, _createClass3.default)(WhiteLabelCrownContainer, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                name = _props.name,
                url = _props.url;


            return (0, _jsx3.default)(_WhiteLabelCrown2.default, {
                name: name,
                url: url
            });
        }
    }]);
    return WhiteLabelCrownContainer;
}(_react.Component);

exports.default = (0, _reactRedux.connect)(mapStateToProps)(WhiteLabelCrownContainer);
module.exports = exports['default'];

/***/ }),

/***/ "pjS5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _toConsumableArray2 = __webpack_require__("Gu7T");

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propsComparer = __webpack_require__("wsGv");

var _propsComparer2 = _interopRequireDefault(_propsComparer);

var _noop = __webpack_require__("9vKl");

var _noop2 = _interopRequireDefault(_noop);

var _placeholderLA = __webpack_require__("KCpM");

var _placeholderLA2 = _interopRequireDefault(_placeholderLA);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageWithFallback = (_temp = _class = function (_Component) {
    (0, _inherits3.default)(ImageWithFallback, _Component);

    function ImageWithFallback(props, context) {
        (0, _classCallCheck3.default)(this, ImageWithFallback);

        var _this = (0, _possibleConstructorReturn3.default)(this, (ImageWithFallback.__proto__ || (0, _getPrototypeOf2.default)(ImageWithFallback)).call(this, props, context));

        _this.onClick = function (event) {
            _this.props.onClick(event);
        };

        _this.onError = function (event) {
            _this.setState({ imageSource: _placeholderLA2.default });
            _this.props.onError(event);
        };

        _this.onLoad = function (event) {
            _this.props.onLoad(event);

            if (_this.props.minSize) {
                var _this$imageRef$getBou = _this.imageRef.getBoundingClientRect(),
                    width = _this$imageRef$getBou.width;

                var _this$imageRef = _this.imageRef,
                    naturalHeight = _this$imageRef.naturalHeight,
                    naturalWidth = _this$imageRef.naturalWidth;


                _this.setState({
                    size: {
                        minHeight: width / naturalWidth * naturalHeight + 'px',
                        minWidth: width + 'px'
                    }
                });
            }
        };

        var url = props.src || _placeholderLA2.default;
        _this.state = {
            imageSource: props.forceFallback ? _placeholderLA2.default : url,
            size: {}
        };
        return _this;
    }

    (0, _createClass3.default)(ImageWithFallback, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            var _this2 = this;

            if (this.props.src !== nextProps.src) {
                // set the placeholder image first so that the previous image is cleared out before we set the new one.
                this.setState({ imageSource: _placeholderLA2.default });
                this.timeout = setTimeout(function () {
                    return _this2.setState({ imageSource: nextProps.src });
                }, 10);
            }
        }
    }, {
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps, nextState) {
            return (0, _propsComparer2.default)(this.props, nextProps, ['alt', 'className', 'forceFallback', 'minSize', 'src', 'style']) || (0, _propsComparer2.default)(this.state, nextState, ['imageSource', 'size']);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            if (this.timeout) {
                clearTimeout(this.timeout);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var _props = this.props,
                alt = _props.alt,
                className = _props.className,
                style = _props.style;
            var _state = this.state,
                imageSource = _state.imageSource,
                size = _state.size;


            var completeStyles = (0, _extends3.default)({}, style, size);
            var classes = [].concat((0, _toConsumableArray3.default)(className.split(' '))).join(' ').trim();
            return _react2.default.createElement('img', {
                alt: alt,
                ref: function ref(_ref) {
                    return _this3.imageRef = _ref;
                },
                className: classes,
                src: imageSource,
                onClick: this.onClick,
                onError: this.onError,
                onLoad: this.onLoad,
                style: completeStyles
            });
        }
    }]);
    return ImageWithFallback;
}(_react.Component), _class.defaultProps = {
    alt: '',
    className: '',
    forceFallback: false,
    onClick: _noop2.default,
    onError: _noop2.default,
    onLoad: _noop2.default,
    src: _placeholderLA2.default,
    style: {}
}, _temp);
exports.default = ImageWithFallback;
module.exports = exports['default'];

/***/ }),

/***/ "pxDK":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = __webpack_require__("dcb+");

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _AbsenteeBidModalLoader = __webpack_require__("osDh");

var _AbsenteeBidModalLoader2 = _interopRequireDefault(_AbsenteeBidModalLoader);

var _AddCreditCardModalLoader = __webpack_require__("6Sy9");

var _AddCreditCardModalLoader2 = _interopRequireDefault(_AddCreditCardModalLoader);

var _AddSearchAlertModalLoader = __webpack_require__("Z0wO");

var _AddSearchAlertModalLoader2 = _interopRequireDefault(_AddSearchAlertModalLoader);

var _AutoPopModalContainer = __webpack_require__("FHLC");

var _AutoPopModalContainer2 = _interopRequireDefault(_AutoPopModalContainer);

var _CompleteAccountModalLoader = __webpack_require__("k57w");

var _CompleteAccountModalLoader2 = _interopRequireDefault(_CompleteAccountModalLoader);

var _ConfirmPasswordModalLoader = __webpack_require__("FoiQ");

var _ConfirmPasswordModalLoader2 = _interopRequireDefault(_ConfirmPasswordModalLoader);

var _reactRedux = __webpack_require__("RH2O");

var _ConsignmentConfirmModalLoader = __webpack_require__("IkOe");

var _ConsignmentConfirmModalLoader2 = _interopRequireDefault(_ConsignmentConfirmModalLoader);

var _DownloadMobileModalLoader = __webpack_require__("6Gwy");

var _DownloadMobileModalLoader2 = _interopRequireDefault(_DownloadMobileModalLoader);

var _ForgotPasswordModalLoader = __webpack_require__("4C+L");

var _ForgotPasswordModalLoader2 = _interopRequireDefault(_ForgotPasswordModalLoader);

var _modal = __webpack_require__("u90i");

var _HealthcheckModalLoader = __webpack_require__("UnnL");

var _HealthcheckModalLoader2 = _interopRequireDefault(_HealthcheckModalLoader);

var _InstallFlashModalLoader = __webpack_require__("PbAz");

var _InstallFlashModalLoader2 = _interopRequireDefault(_InstallFlashModalLoader);

var _ItemDescriptionModalLoader = __webpack_require__("ibTp");

var _ItemDescriptionModalLoader2 = _interopRequireDefault(_ItemDescriptionModalLoader);

var _LoginModalLoader = __webpack_require__("Q5vn");

var _LoginModalLoader2 = _interopRequireDefault(_LoginModalLoader);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _RegisterForCatalogModalLoader = __webpack_require__("owzB");

var _RegisterForCatalogModalLoader2 = _interopRequireDefault(_RegisterForCatalogModalLoader);

var _RetractBidModalLoader = __webpack_require__("UGHK");

var _RetractBidModalLoader2 = _interopRequireDefault(_RetractBidModalLoader);

var _SendSellerMessageModalLoader = __webpack_require__("fFJ6");

var _SendSellerMessageModalLoader2 = _interopRequireDefault(_SendSellerMessageModalLoader);

var _SignUpModalContainer = __webpack_require__("KmPa");

var _SignUpModalContainer2 = _interopRequireDefault(_SignUpModalContainer);

var _SignUpPasswordModalLoader = __webpack_require__("FftY");

var _SignUpPasswordModalLoader2 = _interopRequireDefault(_SignUpPasswordModalLoader);

var _SubmitConsignmentModalLoader = __webpack_require__("zOpu");

var _SubmitConsignmentModalLoader2 = _interopRequireDefault(_SubmitConsignmentModalLoader);

var _TermsModalLoader = __webpack_require__("Y8Cm");

var _TermsModalLoader2 = _interopRequireDefault(_TermsModalLoader);

var _UpdatePasswordModalLoader = __webpack_require__("U847");

var _UpdatePasswordModalLoader2 = _interopRequireDefault(_UpdatePasswordModalLoader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Modals = (_dec = (0, _reactRedux.connect)(function (state) {
    return {
        openModal: (0, _modal.getOpenModal)(state)
    };
}), _dec(_class = function (_Component) {
    (0, _inherits3.default)(Modals, _Component);

    function Modals() {
        (0, _classCallCheck3.default)(this, Modals);
        return (0, _possibleConstructorReturn3.default)(this, (Modals.__proto__ || (0, _getPrototypeOf2.default)(Modals)).apply(this, arguments));
    }

    (0, _createClass3.default)(Modals, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps) {
            return this.props.openModal !== nextProps.openModal;
        }
    }, {
        key: 'render',
        value: function render() {
            var openModal = this.props.openModal;


            return (0, _jsx3.default)('div', {}, void 0, (0, _jsx3.default)(_AutoPopModalContainer2.default, {}), (0, _jsx3.default)(_SignUpModalContainer2.default, {}), openModal === 'ABSENTEE_BID' && (0, _jsx3.default)(_AbsenteeBidModalLoader2.default, {}), openModal === 'ADD_CREDIT_CARD' && (0, _jsx3.default)(_AddCreditCardModalLoader2.default, {}), openModal === 'ADD_SEARCH_ALERT' && (0, _jsx3.default)(_AddSearchAlertModalLoader2.default, {}), openModal === 'CHANGE_PASSWORD' && (0, _jsx3.default)(_UpdatePasswordModalLoader2.default, {}), openModal === 'LOGIN' && (0, _jsx3.default)(_LoginModalLoader2.default, {}), openModal === 'RETRACT_BID' && (0, _jsx3.default)(_RetractBidModalLoader2.default, {}), openModal === 'SEND_SELLER_MESSAGE' && (0, _jsx3.default)(_SendSellerMessageModalLoader2.default, {}), openModal === 'SEND_SELLER_CONSIGNMENT_MESSAGE' && (0, _jsx3.default)(_SubmitConsignmentModalLoader2.default, {}), openModal === 'SET_PASSWORD' && (0, _jsx3.default)(_SignUpPasswordModalLoader2.default, {}), openModal === 'COMPLETE_ACCOUNT' && (0, _jsx3.default)(_CompleteAccountModalLoader2.default, {}), openModal === 'CONFIRM_PASSWORD' && (0, _jsx3.default)(_ConfirmPasswordModalLoader2.default, {}), openModal === 'CONFIRM_CONSIGNMENT' && (0, _jsx3.default)(_ConsignmentConfirmModalLoader2.default, {}), openModal === 'DOWNLOAD_MOBILE' && (0, _jsx3.default)(_DownloadMobileModalLoader2.default, {}), openModal === 'FORGOT_PASSWORD' && (0, _jsx3.default)(_ForgotPasswordModalLoader2.default, {}), openModal === 'HEALTHCHECK' && (0, _jsx3.default)(_HealthcheckModalLoader2.default, {}), openModal === 'INSTALL_FLASH' && (0, _jsx3.default)(_InstallFlashModalLoader2.default, {}), openModal === 'ITEM_DESCRIPTION' && (0, _jsx3.default)(_ItemDescriptionModalLoader2.default, {}), openModal === 'REGISTER_FOR_AUCTION' && (0, _jsx3.default)(_RegisterForCatalogModalLoader2.default, {}), openModal === 'TERMS' && (0, _jsx3.default)(_TermsModalLoader2.default, {}));
        }
    }]);
    return Modals;
}(_react.Component)) || _class);
exports.default = Modals;
module.exports = exports['default'];

/***/ }),

/***/ "qG7W":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = __webpack_require__("dcb+");

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propsComparer = __webpack_require__("wsGv");

var _propsComparer2 = _interopRequireDefault(_propsComparer);

var _reactIntl = __webpack_require__("Pq8k");

var _reactHoverintent = __webpack_require__("AbPR");

var _reactHoverintent2 = _interopRequireDefault(_reactHoverintent);

var _components = __webpack_require__("bGai");

var _noop = __webpack_require__("9vKl");

var _noop2 = _interopRequireDefault(_noop);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _MegaNavLink = __webpack_require__("lXgo");

var _MegaNavLink2 = _interopRequireDefault(_MegaNavLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MegaNavLink = function (_Component) {
    (0, _inherits3.default)(MegaNavLink, _Component);

    function MegaNavLink(props, context) {
        (0, _classCallCheck3.default)(this, MegaNavLink);

        var _this = (0, _possibleConstructorReturn3.default)(this, (MegaNavLink.__proto__ || (0, _getPrototypeOf2.default)(MegaNavLink)).call(this, props, context));

        _this.state = {
            active: false
        };
        return _this;
    }

    (0, _createClass3.default)(MegaNavLink, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps, nextState) {
            return (0, _propsComparer2.default)(this.props, nextProps, ['active', 'link', 'mobile', 'msgId']) || (0, _propsComparer2.default)(this.state, nextState, ['active']);
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                active = _props.active,
                link = _props.link,
                mobile = _props.mobile,
                msgId = _props.msgId,
                openNav = _props.openNav,
                closeNav = _props.closeNav,
                tabletNavigation = _props.tabletNavigation;


            var isPhone = mobile && mobile !== 'tablet';
            var isTablet = mobile === 'tablet';
            return (0, _jsx3.default)(_reactHoverintent2.default, {
                onMouseOver: isTablet ? _noop2.default : openNav,
                onMouseOut: _noop2.default,
                sensitivity: 5,
                interval: 50,
                timeout: 50
            }, void 0, (0, _jsx3.default)('div', {
                className: _MegaNavLink2.default.navLink + ' ' + (active && !isPhone ? _MegaNavLink2.default.active : '')
            }, void 0, (0, _jsx3.default)(_components.Link, {
                onClick: !isTablet ? closeNav : tabletNavigation,
                route: true,
                to: isTablet ? '' : link,
                primaryWeak: true
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: msgId
            }))));
        }
    }]);
    return MegaNavLink;
}(_react.Component);

exports.default = MegaNavLink;
module.exports = exports['default'];

/***/ }),

/***/ "qNQ/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"panel":"panel___1WbzA","header":"header___1bwqQ","arrow":"arrow___2_qvo","print-header":"print-header___2ohgJ"};

/***/ }),

/***/ "qPVN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"footer":"footer___X_ABR"};

/***/ }),

/***/ "qWId":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toggleSavedSearchEmail = exports.submitDeleteSavedSearch = exports.fetchSavedSearchesIfNeeded = exports.getSavedSearchesCount = exports.getFilteredSavedSearches = exports.isSavedSearchesLoading = exports.getSavedSearches = exports.UNSUBSCRIBE_SAVED_SEARCH_SUCCESS = exports.UNSUBSCRIBE_SAVED_SEARCH_REQUEST = exports.UNSUBSCRIBE_SAVED_SEARCH_FAIL = exports.SUBSCRIBE_SAVED_SEARCH_SUCCESS = exports.SUBSCRIBE_SAVED_SEARCH_REQUEST = exports.SUBSCRIBE_SAVED_SEARCH_FAIL = exports.LOAD_SAVED_SEARCHES_SUCCESS = exports.LOAD_SAVED_SEARCHES_REQUEST = exports.LOAD_SAVED_SEARCHES_FAIL = exports.DELETE_SAVED_SEARCH_SUCCESS = exports.DELETE_SAVED_SEARCH_REQUEST = exports.DELETE_SAVED_SEARCH_FAIL = undefined;

var _regenerator = __webpack_require__("Xxa5");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _asyncToGenerator2 = __webpack_require__("exGp");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;

var _api = __webpack_require__("zFQO");

var _cloneDeep = __webpack_require__("kvU2");

var _cloneDeep2 = _interopRequireDefault(_cloneDeep);

var _reselect = __webpack_require__("bndy");

var _user = __webpack_require__("CFLi");

var _config = __webpack_require__("iS9E");

var _analytics = __webpack_require__("yxCd");

var _isEmpty = __webpack_require__("lHK6");

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _ms = __webpack_require__("EarI");

var _ms2 = _interopRequireDefault(_ms);

var _pagination = __webpack_require__("7oYi");

var _savedSearchFacets = __webpack_require__("y7cp");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Action Types */
var DELETE_SAVED_SEARCH_FAIL = exports.DELETE_SAVED_SEARCH_FAIL = 'la/user/savedSearches/DELETE_FAIL';
var DELETE_SAVED_SEARCH_REQUEST = exports.DELETE_SAVED_SEARCH_REQUEST = 'la/user/savedSearches/DELETE_REQUEST';
var DELETE_SAVED_SEARCH_SUCCESS = exports.DELETE_SAVED_SEARCH_SUCCESS = 'la/user/savedSearches/DELETE_SUCCESS';

var LOAD_SAVED_SEARCHES_FAIL = exports.LOAD_SAVED_SEARCHES_FAIL = 'la/user/savedSearches/LOAD_FAIL';
var LOAD_SAVED_SEARCHES_REQUEST = exports.LOAD_SAVED_SEARCHES_REQUEST = 'la/user/savedSearches/LOAD_REQUEST';
var LOAD_SAVED_SEARCHES_SUCCESS = exports.LOAD_SAVED_SEARCHES_SUCCESS = 'la/user/savedSearches/LOAD_SUCCESS';

var SUBSCRIBE_SAVED_SEARCH_FAIL = exports.SUBSCRIBE_SAVED_SEARCH_FAIL = 'la/user/savedSearches/SUBSCRIBE_FAIL';
var SUBSCRIBE_SAVED_SEARCH_REQUEST = exports.SUBSCRIBE_SAVED_SEARCH_REQUEST = 'la/user/savedSearches/SUBSCRIBE_REQUEST';
var SUBSCRIBE_SAVED_SEARCH_SUCCESS = exports.SUBSCRIBE_SAVED_SEARCH_SUCCESS = 'la/user/savedSearches/SUBSCRIBE_SUCCESS';

var UNSUBSCRIBE_SAVED_SEARCH_FAIL = exports.UNSUBSCRIBE_SAVED_SEARCH_FAIL = 'la/user/savedSearches/UNSUBSCRIBE_FAIL';
var UNSUBSCRIBE_SAVED_SEARCH_REQUEST = exports.UNSUBSCRIBE_SAVED_SEARCH_REQUEST = 'la/user/savedSearches/UNSUBSCRIBE_REQUEST';
var UNSUBSCRIBE_SAVED_SEARCH_SUCCESS = exports.UNSUBSCRIBE_SAVED_SEARCH_SUCCESS = 'la/user/savedSearches/UNSUBSCRIBE_SUCCESS';

var REDUX_STORE_TIME = (0, _ms2.default)('30m');

/* reducer */
var DEFAULT_STATE = {
    loaded: 0,
    loading: false,
    searches: []
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var searches = void 0;

    switch (action.type) {
        case LOAD_SAVED_SEARCHES_FAIL:
            return (0, _extends3.default)({}, state, {
                loading: false
            });
        case LOAD_SAVED_SEARCHES_REQUEST:
            return (0, _extends3.default)({}, state, {
                loading: true
            });
        case LOAD_SAVED_SEARCHES_SUCCESS:
            return (0, _extends3.default)({}, state, {
                loaded: action.meta.actionTime,
                loading: false,
                searches: action.payload
            });
        case DELETE_SAVED_SEARCH_REQUEST:
            searches = [];
            (0, _cloneDeep2.default)(state.searches).forEach(function (x) {
                if (x.savedSearchId !== action.payload) {
                    searches.push(x);
                }
            });

            return (0, _extends3.default)({}, state, {
                searches: searches
            });
        case SUBSCRIBE_SAVED_SEARCH_REQUEST:
            searches = (0, _cloneDeep2.default)(state.searches);
            searches.forEach(function (x) {
                if (x.savedSearchId === action.payload) {
                    x.sendAlert = true;
                }
            });

            return (0, _extends3.default)({}, state, {
                searches: searches
            });
        case UNSUBSCRIBE_SAVED_SEARCH_REQUEST:
            searches = (0, _cloneDeep2.default)(state.searches);
            searches.forEach(function (x) {
                if (x.savedSearchId === action.payload) {
                    x.sendAlert = false;
                }
            });

            return (0, _extends3.default)({}, state, {
                searches: searches
            });
        default:
            return state;
    }
}

/* SELECTORS */
var savedSearchSelector = function savedSearchSelector(state) {
    return state.user.savedSearch;
};
var idSelector = function idSelector(state, id) {
    return id;
};

var savedSearchSearchesSelector = (0, _reselect.createSelector)(savedSearchSelector, function (savedSearch) {
    return savedSearch.searches;
});

var getSavedSearches = exports.getSavedSearches = (0, _reselect.createSelector)(savedSearchSearchesSelector, function (savedSearches) {
    return savedSearches;
});

var getSavedSearchById = (0, _reselect.createSelector)([savedSearchSearchesSelector, idSelector], function (savedSearches, id) {
    return savedSearches.find(function (x) {
        return x.savedSearchId === id;
    });
});

var getLoadTimeForSavedSearches = (0, _reselect.createSelector)(savedSearchSelector, function (savedSearch) {
    return savedSearch.loaded || 0;
});

var isSavedSearchesLoading = exports.isSavedSearchesLoading = (0, _reselect.createSelector)(savedSearchSelector, function (savedSearch) {
    return savedSearch.loading || false;
});

var shouldFetchSavedSearches = function shouldFetchSavedSearches(state) {
    var loaded = getLoadTimeForSavedSearches(state);
    var time = Date.now();
    var diff = time - loaded;
    if (diff < REDUX_STORE_TIME) return false;
    return !isSavedSearchesLoading(state);
};

// sort/ filtering
var savedSearchSortAscending = function savedSearchSortAscending() {
    var a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var aFacetString = (0, _savedSearchFacets.toFacetString)(a.facets).toLowerCase();
    var bFacetString = (0, _savedSearchFacets.toFacetString)(b.facets).toLowerCase();
    if (bFacetString > aFacetString) {
        return -1;
    } else if (aFacetString > bFacetString) {
        return 1;
    }
    return 0;
};

var compareFunctions = {
    LAST_SENT_ASCENDING: function LAST_SENT_ASCENDING() {
        var a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        if (!a || !a.lastSent || !a.lastSent) return 1;
        if (!b || !b.lastSent || !b.lastSent) return -1;
        return a.lastSent === b.lastSent ? savedSearchSortAscending(a, b) : Date.parse(a.lastSent) - Date.parse(b.lastSent);
    },
    LAST_SENT_DESCENDING: function LAST_SENT_DESCENDING() {
        var a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        if (!a || !a.lastSent || !a.lastSent) return 1;
        if (!b || !b.lastSent || !b.lastSent) return -1;
        return a.lastSent === b.lastSent ? savedSearchSortAscending(a, b) : Date.parse(b.lastSent) - Date.parse(a.lastSent);
    },
    SEARCH_TERM_ASCENDING: function SEARCH_TERM_ASCENDING() {
        var a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        return savedSearchSortAscending(a, b);
    },
    SEARCH_TERM_DESCENDING: function SEARCH_TERM_DESCENDING() {
        var a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        return savedSearchSortAscending(b, a);
    }
};

var savedSearchSearchFilter = function savedSearchSearchFilter(wrapper, searchString) {
    var searchTokens = searchString.toLowerCase().trim().split(/\s/);
    var matchingTokens = searchTokens.filter(function (token) {
        var facetString = (0, _savedSearchFacets.toFacetString)(wrapper.facets);
        return ('' + facetString).toLowerCase().includes(token);
    });
    var doesMatch = matchingTokens.length === searchTokens.length;
    return doesMatch;
};

var getFilteredSavedSearches = exports.getFilteredSavedSearches = function getFilteredSavedSearches(state) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        page = _ref.page,
        searchTerms = _ref.searchTerms;

    var sortOrder = arguments[2];
    var pageSize = arguments[3];

    var items = getSavedSearches(state);
    var loadedItems = items.filter(function (item) {
        return !(0, _isEmpty2.default)(item);
    });
    var loadedItemsCount = loadedItems.length;
    var filteredItems = searchTerms ? loadedItems.filter(function (itemWrapper) {
        return savedSearchSearchFilter(itemWrapper, searchTerms);
    }) : loadedItems;
    var sortedItems = sortOrder ? filteredItems.sort(compareFunctions[sortOrder]) : filteredItems;
    return {
        filteredCount: filteredItems.length || 0,
        items: (0, _pagination.pageSlicer)(sortedItems, pageSize, page) || [],
        loadedItemsCount: loadedItemsCount,
        totalCount: items.length || 0
    };
};

var getSavedSearchesCount = exports.getSavedSearchesCount = function getSavedSearchesCount(state) {
    var items = getSavedSearches(state);

    return items.length;
};

/* ACTION CREATORS */
var fetchSavedSearchesIfNeeded = exports.fetchSavedSearchesIfNeeded = function fetchSavedSearchesIfNeeded(force) {
    return function () {
        var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch, getState) {
            var state, authToken, deployment, response;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            state = getState();

                            if (!(force || shouldFetchSavedSearches(state))) {
                                _context.next = 15;
                                break;
                            }

                            authToken = (0, _user.getAuthToken)(state);
                            deployment = (0, _config.getDeployment)(state);
                            _context.prev = 4;

                            dispatch({
                                type: LOAD_SAVED_SEARCHES_REQUEST
                            });
                            _context.next = 8;
                            return _api.SaveSearch.fetchSavedSearches({ authToken: authToken, deployment: deployment });

                        case 8:
                            response = _context.sent;

                            dispatch({
                                meta: { actionTime: Date.now() },
                                payload: response.data,
                                type: LOAD_SAVED_SEARCHES_SUCCESS
                            });
                            _context.next = 15;
                            break;

                        case 12:
                            _context.prev = 12;
                            _context.t0 = _context['catch'](4);

                            dispatch({
                                error: true,
                                payload: _context.t0,
                                type: LOAD_SAVED_SEARCHES_FAIL
                            });

                        case 15:
                            return _context.abrupt('return', _promise2.default.resolve());

                        case 16:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, undefined, [[4, 12]]);
        }));

        return function (_x14, _x15) {
            return _ref2.apply(this, arguments);
        };
    }();
};

var submitDeleteSavedSearch = exports.submitDeleteSavedSearch = function submitDeleteSavedSearch(savedSearchId) {
    return function () {
        var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(dispatch, getState) {
            var state, authToken, deployment, analytics, response;
            return _regenerator2.default.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            state = getState();
                            authToken = (0, _user.getAuthToken)(state);
                            deployment = (0, _config.getDeployment)(state);
                            analytics = (0, _analytics.getUnfollowSearchAnalytics)();
                            _context2.prev = 4;

                            dispatch({
                                payload: savedSearchId,
                                type: DELETE_SAVED_SEARCH_REQUEST
                            });
                            _context2.next = 8;
                            return _api.SaveSearch.postDeleteSavedSearches({
                                authToken: authToken,
                                deployment: deployment,
                                savedSearchIds: [savedSearchId]
                            });

                        case 8:
                            response = _context2.sent;

                            dispatch({
                                meta: (0, _extends3.default)({ actionTime: Date.now() }, analytics, { savedSearchId: savedSearchId }),
                                payload: response.data,
                                type: DELETE_SAVED_SEARCH_SUCCESS
                            });
                            _context2.next = 15;
                            break;

                        case 12:
                            _context2.prev = 12;
                            _context2.t0 = _context2['catch'](4);

                            dispatch({
                                error: true,
                                meta: { savedSearchId: savedSearchId },
                                payload: _context2.t0,
                                type: DELETE_SAVED_SEARCH_FAIL
                            });

                        case 15:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, undefined, [[4, 12]]);
        }));

        return function (_x16, _x17) {
            return _ref3.apply(this, arguments);
        };
    }();
};

var toggleSavedSearchEmail = exports.toggleSavedSearchEmail = function toggleSavedSearchEmail(savedSearchId) {
    return function () {
        var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(dispatch, getState) {
            var state, authToken, deployment, search, response, _response;

            return _regenerator2.default.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            state = getState();
                            authToken = (0, _user.getAuthToken)(state);
                            deployment = (0, _config.getDeployment)(state);
                            search = getSavedSearchById(state, savedSearchId);

                            if (!search.sendAlert) {
                                _context3.next = 18;
                                break;
                            }

                            dispatch({
                                payload: savedSearchId,
                                type: UNSUBSCRIBE_SAVED_SEARCH_REQUEST
                            });
                            _context3.prev = 6;
                            _context3.next = 9;
                            return _api.SaveSearch.postUnsubscribeFromSavedSearches({
                                authToken: authToken,
                                deployment: deployment,
                                savedSearchIds: [savedSearchId]
                            });

                        case 9:
                            response = _context3.sent;

                            dispatch({
                                meta: { savedSearchId: savedSearchId },
                                payload: response.data,
                                type: UNSUBSCRIBE_SAVED_SEARCH_SUCCESS
                            });
                            _context3.next = 16;
                            break;

                        case 13:
                            _context3.prev = 13;
                            _context3.t0 = _context3['catch'](6);

                            dispatch({
                                error: true,
                                meta: { savedSearchId: savedSearchId },
                                payload: _context3.t0,
                                type: UNSUBSCRIBE_SAVED_SEARCH_FAIL
                            });

                        case 16:
                            _context3.next = 29;
                            break;

                        case 18:
                            dispatch({
                                payload: savedSearchId,
                                type: SUBSCRIBE_SAVED_SEARCH_REQUEST
                            });
                            _context3.prev = 19;
                            _context3.next = 22;
                            return _api.SaveSearch.postSubscribeToSavedSearches({
                                authToken: authToken,
                                deployment: deployment,
                                savedSearchIds: [savedSearchId]
                            });

                        case 22:
                            _response = _context3.sent;

                            dispatch({
                                meta: { savedSearchId: savedSearchId },
                                payload: _response.data,
                                type: SUBSCRIBE_SAVED_SEARCH_SUCCESS
                            });
                            _context3.next = 29;
                            break;

                        case 26:
                            _context3.prev = 26;
                            _context3.t1 = _context3['catch'](19);

                            dispatch({
                                error: true,
                                meta: { savedSearchId: savedSearchId },
                                payload: _context3.t1,
                                type: SUBSCRIBE_SAVED_SEARCH_FAIL
                            });

                        case 29:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, undefined, [[6, 13], [19, 26]]);
        }));

        return function (_x18, _x19) {
            return _ref4.apply(this, arguments);
        };
    }();
};

/***/ }),

/***/ "qyrl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"map":"map___3yJp2"};

/***/ }),

/***/ "r3q8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = __webpack_require__("dcb+");

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _Overlay = __webpack_require__("2CZH");

var _Overlay2 = _interopRequireDefault(_Overlay);

var _Popover = __webpack_require__("fdtx");

var _Popover2 = _interopRequireDefault(_Popover);

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propsComparer = __webpack_require__("wsGv");

var _propsComparer2 = _interopRequireDefault(_propsComparer);

var _classnames = __webpack_require__("HW6M");

var _classnames2 = _interopRequireDefault(_classnames);

var _reactFontawesome = __webpack_require__("f7W8");

var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);

var _noop = __webpack_require__("9vKl");

var _noop2 = _interopRequireDefault(_noop);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _DropDownMenu = __webpack_require__("8g7e");

var _DropDownMenu2 = _interopRequireDefault(_DropDownMenu);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DropDownMenu = (_temp = _class = function (_Component) {
    (0, _inherits3.default)(DropDownMenu, _Component);

    function DropDownMenu(props, context) {
        (0, _classCallCheck3.default)(this, DropDownMenu);

        var _this = (0, _possibleConstructorReturn3.default)(this, (DropDownMenu.__proto__ || (0, _getPrototypeOf2.default)(DropDownMenu)).call(this, props, context));

        _this.open = function () {
            _this.setState({ show: true });
        };

        _this.close = function () {
            _this.setState({ show: false });
        };

        _this.toggle = function () {
            _this.setState({ show: !_this.state.show });
        };

        _this.attachOnClickListener = function (links) {
            // attach a listener that will close the menu on click
            return links.map(function (link) {
                var onClick = void 0;
                if (link.props.onClick) {
                    onClick = function onClick(event) {
                        link.props.onClick(event);
                        if (link.type !== 'form') {
                            _this.close();
                        }
                    };
                } else {
                    onClick = _this.close;
                }
                return _react2.default.cloneElement(link, { onClick: onClick });
            });
        };

        _this.state = { show: false };
        return _this;
    }

    (0, _createClass3.default)(DropDownMenu, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps, nextState) {
            return (0, _propsComparer2.default)(this.props, nextProps, ['dropdownClass', 'links', 'mobile', 'parent', 'placement', 'popoverClass', 'title', 'titleClass']) || (0, _propsComparer2.default)(this.state, nextState, ['show']);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                dropdownClass = _props.dropdownClass,
                links = _props.links,
                mobile = _props.mobile,
                onEnter = _props.onEnter,
                onEntered = _props.onEntered,
                onExit = _props.onExit,
                onExited = _props.onExited,
                parent = _props.parent,
                placement = _props.placement,
                popoverClass = _props.popoverClass,
                title = _props.title,
                titleClass = _props.titleClass;


            var dropDownClassNames = (0, _classnames2.default)(_DropDownMenu2.default['dropdown-menu'], dropdownClass);
            var popOverClassNames = (0, _classnames2.default)(_DropDownMenu2.default.popover, popoverClass);
            var titleClassNames = (0, _classnames2.default)(_DropDownMenu2.default.title, titleClass);

            return (0, _jsx3.default)('div', {
                className: dropDownClassNames
            }, void 0, _react2.default.createElement(
                'a',
                {
                    ref: function ref(_ref) {
                        return _this2.targetRef = _ref;
                    },
                    onMouseEnter: !mobile ? this.open : _noop2.default,
                    onClick: this.toggle,
                    onMouseLeave: this.close
                },
                (0, _jsx3.default)('span', {
                    className: titleClassNames
                }, void 0, title, (0, _jsx3.default)(_reactFontawesome2.default, {
                    icon: this.state.show ? ['fas', 'caret-up'] : ['fas', 'caret-down'],
                    className: _DropDownMenu2.default.triangle
                }))
            ), (0, _jsx3.default)(_Overlay2.default, {
                show: this.state.show,
                onHide: this.close,
                placement: placement,
                target: this.targetRef,
                container: parent,
                onEnter: onEnter,
                onEntered: onEntered,
                onExit: onExit,
                onExited: onExited,
                rootClose: true
            }, void 0, (0, _jsx3.default)(_Popover2.default, {
                className: popOverClassNames,
                id: 'popover-trigger-click-root-close',
                onMouseOver: this.open,
                onMouseOut: this.close
            }, void 0, (0, _jsx3.default)('div', {
                className: _DropDownMenu2.default['dropdown-pop-up']
            }, void 0, this.attachOnClickListener(links)))));
        }
    }]);
    return DropDownMenu;
}(_react.Component), _class.defaultProps = {
    onEnter: _noop2.default,
    onEntered: _noop2.default,
    onExit: _noop2.default,
    onExited: _noop2.default
}, _temp);
exports.default = DropDownMenu;
module.exports = exports['default'];

/***/ }),

/***/ "rF6g":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CoverLotsRemote = undefined;

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _helpers = __webpack_require__("SY39");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CoverLotsRemote = exports.CoverLotsRemote = {
    fetchCoverLots: function fetchCoverLots(_ref) {
        var authToken = _ref.authToken,
            catalogIds = _ref.catalogIds,
            deployment = _ref.deployment;
        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makePost)('<ITEM-API>small/cover-lots', deployment);
            (0, _helpers.addAuthToken)(request, authToken);
            request.send({ ids: catalogIds });
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response });
            });
        });
    }
};

/***/ }),

/***/ "rVZG":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.setWindowSize = exports.getWindowSize = exports.SET_WINDOW_SIZE = undefined;

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;

var _reselect = __webpack_require__("bndy");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Action Types */
var SET_WINDOW_SIZE = exports.SET_WINDOW_SIZE = 'la/ui/windowSize/SET';

// reducer
var DEFAULT_STATE = {
    height: 1024,
    width: 1024
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        case SET_WINDOW_SIZE:
            return (0, _extends3.default)({}, state, {
                height: action.payload.height,
                width: action.payload.width
            });
        default:
            return state;
    }
}

/* SELECTORS */
var stateSelector = function stateSelector(state) {
    return state.ui.windowSize;
};

var getWindowSize = exports.getWindowSize = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state;
});

/* ACTION CREATORS */
var setWindowSize = exports.setWindowSize = function setWindowSize(_ref) {
    var height = _ref.height,
        width = _ref.width;
    return {
        payload: { height: height, width: width },
        type: SET_WINDOW_SIZE
    };
};

/***/ }),

/***/ "rWG9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"mobile":"mobile___20ki_","header":"header___1rM1t","app-store-link":"app-store-link___2ZVFT","ios":"ios___1BtPW","android":"android___19H4U"};

/***/ }),

/***/ "rdp+":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SellerCatalogsRemote = undefined;

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _helpers = __webpack_require__("SY39");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SellerCatalogsRemote = exports.SellerCatalogsRemote = {
    fetchSellerEndedCatalogsById: function fetchSellerEndedCatalogsById(_ref) {
        var authToken = _ref.authToken,
            count = _ref.count,
            deployment = _ref.deployment,
            page = _ref.page,
            sellerId = _ref.sellerId,
            sortTerm = _ref.sortTerm;
        return new _promise2.default(function (resolve, reject) {
            var query = {};
            var request = (0, _helpers.makeGet)('<ITEM-API>spa/small/seller/' + sellerId + '/recent', deployment);
            (0, _helpers.addAuthToken)(request, authToken);
            if (global.__SERVER__) {
                query.pageSize = count;
                query.cursor = (page - 1) * count;
                query.sortTerm = sortTerm;
            }
            request.query(query);
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response });
            });
        });
    },
    fetchSellerUpcomingCatalogsById: function fetchSellerUpcomingCatalogsById(_ref2) {
        var authToken = _ref2.authToken,
            deployment = _ref2.deployment,
            sellerId = _ref2.sellerId;
        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makeGet)('<ITEM-API>spa/small/seller/' + sellerId + '/upcoming', deployment);
            (0, _helpers.addAuthToken)(request, authToken);
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response });
            });
        });
    }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("DuR2")))

/***/ }),

/***/ "rj0E":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _catalogRegistration = __webpack_require__("yTM5");

var CatalogRegistation = {
    fetchCatalogRegistration: _catalogRegistration.CatalogRegistrationRemote.fetchCatalogRegistration
};

exports.default = CatalogRegistation;
module.exports = exports['default'];

/***/ }),

/***/ "rjim":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ItemDetailRemote = undefined;

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _helpers = __webpack_require__("SY39");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ItemDetailRemote = exports.ItemDetailRemote = {
    fetchItemDetailsByIds: function fetchItemDetailsByIds(_ref) {
        var authToken = _ref.authToken,
            deployment = _ref.deployment,
            itemIds = _ref.itemIds;
        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makePost)('<ITEM-API>spa/small/item-detail', deployment);
            (0, _helpers.addAuthToken)(request, authToken);
            request.send({ itemIds: itemIds });
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response });
            });
        });
    }
};

/***/ }),

/***/ "rkxl":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _defineProperty2 = __webpack_require__("bOdI");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _A = __webpack_require__("etkc");

var _A2 = _interopRequireDefault(_A);

var _propsComparer = __webpack_require__("wsGv");

var _propsComparer2 = _interopRequireDefault(_propsComparer);

var _classnames = __webpack_require__("HW6M");

var _classnames2 = _interopRequireDefault(_classnames);

var _noop = __webpack_require__("9vKl");

var _noop2 = _interopRequireDefault(_noop);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouter = __webpack_require__("CIox");

var _Link = __webpack_require__("hUkZ");

var _Link2 = _interopRequireDefault(_Link);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Link = (_temp2 = _class = function (_Component) {
    (0, _inherits3.default)(Link, _Component);

    function Link() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, Link);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Link.__proto__ || (0, _getPrototypeOf2.default)(Link)).call.apply(_ref, [this].concat(args))), _this), _this.refreshCurrentPage = function () {
            if (_this.props.route && '' + window.location.pathname + window.location.search === _this.props.to) {
                window.location.reload();
            }
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(Link, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps) {
            return (0, _propsComparer2.default)(this.props, nextProps, ['children', 'className', 'primary', 'primaryWeak', 'secondary', 'target', 'to']);
        }
    }, {
        key: 'render',
        value: function render() {
            var _classNames;

            var _props = this.props,
                className = _props.className,
                children = _props.children,
                onClick = _props.onClick,
                onMouseOut = _props.onMouseOut,
                onMouseOver = _props.onMouseOver,
                primary = _props.primary,
                primaryWeak = _props.primaryWeak,
                rel = _props.rel,
                route = _props.route,
                secondary = _props.secondary,
                target = _props.target,
                to = _props.to;


            var classes = (0, _classnames2.default)(_Link2.default.link, (_classNames = {}, (0, _defineProperty3.default)(_classNames, _Link2.default.primary, primary), (0, _defineProperty3.default)(_classNames, _Link2.default['primary-weak'], primaryWeak), (0, _defineProperty3.default)(_classNames, _Link2.default.secondary, secondary), _classNames), className);

            var linkProps = {
                className: classes
            };
            if (children) {
                linkProps.children = children;
            }
            if (onMouseOut) {
                linkProps.onMouseOut = onMouseOut;
            }
            if (onMouseOver) {
                linkProps.onMouseOver = onMouseOver;
            }
            if (rel) {
                linkProps.rel = rel;
            }

            linkProps.onClick = onClick || this.refreshCurrentPage;

            // only add a 'target' if not a route
            if (!route && target) {
                linkProps.target = target;
            }

            // depending on a route, add a 'to' or 'href'
            if (route && to) {
                linkProps.to = to;
            }
            if (!route && to) {
                linkProps.href = to;
            }

            return route ? _react2.default.createElement(_reactRouter.Link, linkProps) : _react2.default.createElement(_A2.default, linkProps);
        }
    }]);
    return Link;
}(_react.Component), _class.defaultProps = {
    children: '',
    className: '',
    onMouseOut: _noop2.default,
    onMouseOver: _noop2.default,
    primary: false,
    primaryWeak: false,
    rel: '',
    route: false,
    secondary: false,
    target: '',
    to: ''
}, _temp2);
exports.default = Link;
module.exports = exports['default'];

/***/ }),

/***/ "s0Az":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = __webpack_require__("dcb+");

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _urls = __webpack_require__("CakR");

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propsComparer = __webpack_require__("wsGv");

var _propsComparer2 = _interopRequireDefault(_propsComparer);

var _reactFontawesome = __webpack_require__("f7W8");

var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);

var _reactIntl = __webpack_require__("Pq8k");

var _components = __webpack_require__("bGai");

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Support = __webpack_require__("/MQq");

var _Support2 = _interopRequireDefault(_Support);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var year = new Date().getFullYear();

var Support = function (_Component) {
    (0, _inherits3.default)(Support, _Component);

    function Support() {
        (0, _classCallCheck3.default)(this, Support);
        return (0, _possibleConstructorReturn3.default)(this, (Support.__proto__ || (0, _getPrototypeOf2.default)(Support)).apply(this, arguments));
    }

    (0, _createClass3.default)(Support, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps) {
            return (0, _propsComparer2.default)(this.props, nextProps, ['userData']);
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                baseUrl = _props.baseUrl,
                classicBaseUrl = _props.classicBaseUrl,
                openHealthcheckModal = _props.openHealthcheckModal,
                userData = _props.userData;
            var email = userData.email,
                _userData$firstName = userData.firstName,
                firstName = _userData$firstName === undefined ? '' : _userData$firstName,
                _userData$lastName = userData.lastName,
                lastName = _userData$lastName === undefined ? '' : _userData$lastName;

            var name = (firstName + ' ' + lastName).trim();

            return (0, _jsx3.default)('div', {
                className: _Support2.default.support
            }, void 0, (0, _jsx3.default)('div', {
                className: _Support2.default.container
            }, void 0, (0, _jsx3.default)('div', {
                className: _Support2.default.column
            }, void 0, (0, _jsx3.default)('div', {
                className: _Support2.default.wrapper
            }, void 0, (0, _jsx3.default)('div', {
                className: _Support2.default['column-title']
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'company'
            })), (0, _jsx3.default)('ul', {}, void 0, (0, _jsx3.default)('li', {}, void 0, (0, _jsx3.default)(_components.Link, {
                route: true,
                to: '/about'
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'about'
            }))), (0, _jsx3.default)('li', {}, void 0, (0, _jsx3.default)(_components.Link, {
                target: '_blank',
                to: 'https://careers.jobscore.com/careers/liveauctioneers',
                rel: 'noopener'
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'careers'
            }))), (0, _jsx3.default)('li', {}, void 0, (0, _jsx3.default)(_components.Link, {
                target: '_blank',
                to: baseUrl + '/news/',
                rel: 'noopener'
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'auction_central_news'
            }))), (0, _jsx3.default)('li', {}, void 0, (0, _jsx3.default)(_components.Link, {
                target: '_blank',
                to: 'https://liveauctioneers.desk.com/',
                rel: 'noopener'
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'support_center'
            }))), (0, _jsx3.default)('li', {}, void 0, (0, _jsx3.default)(_components.Link, {
                target: '_blank',
                to: 'https://liveauctioneers.desk.com/',
                rel: 'noopener'
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'contact_us'
            })))))), (0, _jsx3.default)('div', {
                className: _Support2.default.column
            }, void 0, (0, _jsx3.default)('div', {
                className: _Support2.default.wrapper
            }, void 0, (0, _jsx3.default)('div', {
                className: _Support2.default['column-title']
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'winning'
            })), (0, _jsx3.default)('ul', {}, void 0, (0, _jsx3.default)('li', {}, void 0, (0, _jsx3.default)(_components.Link, {
                route: true,
                to: '/how-it-works'
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'how_auctions_work'
            }))), (0, _jsx3.default)('li', {}, void 0, (0, _jsx3.default)(_components.Link, {
                route: true,
                to: (0, _urls.getAllUpcomingAuctionsUrl)()
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'auction_calendar'
            }))), (0, _jsx3.default)('li', {}, void 0, (0, _jsx3.default)(_components.Link, {
                route: true,
                to: (0, _urls.getAuctioneerDirectoryUrl)()
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'auction_house_directory'
            }))), (0, _jsx3.default)('li', {}, void 0, (0, _jsx3.default)(_components.Link, {
                route: true,
                to: '/find-auctions-near-me'
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'auctions_near_you'
            }))), (0, _jsx3.default)('li', {}, void 0, (0, _jsx3.default)(_components.Link, {
                route: true,
                to: (0, _urls.getAuctionResultsUrl)()
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'auction_result_search'
            }))), (0, _jsx3.default)('li', {}, void 0, (0, _jsx3.default)(_components.Link, {
                route: true,
                to: '/mobile'
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'mobile'
            })))))), (0, _jsx3.default)('div', {
                className: _Support2.default.column
            }, void 0, (0, _jsx3.default)('div', {
                className: _Support2.default.wrapper
            }, void 0, (0, _jsx3.default)('div', {
                className: _Support2.default['column-title']
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'selling'
            })), (0, _jsx3.default)('ul', {}, void 0, (0, _jsx3.default)('li', {}, void 0, (0, _jsx3.default)(_components.Link, {
                route: true,
                to: '/features'
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'why_sell'
            }))), (0, _jsx3.default)('li', {}, void 0, (0, _jsx3.default)(_components.Link, {
                route: true,
                to: '/seller-testimonials'
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'seller_testimonials'
            }))), (0, _jsx3.default)('li', {}, void 0, (0, _jsx3.default)('a', {
                target: '_blank',
                href: baseUrl + '/pages/sell/'
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'become_a_seller'
            }))), (0, _jsx3.default)('li', {}, void 0, (0, _jsx3.default)(_components.Link, {
                route: true,
                to: '/consignments'
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'consign_an_item'
            }))), (0, _jsx3.default)('li', {}, void 0, (0, _jsx3.default)(_components.Link, {
                target: '_blank',
                to: classicBaseUrl + '/user/login.html?url=/auctioneers/',
                rel: 'nofollow'
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'auctioneer_sign_in'
            }))))))), (0, _jsx3.default)('div', {
                className: _Support2.default['container-using']
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'using'
            }), ': \xA0', (0, _jsx3.default)('span', {
                className: _Support2.default['new-site']
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'the_new_liveauctioneers_site'
            })), ' ', '\xA0', (0, _jsx3.default)(_components.Link, {
                to: classicBaseUrl,
                className: _Support2.default['classic-link'],
                rel: 'nofollow'
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'classic_site'
            }))), (0, _jsx3.default)('div', {
                className: _Support2.default['social-icons']
            }, void 0, (0, _jsx3.default)('a', {
                className: _Support2.default.email,
                alt: 'Email',
                href: (0, _urls.getDeskSupportEmail)(name, email),
                target: '_blank',
                rel: 'noopener'
            }, void 0, '\xA0'), (0, _jsx3.default)('a', {
                className: _Support2.default.twitter,
                alt: 'Twitter',
                href: 'https://twitter.com/liveauctioneers/',
                target: '_blank',
                rel: 'noopener'
            }, void 0, '\xA0'), (0, _jsx3.default)('a', {
                className: _Support2.default.facebook,
                alt: 'Facebook',
                href: 'https://www.facebook.com/LiveAuctioneers/',
                target: '_blank',
                rel: 'noopener'
            }, void 0, '\xA0'), (0, _jsx3.default)('a', {
                className: _Support2.default.pinterest,
                alt: 'Pinterest',
                href: 'https://www.pinterest.com/liveauctioneers/',
                target: '_blank',
                rel: 'noopener'
            }, void 0, '\xA0')), (0, _jsx3.default)('div', {
                className: _Support2.default['container-copyright']
            }, void 0, (0, _jsx3.default)('div', {
                className: _Support2.default.copyright
            }, void 0, (0, _jsx3.default)('span', {}, void 0, '\xA9'), ' ', (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'copyright',
                values: { year: year }
            }), (0, _jsx3.default)(_components.Link, {
                route: true,
                to: (0, _urls.getTermsAndConditionsUrl)()
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'terms_and_conditions'
            })), (0, _jsx3.default)(_components.Link, {
                route: true,
                to: (0, _urls.getPrivacyUrl)()
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'privacy_policy'
            })), (0, _jsx3.default)(_reactFontawesome2.default, {
                className: _Support2.default.health,
                icon: ['fas', 'tachometer-alt'],
                onClick: openHealthcheckModal
            })), (0, _jsx3.default)('div', {
                className: _Support2.default.sitemap
            }, void 0, (0, _jsx3.default)('span', {
                className: _Support2.default['bold-title']
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'sitemap'
            }), ':'), (0, _jsx3.default)(_components.Link, {
                to: 'https://www.liveauctioneers.com/browse/archive/page1',
                target: '_blank',
                rel: 'noopener'
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'past_auctions'
            })), (0, _jsx3.default)(_components.Link, {
                to: 'https://www.liveauctioneers.com/browse/',
                target: '_blank',
                rel: 'noopener'
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'upcoming_auctions'
            })), (0, _jsx3.default)(_components.Link, {
                to: 'https://www.liveauctioneers.com/search_auctioneers.html',
                target: '_blank',
                rel: 'noopener'
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'auctioneer_directory'
            })))));
        }
    }]);
    return Support;
}(_react.Component);

exports.default = Support;
module.exports = exports['default'];

/***/ }),

/***/ "sPdJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"item-card":"item-card___3_cUz","placeholder":"placeholder___Qa-a3","item-title":"item-title___3zS_6","auctioneer-link":"auctioneer-link___38t-L","lot-number":"lot-number___1bbG2","pipe":"pipe___2HOUl","item-save":"item-save___3Pe81","item-current-bid":"item-current-bid___j1nna","item-bid-count":"item-bid-count___3Y9db","item-is-live-link":"item-is-live-link___NE4d7","catalog-countdown-container":"catalog-countdown-container___11GWP","item-image-link-container":"item-image-link-container___3pHDD","image-container":"image-container___1PDU3","image":"image___1NmzI","item-title-container":"item-title-container___28diB","item-bids-container":"item-bids-container___Nn-yg","item-current-bid-container":"item-current-bid-container___2nt0S","price-gateway-container":"price-gateway-container___k8XZD","estimate-house-time-container":"estimate-house-time-container___2vr4h","auctioneer-link-container":"auctioneer-link-container___17sbF","estimate-link-container":"estimate-link-container___LVUWm","auctioneer-name-container":"auctioneer-name-container___bUnP4","estimate-name-container":"estimate-name-container___20cNY","item-is-live":"item-is-live___28Yzo"};

/***/ }),

/***/ "sSv9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _checkout = __webpack_require__("f9A3");

exports.default = {
    fetchInvoice: _checkout.Checkout.fetchInvoice
};
module.exports = exports['default'];

/***/ }),

/***/ "sjfW":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getSimilarItems = exports.getSimilarItemIds = exports.LOAD_SIMILAR_ITEMS_SUCCESS = exports.LOAD_SIMILAR_ITEMS_REQUEST = exports.LOAD_SIMILAR_ITEMS_FAIL = undefined;

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _regenerator = __webpack_require__("Xxa5");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__("exGp");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _defineProperty2 = __webpack_require__("bOdI");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends4 = __webpack_require__("Dd8w");

var _extends5 = _interopRequireDefault(_extends4);

exports.default = reducer;
exports.fetchSimilarItemsIfNeeded = fetchSimilarItemsIfNeeded;

var _api = __webpack_require__("zFQO");

var _reselect = __webpack_require__("bndy");

var _difference = __webpack_require__("WlNK");

var _difference2 = _interopRequireDefault(_difference);

var _user = __webpack_require__("CFLi");

var _config = __webpack_require__("iS9E");

var _cardData = __webpack_require__("6OFE");

var _ms = __webpack_require__("EarI");

var _ms2 = _interopRequireDefault(_ms);

var _union = __webpack_require__("gszD");

var _union2 = _interopRequireDefault(_union);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Action Types */
var LOAD_SIMILAR_ITEMS_FAIL = exports.LOAD_SIMILAR_ITEMS_FAIL = 'la/domain/similarItems/LOAD_FAIL';
var LOAD_SIMILAR_ITEMS_REQUEST = exports.LOAD_SIMILAR_ITEMS_REQUEST = 'la/domain/similarItems/LOAD_REQUEST';
var LOAD_SIMILAR_ITEMS_SUCCESS = exports.LOAD_SIMILAR_ITEMS_SUCCESS = 'la/domain/similarItems/LOAD_SUCCESS';

var REDUX_STORE_TIME = (0, _ms2.default)('30m');

/* reducer */
var DEFAULT_STATE = {
    byId: {},
    loaded: {},
    loading: []
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        case LOAD_SIMILAR_ITEMS_FAIL:
            return (0, _extends5.default)({}, state, {
                loading: (0, _difference2.default)(state.loading, [action.meta.itemId])
            });
        case LOAD_SIMILAR_ITEMS_REQUEST:
            return (0, _extends5.default)({}, state, {
                loading: (0, _union2.default)(state.loading, [action.payload])
            });
        case LOAD_SIMILAR_ITEMS_SUCCESS:
            return (0, _extends5.default)({}, state, {
                byId: (0, _extends5.default)({}, state.byId, (0, _defineProperty3.default)({}, action.meta.itemId, action.payload.itemIDs)),
                loaded: (0, _extends5.default)({}, state.loaded, (0, _defineProperty3.default)({}, action.meta.itemId, action.meta.actionTime)),
                loading: (0, _difference2.default)(state.loading, [action.meta.itemId])
            });
        default:
            return state;
    }
}

/* SELECTORS */
var stateSelector = function stateSelector(state) {
    return state.domain.similarItems;
};
var idSelector = function idSelector(state, id) {
    return id;
};

var byIdSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.byId;
});

var loadedSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.loaded;
});

var loadingSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.loading;
});

// takes in a (state, id) and returns data
var getSimilarItemIds = exports.getSimilarItemIds = (0, _reselect.createSelector)([byIdSelector, idSelector], function (byId, id) {
    return byId[id] || [];
});

// takes in a (state, id) and returns load time
var getLoadTimeForSimilarItems = (0, _reselect.createSelector)([loadedSelector, idSelector], function (loaded, id) {
    return loaded[id] || 0;
});

// takes in a (state, id) and returns if data is loading
var isSimilarItemsLoading = (0, _reselect.createSelector)([loadingSelector, idSelector], function (loading, id) {
    return loading.includes(id);
});

var getSimilarItems = exports.getSimilarItems = function getSimilarItems(state, itemId, limit) {
    var similarItemIds = getSimilarItemIds(state, itemId);
    similarItemIds = similarItemIds.filter(function (id) {
        return id !== itemId;
    });
    similarItemIds = similarItemIds.slice(0, limit);
    return (0, _cardData.getItemCardDatas)(state, similarItemIds);
};

var shouldFetchSimilarItems = function shouldFetchSimilarItems(state, itemId) {
    if (!itemId) return false;
    var item = getSimilarItems(state, itemId);
    if (item.length) {
        var loaded = getLoadTimeForSimilarItems(state, itemId);
        var time = Date.now();
        var diff = time - loaded;
        if (diff < REDUX_STORE_TIME) return false;
    }
    var loading = isSimilarItemsLoading(state, itemId);
    return !loading;
};

/* ACTION CREATORS */
var loadSimilarItems = function loadSimilarItems(similarItemInfo) {
    return function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch, getState) {
            var state, authToken, deployment, response;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.prev = 0;
                            state = getState();
                            authToken = (0, _user.getAuthToken)(state);
                            deployment = (0, _config.getDeployment)(state);

                            dispatch({
                                payload: similarItemInfo.itemId,
                                type: LOAD_SIMILAR_ITEMS_REQUEST
                            });
                            _context.next = 7;
                            return _api.SimilarItems.fetchSimilarItems({ authToken: authToken, deployment: deployment, similarItemInfo: similarItemInfo });

                        case 7:
                            response = _context.sent;

                            dispatch({
                                meta: { actionTime: Date.now(), itemId: similarItemInfo.itemId },
                                payload: response,
                                type: LOAD_SIMILAR_ITEMS_SUCCESS
                            });
                            _context.next = 14;
                            break;

                        case 11:
                            _context.prev = 11;
                            _context.t0 = _context['catch'](0);

                            dispatch({
                                error: true,
                                meta: { itemId: similarItemInfo.itemId },
                                payload: _context.t0,
                                type: LOAD_SIMILAR_ITEMS_FAIL
                            });

                        case 14:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, undefined, [[0, 11]]);
        }));

        return function (_x3, _x4) {
            return _ref.apply(this, arguments);
        };
    }();
};

function fetchSimilarItemsIfNeeded(similarItemInfo) {
    return function (dispatch, getState) {
        if (similarItemInfo && shouldFetchSimilarItems(getState(), similarItemInfo.itemId)) {
            return dispatch(loadSimilarItems(similarItemInfo));
        }
        return _promise2.default.resolve();
    };
}

/***/ }),

/***/ "ssAn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"carousel":"carousel___2R0nD"};

/***/ }),

/***/ "t5WM":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _config = __webpack_require__("QmSG");

var _config2 = _interopRequireDefault(_config);

var _en = __webpack_require__("eNmu");

var _en2 = _interopRequireDefault(_en);

var _flattenMessages = __webpack_require__("X4s9");

var _flattenMessages2 = _interopRequireDefault(_flattenMessages);

var _getBrowserDataFromUA = __webpack_require__("COnH");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getCookieValue(a) {
    var b = typeof document !== 'undefined' && document.cookie.match('(^|;)\\s*' + a + '\\s*=\\s*([^;]+)');
    return b ? b.pop() : '';
}

var DEFAULT_ITEMS_TO_SHOW = 24;

var getPageSizeFromCookie = function getPageSizeFromCookie(cookie) {
    return cookie === 'all' ? 'all' : Number(cookie);
};

var getInitialData = function getInitialData() {
    var req = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { cookies: [], headers: [], hostname: '', url: '' };
    var whiteLabelInfo = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    // check the cookie for a valid token
    var token = req.cookies['bidder-auth'] || getCookieValue('bidder-auth') || '';
    var authName = req.cookies['5Xq_name'] || getCookieValue('5Xq_name') || '';
    var authNuid = req.cookies['5Xq_nuid'] || getCookieValue('5Xq_nuid') || '';
    var authVerify = req.cookies['5Xq_nverify'] || getCookieValue('5Xq_nverify') || '';
    var referrer = req.headers.referer || '';
    var userAgent = req.headers['user-agent'] || navigator.userAgent || '';
    var browser = (0, _getBrowserDataFromUA.getBrowserDataFromUA)(userAgent);
    var touchDate = new Date().getTime();
    var flatMessages = (0, _flattenMessages2.default)(_en2.default);
    var dateLastShown = req.cookies['join-modal-last-seen'] || getCookieValue('join-modal-last-seen') || '';
    var hasLoggedInBefore = !!(req.cookies['bidder-has-logged-in'] || getCookieValue('bidder-has-logged-in') || !!token);
    var disableModalForTesting = req.url.includes('hideForTesting') || req.url.includes('/console/');
    var pageSize = getPageSizeFromCookie(req.cookies['pagination-page-size']) || getPageSizeFromCookie(getCookieValue('pagination-page-size')) || DEFAULT_ITEMS_TO_SHOW;

    var whiteLabel = {
        hostname: req.hostname,
        isWhiteLabel: false,
        logo: 'https://p1.liveauctioneers.com/dist/images/logo.svg',
        sellerId: 0
    };

    var optimizer = '';

    var _ref = browser || {},
        _ref$name = _ref.name,
        name = _ref$name === undefined ? '' : _ref$name;

    optimizer = name.toLowerCase() === 'chrome' ? '?auto=webp&format=pjpg' : '';

    if (whiteLabelInfo) {
        var sellerName = whiteLabelInfo.name,
            sellerId = whiteLabelInfo.sellerId,
            website = whiteLabelInfo.website,
            logoId = whiteLabelInfo.logoId;

        var siteNameMatch = (website || '').match(/^(?:https?:\/\/)?(?:[w]{3}\.)?(.*)$/);
        var siteName = siteNameMatch && siteNameMatch[1].length > 0 ? siteNameMatch[1].replace(/\/+$/, '') : '';

        whiteLabel = {
            hostname: req.hostname,
            isWhiteLabel: true,
            logo: !logoId || logoId === '' ? null : 'https://images.liveauctioneers.com/houses/logos/lg/' + logoId + '_large.jpg' + optimizer,
            name: sellerName,
            sellerId: sellerId,
            siteName: siteName,
            siteUrl: website || ''
        };
    }

    return {
        config: _config2.default,
        intl: {
            defaultLocale: 'en',
            locale: 'en',
            messages: flatMessages
        },
        ui: {
            analytics: {
                referrer: referrer,
                touchDate: touchDate
            },
            autoPopModal: {
                dateLastShown: dateLastShown,
                disableModalForTesting: disableModalForTesting,
                hasLoggedInBefore: hasLoggedInBefore
            },
            browser: browser,
            pagination: {
                pageSize: pageSize
            }
        },
        user: {
            user: { authName: authName, authNuid: authNuid, authVerify: authVerify, token: token, userData: {} }
        },
        whiteLabel: whiteLabel
    };
};

exports.default = getInitialData;
module.exports = exports['default'];

/***/ }),

/***/ "u90i":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.openTermsModal = exports.openUpdatePasswordModal = exports.openSetPasswordModal = exports.openSendSellerMessageModal = exports.openSendSellerConsignmentMessageModal = exports.openRetractBidModal = exports.openRegisterForCatalogModal = exports.openAbstenteeBidModal = exports.openLoginModal = exports.openLiveBidModal = exports.openItemDescriptionModal = exports.openInstallFlashModal = exports.openHealthcheckModal = exports.openForgotPasswordModal = exports.openDownloadMobileModal = exports.openCreateAccountModal = exports.openConsignmentConfirmModal = exports.openConfirmPasswordModal = exports.openCompleteAccountModal = exports.openAddSearchAlertModal = exports.openAddCreditCardModal = exports.dismissModal = exports.completeSendSellerMessageModal = exports.completeLoginModal = exports.closeModalAndCheckCreditCard = exports.getOpenModal = exports.OPEN_TERMS_MODAL = exports.OPEN_SET_PASSWORD_MODAL = exports.OPEN_SEND_SELLER_MESSAGE_MODAL = exports.OPEN_SEND_SELLER_CONSIGNMENT_MESSAGE_MODAL = exports.OPEN_RETRACT_BID_MODAL = exports.OPEN_REGISTER_FOR_CATALOG_MODAL = exports.OPEN_LOGIN_MODAL = exports.OPEN_LIVE_BID_MODAL = exports.OPEN_ITEM_DESCRIPTION_MODAL = exports.OPEN_INSTALL_FLASH_MODAL = exports.OPEN_HEALTHCHECK_MODAL = exports.OPEN_FORGOT_PASSWORD_MODAL = exports.OPEN_DOWNLOAD_MOBILE_MODAL = exports.OPEN_CREATE_ACCOUNT_MODAL = exports.OPEN_CONSIGNMENT_CONFIRM_MODAL = exports.OPEN_CONFIRM_PASSWORD_MODAL = exports.OPEN_COMPLETE_ACCOUNT_MODAL = exports.OPEN_CHANGE_PASSWORD_MODAL = exports.OPEN_ADD_SEARCH_ALERT_MODAL = exports.OPEN_ADD_CREDIT_CARD_MODAL = exports.OPEN_ABSENTEE_BID_MODAL = exports.DISMISS_MODAL = exports.COMPLETE_SEND_SELLER_MESSAGE_MODAL = exports.COMPLETE_LOGIN_MODAL = exports.COMPLETE_CONFIRM_PASSWORD_MODAL = exports.COMPLETE_COMPLETE_ACCOUNT_MODAL = undefined;

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;

var _shouldLogin = __webpack_require__("57qU");

var _completeAccount = __webpack_require__("Qs/t");

var _createAccount = __webpack_require__("FneX");

var _reselect = __webpack_require__("bndy");

var _forgotPassword = __webpack_require__("vOFV");

var _user = __webpack_require__("CFLi");

var _login = __webpack_require__("SpFG");

var _enums = __webpack_require__("cjn6");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Action Types */
var COMPLETE_COMPLETE_ACCOUNT_MODAL = exports.COMPLETE_COMPLETE_ACCOUNT_MODAL = 'COMPLETE_COMPLETE_ACCOUNT_MODAL';
var COMPLETE_CONFIRM_PASSWORD_MODAL = exports.COMPLETE_CONFIRM_PASSWORD_MODAL = 'COMPLETE_CONFIRM_PASSWORD_MODAL';
var COMPLETE_LOGIN_MODAL = exports.COMPLETE_LOGIN_MODAL = 'COMPLETE_LOGIN_MODAL'; // this is not used.  LOGIN_SUCCESS is used instead.
var COMPLETE_SEND_SELLER_MESSAGE_MODAL = exports.COMPLETE_SEND_SELLER_MESSAGE_MODAL = 'COMPLETE_SEND_SELLER_MESSAGE_MODAL';
var DISMISS_MODAL = exports.DISMISS_MODAL = 'DISMISS_MODAL';
var OPEN_ABSENTEE_BID_MODAL = exports.OPEN_ABSENTEE_BID_MODAL = 'OPEN_ABSENTEE_BID_MODAL';
var OPEN_ADD_CREDIT_CARD_MODAL = exports.OPEN_ADD_CREDIT_CARD_MODAL = 'OPEN_ADD_CREDIT_CARD_MODAL';
var OPEN_ADD_SEARCH_ALERT_MODAL = exports.OPEN_ADD_SEARCH_ALERT_MODAL = 'OPEN_ADD_SEARCH_ALERT_MODAL';
var OPEN_CHANGE_PASSWORD_MODAL = exports.OPEN_CHANGE_PASSWORD_MODAL = 'OPEN_CHANGE_PASSWORD_MODAL';
var OPEN_COMPLETE_ACCOUNT_MODAL = exports.OPEN_COMPLETE_ACCOUNT_MODAL = 'OPEN_COMPLETE_ACCOUNT_MODAL';
var OPEN_CONFIRM_PASSWORD_MODAL = exports.OPEN_CONFIRM_PASSWORD_MODAL = 'OPEN_CONFIRM_PASSWORD_MODAL';
var OPEN_CONSIGNMENT_CONFIRM_MODAL = exports.OPEN_CONSIGNMENT_CONFIRM_MODAL = 'OPEN_CONSIGNMENT_CONFIRM_MODAL';
var OPEN_CREATE_ACCOUNT_MODAL = exports.OPEN_CREATE_ACCOUNT_MODAL = 'OPEN_CREATE_ACCOUNT_MODAL';
var OPEN_DOWNLOAD_MOBILE_MODAL = exports.OPEN_DOWNLOAD_MOBILE_MODAL = 'OPEN_DOWNLOAD_MOBILE_MODAL';
var OPEN_FORGOT_PASSWORD_MODAL = exports.OPEN_FORGOT_PASSWORD_MODAL = 'OPEN_FORGOT_PASSWORD_MODAL';
var OPEN_HEALTHCHECK_MODAL = exports.OPEN_HEALTHCHECK_MODAL = 'OPEN_HEALTHCHECK_MODAL';
var OPEN_INSTALL_FLASH_MODAL = exports.OPEN_INSTALL_FLASH_MODAL = 'OPEN_INSTALL_FLASH_MODAL';
var OPEN_ITEM_DESCRIPTION_MODAL = exports.OPEN_ITEM_DESCRIPTION_MODAL = 'OPEN_ITEM_DESCRIPTION_MODAL';
var OPEN_LIVE_BID_MODAL = exports.OPEN_LIVE_BID_MODAL = 'OPEN_LIVE_BID_MODAL';
var OPEN_LOGIN_MODAL = exports.OPEN_LOGIN_MODAL = 'OPEN_LOGIN_MODAL';
var OPEN_REGISTER_FOR_CATALOG_MODAL = exports.OPEN_REGISTER_FOR_CATALOG_MODAL = 'OPEN_REGISTER_FOR_CATALOG_MODAL';
var OPEN_RETRACT_BID_MODAL = exports.OPEN_RETRACT_BID_MODAL = 'OPEN_RETRACT_BID_MODAL';
var OPEN_SEND_SELLER_CONSIGNMENT_MESSAGE_MODAL = exports.OPEN_SEND_SELLER_CONSIGNMENT_MESSAGE_MODAL = 'OPEN_SEND_SELLER_CONSIGNMENT_MESSAGE_MODAL';
var OPEN_SEND_SELLER_MESSAGE_MODAL = exports.OPEN_SEND_SELLER_MESSAGE_MODAL = 'OPEN_SEND_SELLER_MESSAGE_MODAL';
var OPEN_SET_PASSWORD_MODAL = exports.OPEN_SET_PASSWORD_MODAL = 'OPEN_SET_PASSWORD_MODAL';
var OPEN_TERMS_MODAL = exports.OPEN_TERMS_MODAL = 'OPEN_TERMS_MODAL';

// reducer
var DEFAULT_STATE = {
    modal: _enums.modalTypes.NONE
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        case _completeAccount.COMPLETE_ACCOUNT_SUCCESS:
        case COMPLETE_COMPLETE_ACCOUNT_MODAL:
        case COMPLETE_SEND_SELLER_MESSAGE_MODAL:
        case _createAccount.CREATE_ACCOUNT_SUCCESS:
        case DISMISS_MODAL:
        case _login.LOGIN_SUCCESS:
            return (0, _extends3.default)({}, state, {
                modal: _enums.modalTypes.NONE
            });
        case OPEN_ADD_SEARCH_ALERT_MODAL:
            return (0, _extends3.default)({}, state, {
                modal: _enums.modalTypes.ADD_SEARCH_ALERT
            });
        case OPEN_ADD_CREDIT_CARD_MODAL:
            return (0, _extends3.default)({}, state, {
                modal: _enums.modalTypes.ADD_CREDIT_CARD
            });
        case OPEN_ABSENTEE_BID_MODAL:
            return (0, _extends3.default)({}, state, {
                modal: _enums.modalTypes.ABSENTEE_BID
            });
        case OPEN_COMPLETE_ACCOUNT_MODAL:
        case _shouldLogin.OPEN_COMPLETE_ACCOUNT_MODAL_FROM_CHECKER:
            return (0, _extends3.default)({}, state, {
                modal: _enums.modalTypes.COMPLETE_ACCOUNT
            });
        case OPEN_CREATE_ACCOUNT_MODAL:
            return (0, _extends3.default)({}, state, {
                modal: _enums.modalTypes.SIGN_UP
            });
        case OPEN_DOWNLOAD_MOBILE_MODAL:
            return (0, _extends3.default)({}, state, {
                modal: _enums.modalTypes.DOWNLOAD_MOBILE
            });
        case OPEN_HEALTHCHECK_MODAL:
            return (0, _extends3.default)({}, state, {
                modal: _enums.modalTypes.HEALTHCHECK
            });
        case OPEN_INSTALL_FLASH_MODAL:
            return (0, _extends3.default)({}, state, {
                modal: _enums.modalTypes.INSTALL_FLASH
            });
        case OPEN_ITEM_DESCRIPTION_MODAL:
            return (0, _extends3.default)({}, state, {
                modal: _enums.modalTypes.ITEM_DESCRIPTION
            });
        case OPEN_CHANGE_PASSWORD_MODAL:
            return (0, _extends3.default)({}, state, {
                modal: _enums.modalTypes.CHANGE_PASSWORD
            });
        case OPEN_CONFIRM_PASSWORD_MODAL:
        case _shouldLogin.OPEN_CONFIRM_PASSWORD_MODAL_FROM_CHECKER:
            return (0, _extends3.default)({}, state, {
                modal: _enums.modalTypes.CONFIRM_PASSWORD
            });
        case OPEN_CONSIGNMENT_CONFIRM_MODAL:
            return (0, _extends3.default)({}, state, {
                modal: _enums.modalTypes.CONFIRM_CONSIGNMENT
            });
        case _forgotPassword.FORGOT_PASSWORD_FAIL:
        case OPEN_FORGOT_PASSWORD_MODAL:
            return (0, _extends3.default)({}, state, {
                modal: _enums.modalTypes.FORGOT_PASSWORD
            });
        case OPEN_LIVE_BID_MODAL:
            return (0, _extends3.default)({}, state, {
                modal: _enums.modalTypes.LIVE_BID
            });
        case OPEN_LOGIN_MODAL:
        case _shouldLogin.OPEN_LOGIN_MODAL_FROM_CHECKER:
            return (0, _extends3.default)({}, state, {
                modal: _enums.modalTypes.LOGIN
            });
        case OPEN_RETRACT_BID_MODAL:
            return (0, _extends3.default)({}, state, {
                modal: _enums.modalTypes.RETRACT_BID
            });
        case OPEN_REGISTER_FOR_CATALOG_MODAL:
            return (0, _extends3.default)({}, state, {
                modal: _enums.modalTypes.REGISTER_FOR_AUCTION
            });
        case OPEN_SEND_SELLER_CONSIGNMENT_MESSAGE_MODAL:
            return (0, _extends3.default)({}, state, {
                modal: _enums.modalTypes.SEND_SELLER_CONSIGNMENT_MESSAGE
            });
        case OPEN_SEND_SELLER_MESSAGE_MODAL:
            return (0, _extends3.default)({}, state, {
                modal: _enums.modalTypes.SEND_SELLER_MESSAGE
            });
        case OPEN_SET_PASSWORD_MODAL:
        case _shouldLogin.OPEN_SET_PASSWORD_MODAL_FROM_CHECKER:
            return (0, _extends3.default)({}, state, {
                modal: _enums.modalTypes.SET_PASSWORD
            });
        case OPEN_TERMS_MODAL:
            return (0, _extends3.default)({}, state, {
                modal: _enums.modalTypes.TERMS
            });
        default:
            return state;
    }
}

/* SELECTORS */
var modalSelector = function modalSelector(state) {
    return state.ui.modal;
};

var getOpenModal = exports.getOpenModal = (0, _reselect.createSelector)(modalSelector, function (modal) {
    return modal.modal || _enums.modalTypes.NONE;
});

/* ACTION CREATORS */
var closeModalAndCheckCreditCard = exports.closeModalAndCheckCreditCard = function closeModalAndCheckCreditCard(preventAddCreditCardModal) {
    return function (dispatch, getState) {
        var state = getState();

        var _getUserData = (0, _user.getUserData)(state),
            creditCardValidated = _getUserData.creditCardValidated;

        dispatch(dismissModal());
        if (!creditCardValidated && !preventAddCreditCardModal) {
            dispatch(openAddCreditCardModal());
        }
    };
};

var completeLoginModal = exports.completeLoginModal = function completeLoginModal() {
    return {
        type: COMPLETE_LOGIN_MODAL
    };
};

var completeSendSellerMessageModal = exports.completeSendSellerMessageModal = function completeSendSellerMessageModal() {
    return {
        type: COMPLETE_SEND_SELLER_MESSAGE_MODAL
    };
};

var dismissModal = exports.dismissModal = function dismissModal() {
    return {
        type: DISMISS_MODAL
    };
};

var openAddCreditCardModal = exports.openAddCreditCardModal = function openAddCreditCardModal() {
    return {
        type: OPEN_ADD_CREDIT_CARD_MODAL
    };
};

var openAddSearchAlertModal = exports.openAddSearchAlertModal = function openAddSearchAlertModal() {
    return {
        type: OPEN_ADD_SEARCH_ALERT_MODAL
    };
};

var openCompleteAccountModal = exports.openCompleteAccountModal = function openCompleteAccountModal() {
    return {
        type: OPEN_COMPLETE_ACCOUNT_MODAL
    };
};

var openConfirmPasswordModal = exports.openConfirmPasswordModal = function openConfirmPasswordModal(payload) {
    return {
        payload: payload,
        type: OPEN_CONFIRM_PASSWORD_MODAL
    };
};

var openConsignmentConfirmModal = exports.openConsignmentConfirmModal = function openConsignmentConfirmModal() {
    return {
        type: OPEN_CONSIGNMENT_CONFIRM_MODAL
    };
};

var openCreateAccountModal = exports.openCreateAccountModal = function openCreateAccountModal() {
    return {
        type: OPEN_CREATE_ACCOUNT_MODAL
    };
};

var openDownloadMobileModal = exports.openDownloadMobileModal = function openDownloadMobileModal() {
    return {
        type: OPEN_DOWNLOAD_MOBILE_MODAL
    };
};

var openForgotPasswordModal = exports.openForgotPasswordModal = function openForgotPasswordModal() {
    return {
        type: OPEN_FORGOT_PASSWORD_MODAL
    };
};

var openHealthcheckModal = exports.openHealthcheckModal = function openHealthcheckModal() {
    return {
        type: OPEN_HEALTHCHECK_MODAL
    };
};

var openInstallFlashModal = exports.openInstallFlashModal = function openInstallFlashModal() {
    return {
        type: OPEN_INSTALL_FLASH_MODAL
    };
};

var openItemDescriptionModal = exports.openItemDescriptionModal = function openItemDescriptionModal(itemId) {
    return {
        payload: itemId,
        type: OPEN_ITEM_DESCRIPTION_MODAL
    };
};

var openLiveBidModal = exports.openLiveBidModal = function openLiveBidModal(itemId, bidAmount) {
    return {
        payload: { bidAmount: bidAmount, itemId: itemId },
        type: OPEN_LIVE_BID_MODAL
    };
};

var openLoginModal = exports.openLoginModal = function openLoginModal() {
    return {
        type: OPEN_LOGIN_MODAL
    };
};

var openAbstenteeBidModal = exports.openAbstenteeBidModal = function openAbstenteeBidModal(itemId, bidAmount) {
    return {
        payload: { bidAmount: bidAmount, itemId: itemId },
        type: OPEN_ABSENTEE_BID_MODAL
    };
};

var openRegisterForCatalogModal = exports.openRegisterForCatalogModal = function openRegisterForCatalogModal(_ref) {
    var catalogId = _ref.catalogId,
        _ref$fromBiddingConso = _ref.fromBiddingConsole,
        fromBiddingConsole = _ref$fromBiddingConso === undefined ? false : _ref$fromBiddingConso;
    return {
        payload: { catalogId: catalogId, fromBiddingConsole: fromBiddingConsole },
        type: OPEN_REGISTER_FOR_CATALOG_MODAL
    };
};

var openRetractBidModal = exports.openRetractBidModal = function openRetractBidModal(itemId) {
    return {
        payload: { itemId: itemId },
        type: OPEN_RETRACT_BID_MODAL
    };
};

var openSendSellerConsignmentMessageModal = exports.openSendSellerConsignmentMessageModal = function openSendSellerConsignmentMessageModal(messageDetails, sellerId, sellerName, subject, title) {
    return {
        payload: { messageDetails: messageDetails, sellerId: sellerId, sellerName: sellerName },
        type: OPEN_SEND_SELLER_CONSIGNMENT_MESSAGE_MODAL
    };
};

var openSendSellerMessageModal = exports.openSendSellerMessageModal = function openSendSellerMessageModal(messageDetails, sellerId, sellerName, subject, title) {
    return {
        payload: { messageDetails: messageDetails, sellerId: sellerId, sellerName: sellerName, subject: subject, title: title },
        type: OPEN_SEND_SELLER_MESSAGE_MODAL
    };
};

var openSetPasswordModal = exports.openSetPasswordModal = function openSetPasswordModal() {
    return {
        type: OPEN_SET_PASSWORD_MODAL
    };
};

var openUpdatePasswordModal = exports.openUpdatePasswordModal = function openUpdatePasswordModal() {
    return {
        type: OPEN_CHANGE_PASSWORD_MODAL
    };
};

var openTermsModal = exports.openTermsModal = function openTermsModal(catalogId) {
    return {
        payload: { catalogId: catalogId },
        type: OPEN_TERMS_MODAL
    };
};

/***/ }),

/***/ "uC6t":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.BidHistoryRemote = undefined;

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _helpers = __webpack_require__("SY39");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BidHistoryRemote = exports.BidHistoryRemote = {
    fetchBidHistory: function fetchBidHistory(_ref) {
        var authToken = _ref.authToken,
            deployment = _ref.deployment,
            itemId = _ref.itemId;
        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makeGet)('<ITEM-API>spa/bid-history/' + itemId, deployment);
            (0, _helpers.addAuthToken)(request, authToken);
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response });
            });
        });
    }
};

/***/ }),

/***/ "uHXy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"save-container":"save-container___2r7qU","save":"save___2qwbN"};

/***/ }),

/***/ "ub8h":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = __webpack_require__("dcb+");

var _jsx3 = _interopRequireDefault(_jsx2);

var _defineProperty2 = __webpack_require__("bOdI");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__("HW6M");

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactModal = __webpack_require__("sW0/");

var _reactModal2 = _interopRequireDefault(_reactModal);

var _Modal = __webpack_require__("luc6");

var _Modal2 = _interopRequireDefault(_Modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Modal = (_temp = _class = function (_Component) {
    (0, _inherits3.default)(Modal, _Component);

    function Modal() {
        (0, _classCallCheck3.default)(this, Modal);
        return (0, _possibleConstructorReturn3.default)(this, (Modal.__proto__ || (0, _getPrototypeOf2.default)(Modal)).apply(this, arguments));
    }

    (0, _createClass3.default)(Modal, [{
        key: 'render',


        // Do NOT add a shouldComponentUpdate method.  It will break the children

        value: function render() {
            var _props = this.props,
                body = _props.body,
                bodyClassName = _props.bodyClassName,
                contentLabel = _props.contentLabel,
                footer = _props.footer,
                footerClassName = _props.footerClassName,
                header = _props.header,
                headerClassName = _props.headerClassName,
                large = _props.large,
                leftImage = _props.leftImage,
                modalRightClassName = _props.modalRightClassName,
                modalSize = _props.modalSize,
                show = _props.show,
                small = _props.small;


            var classes = (0, _classnames2.default)(_Modal2.default['modal-content'], (0, _defineProperty3.default)({}, _Modal2.default['modal-content-large'], large), (0, _defineProperty3.default)({}, _Modal2.default['modal-content-small'], small), (0, _defineProperty3.default)({}, modalSize, modalSize), (0, _defineProperty3.default)({}, _Modal2.default['modal-content-size'], !large && !small && !modalSize));

            var rightModalClasses = (0, _classnames2.default)(_Modal2.default['modal-right'], modalRightClassName);

            var footerClasses = (0, _classnames2.default)(_Modal2.default['modal-footer'], footerClassName);
            var bodyClasses = (0, _classnames2.default)(_Modal2.default['modal-body'], bodyClassName || _Modal2.default['modal-body-default']);
            var headerClasses = (0, _classnames2.default)(_Modal2.default['modal-header'], headerClassName || _Modal2.default['modal-header-default']);

            return (0, _jsx3.default)(_reactModal2.default, {
                className: {
                    afterOpen: _Modal2.default['modal-content--after-open'],
                    base: classes,
                    beforeClose: _Modal2.default['modal-content--before-close']
                },
                bodyOpenClassName: _Modal2.default['ReactModal__Body--open'],
                closeTimeoutMS: 100,
                contentLabel: contentLabel,
                isOpen: show,
                overlayClassName: {
                    afterOpen: _Modal2.default['modal-overlay--after-open'],
                    base: '' + _Modal2.default['modal-overlay'],
                    beforeClose: _Modal2.default['modal-overlay--before-close']
                }
            }, void 0, leftImage && (0, _jsx3.default)('div', {
                className: _Modal2.default['modal-leftImage']
            }, void 0, leftImage), (0, _jsx3.default)('div', {
                className: rightModalClasses
            }, void 0, header && (0, _jsx3.default)('div', {
                className: headerClasses
            }, void 0, header), body && (0, _jsx3.default)('div', {
                className: bodyClasses
            }, void 0, body), footer && (0, _jsx3.default)('div', {
                className: footerClasses
            }, void 0, footer)));
        }
    }]);
    return Modal;
}(_react.Component), _class.defaultProps = {
    body: null,
    footer: null,
    header: null,
    large: false,
    leftImage: null,
    show: false,
    small: false
}, _temp);
exports.default = Modal;
module.exports = exports['default'];

/***/ }),

/***/ "uhYE":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fetchCatalogRegistrationIfNeeded = exports.getAllUserCatalogRegistrationIds = exports.isCatalogRegistrationLoading = exports.getLoadTimeForCatalogRegistration = exports.getCatalogRegistration = exports.LOAD_CATALOG_REGISTRATION_SUCCESS = exports.LOAD_CATALOG_REGISTRATION_REQUEST = exports.LOAD_CATALOG_REGISTRATION_FAIL = undefined;

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _regenerator = __webpack_require__("Xxa5");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__("exGp");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _keys = __webpack_require__("fZjL");

var _keys2 = _interopRequireDefault(_keys);

var _defineProperty2 = __webpack_require__("bOdI");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends4 = __webpack_require__("Dd8w");

var _extends5 = _interopRequireDefault(_extends4);

exports.default = reducer;

var _user = __webpack_require__("CFLi");

var _api = __webpack_require__("zFQO");

var _cloneDeep = __webpack_require__("kvU2");

var _cloneDeep2 = _interopRequireDefault(_cloneDeep);

var _reselect = __webpack_require__("bndy");

var _difference = __webpack_require__("WlNK");

var _difference2 = _interopRequireDefault(_difference);

var _config = __webpack_require__("iS9E");

var _login = __webpack_require__("SpFG");

var _passwordReset = __webpack_require__("fWpZ");

var _registerForCatalog = __webpack_require__("eUWk");

var _union = __webpack_require__("gszD");

var _union2 = _interopRequireDefault(_union);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Action Types */
var LOAD_CATALOG_REGISTRATION_FAIL = exports.LOAD_CATALOG_REGISTRATION_FAIL = 'la/domain/catalogRegistration/LOAD_FAIL';
var LOAD_CATALOG_REGISTRATION_REQUEST = exports.LOAD_CATALOG_REGISTRATION_REQUEST = 'la/domain/catalogRegistration/LOAD_REQUEST';
var LOAD_CATALOG_REGISTRATION_SUCCESS = exports.LOAD_CATALOG_REGISTRATION_SUCCESS = 'la/domain/catalogRegistration/LOAD_SUCCESS';

/* reducer */
var DEFAULT_STATE = {
    byId: {},
    loaded: {},
    loading: []
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var existing = void 0;
    var loaded = void 0;
    var loading = void 0;
    var time = void 0;

    switch (action.type) {
        case LOAD_CATALOG_REGISTRATION_FAIL:
            return (0, _extends5.default)({}, state, {
                loading: (0, _difference2.default)(state.loading, [action.meta.catalogId])
            });
        case LOAD_CATALOG_REGISTRATION_REQUEST:
            return (0, _extends5.default)({}, state, {
                loading: (0, _union2.default)(state.loading, [action.payload])
            });
        case _registerForCatalog.REGISTER_FOR_CATALOG_SUCCESS:
            return (0, _extends5.default)({}, state, {
                byId: (0, _extends5.default)({}, state.byId, (0, _defineProperty3.default)({}, action.payload, {
                    approved: false,
                    catalogId: action.payload,
                    pending: true,
                    registered: false
                }))
            });
        case _user.LOAD_BIDDER_DATA_SUCCESS:
        case _login.LOGIN_SUCCESS:
        case _passwordReset.PASSWORD_RESET_SUCCESS:
            time = action.meta.actionTime;
            loaded = (0, _extends5.default)({}, state.loaded);
            existing = (0, _cloneDeep2.default)(state.byId);
            if (action.payload.catalogRegistration) {
                action.payload.catalogRegistration.forEach(function (catalog) {
                    existing[catalog.catalogId] = catalog;
                    loaded[catalog.catalogId] = time;
                });
            }
            return (0, _extends5.default)({}, state, {
                byId: existing,
                loaded: loaded
            });

        case LOAD_CATALOG_REGISTRATION_SUCCESS:
            time = action.meta.actionTime;
            existing = (0, _cloneDeep2.default)(state.byId);
            loaded = (0, _extends5.default)({}, state.loaded, (0, _defineProperty3.default)({}, action.meta.catalogId, time));
            loading = (0, _cloneDeep2.default)(state.loading);
            existing[action.meta.catalogId] = existing[action.meta.catalogId] || {};
            if (action.payload.approved) {
                existing[action.meta.catalogId].approved = true;
                existing[action.meta.catalogId].pending = false;
                existing[action.meta.catalogId].declined = false;
            }

            loading = (0, _difference2.default)(loading, [action.meta.catalogId]);

            return (0, _extends5.default)({}, state, {
                byId: existing,
                loaded: loaded,
                loading: loading
            });

        case _user.LOG_OUT_BIDDER:
            return (0, _extends5.default)({}, DEFAULT_STATE);

        default:
            return state;
    }
}

/* SELECTORS */
var stateSelector = function stateSelector(state) {
    return state.user.catalogRegistration;
};
var idSelector = function idSelector(state, id) {
    return id;
};

var byIdSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.byId;
});

var loadedSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.loaded;
});

var loadingSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.loading;
});

var getCatalogRegistration = exports.getCatalogRegistration = (0, _reselect.createSelector)([byIdSelector, idSelector], function (byId, id) {
    return byId[id] || {};
});

var getLoadTimeForCatalogRegistration = exports.getLoadTimeForCatalogRegistration = (0, _reselect.createSelector)([loadedSelector, idSelector], function (loaded, id) {
    return loaded[id] || 0;
});

var isCatalogRegistrationLoading = exports.isCatalogRegistrationLoading = (0, _reselect.createSelector)([loadingSelector, idSelector], function (loading, id) {
    return loading.includes(id);
});

var getAllUserCatalogRegistrationIds = exports.getAllUserCatalogRegistrationIds = function getAllUserCatalogRegistrationIds(state) {
    return (0, _keys2.default)(state.user.catalogRegistration.byId).map(function (catIdString) {
        return Number(catIdString);
    });
};

var fetchCatalogRegistration = function fetchCatalogRegistration(catalogId) {
    return function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch, getState) {
            var state, authToken, deployment, email, response;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            state = getState();
                            _context.prev = 1;
                            authToken = (0, _user.getAuthToken)(state);
                            deployment = (0, _config.getDeployment)(state);
                            email = (0, _user.getBidderEmail)(state);


                            dispatch({
                                meta: { actionTime: Date.now() },
                                payload: catalogId,
                                type: LOAD_CATALOG_REGISTRATION_REQUEST
                            });
                            _context.next = 8;
                            return _api.CatalogRegistration.fetchCatalogRegistration({ authToken: authToken, catalogId: catalogId, deployment: deployment, email: email });

                        case 8:
                            response = _context.sent;

                            dispatch({
                                meta: { actionTime: Date.now(), catalogId: catalogId },
                                payload: (0, _extends5.default)({}, response.data, { created: new Date().getTime() }),
                                type: LOAD_CATALOG_REGISTRATION_SUCCESS
                            });
                            _context.next = 15;
                            break;

                        case 12:
                            _context.prev = 12;
                            _context.t0 = _context['catch'](1);

                            dispatch({
                                error: true,
                                meta: { catalogId: catalogId },
                                payload: _context.t0,
                                type: LOAD_CATALOG_REGISTRATION_FAIL
                            });

                        case 15:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, undefined, [[1, 12]]);
        }));

        return function (_x3, _x4) {
            return _ref.apply(this, arguments);
        };
    }();
};

var shouldFetchCatalogRegistration = function shouldFetchCatalogRegistration(state, catalogId) {
    if (!catalogId) return false;
    var loading = isCatalogRegistrationLoading(state, catalogId);
    return !loading;
};

var fetchCatalogRegistrationIfNeeded = exports.fetchCatalogRegistrationIfNeeded = function fetchCatalogRegistrationIfNeeded(catalogId) {
    return function (dispatch, getState) {
        if (shouldFetchCatalogRegistration(getState(), catalogId)) {
            return dispatch(fetchCatalogRegistration(catalogId));
        }
        return _promise2.default.resolve();
    };
};

/***/ }),

/***/ "uien":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.bidderExistsSuccess = exports.getBidderExistsEmail = exports.getBidderExists = exports.BIDDER_EXISTS_SUCCESS = undefined;

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;

var _createAccount = __webpack_require__("FneX");

var _reselect = __webpack_require__("bndy");

var _modal = __webpack_require__("u90i");

var _login = __webpack_require__("SpFG");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Action Types */
var BIDDER_EXISTS_SUCCESS = exports.BIDDER_EXISTS_SUCCESS = 'la/ui/bidderExists/SUCCESS';

// reducer
var DEFAULT_STATE = {
    email: ''
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        case BIDDER_EXISTS_SUCCESS:
            return (0, _extends3.default)({}, state, {
                email: action.payload.email
            });
        case _createAccount.CREATE_ACCOUNT_REQUEST:
        case _createAccount.CREATE_ACCOUNT_SUCCESS:
        case _modal.DISMISS_MODAL:
        case _login.LOGIN_SUCCESS:
            return (0, _extends3.default)({}, state, {
                email: ''
            });
        default:
            return state;
    }
}

/* SELECTORS */
var stateSelector = function stateSelector(state) {
    return state.ui.bidderExists;
};

var getUiBidderExists = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state;
});

var getBidderExists = exports.getBidderExists = (0, _reselect.createSelector)(getUiBidderExists, function (state) {
    return !!state.email;
});

var getBidderExistsEmail = exports.getBidderExistsEmail = (0, _reselect.createSelector)(getUiBidderExists, function (state) {
    return state.email;
});

/* ACTION CREATORS */
var bidderExistsSuccess = exports.bidderExistsSuccess = function bidderExistsSuccess(email) {
    return {
        payload: { email: email },
        type: BIDDER_EXISTS_SUCCESS
    };
};

/***/ }),

/***/ "v7uI":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _searchSuggestions = __webpack_require__("FGjK");

var SearchSuggestions = {
    fetchSuggestions: _searchSuggestions.SearchSuggestionsRemote.fetchSuggestions
};

exports.default = SearchSuggestions;
module.exports = exports['default'];

/***/ }),

/***/ "vC/J":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = __webpack_require__("dcb+");

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propsComparer = __webpack_require__("wsGv");

var _propsComparer2 = _interopRequireDefault(_propsComparer);

var _LoggedIn = __webpack_require__("g19V");

var _LoggedIn2 = _interopRequireDefault(_LoggedIn);

var _LoggedOut = __webpack_require__("5Sl0");

var _LoggedOut2 = _interopRequireDefault(_LoggedOut);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Login = function (_Component) {
    (0, _inherits3.default)(Login, _Component);

    function Login() {
        (0, _classCallCheck3.default)(this, Login);
        return (0, _possibleConstructorReturn3.default)(this, (Login.__proto__ || (0, _getPrototypeOf2.default)(Login)).apply(this, arguments));
    }

    (0, _createClass3.default)(Login, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps) {
            return (0, _propsComparer2.default)(this.props, nextProps, ['userLoggedIn', 'windowWidth']);
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                baseUrl = _props.baseUrl,
                logOutBidder = _props.logOutBidder,
                mobile = _props.mobile,
                openCreateAccountModal = _props.openCreateAccountModal,
                openLoginModal = _props.openLoginModal,
                parent = _props.parent,
                userLoggedIn = _props.userLoggedIn,
                whiteLabel = _props.whiteLabel,
                windowWidth = _props.windowWidth;


            return userLoggedIn ? (0, _jsx3.default)(_LoggedIn2.default, {
                baseUrl: baseUrl,
                logOutBidder: logOutBidder,
                mobile: mobile,
                parent: parent,
                whiteLabel: whiteLabel,
                windowWidth: windowWidth
            }) : (0, _jsx3.default)(_LoggedOut2.default, {
                openCreateAccountModal: openCreateAccountModal,
                openLoginModal: openLoginModal
            });
        }
    }]);
    return Login;
}(_react.Component);

exports.default = Login;
module.exports = exports['default'];

/***/ }),

/***/ "vCo/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = __webpack_require__("dcb+");

var _jsx3 = _interopRequireDefault(_jsx2);

var _toConsumableArray2 = __webpack_require__("Gu7T");

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__("Pq8k");

var _countDown = __webpack_require__("7bCi");

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _CatalogDate = __webpack_require__("AN9j");

var _CatalogDate2 = _interopRequireDefault(_CatalogDate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CatalogDate = (_temp = _class = function (_PureComponent) {
    (0, _inherits3.default)(CatalogDate, _PureComponent);

    function CatalogDate() {
        (0, _classCallCheck3.default)(this, CatalogDate);
        return (0, _possibleConstructorReturn3.default)(this, (CatalogDate.__proto__ || (0, _getPrototypeOf2.default)(CatalogDate)).apply(this, arguments));
    }

    (0, _createClass3.default)(CatalogDate, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                className = _props.className,
                date = _props.date,
                showDate = _props.showDate;

            var classes = [].concat((0, _toConsumableArray3.default)(className.split(' ')), [_CatalogDate2.default['card-date']]).join(' ').trim();

            var formattedDate = (0, _countDown.getCountDown)(date);

            var displayDate = (0, _jsx3.default)('div', {});
            if (formattedDate.countDown) {
                displayDate = (0, _jsx3.default)('span', {
                    className: _CatalogDate2.default.countdown
                }, void 0, formattedDate.dateFormat, ' ', (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                    id: 'left'
                }));
            } else {
                displayDate = (0, _jsx3.default)('span', {
                    className: _CatalogDate2.default.date
                }, void 0, formattedDate.dateFormat);
            }

            return showDate && (0, _jsx3.default)('span', {
                className: classes
            }, void 0, displayDate);
        }
    }]);
    return CatalogDate;
}(_react.PureComponent), _class.defaultProps = {
    className: '',
    date: 0,
    showDate: true
}, _temp);
exports.default = CatalogDate;
module.exports = exports['default'];

/***/ }),

/***/ "vDMj":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = __webpack_require__("dcb+");

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__("Pq8k");

var _components = __webpack_require__("bGai");

var _Seo = __webpack_require__("CIJv");

var _Seo2 = _interopRequireDefault(_Seo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Seo = function (_PureComponent) {
    (0, _inherits3.default)(Seo, _PureComponent);

    function Seo() {
        (0, _classCallCheck3.default)(this, Seo);
        return (0, _possibleConstructorReturn3.default)(this, (Seo.__proto__ || (0, _getPrototypeOf2.default)(Seo)).apply(this, arguments));
    }

    (0, _createClass3.default)(Seo, [{
        key: 'render',

        // TODO: replace strings with <FormattedMessages />
        value: function render() {
            return (0, _jsx3.default)('div', {
                className: _Seo2.default.seo
            }, void 0, (0, _jsx3.default)('div', {
                className: _Seo2.default.container
            }, void 0, (0, _jsx3.default)('div', {
                className: _Seo2.default.column
            }, void 0, (0, _jsx3.default)('div', {
                className: _Seo2.default.wrapper
            }, void 0, (0, _jsx3.default)('div', {
                className: _Seo2.default['column-title']
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'popular_searches'
            })), (0, _jsx3.default)('ul', {}, void 0, (0, _jsx3.default)('li', {}, void 0, (0, _jsx3.default)(_components.Link, {
                route: true,
                to: '/c/art/chinese/1/162/'
            }, void 0, 'Chinese Art')), (0, _jsx3.default)('li', {}, void 0, (0, _jsx3.default)(_components.Link, {
                route: true,
                to: '/c/clocks/74/'
            }, void 0, 'Clocks')), (0, _jsx3.default)('li', {}, void 0, (0, _jsx3.default)(_components.Link, {
                route: true,
                to: '/c/coins-medals-money/24/'
            }, void 0, 'Coins and Paper Money')), (0, _jsx3.default)('li', {}, void 0, (0, _jsx3.default)(_components.Link, {
                route: true,
                to: '/c/jade/25797/'
            }, void 0, 'Jade'))))), (0, _jsx3.default)('div', {
                className: _Seo2.default.column
            }, void 0, (0, _jsx3.default)('div', {
                className: _Seo2.default.wrapper
            }, void 0, (0, _jsx3.default)('div', {
                className: _Seo2.default['column-title']
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'artists_and_creators'
            })), (0, _jsx3.default)('ul', {}, void 0, (0, _jsx3.default)('li', {}, void 0, (0, _jsx3.default)(_components.Link, {
                route: true,
                to: '/c/finn-juhl/7645/'
            }, void 0, 'Finn Juhl')), (0, _jsx3.default)('li', {}, void 0, (0, _jsx3.default)(_components.Link, {
                route: true,
                to: '/c/hans-wegner/9858/'
            }, void 0, 'Hans Wegner')), (0, _jsx3.default)('li', {}, void 0, (0, _jsx3.default)(_components.Link, {
                route: true,
                to: '/c/keith-haring/14133/'
            }, void 0, 'Keith Haring')), (0, _jsx3.default)('li', {}, void 0, (0, _jsx3.default)(_components.Link, {
                route: true,
                to: '/c/marc-chagall/15935/'
            }, void 0, 'Marc Chagall'))))), (0, _jsx3.default)('div', {
                className: _Seo2.default.column
            }, void 0, (0, _jsx3.default)('div', {
                className: _Seo2.default.wrapper
            }, void 0, (0, _jsx3.default)('div', {
                className: _Seo2.default['column-title']
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'brands'
            })), (0, _jsx3.default)('ul', {}, void 0, (0, _jsx3.default)('li', {}, void 0, (0, _jsx3.default)(_components.Link, {
                route: true,
                to: '/c/chanel/4017/'
            }, void 0, 'Chanel')), (0, _jsx3.default)('li', {}, void 0, (0, _jsx3.default)(_components.Link, {
                route: true,
                to: '/c/hermes/10420/'
            }, void 0, 'Herm\xE8s')), (0, _jsx3.default)('li', {}, void 0, (0, _jsx3.default)(_components.Link, {
                route: true,
                to: '/c/louis-vuitton/15385/'
            }, void 0, 'Louis Vuitton')), (0, _jsx3.default)('li', {}, void 0, (0, _jsx3.default)(_components.Link, {
                route: true,
                to: '/c/rolex/21252/'
            }, void 0, 'Rolex'))))), (0, _jsx3.default)('div', {
                className: _Seo2.default.column
            }, void 0, (0, _jsx3.default)('div', {
                className: _Seo2.default.wrapper
            }, void 0, (0, _jsx3.default)('div', {
                className: _Seo2.default['column-title']
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'style_periods'
            })), (0, _jsx3.default)('ul', {}, void 0, (0, _jsx3.default)('li', {}, void 0, (0, _jsx3.default)(_components.Link, {
                route: true,
                to: '/c/art-deco/253/'
            }, void 0, 'Art Deco')), (0, _jsx3.default)('li', {}, void 0, (0, _jsx3.default)(_components.Link, {
                route: true,
                to: '/c/byzantine/25695/'
            }, void 0, 'Byzantine')), (0, _jsx3.default)('li', {}, void 0, (0, _jsx3.default)(_components.Link, {
                route: true,
                to: '/c/edwardian/274/'
            }, void 0, 'Edwardian')), (0, _jsx3.default)('li', {}, void 0, (0, _jsx3.default)(_components.Link, {
                route: true,
                to: '/c/gothic/252/'
            }, void 0, 'Gothic'))))), (0, _jsx3.default)('div', {
                className: _Seo2.default.column
            }, void 0, (0, _jsx3.default)('div', {
                className: _Seo2.default.wrapper
            }, void 0, (0, _jsx3.default)('div', {
                className: _Seo2.default['column-title']
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'origins'
            })), (0, _jsx3.default)('ul', {}, void 0, (0, _jsx3.default)('li', {}, void 0, (0, _jsx3.default)(_components.Link, {
                route: true,
                to: '/c/japanese/163/'
            }, void 0, 'Japanese')), (0, _jsx3.default)('li', {}, void 0, (0, _jsx3.default)(_components.Link, {
                route: true,
                to: '/c/tibetan/168/'
            }, void 0, 'Tibetan')), (0, _jsx3.default)('li', {}, void 0, (0, _jsx3.default)(_components.Link, {
                route: true,
                to: '/c/southeast-asian/169/'
            }, void 0, 'Southeast Asian')), (0, _jsx3.default)('li', {}, void 0, (0, _jsx3.default)(_components.Link, {
                route: true,
                to: '/c/taiwanese/165/'
            }, void 0, 'Taiwanese')))))));
        }
    }]);
    return Seo;
}(_react.PureComponent);

exports.default = Seo;
module.exports = exports['default'];

/***/ }),

/***/ "vOFV":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.submitForgotPassword = exports.getUiForgotPassword = exports.FORGOT_PASSWORD_SUCCESS = exports.FORGOT_PASSWORD_REQUEST = exports.FORGOT_PASSWORD_FAIL = undefined;

var _regenerator = __webpack_require__("Xxa5");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__("exGp");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;

var _api = __webpack_require__("zFQO");

var _reselect = __webpack_require__("bndy");

var _user = __webpack_require__("CFLi");

var _config = __webpack_require__("iS9E");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Action Types */
var FORGOT_PASSWORD_FAIL = exports.FORGOT_PASSWORD_FAIL = 'la/ui/forgotPassword/FAIL';
var FORGOT_PASSWORD_REQUEST = exports.FORGOT_PASSWORD_REQUEST = 'la/ui/forgotPassword/REQUEST';
var FORGOT_PASSWORD_SUCCESS = exports.FORGOT_PASSWORD_SUCCESS = 'la/ui/forgotPassword/SUCCESS';

// reducer
var DEFAULT_STATE = {
    error: false,
    errorMessage: null,
    submitted: false,
    success: false
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        case FORGOT_PASSWORD_REQUEST:
            return (0, _extends3.default)({}, state, {
                error: false,
                errorMessage: null,
                submitted: true,
                success: false
            });
        case FORGOT_PASSWORD_SUCCESS:
            return (0, _extends3.default)({}, state, {
                submitted: false,
                success: true
            });
        case FORGOT_PASSWORD_FAIL:
            return (0, _extends3.default)({}, state, {
                error: true,
                errorMessage: action.payload.message,
                submitted: false,
                success: false
            });
        default:
            return state;
    }
}

/* SELECTORS */
var stateSelector = function stateSelector(state) {
    return state.ui.forgotPassword;
};

var getUiForgotPassword = exports.getUiForgotPassword = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state;
});

/* ACTION CREATORS */
var submitForgotPassword = exports.submitForgotPassword = function submitForgotPassword(emailAddress) {
    return function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch, getState) {
            var state, authToken, deployment;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.prev = 0;
                            state = getState();
                            authToken = (0, _user.getAuthToken)(state);
                            deployment = (0, _config.getDeployment)(state);

                            dispatch({
                                payload: emailAddress,
                                type: FORGOT_PASSWORD_REQUEST
                            });
                            _context.next = 7;
                            return _api.Auth.postForgotPassword({ authToken: authToken, deployment: deployment, emailAddress: emailAddress });

                        case 7:
                            dispatch({
                                payload: emailAddress,
                                type: FORGOT_PASSWORD_SUCCESS
                            });
                            _context.next = 13;
                            break;

                        case 10:
                            _context.prev = 10;
                            _context.t0 = _context['catch'](0);

                            dispatch({
                                error: true,
                                meta: { emailAddress: emailAddress },
                                payload: _context.t0,
                                type: FORGOT_PASSWORD_FAIL
                            });

                        case 13:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, undefined, [[0, 10]]);
        }));

        return function (_x3, _x4) {
            return _ref.apply(this, arguments);
        };
    }();
};

/***/ }),

/***/ "vi1m":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fetchSellersDetailsIfNeeded = exports.isSellerDetailLoading = exports.getLoadTimeForSellerDetail = exports.getSellerDetail = exports.LOAD_SELLER_DETAILS_SUCCESS = exports.LOAD_SELLER_DETAILS_REQUEST = exports.LOAD_SELLER_DETAILS_FAIL = undefined;

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _regenerator = __webpack_require__("Xxa5");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__("exGp");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;

var _api = __webpack_require__("zFQO");

var _cloneDeep = __webpack_require__("kvU2");

var _cloneDeep2 = _interopRequireDefault(_cloneDeep);

var _reselect = __webpack_require__("bndy");

var _difference = __webpack_require__("WlNK");

var _difference2 = _interopRequireDefault(_difference);

var _user = __webpack_require__("CFLi");

var _config = __webpack_require__("iS9E");

var _isEmpty = __webpack_require__("lHK6");

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _ms = __webpack_require__("EarI");

var _ms2 = _interopRequireDefault(_ms);

var _union = __webpack_require__("gszD");

var _union2 = _interopRequireDefault(_union);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Action Types */
var LOAD_SELLER_DETAILS_FAIL = exports.LOAD_SELLER_DETAILS_FAIL = 'la/domain/sellerDetail/LOAD_FAIL';
var LOAD_SELLER_DETAILS_REQUEST = exports.LOAD_SELLER_DETAILS_REQUEST = 'la/domain/sellerDetail/LOAD_REQUEST';
var LOAD_SELLER_DETAILS_SUCCESS = exports.LOAD_SELLER_DETAILS_SUCCESS = 'la/domain/sellerDetail/LOAD_SUCCESS';

var REDUX_STORE_TIME = (0, _ms2.default)('30m');

/* reducer */
var DEFAULT_STATE = {
    byId: {},
    loaded: {},
    loading: []
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var existing = void 0;
    var loaded = void 0;
    var loading = void 0;
    var time = void 0;

    switch (action.type) {
        case LOAD_SELLER_DETAILS_FAIL:
            return (0, _extends3.default)({}, state, {
                loading: (0, _difference2.default)(state.loading, action.meta.sellerIds)
            });
        case LOAD_SELLER_DETAILS_REQUEST:
            return (0, _extends3.default)({}, state, {
                loading: (0, _union2.default)(state.loading, action.payload)
            });
        case LOAD_SELLER_DETAILS_SUCCESS:
            existing = (0, _cloneDeep2.default)(state.byId);
            loaded = (0, _extends3.default)({}, state.loaded);
            loading = (0, _cloneDeep2.default)(state.loading);
            time = action.meta.actionTime;

            if (action.payload.sellerDetails) {
                action.payload.sellerDetails.forEach(function (x) {
                    existing[x.sellerId] = (0, _extends3.default)({}, x);
                    loaded[x.sellerId] = time;
                    loading = (0, _difference2.default)(loading, [x.sellerId]);
                });
            }
            return (0, _extends3.default)({}, state, {
                byId: existing,
                loaded: loaded,
                loading: loading
            });
        default:
            return state;
    }
}

/* SELECTORS */
var stateSelector = function stateSelector(state) {
    return state.domain.sellerDetail;
};
var idSelector = function idSelector(state, id) {
    return id;
};

var byIdSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.byId;
});

var loadedSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.loaded;
});

var loadingSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.loading;
});

// takes in a (state, id) and returns the data
var getSellerDetail = exports.getSellerDetail = (0, _reselect.createSelector)([byIdSelector, idSelector], function (byId, id) {
    return byId[id] || {};
});

// takes in a (state, id) and returns the load time
var getLoadTimeForSellerDetail = exports.getLoadTimeForSellerDetail = (0, _reselect.createSelector)([loadedSelector, idSelector], function (loaded, id) {
    return loaded[id] || 0;
});

// takes in a (state, id) and returns the is loading
var isSellerDetailLoading = exports.isSellerDetailLoading = (0, _reselect.createSelector)([loadingSelector, idSelector], function (loading, id) {
    return loading.indexOf(id) !== -1;
});

var shouldFetchSellerDetail = function shouldFetchSellerDetail(state, sellerId) {
    var data = getSellerDetail(state, sellerId);
    if (!(0, _isEmpty2.default)(data)) {
        var loaded = getLoadTimeForSellerDetail(state, sellerId);
        var time = Date.now();
        var diff = time - loaded;
        if (diff < REDUX_STORE_TIME) return false;
    }
    var loading = isSellerDetailLoading(state, sellerId);
    return !loading;
};

var whichSellerDetailsNeeded = function whichSellerDetailsNeeded(state, sellerIds) {
    return sellerIds.filter(function (sellerId) {
        return shouldFetchSellerDetail(state, sellerId);
    });
};

/* ACTION CREATORS */
var loadSellerDetails = function loadSellerDetails(sellerIds) {
    return function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch, getState) {
            var state, authToken, deployment, response;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.prev = 0;
                            state = getState();
                            authToken = (0, _user.getAuthToken)(state);
                            deployment = (0, _config.getDeployment)(state);

                            dispatch({
                                payload: sellerIds,
                                type: LOAD_SELLER_DETAILS_REQUEST
                            });
                            _context.next = 7;
                            return _api.SellerDetail.fetchSellerDetailsByIds({ authToken: authToken, deployment: deployment, sellerIds: sellerIds });

                        case 7:
                            response = _context.sent;

                            dispatch({
                                meta: { actionTime: Date.now(), sellerIds: sellerIds },
                                payload: response.data,
                                type: LOAD_SELLER_DETAILS_SUCCESS
                            });
                            _context.next = 14;
                            break;

                        case 11:
                            _context.prev = 11;
                            _context.t0 = _context['catch'](0);

                            dispatch({
                                error: true,
                                meta: { sellerIds: sellerIds },
                                payload: _context.t0,
                                type: LOAD_SELLER_DETAILS_FAIL
                            });

                        case 14:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, undefined, [[0, 11]]);
        }));

        return function (_x3, _x4) {
            return _ref.apply(this, arguments);
        };
    }();
};

var fetchSellersDetailsIfNeeded = exports.fetchSellersDetailsIfNeeded = function fetchSellersDetailsIfNeeded(sellerIds) {
    return function (dispatch, getState) {
        var needed = whichSellerDetailsNeeded(getState(), sellerIds);
        if (needed.length) {
            return dispatch(loadSellerDetails(needed));
        }
        return _promise2.default.resolve();
    };
};

/***/ }),

/***/ "vwV8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = __webpack_require__("dcb+");

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _components = __webpack_require__("bGai");

var _urls = __webpack_require__("CakR");

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propsComparer = __webpack_require__("wsGv");

var _propsComparer2 = _interopRequireDefault(_propsComparer);

var _AuctioneerAddress = __webpack_require__("PbmM");

var _AuctioneerAddress2 = _interopRequireDefault(_AuctioneerAddress);

var _classnames = __webpack_require__("HW6M");

var _classnames2 = _interopRequireDefault(_classnames);

var _caterwaulComponents = __webpack_require__("7T5E");

var _reactIntl = __webpack_require__("Pq8k");

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _AuctioneerInfo = __webpack_require__("mHb4");

var _AuctioneerInfo2 = _interopRequireDefault(_AuctioneerInfo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AuctioneerInfo = (_temp = _class = function (_Component) {
    (0, _inherits3.default)(AuctioneerInfo, _Component);

    function AuctioneerInfo() {
        (0, _classCallCheck3.default)(this, AuctioneerInfo);
        return (0, _possibleConstructorReturn3.default)(this, (AuctioneerInfo.__proto__ || (0, _getPrototypeOf2.default)(AuctioneerInfo)).apply(this, arguments));
    }

    (0, _createClass3.default)(AuctioneerInfo, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps) {
            return (0, _propsComparer2.default)(this.props, nextProps, ['className', 'seller']);
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                className = _props.className,
                noImageLink = _props.noImageLink,
                seller = _props.seller,
                showSendSellerMessageModal = _props.showSendSellerMessageModal;
            var countryCode = seller.countryCode,
                sellerId = seller.sellerId,
                name = seller.name,
                logoId = seller.logoId;


            var classes = (0, _classnames2.default)(_AuctioneerInfo2.default['auctioneer-info'], className);

            return (0, _jsx3.default)('div', {
                className: classes
            }, void 0, (0, _jsx3.default)('div', {
                className: _AuctioneerInfo2.default.details
            }, void 0, (0, _jsx3.default)('div', {
                className: _AuctioneerInfo2.default['flag-name']
            }, void 0, (0, _jsx3.default)(_caterwaulComponents.Flag, {
                className: _AuctioneerInfo2.default.flag,
                countryCode: countryCode
            }), (0, _jsx3.default)(_components.Link, {
                route: true,
                to: (0, _urls.getSellerUrl)(sellerId, name),
                className: _AuctioneerInfo2.default.name
            }, void 0, name)), (0, _jsx3.default)(_AuctioneerAddress2.default, {
                seller: seller
            }), (0, _jsx3.default)('div', {
                className: _AuctioneerInfo2.default.question
            }, void 0, (0, _jsx3.default)(_components.ShouldLogInContainer, {
                requireLogin: true,
                requireCompleteProfile: true,
                runFunction: showSendSellerMessageModal
            }, void 0, (0, _jsx3.default)(_components.Link, {}, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'ask_a_question'
            }))), (0, _jsx3.default)('span', {
                className: _AuctioneerInfo2.default['seller-info-pipe']
            }, void 0, '|'), (0, _jsx3.default)(_components.FollowSellerContainer, {
                sellerId: sellerId
            }))), (0, _jsx3.default)('div', {
                className: _AuctioneerInfo2.default['image-container']
            }, void 0, !noImageLink ? (0, _jsx3.default)(_components.Link, {
                route: true,
                to: (0, _urls.getSellerUrl)(sellerId, name)
            }, void 0, logoId && (0, _jsx3.default)(_components.ImageWithFallback, {
                className: _AuctioneerInfo2.default.image,
                src: (0, _urls.getAuctioneerLogoUrl)(logoId),
                alt: name
            })) : logoId && (0, _jsx3.default)(_components.ImageWithFallback, {
                className: _AuctioneerInfo2.default.image,
                src: (0, _urls.getAuctioneerLogoUrl)(logoId),
                alt: name
            })));
        }
    }]);
    return AuctioneerInfo;
}(_react.Component), _class.defaultProps = {
    className: ''
}, _temp);
exports.default = AuctioneerInfo;
module.exports = exports['default'];

/***/ }),

/***/ "vx4l":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fetchBidHistoryIfNeeded = exports.isBidHistoryLoading = exports.getLoadTimeForBidHistory = exports.getBidHistory = exports.LOAD_BID_HISTORY_SUCCESS = exports.LOAD_BID_HISTORY_REQUEST = exports.LOAD_BID_HISTORY_FAIL = undefined;

var _regenerator = __webpack_require__("Xxa5");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _asyncToGenerator2 = __webpack_require__("exGp");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _defineProperty2 = __webpack_require__("bOdI");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends3 = __webpack_require__("Dd8w");

var _extends4 = _interopRequireDefault(_extends3);

exports.default = reducer;

var _api = __webpack_require__("zFQO");

var _cloneDeep = __webpack_require__("kvU2");

var _cloneDeep2 = _interopRequireDefault(_cloneDeep);

var _reselect = __webpack_require__("bndy");

var _difference = __webpack_require__("WlNK");

var _difference2 = _interopRequireDefault(_difference);

var _user = __webpack_require__("CFLi");

var _config = __webpack_require__("iS9E");

var _ms = __webpack_require__("EarI");

var _ms2 = _interopRequireDefault(_ms);

var _union = __webpack_require__("gszD");

var _union2 = _interopRequireDefault(_union);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Action Types */
var LOAD_BID_HISTORY_FAIL = exports.LOAD_BID_HISTORY_FAIL = 'la/domain/bidHistory/LOAD_FAIL';
var LOAD_BID_HISTORY_REQUEST = exports.LOAD_BID_HISTORY_REQUEST = 'la/domain/bidHistory/LOAD_REQUEST';
var LOAD_BID_HISTORY_SUCCESS = exports.LOAD_BID_HISTORY_SUCCESS = 'la/domain/bidHistory/LOAD_SUCCESS';

var REDUX_STORE_TIME = (0, _ms2.default)('30m');

/* reducer */
var DEFAULT_STATE = {
    byId: {},
    loaded: {},
    loading: []
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var existing = void 0;
    var loaded = void 0;
    var loading = void 0;
    var time = void 0;

    switch (action.type) {
        case LOAD_BID_HISTORY_FAIL:
            return (0, _extends4.default)({}, state, {
                loading: (0, _difference2.default)(state.loading, [action.meta.itemId])
            });
        case LOAD_BID_HISTORY_REQUEST:
            return (0, _extends4.default)({}, state, {
                loading: (0, _union2.default)(state.loading, [action.payload])
            });
        case LOAD_BID_HISTORY_SUCCESS:
            time = action.meta.actionTime;
            existing = (0, _cloneDeep2.default)(state.byId);
            loaded = (0, _extends4.default)({}, state.loaded, (0, _defineProperty3.default)({}, action.meta.itemId, time));
            loading = (0, _cloneDeep2.default)(state.loading);

            existing[action.meta.itemId] = action.payload;
            loading = (0, _difference2.default)(loading, [action.meta.itemId]);
            return (0, _extends4.default)({}, state, {
                byId: existing,
                loaded: loaded,
                loading: loading
            });
        default:
            return state;
    }
}

/* SELECTORS */
var stateSelector = function stateSelector(state) {
    return state.domain.bidHistory;
};
var idSelector = function idSelector(state, id) {
    return id;
};

var byIdSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.byId;
});

var loadedSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.loaded;
});

var loadingSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.loading;
});

var getBidHistory = exports.getBidHistory = (0, _reselect.createSelector)([byIdSelector, idSelector], function (byId, id) {
    return byId[id] || [];
});

var getLoadTimeForBidHistory = exports.getLoadTimeForBidHistory = (0, _reselect.createSelector)([loadedSelector, idSelector], function (loaded, id) {
    return loaded[id] || 0;
});

var isBidHistoryLoading = exports.isBidHistoryLoading = (0, _reselect.createSelector)([loadingSelector, idSelector], function (loading, id) {
    return loading.includes(id);
});

var shouldFetchBidHistory = (0, _reselect.createSelector)([idSelector, getBidHistory, getLoadTimeForBidHistory, isBidHistoryLoading], function (catalogId, bidHistory, loaded, loading) {
    if (!catalogId) return false;
    if (bidHistory) {
        var time = Date.now();
        var diff = time - loaded;
        if (diff < REDUX_STORE_TIME) return false;
    }
    return !loading;
});

/* ACTION CREATORS */
var fetchBidHistoryIfNeeded = exports.fetchBidHistoryIfNeeded = function fetchBidHistoryIfNeeded(itemId) {
    return function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch, getState) {
            var state, authToken, deployment, response;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            state = getState();

                            if (!shouldFetchBidHistory(state, itemId)) {
                                _context.next = 17;
                                break;
                            }

                            _context.prev = 2;
                            authToken = (0, _user.getAuthToken)(state);
                            deployment = (0, _config.getDeployment)(state);

                            dispatch({
                                meta: { actionTime: Date.now() },
                                payload: itemId,
                                type: LOAD_BID_HISTORY_REQUEST
                            });
                            _context.next = 8;
                            return _api.BidHistory.fetchBidHistory({ authToken: authToken, deployment: deployment, itemId: itemId });

                        case 8:
                            response = _context.sent;

                            dispatch({
                                meta: { actionTime: Date.now(), itemId: itemId },
                                payload: response.data,
                                type: LOAD_BID_HISTORY_SUCCESS
                            });
                            _context.next = 15;
                            break;

                        case 12:
                            _context.prev = 12;
                            _context.t0 = _context['catch'](2);

                            dispatch({
                                error: true,
                                meta: { itemId: itemId },
                                payload: _context.t0,
                                type: LOAD_BID_HISTORY_FAIL
                            });

                        case 15:
                            _context.next = 18;
                            break;

                        case 17:
                            return _context.abrupt('return', _promise2.default.resolve());

                        case 18:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, undefined, [[2, 12]]);
        }));

        return function (_x3, _x4) {
            return _ref.apply(this, arguments);
        };
    }();
};

/***/ }),

/***/ "wFxa":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fetchSellerEndedCatalogsIfNeeded = exports.isEndedCatalogsLoading = exports.getLoadTimeForEndedCatalogs = exports.getEndedCatalogs = exports.LOAD_SELLER_ENDED_CATALOGS_SUCCESS = exports.LOAD_SELLER_ENDED_CATALOGS_REQUEST = exports.LOAD_SELLER_ENDED_CATALOGS_FAIL = undefined;

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _regenerator = __webpack_require__("Xxa5");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__("exGp");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _defineProperty2 = __webpack_require__("bOdI");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends4 = __webpack_require__("Dd8w");

var _extends5 = _interopRequireDefault(_extends4);

exports.default = reducer;

var _api = __webpack_require__("zFQO");

var _reselect = __webpack_require__("bndy");

var _difference = __webpack_require__("WlNK");

var _difference2 = _interopRequireDefault(_difference);

var _user = __webpack_require__("CFLi");

var _config = __webpack_require__("iS9E");

var _ms = __webpack_require__("EarI");

var _ms2 = _interopRequireDefault(_ms);

var _union = __webpack_require__("gszD");

var _union2 = _interopRequireDefault(_union);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOAD_SELLER_ENDED_CATALOGS_FAIL = exports.LOAD_SELLER_ENDED_CATALOGS_FAIL = 'la/domain/sellerEndedCatalogs/LOAD_FAIL';
var LOAD_SELLER_ENDED_CATALOGS_REQUEST = exports.LOAD_SELLER_ENDED_CATALOGS_REQUEST = 'la/domain/sellerEndedCatalogs/LOAD_REQUEST';
var LOAD_SELLER_ENDED_CATALOGS_SUCCESS = exports.LOAD_SELLER_ENDED_CATALOGS_SUCCESS = 'la/domain/sellerEndedCatalogs/LOAD_SUCCESS';

var REDUX_STORE_TIME = (0, _ms2.default)('30m');

var DEFAULT_STATE = {
    byId: {},
    loaded: {},
    loading: []
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        case LOAD_SELLER_ENDED_CATALOGS_FAIL:
            return (0, _extends5.default)({}, state, {
                loading: (0, _difference2.default)(state.loading, [action.meta.sellerId])
            });
        case LOAD_SELLER_ENDED_CATALOGS_REQUEST:
            return (0, _extends5.default)({}, state, {
                loading: (0, _union2.default)(state.loading, [action.payload])
            });
        case LOAD_SELLER_ENDED_CATALOGS_SUCCESS:
            var _action$meta = action.meta,
                actionTime = _action$meta.actionTime,
                sellerId = _action$meta.sellerId;

            var newState = (0, _extends5.default)({}, state, {
                byId: (0, _extends5.default)({}, state.byId, (0, _defineProperty3.default)({}, sellerId, action.payload.catalogs.map(function (catalog) {
                    return catalog.catalogId;
                }))),
                loading: (0, _difference2.default)(state.loading, [sellerId])
            });
            // TODO: make this reducer pure
            // dont set loaded if we're on the server because we'll need to get the rest
            newState.loaded = global.__SERVER__ ? (0, _extends5.default)({}, state.loaded) : (0, _extends5.default)({}, state.loaded, (0, _defineProperty3.default)({}, sellerId, actionTime));
            return newState;
        default:
            return state;
    }
}

/* SELECTORS */
var stateSelector = function stateSelector(state) {
    return state.domain.sellerEndedCatalogs;
};
var idSelector = function idSelector(state, id) {
    return id;
};

var byIdSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.byId;
});

var loadedSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.loaded;
});

var loadingSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.loading;
});

// takes in a (state, id) and returns the data
var getEndedCatalogs = exports.getEndedCatalogs = (0, _reselect.createSelector)([byIdSelector, idSelector], function (byId, id) {
    return byId[id] || [];
});

// takes in a (state, id) and returns the load time
var getLoadTimeForEndedCatalogs = exports.getLoadTimeForEndedCatalogs = (0, _reselect.createSelector)([loadedSelector, idSelector], function (loaded, id) {
    return loaded[id] || 0;
});

// takes in a (state, id) and returns the is loading
var isEndedCatalogsLoading = exports.isEndedCatalogsLoading = (0, _reselect.createSelector)([loadingSelector, idSelector], function (loading, id) {
    return loading.includes(id);
});

var shouldFetchEndedCatalogs = function shouldFetchEndedCatalogs(state, sellerId) {
    if (!sellerId) return false;
    var item = getEndedCatalogs(state, sellerId);
    if (item.length) {
        var loaded = getLoadTimeForEndedCatalogs(state, sellerId);
        var time = Date.now();
        var diff = time - loaded;
        if (diff < REDUX_STORE_TIME) return false;
    }
    var loading = isEndedCatalogsLoading(state, sellerId);
    return !loading;
};

/* ACTION CREATORS */
var loadEndedCatalogs = function loadEndedCatalogs(sellerId, page, count, sortTerm) {
    return function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch, getState) {
            var state, authToken, deployment, response;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.prev = 0;
                            state = getState();
                            authToken = (0, _user.getAuthToken)(state);
                            deployment = (0, _config.getDeployment)(state);

                            dispatch({
                                payload: sellerId,
                                type: LOAD_SELLER_ENDED_CATALOGS_REQUEST
                            });
                            _context.next = 7;
                            return _api.SellerCatalogs.fetchSellerEndedCatalogsById({
                                authToken: authToken,
                                count: count,
                                deployment: deployment,
                                page: page,
                                sellerId: sellerId,
                                sortTerm: sortTerm
                            });

                        case 7:
                            response = _context.sent;

                            dispatch({
                                meta: { actionTime: Date.now(), sellerId: sellerId },
                                payload: response.data,
                                type: LOAD_SELLER_ENDED_CATALOGS_SUCCESS
                            });
                            _context.next = 14;
                            break;

                        case 11:
                            _context.prev = 11;
                            _context.t0 = _context['catch'](0);

                            dispatch({
                                error: true,
                                meta: { sellerId: sellerId },
                                payload: _context.t0,
                                type: LOAD_SELLER_ENDED_CATALOGS_FAIL
                            });

                        case 14:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, undefined, [[0, 11]]);
        }));

        return function (_x3, _x4) {
            return _ref.apply(this, arguments);
        };
    }();
};

var fetchSellerEndedCatalogsIfNeeded = exports.fetchSellerEndedCatalogsIfNeeded = function fetchSellerEndedCatalogsIfNeeded(sellerId, page, count, sortTerm) {
    return function (dispatch, getState) {
        if (shouldFetchEndedCatalogs(getState(), sellerId)) {
            return dispatch(loadEndedCatalogs(sellerId, page, count, sortTerm));
        }
        return _promise2.default.resolve();
    };
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("DuR2")))

/***/ }),

/***/ "wTTR":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var transform = function transform(_ref) {
    var response = _ref.catalogs,
        count = _ref.count;

    var catalogs = response.map(function (catalog) {
        var items = catalog.results.map(function (item) {
            return {
                hammerPrice: item.hammer_price,
                hammerPriceAtomic: item.hammer_price_atomic,
                itemId: item.lot_id,
                lotNumber: item.lot_num,
                title: item.title
            };
        });

        var transformedCatalog = {
            catalogId: catalog.catalog_id,
            currency: catalog.currency_type.code,
            items: items,
            liveAuctioneersPayments: !!catalog.la_payment,
            saleStartTs: catalog.sale_start_ts,
            sellerId: catalog.house_id,
            sellerName: catalog.house_name,
            title: catalog.auct_title
        };

        if (catalog.invoice) {
            transformedCatalog.invoice = {
                balanceDue: catalog.invoice.balance_due,
                hammerPrice: catalog.invoice.hammer_price,
                paidStatus: catalog.invoice.paid_status,
                sent: !!catalog.invoice.is_sent
            };
        }

        return transformedCatalog;
    });

    return {
        data: {
            catalogs: catalogs,
            count: Number(count)
        },
        message: 'Successfully retrieved the items.',
        success: true
    };
};

exports.default = transform;
module.exports = exports['default'];

/***/ }),

/***/ "wUUL":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _saveItem = __webpack_require__("JuF/");

var SaveItem = {
    fetchSavedItemCounts: _saveItem.SaveItemRemote.fetchSavedItemCounts,
    postSaveItem: _saveItem.SaveItemRemote.postSaveItem,
    postUnsaveItem: _saveItem.SaveItemRemote.postUnsaveItem
};

exports.default = SaveItem;
module.exports = exports['default'];

/***/ }),

/***/ "wsGv":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof2 = __webpack_require__("pFYg");

var _typeof3 = _interopRequireDefault(_typeof2);

var _getIterator2 = __webpack_require__("BO1k");

var _getIterator3 = _interopRequireDefault(_getIterator2);

exports.default = areThereDifferences;

var _isEqual = __webpack_require__("hygk");

var _isEqual2 = _interopRequireDefault(_isEqual);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function areThereDifferences() {
    var currentProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var nextProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var fieldsToCompare = arguments[2];
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        for (var _iterator = (0, _getIterator3.default)(fieldsToCompare), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var field = _step.value;

            if (field === 'children') {
                if (currentProps[field] !== nextProps[field]) return true;
            }
            var type = (0, _typeof3.default)(currentProps[field]);
            if (type === 'object') {
                if (!(0, _isEqual2.default)(currentProps[field], nextProps[field])) return true;
            } else if (type !== 'function') {
                if (currentProps[field] !== nextProps[field]) {
                    return true;
                }
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }

    return false;
}
module.exports = exports['default'];

/***/ }),

/***/ "wyFM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"button":"button___3_Ozh","primary":"primary___zYyzg","secondary":"secondary___3Hm6m","small":"small___nAPfO","tertiary":"tertiary___1vMCD"};

/***/ }),

/***/ "x7tz":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getUiSetPassword = exports.SET_PASSWORD_SUCCESS = exports.SET_PASSWORD_REQUEST = exports.SET_PASSWORD_FAIL = undefined;

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.submitSetPassword = submitSetPassword;

var _user = __webpack_require__("CFLi");

var _api = __webpack_require__("zFQO");

var _reselect = __webpack_require__("bndy");

var _config = __webpack_require__("iS9E");

var _analytics = __webpack_require__("yxCd");

var _modal = __webpack_require__("u90i");

var _login = __webpack_require__("SpFG");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Action Types */
var SET_PASSWORD_FAIL = exports.SET_PASSWORD_FAIL = 'la/ui/setPassword/FAIL';
var SET_PASSWORD_REQUEST = exports.SET_PASSWORD_REQUEST = 'la/ui/setPassword/REQUEST';
var SET_PASSWORD_SUCCESS = exports.SET_PASSWORD_SUCCESS = 'la/ui/setPassword/SUCCESS';

// reducer
var DEFAULT_STATE = {
    error: false,
    errorMessage: '',
    submitted: false,
    success: false
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        case SET_PASSWORD_FAIL:
            return (0, _extends3.default)({}, state, {
                error: true,
                errorMessage: action.payload.message,
                submitted: false,
                success: false
            });
        case SET_PASSWORD_REQUEST:
            return (0, _extends3.default)({}, state, {
                error: false,
                errorMessage: '',
                submitted: true,
                success: false
            });
        case SET_PASSWORD_SUCCESS:
            return (0, _extends3.default)({}, state, {
                error: false,
                errorMessage: '',
                submitted: false,
                success: true
            });
        default:
            return state;
    }
}

/* SELECTORS */
var stateSelector = function stateSelector(state) {
    return state.ui.setPassword;
};

var getUiSetPassword = exports.getUiSetPassword = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state;
});

/* ACTION CREATORS */
function setPasswordFail(emailAddress, error) {
    return {
        error: true,
        meta: { emailAddress: emailAddress },
        payload: error.error_message,
        type: SET_PASSWORD_FAIL
    };
}

function setPasswordRequest() {
    return {
        type: SET_PASSWORD_REQUEST
    };
}

function setPasswordSuccess(state, userDetails, attributionData) {
    return {
        // bidderID from token not response
        meta: (0, _extends3.default)({}, (0, _analytics.getSetPasswordAnalytics)(state, userDetails.bidderId, attributionData), {
            actionTime: Date.now()
        }),
        payload: userDetails,
        type: SET_PASSWORD_SUCCESS
    };
}

function submitSetPassword(password, attributionData) {
    return function (dispatch, getState) {
        var state = getState();
        var authToken = (0, _user.getAuthToken)(state);
        var deployment = (0, _config.getDeployment)(state);
        var emailAddress = (0, _user.getBidderEmail)(state);
        var userData = (0, _user.getUserData)(state);
        dispatch(setPasswordRequest());
        return _api.Bidder.postSetPassword({ authToken: authToken, deployment: deployment, password: password }).then(function () {
            dispatch(setPasswordSuccess(getState(), userData, attributionData));
            dispatch((0, _login.submitLogin)(emailAddress, password)).then(function () {
                dispatch((0, _modal.openCompleteAccountModal)());
            });
        }).catch(function (error) {
            dispatch(setPasswordFail(emailAddress, error));
        });
    };
}

/***/ }),

/***/ "xSux":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"follow-seller":"follow-seller___3vwbU","uppercase":"uppercase___3BCTO"};

/***/ }),

/***/ "xf6/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wide":"wide___3eYEd","recordingExclude":"recordingExclude___3_z8p","form-group":"form-group___3aioe","help":"help___1E0Iv","form-control":"form-control___2w-lK","small":"small___2uSLm","custom-error-icon":"custom-error-icon___2EBiH","error":"error___214aG","monthYearGroup":"monthYearGroup___1D-Y9","monthYearElement":"monthYearElement___2Ztig"};

/***/ }),

/***/ "xgTf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"app":"app___31MH8","appContent":"appContent___32OVM"};

/***/ }),

/***/ "xmqD":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.submitLiveBid = exports.getBidderHasHighBid = exports.getUiLiveBid = exports.LIVE_BID_SUCCESS = exports.LIVE_BID_REQUEST = exports.LIVE_BID_FAIL = undefined;

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;

var _console = __webpack_require__("FSAu");

var _reselect = __webpack_require__("bndy");

var _liveCatalogStatus = __webpack_require__("ByEe");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Action Types */
var LIVE_BID_FAIL = exports.LIVE_BID_FAIL = 'la/ui/liveBid/FAIL';
var LIVE_BID_REQUEST = exports.LIVE_BID_REQUEST = 'la/ui/liveBid/REQUEST';
var LIVE_BID_SUCCESS = exports.LIVE_BID_SUCCESS = 'la/ui/liveBid/SUCCESS';

// reducer
var DEFAULT_STATE = {
    bidderHasHighBid: false,
    submitted: false,
    success: false
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        case LIVE_BID_REQUEST:
            return (0, _extends3.default)({}, state, {
                submitted: true,
                success: false
            });
        case _console.BID_ACCEPTED:
            return (0, _extends3.default)({}, state, {
                bidderHasHighBid: action.payload.myBid,
                submitted: false,
                success: true
            });
        case _console.LOT_CLOSED:
        case _console.LOT_PASSED:
        case _console.LOT_SKIPPED:
        case _console.LOT_SOLD:
            return (0, _extends3.default)({}, state, {
                bidderHasHighBid: false,
                submitted: false,
                success: true
            });
        case LIVE_BID_SUCCESS:
            return (0, _extends3.default)({}, state, {
                submitted: false,
                success: true
            });
        case LIVE_BID_FAIL:
            return (0, _extends3.default)({}, state, {
                error: true,
                submitted: false,
                success: false
            });
        case _console.NEXT_LOT_LOADED:
            return (0, _extends3.default)({}, state, {
                bidderHasHighBid: false,
                submitted: false
            });
        case _liveCatalogStatus.LOAD_LIVE_CATALOG_STATUS_SUCCESS:
            var currentHighBidderId = action.payload.currentItem.leadingBidder;
            return (0, _extends3.default)({}, state, {
                bidderHasHighBid: action.meta.bidderId === currentHighBidderId
            });
        default:
            return state;
    }
}

/* SELECTORS */
var stateSelector = function stateSelector(state) {
    return state.ui.liveBid;
};
var getUiLiveBid = exports.getUiLiveBid = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state;
});

var getBidderHasHighBid = exports.getBidderHasHighBid = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.bidderHasHighBid;
});

/* ACTIONS CREATORS */
var submitLiveBid = exports.submitLiveBid = function submitLiveBid(catalogId, amount, currency) {
    return function (dispatch) {
        try {
            dispatch({
                payload: {
                    amount: amount,
                    catalogId: catalogId,
                    currency: currency
                },
                type: LIVE_BID_REQUEST
            });
        } catch (error) {
            dispatch({
                error: true,
                payload: error,
                type: LIVE_BID_FAIL
            });
        }
    };
};

/***/ }),

/***/ "y7cp":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toSearchUrl = exports.toFacetUrlParams = exports.toFacetString = undefined;

var _stringify = __webpack_require__("mvHQ");

var _stringify2 = _interopRequireDefault(_stringify);

var _compact = __webpack_require__("C2y9");

var _compact2 = _interopRequireDefault(_compact);

var _union = __webpack_require__("gszD");

var _union2 = _interopRequireDefault(_union);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* SELECTORS */
var toFacetLabel = function toFacetLabel(facet, value) {
    var selectionType = facet.selection;
    if (selectionType === 'single') {
        return value.name;
    }
    if (selectionType === 'single2') {
        return value.name;
    }
    if (selectionType === 'distance') {
        return facet.name + ': ' + facet.selected_postal_code;
    }
    if (selectionType === 'range') {
        return facet.name + ': ' + facet.selected_start + ' - ' + facet.selected_end; // add in currency
    }
    if (selectionType === 'multiple') {
        return value.name;
    }
    if (selectionType === 'keyword') {
        return facet.selected_value;
    }
    if (selectionType === 'date') {
        return facet.name;
    }
};

var toFacetString = exports.toFacetString = function toFacetString(facets) {
    var selections = [];
    facets.forEach(function (facet) {
        if (facet.qs === 'keyword') {
            selections.unshift(toFacetLabel(facet));
        } else if (facet.values) {
            facet.values.forEach(function (value) {
                selections.push(toFacetLabel(facet, value));
            });
        } else {
            selections.push(toFacetLabel(facet));
        }
    });
    return (0, _compact2.default)(selections).join(', ');
};

var toFacetUrlParam = function toFacetUrlParam(facet, oldValue) {
    var selectionType = facet.qs;
    if (facet.selection === 'single' || facet.selection === 'multiple') {
        var oldValues = oldValue ? oldValue.split(',') : [];
        var newValues = facet.values.map(function (x) {
            return '' + x.value;
        });
        return (0, _union2.default)(oldValues, newValues).join(',');
    }
    if (selectionType === 'keyword') {
        return facet.selected_value; // overwrite old value
    }
    if (facet.selection === 'range') {
        var _oldValues = oldValue ? oldValue.split(',') : [];

        var currency = facet.currencies.length ? facet.currencies[0].code : 'USD';
        var min = facet.selected_start;
        var max = facet.selected_end;
        var minValue = min !== '' && min !== undefined ? min : -1;
        var maxValue = max !== '' && max !== undefined ? max : -1;
        var newValue = currency + ':' + minValue + ':' + maxValue;

        return (0, _union2.default)(_oldValues, [newValue]).join(',');
    }
    if (facet.selection === 'distance') {
        var _oldValues2 = oldValue ? oldValue.split(',') : [];

        var country = facet.selected_country;
        var zipCode = facet.selected_postal_code;
        var range = facet.selected_radius;
        var measurement = facet.selected_radius_unit;
        var _newValue = country + ':' + zipCode + ':' + range + ':' + measurement;

        return (0, _union2.default)(_oldValues2, [_newValue]).join(',');
    }
};

var toFacetUrlParams = exports.toFacetUrlParams = function toFacetUrlParams(facets) {
    var url = {
        // published_date: null,
        // sort: '-publish_date',
    };
    facets.forEach(function (facet) {
        url[facet.qs] = toFacetUrlParam(facet, url[facet.qs]);
    });
    return (0, _stringify2.default)(url);
};

var toSearchUrl = exports.toSearchUrl = function toSearchUrl(facets) {
    var urlParams = toFacetUrlParams(facets);
    return '/search?parameters=' + encodeURIComponent(urlParams);
};

/***/ }),

/***/ "yM+3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _seller = __webpack_require__("e6NR");

var Seller = {
    fetchSellers: _seller.SellerRemote.fetchSellers,
    fetchSellersByIds: _seller.SellerRemote.fetchSellersByIds,
    postFollow: _seller.SellerRemote.postFollow,
    postMessage: _seller.SellerRemote.postMessage,
    postUnfollow: _seller.SellerRemote.postUnfollow
};

exports.default = Seller;
module.exports = exports['default'];

/***/ }),

/***/ "yMle":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = __webpack_require__("dcb+");

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__("Pq8k");

var _Trust = __webpack_require__("cq7Z");

var _Trust2 = _interopRequireDefault(_Trust);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Trust = function (_PureComponent) {
    (0, _inherits3.default)(Trust, _PureComponent);

    function Trust() {
        (0, _classCallCheck3.default)(this, Trust);
        return (0, _possibleConstructorReturn3.default)(this, (Trust.__proto__ || (0, _getPrototypeOf2.default)(Trust)).apply(this, arguments));
    }

    (0, _createClass3.default)(Trust, [{
        key: 'render',
        value: function render() {
            return (0, _jsx3.default)('div', {
                className: _Trust2.default.trust
            }, void 0, (0, _jsx3.default)('div', {
                className: _Trust2.default.centered
            }, void 0, (0, _jsx3.default)('div', {
                className: _Trust2.default.images
            }, void 0, (0, _jsx3.default)('div', {
                className: _Trust2.default['column-title']
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'as_seen_on'
            })), (0, _jsx3.default)('div', {
                className: _Trust2.default['column-content']
            }, void 0, (0, _jsx3.default)('div', {
                className: _Trust2.default.nbc
            }, void 0, (0, _jsx3.default)('img', {
                style: { maxHeight: '43px', maxWidth: '44px' },
                src: 'https://p1.liveauctioneers.com/dist/images/NBC.svg',
                alt: 'NBC'
            })), (0, _jsx3.default)('div', {
                className: _Trust2.default.abc
            }, void 0, (0, _jsx3.default)('img', {
                style: { maxHeight: '38px', maxWidth: '38px' },
                src: 'https://p1.liveauctioneers.com/dist/images/ABC.svg',
                alt: 'ABC'
            })), (0, _jsx3.default)('div', {
                className: _Trust2.default.today
            }, void 0, (0, _jsx3.default)('img', {
                style: { maxHeight: '42px', maxWidth: '57px' },
                src: 'https://p1.liveauctioneers.com/dist/images/TODAY.svg',
                alt: 'Today'
            })), (0, _jsx3.default)('div', {
                className: _Trust2.default['chicago-tribune']
            }, void 0, (0, _jsx3.default)('img', {
                style: { maxHeight: '20px', maxWidth: '137px' },
                src: 'https://p1.liveauctioneers.com/dist/images/ChicagoTribune.svg',
                alt: 'Chicago Tribune'
            })), (0, _jsx3.default)('div', {
                className: _Trust2.default['architectural-digest']
            }, void 0, (0, _jsx3.default)('img', {
                style: { maxHeight: '14px', maxWidth: '162px' },
                src: 'https://p1.liveauctioneers.com/dist/images/ArchDigest.svg',
                alt: 'Architectural Digest'
            })))), (0, _jsx3.default)('div', {
                className: _Trust2.default.separator
            }), (0, _jsx3.default)('div', {
                className: _Trust2.default.shop
            }, void 0, (0, _jsx3.default)('div', {
                className: _Trust2.default['column-title']
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'shop_with_confidence'
            })), (0, _jsx3.default)('div', {
                className: _Trust2.default['column-content']
            }, void 0, (0, _jsx3.default)('div', {
                className: _Trust2.default['column-content-left']
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'since_2002_liveauctioneers_has_made_items'
            })), (0, _jsx3.default)('div', {
                className: _Trust2.default['column-content-right']
            }, void 0, (0, _jsx3.default)('a', {
                href: 'http://www.bbb.org/new-york-city/business-reviews/internet-auction-service/live-auctioneers-llc-in-new-york-ny-123530/#bbbonlineclick',
                target: '_blank',
                rel: 'nofollow noopener'
            }, void 0, (0, _jsx3.default)('img', {
                src: 'https://p1.liveauctioneers.com/seals/blue-seal-250-52-bbb-123530.png',
                alt: 'LiveAuctioneers LLC BBB Business Review'
            })))))));
        }
    }]);
    return Trust;
}(_react.PureComponent);

exports.default = Trust;
module.exports = exports['default'];

/***/ }),

/***/ "yR8t":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _catalogSearch = __webpack_require__("2eK9");

var CataloSearch = {
    fetchCatalogsTodayCount: _catalogSearch.CatalogSearchRemote.fetchCatalogsTodayCount,
    fetchResults: _catalogSearch.CatalogSearchRemote.fetchSearchResults
};

exports.default = CataloSearch;
module.exports = exports['default'];

/***/ }),

/***/ "yTM5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CatalogRegistrationRemote = undefined;

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _helpers = __webpack_require__("SY39");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CatalogRegistrationRemote = exports.CatalogRegistrationRemote = {
    fetchCatalogRegistration: function fetchCatalogRegistration(_ref) {
        var authToken = _ref.authToken,
            catalogId = _ref.catalogId,
            deployment = _ref.deployment,
            email = _ref.email;
        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makePost)('<CLERK-SERVICE>clerk/approval/' + catalogId, deployment);
            (0, _helpers.addAuthToken)(request, authToken);
            request.send({
                AuctionId: catalogId,
                Email: email,
                Token: authToken
            });
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response, success404: true });
            });
        });
    }
};

/***/ }),

/***/ "yi49":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = __webpack_require__("dcb+");

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _components = __webpack_require__("bGai");

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__("HW6M");

var _classnames2 = _interopRequireDefault(_classnames);

var _DiscoveryTags = __webpack_require__("JstK");

var _DiscoveryTags2 = _interopRequireDefault(_DiscoveryTags);

var _reactIntl = __webpack_require__("Pq8k");

var _urls = __webpack_require__("CakR");

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _SimilarItems = __webpack_require__("blov");

var _SimilarItems2 = _interopRequireDefault(_SimilarItems);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SimilarItems = (_temp = _class = function (_Component) {
    (0, _inherits3.default)(SimilarItems, _Component);

    function SimilarItems() {
        (0, _classCallCheck3.default)(this, SimilarItems);
        return (0, _possibleConstructorReturn3.default)(this, (SimilarItems.__proto__ || (0, _getPrototypeOf2.default)(SimilarItems)).apply(this, arguments));
    }

    (0, _createClass3.default)(SimilarItems, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                centerHeader = _props.centerHeader,
                className = _props.className,
                facets = _props.facets,
                headerMessage = _props.headerMessage,
                itemTitle = _props.itemTitle,
                similarItems = _props.similarItems,
                slider = _props.slider;


            var items = similarItems.length ? similarItems : new Array(6).fill(null);

            var classes = (0, _classnames2.default)(_SimilarItems2.default['similar-items'], className);
            var gridHeaderClasses = (0, _classnames2.default)(_SimilarItems2.default['similar-items-header'], centerHeader ? _SimilarItems2.default['center-text'] : '');

            return (0, _jsx3.default)('div', {
                className: classes
            }, void 0, slider && similarItems.length ? (0, _jsx3.default)(_components.ItemCardCarousel, {
                className: _SimilarItems2.default['carousel-container'],
                headerMessage: headerMessage,
                index: 0,
                items: items
            }) : (0, _jsx3.default)(_react.Fragment, {}, void 0, (0, _jsx3.default)('div', {
                className: gridHeaderClasses
            }, 'header', (0, _jsx3.default)('h2', {
                className: _SimilarItems2.default['header-text-large']
            }, void 0, headerMessage)), (0, _jsx3.default)(_DiscoveryTags2.default, {
                facets: facets
            }, 'discoveryTags'), (0, _jsx3.default)(_components.ItemGrid, {
                cardViewModels: items,
                hideSeller: true,
                hideLotNumbers: true,
                className: _SimilarItems2.default['similar-grid'],
                itemCardClass: _SimilarItems2.default['similar-cards']
            }, 'grid'), (0, _jsx3.default)('div', {
                className: _SimilarItems2.default['see-similar-cta']
            }, 'cta', (0, _jsx3.default)(_components.ButtonLink, {
                url: (0, _urls.getSimilarItemsUrl)(itemTitle)
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'see_more_items'
            })))));
        }
    }]);
    return SimilarItems;
}(_react.Component), _class.defaultProps = {
    centerHeader: false,
    className: ''
}, _temp);
exports.default = SimilarItems;
module.exports = exports['default'];

/***/ }),

/***/ "ykdQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"header":"header___3bMN6","controls-container":"controls-container___jqKJ5","wrapper":"wrapper___35NP9","search-bar":"search-bar___iKImy","image-container":"image-container___L9-HZ","header-logo-link":"header-logo-link___2LNNU","header-logo":"header-logo___2Jzma","search-field-container":"search-field-container___2O0qz","search-button-container":"search-button-container___1-KcN","search-field-icon":"search-field-icon___1JJJJ","mobile-search":"mobile-search___1CPVa","show":"show___1nmCt","white-label":"white-label___1yZV-"};

/***/ }),

/***/ "yriu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"paginate-sort-filter":"paginate-sort-filter___ic8QI","controls":"controls___3HMW1","search":"search___XzGEZ","search-icon":"search-icon___2sRQY","my-bids-throbber":"my-bids-throbber___1rcZG","throbber":"throbber___3noJj","page-size":"page-size___3SQ5Z","sort-by":"sort-by___3R3Dl","grid-wrapper":"grid-wrapper___3F2Xe","grid":"grid___10xPX","cards":"cards___-5eCC","show-controls":"show-controls___1z43v"};

/***/ }),

/***/ "yv/Z":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fetchCatalogsIfNeeded = exports.getCatalogIdsForSeller = exports.getCatalog = exports.LOAD_CATALOGS_SUCCESS = exports.LOAD_CATALOGS_REQUEST = exports.LOAD_CATALOGS_FAIL = undefined;

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _regenerator = __webpack_require__("Xxa5");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__("exGp");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _keys = __webpack_require__("fZjL");

var _keys2 = _interopRequireDefault(_keys);

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;

var _fetchBatch = __webpack_require__("6OCT");

var _api = __webpack_require__("zFQO");

var _cloneDeep = __webpack_require__("kvU2");

var _cloneDeep2 = _interopRequireDefault(_cloneDeep);

var _reselect = __webpack_require__("bndy");

var _difference = __webpack_require__("WlNK");

var _difference2 = _interopRequireDefault(_difference);

var _user = __webpack_require__("CFLi");

var _config = __webpack_require__("iS9E");

var _catalogAd = __webpack_require__("0QM2");

var _home = __webpack_require__("TSUT");

var _item = __webpack_require__("Gk4U");

var _sellerEndedCatalogs = __webpack_require__("wFxa");

var _sellerUpcomingCatalogs = __webpack_require__("iMUO");

var _upcomingCatalogs = __webpack_require__("39qi");

var _ms = __webpack_require__("EarI");

var _ms2 = _interopRequireDefault(_ms);

var _union = __webpack_require__("gszD");

var _union2 = _interopRequireDefault(_union);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Action Types */
var LOAD_CATALOGS_FAIL = exports.LOAD_CATALOGS_FAIL = 'la/domain/catalogs/LOAD_FAIL';
var LOAD_CATALOGS_REQUEST = exports.LOAD_CATALOGS_REQUEST = 'la/domain/catalogs/LOAD_REQUEST';
var LOAD_CATALOGS_SUCCESS = exports.LOAD_CATALOGS_SUCCESS = 'la/domain/catalogs/LOAD_SUCCESS';

var REDUX_STORE_TIME = (0, _ms2.default)('30m');
var FETCH_SET_SIZE = 120;

/* reducer */
var DEFAULT_STATE = {
    byId: {},
    loaded: {},
    loading: []
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var existing = void 0;
    var loaded = void 0;
    var loading = void 0;
    var time = void 0;

    switch (action.type) {
        case LOAD_CATALOGS_FAIL:
            return (0, _extends3.default)({}, state, {
                loading: (0, _difference2.default)(state.loading, action.meta.catalogIds)
            });
        case LOAD_CATALOGS_REQUEST:
            return (0, _extends3.default)({}, state, {
                loading: (0, _union2.default)(state.loading, action.payload)
            });
        case _catalogAd.LOAD_CATALOG_AD_SUCCESS:
        case LOAD_CATALOGS_SUCCESS:
        case _home.LOAD_HOME_DATA_SUCCESS:
        case _item.LOAD_ITEMS_SUCCESS:
        case _sellerUpcomingCatalogs.LOAD_SELLER_UPCOMING_CATALOGS_SUCCESS:
        case _sellerEndedCatalogs.LOAD_SELLER_ENDED_CATALOGS_SUCCESS:
        case _upcomingCatalogs.LOAD_UPCOMING_CATALOGS_SUCCESS:
            existing = (0, _cloneDeep2.default)(state.byId);
            loaded = (0, _extends3.default)({}, state.loaded);
            loading = (0, _cloneDeep2.default)(state.loading);
            time = action.meta.actionTime;

            if (action.payload.catalogs) {
                action.payload.catalogs.forEach(function (item) {
                    existing[item.catalogId] = (0, _extends3.default)({}, item);
                    loaded[item.catalogId] = time;
                    loading = (0, _difference2.default)(loading, [item.catalogId]);
                });
            }
            return (0, _extends3.default)({}, state, {
                byId: existing,
                loaded: loaded,
                loading: loading
            });
        default:
            return state;
    }
}

/* SELECTORS */
var stateSelector = function stateSelector(state) {
    return state.domain.catalog;
};
var globalStateSelector = function globalStateSelector(state) {
    return state;
};
var idSelector = function idSelector(state, id) {
    return id;
};

var byIdSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.byId;
});

var loadedSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.loaded;
});

var loadingSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.loading;
});

var getCatalog = exports.getCatalog = (0, _reselect.createSelector)([byIdSelector, idSelector], function (byId, id) {
    return byId[id] || {};
});

var getLoadTimeForCatalog = (0, _reselect.createSelector)([loadedSelector, idSelector], function (loaded, id) {
    return loaded[id] || 0;
});

var isCatalogLoading = (0, _reselect.createSelector)([loadingSelector, idSelector], function (loading, id) {
    return loading.includes(id);
});

var shouldFetchCatalog = (0, _reselect.createSelector)([getCatalog, getLoadTimeForCatalog, isCatalogLoading], function (catalog, loaded, loading) {
    if (catalog) {
        var time = Date.now();
        var diff = time - loaded;
        if (diff < REDUX_STORE_TIME) return false;
    }
    return !loading;
});

var getCatalogIdsForSeller = exports.getCatalogIdsForSeller = (0, _reselect.createSelector)([byIdSelector, idSelector], function (byId, id) {
    return (0, _keys2.default)(byId).map(function (key) {
        return byId[key];
    }).filter(function (catalog) {
        return catalog.sellerId === id && catalog.catalogStatus;
    }).map(function (catalog) {
        return catalog.catalogId;
    });
});

var whichCatalogsNeeded = (0, _reselect.createSelector)([globalStateSelector, idSelector], function (state, catalogIds) {
    return catalogIds.filter(function (catalogId) {
        return shouldFetchCatalog(state, catalogId);
    });
});

/* ACTION CREATORS */
var loadCatalogs = function loadCatalogs(catalogIds, loadingId, isFinalFetch) {
    return function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch, getState) {
            var state, authToken, deployment, response;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.prev = 0;
                            state = getState();
                            authToken = (0, _user.getAuthToken)(state);
                            deployment = (0, _config.getDeployment)(state);

                            dispatch({
                                payload: catalogIds,
                                type: LOAD_CATALOGS_REQUEST
                            });
                            _context.next = 7;
                            return _api.Catalog.fetchCatalogsByIds({ authToken: authToken, catalogIds: catalogIds, deployment: deployment });

                        case 7:
                            response = _context.sent;

                            dispatch({
                                meta: { actionTime: Date.now(), catalogIds: catalogIds },
                                payload: response.data,
                                type: LOAD_CATALOGS_SUCCESS
                            });
                            if (isFinalFetch) {
                                dispatch((0, _fetchBatch.loadBatchEnd)(loadingId));
                            }
                            _context.next = 16;
                            break;

                        case 12:
                            _context.prev = 12;
                            _context.t0 = _context['catch'](0);

                            dispatch({
                                error: true,
                                meta: { catalogIds: catalogIds },
                                payload: _context.t0,
                                type: LOAD_CATALOGS_FAIL
                            });
                            dispatch((0, _fetchBatch.loadBatchEnd)(loadingId));

                        case 16:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, undefined, [[0, 12]]);
        }));

        return function (_x3, _x4) {
            return _ref.apply(this, arguments);
        };
    }();
};

var loadCatalogsInSets = function loadCatalogsInSets(ids, setSize, loadingId) {
    return function (dispatch) {
        if (ids.length > setSize) {
            return dispatch(loadCatalogs(ids.slice(0, setSize), loadingId, false)).then(function () {
                dispatch(loadCatalogsInSets(ids.slice(setSize), setSize, loadingId));
            });
        }
        return dispatch(loadCatalogs(ids, loadingId, true));
    };
};

var fetchCatalogsIfNeeded = exports.fetchCatalogsIfNeeded = function fetchCatalogsIfNeeded(catalogIds) {
    var loadingId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'none';

    return function (dispatch, getState) {
        var needed = whichCatalogsNeeded(getState(), catalogIds);
        if (needed.length) {
            dispatch((0, _fetchBatch.loadBatchStart)(loadingId));
            return dispatch(loadCatalogsInSets(needed, FETCH_SET_SIZE, loadingId));
        }
        return _promise2.default.resolve();
    };
};

/***/ }),

/***/ "yxCd":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.recordAttributionAnalytics = exports.trackUpcomingCatalogClick = exports.trackTrendingItemClick = exports.trackFeaturedCategoryClick = exports.trackFeaturedCatalogClick = exports.trackHeroClick = exports.trackACNClick = exports.trackAdUnitClick = exports.trackClick = exports.recordAnalyticsForWonItemsPageView = exports.recordAnalyticsForTerminologyPageView = exports.recordAnalyticsForTermsAndConditionsPageView = exports.recordAnalyticsForSearchItemsPageView = exports.recordAnalyticsForSellerPageView = exports.recordAnalyticsForSellerTestimonialsPageView = exports.recordAnalyticsForSellerDirectoryPageView = exports.recordAnalyticsForSavedSearchesPageView = exports.recordAnalyticsForSavedItemsPageView = exports.recordAnalyticsForPRServicesPageView = exports.recordAnalyticsForPrivacyPageView = exports.recordAnalyticsForPasswordResetPageView = exports.recordAnalyticsForNearMePageView = exports.recordAnalyticsForMyBidsPageView = exports.recordAnalyticsForMyAuctionsPageView = exports.recordAnalyticsForMobilePageView = exports.recordAnalyticsForMessagesPageView = exports.recordAnalyticsForItemPageView = exports.recordAnalyticsForIntellectualPropertyPageView = exports.recordAnalyticsForIdentify = exports.recordAnalyticsForHowItWorksPageView = exports.recordAnalyticsForHomePageView = exports.recordAnalyticsForFollowedSellersPageView = exports.recordAnalyticsForFeaturesPageView = exports.recordAnalyticsForCheckoutPageView = exports.recordAnalyticsForCheckoutConfirmationPageView = exports.recordAnalyticsForConsignmentsPageView = exports.recordAnalyticsForCategoryLandingPageView = exports.recordAnalyticsForCatalogPageView = exports.recordAnalyticsForBidConsolePageView = exports.recordAnalyticsForAuctionResultsPageView = exports.recordAnalyticsForAddCreditCardPageView = exports.recordAnalyticsForAccountSettingsPageView = exports.recordAnalyticsForAboutUsPageView = exports.saveFullStorySessionUrl = exports.getRetractedAbsenteeBidAnalytics = exports.getPlacedAbsenteeBidAnalytics = exports.getRequestedAuctionRegistrationAnalytics = exports.getLoginAnalytics = exports.getSetPasswordAnalytics = exports.getRegisterAccountAnalytics = exports.getCompleteAccountAnalytics = exports.getUnfollowSellerAnalytics = exports.getFollowSellerAnalytics = exports.getUnfollowSearchAnalytics = exports.getFollowSearchAnalytics = exports.getUnsaveItemAnalytics = exports.getSaveItemAnalytics = exports.getAttributionData = exports.getFullStorySessionUrl = exports.SET_PASSWORD = exports.UNSAVE_ITEM = exports.UNFOLLOW_SELLER = exports.UNFOLLOW_SEARCH = exports.SAVE_ITEM = exports.RETRACTED_ABSENTEE_BID = exports.REQUESTED_AUCTION_REGISTRATION = exports.REGISTER_ACCOUNT = exports.PLACED_ABSENTEE_BID = exports.FOLLOW_SELLER = exports.FOLLOW_SEARCH = exports.COMPLETE_ACCOUNT = exports.TRACK_PAGEVIEW = exports.TRACK_CLICK = exports.TRACK_ATTRIBUTION_DATA = exports.SAVE_FULLSTORY_SESSION_URL = exports.IDENTIFY_ANALYTICS = undefined;

var _regenerator = __webpack_require__("Xxa5");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__("exGp");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;

var _user = __webpack_require__("CFLi");

var _urls = __webpack_require__("CakR");

var _route = __webpack_require__("9NGF");

var _reduxSegment = __webpack_require__("m95F");

var _config = __webpack_require__("iS9E");

var _biddingInfo = __webpack_require__("m9FA");

var _catalog = __webpack_require__("yv/Z");

var _catalogRegistration = __webpack_require__("uhYE");

var _categoryGrabber = __webpack_require__("Gd4V");

var _item = __webpack_require__("Gk4U");

var _itemFacets = __webpack_require__("WWzX");

var _seller = __webpack_require__("4q18");

var _whiteLabel = __webpack_require__("cYj3");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var KNOWN_SEARCH_ENGINES = ['.msn.', '.search.com', 'about.com', 'adsensecustomsearchads.com', 'alice.', 'alltheweb.com', 'altavista.com', 'ask.com', 'avg.com', 'babylon.com', 'baidu.', 'biglobe.', 'bing.', 'centrum.cz', 'cnn.com/search', 'daum.net', 'delta-search.com', 'discretesearch.com', 'duckduckgo.com', 'easydialsearch.com', 'ekolay.net', 'eniro.se', 'haosou.com', 'kvasir.no', 'lycos.', 'mamma.com', 'mynet.com', 'myprivatesearch.com', 'mysearchdial.com', 'najdi.', 'naver.com', 'onet.pl', 'onetcenter.', 'ozu.es', 'pchome.com', 'query.searchdconvertnow.com', 'rakuten.', 'rambler.ru', 'search.aol', 'search.avira.net', 'search.bt.com', 'search.centurylink.com', 'search.colonymt.com', 'search.earthlink.net', 'search.excite.com', 'search.frontier.com', 'search.media.telstra.com', 'search.mediacomcable.com', 'search.monstercrawler.com', 'search.myway.com', 'search.pch.com', 'search.smt.docomo', 'search.socialdownloadr.com', 'search.twcc.com', 'search.us.com', 'search.xfinity.com', 'search.yahoo.com', 'searchall.com', 'searchassist.verizon.com', 'searchguide.windstream.net', 'searchlock.com', 'searchprivacy.co', 'searcht.sosodesktop.com', 'searchthis.com', 'securesearch.co', 'sesam.no', 'seznam.cz', 'so.com', 'sogou.com', 'startsiden.no', 'szukacz.pl', 'terra.com', 'thesmartsearch.net', 'utorrent.inspsearch.com', 'virgilio.it', 'voila.fr', 'w.goo.ne.jp', 'w.google.', 'w.yahoo.com', 'wp.pl', 'www.delta-search.com', 'yam.com', 'yandex.', 'yoursearch.me', 'zdsearch.com'];
var KNOWN_SOCIAL_NETWORKS = ['pinterest.', 'twitter.', '/t.co', 'facebook.', 'yuku.', 'netvibes.', 'blogspot.', 'houzz.', 'polyvore.', 'youtube.', 'vk.com', 'paper.li', 'reddit.', 'addthis.', 'buzzfeed.', 'plus.google.', 'plus.url.google', 'ravelry', 'wikia.', 'wordpress.', 'blog.goo.ne', 'linkedin.', 'groups.google.', '.ning.', 'stackexchange.', 'stumbleupon.', 'tumblr.', 'typepad.', 'answers.yahoo.'];
var IGNORED_REFERRERS = ['liveauctioneers.', 'optimizely.', 'atlassian.', 'localhost', 'rainforestqa.'];

/* ACTION TYPES */
// const SET_ANONYMOUS_ID = 'SET_ANONYMOUS_ID';
var IDENTIFY_ANALYTICS = exports.IDENTIFY_ANALYTICS = 'IDENTIFY_ANALYTICS';
var SAVE_FULLSTORY_SESSION_URL = exports.SAVE_FULLSTORY_SESSION_URL = 'SAVE_FULLSTORY_SESSION_URL';
var TRACK_ATTRIBUTION_DATA = exports.TRACK_ATTRIBUTION_DATA = 'TRACK_ATTRIBUTION_DATA';
var TRACK_CLICK = exports.TRACK_CLICK = 'TRACK_CLICK';
var TRACK_PAGEVIEW = exports.TRACK_PAGEVIEW = 'TRACK_PAGEVIEW';

/* ANALYTIC TYPES */
var COMPLETE_ACCOUNT = exports.COMPLETE_ACCOUNT = 'Completed Profile';
var FOLLOW_SEARCH = exports.FOLLOW_SEARCH = 'Followed Search';
var FOLLOW_SELLER = exports.FOLLOW_SELLER = 'Followed Auctioneer';
var PLACED_ABSENTEE_BID = exports.PLACED_ABSENTEE_BID = 'Placed Absentee Bid';
var REGISTER_ACCOUNT = exports.REGISTER_ACCOUNT = 'Registered Account';
var REQUESTED_AUCTION_REGISTRATION = exports.REQUESTED_AUCTION_REGISTRATION = 'Requested Auction Registration';
var RETRACTED_ABSENTEE_BID = exports.RETRACTED_ABSENTEE_BID = 'Retracted abstentee bid';
var SAVE_ITEM = exports.SAVE_ITEM = 'Saved Item';
var UNFOLLOW_SEARCH = exports.UNFOLLOW_SEARCH = 'Unfollowed Search';
var UNFOLLOW_SELLER = exports.UNFOLLOW_SELLER = 'Unfollowed Auctioneer';
var UNSAVE_ITEM = exports.UNSAVE_ITEM = 'Unsaved Item';
var SET_PASSWORD = exports.SET_PASSWORD = 'Set Password';

// reducer
var DEFAULT_STATE = {
    anonymousId: '',
    attributionData: {
        bidderId: 0,
        campaign: 'Placeholder campaign Data',
        content: 'Placeholder content Data',
        keyword: 'Placeholder keyword Data',
        medium: 'Placeholder medium Data',
        source: 'Placeholder source Data',
        touchDate: 0
    },
    fullStorySessionUrl: '',
    referrer: ''
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        case SAVE_FULLSTORY_SESSION_URL:
            return (0, _extends3.default)({}, state, {
                fullStorySessionUrl: action.payload
            });
        case TRACK_ATTRIBUTION_DATA:
        default:
            return state;
    }
}

/* SELECTORS */
var getReferrer = function getReferrer(state) {
    return state.ui.analytics.referrer;
};

var getFullStorySessionUrl = exports.getFullStorySessionUrl = function getFullStorySessionUrl(state) {
    return state.ui.analytics.fullStorySessionUrl;
};

var getSailthru = function getSailthru() {
    return typeof window !== 'undefined' ? window.Sailthru : function () {
        return false;
    };
};

var getTouchDate = function getTouchDate(state) {
    return state.ui.analytics.touchDate;
};

var parseQuery = function parseQuery(qstr) {
    var query = {};
    var y = (qstr[0] === '?' ? qstr.substr(1) : qstr).split('?');
    var a = y[1].split('&');
    for (var i = 0; i < a.length; i += 1) {
        var b = a[i].split('=');
        query[decodeURIComponent(b[0]).toLowerCase()] = decodeURIComponent(b[1] || '');
    }
    return query;
};

var searchList = function searchList(haystack, needle) {
    var ret = -1;
    haystack.forEach(function (value) {
        if (needle.toLowerCase().includes(value)) {
            ret = needle;
        }
    });
    return ret;
};

var recursiveDecodeURI = function recursiveDecodeURI(URL) {
    try {
        var generatedURL = decodeURIComponent(URL);
        if (URL.length !== generatedURL.length) {
            return recursiveDecodeURI(generatedURL);
        }
    } catch (error) {
        console.error(error, URL);
    }
    return URL;
};

var getAttributionData = exports.getAttributionData = function getAttributionData(state) {
    var baseURL = (0, _config.getBaseUrl)(state);
    var currentUrl = recursiveDecodeURI((0, _route.getCurrentUrlFromState)(state, baseURL));
    var rawReferrer = getReferrer(state);
    var referrer = (0, _urls.separateURL)(rawReferrer);
    var bidderId = (0, _user.getBidderId)(state);
    var touchDate = getTouchDate(state);

    var attributionData = {
        bidderId: bidderId,
        campaign: '',
        content: '',
        keyword: '',
        medium: '',
        source: '',
        touchDate: touchDate
    };

    var engineName = searchList(KNOWN_SEARCH_ENGINES, rawReferrer);
    var networkName = searchList(KNOWN_SOCIAL_NETWORKS, rawReferrer);
    var referrerName = searchList(IGNORED_REFERRERS, rawReferrer);
    if (currentUrl.toLowerCase().includes('gclid')) {
        var queryObject = parseQuery(currentUrl);
        attributionData = (0, _extends3.default)({}, attributionData, {
            campaign: 'adwords',
            content: 'adwords',
            keyword: queryObject.gclid,
            medium: 'cpc',
            source: 'google'
        });
    } else if (currentUrl.toLowerCase().includes('gclsrc')) {
        var _queryObject = parseQuery(currentUrl);
        attributionData = (0, _extends3.default)({}, attributionData, {
            campaign: 'DoubleClick',
            content: 'DoubleClick',
            keyword: _queryObject.gclsrc || '',
            medium: 'cpc',
            source: 'google'
        });
    } else if (currentUrl.toLowerCase().includes('campaignsource')) {
        var _queryObject2 = parseQuery(currentUrl);
        attributionData = (0, _extends3.default)({}, attributionData, {
            campaign: _queryObject2.campaignname || '',
            content: _queryObject2.campaigncontent || '',
            keyword: _queryObject2.campaignkeyword || '',
            medium: _queryObject2.campaignmedium || '',
            source: _queryObject2.campaignsource || ''
        });
    } else if (currentUrl.toLowerCase().includes('utm_source')) {
        var _queryObject3 = parseQuery(currentUrl);
        attributionData = (0, _extends3.default)({}, attributionData, {
            campaign: _queryObject3.utm_campaign || '',
            content: _queryObject3.utm_content || '',
            keyword: _queryObject3.utm_term || '',
            medium: _queryObject3.utm_medium || '',
            source: _queryObject3.utm_source || ''
        });
    } else if (engineName !== -1) {
        attributionData = (0, _extends3.default)({}, attributionData, {
            content: referrer.path,
            medium: 'organic',
            source: referrer.host
        });
    } else if (networkName !== -1) {
        attributionData = (0, _extends3.default)({}, attributionData, {
            content: referrer.path,
            medium: 'social',
            source: referrer.host
        });
    } else if (referrer.host !== '' && referrerName === -1) {
        attributionData = (0, _extends3.default)({}, attributionData, {
            content: referrer.path,
            medium: 'referral',
            source: referrer.host
        });
    } else {
        attributionData = (0, _extends3.default)({}, attributionData, {
            campaign: 'direct',
            source: 'direct'
        });
    }
    return attributionData;
};

var getItemPrice = function getItemPrice(salePrice, leadingBid) {
    return salePrice || leadingBid;
};

var mapCategoryNames = function mapCategoryNames(facets) {
    for (var prop in facets) {
        if (Object.prototype.hasOwnProperty.call(facets, prop)) {
            facets[prop] = facets[prop].map(function (facet) {
                var facetLevel = (0, _categoryGrabber.getCategoryLevel)(facet);
                if (facetLevel.categoryName) {
                    return facetLevel.categoryName;
                }
                return facet;
            });
        }
    }
    return facets;
};

var getItemAnalytics = function getItemAnalytics(state, itemId, event) {
    var item = (0, _item.getItem)(state, itemId);
    var itemFacets = (0, _itemFacets.getItemFacets)(state, itemId);
    var facets = mapCategoryNames(itemFacets);
    var catalog = (0, _catalog.getCatalog)(state, item.catalogId);

    var _getBiddingInfo = (0, _biddingInfo.getBiddingInfo)(state, itemId),
        leadingBid = _getBiddingInfo.leadingBid;

    var salePrice = item.salePrice,
        sellerId = item.sellerId,
        title = item.title;
    var buyersPremium = catalog.buyersPremium,
        catalogId = catalog.catalogId,
        catalogStatus = catalog.catalogStatus;
    var _facets$categories = facets.categories,
        categories = _facets$categories === undefined ? 'n/a' : _facets$categories,
        _facets$creators = facets.creators,
        creators = _facets$creators === undefined ? 'n/a' : _facets$creators,
        _facets$materialsTech = facets.materialsTechniques,
        materialsTechniques = _facets$materialsTech === undefined ? 'n/a' : _facets$materialsTech,
        _facets$origins = facets.origins,
        origins = _facets$origins === undefined ? 'n/a' : _facets$origins,
        _facets$stylePeriods = facets.stylePeriods,
        stylePeriods = _facets$stylePeriods === undefined ? 'n/a' : _facets$stylePeriods;


    var price = getItemPrice(salePrice, leadingBid);

    var formatAnalytics = {
        analytics: {
            eventPayload: {
                event: event,
                properties: {
                    buyersPremium: buyersPremium,
                    catalogId: catalogId,
                    catalogStatus: catalogStatus,
                    categories: categories,
                    creators: creators,
                    houseId: sellerId,
                    itemId: itemId,
                    materialsTechniques: materialsTechniques,
                    origins: origins,
                    price: price,
                    stylePeriods: stylePeriods,
                    title: title
                }
            },
            eventType: _reduxSegment.EventTypes.track
        }
    };
    return formatAnalytics;
};

var getSaveItemAnalytics = exports.getSaveItemAnalytics = function getSaveItemAnalytics(state, itemId) {
    return getItemAnalytics(state, itemId, SAVE_ITEM);
};

var getUnsaveItemAnalytics = exports.getUnsaveItemAnalytics = function getUnsaveItemAnalytics(state, itemId) {
    return getItemAnalytics(state, itemId, UNSAVE_ITEM);
};

var getSellerAnalytics = function getSellerAnalytics(sellerId, event) {
    return {
        analytics: {
            eventPayload: {
                event: event,
                properties: {
                    houseId: sellerId
                }
            },
            eventType: _reduxSegment.EventTypes.track
        }
    };
};
var getFollowSearchAnalytics = exports.getFollowSearchAnalytics = function getFollowSearchAnalytics() {
    return {
        analytics: {
            eventPayload: {
                event: FOLLOW_SEARCH
            },
            eventType: _reduxSegment.EventTypes.track
        }
    };
};
var getUnfollowSearchAnalytics = exports.getUnfollowSearchAnalytics = function getUnfollowSearchAnalytics() {
    return {
        analytics: {
            eventPayload: {
                event: UNFOLLOW_SEARCH
            },
            eventType: _reduxSegment.EventTypes.track
        }
    };
};
var getFollowSellerAnalytics = exports.getFollowSellerAnalytics = function getFollowSellerAnalytics(sellerId) {
    return getSellerAnalytics(sellerId, FOLLOW_SELLER);
};

var getUnfollowSellerAnalytics = exports.getUnfollowSellerAnalytics = function getUnfollowSellerAnalytics(sellerId) {
    return getSellerAnalytics(sellerId, UNFOLLOW_SELLER);
};

var getCompleteAccountAnalytics = exports.getCompleteAccountAnalytics = function getCompleteAccountAnalytics() {
    return {
        analytics: {
            eventPayload: {
                event: COMPLETE_ACCOUNT
            },
            eventType: _reduxSegment.EventTypes.track
        }
    };
};

var registerAnalytics = function registerAnalytics(state, bidderId, attributionData, event) {
    var whiteLabel = (0, _whiteLabel.isWhiteLabel)(state);
    return {
        analytics: [{
            eventPayload: {
                event: event,
                properties: {
                    attribution_bidderId: bidderId,
                    attribution_campaign: attributionData.campaign,
                    attribution_content: attributionData.content,
                    attribution_keyword: attributionData.keyword,
                    attribution_medium: attributionData.medium,
                    attribution_source: attributionData.source,
                    attribution_touchdate: attributionData.touchDate,
                    whiteLabel: whiteLabel
                }
            },
            eventType: _reduxSegment.EventTypes.track
        }]
    };
};

var getRegisterAccountAnalytics = exports.getRegisterAccountAnalytics = function getRegisterAccountAnalytics(state, bidderId, attributionData) {
    return registerAnalytics(state, bidderId, attributionData, REGISTER_ACCOUNT);
};

var getSetPasswordAnalytics = exports.getSetPasswordAnalytics = function getSetPasswordAnalytics(state, bidderId, attributionData) {
    return registerAnalytics(state, bidderId, attributionData, SET_PASSWORD);
};

var getLoginAnalytics = exports.getLoginAnalytics = function getLoginAnalytics(loginData) {
    return {
        analytics: {
            eventPayload: {
                traits: {
                    annualNms: loginData.annualNMS,
                    createdAt: loginData.bidder.createdDate,
                    creditCardValidated: loginData.bidder.creditCardValidated,
                    email: loginData.bidder.email,
                    firstName: loginData.bidder.firstName,
                    lastName: loginData.bidder.lastName,
                    profileComplete: loginData.bidder.profileComplete
                },
                userId: loginData.bidder.bidderId
            },
            eventType: _reduxSegment.EventTypes.identify
        }
    };
};

var getRequestedAuctionRegistrationAnalytics = exports.getRequestedAuctionRegistrationAnalytics = function getRequestedAuctionRegistrationAnalytics(state, catalogId) {
    // TODO: this is gross and needs to be refactored once we have catalogs in the
    // store, but for now it will work
    var whiteLabel = (0, _whiteLabel.isWhiteLabel)(state);

    var _ref = (0, _catalog.getCatalog)(state, catalogId) || {},
        catalogStatus = _ref.catalogStatus,
        sellerId = _ref.sellerId;

    var auctionAnalytics = {
        analytics: {
            eventPayload: {
                event: REQUESTED_AUCTION_REGISTRATION,
                properties: {
                    catalogId: catalogId,
                    catalogStatus: catalogStatus,
                    sellerId: sellerId,
                    whiteLabel: whiteLabel
                }
            },
            eventType: _reduxSegment.EventTypes.track
        }
    };
    return auctionAnalytics;
};

var getPlacedAbsenteeBidAnalytics = exports.getPlacedAbsenteeBidAnalytics = function getPlacedAbsenteeBidAnalytics(state, itemId, bidAmount) {
    // TODO: we need to decide what the proper definition of 'bidCount' is and then implement
    var _getItem = (0, _item.getItem)(state, itemId),
        catalogId = _getItem.catalogId,
        salePrice = _getItem.salePrice,
        sellerId = _getItem.sellerId,
        title = _getItem.title;

    var _getCatalog = (0, _catalog.getCatalog)(state, catalogId),
        buyersPremium = _getCatalog.buyersPremium,
        catalogStatus = _getCatalog.catalogStatus,
        currency = _getCatalog.currency;

    var _getBiddingInfo2 = (0, _biddingInfo.getBiddingInfo)(state, itemId),
        leadingBid = _getBiddingInfo2.leadingBid;

    var approvedForAuction = (0, _catalogRegistration.getCatalogRegistration)(state, catalogId).approved;
    var userData = (0, _user.getUserData)(state);
    var bidderId = userData.bidderId;
    var price = getItemPrice(salePrice, leadingBid);
    var whiteLabel = (0, _whiteLabel.isWhiteLabel)(state);
    // const bidCount = 1;
    var formatAnalytics = {
        analytics: {
            eventPayload: {
                event: PLACED_ABSENTEE_BID,
                properties: {
                    approvedForAuction: approvedForAuction,
                    // bidCount,
                    biddingStatus: 'absentee',
                    buyersPremium: buyersPremium,
                    catalogId: catalogId,
                    catalogStatus: catalogStatus,
                    currency: currency,
                    houseId: sellerId,
                    itemId: itemId,
                    orderId: itemId + '-' + bidderId,
                    products: [{
                        id: itemId,
                        name: title,
                        price: price,
                        quantity: 1
                    }],
                    total: bidAmount,
                    value: bidAmount,
                    whiteLabel: whiteLabel
                }
            },
            eventType: _reduxSegment.EventTypes.track
        }
    };

    return formatAnalytics;
};

var getRetractedAbsenteeBidAnalytics = exports.getRetractedAbsenteeBidAnalytics = function getRetractedAbsenteeBidAnalytics(state, itemId, retractionReason, retractionExplanation) {
    var userData = (0, _user.getUserData)(state);
    var bidderId = userData.bidderId;

    var formatAnalytics = {
        analytics: {
            eventPayload: {
                event: RETRACTED_ABSENTEE_BID,
                properties: {
                    bidderId: bidderId,
                    itemId: itemId,
                    retractionExplanation: retractionExplanation,
                    retractionReason: retractionReason
                }
            },
            eventType: _reduxSegment.EventTypes.track
        }
    };

    return formatAnalytics;
};

/* ACTION CREATORS */
var sailthruTrack = function sailthruTrack(url) {
    var sailthru = getSailthru();
    if (sailthru) {
        var path = (0, _urls.separateURL)(url).path ? (0, _urls.separateURL)(url).path : url;
        var finalURL = 'https://www.liveauctioneers.com' + path;
        try {
            sailthru.track('pageview', {
                url: finalURL
            });
        } catch (e) {
            // commenting out this error because its pointless
            // console.log('Edge thinks this method wants an object, but it\'s wrong!');
        }
    }
};

var saveFullStorySessionUrl = exports.saveFullStorySessionUrl = function saveFullStorySessionUrl(sessionUrl) {
    return {
        payload: sessionUrl,
        type: SAVE_FULLSTORY_SESSION_URL
    };
};

var trackPageView = function trackPageView(pageType, props) {
    return function () {
        var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch, getState) {
            var state, baseUrl, currentUrl;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            state = getState();
                            baseUrl = (0, _config.getBaseUrl)(state);
                            currentUrl = (0, _route.getCurrentUrlFromState)(state, baseUrl);


                            sailthruTrack(currentUrl);
                            return _context.abrupt('return', dispatch({
                                meta: {
                                    analytics: {
                                        eventPayload: {
                                            properties: (0, _extends3.default)({
                                                pageType: pageType,
                                                url: currentUrl
                                            }, props)
                                        },
                                        eventType: _reduxSegment.EventTypes.page
                                    }
                                },
                                payload: {},
                                type: TRACK_PAGEVIEW
                            }));

                        case 5:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, undefined);
        }));

        return function (_x3, _x4) {
            return _ref2.apply(this, arguments);
        };
    }();
};

var recordAnalyticsForAboutUsPageView = exports.recordAnalyticsForAboutUsPageView = function recordAnalyticsForAboutUsPageView() {
    return function () {
        var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(dispatch, getState) {
            return _regenerator2.default.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            return _context2.abrupt('return', dispatch(trackPageView('about us')));

                        case 1:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, undefined);
        }));

        return function (_x5, _x6) {
            return _ref3.apply(this, arguments);
        };
    }();
};

var recordAnalyticsForAccountSettingsPageView = exports.recordAnalyticsForAccountSettingsPageView = function recordAnalyticsForAccountSettingsPageView() {
    return function () {
        var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(dispatch, getState) {
            return _regenerator2.default.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            return _context3.abrupt('return', dispatch(trackPageView('account settings')));

                        case 1:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, undefined);
        }));

        return function (_x7, _x8) {
            return _ref4.apply(this, arguments);
        };
    }();
};

var recordAnalyticsForAddCreditCardPageView = exports.recordAnalyticsForAddCreditCardPageView = function recordAnalyticsForAddCreditCardPageView() {
    return function () {
        var _ref5 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4(dispatch, getState) {
            return _regenerator2.default.wrap(function _callee4$(_context4) {
                while (1) {
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            return _context4.abrupt('return', dispatch(trackPageView('add credit card')));

                        case 1:
                        case 'end':
                            return _context4.stop();
                    }
                }
            }, _callee4, undefined);
        }));

        return function (_x9, _x10) {
            return _ref5.apply(this, arguments);
        };
    }();
};

var recordAnalyticsForAuctionResultsPageView = exports.recordAnalyticsForAuctionResultsPageView = function recordAnalyticsForAuctionResultsPageView() {
    return function () {
        var _ref6 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee5(dispatch, getState) {
            return _regenerator2.default.wrap(function _callee5$(_context5) {
                while (1) {
                    switch (_context5.prev = _context5.next) {
                        case 0:
                            return _context5.abrupt('return', dispatch(trackPageView('auction results')));

                        case 1:
                        case 'end':
                            return _context5.stop();
                    }
                }
            }, _callee5, undefined);
        }));

        return function (_x11, _x12) {
            return _ref6.apply(this, arguments);
        };
    }();
};

var recordAnalyticsForBidConsolePageView = exports.recordAnalyticsForBidConsolePageView = function recordAnalyticsForBidConsolePageView(catalogId) {
    return function () {
        var _ref7 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee6(dispatch, getState) {
            var state, catalog, catalogStatus, saleStartTs, sellerId, title, pathname;
            return _regenerator2.default.wrap(function _callee6$(_context6) {
                while (1) {
                    switch (_context6.prev = _context6.next) {
                        case 0:
                            state = getState();
                            catalog = (0, _catalog.getCatalog)(state, catalogId);
                            catalogStatus = catalog.catalogStatus, saleStartTs = catalog.saleStartTs, sellerId = catalog.sellerId, title = catalog.title;
                            pathname = (0, _urls.getCatalogUrl)(catalogId, title);
                            return _context6.abrupt('return', dispatch(trackPageView('bidding console', {
                                catalogId: catalogId,
                                catalogStatus: catalogStatus,
                                houseId: sellerId,
                                path: pathname,
                                saleStartTs: saleStartTs,
                                title: title
                            })));

                        case 5:
                        case 'end':
                            return _context6.stop();
                    }
                }
            }, _callee6, undefined);
        }));

        return function (_x13, _x14) {
            return _ref7.apply(this, arguments);
        };
    }();
};

var recordAnalyticsForCatalogPageView = exports.recordAnalyticsForCatalogPageView = function recordAnalyticsForCatalogPageView(catalogId) {
    return function () {
        var _ref8 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee7(dispatch, getState) {
            var state, catalog, catalogStatus, saleStartTs, sellerId, title, pathname;
            return _regenerator2.default.wrap(function _callee7$(_context7) {
                while (1) {
                    switch (_context7.prev = _context7.next) {
                        case 0:
                            state = getState();
                            catalog = (0, _catalog.getCatalog)(state, catalogId);
                            catalogStatus = catalog.catalogStatus, saleStartTs = catalog.saleStartTs, sellerId = catalog.sellerId, title = catalog.title;
                            pathname = (0, _urls.getCatalogUrl)(catalogId, title);
                            return _context7.abrupt('return', dispatch(trackPageView('catalog', {
                                catalogId: catalogId,
                                catalogStatus: catalogStatus,
                                houseId: sellerId,
                                path: pathname,
                                saleStartTs: saleStartTs,
                                title: title
                            })));

                        case 5:
                        case 'end':
                            return _context7.stop();
                    }
                }
            }, _callee7, undefined);
        }));

        return function (_x15, _x16) {
            return _ref8.apply(this, arguments);
        };
    }();
};

var recordAnalyticsForCategoryLandingPageView = exports.recordAnalyticsForCategoryLandingPageView = function recordAnalyticsForCategoryLandingPageView() {
    return function () {
        var _ref9 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee8(dispatch, getState) {
            var state, _getCurrentUrl, pathname;

            return _regenerator2.default.wrap(function _callee8$(_context8) {
                while (1) {
                    switch (_context8.prev = _context8.next) {
                        case 0:
                            state = getState();
                            _getCurrentUrl = (0, _route.getCurrentUrl)(state), pathname = _getCurrentUrl.pathname;
                            return _context8.abrupt('return', dispatch(trackPageView('category', { path: pathname })));

                        case 3:
                        case 'end':
                            return _context8.stop();
                    }
                }
            }, _callee8, undefined);
        }));

        return function (_x17, _x18) {
            return _ref9.apply(this, arguments);
        };
    }();
};

var recordAnalyticsForConsignmentsPageView = exports.recordAnalyticsForConsignmentsPageView = function recordAnalyticsForConsignmentsPageView() {
    return function () {
        var _ref10 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee9(dispatch, getState) {
            return _regenerator2.default.wrap(function _callee9$(_context9) {
                while (1) {
                    switch (_context9.prev = _context9.next) {
                        case 0:
                            return _context9.abrupt('return', dispatch(trackPageView('consignments')));

                        case 1:
                        case 'end':
                            return _context9.stop();
                    }
                }
            }, _callee9, undefined);
        }));

        return function (_x19, _x20) {
            return _ref10.apply(this, arguments);
        };
    }();
};

var recordAnalyticsForCheckoutConfirmationPageView = exports.recordAnalyticsForCheckoutConfirmationPageView = function recordAnalyticsForCheckoutConfirmationPageView() {
    return function () {
        var _ref11 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee10(dispatch, getState) {
            return _regenerator2.default.wrap(function _callee10$(_context10) {
                while (1) {
                    switch (_context10.prev = _context10.next) {
                        case 0:
                            return _context10.abrupt('return', dispatch(trackPageView('checkout confirmation')));

                        case 1:
                        case 'end':
                            return _context10.stop();
                    }
                }
            }, _callee10, undefined);
        }));

        return function (_x21, _x22) {
            return _ref11.apply(this, arguments);
        };
    }();
};

var recordAnalyticsForCheckoutPageView = exports.recordAnalyticsForCheckoutPageView = function recordAnalyticsForCheckoutPageView() {
    return function () {
        var _ref12 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee11(dispatch, getState) {
            return _regenerator2.default.wrap(function _callee11$(_context11) {
                while (1) {
                    switch (_context11.prev = _context11.next) {
                        case 0:
                            return _context11.abrupt('return', dispatch(trackPageView('checkout page')));

                        case 1:
                        case 'end':
                            return _context11.stop();
                    }
                }
            }, _callee11, undefined);
        }));

        return function (_x23, _x24) {
            return _ref12.apply(this, arguments);
        };
    }();
};

var recordAnalyticsForFeaturesPageView = exports.recordAnalyticsForFeaturesPageView = function recordAnalyticsForFeaturesPageView() {
    return function () {
        var _ref13 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee12(dispatch, getState) {
            return _regenerator2.default.wrap(function _callee12$(_context12) {
                while (1) {
                    switch (_context12.prev = _context12.next) {
                        case 0:
                            return _context12.abrupt('return', dispatch(trackPageView('features')));

                        case 1:
                        case 'end':
                            return _context12.stop();
                    }
                }
            }, _callee12, undefined);
        }));

        return function (_x25, _x26) {
            return _ref13.apply(this, arguments);
        };
    }();
};

var recordAnalyticsForFollowedSellersPageView = exports.recordAnalyticsForFollowedSellersPageView = function recordAnalyticsForFollowedSellersPageView() {
    return function () {
        var _ref14 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee13(dispatch, getState) {
            return _regenerator2.default.wrap(function _callee13$(_context13) {
                while (1) {
                    switch (_context13.prev = _context13.next) {
                        case 0:
                            return _context13.abrupt('return', dispatch(trackPageView('followed sellers')));

                        case 1:
                        case 'end':
                            return _context13.stop();
                    }
                }
            }, _callee13, undefined);
        }));

        return function (_x27, _x28) {
            return _ref14.apply(this, arguments);
        };
    }();
};

var recordAnalyticsForHomePageView = exports.recordAnalyticsForHomePageView = function recordAnalyticsForHomePageView() {
    return function () {
        var _ref15 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee14(dispatch, getState) {
            return _regenerator2.default.wrap(function _callee14$(_context14) {
                while (1) {
                    switch (_context14.prev = _context14.next) {
                        case 0:
                            return _context14.abrupt('return', dispatch(trackPageView('home')));

                        case 1:
                        case 'end':
                            return _context14.stop();
                    }
                }
            }, _callee14, undefined);
        }));

        return function (_x29, _x30) {
            return _ref15.apply(this, arguments);
        };
    }();
};

var recordAnalyticsForHowItWorksPageView = exports.recordAnalyticsForHowItWorksPageView = function recordAnalyticsForHowItWorksPageView() {
    return function () {
        var _ref16 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee15(dispatch, getState) {
            return _regenerator2.default.wrap(function _callee15$(_context15) {
                while (1) {
                    switch (_context15.prev = _context15.next) {
                        case 0:
                            return _context15.abrupt('return', dispatch(trackPageView('how it works')));

                        case 1:
                        case 'end':
                            return _context15.stop();
                    }
                }
            }, _callee15, undefined);
        }));

        return function (_x31, _x32) {
            return _ref16.apply(this, arguments);
        };
    }();
};

var recordAnalyticsForIdentify = exports.recordAnalyticsForIdentify = function recordAnalyticsForIdentify(bidder) {
    return {
        meta: getLoginAnalytics(bidder),
        payload: {},
        type: IDENTIFY_ANALYTICS
    };
};

var recordAnalyticsForIntellectualPropertyPageView = exports.recordAnalyticsForIntellectualPropertyPageView = function recordAnalyticsForIntellectualPropertyPageView() {
    return function () {
        var _ref17 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee16(dispatch, getState) {
            return _regenerator2.default.wrap(function _callee16$(_context16) {
                while (1) {
                    switch (_context16.prev = _context16.next) {
                        case 0:
                            return _context16.abrupt('return', dispatch(trackPageView('intellectual property')));

                        case 1:
                        case 'end':
                            return _context16.stop();
                    }
                }
            }, _callee16, undefined);
        }));

        return function (_x33, _x34) {
            return _ref17.apply(this, arguments);
        };
    }();
};

var recordAnalyticsForItemPageView = exports.recordAnalyticsForItemPageView = function recordAnalyticsForItemPageView(itemId) {
    return function () {
        var _ref18 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee17(dispatch, getState) {
            var state, item, catalog, biddingInfo, facets, salePrice, sellerId, title, buyersPremium, catalogId, catalogStatus, categories, creators, materialsTechniques, origins, stylePeriods, leadingBid, pathname, pageType;
            return _regenerator2.default.wrap(function _callee17$(_context17) {
                while (1) {
                    switch (_context17.prev = _context17.next) {
                        case 0:
                            state = getState();
                            item = (0, _item.getItem)(state, itemId);
                            catalog = (0, _catalog.getCatalog)(state, item.catalogId);
                            biddingInfo = (0, _biddingInfo.getBiddingInfo)(state, itemId);
                            facets = (0, _itemFacets.getItemFacets)(state, itemId);
                            salePrice = item.salePrice, sellerId = item.sellerId, title = item.title;
                            buyersPremium = catalog.buyersPremium, catalogId = catalog.catalogId, catalogStatus = catalog.catalogStatus;
                            categories = facets.categories, creators = facets.creators, materialsTechniques = facets.materialsTechniques, origins = facets.origins, stylePeriods = facets.stylePeriods;
                            leadingBid = biddingInfo.leadingBid;
                            pathname = (0, _urls.getItemUrl)(itemId, title);
                            pageType = catalogStatus === 'done' ? 'sold item' : 'item';
                            return _context17.abrupt('return', dispatch(trackPageView(pageType, {
                                buyersPremium: buyersPremium,
                                catalogId: catalogId,
                                catalogStatus: catalogStatus,
                                categories: categories,
                                creators: creators,
                                houseId: sellerId,
                                itemId: itemId,
                                materialsTechniques: materialsTechniques,
                                origins: origins,
                                path: pathname,
                                salePrice: salePrice || leadingBid,
                                stylePeriods: stylePeriods,
                                title: title
                            })));

                        case 12:
                        case 'end':
                            return _context17.stop();
                    }
                }
            }, _callee17, undefined);
        }));

        return function (_x35, _x36) {
            return _ref18.apply(this, arguments);
        };
    }();
};

var recordAnalyticsForMessagesPageView = exports.recordAnalyticsForMessagesPageView = function recordAnalyticsForMessagesPageView() {
    return function () {
        var _ref19 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee18(dispatch, getState) {
            return _regenerator2.default.wrap(function _callee18$(_context18) {
                while (1) {
                    switch (_context18.prev = _context18.next) {
                        case 0:
                            return _context18.abrupt('return', dispatch(trackPageView('messages')));

                        case 1:
                        case 'end':
                            return _context18.stop();
                    }
                }
            }, _callee18, undefined);
        }));

        return function (_x37, _x38) {
            return _ref19.apply(this, arguments);
        };
    }();
};

var recordAnalyticsForMobilePageView = exports.recordAnalyticsForMobilePageView = function recordAnalyticsForMobilePageView() {
    return function () {
        var _ref20 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee19(dispatch, getState) {
            return _regenerator2.default.wrap(function _callee19$(_context19) {
                while (1) {
                    switch (_context19.prev = _context19.next) {
                        case 0:
                            return _context19.abrupt('return', dispatch(trackPageView('mobile', { path: '/mobile' })));

                        case 1:
                        case 'end':
                            return _context19.stop();
                    }
                }
            }, _callee19, undefined);
        }));

        return function (_x39, _x40) {
            return _ref20.apply(this, arguments);
        };
    }();
};

var recordAnalyticsForMyAuctionsPageView = exports.recordAnalyticsForMyAuctionsPageView = function recordAnalyticsForMyAuctionsPageView() {
    return function () {
        var _ref21 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee20(dispatch, getState) {
            var pathname;
            return _regenerator2.default.wrap(function _callee20$(_context20) {
                while (1) {
                    switch (_context20.prev = _context20.next) {
                        case 0:
                            pathname = (0, _urls.getMyAuctionsUrl)();
                            return _context20.abrupt('return', dispatch(trackPageView('my auctions', { path: pathname })));

                        case 2:
                        case 'end':
                            return _context20.stop();
                    }
                }
            }, _callee20, undefined);
        }));

        return function (_x41, _x42) {
            return _ref21.apply(this, arguments);
        };
    }();
};

var recordAnalyticsForMyBidsPageView = exports.recordAnalyticsForMyBidsPageView = function recordAnalyticsForMyBidsPageView() {
    return function () {
        var _ref22 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee21(dispatch, getState) {
            var pathname;
            return _regenerator2.default.wrap(function _callee21$(_context21) {
                while (1) {
                    switch (_context21.prev = _context21.next) {
                        case 0:
                            pathname = (0, _urls.getMyBidsUrl)();
                            return _context21.abrupt('return', dispatch(trackPageView('my bids', { path: pathname })));

                        case 2:
                        case 'end':
                            return _context21.stop();
                    }
                }
            }, _callee21, undefined);
        }));

        return function (_x43, _x44) {
            return _ref22.apply(this, arguments);
        };
    }();
};

var recordAnalyticsForNearMePageView = exports.recordAnalyticsForNearMePageView = function recordAnalyticsForNearMePageView() {
    return function () {
        var _ref23 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee22(dispatch, getState) {
            return _regenerator2.default.wrap(function _callee22$(_context22) {
                while (1) {
                    switch (_context22.prev = _context22.next) {
                        case 0:
                            return _context22.abrupt('return', dispatch(trackPageView('near me')));

                        case 1:
                        case 'end':
                            return _context22.stop();
                    }
                }
            }, _callee22, undefined);
        }));

        return function (_x45, _x46) {
            return _ref23.apply(this, arguments);
        };
    }();
};

var recordAnalyticsForPasswordResetPageView = exports.recordAnalyticsForPasswordResetPageView = function recordAnalyticsForPasswordResetPageView() {
    return function () {
        var _ref24 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee23(dispatch, getState) {
            return _regenerator2.default.wrap(function _callee23$(_context23) {
                while (1) {
                    switch (_context23.prev = _context23.next) {
                        case 0:
                            return _context23.abrupt('return', dispatch(trackPageView('password reset')));

                        case 1:
                        case 'end':
                            return _context23.stop();
                    }
                }
            }, _callee23, undefined);
        }));

        return function (_x47, _x48) {
            return _ref24.apply(this, arguments);
        };
    }();
};

var recordAnalyticsForPrivacyPageView = exports.recordAnalyticsForPrivacyPageView = function recordAnalyticsForPrivacyPageView() {
    return function () {
        var _ref25 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee24(dispatch, getState) {
            return _regenerator2.default.wrap(function _callee24$(_context24) {
                while (1) {
                    switch (_context24.prev = _context24.next) {
                        case 0:
                            return _context24.abrupt('return', dispatch(trackPageView('privacy')));

                        case 1:
                        case 'end':
                            return _context24.stop();
                    }
                }
            }, _callee24, undefined);
        }));

        return function (_x49, _x50) {
            return _ref25.apply(this, arguments);
        };
    }();
};

var recordAnalyticsForPRServicesPageView = exports.recordAnalyticsForPRServicesPageView = function recordAnalyticsForPRServicesPageView() {
    return function () {
        var _ref26 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee25(dispatch, getState) {
            return _regenerator2.default.wrap(function _callee25$(_context25) {
                while (1) {
                    switch (_context25.prev = _context25.next) {
                        case 0:
                            return _context25.abrupt('return', dispatch(trackPageView('pr services')));

                        case 1:
                        case 'end':
                            return _context25.stop();
                    }
                }
            }, _callee25, undefined);
        }));

        return function (_x51, _x52) {
            return _ref26.apply(this, arguments);
        };
    }();
};

var recordAnalyticsForSavedItemsPageView = exports.recordAnalyticsForSavedItemsPageView = function recordAnalyticsForSavedItemsPageView() {
    return function () {
        var _ref27 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee26(dispatch, getState) {
            var pathname;
            return _regenerator2.default.wrap(function _callee26$(_context26) {
                while (1) {
                    switch (_context26.prev = _context26.next) {
                        case 0:
                            pathname = (0, _urls.getSavedItemsUrl)();
                            return _context26.abrupt('return', dispatch(trackPageView('saved items', { path: pathname })));

                        case 2:
                        case 'end':
                            return _context26.stop();
                    }
                }
            }, _callee26, undefined);
        }));

        return function (_x53, _x54) {
            return _ref27.apply(this, arguments);
        };
    }();
};

var recordAnalyticsForSavedSearchesPageView = exports.recordAnalyticsForSavedSearchesPageView = function recordAnalyticsForSavedSearchesPageView(pageType) {
    return function () {
        var _ref28 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee27(dispatch, getState) {
            return _regenerator2.default.wrap(function _callee27$(_context27) {
                while (1) {
                    switch (_context27.prev = _context27.next) {
                        case 0:
                            return _context27.abrupt('return', dispatch(trackPageView(pageType)));

                        case 1:
                        case 'end':
                            return _context27.stop();
                    }
                }
            }, _callee27, undefined);
        }));

        return function (_x55, _x56) {
            return _ref28.apply(this, arguments);
        };
    }();
};

var recordAnalyticsForSellerDirectoryPageView = exports.recordAnalyticsForSellerDirectoryPageView = function recordAnalyticsForSellerDirectoryPageView() {
    return function () {
        var _ref29 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee28(dispatch, getState) {
            return _regenerator2.default.wrap(function _callee28$(_context28) {
                while (1) {
                    switch (_context28.prev = _context28.next) {
                        case 0:
                            return _context28.abrupt('return', dispatch(trackPageView('directory')));

                        case 1:
                        case 'end':
                            return _context28.stop();
                    }
                }
            }, _callee28, undefined);
        }));

        return function (_x57, _x58) {
            return _ref29.apply(this, arguments);
        };
    }();
};

var recordAnalyticsForSellerTestimonialsPageView = exports.recordAnalyticsForSellerTestimonialsPageView = function recordAnalyticsForSellerTestimonialsPageView() {
    return function () {
        var _ref30 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee29(dispatch, getState) {
            return _regenerator2.default.wrap(function _callee29$(_context29) {
                while (1) {
                    switch (_context29.prev = _context29.next) {
                        case 0:
                            return _context29.abrupt('return', dispatch(trackPageView('testimonials')));

                        case 1:
                        case 'end':
                            return _context29.stop();
                    }
                }
            }, _callee29, undefined);
        }));

        return function (_x59, _x60) {
            return _ref30.apply(this, arguments);
        };
    }();
};

var recordAnalyticsForSellerPageView = exports.recordAnalyticsForSellerPageView = function recordAnalyticsForSellerPageView(sellerId) {
    return function () {
        var _ref31 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee30(dispatch, getState) {
            var state, seller, name, pathname;
            return _regenerator2.default.wrap(function _callee30$(_context30) {
                while (1) {
                    switch (_context30.prev = _context30.next) {
                        case 0:
                            state = getState();
                            seller = (0, _seller.getSeller)(state, sellerId);
                            name = seller.name;
                            pathname = (0, _urls.getSellerUrl)(sellerId, name);
                            return _context30.abrupt('return', dispatch(trackPageView('auctioneer', {
                                houseId: sellerId,
                                name: name,
                                path: pathname
                            })));

                        case 5:
                        case 'end':
                            return _context30.stop();
                    }
                }
            }, _callee30, undefined);
        }));

        return function (_x61, _x62) {
            return _ref31.apply(this, arguments);
        };
    }();
};

var recordAnalyticsForSearchItemsPageView = exports.recordAnalyticsForSearchItemsPageView = function recordAnalyticsForSearchItemsPageView() {
    return function () {
        var _ref32 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee31(dispatch, getState) {
            var state, _getCurrentUrl2, pathname;

            return _regenerator2.default.wrap(function _callee31$(_context31) {
                while (1) {
                    switch (_context31.prev = _context31.next) {
                        case 0:
                            state = getState();
                            _getCurrentUrl2 = (0, _route.getCurrentUrl)(state), pathname = _getCurrentUrl2.pathname;
                            return _context31.abrupt('return', dispatch(trackPageView('search', { path: pathname })));

                        case 3:
                        case 'end':
                            return _context31.stop();
                    }
                }
            }, _callee31, undefined);
        }));

        return function (_x63, _x64) {
            return _ref32.apply(this, arguments);
        };
    }();
};

var recordAnalyticsForTermsAndConditionsPageView = exports.recordAnalyticsForTermsAndConditionsPageView = function recordAnalyticsForTermsAndConditionsPageView() {
    return function () {
        var _ref33 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee32(dispatch, getState) {
            return _regenerator2.default.wrap(function _callee32$(_context32) {
                while (1) {
                    switch (_context32.prev = _context32.next) {
                        case 0:
                            return _context32.abrupt('return', dispatch(trackPageView('terms and conditions')));

                        case 1:
                        case 'end':
                            return _context32.stop();
                    }
                }
            }, _callee32, undefined);
        }));

        return function (_x65, _x66) {
            return _ref33.apply(this, arguments);
        };
    }();
};

var recordAnalyticsForTerminologyPageView = exports.recordAnalyticsForTerminologyPageView = function recordAnalyticsForTerminologyPageView() {
    return function () {
        var _ref34 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee33(dispatch, getState) {
            return _regenerator2.default.wrap(function _callee33$(_context33) {
                while (1) {
                    switch (_context33.prev = _context33.next) {
                        case 0:
                            return _context33.abrupt('return', dispatch(trackPageView('terminology')));

                        case 1:
                        case 'end':
                            return _context33.stop();
                    }
                }
            }, _callee33, undefined);
        }));

        return function (_x67, _x68) {
            return _ref34.apply(this, arguments);
        };
    }();
};

var recordAnalyticsForWonItemsPageView = exports.recordAnalyticsForWonItemsPageView = function recordAnalyticsForWonItemsPageView() {
    return function () {
        var _ref35 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee34(dispatch, getState) {
            return _regenerator2.default.wrap(function _callee34$(_context34) {
                while (1) {
                    switch (_context34.prev = _context34.next) {
                        case 0:
                            dispatch(trackPageView('won items'));

                        case 1:
                        case 'end':
                            return _context34.stop();
                    }
                }
            }, _callee34, undefined);
        }));

        return function (_x69, _x70) {
            return _ref35.apply(this, arguments);
        };
    }();
};

var getGAEventAnalytics = function getGAEventAnalytics(action, category, label) {
    return {
        analytics: {
            eventPayload: {
                event: action,
                properties: {
                    action: action,
                    category: category,
                    label: label
                }
            },
            eventType: _reduxSegment.EventTypes.track
        }
    };
};

var trackClick = exports.trackClick = function trackClick(action, label) {
    return function () {
        var _ref36 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee35(dispatch, getState) {
            var analytics;
            return _regenerator2.default.wrap(function _callee35$(_context35) {
                while (1) {
                    switch (_context35.prev = _context35.next) {
                        case 0:
                            analytics = getGAEventAnalytics(action, 'Navigation', label);
                            return _context35.abrupt('return', dispatch({
                                meta: (0, _extends3.default)({}, analytics),
                                payload: {},
                                type: TRACK_CLICK
                            }));

                        case 2:
                        case 'end':
                            return _context35.stop();
                    }
                }
            }, _callee35, undefined);
        }));

        return function (_x71, _x72) {
            return _ref36.apply(this, arguments);
        };
    }();
};

var trackAdUnitClick = exports.trackAdUnitClick = function trackAdUnitClick(_ref37) {
    var adUnitId = _ref37.adUnitId,
        catalogId = _ref37.catalogId,
        sellerId = _ref37.sellerId;
    return function () {
        var _ref38 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee36(dispatch, getState) {
            var state, bidderId, action, label, analytics;
            return _regenerator2.default.wrap(function _callee36$(_context36) {
                while (1) {
                    switch (_context36.prev = _context36.next) {
                        case 0:
                            state = getState();
                            bidderId = (0, _user.getBidderId)(state);
                            action = 'Clicked ' + (catalogId ? 'Catalog' : 'Consignmet') + ' Ad Unit';
                            label = 'sideBanner-' + adUnitId + '-' + (catalogId || sellerId);

                            if (bidderId !== -1) {
                                label += '-' + bidderId;
                            }

                            analytics = getGAEventAnalytics(action, 'Navigation', label);
                            return _context36.abrupt('return', dispatch({
                                meta: (0, _extends3.default)({}, analytics),
                                payload: {},
                                type: TRACK_CLICK
                            }));

                        case 7:
                        case 'end':
                            return _context36.stop();
                    }
                }
            }, _callee36, undefined);
        }));

        return function (_x73, _x74) {
            return _ref38.apply(this, arguments);
        };
    }();
};

var trackACNClick = exports.trackACNClick = function trackACNClick(label) {
    return function () {
        var _ref39 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee37(dispatch, getState) {
            var state, bidderId, action, labelToUse, analytics;
            return _regenerator2.default.wrap(function _callee37$(_context37) {
                while (1) {
                    switch (_context37.prev = _context37.next) {
                        case 0:
                            state = getState();
                            bidderId = (0, _user.getBidderId)(state);
                            action = 'Clicked Homepage ACN Module';
                            labelToUse = '' + label;

                            if (bidderId !== -1) {
                                labelToUse += '-' + bidderId;
                            }

                            analytics = getGAEventAnalytics(action, 'Navigation', labelToUse);
                            return _context37.abrupt('return', dispatch({
                                meta: (0, _extends3.default)({}, analytics),
                                payload: {},
                                type: TRACK_CLICK
                            }));

                        case 7:
                        case 'end':
                            return _context37.stop();
                    }
                }
            }, _callee37, undefined);
        }));

        return function (_x75, _x76) {
            return _ref39.apply(this, arguments);
        };
    }();
};

var trackHeroClick = exports.trackHeroClick = function trackHeroClick(label) {
    return function () {
        var _ref40 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee38(dispatch, getState) {
            var state, bidderId, action, labelToUse, analytics;
            return _regenerator2.default.wrap(function _callee38$(_context38) {
                while (1) {
                    switch (_context38.prev = _context38.next) {
                        case 0:
                            state = getState();
                            bidderId = (0, _user.getBidderId)(state);
                            action = 'Clicked Homepage Hero Banner Module';
                            labelToUse = '' + label;

                            if (bidderId !== -1) {
                                labelToUse += '-' + bidderId;
                            }

                            analytics = getGAEventAnalytics(action, 'Navigation', labelToUse);
                            return _context38.abrupt('return', dispatch({
                                meta: (0, _extends3.default)({}, analytics),
                                payload: {},
                                type: TRACK_CLICK
                            }));

                        case 7:
                        case 'end':
                            return _context38.stop();
                    }
                }
            }, _callee38, undefined);
        }));

        return function (_x77, _x78) {
            return _ref40.apply(this, arguments);
        };
    }();
};

var trackFeaturedCatalogClick = exports.trackFeaturedCatalogClick = function trackFeaturedCatalogClick(catalogId) {
    return function () {
        var _ref41 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee39(dispatch, getState) {
            var state, _getCatalog2, sellerId, bidderId, action, label, analytics;

            return _regenerator2.default.wrap(function _callee39$(_context39) {
                while (1) {
                    switch (_context39.prev = _context39.next) {
                        case 0:
                            state = getState();
                            _getCatalog2 = (0, _catalog.getCatalog)(state, catalogId), sellerId = _getCatalog2.sellerId;
                            bidderId = (0, _user.getBidderId)(state);
                            action = 'Clicked Homepage Featured Auctions Module';
                            label = 'featured-' + catalogId + '-' + sellerId;

                            if (bidderId !== -1) {
                                label += '-' + bidderId;
                            }

                            analytics = getGAEventAnalytics(action, 'Navigation', label);
                            return _context39.abrupt('return', dispatch({
                                meta: (0, _extends3.default)({}, analytics),
                                payload: {},
                                type: TRACK_CLICK
                            }));

                        case 8:
                        case 'end':
                            return _context39.stop();
                    }
                }
            }, _callee39, undefined);
        }));

        return function (_x79, _x80) {
            return _ref41.apply(this, arguments);
        };
    }();
};

var trackFeaturedCategoryClick = exports.trackFeaturedCategoryClick = function trackFeaturedCategoryClick(label) {
    return function () {
        var _ref42 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee40(dispatch, getState) {
            var state, bidderId, action, labelToUse, analytics;
            return _regenerator2.default.wrap(function _callee40$(_context40) {
                while (1) {
                    switch (_context40.prev = _context40.next) {
                        case 0:
                            state = getState();
                            bidderId = (0, _user.getBidderId)(state);
                            action = 'Clicked Homepage Featured Categories Module';
                            labelToUse = '' + label;

                            if (bidderId !== -1) {
                                labelToUse += '-' + bidderId;
                            }

                            analytics = getGAEventAnalytics(action, 'Navigation', labelToUse);
                            return _context40.abrupt('return', dispatch({
                                meta: (0, _extends3.default)({}, analytics),
                                payload: {},
                                type: TRACK_CLICK
                            }));

                        case 7:
                        case 'end':
                            return _context40.stop();
                    }
                }
            }, _callee40, undefined);
        }));

        return function (_x81, _x82) {
            return _ref42.apply(this, arguments);
        };
    }();
};

var trackTrendingItemClick = exports.trackTrendingItemClick = function trackTrendingItemClick(itemId) {
    return function () {
        var _ref43 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee41(dispatch, getState) {
            var state, _getItem2, catalogId, _getCatalog3, sellerId, bidderId, action, label, analytics;

            return _regenerator2.default.wrap(function _callee41$(_context41) {
                while (1) {
                    switch (_context41.prev = _context41.next) {
                        case 0:
                            state = getState();
                            _getItem2 = (0, _item.getItem)(state, itemId), catalogId = _getItem2.catalogId;
                            _getCatalog3 = (0, _catalog.getCatalog)(state, catalogId), sellerId = _getCatalog3.sellerId;
                            bidderId = (0, _user.getBidderId)(state);
                            action = 'Clicked Homepage Trending Items Module';
                            label = 'Trending-Items-' + itemId + '-' + sellerId;

                            if (bidderId !== -1) {
                                label += '-' + bidderId;
                            }

                            analytics = getGAEventAnalytics(action, 'Navigation', label);
                            return _context41.abrupt('return', dispatch({
                                meta: (0, _extends3.default)({}, analytics),
                                payload: {},
                                type: TRACK_CLICK
                            }));

                        case 9:
                        case 'end':
                            return _context41.stop();
                    }
                }
            }, _callee41, undefined);
        }));

        return function (_x83, _x84) {
            return _ref43.apply(this, arguments);
        };
    }();
};

var trackUpcomingCatalogClick = exports.trackUpcomingCatalogClick = function trackUpcomingCatalogClick(catalogId) {
    return function () {
        var _ref44 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee42(dispatch, getState) {
            var state, _getCatalog4, catalogStatus, sellerId, bidderId, status, action, label, analytics;

            return _regenerator2.default.wrap(function _callee42$(_context42) {
                while (1) {
                    switch (_context42.prev = _context42.next) {
                        case 0:
                            state = getState();
                            _getCatalog4 = (0, _catalog.getCatalog)(state, catalogId), catalogStatus = _getCatalog4.catalogStatus, sellerId = _getCatalog4.sellerId;
                            bidderId = (0, _user.getBidderId)(state);
                            status = catalogStatus === 'online' ? 'upcoming' : catalogStatus;
                            action = 'Clicked Homepage Live and Upcoming Auctions Module';
                            label = status + '-' + catalogId + '-' + sellerId;

                            if (bidderId !== -1) {
                                label += '-' + bidderId;
                            }

                            analytics = getGAEventAnalytics(action, 'Navigation', label);
                            return _context42.abrupt('return', dispatch({
                                meta: (0, _extends3.default)({}, analytics),
                                payload: {},
                                type: TRACK_CLICK
                            }));

                        case 9:
                        case 'end':
                            return _context42.stop();
                    }
                }
            }, _callee42, undefined);
        }));

        return function (_x85, _x86) {
            return _ref44.apply(this, arguments);
        };
    }();
};

var recordAttributionAnalytics = exports.recordAttributionAnalytics = function recordAttributionAnalytics(data) {
    return {
        meta: {
            analytics: {
                eventPayload: {
                    properties: {
                        attribution_bidderId: data.bidderId,
                        attribution_campaign: data.campaign,
                        attribution_content: data.content,
                        attribution_keyword: data.keyword,
                        attribution_medium: data.medium,
                        attribution_source: data.source,
                        attribution_touchdate: data.touchDate,
                        nonInteraction: 1,
                        should_store_in_db: true
                    }
                },
                eventType: _reduxSegment.EventTypes.track
            }
        },
        payload: {},
        type: TRACK_ATTRIBUTION_DATA
    };
};

/***/ }),

/***/ "z0Eu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"catalog-card":"catalog-card___I3lEY","card-body":"card-body___1a_gB","left":"left___2wvJ6","cover-lots":"cover-lots___1oden","middle":"middle___1sx99","title":"title___3anX5","description":"description___1YddN","right":"right___1WMpx","start-date":"start-date___zA11c","live-link-container":"live-link-container___2KA_W","live":"live___3bJZS","explore":"explore___2yNM5","register-link":"register-link___2q9Bg"};

/***/ }),

/***/ "z3uV":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = __webpack_require__("dcb+");

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _reactGoogleTagManager = __webpack_require__("co1z");

var _reactGoogleTagManager2 = _interopRequireDefault(_reactGoogleTagManager);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GoogleTagManager = function (_Component) {
    (0, _inherits3.default)(GoogleTagManager, _Component);

    function GoogleTagManager() {
        (0, _classCallCheck3.default)(this, GoogleTagManager);
        return (0, _possibleConstructorReturn3.default)(this, (GoogleTagManager.__proto__ || (0, _getPrototypeOf2.default)(GoogleTagManager)).apply(this, arguments));
    }

    (0, _createClass3.default)(GoogleTagManager, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var dataLayerName = this.props.dataLayerName || 'dataLayer';
            var scriptId = this.props.scriptId || 'react-google-tag-manager-gtm';

            if (!window[dataLayerName]) {
                var gtmScriptNode = document.getElementById(scriptId);

                /* eslint-disable no-eval */
                eval(gtmScriptNode.textContent);
                /* eslint-enable no-eval */
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var gtm = (0, _reactGoogleTagManager2.default)({
                additionalEvents: this.props.additionalEvents || {},
                dataLayerName: this.props.dataLayerName || 'dataLayer',
                id: this.props.gtmId,
                previewVariables: this.props.previewVariables || false
            });

            return (0, _jsx3.default)(_react.Fragment, {}, void 0, (0, _jsx3.default)('div', {}, void 0, gtm.noScriptAsReact()), (0, _jsx3.default)('div', {
                id: this.props.scriptId || 'react-google-tag-manager-gtm'
            }, void 0, gtm.scriptAsReact()));
        }
    }]);
    return GoogleTagManager;
}(_react.Component);

exports.default = GoogleTagManager;
module.exports = exports['default'];

/***/ }),

/***/ "z8S5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = __webpack_require__("dcb+");

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _LAFooterContainer = __webpack_require__("lT8R");

var _LAFooterContainer2 = _interopRequireDefault(_LAFooterContainer);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _WhiteLabelFooterContainer = __webpack_require__("d3Wo");

var _WhiteLabelFooterContainer2 = _interopRequireDefault(_WhiteLabelFooterContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Footer = function (_PureComponent) {
    (0, _inherits3.default)(Footer, _PureComponent);

    function Footer() {
        (0, _classCallCheck3.default)(this, Footer);
        return (0, _possibleConstructorReturn3.default)(this, (Footer.__proto__ || (0, _getPrototypeOf2.default)(Footer)).apply(this, arguments));
    }

    (0, _createClass3.default)(Footer, [{
        key: 'render',
        value: function render() {
            var whiteLabel = this.props.whiteLabel;


            return whiteLabel ? (0, _jsx3.default)(_WhiteLabelFooterContainer2.default, {}) : (0, _jsx3.default)(_LAFooterContainer2.default, {});
        }
    }]);
    return Footer;
}(_react.PureComponent);

exports.default = Footer;
module.exports = exports['default'];

/***/ }),

/***/ "zFQO":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _auth = __webpack_require__("AGZl");

Object.defineProperty(exports, 'Auth', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_auth).default;
  }
});

var _bid = __webpack_require__("c28x");

Object.defineProperty(exports, 'Bid', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_bid).default;
  }
});

var _bidHistory = __webpack_require__("5qJt");

Object.defineProperty(exports, 'BidHistory', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_bidHistory).default;
  }
});

var _bidIncrements = __webpack_require__("795h");

Object.defineProperty(exports, 'BidIncrements', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_bidIncrements).default;
  }
});

var _bidder = __webpack_require__("Hwmz");

Object.defineProperty(exports, 'Bidder', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_bidder).default;
  }
});

var _biddingInfo = __webpack_require__("1dxa");

Object.defineProperty(exports, 'BiddingInfo', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_biddingInfo).default;
  }
});

var _catalog = __webpack_require__("bRXb");

Object.defineProperty(exports, 'Catalog', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_catalog).default;
  }
});

var _catalogAd = __webpack_require__("0jBl");

Object.defineProperty(exports, 'CatalogAd', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_catalogAd).default;
  }
});

var _catalogDetail = __webpack_require__("Kt20");

Object.defineProperty(exports, 'CatalogDetail', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_catalogDetail).default;
  }
});

var _catalogLocation = __webpack_require__("AMoU");

Object.defineProperty(exports, 'CatalogLocation', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_catalogLocation).default;
  }
});

var _catalogSearch = __webpack_require__("yR8t");

Object.defineProperty(exports, 'CatalogSearch', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_catalogSearch).default;
  }
});

var _checkout = __webpack_require__("sSv9");

Object.defineProperty(exports, 'Checkout', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_checkout).default;
  }
});

var _catalogRegistration = __webpack_require__("rj0E");

Object.defineProperty(exports, 'CatalogRegistration', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_catalogRegistration).default;
  }
});

var _consignment = __webpack_require__("/rMq");

Object.defineProperty(exports, 'Consignment', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_consignment).default;
  }
});

var _coverLots = __webpack_require__("8kzA");

Object.defineProperty(exports, 'CoverLots', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_coverLots).default;
  }
});

var _emailList = __webpack_require__("kA98");

Object.defineProperty(exports, 'EmailList', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_emailList).default;
  }
});

var _healthcheck = __webpack_require__("+RB6");

Object.defineProperty(exports, 'HealthCheck', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_healthcheck).default;
  }
});

var _home = __webpack_require__("IWsF");

Object.defineProperty(exports, 'Home', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_home).default;
  }
});

var _item = __webpack_require__("lSbF");

Object.defineProperty(exports, 'Item', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_item).default;
  }
});

var _itemDetail = __webpack_require__("/L+n");

Object.defineProperty(exports, 'ItemDetail', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_itemDetail).default;
  }
});

var _itemFacets = __webpack_require__("ZbCA");

Object.defineProperty(exports, 'ItemFacets', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_itemFacets).default;
  }
});

var _lostItems = __webpack_require__("9yZm");

Object.defineProperty(exports, 'LostItems', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_lostItems).default;
  }
});

var _liveCatalogStatus = __webpack_require__("CwSH");

Object.defineProperty(exports, 'LiveCatalogStatus', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_liveCatalogStatus).default;
  }
});

var _saveItem = __webpack_require__("wUUL");

Object.defineProperty(exports, 'SaveItem', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_saveItem).default;
  }
});

var _saveSearch = __webpack_require__("Ykd8");

Object.defineProperty(exports, 'SaveSearch', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_saveSearch).default;
  }
});

var _search = __webpack_require__("TdMF");

Object.defineProperty(exports, 'Search', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_search).default;
  }
});

var _searchSuggestions = __webpack_require__("v7uI");

Object.defineProperty(exports, 'SearchSuggestions', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_searchSuggestions).default;
  }
});

var _seller = __webpack_require__("yM+3");

Object.defineProperty(exports, 'Seller', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_seller).default;
  }
});

var _sellerCatalogs = __webpack_require__("kIRm");

Object.defineProperty(exports, 'SellerCatalogs', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_sellerCatalogs).default;
  }
});

var _sellerDetail = __webpack_require__("HW2X");

Object.defineProperty(exports, 'SellerDetail', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_sellerDetail).default;
  }
});

var _sellerRecordResults = __webpack_require__("iZFz");

Object.defineProperty(exports, 'SellerRecordResults', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_sellerRecordResults).default;
  }
});

var _similarItems = __webpack_require__("ApaR");

Object.defineProperty(exports, 'SimilarItems', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_similarItems).default;
  }
});

var _wonItems = __webpack_require__("zfNM");

Object.defineProperty(exports, 'WonItems', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_wonItems).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ "zOpu":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = __webpack_require__("dcb+");

var _jsx3 = _interopRequireDefault(_jsx2);

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Polyfill for webpack, just in case
if (false) require.ensure = function (d, c) {
    c(require);
};

var SubmitConsignmentModalLoader = function (_Component) {
    (0, _inherits3.default)(SubmitConsignmentModalLoader, _Component);

    function SubmitConsignmentModalLoader(props, context) {
        (0, _classCallCheck3.default)(this, SubmitConsignmentModalLoader);

        var _this = (0, _possibleConstructorReturn3.default)(this, (SubmitConsignmentModalLoader.__proto__ || (0, _getPrototypeOf2.default)(SubmitConsignmentModalLoader)).call(this, props, context));

        _this.state = {
            Component: null,
            mounted: false
        };
        return _this;
    }

    (0, _createClass3.default)(SubmitConsignmentModalLoader, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            var _this2 = this;

            return new _promise2.default(function (resolve) {
                __webpack_require__.e/* require.ensure */(19).then((function () {
                    resolve(__webpack_require__("miDa"));
                }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            }).then(function (container) {
                _this2.setState({ Component: container });
            });
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.setState({ mounted: true });
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.setState({ mounted: false });
        }
    }, {
        key: 'render',
        value: function render() {
            var _state = this.state,
                Component = _state.Component,
                mounted = _state.mounted;

            return mounted && Component !== null ? (0, _jsx3.default)(Component, {}) : null;
        }
    }]);
    return SubmitConsignmentModalLoader;
}(_react.Component);

exports.default = SubmitConsignmentModalLoader;
module.exports = exports['default'];

/***/ }),

/***/ "zfNM":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _wonItems = __webpack_require__("1Wc7");

exports.default = {
    fetchWonItems: _wonItems.WonItems.fetchWonItems
};
module.exports = exports['default'];

/***/ }),

/***/ "zfVU":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = __webpack_require__("dcb+");

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _components = __webpack_require__("bGai");

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propsComparer = __webpack_require__("wsGv");

var _propsComparer2 = _interopRequireDefault(_propsComparer);

var _redux = __webpack_require__("2KeS");

var _reactRedux = __webpack_require__("RH2O");

var _reactFontawesome = __webpack_require__("f7W8");

var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);

var _reactIntl = __webpack_require__("Pq8k");

var _user = __webpack_require__("CFLi");

var _noop = __webpack_require__("9vKl");

var _noop2 = _interopRequireDefault(_noop);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ItemPriceGatewayContainer = __webpack_require__("KlEt");

var _ItemPriceGatewayContainer2 = _interopRequireDefault(_ItemPriceGatewayContainer);

var _saveItem = __webpack_require__("6oKK");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ItemPriceGatewayContainer = (_dec = (0, _reactRedux.connect)(function (state) {
    return {
        userAtLeastPartiallyRegistered: (0, _user.isUserAtLeastPartiallyRegistered)(state)
    };
}, function (dispatch) {
    return (0, _redux.bindActionCreators)({ toggleItemSave: _saveItem.toggleItemSave }, dispatch);
}), _dec(_class = (_temp = _class2 = function (_Component) {
    (0, _inherits3.default)(ItemPriceGatewayContainer, _Component);

    function ItemPriceGatewayContainer() {
        (0, _classCallCheck3.default)(this, ItemPriceGatewayContainer);
        return (0, _possibleConstructorReturn3.default)(this, (ItemPriceGatewayContainer.__proto__ || (0, _getPrototypeOf2.default)(ItemPriceGatewayContainer)).apply(this, arguments));
    }

    (0, _createClass3.default)(ItemPriceGatewayContainer, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps) {
            return (0, _propsComparer2.default)(this.props, nextProps, ['userAtLeastPartiallyRegistered', 'children']);
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                children = _props.children,
                className = _props.className,
                containerClassName = _props.containerClassName,
                itemCard = _props.itemCard,
                userAtLeastPartiallyRegistered = _props.userAtLeastPartiallyRegistered;


            var formattedMessageId = itemCard ? 'price_gateway_card' : 'price_gateway_item_page';
            var forceSignUp = !userAtLeastPartiallyRegistered;

            return (0, _jsx3.default)(_components.ShouldLogInContainer, {
                requireLogin: false,
                requireUserAtLeastPartiallyRegistered: true,
                runFunction: _noop2.default,
                className: className,
                forceSignUp: forceSignUp
            }, void 0, userAtLeastPartiallyRegistered ? children : (0, _jsx3.default)('span', {
                className: _ItemPriceGatewayContainer2.default['login-to-see-price'] + ' ' + containerClassName
            }, void 0, (0, _jsx3.default)(_components.Link, {
                className: _ItemPriceGatewayContainer2.default.link
            }, void 0, (0, _jsx3.default)(_reactFontawesome2.default, {
                icon: ['far', 'usd-circle'],
                className: _ItemPriceGatewayContainer2.default.icon
            }), (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                className: _ItemPriceGatewayContainer2.default.link,
                id: formattedMessageId
            }))));
        }
    }]);
    return ItemPriceGatewayContainer;
}(_react.Component), _class2.defaultProps = {
    className: '',
    containerClassName: '',
    itemCard: false,
    userAtLeastPartiallyRegistered: false
}, _temp)) || _class);
exports.default = ItemPriceGatewayContainer;
module.exports = exports['default'];

/***/ }),

/***/ "zsa3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CatalogRemote = undefined;

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _helpers = __webpack_require__("SY39");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CatalogRemote = exports.CatalogRemote = {
    fetchCatalogItems: function fetchCatalogItems(_ref) {
        var authToken = _ref.authToken,
            catalogIds = _ref.catalogIds,
            count = _ref.count,
            deployment = _ref.deployment,
            itemId = _ref.itemId,
            page = _ref.page;
        return new _promise2.default(function (resolve, reject) {
            var id = void 0;
            // right now we can only request one catalog at a time.
            // if we request too many, fail
            if (catalogIds instanceof Array) {
                if (catalogIds.length === 1) {
                    id = catalogIds[0];
                } else {
                    reject('Can only request one catalog at a time for catalog items');
                }
            } else {
                id = catalogIds;
            }
            var request = (0, _helpers.makeGet)('<ITEM-API>spa/small/catalog/' + id + '/items', deployment);
            var query = {};
            if (global.__SERVER__ && itemId) {
                query.itemId = itemId;
                query.limit = 4;
                query.wrap = true;
            } else if (global.__SERVER__) {
                query.pageSize = count;
                query.cursor = (page - 1) * count;
            }

            request.query(query);
            (0, _helpers.addAuthToken)(request, authToken);
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response });
            });
        });
    },
    fetchCatalogsByIds: function fetchCatalogsByIds(_ref2) {
        var authToken = _ref2.authToken,
            catalogIds = _ref2.catalogIds,
            deployment = _ref2.deployment;
        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makePost)('<ITEM-API>spa/small/catalogs', deployment);
            (0, _helpers.addAuthToken)(request, authToken);
            request.send({ ids: catalogIds });
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response });
            });
        });
    },
    fetchCuratorsForCatalog: function fetchCuratorsForCatalog(_ref3) {
        var catalogId = _ref3.catalogId,
            deployment = _ref3.deployment;
        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makeGet)('<ITEM-API>catalog/' + catalogId + '/curators', deployment);
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response });
            });
        });
    },
    fetchRegisteredCatalogs: function fetchRegisteredCatalogs(_ref4) {
        var authToken = _ref4.authToken,
            deployment = _ref4.deployment;
        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makeGet)('<ITEM-API>catalog/registration', deployment);
            (0, _helpers.addAuthToken)(request, authToken);
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response });
            });
        });
    },
    fetchUpcomingCatalogs: function fetchUpcomingCatalogs(_ref5) {
        var authToken = _ref5.authToken,
            deployment = _ref5.deployment;
        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makeGet)('<ITEM-API>spa/small/upcomingcatalogs', deployment);
            (0, _helpers.addAuthToken)(request, authToken);
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response });
            });
        });
    },
    postCatalogItems: function postCatalogItems(_ref6) {
        var authToken = _ref6.authToken,
            catalogIds = _ref6.catalogIds,
            count = _ref6.count,
            deployment = _ref6.deployment,
            cursor = _ref6.cursor,
            itemId = _ref6.itemId,
            page = _ref6.page;
        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makePost)('<ITEM-API>spa/small/catalog/items', deployment);
            var data = {};
            if (global.__SERVER__ && itemId) {
                data.cursor = cursor;
                data.pageSize = 4;
                data.wrap = true;
            } else if (global.__SERVER__) {
                data.pageSize = count;
                data.cursor = (page - 1) * count;
            }
            request.send((0, _extends3.default)({ ids: catalogIds }, data));

            (0, _helpers.addAuthToken)(request, authToken);
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response });
            });
        });
    },
    postRegisterForCatalog: function postRegisterForCatalog(_ref7) {
        var authToken = _ref7.authToken,
            catalogId = _ref7.catalogId,
            deployment = _ref7.deployment;
        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makePost)('<MAINHOST-API>api/b_reg', deployment);
            (0, _helpers.addAuthToken)(request, authToken);
            request.query({ client_version: '4.3' });
            request.type('form');
            request.send({
                accept_terms: 1,
                cat_id: catalogId
            });
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response });
            });
        });
    }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("DuR2")))

/***/ }),

/***/ "zz0d":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = __webpack_require__("dcb+");

var _jsx3 = _interopRequireDefault(_jsx2);

var _toConsumableArray2 = __webpack_require__("Gu7T");

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _propsComparer = __webpack_require__("wsGv");

var _propsComparer2 = _interopRequireDefault(_propsComparer);

var _CatalogCard = __webpack_require__("Kk/C");

var _CatalogCard2 = _interopRequireDefault(_CatalogCard);

var _HorizontalCatalogCard = __webpack_require__("QJZ2");

var _HorizontalCatalogCard2 = _interopRequireDefault(_HorizontalCatalogCard);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _CatalogGrid = __webpack_require__("VqFm");

var _CatalogGrid2 = _interopRequireDefault(_CatalogGrid);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CatalogGrid = (_temp2 = _class = function (_Component) {
    (0, _inherits3.default)(CatalogGrid, _Component);

    function CatalogGrid() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, CatalogGrid);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = CatalogGrid.__proto__ || (0, _getPrototypeOf2.default)(CatalogGrid)).call.apply(_ref, [this].concat(args))), _this), _this.makeCatalogCards = function () {
            var _this$props = _this.props,
                cardViewModels = _this$props.cardViewModels,
                catalogCardClass = _this$props.catalogCardClass,
                horizontal = _this$props.horizontal,
                trackClick = _this$props.trackClick;


            var lastIndex = _this.props.cardViewModels.length - 1;
            var catalogCardClasses = [].concat((0, _toConsumableArray3.default)(catalogCardClass.split(' ')), [_CatalogGrid2.default.card]).join(' ').trim();

            return cardViewModels.map(function (card, index) {
                var cardProps = {
                    cardViewModel: card,
                    key: index,
                    last: index === lastIndex
                };
                if (horizontal) {
                    return _react2.default.createElement(_HorizontalCatalogCard2.default, cardProps);
                }
                cardProps.className = catalogCardClasses;

                if (trackClick) {
                    cardProps.trackClick = function () {
                        return trackClick(card.catalog.catalogId);
                    };
                }
                return _react2.default.createElement(_CatalogCard2.default, cardProps);
            });
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(CatalogGrid, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps) {
            return (0, _propsComparer2.default)(this.props, nextProps, ['catalogCardClass', 'className', 'horizontal', 'cardViewModels']);
        }
    }, {
        key: 'render',
        value: function render() {
            var classes = [].concat((0, _toConsumableArray3.default)(this.props.className.split(' ')), [_CatalogGrid2.default['catalog-grid']]).join(' ').trim();
            return (0, _jsx3.default)('div', {
                className: classes
            }, void 0, this.makeCatalogCards());
        }
    }]);
    return CatalogGrid;
}(_react.Component), _class.defaultProps = {
    catalogCardClass: '',
    className: '',
    horizontal: false
}, _temp2);
exports.default = CatalogGrid;
module.exports = exports['default'];

/***/ })

},[0]);


// WEBPACK FOOTER //
// main.bfb8fea3e5d542c9bf12.js